var $a0b4f895e1596b3b$exports = {};
!function(c) {
    "use strict";
    function t(c, t, a) {
        return a.a = c, a.f = t, a;
    }
    function F2(c) {
        return t(2, c, function(t) {
            return function(a) {
                return c(t, a);
            };
        });
    }
    function F3(c) {
        return t(3, c, function(t) {
            return function(a) {
                return function(n) {
                    return c(t, a, n);
                };
            };
        });
    }
    function F4(c) {
        return t(4, c, function(t) {
            return function(a) {
                return function(n) {
                    return function(r) {
                        return c(t, a, n, r);
                    };
                };
            };
        });
    }
    function F5(c) {
        return t(5, c, function(t) {
            return function(a) {
                return function(n) {
                    return function(r) {
                        return function(e) {
                            return c(t, a, n, r, e);
                        };
                    };
                };
            };
        });
    }
    function F6(c) {
        return t(6, c, function(t) {
            return function(a) {
                return function(n) {
                    return function(r) {
                        return function(e) {
                            return function(d) {
                                return c(t, a, n, r, e, d);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(c) {
        return t(7, c, function(t) {
            return function(a) {
                return function(n) {
                    return function(r) {
                        return function(e) {
                            return function(d) {
                                return function(u) {
                                    return c(t, a, n, r, e, d, u);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(c, t, a) {
        return 2 === c.a ? c.f(t, a) : c(t)(a);
    }
    function A3(c, t, a, n) {
        return 3 === c.a ? c.f(t, a, n) : c(t)(a)(n);
    }
    function A4(c, t, a, n, r) {
        return 4 === c.a ? c.f(t, a, n, r) : c(t)(a)(n)(r);
    }
    function A5(c, t, a, n, r, e) {
        return 5 === c.a ? c.f(t, a, n, r, e) : c(t)(a)(n)(r)(e);
    }
    function A6(c, t, a, n, r, e, d) {
        return 6 === c.a ? c.f(t, a, n, r, e, d) : c(t)(a)(n)(r)(e)(d);
    }
    function A7(c, t, a, n, r, e, d, u) {
        return 7 === c.a ? c.f(t, a, n, r, e, d, u) : c(t)(a)(n)(r)(e)(d)(u);
    }
    var a = F3(function(c, t, a) {
        for(var n = Array(c), r = 0; c > r; r++)n[r] = a(t + r);
        return n;
    }), n = F2(function(c, t) {
        for(var a = Array(c), n = 0; c > n && t.b; n++)a[n] = t.a, t = t.b;
        return a.length = n, h(a, t);
    });
    function r(c) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + c + ".md");
    }
    function e(c, t) {
        for(var a, n = [], r = d(c, t, 0, n); r && (a = n.pop()); r = d(a.a, a.b, 0, n));
        return r;
    }
    function d(c, t, a, n) {
        if (c === t) return !0;
        if ("object" != typeof c || null === c || null === t) return "function" == typeof c && r(5), !1;
        if (a > 100) return n.push(h(c, t)), !0;
        for(var e in 0 > c.$ && (c = $t(c), t = $t(t)), c)if (!d(c[e], t[e], a + 1, n)) return !1;
        return !0;
    }
    function u(c, t, a) {
        if ("object" != typeof c) return c === t ? 0 : t > c ? -1 : 1;
        if (void 0 === c.$) return (a = u(c.a, t.a)) || (a = u(c.b, t.b)) ? a : u(c.c, t.c);
        for(; c.b && t.b && !(a = u(c.a, t.a)); c = c.b, t = t.b);
        return a || (c.b ? 1 : t.b ? -1 : 0);
    }
    var i = F2(function(c, t) {
        var a = u(c, t);
        return 0 > a ? wt : a ? yt : mt;
    });
    function h(c, t) {
        return {
            a: c,
            b: t
        };
    }
    function f(c, t, a) {
        return {
            a: c,
            b: t,
            c: a
        };
    }
    function p(c, t) {
        var a = {};
        for(var n in c)a[n] = c[n];
        for(var n in t)a[n] = t[n];
        return a;
    }
    function o(c, t) {
        if ("string" == typeof c) return c + t;
        if (!c.b) return t;
        var a = b(c.a, t);
        c = c.b;
        for(var n = a; c.b; c = c.b)n = n.b = b(c.a, t);
        return a;
    }
    var M = {
        $: 0
    };
    function b(c, t) {
        return {
            $: 1,
            a: c,
            b: t
        };
    }
    var s = F2(b);
    function l(c) {
        for(var t = M, a = c.length; a--;)t = b(c[a], t);
        return t;
    }
    function z(c) {
        for(var t = []; c.b; c = c.b)t.push(c.a);
        return t;
    }
    var g = F3(function(c, t, a) {
        for(var n = []; t.b && a.b; t = t.b, a = a.b)n.push(A2(c, t.a, a.a));
        return l(n);
    }), v = F2(function(c, t) {
        return c + t;
    }), $ = Math.ceil, m = Math.floor, y = Math.log, w = F2(function(c, t) {
        return c + t;
    }), x = F2(function(c, t) {
        for(var a = t.length, n = Array(a), r = 0; a > r;){
            var e = t.charCodeAt(r);
            55296 > e || e > 56319 ? (n[r] = c(t[r]), r++) : (n[r] = c(t[r] + t[r + 1]), r += 2);
        }
        return n.join("");
    }), k = F3(function(c, t, a) {
        for(var n = a.length; n--;){
            var r = a[n], e = a.charCodeAt(n);
            56320 > e || e > 57343 || (r = a[--n] + r), t = A2(c, r, t);
        }
        return t;
    }), _ = F2(function(c, t) {
        return t.split(c);
    }), j = F2(function(c, t) {
        return t.join(c);
    }), L = F3(function(c, t, a) {
        return a.slice(c, t);
    });
    function A(c) {
        return c + "";
    }
    function C(c) {
        return {
            $: 2,
            b: c
        };
    }
    var I = C(function(c) {
        return "number" != typeof c ? B("an INT", c) : c > -2147483647 && 2147483647 > c && (0 | c) === c ? Lt(c) : !isFinite(c) || c % 1 ? B("an INT", c) : Lt(c);
    }), T = C(function(c) {
        return "boolean" == typeof c ? Lt(c) : B("a BOOL", c);
    }), N = (C(function(c) {
        return "number" == typeof c ? Lt(c) : B("a FLOAT", c);
    }), C(function(c) {
        return Lt(c);
    }), C(function(c) {
        return "string" == typeof c ? Lt(c) : c instanceof String ? Lt(c + "") : B("a STRING", c);
    })), O = F2(function(c, t) {
        return {
            $: 6,
            d: c,
            b: t
        };
    }), E = F2(function(c, t) {
        return {
            $: 7,
            e: c,
            b: t
        };
    });
    function R(c, t) {
        return {
            $: 9,
            f: c,
            g: t
        };
    }
    var S = F2(function(c, t) {
        return {
            $: 10,
            b: t,
            h: c
        };
    }), X = F2(function(c, t) {
        return R(c, [
            t
        ]);
    }), q = F3(function(c, t, a) {
        return R(c, [
            t,
            a
        ]);
    }), H = F2(function(c, t) {
        return F(c, t);
    });
    function F(c, t) {
        switch(c.$){
            case 2:
                return c.b(t);
            case 5:
                return null === t ? Lt(c.c) : B("null", t);
            case 3:
                return D(t) ? V(c.b, t, l) : B("a LIST", t);
            case 4:
                return D(t) ? V(c.b, t, U) : B("an ARRAY", t);
            case 6:
                var a = c.d;
                if ("object" != typeof t || null === t || !(a in t)) return B("an OBJECT with a field named `" + a + "`", t);
                var n = F(c.b, t[a]);
                return ra(n) ? n : xt(A2(_t, a, n.a));
            case 7:
                var r = c.e;
                return D(t) ? t.length > r ? (n = F(c.b, t[r]), ra(n) ? n : xt(A2(jt, r, n.a))) : B("a LONGER array. Need index " + r + " but only see " + t.length + " entries", t) : B("an ARRAY", t);
            case 8:
                if ("object" != typeof t || null === t || D(t)) return B("an OBJECT", t);
                var e = M;
                for(var d in t)if (t.hasOwnProperty(d)) {
                    if (n = F(c.b, t[d]), !ra(n)) return xt(A2(_t, d, n.a));
                    e = b(h(d, n.a), e);
                }
                return Lt(Ht(e));
            case 9:
                for(var u = c.f, i = c.g, f = 0; i.length > f; f++){
                    if (n = F(i[f], t), !ra(n)) return n;
                    u = u(n.a);
                }
                return Lt(u);
            case 10:
                return n = F(c.b, t), ra(n) ? F(c.h(n.a), t) : n;
            case 11:
                for(var p = M, o = c.g; o.b; o = o.b){
                    if (n = F(o.a, t), ra(n)) return n;
                    p = b(n.a, p);
                }
                return xt(At(Ht(p)));
            case 1:
                return xt(A2(kt, c.a, t));
            case 0:
                return Lt(c.a);
        }
    }
    function V(c, t, a) {
        for(var n = t.length, r = Array(n), e = 0; n > e; e++){
            var d = F(c, t[e]);
            if (!ra(d)) return xt(A2(jt, e, d.a));
            r[e] = d.a;
        }
        return Lt(a(r));
    }
    function D(c) {
        return Array.isArray(c) || "undefined" != typeof FileList && c instanceof FileList;
    }
    function U(c) {
        return A2(na, c.length, function(t) {
            return c[t];
        });
    }
    function B(c, t) {
        return xt(A2(kt, "Expecting " + c, t));
    }
    function P(c, t) {
        if (c === t) return !0;
        if (c.$ !== t.$) return !1;
        switch(c.$){
            case 0:
            case 1:
                return c.a === t.a;
            case 2:
                return c.b === t.b;
            case 5:
                return c.c === t.c;
            case 3:
            case 4:
            case 8:
                return P(c.b, t.b);
            case 6:
                return c.d === t.d && P(c.b, t.b);
            case 7:
                return c.e === t.e && P(c.b, t.b);
            case 9:
                return c.f === t.f && G(c.g, t.g);
            case 10:
                return c.h === t.h && P(c.b, t.b);
            case 11:
                return G(c.g, t.g);
        }
    }
    function G(c, t) {
        var a = c.length;
        if (a !== t.length) return !1;
        for(var n = 0; a > n; n++)if (!P(c[n], t[n])) return !1;
        return !0;
    }
    function W(c) {
        return c;
    }
    var Y = F3(function(c, t, a) {
        return a[c] = t, a;
    });
    function J(c) {
        return {
            $: 0,
            a: c
        };
    }
    function Z(c) {
        return {
            $: 2,
            b: c,
            c: null
        };
    }
    var Q = F2(function(c, t) {
        return {
            $: 3,
            b: c,
            d: t
        };
    }), K = F2(function(c, t) {
        return {
            $: 4,
            b: c,
            d: t
        };
    }), cc = 0;
    function tc(c) {
        var t = {
            $: 0,
            e: cc++,
            f: c,
            g: null,
            h: []
        };
        return uc(t), t;
    }
    function ac(c) {
        return Z(function(t) {
            t(J(tc(c)));
        });
    }
    function nc(c, t) {
        c.h.push(t), uc(c);
    }
    var rc = F2(function(c, t) {
        return Z(function(a) {
            nc(c, t), a(J(0));
        });
    }), ec = !1, dc = [];
    function uc(c) {
        if (dc.push(c), !ec) {
            for(ec = !0; c = dc.shift();)ic(c);
            ec = !1;
        }
    }
    function ic(c) {
        for(; c.f;){
            var t = c.f.$;
            if (0 === t || 1 === t) {
                for(; c.g && c.g.$ !== t;)c.g = c.g.i;
                if (!c.g) return;
                c.f = c.g.b(c.f.a), c.g = c.g.i;
            } else {
                if (2 === t) return void (c.f.c = c.f.b(function(t) {
                    c.f = t, uc(c);
                }));
                if (5 === t) {
                    if (0 === c.h.length) return;
                    c.f = c.f.b(c.h.shift());
                } else c.g = {
                    $: 3 === t ? 0 : 1,
                    b: c.f.b,
                    i: c.g
                }, c.f = c.f.d;
            }
        }
    }
    var hc = {};
    function fc(c, t, a, n, r) {
        return {
            b: c,
            c: t,
            d: a,
            e: n,
            f: r
        };
    }
    function pc(c, t) {
        var a = {
            g: t,
            h: void 0
        }, n = c.c, r = c.d, e = c.e, d = c.f;
        function u(c) {
            return A2(Q, u, {
                $: 5,
                b: function(t) {
                    var u = t.a;
                    return 0 === t.$ ? A3(r, a, u, c) : e && d ? A4(n, a, u.i, u.j, c) : A3(n, a, e ? u.i : u.j, c);
                }
            });
        }
        return a.h = tc(A2(Q, u, c.b));
    }
    var oc = F2(function(c, t) {
        return Z(function(a) {
            c.g(t), a(J(0));
        });
    }), Mc = F2(function(c, t) {
        return A2(rc, c.h, {
            $: 0,
            a: t
        });
    });
    function bc(c) {
        return function(t) {
            return {
                $: 1,
                k: c,
                l: t
            };
        };
    }
    function sc(c) {
        return {
            $: 2,
            m: c
        };
    }
    var lc = [], zc = !1;
    function gc(c, t, a) {
        if (lc.push({
            p: c,
            q: t,
            r: a
        }), !zc) {
            zc = !0;
            for(var n; n = lc.shift();)vc(n.p, n.q, n.r);
            zc = !1;
        }
    }
    function vc(c, t, a) {
        var n = {};
        for(var r in $c(!0, t, n, null), $c(!1, a, n, null), c)nc(c[r], {
            $: "fx",
            a: n[r] || {
                i: M,
                j: M
            }
        });
    }
    function $c(c, t, a, n) {
        switch(t.$){
            case 1:
                var r = t.k, e = function(c, t, a, n) {
                    function r(c) {
                        for(var t = a; t; t = t.t)c = t.s(c);
                        return c;
                    }
                    return A2(c ? hc[t].e : hc[t].f, r, n);
                }(c, r, n, t.l);
                return void (a[r] = function(c, t, a) {
                    return a = a || {
                        i: M,
                        j: M
                    }, c ? a.i = b(t, a.i) : a.j = b(t, a.j), a;
                }(c, e, a[r]));
            case 2:
                for(var d = t.m; d.b; d = d.b)$c(c, d.a, a, n);
                return;
            case 3:
                return void $c(c, t.o, a, {
                    s: t.n,
                    t: n
                });
        }
    }
    var mc = F2(function(c, t) {
        return t;
    });
    var yc = "undefined" != typeof document ? document : {};
    function wc(c, t) {
        c.appendChild(t);
    }
    function xc(c) {
        return {
            $: 0,
            a: c
        };
    }
    var kc = F2(function(c, t) {
        return F2(function(a, n) {
            for(var r = [], e = 0; n.b; n = n.b){
                var d = n.a;
                e += d.b || 0, r.push(d);
            }
            return e += r.length, {
                $: 1,
                c: t,
                d: Ec(a),
                e: r,
                f: c,
                b: e
            };
        });
    }), _c = kc(void 0);
    F2(function(c, t) {
        return F2(function(a, n) {
            for(var r = [], e = 0; n.b; n = n.b){
                var d = n.a;
                e += d.b.b || 0, r.push(d);
            }
            return e += r.length, {
                $: 2,
                c: t,
                d: Ec(a),
                e: r,
                f: c,
                b: e
            };
        });
    })(void 0);
    var jc, Lc = F2(function(c, t) {
        return {
            $: "a0",
            n: c,
            o: t
        };
    }), Ac = F2(function(c, t) {
        return {
            $: "a1",
            n: c,
            o: t
        };
    }), Cc = F2(function(c, t) {
        return {
            $: "a2",
            n: c,
            o: t
        };
    }), Ic = F2(function(c, t) {
        return {
            $: "a3",
            n: c,
            o: t
        };
    }), Tc = F3(function(c, t, a) {
        return {
            $: "a4",
            n: t,
            o: {
                f: c,
                o: a
            }
        };
    }), Nc = /^script$/i, Oc = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
    function Ec(c) {
        for(var t = {}; c.b; c = c.b){
            var a = c.a, n = a.$, r = a.n, e = a.o;
            if ("a2" !== n) {
                var d = t[n] || (t[n] = {});
                "a3" === n && "class" === r ? Rc(d, r, e) : d[r] = e;
            } else "className" === r ? Rc(t, r, e) : t[r] = e;
        }
        return t;
    }
    function Rc(c, t, a) {
        var n = c[t];
        c[t] = n ? n + " " + a : a;
    }
    function Sc(c, t) {
        var a = c.$;
        if (5 === a) return Sc(c.k || (c.k = c.m()), t);
        if (0 === a) return yc.createTextNode(c.a);
        if (4 === a) {
            for(var n = c.k, r = c.j; 4 === n.$;)"object" != typeof r ? r = [
                r,
                n.j
            ] : r.push(n.j), n = n.k;
            var e = {
                j: r,
                p: t
            };
            return (d = Sc(n, e)).elm_event_node_ref = e, d;
        }
        if (3 === a) return Xc(d = c.h(c.g), t, c.d), d;
        var d = c.f ? yc.createElementNS(c.f, c.c) : yc.createElement(c.c);
        Xc(d, t, c.d);
        for(var u = c.e, i = 0; u.length > i; i++)wc(d, Sc(1 === a ? u[i] : u[i].b, t));
        return d;
    }
    function Xc(c, t, a) {
        for(var n in a){
            var r = a[n];
            "a1" === n ? qc(c, r) : "a0" === n ? Vc(c, t, r) : "a3" === n ? Hc(c, r) : "a4" === n ? Fc(c, r) : ("value" !== n && "checked" !== n || c[n] !== r) && (c[n] = r);
        }
    }
    function qc(c, t) {
        var a = c.style;
        for(var n in t)a[n] = t[n];
    }
    function Hc(c, t) {
        for(var a in t){
            var n = t[a];
            void 0 !== n ? c.setAttribute(a, n) : c.removeAttribute(a);
        }
    }
    function Fc(c, t) {
        for(var a in t){
            var n = t[a], r = n.f, e = n.o;
            void 0 !== e ? c.setAttributeNS(r, a, e) : c.removeAttributeNS(r, a);
        }
    }
    function Vc(c, t, a) {
        var n = c.elmFs || (c.elmFs = {});
        for(var r in a){
            var e = a[r], d = n[r];
            if (e) {
                if (d) {
                    if (d.q.$ === e.$) {
                        d.q = e;
                        continue;
                    }
                    c.removeEventListener(r, d);
                }
                d = Dc(t, e), c.addEventListener(r, d, jc && {
                    passive: 2 > ha(e)
                }), n[r] = d;
            } else c.removeEventListener(r, d), n[r] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                jc = !0;
            }
        }));
    } catch (c) {}
    function Dc(c, t) {
        function a(t) {
            var n = a.q, r = F(n.a, t);
            if (ra(r)) {
                for(var e, d = ha(n), u = r.a, i = d ? 3 > d ? u.a : u.x : u, h = 1 == d ? u.b : 3 == d && u.an, f = (h && t.stopPropagation(), (2 == d ? u.b : 3 == d && u.ak) && t.preventDefault(), c); e = f.j;){
                    if ("function" == typeof e) i = e(i);
                    else for(var p = e.length; p--;)i = e[p](i);
                    f = f.p;
                }
                f(i, h);
            }
        }
        return a.q = t, a;
    }
    function Uc(c, t) {
        return c.$ == t.$ && P(c.a, t.a);
    }
    function Bc(c, t, a, n) {
        var r = {
            $: t,
            r: a,
            s: n,
            t: void 0,
            u: void 0
        };
        return c.push(r), r;
    }
    function Pc(c, t, a, n) {
        if (c !== t) {
            var r = c.$, e = t.$;
            if (r !== e) {
                if (1 !== r || 2 !== e) return void Bc(a, 0, n, t);
                t = function(c) {
                    for(var t = c.e, a = t.length, n = Array(a), r = 0; a > r; r++)n[r] = t[r].b;
                    return {
                        $: 1,
                        c: c.c,
                        d: c.d,
                        e: n,
                        f: c.f,
                        b: c.b
                    };
                }(t), e = 1;
            }
            switch(e){
                case 5:
                    for(var d = c.l, u = t.l, i = d.length, h = i === u.length; h && i--;)h = d[i] === u[i];
                    if (h) return void (t.k = c.k);
                    t.k = t.m();
                    var f = [];
                    return Pc(c.k, t.k, f, 0), void (f.length > 0 && Bc(a, 1, n, f));
                case 4:
                    for(var p = c.j, o = t.j, M = !1, b = c.k; 4 === b.$;)M = !0, "object" != typeof p ? p = [
                        p,
                        b.j
                    ] : p.push(b.j), b = b.k;
                    for(var s = t.k; 4 === s.$;)M = !0, "object" != typeof o ? o = [
                        o,
                        s.j
                    ] : o.push(s.j), s = s.k;
                    return M && p.length !== o.length ? void Bc(a, 0, n, t) : ((M ? function(c, t) {
                        for(var a = 0; c.length > a; a++)if (c[a] !== t[a]) return !1;
                        return !0;
                    }(p, o) : p === o) || Bc(a, 2, n, o), void Pc(b, s, a, n + 1));
                case 0:
                    return void (c.a !== t.a && Bc(a, 3, n, t.a));
                case 1:
                    return void Gc(c, t, a, n, Yc);
                case 2:
                    return void Gc(c, t, a, n, Jc);
                case 3:
                    if (c.h !== t.h) return void Bc(a, 0, n, t);
                    var l = Wc(c.d, t.d);
                    l && Bc(a, 4, n, l);
                    var z = t.i(c.g, t.g);
                    return void (z && Bc(a, 5, n, z));
            }
        }
    }
    function Gc(c, t, a, n, r) {
        if (c.c === t.c && c.f === t.f) {
            var e = Wc(c.d, t.d);
            e && Bc(a, 4, n, e), r(c, t, a, n);
        } else Bc(a, 0, n, t);
    }
    function Wc(c, t, a) {
        var n;
        for(var r in c)if ("a1" !== r && "a0" !== r && "a3" !== r && "a4" !== r) {
            if (r in t) {
                var e = c[r], d = t[r];
                e === d && "value" !== r && "checked" !== r || "a0" === a && Uc(e, d) || ((n = n || {})[r] = d);
            } else (n = n || {})[r] = a ? "a1" === a ? "" : "a0" === a || "a3" === a ? void 0 : {
                f: c[r].f,
                o: void 0
            } : "string" == typeof c[r] ? "" : null;
        } else {
            var u = Wc(c[r], t[r] || {}, r);
            u && ((n = n || {})[r] = u);
        }
        for(var i in t)i in c || ((n = n || {})[i] = t[i]);
        return n;
    }
    function Yc(c, t, a, n) {
        var r = c.e, e = t.e, d = r.length, u = e.length;
        d > u ? Bc(a, 6, n, {
            v: u,
            i: d - u
        }) : u > d && Bc(a, 7, n, {
            v: d,
            e: e
        });
        for(var i = u > d ? d : u, h = 0; i > h; h++){
            var f = r[h];
            Pc(f, e[h], a, ++n), n += f.b || 0;
        }
    }
    function Jc(c, t, a, n) {
        for(var r = [], e = {}, d = [], u = c.e, i = t.e, h = u.length, f = i.length, p = 0, o = 0, M = n; h > p && f > o;){
            var b = (_ = u[p]).a, s = (j = i[o]).a, l = _.b, z = j.b, g = void 0, v = void 0;
            if (b !== s) {
                var $ = u[p + 1], m = i[o + 1];
                if ($) {
                    var y = $.a, w = $.b;
                    v = s === y;
                }
                if (m) {
                    var x = m.a, k = m.b;
                    g = b === x;
                }
                if (g && v) Pc(l, k, r, ++M), Qc(e, r, b, z, o, d), M += l.b || 0, Kc(e, r, b, w, ++M), M += w.b || 0, p += 2, o += 2;
                else if (g) M++, Qc(e, r, s, z, o, d), Pc(l, k, r, M), M += l.b || 0, p += 1, o += 2;
                else if (v) Kc(e, r, b, l, ++M), M += l.b || 0, Pc(w, z, r, ++M), M += w.b || 0, p += 2, o += 1;
                else {
                    if (!$ || y !== x) break;
                    Kc(e, r, b, l, ++M), Qc(e, r, s, z, o, d), M += l.b || 0, Pc(w, k, r, ++M), M += w.b || 0, p += 2, o += 2;
                }
            } else Pc(l, z, r, ++M), M += l.b || 0, p++, o++;
        }
        for(; h > p;){
            var _;
            M++, Kc(e, r, (_ = u[p]).a, l = _.b, M), M += l.b || 0, p++;
        }
        for(; f > o;){
            var j, L = L || [];
            Qc(e, r, (j = i[o]).a, j.b, void 0, L), o++;
        }
        (r.length > 0 || d.length > 0 || L) && Bc(a, 8, n, {
            w: r,
            x: d,
            y: L
        });
    }
    var Zc = "_elmW6BL";
    function Qc(c, t, a, n, r, e) {
        var d = c[a];
        if (!d) return e.push({
            r: r,
            A: d = {
                c: 0,
                z: n,
                r: r,
                s: void 0
            }
        }), void (c[a] = d);
        if (1 === d.c) {
            e.push({
                r: r,
                A: d
            }), d.c = 2;
            var u = [];
            return Pc(d.z, n, u, d.r), d.r = r, void (d.s.s = {
                w: u,
                A: d
            });
        }
        Qc(c, t, a + Zc, n, r, e);
    }
    function Kc(c, t, a, n, r) {
        var e = c[a];
        if (e) {
            if (0 === e.c) {
                e.c = 2;
                var d = [];
                return Pc(n, e.z, d, r), void Bc(t, 9, r, {
                    w: d,
                    A: e
                });
            }
            Kc(c, t, a + Zc, n, r);
        } else {
            var u = Bc(t, 9, r, void 0);
            c[a] = {
                c: 1,
                z: n,
                r: r,
                s: u
            };
        }
    }
    function ct(c, t, a, n) {
        tt(c, t, a, 0, 0, t.b, n);
    }
    function tt(c, t, a, n, r, e, d) {
        for(var u = a[n], i = u.r; i === r;){
            var h = u.$;
            if (1 === h) ct(c, t.k, u.s, d);
            else if (8 === h) u.t = c, u.u = d, (f = u.s.w).length > 0 && tt(c, t, f, 0, r, e, d);
            else if (9 === h) {
                u.t = c, u.u = d;
                var f, p = u.s;
                p && (p.A.s = c, (f = p.w).length > 0 && tt(c, t, f, 0, r, e, d));
            } else u.t = c, u.u = d;
            if (!(u = a[++n]) || (i = u.r) > e) return n;
        }
        var o = t.$;
        if (4 === o) {
            for(var M = t.k; 4 === M.$;)M = M.k;
            return tt(c, M, a, n, r + 1, e, c.elm_event_node_ref);
        }
        for(var b = t.e, s = c.childNodes, l = 0; b.length > l; l++){
            r++;
            var z = 1 === o ? b[l] : b[l].b, g = r + (z.b || 0);
            if (!(r > i || i > g || (u = a[n = tt(s[l], z, a, n, r, g, d)]) && (i = u.r) <= e)) return n;
            r = g;
        }
        return n;
    }
    function at(c, t) {
        for(var a = 0; t.length > a; a++){
            var n = t[a], r = n.t, e = nt(r, n);
            r === c && (c = e);
        }
        return c;
    }
    function nt(c, t) {
        switch(t.$){
            case 0:
                return function(c, t, a) {
                    var n = c.parentNode, r = Sc(t, a);
                    return r.elm_event_node_ref || (r.elm_event_node_ref = c.elm_event_node_ref), n && r !== c && n.replaceChild(r, c), r;
                }(c, t.s, t.u);
            case 4:
                return Xc(c, t.u, t.s), c;
            case 3:
                return c.replaceData(0, c.length, t.s), c;
            case 1:
                return at(c, t.s);
            case 2:
                return c.elm_event_node_ref ? c.elm_event_node_ref.j = t.s : c.elm_event_node_ref = {
                    j: t.s,
                    p: t.u
                }, c;
            case 6:
                for(var a = t.s, n = 0; a.i > n; n++)c.removeChild(c.childNodes[a.v]);
                return c;
            case 7:
                for(var e = (a = t.s).e, d = c.childNodes[n = a.v]; e.length > n; n++)c.insertBefore(Sc(e[n], t.u), d);
                return c;
            case 9:
                if (!(a = t.s)) return c.parentNode.removeChild(c), c;
                var u = a.A;
                return void 0 !== u.r && c.parentNode.removeChild(c), u.s = at(c, a.w), c;
            case 8:
                return function(c, t) {
                    var a = t.s, n = function(c, t) {
                        if (c) {
                            for(var a = yc.createDocumentFragment(), n = 0; c.length > n; n++){
                                var r = c[n].A;
                                wc(a, 2 === r.c ? r.s : Sc(r.z, t.u));
                            }
                            return a;
                        }
                    }(a.y, t);
                    c = at(c, a.w);
                    for(var r = a.x, e = 0; r.length > e; e++){
                        var d = r[e], u = d.A, i = 2 === u.c ? u.s : Sc(u.z, t.u);
                        c.insertBefore(i, c.childNodes[d.r]);
                    }
                    return n && wc(c, n), c;
                }(c, t);
            case 5:
                return t.s(c);
            default:
                r(10);
        }
    }
    function rt(c) {
        if (3 === c.nodeType) return xc(c.textContent);
        if (1 !== c.nodeType) return xc("");
        for(var t = M, a = c.attributes, n = a.length; n--;){
            var r = a[n];
            t = b(A2(Ic, r.name, r.value), t);
        }
        var e = c.tagName.toLowerCase(), d = M, u = c.childNodes;
        for(n = u.length; n--;)d = b(rt(u[n]), d);
        return A3(_c, e, t, d);
    }
    var et = F4(function(c, t, a, n) {
        return function(c, t, a, n, e, d) {
            var u = A2(H, c, t ? t.flags : void 0);
            ra(u) || r(2);
            var i = {}, h = a(u.a), f = h.a, p = d(M, f), o = function(c, t) {
                var a;
                for(var n in hc){
                    var r = hc[n];
                    r.a && ((a = a || {})[n] = r.a(n, t)), c[n] = pc(r, t);
                }
                return a;
            }(i, M);
            function M(c, t) {
                var a = A2(n, c, f);
                p(f = a.a, t), gc(i, a.b, e(f));
            }
            return gc(i, h.b, e(f)), o ? {
                ports: o
            } : {};
        }(t, n, c.a1, c.bn, c.bj, function(t, a) {
            var r = c.bo, e = n.node, d = rt(e);
            return function(c, t) {
                t(c);
                var a = 0;
                function n() {
                    a = 1 === a ? 0 : (dt(n), t(c), 1);
                }
                return function(r, e) {
                    c = r, e ? (t(c), 2 === a && (a = 1)) : (0 === a && dt(n), a = 2);
                };
            }(a, function(c) {
                var a = r(c), n = function(c, t) {
                    var a = [];
                    return Pc(c, t, a, 0), a;
                }(d, a);
                e = function(c, t, a, n) {
                    return 0 === a.length ? c : (ct(c, t, a, n), at(c, a));
                }(e, d, n, t), d = a;
            });
        });
    }), dt = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(c) {
        return setTimeout(c, 1e3 / 60);
    });
    var ut = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, it = "undefined" != typeof document ? document : ut, ht = "undefined" != typeof window ? window : ut, ft = F3(function(c, t, a) {
        return ac(Z(function() {
            function n(c) {
                tc(a(c));
            }
            return c.addEventListener(t, n, jc && {
                passive: !0
            }), function() {
                c.removeEventListener(t, n);
            };
        }));
    }), pt = F2(function(c, t) {
        var a = F(c, t);
        return ra(a) ? lt(a.a) : zt;
    });
    var ot = F2(function(c, t) {
        return function(c, t) {
            return Z(function(a) {
                dt(function() {
                    var n = document.getElementById(c);
                    a(n ? J(t(n)) : {
                        $: 1,
                        a: pa(c)
                    });
                });
            });
        }(t, function(t) {
            return t[c](), 0;
        });
    });
    var Mt = F2(function(c, t) {
        return Z(function() {
            var a = setInterval(function() {
                tc(t);
            }, c);
            return function() {
                clearInterval(a);
            };
        });
    }), bt = F2(function(c, t) {
        var a = "g";
        c.a6 && (a += "m"), c.aU && (a += "i");
        try {
            return lt(RegExp(t, a));
        } catch (c) {
            return zt;
        }
    }), st = F4(function(c, t, a, n) {
        var r = 0;
        return n.replace(t, function(t) {
            if (r++ >= c) return t;
            for(var n = arguments.length - 3, e = Array(n); n > 0;){
                var d = arguments[n];
                e[--n] = d ? lt(d) : zt;
            }
            return a(A4(Ie, t, arguments[arguments.length - 2], r, l(e)));
        });
    }), lt = function(c) {
        return {
            $: 0,
            a: c
        };
    }, zt = {
        $: 1
    }, gt = s, vt = F3(function(c, t, a) {
        for(;;){
            if (-2 === a.$) return t;
            var n = a.d, r = c, e = A3(c, a.b, a.c, A3(vt, c, t, a.e));
            c = r, t = e, a = n;
        }
    }), $t = function(c) {
        return A3(vt, F3(function(c, t, a) {
            return A2(gt, h(c, t), a);
        }), M, c);
    }, mt = 1, yt = 2, wt = 0, xt = function(c) {
        return {
            $: 1,
            a: c
        };
    }, kt = F2(function(c, t) {
        return {
            $: 3,
            a: c,
            b: t
        };
    }), _t = F2(function(c, t) {
        return {
            $: 0,
            a: c,
            b: t
        };
    }), jt = F2(function(c, t) {
        return {
            $: 1,
            a: c,
            b: t
        };
    }), Lt = function(c) {
        return {
            $: 0,
            a: c
        };
    }, At = function(c) {
        return {
            $: 2,
            a: c
        };
    }, Ct = v, It = A, Tt = F2(function(c, t) {
        return A2(j, c, z(t));
    }), Nt = F2(function(c, t) {
        return l(A2(_, c, t));
    }), Ot = F3(function(c, t, a) {
        for(;;){
            if (!a.b) return t;
            var n = a.b, r = c, e = A2(c, a.a, t);
            c = r, t = e, a = n;
        }
    }), Et = function(c) {
        return A3(Ot, F2(function(c, t) {
            return t + 1;
        }), 0, c);
    }, Rt = g, St = F3(function(c, t, a) {
        for(;;){
            if (u(c, t) >= 1) return a;
            var n = c, r = t - 1, e = A2(gt, t, a);
            c = n, t = r, a = e;
        }
    }), Xt = F2(function(c, t) {
        return A3(St, c, t, M);
    }), qt = F2(function(c, t) {
        return A3(Rt, c, A2(Xt, 0, Et(t) - 1), t);
    }), Ht = function(c) {
        return A3(Ot, gt, M, c);
    }, Ft = 32, Vt = F4(function(c, t, a, n) {
        return {
            $: 0,
            a: c,
            b: t,
            c: a,
            d: n
        };
    }), Dt = [], Ut = $, Bt = F2(function(c, t) {
        return y(t) / y(c);
    }), Pt = Ut(A2(Bt, 2, Ft)), Gt = A4(Vt, 0, Pt, Dt, Dt), Wt = a, Yt = m, Jt = function(c) {
        return c.length;
    }, Zt = F2(function(c, t) {
        return u(c, t) > 0 ? c : t;
    }), Qt = n, Kt = F2(function(c, t) {
        for(;;){
            var a = A2(Qt, Ft, c), n = a.b, r = A2(gt, {
                $: 0,
                a: a.a
            }, t);
            if (!n.b) return Ht(r);
            c = n, t = r;
        }
    }), ca = F2(function(c, t) {
        for(;;){
            var a = Ut(t / Ft);
            if (1 === a) return A2(Qt, Ft, c).a;
            c = A2(Kt, c, M), t = a;
        }
    }), ta = F2(function(c, t) {
        if (t.b) {
            var a = t.b * Ft, n = Yt(A2(Bt, Ft, a - 1)), r = c ? Ht(t.e) : t.e, e = A2(ca, r, t.b);
            return A4(Vt, Jt(t.d) + a, A2(Zt, 5, n * Pt), e, t.d);
        }
        return A4(Vt, Jt(t.d), Pt, Dt, t.d);
    }), aa = F5(function(c, t, a, n, r) {
        for(;;){
            if (0 > t) return A2(ta, !1, {
                e: n,
                b: a / Ft | 0,
                d: r
            });
            var e = {
                $: 1,
                a: A3(Wt, Ft, t, c)
            };
            t -= Ft, n = A2(gt, e, n);
        }
    }), na = F2(function(c, t) {
        if (c > 0) {
            var a = c % Ft;
            return A5(aa, t, c - a - Ft, c, M, A3(Wt, a, c - a, t));
        }
        return Gt;
    }), ra = function(c) {
        return !c.$;
    }, ea = S, da = X, ua = q, ia = function(c) {
        return {
            $: 0,
            a: c
        };
    }, ha = function(c) {
        switch(c.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, fa = function(c) {
        return c;
    }, pa = fa, oa = function(c) {
        return c.length;
    }, Ma = L, ba = F2(function(c, t) {
        return 1 > c ? "" : A3(Ma, 0, c, t);
    }), sa = function(c) {
        for(var t = 0, a = c.charCodeAt(0), n = 43 == a || 45 == a ? 1 : 0, r = n; c.length > r; ++r){
            var e = c.charCodeAt(r);
            if (48 > e || e > 57) return zt;
            t = 10 * t + e - 48;
        }
        return r == n ? zt : lt(45 == a ? -t : t);
    }, la = J, za = la(0), ga = F4(function(c, t, a, n) {
        if (n.b) {
            var r = n.a, e = n.b;
            if (e.b) {
                var d = e.a, u = e.b;
                if (u.b) {
                    var i = u.a, h = u.b;
                    if (h.b) {
                        var f = h.b;
                        return A2(c, r, A2(c, d, A2(c, i, A2(c, h.a, a > 500 ? A3(Ot, c, t, Ht(f)) : A4(ga, c, t, a + 1, f)))));
                    }
                    return A2(c, r, A2(c, d, A2(c, i, t)));
                }
                return A2(c, r, A2(c, d, t));
            }
            return A2(c, r, t);
        }
        return t;
    }), va = F3(function(c, t, a) {
        return A4(ga, c, t, 0, a);
    }), $a = F2(function(c, t) {
        return A3(va, F2(function(t, a) {
            return A2(gt, c(t), a);
        }), M, t);
    }), ma = Q, ya = F2(function(c, t) {
        return A2(ma, function(t) {
            return la(c(t));
        }, t);
    }), wa = F3(function(c, t, a) {
        return A2(ma, function(t) {
            return A2(ma, function(a) {
                return la(A2(c, t, a));
            }, a);
        }, t);
    }), xa = function(c) {
        return A3(va, wa(gt), la(M), c);
    }, ka = oc, _a = F2(function(c, t) {
        var a = t;
        return ac(A2(ma, ka(c), a));
    });
    hc.Task = fc(za, F3(function(c, t) {
        return A2(ya, function() {
            return 0;
        }, xa(A2($a, _a(c), t)));
    }), F3(function() {
        return la(0);
    }), F2(function(c, t) {
        return A2(ya, c, t);
    }));
    var ja, La, Aa = bc("Task"), Ca = F2(function(c, t) {
        return Aa(A2(ya, c, t));
    }), Ia = et, Ta = O, Na = E, Oa = {
        $: 0
    }, Ea = {
        $: 0
    }, Ra = function(c) {
        return {
            $: 1,
            a: c
        };
    }, Sa = {
        $: 0
    }, Xa = F7(function(c, t, a, n, r, e, d) {
        return {
            aR: r,
            aT: t,
            a3: a,
            a4: e,
            a7: c,
            bk: n,
            bl: d
        };
    }), qa = Ic("d"), Ha = Ic("fill"), Fa = Ic("id"), Va = kc("http://www.w3.org/2000/svg"), Da = Va("path"), Ua = Ic("stroke"), Ba = Ic("stroke-width"), Pa = l([
        A2(Da, l([
            Fa("line2877"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M345.95 415.206h-39.644")
        ]), M),
        A2(Da, l([
            Fa("polyline2879"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("m362.343 413.2-8.131 5.804-34.303.12v-3.771")
        ]), M)
    ]), Ga = Va("circle"), Wa = Ic("cx"), Ya = Ic("cy"), Ja = Ic("font-family"), Za = Ic("font-size"), Qa = F2(function(c, t) {
        return A2(kc, c, function(c) {
            return Nc.test(c) ? "p" : c;
        }(t));
    })("http://www.w3.org/2000/svg"), Ka = Ic("r"), cn = Ic("style"), tn = xc, an = tn, nn = Va("tspan"), rn = Ic("x"), en = A2(Tc, "http://www.w3.org/XML/1998/namespace", "xml:space"), dn = Ic("y"), un = l([
        A2(Da, l([
            Fa("polyline9"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M85.795 115.269h59.738V96.547h55.236")
        ]), M),
        A2(Da, l([
            Fa("polyline2617"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M145.533 115.061v27.489l55.496-.156")
        ]), M),
        A2(Ga, l([
            Fa("circle2615"),
            Wa("203.792"),
            Ya("142.356"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A3(Qa, "text", l([
            en("preserve"),
            Fa("l_Cervicle_Vertebrae"),
            rn("21.096"),
            dn("99.933"),
            cn("text-align:start;line-height:120.00000477%;-inkscape-font-specification:Arial")
        ]), l([
            A2(nn, l([
                Fa("tspan4015"),
                rn("21.096"),
                dn("99.933")
            ]), M),
            A2(nn, l([
                Fa("tspan4017"),
                rn("85"),
                dn("113.133")
            ]), l([
                A2(nn, l([
                    Fa("tspan4019"),
                    Ja("Arial"),
                    Za("7"),
                    Ha("#333"),
                    cn("text-align:start;line-height:120.00000477%;-inkscape-font-specification:Arial")
                ]), l([
                    an("(I-VII)")
                ]))
            ]))
        ]))
    ]), hn = l([
        A2(Ga, l([
            Fa("circle2515"),
            Wa("241.585"),
            Ya("150.952"),
            Ka("1.166"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line2521"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M244.954 151.676h93.547")
        ]), M)
    ]), fn = l([
        A2(Da, l([
            Fa("line2811"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M21.059 386.608H197")
        ]), M),
        A2(Ga, l([
            Fa("circle2813"),
            Wa("202.087"),
            Ya("386.833"),
            Ka("1.166"),
            Ha("red")
        ]), M)
    ]), pn = l([
        A2(Ga, l([
            Fa("circle2491"),
            Wa("203.02"),
            Ya("53.942"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A2(Da, l([
            Fa("line2495"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M205.714 53.975h60.606")
        ]), M)
    ]), on = l([
        A2(Da, l([
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M233.099 561.715h54.235")
        ]), M),
        A2(Ga, l([
            Wa("230.823"),
            Ya("562.081"),
            Ka("1.165"),
            Ha("red")
        ]), M)
    ]), Mn = l([
        A2(Ga, l([
            Fa("circle3033"),
            Wa("239.013"),
            Ya("660.907"),
            Ka("1.166"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line3035"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M241.29 661.633h57.51")
        ]), M)
    ]), bn = l([
        A2(Ga, l([
            Fa("circle2745"),
            Wa("310.944"),
            Ya("288.576"),
            Ka("1.166"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line2747"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M314.82 288h34.382")
        ]), M)
    ]), sn = l([
        A2(Da, l([
            Fa("line2743"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M86.347 294.356h112.332")
        ]), M),
        A2(Da, l([
            Fa("polyline3039"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M195.643 349.189h-78.362v-54.833")
        ]), M),
        A2(Ga, l([
            Fa("circle2741"),
            Wa("201.531"),
            Ya("293.79"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A2(Ga, l([
            Fa("circle3037"),
            Wa("200.654"),
            Ya("349.274"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A3(Qa, "text", l([
            Fa("l_Lumbar_Vertebrae"),
            rn("85"),
            dn("292"),
            cn("text-align:start;line-height:120.00000477%;-inkscape-font-specification:Arial")
        ]), l([
            A2(nn, l([
                Fa("tspan6791"),
                Ja("Arial"),
                Za("7"),
                Ha("#333"),
                cn("text-align:start;line-height:120.00000477%;-inkscape-font-specification:Arial")
            ]), l([
                an("(L I - L V)")
            ]))
        ]))
    ]), ln = Ic("display"), zn = Ic("overflow"), gn = l([
        A2(Ga, l([
            Fa("circle2493"),
            Wa("203.493"),
            Ya("118.878"),
            Ka("1.166"),
            Ha("red"),
            ln("inline"),
            zn("visible")
        ]), M),
        A2(Da, l([
            Fa("line2497"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M206.836 118.84h59.514"),
            ln("inline"),
            zn("visible")
        ]), M)
    ]), vn = l([
        A2(Ga, l([
            Fa("circle2523"),
            Wa("203.64"),
            Ya("167.315"),
            Ka("1.166"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line2525"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M206.915 166.947h132.132")
        ]), M)
    ]), $n = l([
        A2(Da, l([
            Fa("line2875"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M359.061 436.88h-40.288")
        ]), M)
    ]), mn = l([
        A2(Da, l([
            Fa("line3089"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M291.107 788H232.67")
        ]), M)
    ]), yn = l([
        A2(Ga, l([
            Fa("circle3025"),
            Wa("231.915"),
            Ya("595.388"),
            Ka("1.165"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line3027"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M235.284 595.021h52.05")
        ]), M)
    ]), wn = l([
        A2(Ga, l([
            Fa("circle2849"),
            Wa("240.921"),
            Ya("359.371"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A2(Da, l([
            Fa("line2847"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M243.893 359.146h137.105")
        ]), M)
    ]), xn = l([
        A2(Da, l([
            Fa("line2881"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M365.615 455.244h-49.026")
        ]), M),
        A2(Da, l([
            Fa("polyline2903"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M332.223 455.244v14.925h29.843")
        ]), M),
        A2(Da, l([
            Fa("polyline3091"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M249.497 801.299h23.61V811.5h25")
        ]), M),
        A2(Da, l([
            Fa("line3093"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M284.107 811.5h-45.579")
        ]), M)
    ]), kn = l([
        A2(Ga, l([
            Fa("circle2815"),
            Wa("334.29"),
            Ya("342.992"),
            Ka("1.165"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line2817"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M337.156 343.314h43.133")
        ]), M)
    ]), _n = l([
        A2(Da, l([
            Fa("polyline2547"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M226.668 146.305h87.618v73.257h-62.052")
        ]), M),
        A2(Da, l([
            Fa("polyline2549"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M242.508 297.333h42.939v-77.771h54.145")
        ]), M),
        A2(Ga, l([
            Fa("circle2545"),
            Wa("238.724"),
            Ya("296.753"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A2(Ga, l([
            Fa("circle2543"),
            Wa("248.884"),
            Ya("219.926"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A2(Ga, l([
            Fa("circle2541"),
            Wa("224.854"),
            Ya("145.629"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M)
    ]), jn = l([
        A2(Da, l([
            Fa("line2807"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M22.625 372.253h174.42")
        ]), M),
        A2(Ga, l([
            Fa("circle2809"),
            Wa("200.153"),
            Ya("372.477"),
            Ka("1.165"),
            Ha("red")
        ]), M)
    ]), Ln = l([
        A2(Ga, l([
            Fa("circle2517"),
            Wa("263.306"),
            Ya("180.708"),
            Ka("1.166"),
            Ha("red"),
            ln("inline"),
            zn("visible")
        ]), M),
        A2(Da, l([
            Fa("line2519"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M266.171 181.031h72.618")
        ]), M)
    ]), An = l([
        A2(Ga, l([
            Fa("circle2529"),
            Wa("201.928"),
            Ya("195.581"),
            Ka("1.165"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line2527"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M204.899 195.357h135.602")
        ]), M)
    ]), Cn = l([
        A2(Da, l([
            Fa("polyline3085"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M224.627 761.883h22.48V769h42")
        ]), M),
        A2(Da, l([
            Fa("polyline3087"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M216.107 777h36v-8")
        ]), M)
    ]), In = l([
        A2(Da, l([
            Fa("polyline3041"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M198.015 281.016h-80.734v-130.12")
        ]), M),
        A2(Da, l([
            Fa("line2723"),
            Ha("none"),
            Ua("#003cff"),
            Ba(".546"),
            qa("M86.715 151.433h113.784")
        ]), M),
        A2(Ga, l([
            Fa("circle2721"),
            Wa("203.35"),
            Ya("151.959"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A2(Ga, l([
            Fa("circle3043"),
            Wa("201.531"),
            Ya("280.686"),
            Ka("1.166"),
            Ha("#003cff")
        ]), M),
        A3(Qa, "text", l([
            Fa("l_Thoracic_Vertebrae"),
            rn("85"),
            dn("149"),
            cn("text-align:start;line-height:120.00000477%;-inkscape-font-specification:Arial")
        ]), l([
            A2(nn, l([
                Fa("tspan6783"),
                Ja("Arial"),
                Za("7"),
                Ha("#333"),
                cn("text-align:start;line-height:120.00000477%;-inkscape-font-specification:Arial")
            ]), l([
                an("(T I - T XII)")
            ]))
        ]))
    ]), Tn = l([
        A2(Ga, l([
            Fa("circle3029"),
            Wa("224.817"),
            Ya("625.964"),
            Ka("1.165"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line3031"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M228.186 625.597h56.419")
        ]), M)
    ]), Nn = l([
        A2(Ga, l([
            Fa("circle2803"),
            Wa("315.18"),
            Ya("330.027"),
            Ka("1.166"),
            Ha("red")
        ]), M),
        A2(Da, l([
            Fa("line2805"),
            Ha("none"),
            Ua("red"),
            Ba(".546"),
            qa("M318.045 330.351h61.699")
        ]), M)
    ]), On = Va("g"), En = l([
        A2(On, l([
            Fa("g1993")
        ]), l([
            A2(Da, l([
                Fa("path1995"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M342.515 420.204c-.104.476-.425.879-.93 1.025-.794.231-1.581.548-2.415.287-.489-.153-.718-.63-1.004-1.028-.418-.578-.563-1.022-.772-1.768-.234-.83-.565-1.929-.396-2.789.341-1.738 2.133-1.576 3.506-1.238.933.23 1.468 1.058 1.689 1.94.104.413.039.8.095 1.212.074.583.159 1.174.247 1.758.027.204.023.408-.02.601z")
            ]), M),
            A2(Da, l([
                Fa("path1997"),
                Ha("#dcc06d"),
                qa("M338.785 418.123c-.205-.163-.017-.418.171-.519.271-.147.476.002.674.191.251.241.681 1.073.034 1.024.328.513.98.306 1.23.914.037-.02.072-.034.104-.05.247.24.384.618.23.933.186.126.138.381.275.537.127-.29.348-.276.539-.451.218-.201.254-.5.23-.772-.074-.918-.39-1.833-.577-2.736-.065-.315-.065-.685-.149-.981-.071-.247-.223-.366-.336-.57-.102-.183-.149-.379-.294-.534-.239-.259-.593-.158-.83-.339.756.363 1.356 1.22 1.53 2.036-.251.023-.685-.607-.892-.797-.117-.107-.324-.234-.403-.375-.045-.075-.079-.192-.101-.232-.013-.026.021-.136-.036-.225-.034-.052-.243-.123-.308-.178-.204-.173-.134-.265-.481-.296-.432-.039-.913.03-1.333.14-.731.194-.717.431-.843 1.095.077-.237.652-1.258.98-.738-.255-.131-.422.098-.573.292a.916.916 0 0 0 .088.184c.05-.148.384-.436.522-.222.076.117-.104.368-.139.479-.165.55-.35.946-.188 1.511-.005-.066-.073-.646.175-.573.184.056.085.423.038.516a.61.61 0 0 0 .339.032c-.42-.61-.205-1.723.593-1.874.286-.053.792.005.777.397-.012.327-.544.519-.805.581.158.066.322.105.457.214.372-.284.975-.049 1.295.219.287.241.4.651.462 1.026.073.457.167.586.399.986.151.269.276.588.123.887-.038-.005-.087.002-.127 0-.026.191.104.336.132.521-.293-.156-.423-.647-.615-.913-.132-.178-.3-.326-.428-.506-.252-.357-.144-.764-.412-1.12-.595-.788-1.723-.719-2.039.292.036.01.066.017.094.026-.058.158-.23.139-.288.258-.076.159.06.136.043.299-.031.266-.281.533.017.74-.115-.078.048-.502.115-.569a.693.693 0 0 1 .365.479c-.017-.095.041-.292.017-.364-.035-.108-.187-.14-.223-.255-.088-.282.111-.502.372-.62z")
            ]), M),
            A2(Da, l([
                Fa("path1999"),
                Ha("#dcc06d"),
                qa("M339.12 419.274c-.09-.035-.141-.095-.149-.181.474-.452 1.348.444 1.489.866-.453-.123-.852-.799-1.391-.715")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2001")
        ]), l([
            A2(Da, l([
                Fa("path2003"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M352.533 411.121c-.832-.218-1.86-.19-2.533-.774-.563-.485-.888-1.22-1.309-1.798-.445-.615-1.084-1.139-.292-1.707.896-.641 2.349-.693 3.409-.889 1.379-.252 2.582.051 3.859.384.314.083.587.268.855.442.125.083.336.271.47.323.169.066.296-.079.457-.002.197.093.426.424.646.551.349.206.754.398 1.132.55.7.276 1.476.417 2.016.968.377.385.808 1.12.566 1.619-.242.503-1.082.895-1.533 1.224-.766.56-1.612 1.075-2.519 1.362-.811.26-2.16.772-2.76-.023-.439-.578-.567-1.287-1.184-1.731-.371-.27-.827-.38-1.28-.499z")
            ]), M),
            A2(Da, l([
                Fa("path2005"),
                Ha("#dcc06d"),
                qa("M348.643 407.899c.51-.422 1.795.272 2.234.622.521.413 1.09.673 1.79.887-.275-.148-.31-.403-.517-.548-.26-.181-.753-.321-1.056-.454-.441-.197-1.929-.644-.912-1.002.374-.13.846-.167 1.237-.211.671-.081 1.33-.21 1.999-.274.604-.059 2.027-.231 2.511.2-.409.044-.77-.094-1.175.016.038.229.256.358.441.453-.252-.033-.544-.105-.789-.025.042.033.104.148.173.194-.405.279-.557-.285-.981-.237.045.055.077.144.119.202a.843.843 0 0 0-.494-.098.95.95 0 0 0 .277.292c.388-.265.39.296.599.324.278.035.216-.473.621-.197.011-.067.027-.115.041-.169.307.024.702.369.287.573.205.162.436.355.563.607a1.175 1.175 0 0 1-.037-.886c.159.03.274-.05.426-.074-.453-1.079 1.076-.216 1.371.146-.094-.018-.261.035-.38.009-.168.546 1.137.958 1.401 1.492.398-.007.802.062 1.173.148-.051-1.101.819-.195 1.023.304.305-.088.573.146.742.38.265-.573.314-.691-.196-1.184-.362-.349-.793-.582-1.256-.76-.479-.185-.957-.32-1.418-.55-.356-.176-.704-.639-1.043-.693.009.061.021.115.025.178-.528-.148-.962-.743-1.531-.94a8.095 8.095 0 0 0-1.778-.435c-1.073-.116-2.262.049-3.26.378-.599.199-1.317.274-1.774.746.047.001.111-.032.158-.037.053.307-1.026.373-.614.623")
            ]), M),
            A2(Da, l([
                Fa("path2007"),
                Ha("#dcc06d"),
                qa("M352.959 409.741c-.467-.228-.906-.228-1.399-.199-1.041.057-2.085-.008-2.65-.982.243.565.665 1.152 1.096 1.608.441.465.847.421 1.475.516.929.14 2.59.241 3.115 1.167-.037-.764-.988-1.794-1.637-2.11z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2009")
        ]), l([
            A2(On, l([
                Fa("g2011")
            ]), l([
                A2(Da, l([
                    Fa("path2013"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M353.628 422.394c-1.258-.225-2.384-.266-3.65-.345-.643-.041-.915-.728-1.097-1.367-.224-.789-.106-1.702-.236-2.516-.05-.322-.169-.537-.023-.842.243-.502.398-.306.207-.892-.169-.512-.342-1.023-.51-1.533-.348-1.042-.61-2.157-.077-3.189.254-.495.472-1.159.996-1.444.462-.25 1.124-.223 1.651-.274 1.195-.116 1.904.544 2.764 1.333.676.622.737 1.537 1.22 2.253.823 1.221 1.002 2.844 1.634 4.175.353.744.759 1.449.645 2.3-.056.421-.188.848-.322 1.251-.085.252-.162.869-.348 1.058-.44.441-2.274.134-2.854.032z")
                ]), M),
                A2(Da, l([
                    Fa("path2015"),
                    Ha("#dcc06d"),
                    qa("M350.87 420.268c-.222-.145-.432-.327-.466-.597a.525.525 0 0 1 .487.312c.13-.018.193-.034.278-.133-.324-.254-.46-.614-.708-.91-.042.111-.145.201-.163.338-.322-.607-.619-1.725-.48-2.355a3.557 3.557 0 0 0-.081.153c-.733-.544-.67-2.024-1.034-2.763-.275-.564-.48-1.303-.256-1.921.151-.417.932-1.207 1.4-1.221.359-.012.382.208.698.313.352.118 1.191-.113 1.222.505-.364.131-.979.161-1.248.429.36-.133 1.304-.18 1.484.184-.084.013-.251.103-.356.107.163.066.408.159.541.289-.261.12-.545.058-.805.181.288.158.821.314 1.156.388-.077-.094-.158-.269-.27-.369.043-.04.086-.088.131-.129-.071-.098-.396-.302-.374-.463.042-.345.464-.143.606.006.108-.071.263-.205.339-.302-.318-.15-1.186-.142-1.034-.672-.492-.005-.969-.818-.23-.864.519-.033 1.175.593 1.508.936.438.457.148.655.198 1.154.02.177.305.478.424.604.187.198.479.365.519.662.013.092-.196.282-.215.385-.009.04.032.4.036.438.058.348.109.524.269.89.263.611 1.026 1.481.87 2.176-.404-.871-.904-1.708-1.519-2.413-.215-.245-.704-1.208-.274-1.325-.372-.183-.879-.32-1.277-.42-.02.09.006.29.031.37.281-.012.542.274.715.47-1.09-.162-1.521-1.144-2.739-.808.523.137.877.215 1.028.817.67-.206 1.504.809 2.023 1.1.195.109 1.182.658.455.877.16.561.074 1.022.563 1.401.033-.06.074-.114.098-.178.147.262.071.651.202.91.149.289.484.373.571.683.032-.069.107-.198.127-.253-.282.412-.467.708-.907.97-.648.386-1.166.16-1.881.186.457.571 1.259.183 1.796.036.23-.063.561-.036.746-.203.205-.186.008-.527.342-.635.236.524-.313 1.12-.661 1.416-.407.343-.6.314-1.113.28-.603-.042-1.645-.297-2.162.12-.154.127-.304.36-.329.541.437.196.962.003 1.427.066.821.109 1.582.352 2.417.319.65-.025 1.134.109 1.352-.624.207-.692-.053-1.338-.021-2.049.031-.648-.159-1.168-.444-1.783-.48-1.029-.706-2.014-.942-3.131-.119-.577-.447-1.027-.698-1.544-.247-.51-.359-1.06-.757-1.492-.465-.507-1.131-1.303-1.798-1.506-.632-.19-1.111.263-1.7.358-.42.067-1.098.085-1.38.464-.271.359-.39 1.266-.424 1.709-.111 1.351.337 2.6.781 3.878.127.37.355.769.172 1.149-.053-.004-.098-.021-.146-.028-.086.398-.053.919.146 1.267-.009-.017-.271.458-.285.518-.054.221-.026.441.038.655.111.377.366.435.539.708.187.297.115.795.448.989.355.208.989-.125.958-.539-.018-.243-.843-1.091.036-1.077z")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2017"),
                Ha("#ccb25c"),
                qa("M350.202 421.608c-.287.159-.522.099-.623-.225-.004-.021.035-.211.035-.245a2.889 2.889 0 0 0-.067-.702c-.085-.385-.3-.728-.404-1.106-.071-.252-.111-.501-.214-.744-.058-.14-.18-.294-.189-.449-.016-.159.062-.153.085-.286.024-.126.013-.218.047-.312.043-.121.137-.256.139-.427.1.211.098.483.147.71a6 6 0 0 0 .376 1.113c.311.716.729 1.381.829 2.152.025-.081.06-.161.098-.239.09.267.036.696-.279.794")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2019")
        ]), l([
            A2(On, l([
                Fa("g2021")
            ]), l([
                A2(Da, l([
                    Fa("path2023"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M349.24 410.98c-.013.334-.284.636-.38.961-.188.638-.063 1.317-.697 1.714-.46.292-1.085.242-1.596.388a3.913 3.913 0 0 1-1.728.11c-.59-.1-.614-.409-1.081-.655-.685-.359-1.452-.172-2.141-.525-.51-.264-1.237-.739-1.437-1.324-.094-.274.026-.518 0-.781-.021-.24-.201-.445-.211-.688-.017-.67.489-1.193.949-1.603.244-.213.396-.416.74-.456.531-.059.499.123.933-.177 1.019-.704 2.31-.619 3.482-.524 1.021.083 1.776.231 2.144 1.303.133.382.226.736.463 1.072.27.387.579.643.56 1.185z")
                ]), M),
                A2(Da, l([
                    Fa("path2025"),
                    Ha("#dcc06d"),
                    qa("M340.716 409.511c.187-.017.38-.058.549-.033-.165-.203.229-.78.553-.519-.039.09-.03.18-.09.276.261-.133.602-.595.915-.458.444.19-.156.437-.367.512.133.123.23.181.414.154-.144.209-.565.355-.798.214a1.167 1.167 0 0 0-.287.148c.243.422.458.081.696-.089.335-.236.412-.264.832-.273-.104-.191-.08-.397-.138-.623.406-.201 1.258-.019 1.685.093-.083-.227-.273-.392-.472-.497.465.076.955.141 1.409.302a.124.124 0 0 1-.019-.092c.441-.081 1.414-.008.697.391-.431.239-1.059.144-1.572.047.028.061.046.121.082.176-.313.102-.615-.013-.915.13.087.027.146.092.219.124-.251.514.161.819.509 1.167-.263-.253-.724-.891-.455-1.238.335.056 1.12.385 1.013.819.107.027.292.049.399.03-.241-.327-.819-1.209.036-.851.316.131.913 1.046.969 1.367-.06.001-.113-.004-.171-.003.209.056.439.085.66.064a.755.755 0 0 1-.244-.443c.094-.006.192-.068.308-.056-.79-.634.078-1.061.701-.565.337.271.341.747-.154.845.046.037.086.097.146.137-.147.029-.307.118-.456.145a3.59 3.59 0 0 0 1.308.286.19.19 0 0 1-.068-.111c.024-.009.231-.119.272-.149-.039-.516-.526-1.108-.853-1.463.058.01.127.024.193.04-.256-.249-.8-.379-.863-.78.218-.091.427.027.535.232.053-.035.021-.061.025-.125-.011.001.221-.045.19-.024-.203-.219-.525-.514-.445-.828-1.116-.726-2.479-.565-3.667-.319-.479.098-1.004.378-1.468.522-.486.152-1.141.04-1.372.67.048-.03.097-.07.14-.101.455.486-.571.589-.819.559-.022.133.056.114.103.163")
                ]), M),
                A2(Da, l([
                    Fa("path2027"),
                    Ha("#dcc06d"),
                    qa("M340.584 410.94a.929.929 0 0 1-.063-.505c.288.02.591-.411.753-.093-.348-.071-.6.158-.348.425-.16.027-.315.134-.401.189")
                ]), M),
                A2(Da, l([
                    Fa("path2029"),
                    Ha("#dcc06d"),
                    qa("M342.052 411.193c-.077-.104-.053-.245-.141-.354.225-.113.601-.058.514.244-.22-.108-.41-.024-.479.206")
                ]), M),
                A2(Da, l([
                    Fa("path2031"),
                    Ha("#dcc06d"),
                    qa("M341.528 411.936c.735.554 1.878 1.001 2.819 1.054.445.023 1.603-.398 1.768.109.76-.057 1.963-.39 2.413-1.052-.216.88.021 1.335-.96 1.534-.922.185-1.698.413-2.653.274-.733-.107-1.214-.729-1.875-1.034-.683-.315-1.55-.369-2.156-.814.225.007.476.048.662-.009")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2033"),
                Ha("#ccb25c"),
                qa("M343.868 413.182c1.284.267 2.504.02 3.779-.25.038.268.143.427-.058.582-.257.197-1.148.262-1.466.288-.416.032-.816-.146-1.212-.248-.313-.082-.703-.144-.951-.353")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2035")
        ]), l([
            A2(On, l([
                Fa("g2037")
            ]), l([
                A2(Da, l([
                    Fa("path2039"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M344.614 425.186c-1.003-.293-2.067-1.176-2.913-1.77-.491-.343-1.41-1.068-1.515-1.693-.124-.741.54-1.194 1.229-1.145.515.037.733.034 1.165-.273.377-.269.658-.639 1.162-.659.796-.033 1.644.781 1.908 1.471-.544-.497-.765-1.177-1.571-1.398-.612-.168-.937.156-1.497.26-.236.043.345-1.137.364-1.182.201-.47.318-1.066.303-1.578-.015-.479-.141-1.189.101-1.615.211-.375.387-.658.512-1.073.395-1.294 1.106-1.429 2.355-.97 1.249.458 1.851 1.846 2.31 2.982.236.591.394 1.205.573 1.825.205.698.645 1.419.664 2.134.014.623-.125 1.632-.455 2.132-.441.67-1.254 1.546-1.922 1.995-.666.447-1.967.789-2.773.557z")
                ]), M),
                A2(Da, l([
                    Fa("path2041"),
                    Ha("#dcc06d"),
                    qa("M343.447 417.014v-.019c-.047-.929.084-2.105.663-2.882.565-.758 1.615-.643 2.331-.189.857.543 1.266 1.64 1.709 2.505-.137-.14-.742-.57-.78-.75.122.545.366 1.187.705 1.616.284.363.538.593.624 1.115.062.373.012.601-.15.944-.106.232-.309.427-.37.682-.016.068.035.687.079.639-.125.142-.257.251-.353.411.004.036.047.181.058.212.182.054 1.061.235 1.149-.001-.128.333.204.634.139.891-.13.5-.51.19-.864.284-.728.188-.979 2.118-1.971 1.509.764.033.672-.511.89-1.022.089-.21.324-.327.393-.569.301-1.074-.55-.205-.582-.228-.201-.141-.38-.272-.571-.416.265-.442.665-.774.406-1.327-.114-.244-.507-.57-.79-.438-.434.198-.173.768-.146 1.107.023.294.006.564-.06.924.159-.886-1.005-1.272-1.096-2.035-.048-.394.372-.467.278-.832-.096-.374-.758-.422-1.04-.573.153-.226.321-.513.547-.69.215.198.468.223.515-.129-.016.106.537.492.638.53.361.139.497.084.774-.178.604-.572.049-1.256-.177-1.872-.205-.557-.173-1.771-.63-2.175-.727-.644-1.373.454-1.661.994-.439.832-.391 1.794-.343 2.703.017.301-.115 1.008-.005 1.247.156.322.729.231.768.636-.616.033-1.317-.317-1.706.288-.126.194-.306.477-.337.684-.119.753.346 1.163-.382 1.69-.132-.391-.481-.842-.834-.358-.023-.534-.348-.137-.561-.3-.124-.095-.273-.463-.03-.646.382-.287 1.064.242 1.523-.165.175-.157.339-.708.418-.982.128-.436.447-.769.607-1.197.217-.572.253-1.048.225-1.638z")
                ]), M),
                A2(Da, l([
                    Fa("path2043"),
                    Ha("#dcc06d"),
                    qa("M342.763 423.05c-.233-.374.453-.647.491-1.106.144.547 1.316 2.811 1.989 2.409a.722.722 0 0 1-.293.536c-.739-.654-1.18-1.723-2.287-1.81.054-.085.05-.22.09-.292")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2045"),
                Ha("#ccb25c"),
                qa("M343.656 419.732c.176-1.032 1.154.148 1.389.376.205.201.42.344.627.617.257.338.662.721.854 1.063-.751-.298-1.12-.86-1.625-1.444-.199-.225-.389-.47-.675-.583-.191-.078-.398-.041-.591-.121.01-.095.077-.135.167-.17")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2047")
        ]), l([
            A2(On, l([
                Fa("g2049")
            ]), l([
                A2(Da, l([
                    Fa("path2051"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M343.531 419.126c.462-.854.125-2.022-.084-2.905-.112-.479-.459-1.162-.373-1.654.083-.488.654-.958.301-1.493-.31-.465-1.484-.661-1.977-.892-.879-.409-1.696-1.38-2.52-.225-.892 1.255-.878 2.476-.569 3.921.313 1.462.863 3.414 2.53 3.85.451.117 1.396.407 1.84.349.514-.069.999-.916.996-1.387")
                ]), M),
                A2(Da, l([
                    Fa("path2053"),
                    Ha("#dcc06d"),
                    qa("M338.343 414.5c.041-.292.32-.396.555-.508-.155-.004-.165-.081-.245-.145.209-.095.454-.053.656-.156-.115-.113-.202-.29-.179-.458a.31.31 0 0 0 .384.095l-.004-.073c.483-.205.644-.402.629-.931.328.356.155.667.207 1.081.341-.005 1.024.057 1.335.197.151.069.177.142.296.238.223.177.459.24.711.368-.04-.222-.218-.621-.362-.736-.182-.146-.54-.241-.76-.343.388-.303-.591-.718-.814-.964.531.189 1.101.38 1.616.597.265.111.547.266.683.516.301.556-.247.828-.258 1.339-.002.231.17.437.243.662.1.297.109.631.217.946.293.849.351 1.571.058 2.443.02-.324-.083-.694-.368-.732-.241-.032-.432.094-.401.35.025.241.272.503.308.778.024.192.004.35-.037.536-.13-.126-.313.004-.354-.024-.134-.089-.146-.231-.184-.373-.108-.42-.299-.713-.454-1.118-.434-1.133-1.096-3.404-2.763-2.95-.087-.28-.272-.763-.665-.615 0-.037.026-.056.072-.055")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2055"),
                Ha("#ccb25c"),
                qa("M338.853 414.578c.576-.768 2.149-.262 2.7.317.506.532 1.399 2.371.798 3.021-.282-.092-.29-.423-.365-.672-.22-.764-.688-1.504-1.202-2.111-.474-.557-1.084-.79-1.749-.692")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2057")
        ]), l([
            A2(Da, l([
                Fa("path2059"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M365.708 417.569c-.493.589-1.12.675-1.789.927-.585.221-1.293.488-1.88.116-.524-.335-.457-1.112-.785-1.573-.289-.409-.867-.445-1.264-.789-.374-.324-.796-.869-1.088-1.272-.353-.48-.603-.933-.158-1.415.335-.361.866-.607 1.31-.84.966-.511 2.482-1.642 3.594-1.121.479.227.646.391 1.188.398.445.004.925-.019 1.266.308.357.345.334.78.376 1.223.043.482.248.976.256 1.455.017.863-.464 1.91-1.026 2.583z")
            ]), M),
            A2(Da, l([
                Fa("path2061"),
                Ha("#dcc06d"),
                qa("M361.856 416.805c-.713-.556-1.698-1.517-.662-2.349-1.11-.625.751-1.978.883-1.103-.053.037-.083.079-.127.114.278.128.526.376.618.663.139-.069.29-.118.426-.118-.616-.497.574-.748.967-.445.729.565-.445.05-.685.203.111.489.468.302.751.429-.074.061-.134.214-.224.273.358.291.818.096 1.256.157-.017-.229-.271-.397-.184-.626.382-.008.726.355.717.686.373.016.206.239.041.404-.188.187-.831.205-1.067.169.924.368 1.225.448.928 1.446.176-.191.291-.462.556-.551-.003-.496.234-.858.165-1.362-.06-.454-.105-.844-.096-1.298.028-1.285-.951-1.051-1.892-1.344-.977-.305-1.755-.812-2.762-.145-.405.268-.65.585-1.129.777-.386.156-.863.241-1.256.415.288.277.697.161 1.049.046.29-.096.869-.156 1.104-.31.243-.155.088-.2.239-.412.566-.789 1.97-.722 2.384.265-.798.32-1.827-.305-2.598.203-.391.258-.591.595-.578 1.025.018.556.032.815-.296 1.322-.604-.358-1.214-.55-1.701-1.074.491.76.837 1.393 1.592 1.868.531.334 1.165.809 1.432 1.377.221.47.274 1.011.959 1.071.455.04 1.765-.398 1.817-.911-.595.214-1.505.119-2.024-.304-.215-.176-.319-.327-.509-.46-.122-.085-.687-.129-.337-.499")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2063")
        ]), l([
            A2(Da, l([
                Fa("path2065"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M356.182 414.279c.293-.069.559-.187.852-.24.332-.058 1.134-.152 1.44-.024.344.142.332.518.563.797.218.261.547.381.837.542.595.334.861.927 1.147 1.551.347.753.311 1.867-.292 2.472-.888.89-2.741 1.347-3.827.461-.531-.435-.388-1.655-.567-2.334-.274-1.042-2.122-2.759-.153-3.225z")
            ]), M),
            A2(Da, l([
                Fa("path2067"),
                Ha("#dcc06d"),
                qa("M356.535 414.645c1.066-.37 1.593.549 2.312 1.132.328.268.827.239.658.746-.382.006-1.088-.327-1.416-.568.351.57.869.606 1.37.873-.004.24.006.496-.179.693-.462-.816-.997-.734-1.707-1.104.052.296.121.666.299.898.245.324.766.304.962.614.213.333.025.71-.248.785-.382.104-.887-.332-1.241-.429.109.155.247.398.41.509.3.201.336.083.652.181.557.172.573.312.565.877-.273.098-.582.021-.854-.012.731.463 1.495-.021 2.205-.407.872-.469.87-1.213.681-2.112-.215-1.008-1.235-1.762-1.981-2.379-.305-.251-.541-.767-.975-.821-.42-.053-1.176.16-1.516.445a.648.648 0 0 1 .511.003")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2121")
        ]), l([
            A2(Da, l([
                Fa("path2123"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M65.776 426.626c-.173-.171-.32-.405-.482-.56-.288-.273-.406-.513-.572-.87a3.286 3.286 0 0 1-.185-2.064c.131-.507 1.144-.967 1.016-1.461.36-.264.334-.785.785-1.027.726-.39 1.794-.002 2.454.39.918.547.98 1.413.541 2.283-.216.43-.25.677-.311 1.133-.138 1.054-2.083 3.322-3.246 2.176z")
            ]), M),
            A2(Da, l([
                Fa("path2125"),
                Ha("#dcc06d"),
                qa("M66.787 426.499c.536-.028.631-.821-.003-.749-.327.037-.618.398-.377.675-.496.237-.542-.044-.715-.488.635.081 1.005-1.083.402-1.385-.324-.161-.738.084-.849.396-.085.242.333.523-.187.553-.315-1.15-.695-1.996.236-2.927.515-.515.964-2.294 1.913-1.706.421.26.733.689 1.155.974.364.247.644.447.668.926.058 1.09-.224 2.673-1.188 3.323-.243.163-.505.407-.808.473")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2127")
        ]), l([
            A2(Da, l([
                Fa("path2129"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M75.16 420.265c.281-.713-1.138-2.148-1.602-2.67-.418-.473-.875-1.446-1.439-1.742-.529-.278-1.455.478-1.914.81-1.228.892-1.903 2.457-2.685 3.713-.562.904-1.221 1.901-1.378 2.976-.072.497-.084 1.83.71 1.771.521-.038.689-.457 1.164-.074.128.104.295.304.378.433.104.16.013.348.256.483.378.213.903-.091 1.227-.278 1.734-1.003 3.67-2.101 4.959-3.682.61-.748.159-1.044.386-1.739")
            ]), M),
            A2(Da, l([
                Fa("path2131"),
                Ha("#dcc06d"),
                qa("M72.343 419.893c.279-.224.694-.294 1.032-.38-.08-.242-.514-.237-.709-.133-.112-.05-.158-.073-.29-.029.008-.17.216-.271.334-.41-.144.032-.298.07-.441.077.223-.174.541-.259.738-.444-.224-.011-.456.078-.667.154-.405.143-.929.271-1.276.53-.337.254-.668.65-.911.996.132-.112.372-.609.409-.775-.075.035-.167.03-.242.067.082-.341.545-.763.822-.971.429-.32 1.043-.332 1.449-.617-.226-.144-.876.048-1.146.117.141-.083.292-.295.106-.413-.224-.14-.86.31-1.098.353-.031-.368.654-.878.987-.936.298-.051.663.226.777.452.14-.176.313-.354.418-.543-.285-.13-.695.003-.913-.334-.198-.306.057-.515.206-.773-.493.062-1.052.557-1.444.856-.532.405-.952.933-1.329 1.489-.478.707-.9 1.443-1.272 2.204-.314.645-.768 1.224-1.053 1.861-.208.465-.75 1.868-.202 2.235.239-.226.392-.532.7-.666-.011-.313.293-1.316.703-1.325.409-.009-.002.754-.031 1.029.088-.004.22.035.313.019-.135.298-.377.426-.483.615-.002.002-.071.384-.073.372.038.169.099.134.239.249.233.191.473.609.737.715.363.146.859-.213 1.106-.449-.209-.144-.448-.117-.602-.398a.878.878 0 0 1-.042-.748c.251-.621.866-1.146 1.325-1.607-.059-.158-.201-.301-.323-.41-.2.167-1.424 1.452-1.669.998-.182-.34.836-1.099.747-1.571-.275-.137-.92.436-.996.13-.072-.287.902-.742 1.077-.833.281-.146.55-.385.828-.5.095.465-.278.947-.067 1.44.207-.189.629.116.654.362.3-.43.593-.865.923-1.279.351-.44.398-.783.9-.943")
            ]), M),
            A2(Da, l([
                Fa("path2133"),
                Ha("#dcc06d"),
                qa("M73.999 418.98c.084-.233-.136-.347-.325-.411.025.22-.135.375-.329.456.27.008.555-.128.779.08")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2135")
        ]), l([
            A2(On, l([
                Fa("g2137")
            ]), l([
                A2(Da, l([
                    Fa("path2139"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M78.511 414.319c-.416-.213-.768-.352-1.243-.378-.842-.048-1.848-.098-2.688.128-.53.143-1.563.425-1.706 1.055-.147.655.591 1.594.842 2.205.301.736.536 1.263 1.055 1.88.394.468.895.708 1.319 1.111.624.595.18 1.2 1.244 1.187 1.049-.014 2.441-.747 2.963-1.694.465-.842.352-2.187.157-3.086-.247-1.143-.905-1.873-1.943-2.408z")
                ]), M),
                A2(Da, l([
                    Fa("path2141"),
                    Ha("#dcc06d"),
                    qa("M74.554 414.226c.734-.215 1.447-.283 2.188-.105.621.149 1.362.096 1.914.472.748.507.603 1.046-.299 1.019-.005-.039.02-.07.015-.105.003.148.11.331.085.475-.033.175-.214.333-.323.478.145-.311.275-.664.008-.903-.202-.182-.465-.166-.56.095-.436-.884-3.145-.762-3.829-.272a.562.562 0 0 1 .467.056.376.376 0 0 1-.345.295c.359.183.383.552.34.922-.156-.44-.19-.659-.532-.845-.2-.107-.383.178-.45-.262-.088-.574.892-1.193 1.321-1.32z")
                ]), M),
                A2(Da, l([
                    Fa("path2143"),
                    Ha("#dcc06d"),
                    qa("M74.538 417.781c.075-.215.182-.395.243-.603-.465.198-1-.156-1.115-.685-.03.27.096.624.238.854.096.157.312.214.385.413.042-.058.139-.116.176-.161a.759.759 0 0 1 .011.243")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2145"),
                Ha("#dcc06d"),
                qa("M79.072 419.146c.131-.432.267-.985.02-1.396-.182 1.262-1.31 2.681-2.793 2.01.194.519.118 1.007.648 1.328.392.236.876.311 1.315.22.353-.073 1.717-.813 1.423-1.341-.204-.363-.867-.045-.988-.63a.863.863 0 0 1 .25-.19")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2147")
        ]), l([
            A2(Da, l([
                Fa("path2149"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M70.589 423.173c-.351.296-.687.613-1.007.945-.177.184-.417.364-.574.549-.268.319-.451.786-.663 1.14-.239.398-.557.871-.577 1.353-.018.425.205.846.367 1.227-.47.19-.299.766-.04 1.058.37.416 1.189.516 1.787.743.684.259 1.043.466 1.798.386 1.028-.108 2.071-.289 3.097-.381.145-2.139 1.433-3.87 1.857-5.955.168-.829.673-1.774.442-2.637-.065-.243-.246-.491-.336-.706-.109-.258-.045-.418-.328-.588-1.165-.695-2.523.639-3.364 1.214-.604.415-1.285.746-1.867 1.18-.202.151-.399.308-.592.472z")
            ]), M),
            A2(Da, l([
                Fa("path2151"),
                Ha("#dcc06d"),
                qa("M76.215 421.134c-.562.198-1.709-.13-1.794.795.057.026.114.068.173.089-.356.387-1.007.407-1.483.604-.346.143-.673.423-.934.685-.271.273-.575.424-.854.689.206.092.865.209 1.059.012.192-.198.17-.628-.185-.573.63-.439 1.407-.185 2.081-.561.333-.188.416-.336.801-.359.326-.021.846.095.883.474-.943.031-1.82 1.188-1.571 2.113-.193-.012-.364.068-.422.246-.106-.063-.216-.074-.299-.23-.06.014-.111.041-.176.064-.063.201-.008.385.167.498a.346.346 0 0 1-.181.217c-.092-.173-.227-.329-.427-.364.108-.109.223-.265.299-.409-.317-.097-.323-.451-.603-.438a.977.977 0 0 1-.075.152c-.045-.356-.138-.556-.509-.598-.552-.065-.626.437-.053.509-.123.173-.298.481-.476.626-.198.159-.661.204-.78.414-.198.351.215.311.198.559-.013.195-.509.604-.61.799.391.018.79-.425.991-.719.261.202.031.541-.241.506a1.228 1.228 0 0 0-.065.223c.157.093.217.166.406.072-.09.235-.318.327-.43.533-.186-.178.471-.972-.293-.84-.566.1-.347.894-.55 1.249.082.195.048.437.063.658.152-.078.318-.153.483-.218-.265.589-.895.79-1.425.891-.427.08-1.331.012-1.198-.669.05-.26.273-.275.251-.554-.02-.25-.194-.608-.247-.873-.124-.629-.135-.985.213-1.552.59-.958 1.418-1.546 2.195-2.36.429-.449.862-.68 1.455-.916.677-.27 1.158-.689 1.682-1.184.445-.419 2.994-1.512 2.659-.146-.159-.021-.32-.038-.487-.053")
            ]), M),
            A2(Da, l([
                Fa("path2153"),
                Ha("#dcc06d"),
                qa("M74.654 429.223c.116-.495.187-1.042.209-1.132a9.995 9.995 0 0 1 .799-2.151c-.321.517-.557 1.12-1.065 1.523a.58.58 0 0 1-.12-.093c-.385.544-.126 1.665-.785 2.093.219-.143.429-.372.649-.547-.061.048-.327.882-.272.979.248.44.447-.079.585-.672z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2253")
        ]), l([
            A2(Da, l([
                Fa("path2255"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M80.418 419.723c-.178-.063-.585-.037-.717-.15-.293-.25-.145-1.024-.202-1.401-.154-1.042-.151-1.602.173-2.574.447-1.335 1.562-1.448 2.795-1.603.758-.095 1.424-.273 2.188-.049a4.555 4.555 0 0 1 2.298 1.543c.333.419.508.952.932 1.304.486.403 1.182.312 1.666.682.141.107.206.357.367.451.254.149.66.078.95.215.676.319.636 1.101.634 1.758-.005.875-.271 1.05-1.052 1.426-.768.369-1.474.841-2.235 1.241-.87.458-2.068 1.044-3.082.985-.934-.054-1.387-1.185-1.847-1.838-.64-.907-1.836-1.624-2.868-1.99z")
            ]), M),
            A2(Da, l([
                Fa("path2257"),
                Ha("#dcc06d"),
                qa("M89.686 421.261c-.321.767-1.625.285-2.23.496-.292.103-.356.273-.579.512-.501.537-1.449 1.17-2.097.806-1.207-.681-.307-2.379-1.846-2.987.329.348.626.616.742 1.098.066.275-.059.706.029.948.167.462.914 1.134 1.384 1.24 1.721.39 3.412-1.169 4.711-2.001-.401-.734 1.724.102 1.239-1.1-.242.27-.527.874-.982.74")
            ]), M),
            A2(Da, l([
                Fa("path2259"),
                Ha("#dcc06d"),
                qa("M87.575 417.349c-.203-.242-.493-.189-.616-.436.146-.056.168-.142.348-.135-.131-.154-.273-.292-.465-.351-.207.32-.887.795-1.245.43-.487-.5.561-1.032.903-1.243-.253-.207-.201-.552-.475-.811-.294-.279-.867-.594-1.224-.751.622.842 1.022 1.914-.205 2.415-1.03.423-3.104-.257-3.73.861-.537-.254-.069-1.032.19-1.325.519-.594.97-1.113 1.738-1.199.321-.036.615-.06.927-.125.403-.084.514.02.863.052 0-.071.022-.158.018-.23.06.019.163.017.234.049-.424-1.563-4.061-.136-4.652.69-.44.614-.603 1.713-.453 2.435.135.644.512.901.762 1.452.007-.024.023-.034.049-.031-.032.339.699.849.996.916-.021-.595.465-1.201.863-1.599-.167.033-.496-.015-.652.052-.251.11-.187.197-.384.392-.378.374-.733.214-.576-.394.235-.903 2.035-.972 2.807-1.046.695-.066 1.389-.476 1.977-.239.069.028.057.249.148.285.084.037.436-.092.547-.112.374-.067.737-.064 1.12-.064")
            ]), M),
            A2(Da, l([
                Fa("path2261"),
                Ha("#dcc06d"),
                qa("M90.929 418.53c-.479 0-1.101.2-1.479-.139-.194-.174-.288-.616-.556-.832.556.012 1.029.603 1.601.722.537.111.569.134.66.678-.191-.186-.437-.397-.724-.368")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2263")
        ]), l([
            A2(Da, l([
                Fa("path2265"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M91.038 427.793c-.397.289-.585.712-.88 1.102-.354.47-.776.526-1.245.815-.596-.717-1.355-1.441-1.847-2.257-.377-.627-.987-1.3-1.244-1.977-.241-.632-.287-1.403-.505-2.035.719-.063 1.418-.019 2.107-.276.308-.115.597-.259.821-.481.164-.163.226-.373.42-.496.789-.506 2.018-.335 2.845-.488.31.946 1.271.932 2 1.34.997.559.263 2.083.208 2.944-.087 1.379-1.742 1.128-2.68 1.809z")
            ]), M),
            A2(Da, l([
                Fa("path2267"),
                Ha("#dcc06d"),
                qa("M93.343 423.264c-.315.181-.424.438-.138.698a.868.868 0 0 0-.469.094c.047-.224-.293-.404-.508-.302.212-.37-.886-1.189-1.146-1.49.169.271.567.82.932.66-.108-.279-.439-.511-.644-.738.286-.086.45.126.644.291.247.206.548.373.867.421-.035.242.246.666.495.402.006-.043-.019-.042-.075.005")
            ]), M),
            A2(Da, l([
                Fa("path2269"),
                Ha("#dcc06d"),
                qa("M92.224 424.754c.434-.207.167-.475-.136-.239-.298.232.029.358.219.198")
            ]), M),
            A2(Da, l([
                Fa("path2271"),
                Ha("#dcc06d"),
                qa("M91.77 427.321c.065-.157.169-.256.232-.409-.477.172-.852-.215-1.226.208-.374.421-.48.893-.728 1.357.053-.254.067-.604-.004-.85-.22.352-.315.876-.382 1.261.86-.252.898-1.636 1.982-1.65")
            ]), M),
            A2(Da, l([
                Fa("path2273"),
                Ha("#dcc06d"),
                qa("M89.962 423.848c.037-.206.167-.372.083-.577-.245.367-.223.978-.378 1.402a4.413 4.413 0 0 1-.465.945c-.069.103-.164.129-.217.251-.125.284.141.708-.189.911-.053-.203-.26-.426-.289-.618-.041-.271.235-.713.281-1.006.132-.842.092-1.627-.206-2.416-.358.232-.713.566-1.111.733-.274.114-.771.044-.971.244-.19.189-.134.486.008.666.103.128.288.229.405.37.245.297.395.604.428.994a5.6 5.6 0 0 1-.085 1.489c-.055.303.024.465.249.695.229.238.491.412.711.672.212.251.403.544.608.818.029-.497-.097-.91-.036-1.396.085-.68-.059-1.113.521-1.581.394-.319.914-.793 1.046-1.308-.264-.268-.457-.924-.393-1.288z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2275")
        ]), l([
            A2(Da, l([
                Fa("path2277"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M83.419 420.575c.584.606.569 1.876.56 2.672-.008.617-.114 1.202-.263 1.795-.213.852-.568 1.658-.918 2.459-.238.548-.5 1.151-.147 1.713-.339-.125-.592-.58-.888-.81.165.348.9 1.041.415 1.428-.339.27-.977-.083-1.445.244-.425.298-.77.771-1.21 1.073-.594.405-1.538.447-2.25.543-1.113.148-2.139-.948-2.479-1.907-.47-1.317.376-2.475 1.032-3.557.539-.891 1.06-2.091 1.121-3.121.024-.417-.063-.686.149-1.027.202-.323.604-.551.784-.946.244-.542.111-.521.62-.819 1.01-.592 1.335-1.338 2.621-1.016.933.233 2.121.84 2.61 1.711")
            ]), M),
            A2(Da, l([
                Fa("path2279"),
                Ha("#dcc06d"),
                qa("M82.13 425.28c.569.065.83-.403.657-.914-.147-.437-.648-.763-1.042-.948-.258-.121-.552-.143-.76-.293-.303-.223-.298-.643-.723-.741-.157.212-.592.394-.695.723-.032.104.079.37.072.386-.057.131-.268.253-.379.372-.378.407-.847.663-1.257 1.041-.154.143-.488.396-.521.625-.048.322.19.284.026.575-.07.125-.458.3-.58.444-.2.239-.312.555-.419.844-.203.552-.445 1.229-.173 1.818.457.98 1.368.55 2.069.047.283-.203.64-.806.93-.925.171-.07.37.009.587 0-.592.317-1.866 2.348-2.582 1.938-.164.588.941.502 1.375.409.759-.158 1.774-.692 2.072-1.47-.427.455-.021.747.443.863a6.025 6.025 0 0 1-2.531.994c-.568.078-1.168.35-1.739.313-.674-.045-1.461-.646-1.784-1.229-.687-1.235.161-2.644.914-3.616.231-.298.369-.662.602-.935.258-.301.707-.511 1.026-.738.407-.293.819-.566 1.105-.983.207-.303.333-.589.624-.822.225-.181.579-.239.48-.622-.077-.303-.365-.33-.623-.297-.833.111-1.656 1.131-1.731 1.904-.297-.003-.541.154-.792.297.053-.294.263-.603.378-.896.133-.334.164-.697.263-1.057.098-.354.239-.381.451-.632.296-.349.309-.833.56-1.186.299-.421 1.211-.959 1.693-1.067.561-.125 2.173.2 2.479.688-.569.112-1.486-.089-1.814.52-.438.814.183 2.12.826 2.614.33.253.695.327 1.002.628.231.226.338.555.722.396.398-.165.473-1.09.452-1.46.053.964-.114 2.301-.438 3.199-.223.618-.51 1.202-.762 1.803-.16.38-.231 1.052-.526 1.313-.178-.355-.192-.761-.389-1.119-.083-.151-.415-.452-.423-.615-.02-.397.74-.753.906-1.131.231-.526-.079-.931-.655-.798-.408.094-.698.546-.822.915-.002-.396.194-1.054.56-1.272.358-.212.567.059.886.097z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2281")
        ]), l([
            A2(Da, l([
                Fa("path2283"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M87.976 427.589c-.232.653-.699 1.079-1.241 1.43-.639.414-1.02 1.006-1.553 1.508-1.069 1.007-2.093-.588-2.857-1.321-.439-.421-.655-.655-.485-1.302.126-.476.285-.979.409-1.443a4.36 4.36 0 0 1 .757-1.49c.162-.209.407-.576.623-.731.312-.225.547-.174.934-.262 1.109-.251 2.499-1.415 3.463-.159.223.293.158 1.333.178 1.714.036.679.003 1.409-.228 2.056z")
            ]), M),
            A2(Da, l([
                Fa("path2285"),
                Ha("#dcc06d"),
                qa("M85.366 425.201c.407-.054.964-.165 1.323-.374.084-.048.641-.688.571-.707-.248-.064-.355.192-.588-.037-.162-.16-.155-.36-.011-.522-.015-.014-.057-.009-.077-.011l-.011-.051c-.169-.011-.305.145-.462.205-.22.085-.477.145-.707.201-.318.079-.677.092-.968.208-.639.256-1.283 1.021-1.608 1.616-.158.29-.284.541-.34.86a4.966 4.966 0 0 1-.341 1.097c-.143.327-.19.406-.009.72.136.233.313.721.56.83.162-.379.12-.903.404-1.231.158.282-.039.764-.095 1.056-.069.359.106.325.361.508-.093-.213-.063-.699.191-.792.097.151.325.238.404.378.121.216-.195.313-.206.576.185.041.401.155.554.031.118-.096.13-.313.311-.423.126-.078.261-.049.373-.101.291-.133.08-.331.13-.56.025-.114.163-.216.204-.333a1.06 1.06 0 0 0 .04-.468c-.083-.386-.4-.576-.769-.598.307.15.41.511.333.835-.046.196-.195.546-.427.563.183.125.54-.072.652.093.279.407-.671.458-.849.431-.157-.023-.25-.12-.369-.205-.285-.202-.483-.402-.647-.72-.147-.284-.234-.739-.155-1.065.118-.497.876-.295 1.016-.698-.222-.212-.627.117-.866.177.119-.256.343-.469.615-.565.346-.121.655.043.995.004-.242-.355-1.029-.084-1.359.032.052-.243.393-.427.616-.525.39-.174.786-.381 1.211-.435z")
            ]), M)
        ]))
    ]), Rn = l([
        A2(On, l([
            Fa("g1131")
        ]), l([
            A2(On, l([
                Fa("g1133")
            ]), l([
                A2(Da, l([
                    Fa("path1135"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M191.041 143.352c-.746.027-1.481.363-2.245.393-.799.03-1.48.011-2.274-.181-.542-.129-.705-.062-1.203-.374-.433-.271-.787-.704-1.167-1.022-1.098-.921-1.18-2.606-1.016-3.952.226-1.847 1.71-2.027 2.694-3.177.747-.872.3-1.811 1.549-2.365 1.117-.494 2.316-.284 3.483-.169 1.121.11 2.275-.092 3.382.075 2.871.434.474 2.786-.201 4.271-.48 1.059-1.26 2.071-2.436 2.307-.486.099-1.042-.105-1.51.07-.11.041-1.084.613-.617.861.989.52 2.589-.714 3.394-1.299 1.071-.777 1.575-2.061 1.906-3.293.775-2.888 5.127-2.635 7.501-3.008 1.819-.285 3.673-.521 5.52-.437.802.037 2.171-.094 2.85.405.222.164.232.521.406.676.33.295.849.311 1.194.652-.738-.401-.181 1.18-.087 1.492.267.876.548 1.652 1.279 2.256.527.434 3.762 2.78 4.052 1.172.084-.458-1.676-.528-1.915-.526-.751.006-1.06.153-1.617-.474-.412-.463-.874-.897-1.251-1.395-.567-.74-1.457-2.49-.698-3.378.612-.716 2.468-.627 3.31-.668.576-.026 1.103.066 1.664.134.569.071.932.03 1.535.089.581.058.681.123 1.169.424.473.292.689.28 1.065.403 1.737.565 2.921 3.279 2.591 5.076-.2 1.082-1.089 2.423-1.774 3.221-.723.84-1.633.746-2.607.989-1.072.268-1.773.614-2.914.409-1.489-.266-3.643-.84-4.52.961-.563 1.157.175 2.12-1.088 3.035-1.075.778-2.459.8-3.764.725-1.039-.061-1.967-.655-3.025-.649-1.152.005-2.127.68-3.248.837-1.007.142-1.887-.282-2.815-.623-.561-.207-1.943-.429-2.324-.931-.672-.886.337-2.41-.71-3.195-.739-.554-1.663.441-2.49.455-.379.006-.608-.272-.939-.272a1.32 1.32 0 0 0-.089 0z")
                ]), M),
                A2(Da, l([
                    Fa("path1137"),
                    Ha("#dcc06d"),
                    qa("M189.456 133.722c-.502-.143-1.172-.717-1.704-.419-.418.237-.658 1.193-.474 1.627.09.218 1.13 1.003 1.239.598-.201.753-1.104.041-1.228.959.484.085.944-.238 1.321-.527.043.339.155.37.338.623.159-.313.123-.702.005-1.055 1.226-.588 1.263 1.217 1.264 2.059.048-.337.13-.71.397-.958.668.512 1.937 1.23 1.471 2.293.071.092.208.208.298.268.938-.597 2.044-2.058 1.984-3.317a.807.807 0 0 1-.712.728c-.615-.611-.592-1.624.086-2.168.06.373.271.713.63.812.116-.211.155-.559.081-.833-.705-.012-1.368-.279-2.057-.435-1.007-.228-1.926.032-2.939-.255z")
                ]), M),
                A2(Da, l([
                    Fa("path1139"),
                    Ha("#dcc06d"),
                    qa("M212.61 133.392c-.586.443-.862.468-.858 1.223.005.608.422 1.507.728 2.008.322.53.921 1.208 1.378 1.576.755.609.8-.005 1.653.178a.994.994 0 0 0 .109-.406c-.401-.023-.61-.5-.403-.813.085.128.058.166.122.336.009-.004.265-.087.271-.086.025.374.124.804.471.691.209-.067-.032-.523.066-.595.226-.167.22-.141.529-.217.636-.158 2.035.232 2.48.744.02-.113.109-.235.121-.372.309.222.68.184 1.038.051.008-.062.017-.122.027-.182.275-.017.416-.022.598.179l-.188.049c.521.373 1.429 1.073.833 1.761 1.072-.049.375 1-.41.901.144.804-.662 1.335-1.354 1.19a1.727 1.727 0 0 0-.14-.861c-.144.114-.466.121-.589.196a4.823 4.823 0 0 0-.655-1.396c.644.916-.139 1.695-.902 1.995-.738.29-1.438.097-2.204-.092.557.502 1.434.732 2.165.749-.102.183-.115.537-.177.745.81.133 1.387-.602 2.032-.837-.074.146-.1.36-.166.504 1.412-.105 3.078-1.426 3.566-2.877.42-1.249.556-3.659-.932-3.972.913-.937-2.338-2.849-3.052-3.036-1.265-.33-2.165.875-3.426 1.084-1.092.18-2.196-.266-3.252.139")
                ]), M),
                A2(Da, l([
                    Fa("path1141"),
                    Ha("#dcc06d"),
                    qa("M184.879 139.287c-.203.361-.333.707-.237 1.073.059-.149.284-.33.361-.474.719.703.655-.414.84-.81.248.114.54.23.792.313-.085-.35-.515-.995-.172-1.303.304-.273.957.169 1.113.299-.046-.437.309-.807-.093-1.198-.477.292-1.205.559-1.643.904-.431.339-.61.87-.962 1.307")
                ]), M),
                A2(Da, l([
                    Fa("path1143"),
                    Ha("#dcc06d"),
                    qa("M187.584 143.85c-.082.004-1.421-.187-1.318-.338.808-1.182 2.042-.098 3.096-.551.325-.14 1.111-.757.238-.779.475-.13.749-.686 1.079-1.081-.188.315-.216.699-.156 1.061.392.056.754-.125 1.095-.33-.239.387-.539.716-.761 1.109.535-.037.956.15 1.414-.078-.548.804-2.13.753-2.987.875-.578.084-1.108.081-1.7.112z")
                ]), M),
                A2(Da, l([
                    Fa("path1145"),
                    Ha("#dcc06d"),
                    qa("M194.887 137.173c-.041 1.322-1.255 2.444-2.262 3.009.721.015 1.207-.629 1.827-.881.013.065.023.13.035.195.071-.055.289-.158.378-.197.134.607-.359.769-.776.995.516 0 1.044-.033 1.324-.522.033.118.079.168.125.278.22-.14.472-.119.695-.189-.126.177-.208.468-.381.641.127-.109.441-.211.582-.315.011.536.4.475.724.225.125.9-.244 1.781-.277 2.66.696-.453.878-2.242.906-3.097-.652-.293-1.369-.634-1.678-1.354-.281-.654-.336-1.523-.516-2.19-.121.359-.067.78-.102 1.177-.219-.233-.371-.669-.397-.654")
                ]), M),
                A2(Da, l([
                    Fa("path1147"),
                    Ha("#dcc06d"),
                    qa("M199.364 141.931c.151-.47-.007-1.01.236-1.403.498.364.938-.146 1.359.067.504.255.356.698.493 1.217.041-.152.162-.271.208-.403 1.07.549 1.147 3.191 1.041 4.297.605-1.176-.507-2.869.446-4.074.283.319.691.429.938.002.913.522.522 2.471 1.337 2.983.31-.649-.125-4.914 1.225-3.673.218-.774 1.22-.715 1.586-.249.354.45.341 2.196.516 2.614.143-.626-.302-2.01.216-2.314.331.674 1.147 1.293 1.851 1.282.032-.248.184-.49.147-.76.3.217.656.309 1.006.196-.058-.308-.183-.641-.179-.967.147.062.455.023.598.08-.087-.181-.156-.586-.291-.772.31-.117.254-.261.393-.417-.365-.002-.499-.281-.491-.662.229-.25.508-.338.804-.258-.025-.43-.87-1.387-1.13-1.782-.655.546-.725 1.418-1.563 1.879-.661.364-1.322.205-1.949.471.668.125.521.738-.034.869-.315.075-.365-.309-.591-.343-.333-.052-.806.021-1.188.029-1.235.027-2.382-.119-3.522.021.115.486-.008.909-.516 1.087-.448-1.279-2.391-1.139-3.373-.852.022.561.618 1.242.427 1.835z")
                ]), M),
                A2(Da, l([
                    Fa("path1149"),
                    Ha("#dcc06d"),
                    qa("M201.873 147.406c.554-.144.906-.773.239-1.006.615-.017 1.206-.129 1.83-.089.051.189.051.556-.002.745-.751-.004-1.7-.213-2.277.461")
                ]), M),
                A2(Da, l([
                    Fa("path1151"),
                    Ha("#dcc06d"),
                    qa("M209.065 147.406c.992-.272 1.118-1.864.825-2.742.501.625.743-.143.629-.681.642 2.525-.23 4-2.683 3.42.843.091 1.09-.284 1.646-.776")
                ]), M),
                A2(Da, l([
                    Fa("path1153"),
                    Ha("#e1e2e3"),
                    Ua("#967348"),
                    Ba(".236"),
                    qa("M206.149 131.077c-2.829-.325-6.239-.026-8.919 1.031-1.842.729-1.733 1.675-1.199 3.513.5 1.724.13 3.44 2.295 3.666 2.059.213 4.165-.225 6.257-.222 1.624.001 3.699.179 5.175-.755 1.633-1.035 1.725-4.674.452-6.039-.94-1.008-2.856-1.055-4.061-1.194z")
                ]), M),
                A2(Da, l([
                    Fa("path1155"),
                    Ha("#ccb25c"),
                    qa("M190.42 133.616c-.651-.202-1.515-.975-2.195-.609-.603.323-.383 1.072-.723 1.573.073-.107.211-.195.301-.289.482.628 2.705.482 3.539.799-.058.031-.183.145-.271.192.173.229.189.355.284.536 1.842-.223 1.645 2.507 1.018 3.541 1.001-.628 1.064-1.952 1.769-2.811-.181.295-.268.165-.488.271-.3-.532-.796-1.319-.353-1.863-.014.161.038.372.044.536.088-.13.313-.254.417-.417.086.032.179.058.271.079.367-.718.218-.999-.577-1.103-1.042-.133-2.017-.116-3.036-.435z")
                ]), M),
                A2(Da, l([
                    Fa("path1157"),
                    Ha("#ccb25c"),
                    qa("M216.468 131.857c-1.391.124-4.123.284-4.566 2.037-.354 1.389.746 3.458 2.126 3.624a1.507 1.507 0 0 1-.256-.886c.106.047.386.033.493.083a5.877 5.877 0 0 1-.054-.304c.211-.012.41.012.582-.129.037-.032.615-.568.542-.53 1.167-.575 2.553.016 3.737.013a.837.837 0 0 1-.508-.684c1.321-.199 2.937.98 3.595 2.084-.633-1.403-2.613-2.102-3.076-3.525.25-.047.348-.263.523-.358-1.08-1.335-1.541-1.568-3.138-1.425z")
                ]), M)
            ])),
            A2(On, l([
                Fa("g1159")
            ]), l([
                A2(Da, l([
                    Fa("path1161"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M217.197 130.166c-.25-1.166-2.44-2.156-3.212-1.084-.516-.155-1.218-.142-1.691-.386-.755-.388-1.208-2.074-1.331-2.87-.222-1.431 1.493-1.622 2.493-1.633 1.836-.024 3.508 1.339 5.071 2.194 1.061.579 1.061.603.414 1.666-.704 1.16.182 1.425.966 2.002 2.25 1.657-1.367 2.314-2.323 3.081-.902.723-1.056 1.092-2.372 1.01-.97-.061-1.862-.283-2.813-.396-.571-.068-1.264-.452-1.75.09-.519.576.06 1.221-.124 1.89-.61 2.252-3.018 2.062-4.775 2.06-1.011-.001-2.003.125-3.008.091a6.181 6.181 0 0 0-.578.01c-1.155.067-2.299.396-3.451.312-1.181-.088-1.748-1.304-2.222-2.291-.745-1.551-1.848-1.764-3.377-1.63-1.052.092-2.273.707-3.206-.029-1.03-.812-.894-1.941-.748-3.166-.593 1.023-.043 1.824.294 2.735-.876-.258-4.603-.225-3.768-2.124.346-.79 1.309-.853 1.669-1.755.217-.543.23-.753.542-1.221.496-.742 1.217-1.356 1.89-1.901 1.217-.985 2.084-1.293 3.523-1.752.47-.15.967-.322 1.473-.242.478.079 1.054.253 1.365.671-1.215.873-.734 3.118-2.311 3.785-1.325.56-3.722-1.159-4.361.733.364-.229.633-.618 1.027-.742.398-.125.942.044 1.356.003.777-.08 1.843-.122 2.477-.693.657-.592.84-1.48 1.249-2.198.533-.936 1.687-1.191 2.638-1.312 1.225-.155 2.41.064 3.634-.241 2.182-.546 4.787-.74 6.994-.207 1.741.421 1.867 1.012 2.527 2.629.365.89 1.049 1.32 1.772 1.75 1.114.663 2.447-.973 3.521.272")
                ]), M),
                A2(Da, l([
                    Fa("path1163"),
                    Ha("#e1e2e3"),
                    Ua("#967348"),
                    Ba(".236"),
                    qa("M200.725 122.824c-2.263.363-4.65 1.277-4.297 4.228.106.888.063 2.057.359 2.891.457 1.291 3.223 1.917 4.436 2.139 1.034.188 2.079-.027 3.16-.025 1.171.002 2.477.161 3.541-.334.508-.237 1.707-.832 1.977-1.332.356-.656.363-2.291.497-3.092.117-.707.435-1.837.207-2.559-.448-1.423-2.918-1.567-4.125-1.777-2.04-.351-3.731-.463-5.755-.139z")
                ]), M),
                A2(Da, l([
                    Fa("path1165"),
                    Ha("#ccb25c"),
                    qa("M188.466 128.421c-.199.144-.638.485-.773.688-.061.09-.268.828-.233.807.26-.159 1.029-.513 1.169.003.098.367-.719.908-.957 1.055.353-.199 1.129-.713 1.419-.249.17-.725 1.139-1.181 1.72-1.392.99-.361 2.117-.008 3.128-.262.705-.177 1.238-.671 1.408-1.399.179-.769.096-1.548.925-1.934.056-.137.09-.414.08-.557-.338-.013-.644.398-.987.506-.339.106-.736.039-1.111.064-.899.062-1.5.474-2.268 1.004-.702.483-1.501.885-2.346 1-.633.086-1.606.33-1.563 1.083")
                ]), M),
                A2(Da, l([
                    Fa("path1167"),
                    Ha("#ccb25c"),
                    qa("M214.581 128.918c1.642-.228 3.026 1.018 3.061 2.731.071-.068.162-.098.228-.153.331.547.67.785 1.246.659.571-.124 1.344-.739 1.399-1.385-.5.078-.939.9-1.474.414-.041.114-.145.16-.173.313-.942.051-1.437-2.028-1.165-2.709.209.071.365.262.441.463-.056-.124-.06-.272-.094-.402.083.041.205.037.271.064-.017-.529.476-1.083.708-1.489-.533-.559-1.229-.636-1.948-.67-1-.046-1.264-.437-2.03-.976-.814-.575-1.794-.85-2.747-1.019-2.611-.459-.809 3.75.634 4.316.561.22 1.088-.079 1.643-.157z")
                ]), M),
                A2(Da, l([
                    Fa("path1169"),
                    Ha("#dcc06d"),
                    qa("M196.05 126.92c.069.454-.031.918-.54.854.152.058.254.243.372.377-.041.045-.091.08-.133.125.292.25.523.898.013 1.041a.554.554 0 0 1 .123.058c-.195.666-1.076.927-1.65 1.071-.482.119-1.463-.124-1.702.321-.177-.136-.243-.109-.443-.182.146.141.179.344.277.494-.091-.001-.207.036-.296.03.04.04.101.169.14.214a7.03 7.03 0 0 1-.828.357c.546-.026.398.18.616.564.279.022.542-.104.74-.319-.493-.354.194-.672.487-.851-.038-.062-.072-.167-.122-.239.536-.241 1.31-.176 1.905-.319-.248.34-.66.431-1.005.624a.724.724 0 0 1 .607.12c-.498.514-1.245.619-1.748 1.113-.22.216-.276.543-.471.74-.244.247-.636.308-.93.465.568.114 1.328-.165 1.839-.386.006.035-.005.06-.034.076.06-.031.19-.073.257-.083-.129.18-.122.371-.202.565.755.236 1.593-.255 2.079-.896-.326.123-.711.084-1.058.062-.067-.493.495-.641.788-.901.393-.35.58-.782.845-1.228.019.034.074.166.091.21.06-.063.213-.117.294-.204.145.214.306.38.544.458-.404-.82-.699-1.073-.698-2.083.001-.403.068-1.74-.156-1.746")
                ]), M),
                A2(Da, l([
                    Fa("path1171"),
                    Ha("#dcc06d"),
                    qa("M198.552 132.343c.841.158 1.593.128 2.421.184-.295.188-1.077.228-1.328.561-.267.354-.014.713-.09 1.148-.168-.273-.401-.345-.632-.527-.018-.001-.095.115-.12.128-.009-.05-.02-.098-.031-.147-.793.112-.238 1.86-.628 2.312-.512.01-.404-.51-.745-.811.034-.114.163-.361.229-.506.436.238.873-.498.926-.925.059-.468-.242-.938-.387-1.34.142-.084.363-.17.539-.161")
                ]), M),
                A2(Da, l([
                    Fa("path1173"),
                    Ha("#dcc06d"),
                    qa("M202.148 132.676c-.137-.045-.25-.018-.337.079a.517.517 0 0 0 .036.16c.655.109.975.242.943 1.098.299-.368.237-.755.608-1.005.151-.101.817-.274 1.007-.236-.056.466.262.327.48.488.408.299.506.258.608.93.089.595.499 2.678-.211 2.842.286.329.857.073 1.109-.236.038.022.098.106.122.128 0-1.311-.928-2.256-.124-3.487.07-.009.102.041.139.043.7-1.448.904 2.151.923 2.173.344-.923-.079-2.063.265-2.966.497.022.917.369.764.822.286.353-.011 1.828 0 2.467.369-.667.177-1.646.617-2.29.224-.328.518-.312.635-.839.136.095.354.096.497.216.026-.174.002-.573.109-.725.207-.3.567-.003.642-.387.279.269 1.728.03 1.796-.429-.363.023-.635-.309-.333-.605-.058-.01-.093.02-.13.059-.162-.403-.444-.413-.544-.883-.124-.592.207-.657.077-1.089-.13-.429-.838-1.516-1.114-1.878-.364 1.087.322 2.605-.271 3.551-.542.866-2.043 1.083-2.914 1.264-1.165.241-2.265.343-3.443.419-.501.032-2.133-.107-2.333.34.013.119.075.01.143.059")
                ]), M),
                A2(Da, l([
                    Fa("path1175"),
                    Ha("#dcc06d"),
                    qa("M214.267 131.425c.343.019.685.018 1.009-.098-.047-.068-.056-.218-.147-.302.146-.041.32-.032.463-.004-.427.475.237.817.565.905-.199.193-.785.242-1.034.088-.318-.193-.305-.738-.777-.673")
                ]), M),
                A2(Da, l([
                    Fa("path1177"),
                    Ha("#dcc06d"),
                    qa("M188.154 130.674c-.624.298-1.54.468-1.871 1.152.227-.015.451-.082.689-.051-.304.6 1.033.768 1.405.808-.03-.87.617-1.453.681-2.245-.394-.285-1.585.688-1.92.919")
                ]), M)
            ])),
            A2(On, l([
                Fa("g1179")
            ]), l([
                A2(On, l([
                    Fa("g1181")
                ]), l([
                    A2(Da, l([
                        Fa("path1183"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M197.214 127.794c.196.842.448 1.661 1.189 2.108.369.223.83.462 1.251.56.493.114.622-.082 1.04-.089.949-.015 1.662.66 2.528.583.35-.031.661-.222 1.013-.243.412-.025.819.177 1.28.107.458-.069.696-.302 1.12-.476.478-.195 1.062-.027 1.521-.217 1.879-.78.617-3.156 1.807-4.34.764-.758 2.085-.019 2.929.032.554.034 1.085-.024 1.567.242.437.24.474.562.81.865.574.517 1.38.085 2.188.361.813.278 2.184 1.695 2.975.702.487-.609.246-2.116-.162-2.705-.376-.542-.774-.835-1.231-1.133-.401-.262-.964-.454-1.132-.975.171.241.418.29.595.397.141-.351.271-.7.213-1.079-.637-.318-.655-1.706-.608-2.354.047-.647.254-.945-.129-1.419-.237-.292-.879-.593-1.212-.802-1.182-.745-2.817-2.543-4.185-2.205-.486.121-.887.5-1.354.674-.448.165-.917.129-1.346.327l.181.225c-.115.124-.173.386-.286.506 2.126-.003 1.531 4.076 3.639 4.36 1.165.158 1.97-.578 2.736.665.637 1.035.753 2.349.597 3.529.708-1.539-.254-3.861-1.852-4.107-1.687-.259-2.817-.436-3.463-2.309-.363-1.055-.301-1.618-1.359-1.888-.953-.242-1.403.114-2.18.768-1.849 1.556-4.253 1.452-6.533.979-1.658-.345-2.891-1.707-4.602-2.089.054-.03.142-.058.175-.081a2.507 2.507 0 0 1-.892-.375c.171.636.085 1.459-.056 2.086-.983.281-1.014 1.755-1.86 2.267-.911.549-1.651.885-2.421 1.64-.745.73-1.881 1.004-1.955 2.03-.071.974.513 2.067-.274 2.88.375-.639.229-.859.262-1.546.015-.281-.073-1.38-.002-1.562.188-.481 1.141-1.074 1.473-1.448.843-.951 2.115-2.205 3.422-2.124.059-1.439 2.065-2.468 1.56-3.877-.881-2.449-4.344-1.571-5.2.407.119-.038.054.004.208.018-.863.235-3.365-.001-3.45 1.314-.853.201-.242.962-.183 1.487.061.532-.261 1.052-.022 1.53-.72.693-.073 1.404-.288 2.147-.09.31-.621.54-.717.91-.112.445.178.523.142.835-.074.625-.808 1.369-.584 2.033.198.581 1.023.921 1.566.999.667.095 1.806.14 2.398-.084.819-.31 1.349-1.428 2.212-1.895.803-.433 1.552-.25 2.377-.467 1.124-.294 1.619-1.795 2.221-.04.146.426.235.894.343 1.356z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1185"),
                        Ha("#ccb25c"),
                        qa("M191.106 118.029c1.515-1.068 2.862.738 3.945 1.654a3 3 0 0 0 .948-.935c.057.836-.214 1.607-.433 2.394-.104.368-.298.243-.266.659.029.368.397.924.471 1.31.073-.42.319-.526.638-.306-.196-.55-.439-1.247-.408-1.863.023-.476.304-.895.32-1.357.05-1.524-.212-2.689-1.67-2.997-.563-.118-3.491-.194-2.814 1.218")
                    ]), M),
                    A2(Da, l([
                        Fa("path1187"),
                        Ha("#dcc06d"),
                        qa("M189.792 123.192c.075-.023.183-.065.253-.086-.056 1.198-1.208 2.225-1.848 3.094.619.51-.517 1.178-.81 1.659.135.015.27.107.373.125-.12.132-.232.436-.369.569.485-.046.882-.382 1.302-.588-.344-.797.585-1.337.829-2.003.308-.845.229-1.241.852-1.98 1.058-1.253 2.441-2.932 4.155-2.797.237-.641.618-1.337.005-1.894.007.089.048.16.119.21.058-.238-.707-.951-1.144-1.219-.53-.325-1.18-.409-1.767-.396.438.753-.549.918-1.053.981-.767.097-1.404-.116-1.577.887-.031.183 1.11.793 1.216 1.097.204.584-.266 1.808-.536 2.341z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1189"),
                        Ha("#ccb25c"),
                        qa("M192.239 118.983c.364-.298-1.113-.355-1.166-.347-.375.064-1.674.193-1.784.703-.127.593.783.501 1.054.749.38.349.507 1.192.444 1.693.392-.811.759-2.226 1.452-2.798z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1191"),
                        Ha("#dcc06d"),
                        qa("M191.48 124.041c-.141.384-.163.775.12 1.071-.362-.378 2.046-2.691 2.571-2.628.773.089 1.147 1.345 2.065 1.576-.505.295-1.1.464-1.571.846.437-.139.919-.391 1.406-.295-.009.106-.028.118-.008.207-.346.285-.843.388-1.202.614.601-.066 1.516-.529 1.987-.068.014.012.188.89.23 1.005.134.362.278.686.446 1.02-.14-.411-.493-2.833.466-2.226-.003.004.136-.202.121-.193.576.282 1.297.647 1.946.64.014.104.02.203.029.306.835-.484.569.907.797 1.347.092-.373.096-1.406.352-1.646.36-.34 1.89-.324 2.394-.427-.253.514.115.681.51.445.422.51.921.11 1.156.963.292 1.049-.472 2.528-.01 3.58.22-.576.138-1.528.441-2.122.181-.355.441-.293.522-.722.761.314.699-1.212.832-1.706.047.229.173.463.207.711.073-.314.234-.553.48-.62.083.351.085.881.217 1.186.26.604.928.651.512 1.459-.153.016-.282.112-.418.128.296-.019.254.106.422.187-.247.388-.516.769-.885 1.039 1.873-.745.857-2.519 1.835-3.906.94-1.334 4.681-.757 5.715-.123-1.196-.214-2.31-.884-3.508-1.115-.004-.104 0-.195.002-.299.58-.12 1.056.232 1.621.213-.657-.312-1.331-.563-1.828-1.09.501-.517 1.025.362 1.565-.029-.198-.079-.617-.229-.809-.448-.204-.236-.124-.615-.251-.778-.239-.306-.896-.483-.433-.969-.597-.745-1.312-1.955-1.42-2.888-.113.563.104 1.129.263 1.667.051.175.565 1.171.561 1.194-.047.271-.612.63-.753.862-.263.431-.427.887-.697 1.307-.107.163-1.11 1.009-1.054.838.087-.263.246-.516.395-.737-.64.123-1.31.646-1.841 1.046.434.014 1.432-.089 1.188.666-1.453.457-3.513.049-5.036.045-1.599-.005-3.234-.143-4.74-.755.142.035.27.03.417.042-.349-.032-1.11-1.074-1.083-1.484-.923.393-1.556.736-2.643.361-.038-.043-.035-.046.011-.005.054.022.077.063.072.119-.872.554-1.386-.202-2.058.777-.484.703-.761 1.677-1.268 2.323-.066-.077-.132-.119-.192-.172-.032.491-.513 1.133-.66 1.231.517-.471 1.248-1.126 1.967-1.132-.814.334-1.479.947-2.226 1.41-.622.387-1.247.405-1.854.708a1.826 1.826 0 0 0 1.048-.342c-.287.084-.588.197-.875.218.419-.03 1.595-1.638 1.761-2.105.336-.956-.036-1.499.673-2.327z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1193"),
                        Ha("#dcc06d"),
                        qa("M198.301 128.93c.097.804.995 1.154 1.658 1.087-.254-.286-.755-.613-.934-1.055.045.131.048.267.098.393-.365-.084-1.168-.253-1.136-.536")
                    ]), M),
                    A2(Da, l([
                        Fa("path1195"),
                        Ha("#dcc06d"),
                        qa("M212.271 121.26c.644.438 1.706.32 2.476.439.691.107 1.299.543 1.689 1.196.19.317.169.673.339 1.004.262.506.48.411.987.722-.644.28-.908.854-.771 1.532.089.468-.151.256.326.631.436.34 1.22.64 1.725.951.358.22.772.518 1.143.305.209-.119.558-.822.436-1.113-.175-.416-.546-.297-.952-.555-.272-.174-.669-.718-.795-1.036.409-.16.864.528 1.305.69.079-1.193-1.64-1.374-1.953-2.327.313-.29.488-.746.386-1.204-.954-.387-.821-1.72-.715-2.577.186-1.528-.644-1.85-1.881-2.42-.923-.428-1.945-.996-2.913-1.118-2.649-.33-2.438 3.791-.832 4.88z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1197"),
                        Ha("#ccb25c"),
                        qa("M214.023 121.463c.103-.649.997-.542 1.382-.246-.194-1.167-1.938-2.525-3.024-2.538.267-.737.802-.425 1.312-.334-.083-.118-.106-.296-.167-.412.373-.076.78-.003 1.126.166.025-1.094-1.179-1.484-2-1.573-.522-.058-1.085-.023-1.587.146-.115.038-1.36.793-1.075.891 1.32.452 1.224 1.332 1.826 2.469.128.241 2.118 1.989 2.207 1.431z")
                    ]), M)
                ])),
                A2(Da, l([
                    Fa("path1199"),
                    Ha("#ccb25c"),
                    qa("M216.314 120.518c.51.107 1.047-.164 1.337-.542-.204-.171.231.301.188.228-.569 1.274.598 2.489.672 3.721-.296.091-.25-.002-.503.255-.164-.492-.64-1.076-1.141-1.222.772.061.164-.57.147-.884-.028-.477.158-.993-.205-1.435-.154.011-.116.13-.08.101")
                ]), M),
                A2(Da, l([
                    Fa("path1201"),
                    Ha("#ccb25c"),
                    qa("M216.834 124.188c.301 1.051 0 2.03-.407 2.98 1.032.047 2.187.12 2.896 1.047-.073-.475-.265-.915-.491-1.33.096-.042.175-.116.284-.159a4.955 4.955 0 0 0-1.021-1.185c.3.049.62.164.891.328-.739-.497-1.573-.917-2.235-1.451-.055.25.071.345.188.547")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1203"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M197.845 123.128a3.06 3.06 0 0 0 1.015.922c1.102.591 2.452.813 3.676.811 1.866-.002 4.138.163 5.709-1.026 1.436-1.083 1.482-1.979 1.587-3.757.027-.462.204-.96.104-1.446-.344-1.68-2.282-1.093-3.378-1.095-1.867-.002-3.727-.355-5.594-.128-1.107.135-2.204.121-3.267.525-1.07.407-.789.958-.793 2.144-.001 1.008.321 2.19.941 3.05z")
            ]), M),
            A2(On, l([
                Fa("g1205")
            ]), l([
                A2(Da, l([
                    Fa("path1207"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M197.636 120.521c-.133-.495-.2-1.307-.441-1.752-.711-1.311-2.445-1.233-3.628-.913-.579.158-1.157.352-1.562.882-.477.627-.278 1.547-1.274 1.539-.712-.006-.705-.548-1.121-1.084-.223-.288-.499-.562-.598-.929-.206-.759.24-.74.461-1.221.565-1.224.327-2.274-.335-3.307-.697-1.089-1.194-2.229-.055-3.224 1.239-1.079 2.874-2.459 4.484-2.78.89-.177 1.74.047 2.37.803.478.575.504 1.32.994 1.839.974 1.035 3.248.611 4.431.336 2.866-.668 5.782-1.556 8.745-1.416-.815-.522.467-1.646.947-1.892.907-.466 1.169-.025 1.8.639.493.516.951.676 1.485.998.452.275.84.905 1.309 1.118.666.299.328.099.966-.178.772-.337 1.013-.227 1.058.843.033.743-.587 1.226-.728 2.025-.153.868.258 1.481.522 2.196.277.745.25 1.309.305 2.125 1.309.568 1.051 2.536-.328 2.829-.898.188-1.803-1.564-2.504-2.169-1.092-.941-1.909-1.393-3.336-1.083-.776.168-1.93 1.042-2.114 1.877-.286 1.295.256 2.488-.825 3.599-.796.817-2.378 1.159-3.423 1.311-1.189.172-2.328.449-3.545.109-1.9-.534-3.446-.823-4.06-3.12z")
                ]), M),
                A2(Da, l([
                    Fa("path1209"),
                    Ha("#dcc06d"),
                    qa("M190.651 117.297c.027-.734.071-1.365.185-2.027.101-.582.144-1.392.572-1.835.413-.428 1.3-.503 1.136.398.526-.069.742.041 1.258-.314.489-.338.725-1.012 1.42-.91.042-.872 1.038-1.487 1.667-.995-.119-.43-.454-.812-.606-1.21-.181-.473-.125-.955-.392-1.362-.6-.923-1.5-1.009-2.426-.89-.817.104-1.738.382-2.314 1.131-.42.548-.432.729-.92 1.121-.279.225-.592.268-.817.64.603.253-.176.787-.141 1.334.032.486.659.993.882 1.583.191.499.384 1.47.288 2.003-.13.71-.792 1.011-1.136 1.646.389-.053.597.255.55.647.572.034.586.771.772 1.258.07-.74-.004-1.48.022-2.218z")
                ]), M),
                A2(Da, l([
                    Fa("path1211"),
                    Ha("#dcc06d"),
                    qa("M214.111 109.205c-.47-.364-.953-.697-1.547-.864-1.512-.429-2.288.56-2.796 2.012.587.233.736 2.169 1.246 2.9 1.05 1.5 1.93.521 3.397.733-.333-.047-.96.222-1.234.399 1.006.476 1.855.142 2.517 1.384.298.558.567 1.162.738 1.779.058.206.106 1.583.156 1.629-.968-.915-1.111-4.395-3.208-3.453.143-.046.422-.307.586-.404-.605-.734-1.815-.333-2.546-.679-.201.338-.145.717.143.99-.167.083-.286.296-.471.36.179.214.486.313.795.417-1.715.631-2.459.851-2.784 2.892-.243 1.521-.507 2.993-2.075 3.434.162-.562.265-1.165.407-1.734.791 2.327 1.442-.497 1.461-1.586.004-.315.104-.862-.098-1.101.072.085-.877-.123-.842-.131-1.026.253-.109.96-.706 1.445-.128-.741-.467-1.058-1.146-1.095-.493.641-.103 1.724-.712 2.19-.077-.46-.181-2.481-.536-2.676-.774-.426-.952 1.658-1.363 1.998-.18-.433-.339-.922-.354-1.403-.051.064-.218.153-.271.206-.308-1.43-1.163.956-1.278 1-.322-.493-.109-1.358-.435-1.754-.292-.356-.665-.334-.724.194-.66-.557-1.697-.291-1.672.779-.125-.106-.347-.105-.478-.195-.305.409-.18 1.034-.312 1.424a10.5 10.5 0 0 0-.41-2.218c-.124-.393-.252-.585-.343-1.001-.069-.316-.019-.69-.086-.99.385.304.948.723 1.146 1.192.744.035 2.132.355 2.696.757.041-.106.174-.235.203-.306 1.116.791 2.816.186 4.064.12.838-.045 1.625.111 2.476-.242 1.399-.58.244-.543-.569-.752.734-.367 1.606-.377 2.237-.967.875-.814.619-2.299 1.463-3.135.943-.933 1.423.424 2.425.655.683.156 1.427-.576 2.063-.202.621.368.804 1.787.913 2.432.104.631.162 1.308.431 1.891.22.476 1.049.882 1.167 1.201-.142-.385-.05-.557.309-.441-.516-1.357-.693-2.751-1.233-4.106-.336-.85-.274-1.01.13-1.749.331-.603.576-1.213.267-1.902-.623-.111-.975.115-1.54-.155-.62-.298-1.133-.754-1.667-1.172z")
                ]), M),
                A2(Da, l([
                    Fa("path1213"),
                    Ha("#dcc06d"),
                    qa("M192.111 114.739c-.951.77-.017 1.198-.069 1.922-.004.058-.402.488-.457.635-.11.302-.121.753-.024 1.059.319-.548.542-1.227 1.264-1.073-.093-1.083.594-1.683 1.123-2.53-.855.7-1.968 1.487-2.15-.123")
                ]), M),
                A2(Da, l([
                    Fa("path1215"),
                    Ha("#ccb25c"),
                    qa("M195.54 112.381c-.857.039-1.396.9-2.176 1.003-.622.083-.754-.447-1.255-.548-.26-.051-.759.392-.915.557.03-.822-.396-1.012-1.045-.898-.469-1.148-.16-1.527 1.018-1.757.465-.092 1.123-.265 1.574-.002.444.256.558.885 1.027 1.102-.526-1.351-1.229-1.045-2.386-1.214-1.249-.182-.386-1.087.336-1.638.793-.606 1.874-.926 2.794-.479.485.237 1.87 1.445 1.395 2.003.232.289.478.546.755.787-.527-.056-1.503.403-1.122 1.084z")
                ]), M),
                A2(Da, l([
                    Fa("path1217"),
                    Ha("#ccb25c"),
                    qa("M195.341 114.071c.301.187.692.267 1.029.323-.094-.313-.072-.583.124-.841.017.609.183 1.211.373 1.755a1.191 1.191 0 0 0-.761-.03c.149-.143.167-.377.268-.517-.289-.226-.708-.27-.999-.348.081-.102.113-.242.175-.342")
                ]), M),
                A2(Da, l([
                    Fa("path1219"),
                    Ha("#ccb25c"),
                    qa("M209.312 116.296c-.283.173-.623.239-.902.335.292.042.377.142.685.017-.073.068-.194.237-.294.319-.005.453.166 1.078.222 1.635.39-1.151.569-1.749 1.717-2.196-.181.054-.405-.027-.583-.015-.104-.515.273-.874.205-1.396-.424.582-.718 1.18-1.362 1.524")
                ]), M),
                A2(Da, l([
                    Fa("path1221"),
                    Ha("#ccb25c"),
                    qa("M215.254 110.401c.471.449 1.111.593 1.553 1.084.098-.182.222-.523.284-.731-.505-.33-.68.235-1.103.211-1.017-.059-1.322-1.001-1.862-1.665-.552-.678-1.448-1.071-2.335-1.034-.913.038-2.341 1.48-1.776 2.5.271.49.849.769 1.087 1.287.788-.195 1.067.769 1.647 1.049.832.401 1.772-.407 2.57-.065 0 .046-.042.182-.049.234 1.19.328 1.054 3.136 1.662 4.217-.049-.434-.213-.857-.199-1.289.094.026.177.048.278.085-.379-.864-.804-1.89-.8-2.861.531-.215.156-.992.725-1.354-.501-.931-2.958-1.789-3.86-1.306.056.102.049.2.081.292-.55-.248-.854.523-.629.975-.482-1.104.508-1.962 1.474-1.681.312-.028.697.134 1.032.145-.096-.503-.418-.955-.844-1.316")
                ]), M)
            ]))
        ])),
        A2(On, l([
            Fa("g1223")
        ]), l([
            A2(Da, l([
                Fa("path1225"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M209.502 111.546c-.445-2.048-3.969-1.743-5.542-1.649-1.959.117-4.151-.032-6.012.739-1.898.786-1.07 1.89-.62 3.545.485 1.782.957 2.253 2.668 2.994 1.911.828 4.377.918 6.337.21 1.051-.381 2.03-.937 2.527-2.043.324-.725.749-2.921.674-3.592a1.496 1.496 0 0 0-.032-.204z")
            ]), M),
            A2(Da, l([
                Fa("path1227"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M202.815 116.169c-1.29.203-4.14.014-4.812-1.539-.364-.843-.093-1.764-.539-2.595-.515-.96-1.847-2.794-2.929-3.207-2.07-.791-3.208 1.044-4.894 1.798-1.904.852-3.078-2.492-.767-2.49.11-.596.312-1.168.37-1.802.088-.944-.451-1.339-.471-2.049-.048-1.65 2.712-3.563 3.875-4.296.888-.561 2.383-1.565 3.437-1.677.931-.097 1.367.339 2.23.885.768.485 1.5 1.102 2.452 1.134 1.362.043 3.028-.932 4.244-1.509 2.21-1.047 4.03-1.179 6.246-.176.721.326 1.651.595 2.342 1.047.698.458.964 1.012 1.606 1.584.535.479 1.415.589 1.649 1.381.186.626-.46 1.292-.627 1.961-.422 1.687.416 1.95 1.246 3.082.83 1.132.702 3.739-1.173 3.424-1.843-.311-2.489-2.755-4.727-2.464-4.146.54-1.25 7.233-5.613 7.041.028.131.09.165.126.305-.667.525-1.148.092-1.865.036-.632-.05-.736.02-1.406.126z")
            ]), M),
            A2(Da, l([
                Fa("path1229"),
                Ha("#dcc06d"),
                qa("M195.415 103.6c1.688-.302 1.94-2.841.631-3.699-1.787-1.169-3.031.439-4.408 1.449-1.093.802-2.523 1.108-2.456 2.83.034.86.363 1.609.291 2.534-.081 1.021-.653.917-.931 1.769.096-.034.198-.053.295-.084-.152.283-.958 1.355-.281 1.635.359.149.845-1.336 1.102-1.606.287.384.063 1.01-.175 1.384 1.753-.187.939-3.121 2.786-3.561.047-.226.162-.292.227-.45.137.208.298.461.313.762.432-.93.029-1.29 1.04-1.765.765-.36 1.335-.948 2.087-1.311")
            ]), M),
            A2(Da, l([
                Fa("path1231"),
                Ha("#dcc06d"),
                qa("M200.731 111.197c-.012.358.127.675.396.852.172-.616-.02-1.322.292-1.877a.624.624 0 0 0-.142.173c-.233-.061-.127-.157-.421-.112-.188-.352-.219-.803.058-1.06.058.068.196.269.221.308-.404-.651-1.533-.54-2.123-.862-.587-.323-1.42-1.094-1.645-1.764-.535 1.016-1.498.813-2.456.73a2.24 2.24 0 0 1-.318-.743c.292-.021.555-.093.804-.223-.227.302-.124.32-.061.635 1.386-.286 1.159-1.253 1.24-2.531.094.034.194.056.29.086-.179-.25-.228-.44-.326-.754-.597.268-1.098.55-1.616.996.08.021.178.054.251.074-.475.338-1.136.489-1.536.855-.508.465-.588 1.162-1.124 1.587-.042-.095-.105-.192-.151-.291-.375.36-.793.808-.978 1.344.218-.201.493-.323.761-.336-.1.128-.152.295-.242.419.875-.345 1.992-.849 2.89-.467.188.081.026.34.22.453.238.141.577.154.835.27.655.291 1.17.684 1.535 1.297-.15.001-.278.101-.377.119.603.906.914 1.845 1.406 2.78-.028-.492.292-.812.744-.792-.542-.519-.903-.775-1.144-1.51-.267-.819-.657-1.251-1.343-1.877.276.258.627.414.996.414-.066-.091-.114-.201-.179-.297.537.536 1.751.91 2.483.862-.096.093-.162.231-.25.322 1.463.695-.458 2.213-.221 3.099-.076-.286 1.317-1.384 1.231-2.179z")
            ]), M),
            A2(Da, l([
                Fa("path1233"),
                Ha("#dcc06d"),
                qa("M201.67 109.162c.185.067.514.342.69.438-.062.085-.111.251-.16.334.33.29.642.651.742 1.11.173-.25.175-.633.365-.908.201-.292.51-.295.678-.628.384.124.509-.397.695-.769-.559.018-1.098.286-1.662.313-.448.023-.832-.266-1.246-.002")
            ]), M),
            A2(Da, l([
                Fa("path1235"),
                Ha("#dcc06d"),
                qa("M206.996 108.566c-.864.382-1.714.599-1.858.201.314.864.256 1.706.203 2.61.066-.112.286-.271.373-.405.051.181.051.69.147.836.141.216.446.205.583.465.26.492.333 1.043.102 1.546-.072.018-.091-.073-.164-.087-.021.631-1.724 1.134-2.287 1.118.248.558 1.628.512 2.086.462 2.545-.28 2.031-3.417 2.967-5.151.32-.592.877-1.377 1.465-1.699.352-.192.698-.074 1.043-.213.265-.105.54-.488.828-.624-.329.029-.482-.073-.689-.219 1.563-.837 1.854.87 2.662 1.857-.58-.722-.545-1.846-.605-2.753-1.086-.403-2.159-.508-2.907-1.648a2.038 2.038 0 0 0-.011.281c-.629-.161-1.25-1.067-1.548-1.727-.785 1.388-.026 2.915-1.324 3.975.254-.077.533-.116.785-.216.013.032.092.158.107.175-.156.251-1.064.822-1.958 1.216z")
            ]), M),
            A2(Da, l([
                Fa("path1237"),
                Ha("#dcc06d"),
                qa("M212.512 105.182c.448.214.88.439 1.277.703.199.131.303.365.491.505.149.109.497-.025.661.18.527.66.119 2.387.403 3.242 1.053-.417.578 1.259 1.646.661.697-.391.889-2.267-.079-1.773a2.461 2.461 0 0 0-.111-.118c.028-.104.047-.214.081-.317-.633-.188-1.182.207-1.339-.869.298.018.602.13.898.214-1.395-.538-.508-2.517-.254-3.43.182-.652.182-.995-.256-1.552-.571-.727-1.476-1.688-2.162-2.263-.395-.329-1.096-.726-1.568-.913-.538-.211-1.522-.648-2.083-.642-.768.01-1.418.826-1.591 1.562-.205.868.251 1.605-.083 2.475.406-.063.813-.259 1.186-.029.489.299.543 1.026 1.013 1.354.245.168.544.095.802.225.383.195.673.595 1.068.785z")
            ]), M),
            A2(Da, l([
                Fa("path1239"),
                Ha("#ccb25c"),
                qa("M190.098 103.933c-.001.194.114.449.126.656.346-.163.618.13.685.448.253-1.34.752-.765 1.573-.75-.02.365-.105.745-.383.971-.065-.086.007-.199-.015-.29-.065.126-.138.266-.177.403.134-.149.412-.257.572-.397.01.12.039.277.035.397.305-.246.348-.719.63-1.062.697-.031 1.806-.417 2.455-.959.386-.322 1.539-1.891.271-1.768.377-.576-.219-1.504-.768-1.742-.762-.328-1.563.435-2.086.861-.604.494-1.112 1.064-1.777 1.451-.521.304-1.081.641-1.438 1.431.131-.057.266-.04.387-.078.019.217.003.468-.09.651")
            ]), M),
            A2(Da, l([
                Fa("path1241"),
                Ha("#ccb25c"),
                qa("M214.041 101.73c-.983-.838-1.937-2.213-3.28-2.394-.605-.081-.857.024-1.224.582-.058.091-.506 1.252-.448 1.264a.824.824 0 0 0 .147.02c-.008.067-.023.585.064.599.674.109.924 1.102 1.252 1.679.068-.102.412-.318.478-.428.216 1.203 1.933 1.057 2.342 2.207.085-.045.066-.086.1-.198a.246.246 0 0 1 .168.052c-.032-.707.615-.867 1.135-.629-.145.062-.284.261-.377.314.252.068.45.225.71.269-.179.443.021 1.015.032 1.526.262-.292.614-2.449.608-2.994-.016-1.075-.967-1.238-1.707-1.869z")
            ]), M),
            A2(Da, l([
                Fa("path1243"),
                Ha("#ccb25c"),
                qa("M209.161 106.953c.19-.016-.198.899-.243.961-.203.295-.563.458-.862.609-.557.279-1.512.382-1.785 1.089-.115.304.168.7.087.967.126-.415.352-.75.439-1.184.35.06.371.074.7-.114-.18.439-.375.932-.282 1.429.227-.258.463-.726.689-.982.145 1.181-.265 2.382-.277 3.524.747-.942.834-2.469 1.425-3.537.479-.865.975-1.269 1.887-1.58-.312-.442-.872-.713-.383-1.296.403.437.934.005 1.426-.15-.915-.651-1.561-1.521-2.583-2.08.023.795-.433 1.565-.632 2.311.121-.01.275.044.394.033z")
            ]), M),
            A2(Da, l([
                Fa("path1245"),
                Ha("#ccb25c"),
                qa("M198.106 108.705c-.081-.662-.658-1.136-1.248-.956.105.363 1.264 1.077 1.248.956z")
            ]), M),
            A2(Da, l([
                Fa("path1247"),
                Ha("#ccb25c"),
                qa("M215.431 107.716c.092.53.495.677.928.574.007.063.015.124.028.185.13.013.263.011.39.043-.236.143-.52.199-.731.42.066.044.198.184.291.25-.361.354-.073.994.07 1.295-.288-.569-.791-.825-.975-1.322-.13-.358-.162-1.178-.189-1.549.124.222.35.433.606.547")
            ]), M),
            A2(Da, l([
                Fa("path1249"),
                Ha("#ccb25c"),
                qa("M194.268 105.936c-.876.641-1.176 1.636-.041 1.552a.591.591 0 0 0-.082.21c-.691.113-1.285.701-1.953.669.57-.929.974-2.271 1.972-2.653")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1251"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".236"),
            qa("M199.763 100.48c-2.704.167-2.497 2.164-2.369 4.454.062 1.095.371 1.617 1.357 2.312 1.88 1.327 4.621.975 6.805.804 2.445-.191 2.841-3.106 3.104-5.258.066-.538.241-1.082-.109-1.529-.731-.945-2.995-.719-3.987-.773a40.473 40.473 0 0 0-4.801-.01z")
        ]), M),
        A2(Da, l([
            Fa("path1253"),
            Ha("#f3d48c"),
            Ua("#967348"),
            Ba(".322"),
            qa("M189.78 103.272c1.15-.28 1.588-1.163 2.533-1.87.783-.585 1.684-1.036 2.69-.917 1.264.148 1.267 1.165 1.576 2.319 1.692-.156 1.083 2.461 2.263 3.27.893.612 2.216.705 3.216.887 1.162.212 2.359.633 3.492.229 1.633-.581 1.949-2.076 2.576-3.566.828-1.974 1.719-3.607 3.763-3.87.763.977 1.145 1.843 2.186 2.622.315.238.693.642 1.066.756.45.139.979-.083 1.437.047.732.21 1.647 1.477 2.421 1.227 1.088-.349.493-2.428-.019-3.04-.948-1.131-4.095-1.12-3.526-3.417.088-.362.531-.552.375-1.029-.104-.315-.866-.716-1.124-.91a18.274 18.274 0 0 0-5.14-2.672c-1.045-.347-2.066-.286-2.757-1.195-.956-1.252-2.083-1.532-3.667-1.811-1.946-.342-3.359-.798-4.368 1.117-.815 1.545-1.102 2.55-2.624 3.45-1.414.837-3.051 1.46-4.592 1.913-.448.131-.928.169-1.276.536-.346.36-.293.835-.52 1.358a6.724 6.724 0 0 1-1.436 2.114c-.61.593-1.746 1.066-2.194 1.779-.345.55-.349 1.921.347 2.205.597.244.944-.336 1.356-.664.63-.5 1.166-.677 1.946-.868z")
        ]), M),
        A2(Da, l([
            Fa("path1255"),
            Ha("#dcc06d"),
            qa("M196.457 100.375c.021.446.121.884.121 1.326.971-.585 2.058 1.833 2.359 2.517.096-.549.038-1.645-.067-2.138.074.088.226.217.276.286-.069-.205-.047-.458-.179-.672.301.045.686.321 1.016.453-.178-.981-.628-1.903-.687-2.995-.063-1.156-.104-2.522.142-3.652-.307 1.187-.374 2.635-1.106 3.635-.546.746-.731.552-1.447.254.051.11.055.294.08.387-.432.02-.9.055-1.333-.045.343.179 1.136.728 1.034 1.09")
        ]), M),
        A2(Da, l([
            Fa("path1257"),
            Ha("#dcc06d"),
            qa("M187.074 103.822c.709-.329 2.217-1.724 2.995-1.235.856-1.3 2.515-2.263 3.875-2.788-.467-1.044 2.039-1.844 2.503-2.522-1.02.283-2.102 1.461-3.087 1.981-1.048.554-2.512.83-3.448 1.588-.475.385-.704 1.045-1.162 1.53-.723.764-1.631 1.283-2.299 2.114")
        ]), M)
    ]), Sn = l([
        A2(On, l([
            Fa("ClavicleRight")
        ]), l([
            A2(Da, l([
                Fa("path1645"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M191.558 151.234c-4.785-3.439-11.39-4.418-17.149-5.164-4.262-.551-8.437-.904-12.705-1.377-1.953-.218-3.856-.764-5.818-.916-2.649-.205-5.323-.01-7.976-.111-1.48-.056-2.98-.399-4.447-.401-1.489-.002-2.939.39-4.451.292-2.269-.146-4.004.11-6.191-.684-1.886-.686-3.535-1.234-5.349.018-1.352.932-2.799 2.692-2.506 4.443.233 1.393 1.5 2.274 2.002 3.544.949.189 2.182-.098 3.175-.146 1.635-.083 3.286.104 4.915-.113 1.487-.196 2.528-.721 4.056-.598 1.147.093 2.271.175 3.429.17 2.174-.01 4.296.329 6.432.759 6.814 1.375 13.819 1.487 20.722 1.193 5.673-.241 11.112.249 15.706 3.923 2.934 2.348 4.196 6.235 8.384 3.453 4.186-2.782.78-6.123-2.229-8.285z")
            ]), M),
            A2(Da, l([
                Fa("path1647"),
                Ha("#dcc06d"),
                qa("M127.651 147.866c1.498.01 2.94.16 4.439.179 1.087.013 1.113.321 1.805.586 2.198.836 6.154 1.091 8.364.085-.254-.047-.536-.162-.83-.174 1.101-.326 3.164-.62 4.414-.133-1.048.613 1.239 1.246 1.825 1.379 2.375.541 5.095.804 7.536.948 1.578.093 3.214.008 4.792-.01 1.382-.015 2.762-.253 4.141-.186.869.042 1.607.386 2.442-.005-.203.101-.358.265-.471.34 6.671.625 15.735-2.406 20.528 3.754-.399-.125-.818-.196-1.161-.522 1.27 1.505 2.249 2.571 3.967 3.611-2.401-1.5-4.671-3.64-7.253-4.81-2.214-1.003-4.568-1.126-6.978-1.292-5.793-.396-11.686.523-17.393-.183-4.393-.544-9.018-1.86-13.41-2.142-3.629-.231-7.595-.089-11.177.323-1.917.22-5.133 1.207-6.617-.506-.876-1.014-.954-2.569-.216-3.592.146 1.065 1.542 1.716 1.609 2.349")
            ]), M)
        ])),
        A2(On, l([
            Fa("ClavicleLeft")
        ]), l([
            A2(Da, l([
                Fa("path1651"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M220.691 159.82c.774-.387 1.533-.836 2.268-1.219 3.097-1.617 7.017-2.421 10.436-3.09 1.993-.39 3.898-1.153 5.914-1.287 2.396-.161 4.79.292 7.188.167 2.621-.139 5.26-.264 7.825-.795 4.019-.832 7.911-2.226 11.972-2.858 4.225-.657 6.996.321 11.104.755 2.446.258 4.437-2.01 5.626-3.913 2.183-3.481-2.817-2.971-5.417-3.4-9.396-1.555-18.419-.059-27.62 2.104-1.294.305-2.731.809-4.007 1.014-3.021.485-6.173.567-9.233.921-2.718.313-5.251.687-7.904 1.264-1.341.291-4.938 1.79-5.887.696-3.197 2.068-11.442.96-11.142 6.724.051.973 2.455 2.417 3.447 3.093 1.834 1.254 3.675.699 5.43-.176z")
            ]), M),
            A2(Da, l([
                Fa("path1653"),
                Ha("#dcc06d"),
                qa("M215.621 157.878c.674 1.586 3.084.985 4.278.676-.072-.053-.2-.105-.324-.179.463-.602 1.873-.778 2.603-.828a.52.52 0 0 0-.1.299c2.115.144 4.921-1.585 7.004-2.119 1.751-.448 7.002-.288 7.996-1.525-5.851-1.186-11.788 2.372-17.52 2.78-1.932.138-3.404 1.562-5.117.157.316.508.786.898 1.359 1.094")
            ]), M),
            A2(Da, l([
                Fa("path1655"),
                Ha("#dcc06d"),
                qa("M245.301 153.051c2.254-.439 4.684-.506 6.855-1.282 1.07-.383 3.888-1.165 4.453-1.909.842.46 3.243-.345 4.345-.524a81.598 81.598 0 0 1 7.972-.894c2.354-.148 4.748.656 7.058.483-.083.028-.117.091-.104.188.88.417 2.26.797 3.181.183.515-.342 1.271-.676.18-1.084.111.016 1.155.313 1.617.4-.969 1.893-3.076 1.769-4.995 1.453-3.652-.598-7.38-1.352-11.076-.769-3.146.498-6.159 1.823-9.151 2.85a20.607 20.607 0 0 1-5.508 1.093c-1.838.099-4.38-.549-6.077.17")
            ]), M)
        ]))
    ]), Xn = l([
        A2(Da, l([
            Fa("path579"),
            Ha("#f3d48c"),
            Ua("#967348"),
            Ba(".322"),
            qa("M198.249 385.062c.035.459-.397.825-.323 1.323.032.217.688 1.32.961 1.183 2.043-1.035.172 1.63.229 1.858.222.887.946.827 1.733.731.019.532-.406.536-.52.916-.411 1.379.876 3.818 2.551 3.194.629-.234 1.158-1.245 1.312-1.851.207-.806-.512-1.441-.215-1.991-.056.104.612-.112.65-.135.312-.188.523-.717.566-1.059.134-1.096-1.901-.889-1.21-1.748.42-.523 1.28-.112 1.647-.869.365-.754-.328-1.633-1.046-1.852.82-1.04 2.236.639 3.091-.799.683-1.148 1.058-2.039.548-3.191-1.47.095-3.046.718-4.531 1.045-1.61.356-2.947.027-4.566.004-.789-.011-1.525-.004-2.28-.134-1.021-.175-2.207-.839-2.452.469-.143.77.594 2.614 1.272 3.027.721.435 1.807-.179 2.583-.121z")
        ]), M),
        A2(Da, l([
            Fa("path581"),
            Ha("#dcc06d"),
            qa("M201.137 392.282c1.157-.221.59 1.354 1.612.673.689-.458.329-1.046-.392-1.099.375-.704-.316-.979-.801-1.16.546.193 1.813.3 1.843-.54-.604.044-1.105-.135-1.685-.154 1.101-.159 1.25-.334 1.809-.972-.047.02-.085.01-.113-.028.085.04-.07-.254-.013-.181-.438-.182-.418-.042-.537-.546-1.117.089-.854.339-1.194 1.29.047-1.018-.455-1.214-1.179-1.742.277-.319 1.296-.264 1.84-.393 0-.425-.033-.597-.472-.784.887-.206 2.274-.467 1.672-1.72-1.465-.081-3.042.308-4.358-.295 1.154.488 2.796-.179 3.967-.426-.1-.281-.047-.568-.132-.868.108.266.398.557.516.751.056-.125.145-.238.194-.335 1.005.871 1.643-1.068 1.713-1.757.279.809-.036 1.987 1.233 1.469.395-.161 1.342-1.335 1.393-1.766-.1.854-.147 1.728-.855 2.268-.826.628-1.574-.284-2.411.244-.96.605-.42.592-.023 1.194 1.123 1.713-2.314 1.232-1.324 2.963.482.018 1.247.232 1.331.836.096.703-.785.718-1.058 1.099-.324.451.021 1.007.005 1.543-.02.625-.393 1.817-1.082 1.997-.806.211-1.793-.955-1.365-1.698")
        ]), M),
        A2(Da, l([
            Fa("path583"),
            Ha("#ccb25c"),
            qa("M196.31 382.09c1.197-.57 1.667.995 2.084 1.733-.102-.57-.455-1.065-.596-1.575.672.129 1.161-.006 1.822-.023-.982-.004-1.966-.317-2.909-.269")
        ]), M),
        A2(Da, l([
            Fa("path585"),
            Ha("#ccb25c"),
            qa("M199.93 385.174c1.161-.153 2.485.367 3.6.185-.009.17.079.438.049.607.751-.343.516-.848-.03-1.058-.749-.29-2.565.408-3.35.536")
        ]), M),
        A2(Da, l([
            Fa("path587"),
            Ha("#ccb25c"),
            qa("M203.282 388.125c-.68-.333-1.728-.127-2.297.134.849.68 2.105-.157 3.085.385-.073-.441-.646-.569-1.056-.788")
        ]), M),
        A2(Da, l([
            Fa("path589"),
            Ha("#ccb25c"),
            qa("M203.148 390.538c-.691-.091-1.284.204-1.964.128.498.327 1.13.571 1.669.797.009-.415-.081-.772-.106-1.193")
        ]), M)
    ]), qn = Ic("gradientTransform"), Hn = Ic("gradientUnits"), Fn = Va("linearGradient"), Vn = Ic("offset"), Dn = Ic("opacity"), Un = Va("stop"), Bn = Ic("stop-color"), Pn = Ic("x1"), Gn = Ic("x2"), Wn = Ic("y1"), Yn = Ic("y2"), Jn = l([
        A2(On, l([
            Fa("g1329"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32")
        ]), l([
            A2(Da, l([
                Fa("path1331"),
                qa("M169.92 57.363c-.268-.244-2.598-1.59-2.598-1.618-.041 2.231.298 4.621.896 6.773.566 2.038 1.049 3.928 1.156 6.033.109 2.163.188 4.286.148 6.423-.04 2.248-.252 3.152 1.834 4.482 2.784 1.777 1.101-1.141 1.108-2.878.015-2.896-.292-6.015.129-8.963.149-1.043.791-2.257.824-3.251.042-1.258-.822-2.453-1.394-3.514-.63-1.177-1.041-2.517-2.103-3.487z")
            ]), M),
            A2(Da, l([
                Fa("path1333"),
                qa("M171.63 58.673c-1.718.46-1.058 2.467-.637 3.586.84 2.231 1.683 3.02 3.104.539-.423-.511-1.742-4.319-2.467-4.125z")
            ]), M),
            A2(Da, l([
                Fa("path1335"),
                qa("M167.885 47.307c-.384 2.087-.615 4.302-.875 6.398-.159 1.279-.076 2.698.012 3.981.054.75.874 3.006.651 3.583.211-.547.416-1.074.418-1.659.36.289.798.425 1.229.605.012-.031.188-.355.198-.343.272.308.676.629.86 1.043.04-.706.432-1.406 1.091-1.773a3.5 3.5 0 0 1-.375-1.771c-.107-.04-.205.037-.279.003-1.28-.586-1.745-4.364-1.124-5.51.121.095.384.223.513.331a4.913 4.913 0 0 1-.116-1.386l.296-.062c.097-.572-.205-.895-.287-1.426-.296-1.92.149-4.029.254-5.962.109-2.045.197-4.417 1.433-6.156-1.483 1.071-2.33 4.024-2.842 5.719a41.305 41.305 0 0 0-1.057 4.385z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1337"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32")
        ]), l([
            A2(Da, l([
                Fa("path1339"),
                qa("M236.105 74.116c-.027-1.309.141-2.616.115-3.926-.052-2.581.721-5.255 1.308-7.747.256-1.09 1.124-4.569-.547-4.991-1.371-.346-2.835 2.198-3.5 3.03-1.232 1.545-1.36 3.229-.863 5.204.778 3.088 1.45 7.026.18 10.112-.976 2.371 1.727 3.722 3.165 1.67.664-.951.183-2.125.146-3.223l-.004-.129z")
            ]), M),
            A2(Da, l([
                Fa("path1341"),
                qa("M238.003 47.189c.607 4.007.441 9.333-.721 13.22-.265-.706-.817-.633-1.022.141-.075-.278-.332-.565-.403-.777-.311.308-.663.639-1.013.951-.717-1.256-1.273.28-1.299 1.103-.431-.242-.981-.657-1.563-.352.726-1.916-.076-4.441.553-6.423.411-1.288 1.126-1.793 1.036-3.405-.056-.981-.434-1.884-.495-2.848-.069-1.076.246-2.016.318-3.089.087-1.296-.318-2.84-.141-4.072.099-.664.618-.993.789-1.591.236-.831-.06-1.751.33-2.494 1.126 1.146 1.391 3.029 1.934 4.48.639 1.713 1.418 3.327 1.697 5.156z")
            ]), M),
            A2(Da, l([
                Fa("path1343"),
                qa("M231.641 64.882a1.311 1.311 0 0 1-.129-.066c-1.328-.775-1.134-3.797-.744-4.978.182-.544.425-1.131.846-1.54.143-.14 1.433-.761 1.422-.729-.457 1.675.715 3.401.45 5.11-.173 1.126-.79 2.674-1.845 2.203z")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1345"),
            Ha("#231f20"),
            qa("M214.269 71.147c-.792-.639-1.331-1.556-2.078-2.475-.994-1.226-1.352-2.975-2.369-4.088-1.244-1.363-3.317-.377-4.898-.384-3.239-.015-6.373-.261-9.62.016-1.911.165-1.994 1.187-2.554 3.08-.53 1.792-.614 2.441-2.013 3.752-1.15 1.078-2.429 1.961-3.716 2.864-1.378.966-3.625 2.122-4.494 3.631-.821 1.428.177 3.911.982 5.185 1.138 1.802 4.085 1.683 6.014 1.577 1.792-.1 2.981-.42 4.344.69.522.426 1.468.96 1.732 1.604.313.758-.23 1.834-.188 2.703.083 1.767.034 4.392 2.136 4.966 2.434.664 3.488-1.328 4.783-2.646.955 1.015 1.514 2.572 2.993 2.952 2.5.641 2.997-2.1 3.029-3.968.015-.931-.623-2.893-.273-3.688.539-1.227 3.024-1.269 4.116-1.386 2.718-.29 5.659.234 8.331-.438 4.196-1.057 2.9-6.333 2.57-9.433-.147-1.362.158-2.67-1.237-3.272-1.817-.784-3.858-.151-5.752-.444a3.728 3.728 0 0 1-1.838-.798z")
        ]), M),
        A2(Fn, l([
            Fa("XMLID_7_"),
            Pn("202.647"),
            Gn("202.514"),
            Wn("95.355"),
            Yn("83.228"),
            Hn("userSpaceOnUse")
        ]), l([
            A2(Un, l([
                Fa("stop1348"),
                Vn("0"),
                Bn("#f3d48c")
            ]), M),
            A2(Un, l([
                Fa("stop1350"),
                Vn(".348"),
                Bn("#ccb25c")
            ]), M),
            A2(Un, l([
                Fa("stop1352"),
                Vn(".444"),
                Bn("#c8af5a")
            ]), M),
            A2(Un, l([
                Fa("stop1354"),
                Vn(".535"),
                Bn("#bda555")
            ]), M),
            A2(Un, l([
                Fa("stop1356"),
                Vn(".626"),
                Bn("#a9944c")
            ]), M),
            A2(Un, l([
                Fa("stop1358"),
                Vn(".715"),
                Bn("#8e7c40")
            ]), M),
            A2(Un, l([
                Fa("stop1360"),
                Vn(".803"),
                Bn("#6b5d30")
            ]), M),
            A2(Un, l([
                Fa("stop1362"),
                Vn(".892"),
                Bn("#40381d")
            ]), M),
            A2(Un, l([
                Fa("stop1364"),
                Vn(".978"),
                Bn("#0e0c06")
            ]), M),
            A2(Un, l([
                Fa("stop1366"),
                Vn("1"),
                Bn("#000")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1368"),
            Ha("url(#XMLID_7_)"),
            qa("M202.63 82.026c-.081 1.182-.194 2.187-.267 3.332-.056.857-.313 1.867-.517 2.665.651.697.058 2.415.89 2.922.457-1.74.531-3.139.424-4.92-.087-1.444.305-3.186-.158-4.517-.31.165-.322.432-.373.786")
        ]), M),
        A2(On, l([
            Fa("g1370")
        ]), l([
            A2(Da, l([
                Fa("path1372"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".32"),
                qa("M197.434 69.279c.226-.233.553-.369.729-.765.204-.456.103-.846.332-1.241.161-.28.487-.534.739-.722 1.401 1.128 1.145 2.405 1.254 4.093.093 1.435-.261 2.707-.62 4.063-.367 1.383-.398 2.708-.813 4.069-.42 1.375.224 2.844-.158 4.267-.593 2.217-4.738 8.041-.562 9.145 1.022.271 2.525.328 3.299-.514.701-.767.671-2.069 1.1-2.982.162 1.884-.149 3.775.074 5.659.265 2.23 1.165 4.741.907 6.993-.232 2.028-2.088 2.092-3.771 2.268-2.409.247-4.838.347-7.225.776-1.25.225-2.474.566-3.705.868-.08.019-3.218.805-2.55 1.23-.115-.074-.42-.246-.507-.323-.215-1.284-.94-2.276-.701-3.701.423-2.517 1.949-6.189-1.323-7.292-1.862-.627-3.81-.658-5.699-1.383-.936-.359-5.197-1.734-4.097-3.351 1.116.524 2.658-1.186 3.186-1.978.025-.037.51-1.03.532-1.102.11-.361-.216-.45-.054-.806.239-.522 1.08-.451.442-1.197.676-.456 1.839-.582 2.154-1.442.243-.027.295-.099.493-.183-.638.271.02-1.275.171-1.437.351-.378 1.269-.831 1.743-1.014.236-.09.54.22.812-.137-.054-.051-.062-.05-.022.003 1.145.513 2.639-.934 3.502-.583.087-.031.118-.19.2-.229.108-.003.095.093.203.095.288-.531.862-1.366 1.344-1.708l.06.236c.404-.439.873-.998 1.204-1.539.143-.233 1.284.9 1.369 1.118.687-1.119.648-2.551 1.156-3.753.526-1.242.952-2.003 2.008-2.92.801-.696 1.952-.607 2.548-1.6.145-.242.011-.631.122-.818a.763.763 0 0 1 .124-.163z")
            ]), M),
            A2(Da, l([
                Fa("path1374"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".32"),
                qa("M208.148 89.481c.002-1.019-.482-1.992-.819-3.022-.379-1.151-.654-2.335-.669-3.533-.026-1.937.576-3.675-.405-5.498-.666-1.24-.685-2.629-.702-4.092-.019-1.782.823-4.246-.243-5.807.618-.064.77-.625.536-1.071.866-.215 1.503-1.862 1.61-2.677 2.973 1.906-.301 5.893 2.457 8.272 1.241 1.071 2.764 1.572 3.718 3.031.817 1.249.516 2.778 1.975 3.582 1.817.998 4.126.748 6.119.744 2.258-.007 3.599-.365 4.451 2.109.463 1.345.074 2.431.081 3.856.009 1.46.477 2.232 1.614 3.151.203.164 1.287.77 1.353.934.398 1.004-2.363 2.173-3.01 2.401-1.679.595-3.585 1.421-4.423 3.092-.862 1.716-.269 3.793-.3 5.617-.017.996.224 3.771-.763 4.351-.608.356-2.777-.188-3.58-.144-1.664.09-3.313-.277-4.953-.492-1.657-.216-3.517-.128-5.065-.805-.245-.105-3.934-1.737-3.737-.881-.395-1.723.377-3.725-.066-5.513-.612-2.459-.503-5.432-.569-7.952.552 1.259 1.395 3.425 3.074 3.287 1.211-.1 2.054-1.238 2.269-2.398.032-.182.047-.363.047-.542z")
            ]), M),
            A2(Fn, l([
                Fa("XMLID_8_"),
                Pn("216.603"),
                Gn("218.749"),
                Wn("83.698"),
                Yn("82.625"),
                Hn("userSpaceOnUse")
            ]), l([
                A2(Un, l([
                    Fa("stop1377"),
                    Vn("0"),
                    Bn("#f3d48c")
                ]), M),
                A2(Un, l([
                    Fa("stop1379"),
                    Vn(".107"),
                    Bn("#eed089")
                ]), M),
                A2(Un, l([
                    Fa("stop1381"),
                    Vn(".235"),
                    Bn("#e0c381")
                ]), M),
                A2(Un, l([
                    Fa("stop1383"),
                    Vn(".372"),
                    Bn("#c8ae73")
                ]), M),
                A2(Un, l([
                    Fa("stop1385"),
                    Vn(".516"),
                    Bn("#a69160")
                ]), M),
                A2(Un, l([
                    Fa("stop1387"),
                    Vn(".665"),
                    Bn("#7c6c47")
                ]), M),
                A2(Un, l([
                    Fa("stop1389"),
                    Vn(".82"),
                    Bn("#473e29")
                ]), M),
                A2(Un, l([
                    Fa("stop1391"),
                    Vn(".975"),
                    Bn("#0a0906")
                ]), M),
                A2(Un, l([
                    Fa("stop1393"),
                    Vn("1"),
                    Bn("#000")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1395"),
                Ha("url(#XMLID_8_)"),
                qa("M217.359 82.331c-.503.513-.501 1.363.764 1.423.688.033 1.393-.282 1.292-1.135-.721-.943-1.599-.755-2.056-.288z")
            ]), M),
            A2(Da, l([
                Fa("path1397"),
                Ha("#dcc06d"),
                qa("M207.288 101.008c.523.364.915.789 1.069 1.363.416-.87.254-2.486-.309-3.265-.104.043-.139.189-.222.221-.251-.304-.661-.504-.883-.759.531.645.467 1.847.166 2.618")
            ]), M),
            A2(Da, l([
                Fa("path1399"),
                Ha("#dcc06d"),
                qa("M201.209 100.829c.516-.087.943.077 1.273.473-.198-.48-.153-.795-.211-1.306a.47.47 0 0 0 .149.236c.196-.799-.277-1.718-.909-2.204-.26.87.028 2.09-.482 2.802")
            ]), M),
            A2(Da, l([
                Fa("path1401"),
                Ha("#dcc06d"),
                qa("M209.792 101.008c.495.158.9.441 1.224.843.343-1.814-.74-3.729-.83-5.491-.103-1.959 1.324-4.262.352-6.249.397.981-.089 2.747-.429 3.744-.407 1.197-.309 1.187-.315 2.329-.007 1.357.789 3.487.177 4.824")
            ]), M),
            A2(Da, l([
                Fa("path1403"),
                Ha("#dcc06d"),
                qa("M196.917 102.438a2.71 2.71 0 0 1 1.013-1.079c-.895-.283-.364-5.173-.142-6.045-1.633.218-1.803-2.987-2.131-4.088.028 2.417 1.263 4.676 1.26 7.154-.002 1.295.11 2.682-.179 3.879")
            ]), M),
            A2(Da, l([
                Fa("path1405"),
                Ha("#dcc06d"),
                qa("M214.489 100.431c-.02-.293-.356-.71-.416-1.032-.335-1.815.177-3.831.188-5.667-.013 2.004-.488 4.22-.768 6.206-.081.584-.079 1.349-.458 1.846-.503.655-1.469.418-1.79 1.526 1.152-.254 2.03-.472 3.169.195-.203-1.128.151-2.015.075-3.074z")
            ]), M),
            A2(Da, l([
                Fa("path1407"),
                Ha("#dcc06d"),
                qa("M215.691 103.69c-.058-.581.079-1.205.205-1.762 2.173-.177 1.301-4.707 1.444-6.274.535 1.666-.248 4.903.715 6.4.121-.036.162-.107.292-.126-.149.276-.286 1.326.395 1.023.321-.142.443-1.232.526-1.433.019.072.161.381.213.548 1.454-.914-.151-2.201.288-2.994.075.05.075.072-.004.065.143-.346.457-1.216.571-1.886.167-.971-.132-2.17.344-3.002-.275.054-.57-.019-.862.115.877-.613 1.493-1.791 2.31-2.593.516 1.124 3.397-.368 4.41-.572-1.955 2.074-5.276 1.852-5.662 5.159-.295 2.524.954 6.466-1.033 8.39-.075-.475-.29-.95-.572-1.261a3.11 3.11 0 0 0-1.076.942c-.39-.385-.864-.946-1.44-1.116-.516-.151-.657 1.186-1.243.017")
            ]), M),
            A2(Da, l([
                Fa("path1409"),
                Ha("#dcc06d"),
                qa("M216.944 83.843c-.149 1.155-1.724 1.113-2.654 1.1.482 1.339-.58.992-1.431 1.252.194 1.325.414 2.709.549 4.09.1 1.042-.178 2.807.322 3.687.414-1.423.365-2.917.889-4.352.979 3.319 1.222 7.516 1.252 10.711.011-2.135-.627-6.928.67-8.605.094.486.529 1.021.595 1.393.149.834-.103 1.653.17 2.471-.03-1.977-.648-3.896-.576-5.827-.187.271-.648.61-.854.896-.704-.396-.5-1.235-.719-1.917-.021.066-.066.095-.136.087-.104-.615-.488-.982-1.047-.671.345-.648.273-1.754.826-2.23.174-.149.768.159 1.089-.064.6-.413 1.028-1.524.698-2.199")
            ]), M),
            A2(Da, l([
                Fa("path1411"),
                Ha("#dcc06d"),
                qa("M210.447 82.155c-.217-1.423-.757-4.961-2.062-5.81.113 1.604.959 3.363 1.237 4.999.188 1.097.542 3.797-.519 4.51.93.854 1.214 2.175 1.591 3.383-.659-2.11.09-4.873-.247-7.082z")
            ]), M),
            A2(Da, l([
                Fa("path1413"),
                Ha("#dcc06d"),
                qa("M193.528 100.168c-.032.069-.949 2.045-1.066 1.878-1.111-1.573-1.706-4.11-1.078-6-.704 2.117-.367 4.715-.367 6.954.183.094-.178-.03.014-.136a3.24 3.24 0 0 0-.947.979c-.061-.157-.294-.306-.344-.668a687.1 687.1 0 0 0-1.195.669c-.111-1.501.347-3.196.112-4.621-.766 1.195-.648 3.039-.715 4.447-.558.061-.262-.077-.818.323-.045-.055-.364-.482-.358-.472-.093.158-.126.347-.267.471-.471-2.034.215-3.48.411-5.42a.133.133 0 0 1-.104.089c-.002-1.117-.426-2.604-.792-3.403.379 2.659-1.66 8.089.321 10.213-.049-.445.194-.8.245-1.22.313-.068.914-.174 1.175-.179.183.304.609.539.769.815.414-1.46 1.387-.839 2.27-.142-.593-.468 1.547-1.239 2.172-.578-.07-.71.376-1.007 1.068-.865-.37-.867-.535-2.124-.506-3.134z")
            ]), M),
            A2(Fn, l([
                Fa("XMLID_9_"),
                Pn("189.957"),
                Gn("188.17"),
                Wn("83.639"),
                Yn("82.746"),
                Hn("userSpaceOnUse")
            ]), l([
                A2(Un, l([
                    Fa("stop1416"),
                    Vn("0"),
                    Bn("#f3d48c")
                ]), M),
                A2(Un, l([
                    Fa("stop1418"),
                    Vn(".107"),
                    Bn("#eed089")
                ]), M),
                A2(Un, l([
                    Fa("stop1420"),
                    Vn(".235"),
                    Bn("#e0c381")
                ]), M),
                A2(Un, l([
                    Fa("stop1422"),
                    Vn(".372"),
                    Bn("#c8ae73")
                ]), M),
                A2(Un, l([
                    Fa("stop1424"),
                    Vn(".516"),
                    Bn("#a69160")
                ]), M),
                A2(Un, l([
                    Fa("stop1426"),
                    Vn(".665"),
                    Bn("#7c6c47")
                ]), M),
                A2(Un, l([
                    Fa("stop1428"),
                    Vn(".82"),
                    Bn("#473e29")
                ]), M),
                A2(Un, l([
                    Fa("stop1430"),
                    Vn(".975"),
                    Bn("#0a0906")
                ]), M),
                A2(Un, l([
                    Fa("stop1432"),
                    Vn("1"),
                    Bn("#000")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1434"),
                Ha("url(#XMLID_9_)"),
                qa("M189.408 84.168c2.144-.837-1.309-2.988-1.622-2.519-.6.896.386 2.985 1.595 2.53l.027-.011z")
            ]), M),
            A2(Da, l([
                Fa("path1436"),
                Ha("#dcc06d"),
                qa("M187.799 84.379c.3.525.567 1.052.903 1.546.002-.285.111-.36.166-.584.536.529.341.254.901.268.271.2.624.497.913.732-.629 1.083.448 2.678.47 3.747.035 1.614-.414 3.933-.314 5.228 0-1.561.115-3.58-.853-4.794-.058-.047-.191.215-.228.233-.012-.161.061-.307-.031-.461-1.363 1.885-.274 4.665-.993 6.727-.185-1.977.453-4.163-.07-5.994-.562-.426-.797-1.367-1.682-1.286-.033.052-.189.21-.263.298.033-.697-.183-.447-.493-.943-1.218.929-1.641 2.108-3.11 2.901 1.294-.555 2.494-1.599 2.927-2.941.113-.074.576-.269.721-.321.5.658 2.475 1.485 2.007-.01.202.5.621.731 1.148.634.251-1.129-.51-2.305-1.085-3.198-.439-.681-.703-1.208-1.033-1.959")
            ]), M),
            A2(Da, l([
                Fa("path1438"),
                Ha("#dcc06d"),
                qa("M197.633 77.585c-.016 3.599-2.487 6.968-2.132 10.481-.69-2.263.108-4.612.751-6.861.554-1.95.86-3.986 1.636-5.868-.377 1.185-.719 2.197.102 3.321")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1440"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32"),
            qa("M193.378 63.639c-1.875-2.021-3.623-2.75-6.26-1.182-2.049 1.218-3.837 3.196-5.224 5.115-.553.764-2.358 1.761-2.516 2.678-.155.893 1.539 3.222 2.309 3.558a1.916 1.916 0 0 0-.129-.478c.925-.115.37.493.873.866.437.323.961.448 1.259.922.7 1.112.173 3.043.748 4.228 2.026-.387 3.644-2.497 5.524-3.286-.012.046-.115-.099-.121-.08.185-.237.549-.373.768-.518 1.402 2.267 2.171-1.213 2.508-2.133.62-1.685 1.794-3.114 2.2-4.864.195-.842.253-1.861-.019-2.68-.358-1.075-1.11-1.273-1.92-2.146z")
        ]), M),
        A2(Da, l([
            Fa("path1442"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32"),
            qa("M216.381 60.822c-2.304.381-3.976 1.246-5.36 3.04-1.439 1.869-1.538 3.082-.939 5.488.493 1.973 1.472 4.244 3.464 5.058 1.648.672 4.55 2.883 6.418 2.397.031-.008 1.066-1.252 1.28-1.427.687-.565 1.36-1.103 2.145-1.548.621-.351.79-.344 1.6-.537 2.058-.49 1.029-1.346 1.825-2.873.318-.61 1.192-.634 1.194-1.37.003-.262-2.387-3.099-2.621-3.428-1.621-2.257-6.277-5.248-9.006-4.8z")
        ]), M),
        A2(Fn, l([
            Fa("XMLID_10_"),
            Pn("217.979"),
            Gn("218.337"),
            Wn("56.645"),
            Yn("57.808"),
            Hn("userSpaceOnUse")
        ]), l([
            A2(Un, l([
                Fa("stop1445"),
                Vn("0"),
                Bn("#f3d48c")
            ]), M),
            A2(Un, l([
                Fa("stop1447"),
                Vn(".107"),
                Bn("#eed089")
            ]), M),
            A2(Un, l([
                Fa("stop1449"),
                Vn(".235"),
                Bn("#e0c381")
            ]), M),
            A2(Un, l([
                Fa("stop1451"),
                Vn(".372"),
                Bn("#c8ae73")
            ]), M),
            A2(Un, l([
                Fa("stop1453"),
                Vn(".516"),
                Bn("#a69160")
            ]), M),
            A2(Un, l([
                Fa("stop1455"),
                Vn(".665"),
                Bn("#7c6c47")
            ]), M),
            A2(Un, l([
                Fa("stop1457"),
                Vn(".82"),
                Bn("#473e29")
            ]), M),
            A2(Un, l([
                Fa("stop1459"),
                Vn(".975"),
                Bn("#0a0906")
            ]), M),
            A2(Un, l([
                Fa("stop1461"),
                Vn("1"),
                Bn("#000")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1463"),
            Ha("url(#XMLID_10_)"),
            qa("M217.225 57.385c.011.04.038.081.081.119.233.209 2.011.108 1.849-.224-.422-.864-2.058-.344-1.93.105z")
        ]), M),
        A2(Da, l([
            Fa("path1465"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32"),
            qa("M203.715 74.836c.098-.516.062-1.094.143-1.577.244-1.436.333-3.24-.283-4.595-.308-.676-.642-.902-.725-1.676-.026-.216.039-.695-.111-.875-.008-.01-.345-.43-.386-.179.011-.071-.023-.241 0-.332-.664-.095-1.896 1.119-2.146.616-.621.627-1.653.755-.802 1.791.401.488.647.574.737 1.241.21 1.544-.596 2.401-1.086 3.73a8.177 8.177 0 0 0-.514 2.82c.001.586-.02 2.034.512 2.391.336-.41.599-.909.865-1.365.082-.14 1.213-1.694 1.379-1.334.118.26.259.45.316.739.86-.423 1.325.208 1.901-.811.1-.177.162-.375.2-.584z")
        ]), M),
        A2(On, l([
            Fa("g1467")
        ]), l([
            A2(Da, l([
                Fa("path1469"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".32"),
                qa("M207.301 79.322c-.234-1.119-1.407-2.213-1.096-3.408-.162.11-1.154.019-1.15-.034.068-.594-.364-1.18-.936-.895-.211.628-.294 1.52-1.201 1.156.198-1.581.104-3.433.015-4.911-.032-.537-.324-.966-.38-1.496-.066-.61.141-1.226.167-1.834.039-.981-.591-1.68.284-2.276.89.667 1.66-.173 2.542.048-.063-.016.833.401.802.381.284.199.491.313.29.695.687.579-.479 1.771-.655 2.393-.458 1.627.838 3.005 1.222 4.459.493 1.872-.296 3.86.096 5.722z")
            ]), M),
            A2(Da, l([
                Fa("path1471"),
                Ha("#dcc06d"),
                qa("M204.07 69.539c.051.251.129.494.232.728-.043-.097.115-.334.175-.403 1.037 1.153.978 3.566 1.061 5.031.124.009.17-.117.286-.153.186.475.05.394.348.542.324.768.226 1.595.213 2.417.87-1.397.648-2.88.171-4.366-.331-1.026-1.677-3.038-1.203-4.123.595-.358.807-1.403.648-2.16-.535.742-1.114 1.703-1.886 2.282-.075-.083-.147-.199-.237-.268-.022.197.055.334.192.473")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1473"),
            Ha("#f3d48c"),
            Ua("#967348"),
            Ba(".32"),
            qa("M197.455 72.068a8.55 8.55 0 0 1-.947 1.492c.302-.384-.613-2.202-.677-2.65-.131-.897.023-1.649.627-2.379 1.061-1.281 1.646.444 1.554 1.636-.049.644-.26 1.293-.557 1.901z")
        ]), M),
        A2(Da, l([
            Fa("path1475"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32"),
            qa("M195.845 70.121c.233.906.789 2.211.642 3.119-.153.941-1.185 2.204-1.793 2.904.729-1.077.121-2.075.139-3.224.018-1.044.639-2.1 1.013-3.068")
        ]), M),
        A2(Da, l([
            Fa("path1477"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".32"),
            qa("M209.218 70.207c1.139-.043 1.76 1.785 1.986 2.637.396 1.492.331 2.588 1.491 3.833-1.753-1.035-3.246-2.69-3.905-4.67-.201-.603-.544-1.764.428-1.8z")
        ]), M),
        A2(Da, l([
            Fa("path1479"),
            Ha("#f3d48c"),
            Ua("#967348"),
            Ba(".32"),
            qa("M209.229 70.927c-.007-.346.004-.709.023-1.105.035-.716-.066-1.381-.132-2.079.192.796-.652 1.063-.94 1.685-.79 1.692 1.188 3.384 1.892 4.675-.626-1.149-.822-2.063-.843-3.176z")
        ]), M),
        A2(On, l([
            Fa("g1481")
        ]), l([
            A2(Da, l([
                Fa("path1483"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".32"),
                qa("M182.146 73.026a6.152 6.152 0 0 0-.649-.333c-.221-.098-.916-.39-1.045-.589-.216-.335.358-.553.233-.777-.294-.528-1.107-.722-1.564-1.083-.293-.231-.308-.84-.502-.969-.305-.203-.727-.013-1.058-.195-.374-.205-.537-.578-.786-.878-.625-.761-1.163-1.643-1.846-2.375-.5-.535-1.052-.84-1.239-1.602-.036-.141-1.833 2.611-1.972 2.983-.564 1.509-1.023 3.193-.816 4.814.104.795.256 1.224.266 1.988.017 1.326.79 2.876.512 4.147-.4-.803-1.041.124-1.592.107-.258-.008-1.964-1.052-1.917-1.192-.345 1.008-.476 2.153-.732 3.155 1.442.56 2.857 4.771 3.563 6.084.634 1.18 1.777 4.169 2.852 4.783.949-.421 1.693-.085 2.65-.126.357-1.765 1.831-2.879 2.557-4.457-.131-.152-.161-.086-.324-.195.094-.205.267-.536.319-.636.958-.53 2.792-1.478 2.817-2.701a27.406 27.406 0 0 0-.305-.061c.258-.645.823-1.16.679-2.052.08.162.159.254.22.443 1.117.161 3.078.135 3.947-.458.62-.424 1.33-1.101 1.527-1.827-.766-.058-1.266.745-2.019.892-.668.129-1.584.018-2.256-.031-.189-.397-.344-5.536.33-5.296-.067-.024-.431-.129-.48-.064.087-.113.146-.374.247-.489-.85.125-.669-.382-1.088-.667a10.617 10.617 0 0 0-.529-.343z")
            ]), M),
            A2(Da, l([
                Fa("path1485"),
                Ha("#dcc06d"),
                qa("M172.501 70.304c-.843 1.135-.595 5.117.246 6.196a.176.176 0 0 1 .144-.059c-.363 1.237.507 2.164.262 3.495-.546 2.957 1.187 5.197 1.714 7.999l-.079-.035c.005.457.004.914.011 1.37-.457-1.529-.8-3.03-1.354-4.547-.321-.878-.94-1.784-1.181-2.667-.287-1.048-.233-2.58-1.048-3.479.302.263.517.21.881.237-.422-.733-.223-1.744-.381-2.521-.221-1.083-.493-1.992-.575-3.09-.147-1.996-.057-3.754.865-5.484-.277.52.776 2.117.875 2.646a2.812 2.812 0 0 1-.38-.061z")
            ]), M),
            A2(Da, l([
                Fa("path1487"),
                Ha("#dcc06d"),
                qa("M174.926 77.898c.496.08.842.375 1.012.825-.394-1.128-.72-2.195-.973-3.365-.206-.959-.071-2.35-.449-3.178.04 1.952.151 3.709.543 5.584")
            ]), M),
            A2(Da, l([
                Fa("path1489"),
                Ha("#dcc06d"),
                qa("M177.742 81.519c1.574 1.027 3.516 1.101 5.323 1.066-.433.264-.913.549-1.402.661.067-.017-.936-.412-1.047-.434-.464-.087-.926.044-1.399-.084-.981-.264-1.992-1.171-2.279-2.148")
            ]), M),
            A2(Da, l([
                Fa("path1491"),
                Ha("#dcc06d"),
                qa("M179.801 78.074c-1.575-1.631-2.383-3.771-2.331-6.035.183 1.033 1.931 2.01 2.771 2.656-.854-.656-1.331-1.679-1.999-2.497-.68-.834-1.592-1.689-1.7-2.843-.663 1.649-.982 3.802-.521 5.549.429 1.622 1.493 3.319 2.814 4.356 1.256.988 4.71 2.717 6.236 1.58-1.116.834-4.606-2.077-5.27-2.766z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1493")
        ]), l([
            A2(On, l([
                Fa("g1495")
            ]), l([
                A2(Da, l([
                    Fa("path1497"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".32"),
                    qa("M230.388 67.167c-.062.023-.121.048-.179.072.009-.004-2.062.857-1.403 1.128-.557-.229-1.119-.564-1.696-.917-.014 1.039-.601 1.515-1.074 2.384-.098.18-.189.364-.276.551-.344.74-.769 1.682-1.732 1.499.042.272-.098.643-.041.912-.195-.141-.598-.151-.763-.244.048.219-.084.547-.042.768-1.104.244-1.021.856-1.177 1.784-.055.337-.013 1.01-.288 1.276-.08.076-.879.393-.769.192-.229.414-.54.71-.582 1.173-.379.026-4.724-.676-4.651-1.035-.625 3.104 3.284 2.623 5.089 2.624.737 0 1.617-.268 2.327.007.78.301 1.687 1.146 2.435 1.609-.3.21-.579.514-.744.818.385 0 .794.039 1.16.179-.559.497-1.377.782-1.285 1.595.031.296.757.366.671 1.043.122.009.246.025.367.047-.139.243-.632 1.173-.539 1.447.231.681 1.103.548 1.574.836-.056.069-.111.138-.171.205.733.593.989 1.746.638 2.596.732-.166.732.587.811 1.173.077.613 3.774-1.899 4.012-2.125.967-.917 1.47-1.885 2.54-2.678 1.396-1.035 1.56-1.613 1.879-3.227.448-2.255 1.953-4.367 1.563-6.704-.333-1.985-1.363-1.5-2.365-.804-.27.187-.391.523-.711.684-.392.197-1.074-.009-1.319.121-.484.259-.929.884-1.314 1.437 1.022-1.46 1.848-3.708 1.896-5.511.045-1.719.156-3.606-.283-5.279-.097-.37-.643-1.397-.178-1.761-.445.349-.625 1.024-1.111 1.317-.619.37-1.551.531-2.269.808z")
                ]), M),
                A2(Da, l([
                    Fa("path1499"),
                    Ha("#dcc06d"),
                    qa("M232.775 76.702c.776-2.458 1.822-5.02 1.306-7.673-.128-.654-.393-1.316-.516-1.957-.229.695-.271 1.132-.303 1.869-.093 2.154-.025 4.088-.837 6.069-.557 1.36-.955 2.749-.752 4.346.552-.175 1.024-1.091 1.552-1.462.83-.581 1.784-.662 2.818-.934-1.04-.384-2.174.125-3.175.25a3.41 3.41 0 0 1 .1-.499.219.219 0 0 0-.193-.009z")
                ]), M),
                A2(Da, l([
                    Fa("path1501"),
                    Ha("#dcc06d"),
                    qa("M230.577 89.296a7.225 7.225 0 0 0 1.717-2.508c.149-.372.326-1.897.715-2.021 1.32-.424 2.09-1.884 2.398-3.117.061-.237-.29-.346-.223-.53.102-.289.451-.43.622-.674.387-.552.913-.949 1.214-1.57-.318 2.453-.348 5.995-3.067 6.958-.153 1.6-2.198 2.513-3.242 3.463")
                ]), M),
                A2(Da, l([
                    Fa("path1503"),
                    Ha("#dcc06d"),
                    qa("M231.114 75.082c-1.422 3.522-4.147 4.464-7.375 5.709 1.9-.443 4.192-1.237 5.792-2.321 1.45-.983.939-2.206 1.583-3.388")
                ]), M),
                A2(Da, l([
                    Fa("path1505"),
                    Ha("#dcc06d"),
                    qa("M231.733 69.746c-.227 1.04-.163 2.104-.197 2.945.278-.505.61-1.152.657-1.735.021-.28-.429-1.359-.46-1.21z")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1507"),
                Ha("#dcc06d"),
                qa("M228.047 71.405a.76.76 0 0 1-.525-.065c-.667 1.072-2.131 2.339-2.296 3.62.825.326 1.224-1.157 1.987-1.346-1.214 3.797-6.273 4.48-9.472 5.227 1.235-.289 2.862.145 4.176-.033 1.92-.26 3.695-1.408 5.221-2.521 1.933-1.409 2.515-4.077 2.337-6.349-.105.562-.788 1.336-1.428 1.467z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1509")
        ]), l([
            A2(On, l([
                Fa("g1511")
            ]), l([
                A2(Da, l([
                    Fa("path1513"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".32"),
                    qa("M169.929 49.853c-.016 1.17-.459 2.456-.371 3.765.126 1.881.494 3.352 1.57 4.828.755 1.036 1.532 1.796 2.108 2.928.288.563-.731 2.697-.867 3.34-.196.92-.592 1.883-.67 2.811.189-.225.531-.363.667-.474-.049.168-.068.36-.104.51.106-.103.387-.261.495-.381-.125.354-.145.818.054 1.185.511-.498.829-1.356 1.292-1.96-.001.111-.066.24-.103.343.132-.005.378-.014.503.04.015.159.04.336.043.493.375.321.82.459 1.183.721 1.266.914 2.291 1.682 3.703 2.423 1.689.885 1.425.538 2.816-1.011 1.318-1.466 3.003-2.866 4.07-4.505-.153-.034-.313-.038-.469-.053.933-.6 1.806-1.332 2.669-2.222.058.112.101.225.162.326a4.37 4.37 0 0 1 1.045-.916c-.002.002 3.858 3.073 4.369 3.45 1.473 1.088 3.23 2.024 4.25 3.616 1.696-.882 2.333-2.621 4.435-2.565.755.021 2.276-.068 3.038.174.712.225 1.128 1.056 1.712 1.587.158.073-.062.051-.066-.14.004.701.124 1.33.674 1.714-.064-.944 1.277-2.611 2.05-3.419 1.93-2.032 4.948-2.798 6.765-4.771.379.016.752.032 1.211.015.67 2.84 4.017 4.198 5.749 6.338.158-.091.38-.184.514-.281.031.468-.103.959-.368 1.369.593-.232 1.797-.535 2.379-1.011.197.62-.254 1.21-.396 1.909a5.047 5.047 0 0 1 1.076-1.152c-.037.154-.102.289-.144.439.358-.375.636-.875.84-1.341-.044.466.122.927.217 1.322 1.148-1.927 2.415-2.039 4.811-2.109-.113-.681.544-1.281.521-1.622-.042-.612-.748-1.19-1.04-1.749-.89-1.698-.531-3.461-.146-5.346.136.003.151.106.277.135.932.207 2.124-4.416 2.265-5.179.4-2.151.548-4.36-.411-6.402.23.183.599.285.855.48.044-1.03-.736-1.947-.673-2.952.237.167.493.198.664.288.011-.761-.218-1.573-.482-2.282.348.205.823.211 1.197.32.23-1.197-.326-2.522-.813-3.583-1.538-3.363-3.344-6.178-5.58-9.083-1.191-1.551-2.701-2.356-4.265-3.431-3.803-2.616-7.802-4.317-12.347-5.204-4.481-.874-9.784-1.705-14.333-.989-3.106.489-5.871.755-8.856 1.729-2.692.88-5.243 2.193-7.591 3.768-4.701 3.152-8.976 7.571-11.053 12.914-.646 1.663-1.357 3.377-1.417 5.183-.064 1.874.341 3.785.316 5.67z")
                ]), M),
                A2(Da, l([
                    Fa("path1515"),
                    Ha("#dcc06d"),
                    qa("M172.958 63.996c.576-2.08 1.421-3.205 2.552-5.01.699-1.117 1.79-2.49 2.141-3.751 1.072-3.859-2.474-7.203-2.946-10.714-.582 1.018-.413 2.33-.536 3.552-.063-.157-.246-.42-.312-.65-.412 1.489-.282 1.563-1.442 2.404-.636.462-1.188.812-1.75 1.354-.07.063-.069.054.002-.023.112-.045.167.002.166.14-.172.003-.427.159-.79.071-.374 1.385.031 4.909.956 6.132-.109-.901.066-2.236.67-2.671-.112-.042.206-.067.398.031.017-.42.248-.555.014-1.019.252.07.563-.011.848.125-.077-.204-.017-.475-.133-.701 1.707-1.119 3.423.99 3.206 2.689-.307 2.387-2.368 4.528-2.508 7.148")
                ]), M),
                A2(Da, l([
                    Fa("path1517"),
                    Ha("#dcc06d"),
                    qa("M232.499 64.175c-1.518-3.082-4.283-5.965-4.648-9.516-.276-2.708 1.639-4.129 2.176-6.728 1.834-.151 2.095-3.967 2.152-5.339 1.956 2.811 1.49 8.53.674 11.711.007-.532-.124-1.067-.484-1.382-.382.663-.32 1.562-.764 2.15-.349.465-.746.118-1.076.508-.709.84-.596 1.992-.531 3.056.106 1.783.841 3.108 1.607 4.645")
                ]), M),
                A2(Da, l([
                    Fa("path1519"),
                    Ha("#dcc06d"),
                    qa("M204.607 58.454c.941.112 2.259-.002 2.172-1.229 1.531.049 2.479-1.837 3.741-2.499 1.023-.536 2.527-.817 3.692-.751-1.35.385-6.046 2.1-5.876 3.878-.757.218-.526 1.09-1.216 1.329-.607.21-1.836-.789-2.513-.906")
                ]), M),
                A2(Da, l([
                    Fa("path1521"),
                    Ha("#dcc06d"),
                    qa("M185.323 43.997a.375.375 0 0 0-.018.275c-.43-.8-1.208-1.154-2.084-1.043.283-1.821-2.389-1.487-3.413-1.254 1.348-.487 2.432.099 3.559.39 1.781.461 3.54 1.074 4.048 3.065-.538-.701-1.298-1.091-2.092-1.433z")
                ]), M),
                A2(Da, l([
                    Fa("path1523"),
                    Ha("#dcc06d"),
                    qa("M173.611 43.06a5.895 5.895 0 0 0-1.371-.51c-.12.369-.416.595-.394 1.049-.104-.271-.51-.466-.675-.681-1.036 1.12-.5 3.084-.167 4.396-1.429-2.796-1.241-8.274 1.394-10.423-.222.181-.096 2.759-.052 3.156.118 1.054.486 2.254 1.265 3.013z")
                ]), M),
                A2(Da, l([
                    Fa("path1525"),
                    Ha("#dcc06d"),
                    qa("M230.89 33.779c1.203 1.667.537 4.521.202 6.373.917-.597 2.369.16 2.805 1.095.02-.8-.398-1.561-.294-2.371.326.325.616.841.829 1.292-.014-2.042-1.959-4.033-3.007-5.674")
                ]), M),
                A2(Da, l([
                    Fa("path1527"),
                    Ha("#dcc06d"),
                    qa("M197.811 65.964c.432-1.833 1.347-4.815-.43-6.212-1.416-1.114-4.338-.999-6.046-1.123a25.822 25.822 0 0 0-7.286.5c-4.532.973-7.584 4.143-8.517 8.639.193-.036.304-.117.47-.219.164.128.142.335.348.404.126-.036.194-.199.314-.175a2.22 2.22 0 0 0 1.264.661c.114-.183.313-.302.43-.483 1.752.939 1.555-.288 2.669-1.579 1.383-1.603 3.507-3.781 5.644-4.126-.421-.203-.737-.463-1.183-.619 1.443-1.136 4.001-1.591 5.873-1.355-.022.137-.131.14-.143.276 1.028.44 2.421.431 3.5.725-.058-.016-.367-.102-.435-.113 3.325.901 3.283 3.561 3.658 6.174-.056-.387.521-1.378.579-1.854.085-.694-.127-1.27-.144-1.92-.034-1.243.381-2.6-.695-3.55-.015-.014-.031-.026-.047-.039")
                ]), M),
                A2(Da, l([
                    Fa("path1529"),
                    Ha("#dcc06d"),
                    qa("M208.257 61.376c1.591-1.875 5.417-2.107 7.543-2.186 3.643-.135 7.417-.083 10.504 2.127.854.611 1.615 1.352 2.187 2.238.33.515.811 2.864 1.124 3.064-.87-.555-1.964-1.513-2.799-.497-.076-.442-.396-.612-.535-.861-.285.948-1.228 1.864-2.299 1.568-.041-.012-1.075-2.492-1.305-2.785-.74-.934-1.681-1.599-2.696-2.198-2.086-1.234-4.494-.766-6.625.338-.928.482-1.757 1.833-2.67 2.17-.932.346-1.719-.134-2.438.75-.373.458-.375 1.274-.552 1.817-.751-1.417-.548-3.652.205-5.035.102-.18.219-.351.356-.51z")
                ]), M),
                A2(Da, l([
                    Fa("path1531"),
                    Ha("#ccb25c"),
                    qa("M172.378 66.768c-.975-1.899 1.061-4.575 2.038-6.07 1.167-1.785 2.641-3.38 3.061-5.509.258-1.311.842-4.074-.65-4.904-.071 1.553.626 3.951-.798 5.068-.056-.064-.107-.151-.171-.208.018 1.494-.424 3.186-1.06 4.542-.952 2.028-3.281 4.813-2.42 7.216")
                ]), M),
                A2(Da, l([
                    Fa("path1533"),
                    Ha("#ccb25c"),
                    qa("M228.566 50.81c-.221 1.141-.798 2.159-.813 3.35-.013 1.254.525 2.508 1.078 3.62 1.174 2.356 2.559 4.587 3.332 7.093-.78-1.063-1.074-2.946-1.586-4.257-.423-1.087-.855-2.174-.96-3.348-2.188-.126-1.229-5.568-.782-6.726")
                ]), M),
                A2(Fn, l([
                    Fa("XMLID_11_"),
                    Pn("188.783"),
                    Gn("188.533"),
                    Wn("55.772"),
                    Yn("56.896"),
                    Hn("userSpaceOnUse")
                ]), l([
                    A2(Un, l([
                        Fa("stop1536"),
                        Vn("0"),
                        Bn("#f3d48c")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1538"),
                        Vn(".107"),
                        Bn("#eed089")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1540"),
                        Vn(".235"),
                        Bn("#e0c381")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1542"),
                        Vn(".372"),
                        Bn("#c8ae73")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1544"),
                        Vn(".516"),
                        Bn("#a69160")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1546"),
                        Vn(".665"),
                        Bn("#7c6c47")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1548"),
                        Vn(".82"),
                        Bn("#473e29")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1550"),
                        Vn(".975"),
                        Bn("#0a0906")
                    ]), M),
                    A2(Un, l([
                        Fa("stop1552"),
                        Vn("1"),
                        Bn("#000")
                    ]), M)
                ])),
                A2(Da, l([
                    Fa("path1554"),
                    Ha("url(#XMLID_11_)"),
                    qa("M187.869 56.042c.66-.228 1.415-.037 1.762.627-.43.495-1.637.1-2.011-.378")
                ]), M)
            ])),
            A2(Fn, l([
                Fa("XMLID_12_"),
                Pn("234.682"),
                Gn("234.371"),
                Wn("53.984"),
                Yn("55.384"),
                qn("rotate(-10.765 233.253 149.202)"),
                Hn("userSpaceOnUse")
            ]), l([
                A2(Un, l([
                    Fa("stop1557"),
                    Vn("0"),
                    Bn("#f3d48c")
                ]), M),
                A2(Un, l([
                    Fa("stop1559"),
                    Vn(".107"),
                    Bn("#eed089")
                ]), M),
                A2(Un, l([
                    Fa("stop1561"),
                    Vn(".235"),
                    Bn("#e0c381")
                ]), M),
                A2(Un, l([
                    Fa("stop1563"),
                    Vn(".372"),
                    Bn("#c8ae73")
                ]), M),
                A2(Un, l([
                    Fa("stop1565"),
                    Vn(".516"),
                    Bn("#a69160")
                ]), M),
                A2(Un, l([
                    Fa("stop1567"),
                    Vn(".665"),
                    Bn("#7c6c47")
                ]), M),
                A2(Un, l([
                    Fa("stop1569"),
                    Vn(".82"),
                    Bn("#473e29")
                ]), M),
                A2(Un, l([
                    Fa("stop1571"),
                    Vn(".975"),
                    Bn("#0a0906")
                ]), M),
                A2(Un, l([
                    Fa("stop1573"),
                    Vn("1"),
                    Bn("#000")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1575"),
                Ha("url(#XMLID_12_)"),
                qa("M216.007 56.48c.359.415 1.74.376 1.69-.383-.079-1.11-1.73.336-1.69.383z")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1577"),
            Ha("#ccb25c"),
            qa("M197.948 69.92c.719-2.662 2.652-9.283-1.39-10.394-1.65-.453-3.307-.086-4.973-.258-1.636-.168-2.832-1.023-4.441-.697-2.46.497-5.894.695-7.657 2.645-2.224 2.459-3.802 5.957-4.361 9.205-.387 2.253.73 6.286 1.972 8.288 1.353 2.18 4.718 2.622 7.042 2.452 6.864-.502 12.024-4.627 13.808-11.241z"),
            Dn(".4")
        ]), M),
        A2(Da, l([
            Fa("path1579"),
            Ha("#ccb25c"),
            qa("M226.465 77.644c2.15-1.789 3.39-4.585 3.441-7.895.036-2.341-1.864-5.475-3.445-7.011-3.465-3.375-8.899-3.822-13.385-3.238-3.182.414-6.339.61-6.505 4.886-.226 5.76 2.651 11.717 7.838 14.23 2.12 1.028 4.513 1.309 6.827 1.103 2.074-.185 3.841-.921 5.229-2.075z"),
            Dn(".5")
        ]), M),
        A2(On, l([
            Fa("teethUpper"),
            Ha("#e1e2e3"),
            Ua("#967348")
        ]), l([
            A2(Da, l([
                Fa("path1583"),
                Ba(".392"),
                qa("M187.747 104.399a1.5 1.5 0 0 0-.57-.235c-.687 1.335-.687 3.854-.236 5.326.092.295 1.632-.732 1.732-.854.387-.464.477-.851.458-1.447-.023-.78-.512-2.209-1.384-2.79z")
            ]), M),
            A2(Da, l([
                Fa("path1585"),
                Ba(".392"),
                qa("M189.374 109.152c2.657-1.046 1.067-6.681-.486-4.591-.409.549-.773 5.087.486 4.591z")
            ]), M),
            A2(Da, l([
                Fa("path1587"),
                Ba(".392"),
                qa("M193.291 107.858c.648-1.702-.641-4.933-2.293-3.511-.784.673-.806 4.096.355 4.394 1.06.271 1.668-.172 1.938-.883z")
            ]), M),
            A2(Da, l([
                Fa("path1589"),
                Ba(".375"),
                qa("M194.845 103.322c-.6-.094-1.253.164-1.607.848-.462.888-.01 1.993.358 2.875.127.305 1.441 1.944 1.406 2.055.444-1.348 1.474-3.139 1.113-4.604a1.544 1.544 0 0 0-1.27-1.174z")
            ]), M),
            A2(Da, l([
                Fa("path1591"),
                Ba(".392"),
                qa("M198.609 107.718c.768-.643.553-3.401.134-4.178-.71-1.315-2.051-.401-2.378.708-.327 1.102-.308 2.64-.046 3.752 1.125.229 1.848.088 2.29-.282z")
            ]), M),
            A2(Da, l([
                Fa("path1593"),
                Ba(".392"),
                qa("M203.624 107.002c-.162-2.467-.731-6.166-2.386-5.208-1.78 1.028-2.098 3.746-2.021 5.457.057 1.286.24 1.471 1.656 1.656.196.026 2.79.118 2.793.068.022-.238.022-1.012-.042-1.973z")
            ]), M),
            A2(Da, l([
                Fa("path1595"),
                Ba(".392"),
                qa("M219.475 103.685c.169-.125.356-.218.557-.264.755 1.298.88 3.813.508 5.306-.077.3-1.666-.648-1.774-.765-.41-.444-.518-.826-.531-1.422-.016-.779.4-2.23 1.24-2.855z")
            ]), M),
            A2(Da, l([
                Fa("path1597"),
                Ba(".392"),
                qa("M218.094 108.515c-2.708-.91-1.408-6.618.251-4.61.435.527 1.03 5.039-.251 4.61z")
            ]), M),
            A2(Da, l([
                Fa("path1599"),
                Ba(".392"),
                qa("M214.115 107.421c-.735-1.667.389-4.959 2.112-3.624.817.633 1.013 4.049-.132 4.407-1.043.325-1.675-.086-1.98-.783z")
            ]), M),
            A2(Da, l([
                Fa("path1601"),
                Ba(".375"),
                qa("M212.331 102.97c.595-.122 1.26.101 1.65.766.506.863.111 1.99-.211 2.889-.113.311-1.342 2.014-1.301 2.124-.512-1.324-1.629-3.061-1.346-4.541a1.543 1.543 0 0 1 1.208-1.238z")
            ]), M),
            A2(Da, l([
                Fa("path1603"),
                Ba(".392"),
                qa("M208.796 107.553c-.8-.604-.725-3.37-.347-4.167.642-1.35 2.028-.506 2.412.585.382 1.085.441 2.623.234 3.747-1.111.285-1.841.181-2.299-.165z")
            ]), M),
            A2(Da, l([
                Fa("path1605"),
                Ba(".392"),
                qa("M203.751 107.094c.036-2.472.416-6.196 2.118-5.324 1.83.936 2.285 3.635 2.295 5.347.008 1.287-.164 1.481-1.57 1.739-.194.036-2.777.26-2.786.211-.033-.238-.071-1.01-.057-1.973z")
            ]), M)
        ]))
    ]), Zn = l([
        A2(On, l([
            Fa("FemurRight")
        ]), l([
            A2(Da, l([
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M190.045 563.119c-6.429-13.702-10.378-27.696-15.011-42.17-6.567-20.521-12.748-41.185-18.673-61.855-2.334-8.146-3.671-16.238-6.088-24.325-2.152-7.193-6.471-15.421-4.544-23.134-1.611 3.339-.641 11.489 1.7 14.166.2-2.5.714-4.924.786-7.46.12-4.177-1.453-7.591-.323-11.749.764-2.819 4.466-11.608 8.868-10.511-2.788-.742-7.337.828-9.508 2.823 3.381-4.315 8.504-.984 12.057-4.542 1.681-1.684 2.375-3.973 2.156-6.35-.424-4.606-6.979-12.549-12.196-11.915-5.491.668-5.055 8.206-7.567 11.396-1.437 1.827-5.069 3.538-7.295 3.674 1.399-3.479-4.642-1.622-6.133-1.01-3.697 1.519-2.798 2.865-3.377 6.348-.536 3.215-2.971 6.091-2.78 9.298.208 3.493 3.143 5.325 4.726 8.207 3.908 7.111 6.2 15.041 8.583 22.904 2.784 9.185 5.647 18.028 7.102 27.424 1.573 10.152 5.258 19.811 7.566 29.793 2.672 11.555 6.159 23.231 7.699 34.939 1.418 10.777 1.269 23.275-.358 34.055-.892 5.913-5.612 11.212-5.298 17.324.209 4.056 5.092 8.72 9.239 8.722 3.656.002 6.687-1.727 10.104-2.789 5.073-1.577 8.838.337 13.658.087 4.481-.232 7.142-2.827 9.487-6.514 4.303-6.766-1.852-11.022-4.58-16.836z")
            ]), M),
            A2(Da, l([
                Ha("#dcc06d"),
                qa("M158.221 583.635c2.483 1.407 3.886-.451 6.053-.409-.118.359-.223.663-.287 1.044.818.345 1.89.317 2.812.011-3.842 4.32 7 3.305 7.537-.396.455-3.126-8.432-8.482-11.047-8.277.219-2.989-3.873-3.483-5.719-4.665 1.463-5.126 3.954-12.842 3.44-18.044-.727 2.688-2.123 11.944-.382 14.565 1.457 2.192 3.868 1.13 5.765.733.547 3.036 6.002 5.899 8.278 7.563 3.695 2.698 9.939 5.591 12.889.26.723-1.307 1.083-4.738.724-6.082-.492-1.833-2.622-4.774-4.253-2.072 2.858-4.283-3.612-12.904-5.141-16.852-1.439-3.714-3.134-7.051-3.583-11.042-.32-2.836-.329-5.582-.986-8.383-3.094-13.179-9.463-25.313-11.362-38.908-1.543-11.056-5.296-21.408-9.388-31.808-3.67-9.333-4.873-19.382-8.303-28.713-.695-1.893-1.229-6.083-3.352-6.681.242-.354.948-.956 1.296-1.124 1.637 1.122 1.104 3.58 3.163 4.322.473-3.04-2.575-6.763-4.335-8.875-3.412 2.053-2.704-5.251-2.822-6.794a10.432 10.432 0 0 1-.613-.133c1.419-2.65-1.884-3.049-2.222-4.92-.26-1.443 1.701-3.423 1.749-5.003.041-1.332-.611-3.482-1.309-4.53 1.059 1.591 2.681 4.092 4.463 4.909 1.372.629 2.633-.395 3.458-1.371 1.059-1.25 2.165-2.461 3.521-3.398.41-.283 4.765-2.58 5.004-1.797.27.883-1.635 1.647-2.106 2.193-1.001 1.164-1.91 2.455-2.592 3.835-1.017 2.058-1.749 4.839-1.575 7.15.162 2.134.617 4.348.741 6.493.062 1.04-.055 2.053-.233 3.059-.222 1.256-.215 3.152-.712 4.24-.98-2.018-1.321-4.849-1.47-7.083-.08-1.167.046-2.569.395-3.674.192-.608.701-1.522.13-2.081-.571.325-.759 1.647-.934 2.286-1.868 6.859 1.412 13.176 3.732 19.439 2.924 7.894 3.206 16.534 6.098 24.603 3.722 10.377 5.516 20.812 8.235 31.461 4.222 16.536 9.566 32.468 14.661 48.711 2.471 7.881 6.154 15.248 9.102 22.898 2.671 6.93 10.591 11.961 5.84 20.231a11.029 11.029 0 0 1-8.048 5.399c-1.098.149-10.296-2.238-9.396-3.067-2.138 1.972-3.051 3.601-6.169 4.513-2.978.87-6.135.5-8.944-.694-2.393-1.017-5.729-1.89-6.942-4.446-1.387-2.925.167-7.477 2.229-9.68.164 4.328 7.56 4.596 5.512 9.099-.371-1.718-2.855-5.782-5.109-4.438-2.619 1.557.989 5.562 2.507 6.423z")
            ]), M),
            A2(Da, l([
                Ha("#dcc06d"),
                qa("M134.853 392.979c-.043.943.066 1.945.45 2.811.661-3.814 6.281-4.07 7.393-7.803-1.058 1.365-3.187 2.527-4.698 3.351-1.25.682-2.968 1.344-4.399 1.417.244-.687.108-1.373-.42-1.9-.791-.792-1.319-.554-2.173-.074.95.127 1.299.544.401 1.126-1.196.776-2.378.799-3.361 1.967.786-1.213 5.401-2.873 6.075-.792")
            ]), M),
            A2(Da, l([
                Ha("#dcc06d"),
                qa("M132.108 409.464c.273 1.686-.852 3.86-2.279 4.666-.279-.404-1.382-1.179-1.866-.739-.489.443.131 1.702.352 2.104-.486-2.493-2.711-3.718-3.794-5.847 1.371-.31 2.309 2.025 3.574 2.248.783.138 1.708-.219 2.359-.62.401-.246 1.747-1.241 1.654-1.812z")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M146.074 411.793c-.275 1.815-.639 3.301-.54 5.153.098 1.826.456 3.798 1.082 5.514-.182-2.291-.556-4.563-.407-6.882.042-.665.361-1.41.37-2.041.011-.673-.438-1.213-.505-1.878")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M153.941 396.362c-1.682.721-2.845 2.158-3.961 3.549.866-1.506-1.486-.333-1.892-.136-1.471.717-2.793 1.518-4.006 2.63-.382.351-.914 1.33-1.492 1.352-.379.014-1.031-.533-1.365-.708-.929-.485-1.572-.996-2.347-1.671 1.021.936 1.554 1.58 3.035 1.469 3.166-.234 4.689-3.619 7.371-5.031 1.517-.797 3.181-.857 4.657-1.454z")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M188.55 578.677c.863-1.372 3.047-6.863.545-7.567 1.375.388-1.801-9.151-1.878-9.623.548.247.573.374 1.046-.061.787 1.925 1.806 3.745 2.97 5.468 1.319 1.947 3.416 3.313 3.479 5.902-1.144.014-2.211 4.776-2.882 5.832-2.366 3.727-7.056 4.677-11.149 4.247-.992-.105-2.25.192-3.175-.003-1.756-.375-2.982-2.325-4.296-3.388-1.222-.988-2.49-1.554-3.857-2.264 2.683 1.896 6.981 5.03 10.301 5.367 3.061.312 7.232-1.263 8.896-3.91z")
            ]), M)
        ])),
        A2(On, l([
            Fa("FemurLeft")
        ]), l([
            A2(Da, l([
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M248.121 579.791c-.447 2.931-1.395 5.811-3.142 8.059-1.589 2.044-3.415.892-5.635.716-2.531-.199-4.677-1.898-7.311-2.132-3.671-.324-7.22.529-10.447 2.28-2.515 1.364-5.358 2.271-8.169 2.345.365 2.138-2.519.265-3.076-.352-1.459-1.616-2.085-3.382-2.962-5.299-.527-1.149-.997-1.91-.907-3.222.096-1.366.194-2.734.307-4.1.103-1.235.36-2.392.207-3.645-.088-.716-.239-1.483-.054-2.197.182-.692.708-1.234 1.101-1.813 1.083-1.604 2.146-3.204 3.097-4.892 1.922-3.412 3.535-6.986 5.115-10.565 1.83-4.142 3.393-8.275 4.873-12.533.917-2.641 1.613-5.185 2.332-7.88 2.053-7.713 5.059-15.053 7.041-22.806 2.077-8.129 3.568-16.411 5.335-24.619 1.607-7.456 4.435-14.527 6.915-21.736 1.327-3.852 2.264-7.851 3.682-11.707a63.123 63.123 0 0 0 2.007-6.521c.78-3.121.941-6.193 1.562-9.338.744-3.757 2.086-7.361 3.329-10.97.555-1.61 1.016-3.235 1.591-4.846.905-2.529.83-4.528.879-7.107.542 1.254.54 2.815.237 4.237-.579 2.727-1.628 5.657-2.656 8.25-.53-1.293-.307-2.682-.571-4.23a16.81 16.81 0 0 0-1.352-4.278c-.257-.537-1.055-1.425-1.168-1.936-.343-1.554 1.295-2.237 2.055-3.303 1.651-2.321 2.235-6.321.618-8.793-1.378-2.108-3.079-4.518-5.44-5.573-2.277-1.017-5.55-1.07-7.147-3.181-4.536-6.002.391-10.687 4.748-14.668 2.527-2.309 6.149-3.723 9.397-1.729 3.538 2.171 1.407 7.326-.405 9.81 1.064-2.195 2.18-3.361 2.304-5.925.165-.062.35-.112.521-.153 1.078 2.056 1.653 4.628 3.371 6.432 1.972 2.074 5.48 3.941 8.417 3.622-.982.095-3.941-.268-4.259-1.558-.168-.687.807-2.113.825-2.987 2.284-.798 5.554-1.411 7.681.168 1.04.772 1.182 1.8 1.687 2.865.56 1.173 1.482 2.044 2.329 2.898-1.066 1.481-.213 4.421.324 5.999.78 2.289 2.534 3.888 1.726 6.472-.854 2.725-3.205 4.583-4.498 7.058-3.756 7.193-5.878 15.168-8.096 23.081-2.15 7.677-4.431 15.339-5.833 23.196-.66 3.683-.623 7.289-1.727 10.899-1.116 3.659-2.764 7.124-4.118 10.695-1.879 4.949-3.212 10.009-4.587 15.11-1.417 5.258-2.08 10.63-3.52 15.896-.753 2.761-1.117 5.516-1.922 8.245-.937 3.187-2.118 6.323-2.438 9.654-.353 3.703-.529 7.455-.613 11.169-.057 2.622.581 5.093.675 7.647.111 3.005.106 5.896.397 8.92.202 2.1.601 3.99 1.516 5.894.881 1.829 2.101 3.011 3.355 4.529 1.077 1.308.784 3.221.822 5.063a31.393 31.393 0 0 1-.325 5.385z")
            ]), M),
            A2(Da, l([
                Ha("#dcc06d"),
                qa("M241.91 557.729c-.963-4.215-1.149-8.277-1.236-12.578-.053-2.668-.275-5.354-.348-8.006-.085-3.018.962-6.085 1.246-9.093-.259 2.739-1.074 5.492-1.489 8.225-.403 2.645-1.393 5.15-1.896 7.772-.449 2.344-.561 4.064-2.061 6.056-1.478 1.969-3.399 3.869-5.233 5.495-1.735 1.535-5.307 3.282-6.157 5.131-1.049 2.275-.111 5.24-1.762 7.287-1.733 2.147-4.929 3.705-7.089 5.446 1.021 1.223-2.192 2.839-3.144 3.08-.094-1.291-.909-2.311-1.225-3.545-.224-.872.248-1.944-1.25-1.593-.089-.777.241-2.019.868-2.499.759.572 1.715.665 2.009 1.683-.092-.575-.572-.721-.751-1.178-.234-.594-.182-.642-.243-1.243-.104-1.053.548-2.035.307-3.04-1.461.961-2.419 3.825-3.451 5.296-.785 1.119-1.384 2.511-1.867 3.732 3.679 3.119 3.744 8.318 4.735 12.549-.458-3.41 1.698-6.798 3.719-9.203 1.515-1.802 2.815-3.845 4.776-5.219 1.254-.88 2.71-1.326 4.054-2.085 2.663-1.503 4.79-4.659 7.02-6.778 1.888-1.795 3.852-5.395 6.281-6.338.581 1.242-.65 3.341-.477 4.836.256 2.182 2.057 3.913 3.063 5.779.821 1.524 1.901 4.114 1.483 5.891-.34 1.438-1.03 1.229-2.212 1.717 2.62 2.796 2.46 7.39-.865 9.419-2.041 1.245-3.896 1.716-6.112 1.293-2.185-.416-4.071-.18-6.179.596 2.855-.678 5.518-.16 8.35.382 2.099.401 4.266 1.403 6.414 1.299 2.367-.117 3.124-.926 4.273-2.911 1.841-3.176 2.438-7.348 2.101-10.961-.406-4.344-3.245-7.082-4.619-11.037-.608-1.752-.61-3.814-1.033-5.657z")
            ]), M),
            A2(Da, l([
                Ha("#dcc06d"),
                qa("M265.474 416.94c.656-1.637.897-2.811 2.113-3.728 1.38-1.044 2.847-1.615 4.038-2.965.825-.937 1.392-2.023 2.093-3.041a21.033 21.033 0 0 1-1.725 3.146c-1.079 1.646-3.523 3.602-3.995 5.539-.354 1.457 1.198 2.114.382 3.758-.821 1.659-2.56 2.684-3.02 4.635-.489 2.074-.324 4.512-.676 6.659-1.387 8.438-4.768 16.445-6.909 24.696-.829 3.192-1.58 6.406-2.166 9.652-.555 3.072-.485 5.761-1.425 8.808-.796 2.564-1.446 5.17-2.283 7.726-2.264 6.918-4.416 13.813-7.167 20.56-.434 1.064-1.692 2.914-1.715 4.106-.018.944.684 1.46.654 2.875-.126 6.031-3.095 12.258-2.438 18.3.643-1.302.881-3.353 1.246-4.85.751-3.104 1.427-6.217 2.173-9.326.841-3.496 2.029-6.879 3.038-10.327 1.987-6.795 3.628-13.717 5.784-20.474 2.312-7.24 5.37-14.361 7.049-21.735.688-3.025.994-5.981 1.165-9.029.179-3.221 1.86-6.482 2.782-9.538.524-1.733.736-3.459 1.232-5.197.712-2.497 1.402-5.003 2.178-7.481.8-2.555 2.073-5.057 2.709-7.644.468-1.896.663-3.306 1.695-5.049a92.181 92.181 0 0 1 4.647-7.077c1.327-1.832 2.033-3.06 1.313-5.416-.595-1.95-1.805-3.577-2.216-5.461-.385-1.75-.147-3.479-1.138-5.024-1.097-1.706-3.32-3.767-5.19-4.513-1.882-.751-3.161 1.041-4.335 2.416 1.248-.606 6.269-2.013 6.241.77-.026 2.776-7.653 1.217-9.081.506-1.421-.705-2.52-1.588-3.703-2.602-.874-.749-2.455-1.279-2.7-2.515-.683.571-.926 1.415-1.391 2.158-1.301 2.083-2.858 2.785-5.059 3.677-.769.312-1.513.521-2.319.687-1.121.228-2.563.179-3.571.693 1.964.709 5.086 1.333 6.135 3.356-.357-.636-1.915-1.418-1.65-2.423.232-.879 1.681-.955 2.391-.892.248.021 2.676 1.091 2.097 1.327 1.691-.686 1.901-2.531 4.032-2.989 1.729-.372 2.717.06 3.94.858-.002-.001.427.583.542.677.164.134.563-.006.778.141.353.239.906.573 1.063.959 1.145 2.829-1.871 5.837-4.345 6.687-2.376.814-2.525-.884-3.943-2.063-.683 1.225.209 3.95.254 5.392.074 2.589-.069 3.989-1.297 6.378-.476.924-2.084 2.588-2.304 3.441-.481 1.858 2.587 4.251 2.507 6.558.71-1.718.986-3.297 1.149-5.111.119-1.371-.104-2.763-.05-4.146-.012.366.896 1.396 1.064 1.816.267.659.422 1.345.476 2.053.115 1.509-.344 2.894-.681 4.336-.307 1.3-.384 2.386-.992 3.597-.759 1.515-1.703 2.907-2.283 4.512-.702 1.941-1.256 4.111-1.794 6.146-.486 1.846-.569 3.427-.598 5.312-.017 1.152-.35 2.474.02 3.564 1.96-7.658 4.599-15.064 6.778-22.669.535-1.875.938-3.854 1.396-5.75.487-2.036-.232-4.147-.271-6.213-.03-1.589-.805-5.345.471-6.578.666-.642 1.976-.969 2.754-1.538 1.503-1.094 1.866-2.392 2.596-3.958.304-.654.465-2.068.831-2.566 1.796-2.451 9.72-.534 8.128 3.051-1.44 3.245-5.011 4.308-6.909 7.098-.9 1.328-.396 2.825-.378 4.388.03 2.292.216 4.608-.217 6.874z")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M256.603 385.524c-.362 1.962-.844 4.162-2.156 5.738-.968 1.167-2.568 1.862-3.742 2.729 2.672-1.412 4.372-3.271 6.513-5.254.299.577.859 1.087 1.425 1.518.068-.857-.598-1.214-.96-1.928-.375-.742-.369-2.232-1.077-2.624")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M266.698 389.245c-.834.311-2.106 2.31-1.514 3.258.324.52 1.402.625 1.944.779-1.047-.839-1.634-2.259-.6-3.498")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M254.852 412.566c.109-.282.165-.6.267-.888-.447.413-1.442 1.228-1.642 1.812-.34.979.404 1.728.696 2.717.604 2.059.066 3.959.34 5.969.697-3.256 2.182-7.063.149-10.142")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M276.408 400.306c-.328 1.152-1.103 2.147-1.52 3.237 1.023-.573 2.128.483 2.697 1.206 1.042 1.317.608 1.93-.303 3.219-.658.932-1.715 1.664-2.306 2.555-1 1.506-1.863 3.835-2.358 5.54 1.194-2.406 3.097-4.705 4.515-7.021.535-.874 1.466-1.925 1.684-2.926.495-2.256-2.346-3.46-2.403-5.632")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M241.524 560.032c-.029 1.771.184 3.65.648 5.359.353 1.302.378 2.893.937 4.094.364.786 2.956 2.733 1.572 3.208-.016 1.596-.113 2.701-2.065 2.508 1.007.505 2.394 1.024 3.521 1.021.278 2.467-.575 5.075-1.751 7.225-.962 1.762-2.049 1.94-4.102 2.225.111.218.086.457.165.646-1.657.214-2.419-.343-3.729-.933-1.263-.566-2.472-.416-3.799-.526-3.436-.287-6.813-.68-10.118.746 1.589.201 3.83-.799 5.487-1.023 1.727-.231 3.557.055 5.2.653 1.619.588 3.652 3.03 5.228 3.137.909.061 1.109-.854 1.776-1.007.788-.179 1.502.377 2.338.186 1.645-.379 2.508-3.332 3.059-4.763.826-2.15 1.414-4.447 1.655-6.773.162-1.589.766-5.091-.491-6.406-.161-.169-.775-.046-1.002-.229-.381-.312-.602-.685-.953-1.026-.557-.536-1.057-1.072-1.425-1.744-1.126-2.047-1.054-4.313-1.79-6.403")
            ]), M),
            A2(Da, l([
                Ha("#ccb25c"),
                qa("M213.84 578.503c-1.16 1.426-1.787 3.467-2.188 5.225 3.988-6.23 10.892-10.151 15.189-16.183a118.64 118.64 0 0 1-8.938 7.303c-1.603 1.187-3.989 3.755-5.479 4.4")
            ]), M)
        ]))
    ]), Qn = l([
        A2(On, l([
            Fa("FibulaRight")
        ]), l([
            A2(Da, l([
                Fa("path421"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M161.602 622.69c-.275-2.346-.951-4.168-2.552-3.871.797.265 1.891.255 2.705.294-.374-4.057-3.704-10.944-7.75-12.409-.174 2.168-1.705 4.22-2.235 6.392-.67 2.753.531 4.255 1.512 6.732.391-.027.918.146 1.314.116-.696 10.504.201 22.204 2.567 32.567 2.996 13.12 2.502 26.338 4.36 39.64.993 7.099 1.341 14.367 2.704 21.404 1.083 5.585 2.419 11.185 2.251 16.871-.142 4.861-1.109 10.005-.698 14.851.377 4.429.298 7.965-1.021 12.386-.709 2.374-.367 3.96.323 6.643 1.3.114 4.856-1.633 6.024-2.459 1.78-1.258 2.252-2.554 2.514-4.979.603-5.566-1.39-10.995-.722-16.415.583-4.72-.384-9.293-.726-13.989-.352-4.823-.855-9.8-1.092-14.573-.237-4.777-.902-9.389-1.412-14.106-.859-7.952-1.591-15.354-3.149-23.225-1.656-8.368-2.897-16.83-3.368-25.354-.333-6.037-.686-12.204-1.36-18.238-.367-3.285 1.058-9.483-2.02-11.897 3.647-.181 1.972-5.425.975-7.404-1.183-2.347-3.372-8.546-6.07-5.05.289.063.517-.041.688-.313")
            ]), M),
            A2(Da, l([
                Fa("path423"),
                Ha("#dcc06d"),
                qa("M156.08 610.236c-1.864 1.217-2.291 3.849-1.457 5.695.34-.112.713-.165 1.045-.298-.342 1.742 1.001 2.34 2.437 2.471-2.682-.242-3.931 1.899-5.345-1.877-1.108-2.958.063-6.575 2.506-8.458.489.687 1.159 1.394 1.529 2.108")
            ]), M),
            A2(Da, l([
                Fa("path425"),
                Ha("#dcc06d"),
                qa("M161.086 635.269c.28 3.864-1.332 7.653-.733 11.437.505 3.187 1.645 6.415 2.162 9.56.248-3.411-.544-6.938-.722-10.337-.175-3.338 1.014-8.397-.35-11.376")
            ]), M),
            A2(Da, l([
                Fa("path427"),
                Ha("#dcc06d"),
                qa("M163.589 700.708c2.303 8.906 4.048 18.152 4.927 27.186.749 7.691-.353 17.322 2.262 24.558-1.044-2.758-1.563-4.041-2.899-.972-1.217 2.798-1.625 6.267-2.519 9.201 1.925-11.97 2.222-24.375.724-36.372-.558-4.463-1.449-8.801-2.216-13.23-.621-3.589-2.634-11.246-.27-14.533.776 2.998.981 6.424 1.422 9.526")
            ]), M)
        ])),
        A2(On, l([
            Fa("FibulaLeft")
        ]), l([
            A2(Da, l([
                Fa("path2361"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M239.479 620.989c.32-2.339 1.032-4.147 2.628-3.819-.802.25-1.896.217-2.711.24.457-4.05 3.922-10.868 7.996-12.251.132 2.17 1.621 4.253 2.106 6.436.617 2.765-.616 4.242-1.646 6.7-.388-.036-.919.127-1.315.09.486 10.516-.643 22.194-3.217 32.509-3.254 13.059-3.023 26.284-5.148 39.544-1.133 7.077-1.627 14.337-3.131 21.347-1.192 5.563-2.641 11.135-2.585 16.823.045 4.863.908 10.024.401 14.862-.466 4.42-.457 7.957.771 12.402.663 2.389.288 3.968-.454 6.636-1.301.087-4.823-1.73-5.975-2.579-1.755-1.293-2.2-2.598-2.413-5.026-.493-5.579 1.609-10.966 1.049-16.398-.488-4.73.568-9.283 1.004-13.972.448-4.815 1.052-9.781 1.383-14.548.332-4.774 1.09-9.371 1.692-14.078 1.019-7.934 1.896-15.317 3.612-23.156 1.822-8.333 3.23-16.77 3.873-25.281.452-6.029.928-12.188 1.723-18.207.431-3.277-.87-9.502 2.257-11.855-3.643-.252-1.864-5.463-.828-7.421 1.229-2.324 3.543-8.478 6.169-4.93-.288.059-.514-.05-.679-.326")
            ]), M),
            A2(Da, l([
                Fa("path2363"),
                Ha("#dcc06d"),
                qa("M245.246 608.648c1.841 1.253 2.214 3.894 1.345 5.723-.34-.118-.71-.179-1.04-.316.308 1.746-1.047 2.318-2.484 2.42 2.686-.189 3.893 1.978 5.381-1.77 1.167-2.936.067-6.576-2.339-8.507-.502.677-1.187 1.369-1.57 2.078")
            ]), M),
            A2(Da, l([
                Fa("path2365"),
                Ha("#dcc06d"),
                qa("M239.742 633.574c-.356 3.858 1.18 7.68.505 11.449-.569 3.177-1.772 6.382-2.353 9.516-.18-3.416.683-6.925.931-10.321.238-3.333-.85-8.415.573-11.365")
            ]), M),
            A2(Da, l([
                Fa("path2367"),
                Ha("#dcc06d"),
                qa("M235.934 698.951c-2.479 8.86-4.408 18.07-5.467 27.082-.902 7.677.007 17.327-2.751 24.508 1.099-2.736 1.642-4.008 2.916-.914 1.162 2.823 1.501 6.299 2.336 9.251-1.688-12.006-1.734-24.415.002-36.379.645-4.451 1.625-8.771 2.479-13.186.692-3.575 2.856-11.189.558-14.523-.834 2.981-1.106 6.402-1.61 9.497")
            ]), M)
        ]))
    ]), Kn = l([
        A2(On, l([
            Fa("HumerusLeft")
        ]), l([
            A2(Da, l([
                Fa("path1663"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M298.512 262.902c.449 5.549.893 11.124.09 16.665-.667 4.608-.892 9.146-1.427 13.792-.171 1.481-.404 2.972-.603 4.448-.169 1.243-.754 2.29-1.264 3.459-.269.621-.618 1.2-.547 1.908.062.614.581 1.474.932 2.007.564.869 1.386 1.567 2.382 1.883 1.173.371 1.915-.101 3.021-.149.094 1.358-.271 3.074.573 4.272 1.165 1.651 3.25.712 4.575-.19.71-.484 1.424-1.051 1.969-1.719.64-.788 1.151-1.754 2.156-2.158 1.832-.734 3.333.548 5.093.01 1.726-.527 2.043-1.723 3.57-2.452 2.468-1.177 6.786.12 7.84-3.029.715-2.144-1.13-3.043-1.774-4.353-1.621-3.297-1.808-7.146-3.444-10.446-1.461-2.952-3.702-5.475-5.145-8.437-1.532-3.15-3.038-6.241-4.052-9.611-2.147-7.148-3.212-13.818-3.709-21.226-.348-5.183-.849-10.305-.909-15.548-.102-8.981-.392-17.978-1.521-26.897-.961-7.572-4.36-16.054-3.501-23.658.405-3.585.736-6.836-.94-9.724-1.801-3.1-8.207-3.128-6.485 1.394-.997-2.616-.178-4.932-3.298-5.861-4.5-1.34-10.09 1.195-13.038 4.605-1.866 2.159-3.217 6.092-2.651 8.937 1.016 5.109 5.755 2.266 8.214 5.425.949 1.221 1.139 3.47 1.813 4.887 1.106 2.332 2.413 4.425 3.239 6.904 1.719 5.162 2.218 10.641 2.938 16.005 2.172 16.217 4.595 32.598 5.903 48.857z")
            ]), M),
            A2(Da, l([
                Fa("path1665"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M288.564 177.18c1.997-1.209 3.275-2.328 4.585-5.012 4.341-8.914-9.837-5.594-13.547-2.608-3.518 2.827-6.491 10.381-2.242 13.866.548.449 5.847 2.106 5.858.958.036-3.076.987-4.725 3.635-6.219.627-.354 1.194-.673 1.711-.985z")
            ]), M),
            A2(Da, l([
                Fa("path1667"),
                Ha("#dcc06d"),
                qa("M293.839 170.015c-.777 1.212-1.535 2.447-1.323 3.887.642.04.987.476 1.687.453-.874 2.181 1.811 5.63 2.535 7.867 1.302 4.015 1.437 8.23 2.01 12.335.937 6.719 1.378 13.625 2.116 20.409.979-1.853-.48-8.27-.639-10.77-.243-3.818-.727-7.608-.765-11.445-.041-4.012-.003-8.13-.616-12.105-.188-1.218-2.268-7.944 1.07-4.01.963 1.137.872 3.625 1.13 5.069.32-2.745 1.949-5.86.706-8.553-1.196-2.598-6.185-3.482-6.443.198-.589-2.378-1.996-1.928-2.862-.103")
            ]), M),
            A2(Da, l([
                Fa("path1669"),
                Ha("#dcc06d"),
                qa("M311.451 304.422c-1.522 1.395-3.725 1.56-5.008 3.723 1.908-2.512 5.226-1.999 7.508-2.454 2.352-.469 2.713-1.674 4.538-2.568 1.232-.604 3.089.479 4.355-.677-2.114.052-4.357-.23-4.566-2.534-.173-1.895 1.637-2.592 2.015-3.952.52-1.841-1.072-4.022-1.004-5.912.2 1.211.857 3.147 1.666 4.11.102-.198.362-.462.378-.785.73.955 1.341 2.057 2.092 3.027.454-.232.753.23 1.056.622-1.295-1.993-1.527-4.509-2.603-6.592-1.46-2.832-3.164-5.406-4.464-8.293-1.495-3.327-3.521-6.354-4.806-9.793-2.827-7.59-3.467-14.779-4.717-22.705-.551-3.486-1.416-7.129-1.551-10.642-2.297 7.455-.084 16.895.358 24.551.258 4.479 1.151 8.65 1.986 13.045.37 1.945.494 4.802 1.524 6.503-.205-1.184-1.18-6.936.198-6.941 1.135-.005 2.858 3.592 3.284 4.377 1.001 1.841 1.979 4.012 2.485 6.047.544 2.19 1.316 4.431 1.35 6.708.011.731.061 1.865-.879 1.946-.8.068-.973-.769-1.29-1.26-.725-1.125-1.598-2.146-2.368-3.239-.692-.983-1.283-2.214-1.88-3.159.411.654.505 1.842.792 2.592.355.916.773 1.804 1.189 2.692.842 1.799 1.886 3.69 2.238 5.665.207 1.144.787 3.634.306 4.754-.58 1.351-2.96 1.616-4.182 1.144z")
            ]), M),
            A2(Da, l([
                Fa("path1671"),
                Ha("#ccb25c"),
                qa("M311.549 292.796a13.07 13.07 0 0 0-.412-.63c-.866-1.25-1.211-2.559-1.909-3.851.646 1.693 1.502 3.28 1.956 5.05.188.726.548 1.73.505 2.482-.017.289-.4.757-.382.971.084.859.855 1.595.583 2.674-.605 2.417-2.592 1.187-3.127-.447-.46-1.402.018-3.457-.562-4.707.513 1.109-.08 3.199-.199 4.401-.088.858-.378 1.748-.357 2.612.026 1.111.187 1.061 1.241 1.227 1.084.168 2.423.214 3.449-.241 3.111-1.381 1.696-4.927.583-7.042-.446-.847-.868-1.689-1.369-2.499z")
            ]), M),
            A2(Da, l([
                Fa("path1673"),
                Ha("#ccb25c"),
                qa("M301.58 303.891c-.804-.762-.591-3.809-.559-4.913.016 1.349.32 3.785-.364 5.001-.259.464-.617.911-1.295.521-.144-.082-.911-.99-.454-1.095-3.148.727-2.104-1.826-1.92-3.71-.115 1.094-1.344 2.183-1.585 3.273-.217.979.391 1.723 1.144 2.272 1.003.734 2.24 1.156 3.47.866.563-.132 2.54-1.517 2.97-.664-.493-.98-.861-2.026-.886-3.117-.187.496-.293 1.067-.521 1.566z")
            ]), M),
            A2(Da, l([
                Fa("path1675"),
                Ha("#ccb25c"),
                qa("M321.095 303.456c2.423-.62 5.552-3.51 3.109-5.969 3.575 1.964 1.116 6.271-2.396 5.604")
            ]), M),
            A2(Da, l([
                Fa("path1677"),
                Ha("#ccb25c"),
                qa("M296.372 172.847c-2.59 1.753-1.744 4.324-1.092 6.891.831 3.276 1.132 7.061 2.379 10.152-.131-3.674-.831-7.431-1.138-11.072-.165-1.903-.917-4.193-.149-5.971")
            ]), M)
        ])),
        A2(On, l([
            Fa("HumerusRight")
        ]), l([
            A2(Da, l([
                Fa("path1723"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M103.302 252.136c.528-1.607 1.159-3.144 1.735-4.758 5.387-15.065 7.826-31.198 14.124-46.038 1.429-3.366 2.402-6.956 4.455-10.031 1.574-2.358 3.904-4.184 5.739-6.159 4.349-4.679 2.861-11.644-2.782-14.67-6.795-3.645-10.923-1.486-16.448 2.798-6.44-1.523-6.146 7.97-6.174 11.872-.03 4.136-.001 8.859-.597 12.929-1.759 11.999-3.774 24.344-7.438 35.896-2.137 6.741-5.718 12.973-7.92 19.597-3.716 11.178-7.78 22.088-12.568 32.845-1.657 3.72-5.607 6.393-7.161 10.032-1.217 2.851-.338 5.11 1.768 7.373 2.075 2.228 3.943 1.158 6.424.759 2.146-.345 2.381 2.076 4.353 2.622 1.385.383 2.877-.245 4.234.114 1.449.383 2.959 1.714 4.338 2.355 1.06.493 2.519.609 3.572.001 1.437-.83 1.213-3.024 2.31-4.128 1.547-1.557 3.645.577 5.28-1.322 1.518-1.763 1.177-4.571 2.032-6.629-.24.577-6.527-7.297-6.826-8.675-.356-1.645.261-2.739.475-4.336.365-2.716-.087-5.512-.049-8.247.113-8.091 4.566-15.461 6.804-23.163.1-.351.208-.695.32-1.037z")
            ]), M),
            A2(Da, l([
                Fa("path1725"),
                Ha("none"),
                Ua("#967348"),
                Ba(".322"),
                qa("M120.136 177.361c-3.004 4.813-1.293 11.668-2.531 17.044 1.873-3.228-.837-9.583 2.084-12.341 1.023 1.212 2.869.578 2.743-.769 1.578-2.488 4.299.344 5.865 1.026.493-3.004-3.422-12.815-7.179-7.954-1.826-2.731-5.49-3.134-7.769-.711-.837.889-1.466 2.088-1.342 3.345.041.406 1.678 3.439 1.995 2.954-.182.278-.305.697-.52.983 2.893 2.35-1.04 9.763.217 11.085")
            ]), M),
            A2(Da, l([
                Fa("path1727"),
                Ha("#dcc06d"),
                qa("M70.43 296.439c3.268-1.71 5.417.362 7.39 2.739 2.478-.576 3.479-.545 5.651.771.911.551.604.854 1.597.943.81.073 1.715-.602 2.623-.601 2.95.003 6.302 5.072 3.869 7.507.125.025.213.408.213.504.229-.217.731-.52.959-.743.067.914-.539 1.645-1.239 2.096.795-2.249-1.98-3.044-3.788-3.618 1.565 1.66 3.377-.526 2.626-2.261-.566-1.311-2.686-1.785-3.888-1.864.092-.14.328-.383.415-.483-1.173-.769-2.211.169-3.413.16-.434-.004-1.885-1.749-3.012-1.728-1.517.03-2.793 1.037-3.1 2.523-.288-.036-.439-.164-.753-.172a57.953 57.953 0 0 0-.796 2.691c-.629-1.536-.141-8.272-3.157-7.07-.093-1.755-1.696-2.092-3.271-1.396")
            ]), M),
            A2(Da, l([
                Fa("path1729"),
                Ha("#dcc06d"),
                qa("M81.212 273.961c-2.921 6.839-6.089 13.585-9.744 20.206 1.829-3.313 5.737 1.146 5.12 1.869 2.135-2.504 3.086-1.001 5.524.374-4.682-8.115-2.27-12.024.853-19.889.083.593.271.797.419 1.295 1.708-1.719 2.467-5.924 3.139-8.295.89-3.143 1.976-6.434 2.43-9.652.784-5.541 2.547-11.665 4.398-16.879-4.016 10.463-7.803 20.821-12.139 30.971z")
            ]), M),
            A2(Da, l([
                Fa("path1731"),
                Ha("#dcc06d"),
                qa("M93.976 297.816c.011-3.838-1.453-7.511-1.028-11.65.459-4.45.94-9.843 2.452-13.922-1.367 4.63-2.638 9.308-3.421 14.076-.359 2.172-3.526 12.78 1.997 11.496z")
            ]), M),
            A2(Da, l([
                Fa("path1733"),
                Ha("#dcc06d"),
                qa("M85.091 297.513c.4-2.029.705-4.545 1.717-6.334.086 2.859.933 5.61 1.717 8.373-1.031-1.229-2.143-2.483-2.074-4.155-.553.738-.984 1.829-1.36 2.832")
            ]), M),
            A2(Da, l([
                Fa("path1735"),
                Ha("#dcc06d"),
                qa("M97.574 297.783c.376-1.329.369-2.654-.272-3.094 2.66 1.826 5.264 5.415 2.479 8.583-3.187 3.622-4.033-1.015-5.876-2.65 1.526 1.354 3.075-.745 3.669-2.839z")
            ]), M),
            A2(Da, l([
                Fa("path1737"),
                Ha("#dcc06d"),
                qa("M117.991 183.439c-3.243 1.424-2.052 8.318-2.502 11.819-.584 4.541-.807 8.844-2.227 13.223-4.21 12.989-8.361 26.202-10.656 39.582 3.468-13.428 8.211-26.259 12.263-39.537 1.398-4.583 2.407-7.659 2.407-12.553 0-4.134.267-8.403-.074-12.505-.358.119-.358.373-.642.687")
            ]), M),
            A2(Da, l([
                Fa("path1739"),
                Ha("#dcc06d"),
                qa("M125.499 180.935c-.84-.168-1.522-.126-2.09.449 1.772 2.901-1.164 5.439-2.101 8.223-1.145 3.397-2.039 6.762-3.165 10.17 2.379-4.484 3.542-8.485 7.339-12.118 1.129-1.081 4.249-2.931 4.67-4.418.583-2.053-2.052-3.804-3.562-4.516-3.325-1.57-5.1-.843-6.474 2.406 1.475-2.86 9.294-1.433 7.756 1.917-1.918.195-1.214-2.776-3.804-2.113")
            ]), M),
            A2(Da, l([
                Fa("path1741"),
                Ha("#dcc06d"),
                qa("M110.481 174.141c-.921-.506-1.92-.537-2.718.002.076.176.379.203.448.428-3.189 2.941-2.227 7.876-2.412 11.756-.282 5.887-1.398 11.7-1.755 17.583-.25 4.117-.861 8.344-1.812 12.318 2.217-4.174 3.557-10.261 4.235-14.91.697-4.773 2.072-9.865 1.871-14.712-.18-4.33-.792-7.593 1.429-11.75")
            ]), M),
            A2(Da, l([
                Fa("path1743"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M126.921 175.762c.886 1.536 1.342 3.378 1.206 4.95-.106 1.23-1.806 4.518-.688 5.594.097.094.194.19.289.288 5.33-1.652 6.798-9.293 4.476-13.813-2.378-4.628-9.995-6.424-14.482-4.711-6.893 2.631 1.741 4.14 3.01 6.938-.015-.031 1.876-2.071 2.27-2.16.98-.222 1.678.377 2.36.974a7.683 7.683 0 0 1 1.559 1.94z")
            ]), M),
            A2(Da, l([
                Fa("path1745"),
                Ha("#ccb25c"),
                qa("M120.41 177.725c-.579.91-.692 2.134-.496 3.177 1.298.241 2.656-.228 3.887-.514-.934.798-1.68 1.626-2.816 1.967-.817.245-1.042-.676-1.93.185-.292.283-.725 3.269-.805 3.694-.314 1.671-.255 3.388-.254 5.1 0-3.698-.277-9.954 1.877-13.072")
            ]), M),
            A2(Da, l([
                Fa("path1747"),
                Ha("#ccb25c"),
                qa("M126.847 184.698c-.394 2.252.423 1.693-1.073 3.48-1.65 1.971-3.256 3.985-5.069 5.817 1.049-2.38 3.143-5.02 4.708-7.165-.154-.059-.438-.177-.62-.247.324-.276.716-.851.956-1.031-1.227-1.287-3.396 3.888-3.616 4.515.501-2.645 2.667-4.846 3.908-6.442")
            ]), M),
            A2(Da, l([
                Fa("path1749"),
                Ha("#ccb25c"),
                qa("M109.951 176.384c-4.139-.266-2.477 7.998-2.414 10.383-.052-3.393.82-7.826 2.951-10.383")
            ]), M),
            A2(Da, l([
                Fa("path1751"),
                Ha("#ccb25c"),
                qa("M99.454 298.606c-.125 1.083-.995 2.185-2.109 2.238-1.7.083-4.187-1.692-5.879-2.094-1.237-.293-5.235-1.265-4.836-3.207-.496 2.417-6.338.497-8.112-.001-1.43-.402-2.204-.991-3.7-.876-1.204.093-2.372.651-3.511.959 1.525-1.813 6.377-1.048 6.983 1.298 1.771-.678 3.409.007 5.052.753 1.433.65 1.176.656 2.74.73 2.19.103 11.695 1.828 8.898 6.138 1.442-2.223 3.649.735 5.1-2.085.915-1.779.182-3.95-1.038-5.311.356.398.473.927.412 1.458z")
            ]), M)
        ]))
    ]), cr = l([
        A2(Da, l([
            Fa("path631"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".236"),
            qa("M200.247 347.717c-1.559.416-3.021 1.141-4.604 1.473-.821.172-2.16-.041-2.897.339-2.302 1.184-.482 4.262.757 5.493 1.783 1.771 4.615 1.893 7.032 1.974 2.767.093 5.792.19 8.383-.942 3.268-1.428 4.771-5.348 1.538-7.393-3.142-1.986-6.703-1.878-10.209-.944z")
        ]), M),
        A2(On, l([
            Fa("g641")
        ]), l([
            A2(On, l([
                Fa("g643")
            ]), l([
                A2(Da, l([
                    Fa("path645"),
                    Ha("#e1e2e3"),
                    Ua("#967348"),
                    Ba(".236"),
                    qa("M209.397 317.114c-2.617.967-5.458.83-8.196 1.097-1.845.179-3.816.376-5.608-.234-.947-.324-2.861-1.229-3.151-2.27-.252-.905.009-1.824.156-2.722.11-.677-.193-1.91.302-2.363.98-.897 2.896.616 3.874.866 1.741.447 3.306.734 5.127.617 1.595-.102 3.142-.513 4.665-.973 1.438-.436 4.791-1.934 5.341.155.179.681.045 1.468.25 2.165.113.379.431.725.358 1.073-.111.521-.977 1.025-1.344 1.418a4.26 4.26 0 0 1-1.687 1.139l-.087.032z")
                ]), M),
                A2(On, l([
                    Fa("g647")
                ]), l([
                    A2(Da, l([
                        Fa("path649"),
                        Ha("#e1e2e3"),
                        Ua("#967348"),
                        Ba(".236"),
                        qa("M212.966 340.013c.01.652-.018 1.215-.465 1.855-.621.884-1.643 1.397-2.638 1.737-2.125.726-4.468.806-6.695.787-2.213-.019-4.423.192-6.628-.121-1.134-.161-2.162-.46-3.144-1.051-1.369-.825-1.513-1.716-1.203-3.237.112-.552.127-.864.075-1.41-.179-1.857 1.661-.398 1.573-.194.227-.007.453-.009.68-.006h-.803l.749.001c.568-.048 1.862.203 2.688.267 2.899.225 5.654.449 8.483-.208 1.533-.356 3.043-1.024 4.63-1.116.475-.028 1.039.109 1.495.042.519-.073.962-.531 1.517-.399.348.621-.311 1.646-.322 2.332-.003.256.003.494.008.721z")
                    ]), M),
                    A2(Da, l([
                        Fa("path651"),
                        Ha("#e1e2e3"),
                        Ua("#967348"),
                        Ba(".236"),
                        qa("M212.804 324.189c.021-.23.004-.436-.092-.562-.235-.308-.192-.05-.46-.146-.222-.08-.563-.121-.879-.27-1.341-.63-3-.514-4.434-.395-2.997.251-6.424 1.544-9.424 1.044-.934-.155-2.574-1.054-3.418-.989-1.87.145-1.585 1.792-1.631 3.165-.025.78-.441 1.29-.12 2.04.293.687.912 1.252 1.522 1.655 3.785 2.501 10.682 1.674 14.719.848 1.165-.238 3.494-.81 4.029-2.189.396-1.028-.047-2.047.004-3.087.013-.25.151-.718.184-1.114z")
                    ]), M),
                    A2(Da, l([
                        Fa("path653"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M195.918 354.146c-2.126-.606-4.712-1.699-4.775-3.257-.012-.278.245-.756.318-1.002.28-.924.49-2.009.473-2.992-.568 1.937-2.624 1.172-4.036.605-1.604-.646-2.986-1.834-4.056-3.124-.48-.58-.649-.787-1.375-1.009-.47-.145-1.037-.016-1.351-.534-.629-1.034.905-1.183 1.519-1.639.699-.521 1.318-1.558 2.277-1.719 1.077-.183 1.937.965 2.678 1.578.958.792 1.987 1.291 3.087 1.852 1.179.601.83 1.355 1.354 2.536-.344-.692-1.683-4.229.063-4.101-.223-.017.642.823.753.875.764.357 1.891.616 2.72.831 1.493.385 3.252.417 4.79.443 3.507.058 7.018.048 10.345-1.249.542-.21 1.241-.45 1.63-.891.471-.534 1.218-1.7 1.555-.243.173.738-.369 1.934-.687 2.593.422-.879.41-.916 1.214-1.305.71-.343 1.132-.4 1.712-1.068 1.188-1.37 2.18-3.166 4.195-2.95 1.245.133 2.3.222 2.266 1.615-.07 2.831-2.191 4.372-4.419 5.863-.953.64-1.646 1.233-2.815 1.375-.93.113-2.429-.257-3.152.52a1.035 1.035 0 0 1-.232-.183c.153-.503.087-1.049.258-1.565-.244 1.015-.143 2.357.104 3.353.426 1.716.505 2.007-.933 3.178-.813.661-1.501 1.141-2.504 1.463-3.094.992-7.507 1.159-10.705.667a20.028 20.028 0 0 1-2.271-.516z")
                    ]), M),
                    A2(Da, l([
                        Fa("path655"),
                        Ha("#dcc06d"),
                        qa("M201.584 344.454c-.397.021-.781-.025-1.146-.073-.011.049-.022.098-.031.148-.371.027-.789.059-1.14-.066.088.172.22.397.373.53.175.154.423.03.519.148.269.33.192 1.091.263 1.52.002-.505-.029-1.037.172-1.485.64.472 1.67-.367 2.411-.08-.169.635-.101.958.096 1.565.168-.427-.122-1.22.438-1.306-.037.288.053.441.188.616.236-.309.365-.739.795-.7.028.879.147 1.778.277 2.645.087.564.158 1.858.523 2.249.1-1.167-.312-2.34-.165-3.501.073-.596.683-1.47 1.41-1.303-.053.073-.111.244-.17.317.747-1.001.552.703.552 1.01 0 .619.175 1.284.337 1.859.064-.539-.03-1.055.203-1.563-.075.906.429 2.062.859 2.82-.096-.052-.211-.041-.335-.129.269.456-.092 1.464.438 1.743.062-.695.083-1.431.122-2.109.064.072.122.131.175.215-.633-1.074-.789-2.153-.621-3.368.192.159.294.464.414.713.064-.696.113-1.021.352-1.659.056.195.207.437.269.578.075-.244.182-.236.273-.348.17 1.207.416 2.443.482 3.655.512-.654-.36-2.003.41-2.582.068.334.072.647.271.889.037-.148.134-.279.175-.399.222.574.188 1.204.397 1.767.162.434.497.779.617 1.191-.356-.756-.457-1.783-.551-2.633-.066-.62-.345-2.083.03-2.576.028.118.122.27.154.39.173-.627.198-1.26.469-1.843.023.03.049.111.083.161.401-.095.433-.618.416-.966-1.026.919-2.914.319-3.818 1.173.058.067.109.284.162.347-.819.408-2.331.587-3.185.442.195-.105.289-.292.344-.348-.707.218-1.664.172-2.402.257-.764.088-1.495.114-2.261 0")
                    ]), M),
                    A2(Da, l([
                        Fa("path657"),
                        Ha("#dcc06d"),
                        qa("M186.833 345.883c.716.362 3.528 1.861 3.858.193.368.011.67-.195 1.031-.179-.504.612-.552.831-.612 1.582-1.198.18-2.496-.067-3.493-.768-.752-.527-1.337-1.329-2.138-1.777.352.387 1.257.479 1.772.413-.172.03-.183.111-.321.183a.717.717 0 0 0 .528.444")
                    ]), M),
                    A2(Da, l([
                        Fa("path659"),
                        Ha("#dcc06d"),
                        qa("M213.921 343.292c-.815.43-1.544 2.389-1.417 3.295.395-.046.553-.532.973-.62.31-.064.762.233 1.15.172-.073-.128-.026-.309-.066-.417.317-.097 1.011-.138 1.226-.398.145-.175.034-.515.075-.773.143-.919 1.235-2.918 2.339-2.88-.058-.869.804-1.593 1.076-2.384-1.124-.355-2.59 1.817-3.215 2.556-.403.477-.669.723-1.248.979-.395.174-1.062.278-1.073.74")
                    ]), M),
                    A2(Da, l([
                        Fa("path661"),
                        Ha("#dcc06d"),
                        qa("M221.789 341.503c-1.464.304-1.337 2.797-3.095 2.765.011.458-.819 1.123-1.103 1.496a8.721 8.721 0 0 0 3.489-2.475c.269-.32 1.248-1.682.708-1.875")
                    ]), M),
                    A2(Da, l([
                        Fa("path663"),
                        Ha("#dcc06d"),
                        qa("M184.956 340.967c-.458.017-.936.156-1.251.499-.392-.107-.568.458-.795.728.81.824 1.748 2.24 2.844 2.678-.445-.972-1.306-1.839-1.143-2.996.329-.019.669-.051.959.066-.194-.339-.485-.655-.614-1.063")
                    ]), M),
                    A2(Da, l([
                        Fa("path665"),
                        Ha("#dcc06d"),
                        qa("M192.287 347.046c.54.69.093 2.258-.096 3.008.501-.664.952-1.817.914-2.643.13.067.31.027.42.068.086-.522-.067-1.21-.438-1.572-.146.458-.336 1.428-.979 1.496")
                    ]), M),
                    A2(Da, l([
                        Fa("path667"),
                        Ha("#ccb25c"),
                        qa("M208.022 344.454c0 .147.06.239.181.274.049-.139.197-.285.244-.427.025.156.123.302.13.483.331-.748.838-1.018 1.578-1.039.072.934-.122 1.931.196 2.834-.015-.909.058-1.922.512-2.728.013.138.109.275.13.4.356-.538 1.021-.817 1.22-1.468a4.152 4.152 0 0 1-.962.407c-.559-.56-2.099.274-2.615.637.03.066.064.098.088.157-.47.469-1.399.596-2.044.578.275.142.662.029.983-.019")
                    ]), M),
                    A2(Da, l([
                        Fa("path669"),
                        Ha("#ccb25c"),
                        qa("M210.434 352.053c.497-.067 1.177-.289 1.365-.785.194-.507-.115-.57-.273-1.071.039 1.062-.369 1.363-1.269 1.855")
                    ]), M),
                    A2(Da, l([
                        Fa("path671"),
                        Ha("#ccb25c"),
                        qa("M213.653 343.112c-.836.616-1.237 1.677-1.167 2.739.203-.436.538-1.6 1.248-1.232-.035-.075-.045-.18-.068-.239.977-.009.987-.612 1.325-1.155.671-1.075 2.175-1.667 2.584-2.946-.851.768-1.657 1.471-2.666 2.028-.674.372-1.377.533-1.792 1.252")
                    ]), M),
                    A2(Da, l([
                        Fa("path673"),
                        Ha("#ccb25c"),
                        qa("M192.198 347.136c.131.003.22.056.268.159-.48.57-.399 2.294-.451 3.032.162-.359 1.138-3.103.541-3.013")
                    ]), M),
                    A2(Da, l([
                        Fa("path675"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M199.795 332.389c-1.951.061-4.496.082-6.289-.819-.746-.375-1.104-.938-1.896-1.271-1.744-.736-3.519-1.882-5.493-1.381-.837.213-2.821.258-3.111 1.249-.233.792.353 2.265 1.05 2.688.893.542 2.389.745 3.406.982.468.109 1.037.317 1.515.23.558-.1 1.084-.516 1.699-.615 1.962-.317 3.981.177 5.923.429 2.655.345 5.694.639 8.318.001.657-.16.924-.574 1.564-.697.891-.172 1.968-.111 2.876-.155 2.095-.101 4.452-.452 6.519-.045 1.267.25 1.87.662 3.116.097 1.172-.534 2.177-1.298 3.152-2.133.776-.663 1.596-1.249.559-2.146-.816-.706-2.201-1.199-3.24-1.427-.955-.21-1.791.25-2.704.627-1.26.521-2.451 1.242-3.662 1.875-1.721.901-3.607 1.373-5.503 1.795-2.588.579-5.156.635-7.799.716z")
                    ]), M),
                    A2(Da, l([
                        Fa("path677"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M192.919 327.671c.271.211.555.437.61.476.611.42 1.1.621 1.79.923 1.07.469 2.043.709 3.207.925 1.8.335 3.682.424 5.512.383 1.754-.04 3.957-.516 5.595-1.124.751-.278 2.794-.693 2.875-1.682.03-.37.757.101.832.204.241.336.091.985.051 1.355-.124 1.142-.446 2.295-.522 3.429-.047.729-.122 1.606.002 2.327.181 1.063.762 2.045.13 3.085-.516.85-1.621 1.246-2.501 1.567-2.874 1.049-6.268.743-9.273.899-2.028.104-4.135-.018-6.069-.685-1.159-.399-3.732-1.248-3.319-2.905.294-1.184.445-2.125.45-3.373.002-.742-1.607-6.095.09-6.195.031 0 .28.19.54.391z")
                    ]), M),
                    A2(Da, l([
                        Fa("path679"),
                        Ha("#dcc06d"),
                        qa("M202.479 331.938c-.071.634.207 1.09.29 1.696.12-.216.154-.592.171-.883.277-.054.354-.104.341-.43.019.116.089.216.111.323.636-.702 1.242.009 2.112-.409.429 1.694.177 3.788 1.091 5.313.143-1.441-.915-3.689-.068-5.049.134.345.13.774.397 1.042.125-.241.262-.478.471-.635.657.996.519 2.708.693 3.88.124.826.46 1.743.456 2.563-.313-.163-.448-.545-.616-.855.03.192-.03.4-.018.583-.034.005-.057-.01-.066-.042-.36.305-1.008.216-1.433.206-.736-.015-1.468.118-2.208.134.755.262 1.907.043 2.739.069.693.023 1.173-.036 1.793-.271.536-.201 1.738-.195 1.869-.879-.073.043-.263.069-.373.136-.448-.727-.557-1.529-.497-2.36.347.534.414 1.241.808 1.752.068-.055.269-.098.339-.155.049.129.16.183.194.331.552.137.343-.331.629-.506.173-.108.448-.156.664-.191-.587-.573-.902-2.066-1.039-2.876-.151-.882-.378-2.098.113-2.916.091.391.145.817.267 1.213.369-.828.008-2.186.334-3.126a.37.37 0 0 0 .064.162c.125-.239.305-.511.366-.765-.77.691-1.743 1.285-2.762 1.366a8.554 8.554 0 0 1-.192 1.717c-.264-.575-.119-1.073-.785-1.219-.522-.115-.988.201-1.499.275a88.62 88.62 0 0 1-1.898.249c-.382.046-.997-.145-1.178.252-.122-.122-.41-.156-.503-.224-.267.618-2-.025-2.583-.015.388.237 1.127.662 1.404.629")
                    ]), M),
                    A2(Da, l([
                        Fa("path681"),
                        Ha("#dcc06d"),
                        qa("M193.449 330.061c-.379-.245-.673-.53-1.055-.689a.703.703 0 0 0-.033.682c-.073-.048-.061-.044-.072-.144-.307.554.472 2.101.558 2.743.137 1.01.163 1.998.152 3.016.219-1.016.206-2.348.166-3.382-.019-.467-.391-1.286.001-1.594-.004.149.069.203.106.318.195-.32.501.042.608.294-.084-.425-.093-1.005-.342-1.334")
                    ]), M),
                    A2(Da, l([
                        Fa("path683"),
                        Ha("#dcc06d"),
                        qa("M195.416 338.285c.166.235.355.416.612.436.072-1.106-.086-2.18-.165-3.273.046 1.001-.313 1.962-.357 2.926")
                    ]), M),
                    A2(Da, l([
                        Fa("path685"),
                        Ha("#dcc06d"),
                        qa("M197.115 331.402c.234.722.191 1.483.359 2.211-.076-.799.544-2.085-.449-2.39")
                    ]), M),
                    A2(Da, l([
                        Fa("path687"),
                        Ha("#dcc06d"),
                        qa("M183.883 330.954c.583-.561 1.4-.522 2.147-.644-.564-1.03-3.092.668-1.747.731-.059.041-.137.144-.209.198.563 1.012 2.063 2.053 3.194 2.242.672.113 1.322.011 2.052.141.193-.863 1.968-1.162 2.684-.889.072-.478-.054-1.032-.136-1.484-.547.65-1.733.681-2.507.777-.36.045-.728.158-1.097.159-.831.004-.341-.06-.728-.407-.437-.392-.311-.285-.816-.35-.352-.045-.791.042-1.171-.044-.27-.062-.485-.307-.773-.346-.204-.028-.458.119-.713.096")
                    ]), M),
                    A2(Da, l([
                        Fa("path689"),
                        Ha("#dcc06d"),
                        qa("M217.766 328.451c-1.164.385-2.492 2.473-.55 1.792.047.613-.145 1.21.55 1.159.378-.029 1.304-.691 1.532-.958-.245.697-1.139.688-1.323 1.393.368-.093.725-.414 1.118-.513.328-.083.676-.016 1.015-.102.968-.243 1.589-1.039 2.455-1.441-.871.68-1.64 1.516-2.561 2.14-.387.263-1.316.939-1.805.922-.115-.003-.271-.231-.424-.256-1.389-.213-2.895-.589-4.287-.413-.126-2.483 2.188-3.802 4.458-3.903")
                    ]), M),
                    A2(Da, l([
                        Fa("path691"),
                        Ha("#ccb25c"),
                        qa("M192.465 329.167a.952.952 0 0 0-.353.011c-.474.777.336 2.215.602 2.984.084-.705-.073-2.428-.427-2.995")
                    ]), M),
                    A2(Da, l([
                        Fa("path693"),
                        Ha("#ccb25c"),
                        qa("M210.613 332.206c0 1.332.089 2.676.631 3.908.051-.872-.258-1.736-.164-2.63.23.512.194 1.132.41 1.653.002-.383.077-.754.2-1.119.064.919.239 1.846.518 2.713-.232-.168-.371-.49-.437-.74.021.503.128 1.093.296 1.557.096-.354.103-.802.403-1.042a.31.31 0 0 1 .07.162c-.851-1.989-.358-4.792-.313-6.925-.132.636-.318 1.268-.45 1.899-.015-.208-.053-.241-.017-.464a6.445 6.445 0 0 0-.36 2.084c-.29-.691.03-1.833-.363-2.364-.322.426-.337.965-.335 1.488")
                    ]), M),
                    A2(Da, l([
                        Fa("path695"),
                        Ha("#ccb25c"),
                        qa("M214.815 329.524c-.54-.057-1.006.483-1.508.645.275-.088-.149.87-.152.872-.077.393-.194.815.082 1.169.619-.007 1.559.266 2.083-.006-.842-.133-1.522-.24-1.233-1.125a.263.263 0 0 1-.151.043c-.168-.787.636-1.825 1.417-1.866")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g697")
                ]), l([
                    A2(Da, l([
                        Fa("path699"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M211.842 322.29c-1.997 1.242-5.121.886-7.325.471-2.773-.521-5.593.381-8.386-.018-.759-.109-1.417-.466-2.159-.608-2.814-.543-5.161-1.659-8.03-.298-.841.397-1.595 1.135-2.506.697-.736-.354-1.419-1.201-1.699-1.95-.357-.959-.077-1.855.618-2.588.637-.668 2.201-1.917 3.142-1.887.46.015 1.094.435 1.514.63.778.362 1.587.649 2.434.807 1.438.267 2.963-.723 4.291-.383.933.238 1.876 1.043 2.835 1.351 2.092.673 4.222.522 6.363.463 1.595-.044 3.541-.56 5.059-1.071 1.098-.369 1.877-.486 2.726-1.077.339-.238.821-.608 1.235-.647.576-.054 1.437.43 2.058.58 1.585.382 2.626-.201 3.934-1.03.857-.542 1.491-.551 2.525-.355 1.175.222 2.645.952 3.287 1.989.814 1.32-.936 2.213-1.974 2.778-.731.4-1.516.771-2.306.965-.29-1.497-3.851-1.016-4.753-.708-1.183.404-1.857 1.249-2.883 1.889z")
                    ]), M),
                    A2(Da, l([
                        Fa("path701"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M196.189 315.943c2.957.491 5.993.666 8.962.165 2.592-.438 4.765-.454 6.921-2.269 1.094-.92.879 1.394.823 1.906-.104 1.013-.497 2.082-.493 3.095.003.999-.04 1.979.135 2.95.262 1.469 1.109 2.665-.681 3.304-1.672.6-3.218.955-4.972 1.278-3.055.563-6.184.432-9.203-.273-1.625-.379-3.854-.487-5.153-1.648-.547-.488-.053-1.573-.043-2.182a33.303 33.303 0 0 0-.177-4.185c-.155-1.403-1.067-2.846-.275-4.192a.704.704 0 0 1 .303.001c.174.04.535.743.717.894.521.432 1.335.637 1.964.86.385.135.776.23 1.172.296z")
                    ]), M),
                    A2(Da, l([
                        Fa("path703"),
                        Ha("#dcc06d"),
                        qa("M193.449 316.919c-.122.478.29 1.287.377 1.797.161.931.159 1.836.159 2.777-.107-1.07.2-2.721.175-4.007a.205.205 0 0 0 .07.112c.042-.155.109-.208.125-.418a.687.687 0 0 1 .877.154c.628-.417.724 2.091.997 2.585-.221-.767-.121-1.49-.084-2.251.091-.017.199-.073.274-.09.3.085.605.103.86-.057-.313-.278-.882-.154-1.05-.658-.66.013-2.459-.076-2.711-.831-.019.041-.144.159-.175.25-.158-.103-.368-.108-.501-.25-.039.828.393 1.684.334 2.565a5.262 5.262 0 0 0 .185-1.59")
                    ]), M),
                    A2(Da, l([
                        Fa("path705"),
                        Ha("#dcc06d"),
                        qa("M202.299 317.634c.597-.001 1.171-.056 1.764-.095-.237.237.007.466.313.599.201-.171.303-.063.508-.131 0 .082.019.166.023.247.186-.178.291-.088.509-.158.04.55.228 1.104.279 1.695.066.813-.037 1.778.183 2.565-.009-.919.051-1.82.09-2.734.019-.48-.168-1.233.264-1.538.135.246.194.521.286.784.132-.188.301-.435.412-.601.103 1.869.489 3.834.463 5.694.186-1.013.051-2.025-.002-3.042-.036-.702-.172-2.27.356-2.809.668.305.555 1.029.65 1.643a20.21 20.21 0 0 1 .25 3.157c0 .511.232 1.938-.343 2.135-.019-.23-.126-.38-.215-.59-.045.138-.192.257-.248.386-.039-.111-.113-.187-.158-.296-.047.548-.44.965-1.005.625-.537-.324-.501-1.265-.693-1.79-.068.61.062 1.239-.203 1.828.007-.086-.004-.154-.012-.237-.417.302-1.165.371-1.658.51 1.607.104 3.096.105 4.627-.406 1.145-.382.757-1.666 1.077-2.683-.134.639-.125 1.297.083 1.92.042-.197.211-.408.253-.506-.058.423.308.738.55.273.378.125.958-.238 1.241-.528-1.303-.637-.921-4.021-.975-5.178.092.427.271.943.525 1.301.045-.747.132-1.445.216-2.146.072-.601.286-1.41.01-1.97-.269.186-.584.274-.919.301-.1.43-.286.902-.279 1.347-.064-.192-.13-.863-.26-1.156-.071.115-.292.303-.346.413-.004-.105-.017-.212-.015-.323-.458 1.365.092 2.975-.002 4.367-.416-.891.124-3.199-.608-4.031a314.27 314.27 0 0 0-.019 3.77c.128-.809-.042-1.995-.363-2.741-.164-.38-.267-.629-.683-.69-.224-.033-2.003.653-1.968.81-.154-.713-1.316-.142-1.92-.171-.708-.034-1.581-.194-2.218 0")
                    ]), M),
                    A2(Da, l([
                        Fa("path707"),
                        Ha("#dcc06d"),
                        qa("M197.919 324.875c.374.036.711.228 1.041.351a.89.89 0 0 0-.071-.515c-.736-.144-.495-3.215-.704-3.792.102 1.17.446 2.45.111 3.572.002-.136-.062-.274-.085-.394-.048.084-.151.185-.185.234-.053-.312-.115-.652-.272-.888.105.431.127.892-.024 1.316.116-.084.142.029.279.027")
                    ]), M),
                    A2(Da, l([
                        Fa("path709"),
                        Ha("#ccb25c"),
                        qa("M210.262 322.7c.127-.967-.083-2.063.267-2.984-.026.471.04.923.083 1.388.079-.309.085-.626.203-.921.209.642.106 1.426.267 2.102.094.396.288.775.324 1.147-.38.034-.465-.439-.525-.765.004.501-.015.992.087 1.466.134-.343.397-.475.559-.075.263-.057.429-.274.578-.446-.699-1.216-.262-2.856-.488-4.072.051.07.113.136.164.207-.232-.314.041-1.547.058-1.936.035-.736.002-1.489.115-2.222.049-.313.209-.539.094-.807-.091-.209-.648 1.138-.667 1.206-.209.72-.294 1.42-.405 2.168-.147-.49-.186-.977-.365-1.464.007.458.056.922-.085 1.364-.042-.068-.155-.214-.16-.225-.013.565-.137 1.322-.034 1.853-.045-.14-.262-.388-.343-.504-.228.498-.028 1.25-.009 1.79.013.479.335 1.327.282 1.73z")
                    ]), M),
                    A2(Da, l([
                        Fa("path711"),
                        Ha("#ccb25c"),
                        qa("M219.452 316.016c-1.926.105-3.525 1.994-5.535 1.465-.49-.129-.616-.455-1.058-.023-.251.245-.286.733-.319 1.058-.08.744.013 1.581.22 2.3.01-.024.025-.038.051-.042-.021.087-.039.149-.039.231.375-.354.854-.776 1.297-.939a.22.22 0 0 1-.117.083c.156-.086.322-.113.478-.196-.047.031-.107.047-.145.078.471.003 1.452-.227 1.836-.528a.306.306 0 0 1-.113.104c.299-.057.608-.12.92-.099.179.389 2.363.367 2.871.539.352.825 2.505-1.352 2.877-1.864-.734.353-1.736.703-2.583.634-.426-.035-.81-.172-1.272-.263-.529-.104-1.57-.026-1.573-.738-.002-.784 1.602-1.639 2.204-1.8z")
                    ]), M),
                    A2(Da, l([
                        Fa("path713"),
                        Ha("#dcc06d"),
                        qa("M217.587 317.276c-.561.174-1.68.405-1.776 1.061.215-.03.42.048.621-.044 0 .075 0 .145.002.218.881.416 2.47.132 3.272-.351-.904.824.211 1.247 1.03 1.134.741-.103 1.941-.696 2.037-1.523-.272.618-1.083 1.149-1.783.997-.516-.112-1.117-1.38-.367-1.477-.603.079-1.081.299-1.687.103-.267.465-1.147.818-1.521.263.192-.17.426-.325.618-.469")
                    ]), M),
                    A2(Da, l([
                        Fa("path715"),
                        Ha("#dcc06d"),
                        qa("M183.294 318.723c-.381.343-.403.87-.911 1.104-.203-.196-.292-.688-.084-.937-.602.718-.228 1.788.375 2.376.834.817 1.554.522 2.448.04.672-.36 1.364-.724 2.132-.818-.353.223-.752.34-1.111.526 1.605-.19 3.556-1.207 5.216-.636-.012.061-.035.13-.045.186.336.17.687.405.949.639.471-.824-.141-2.487-.332-3.36-.122.263-.142.58-.274.831a.228.228 0 0 0-.013-.134c-.572.517-1.6.428-2.271.868.373.01.754.006 1.121.119-.375.622-2.375.575-3.045.595-.57.017-1.608.069-2.127-.156.132-.166.151-.355.406-.458-.705.086-1.365.455-2.1.348-.303-1.318.985-1.315 1.663-2.125-.386.461-1.492.538-1.997.992z")
                    ]), M),
                    A2(Da, l([
                        Fa("path717"),
                        Ha("#dcc06d"),
                        qa("M189.783 318.438c-.532-.002-1.014-.064-1.51-.073.223.663 1.798.319 2.22.002-.222-.023-.485-.05-.71-.018")
                    ]), M)
                ]))
            ])),
            A2(On, l([
                Fa("g719")
            ]), l([
                A2(Da, l([
                    Fa("path721"),
                    Ha("#e1e2e3"),
                    Ua("#967348"),
                    Ba(".236"),
                    qa("M212.079 298.723v-.052c.006-.526.168-1.076.053-1.6-.213-.973-1.979-.43-2.63-.526-1.61-.24-3.184-.172-4.803.012-.811.091-1.617.224-2.429.297-2.238.204-4.49-.251-6.73.021-.501.061-.977.208-1.47.292-.342.057-.69-.067-1.009-.015-.649.105-.499.509-.439.981.1.798.105 1.618-.046 2.409-.108.565-.27 1.157.226 1.609.403.37 1.362.501 1.877.658.712.219 1.433.409 2.165.552 2.948.571 5.974.887 8.974.575 1.379-.144 2.937-.322 4.146-1.002.898-.504 2.391-1.417 2.223-2.643a11.246 11.246 0 0 1-.108-1.568z")
                ]), M),
                A2(Da, l([
                    Fa("path723"),
                    Ha("#e1e2e3"),
                    Ua("#967348"),
                    Ba(".236"),
                    qa("M210.65 288.122c-.331.144-.732.217-1.129.303-2.039.444-4.099.946-6.17 1.241-3.271.467-7.341.582-10.308-1.163-.966-.568-.322-1.753-.168-2.563.139-.74-.363-2.035 0-2.674.324-.575 1.88-.702 2.47-.688 1.457.033 2.818.628 4.257.77 1.958.192 4.146.186 6.115.06 1.092-.07 2.133-.382 3.212-.524.706-.093 1.994-.886 2.24.119.16.657-.199 1.429-.241 2.086-.067 1.017 1.178 2.397-.278 3.033z")
                ]), M),
                A2(On, l([
                    Fa("g725")
                ]), l([
                    A2(Da, l([
                        Fa("path727"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M195.371 306.397a20.186 20.186 0 0 1-3.306-.941c-1.146-.445-3.146-.965-4.383-.913-1.026.043-1.646.329-2.481.899-.691.471-1.203.662-.848 1.449.992 2.195 4.204 2.61 6.225 2.159 1.173-.263 2.213-.783 3.406-.915 2.427-.268 5.057-.563 7.495-.464 4.217.171 8.186.083 12.202 1.521.505.181.779-.07 1.218-.046.61.034 1.256.308 1.864.24.71-.08 1.476-.63 2.071-.988.322-.193 1.361-.642 1.455-1.042.309-1.301-3.159-2.735-4.057-3.055-1.09-.387-1.873.409-3.121.745-3.271.876-6.837 1.365-10.234 1.539-2.414.121-5.125.28-7.506-.188z")
                    ]), M),
                    A2(Da, l([
                        Fa("path729"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M192.253 310.62c.251.935 2.048 1.8 2.845 2.083 1.16.41 2.403.586 3.624.69 2.814.238 5.691.124 8.442-.545 1.203-.292 2.318-.594 3.459-1.075.932-.393 1.612-.661 1.377-1.826-.478-2.36.005-5.016.512-7.328.104-.472.205-1.001.171-1.496-.026-.347-.175-.782-.534-.878-.371.663-.683 1.162-1.441 1.41-1.007.327-2.071.397-3.105.594-1.689.323-3.417.456-5.136.456-3.021-.001-5.811-.661-8.692-1.381-.446-.111-.63-.346-.996-.525-.647-.315-.849.324-.831.97.014.457.148 1.042.269 1.487.449 1.66.625 3.167.448 4.904-.074.735-.551 1.649-.431 2.375.005.028.012.056.019.085z")
                    ]), M),
                    A2(Da, l([
                        Fa("path731"),
                        Ha("#dcc06d"),
                        qa("M193.024 303.106a.672.672 0 0 0-.222.28c.233.183.26.483.292.767-.01-.025-.028-.036-.056-.033-.061.333.062.591.12.915.111.605.124 1.191.133 1.815.013.865.057 1.646-.208 2.473.311-.458.588-1.274.54-1.832.007.026.024.039.051.039.327-.653-.399-1.894.071-2.406.042.1.097.134.135.192.004-.139.093-.274.092-.415.764.718.182 2.024.528 2.886-.008-.885.043-1.916.143-2.799.069.042.096.029.176.109.028-.411-.617-.924-.119-1.261.024.041.103.112.125.142.076-.155.231-.248.349-.348.209.151.299.417.397.647.045-.009.067-.034.065-.078.327.634.048 1.452.32 2.105.098-.748.035-1.5.094-2.241.128.231.335.214.53.039.481.599 1.345.157 1.802.667.43.478.297 1.501.268 2.085.176-.518-.084-1.944.339-2.28.4-.317 1.458.409 1.758-.252.688.185 1.703-.076 2.464-.075.885 0 2.259.192 3.063-.208-.405.163-.296.958-.162 1.278.051-.062.19-.135.239-.193.109 1.459.64 2.858.892 4.272-.316-.75-.219-2.117-.26-2.93-.028-.531-.075-1.499.39-1.879.043.076.171.158.197.28.124-.269.29-.666.593-.752.258 1.295.01 2.705.013 4.018.002.782-.215 1.58-.198 2.329-.098-.24-.203-.501-.203-.764a1.65 1.65 0 0 1-.49 1.248c-.106-.29.017-.669-.117-.983.044.407-.036.979-.262 1.32-.391-.343-.683.25-1.079.396-.403.15-.958.195-1.39.213-.593.024-1.518.444-1.64-.384-.644.777-1.342.541-2.246.788 1.613-.038 3.447.175 5.015-.287.989-.291 1.862-.66 2.934-.527.118-.512.352-.496.811-.35.071-.415-.162-.775-.185-1.184-.021-.383.132-.742.122-1.122.094.457.288 1.982.928 1.983.004-.098.098-.208.087-.325.458.227.616-.321 1.041-.148-.716-1.232-.673-2.879-.578-4.259-.017.027-.041.091-.054.108a1.316 1.316 0 0 1-.019-.439c.103-.058.173-.148.224-.36.235.629.103 1.457.165 2.14.053.575.184 1.139.149 1.72.207-.595-.008-1.351.003-1.968.013-.833.021-1.664.066-2.489.025-.453-.139-1.961.277-2.268-.286.211-.333.589-.685.717-.024-.073-.101-.202-.111-.266-.011.506-.1 1.227-.269 1.675-.015-.458-.307-1.209-.104-1.534-.181.216-.405.413-.706.4-.081 1.097.106 2.346-.196 3.4-.124-1.228.135-2.608-.081-3.781-.226.394-.175 1.057-.205 1.51-.062.91.099 1.851-.01 2.751-.441-1.183.01-2.875-.384-4.102-.391.428-.814.276-1.292.161-.583-.139-1.135-.026-1.713.039-.452.049-.771.198-1.169.304-.962.255-2.212.065-3.21.118-1.674.087-3.379-.197-4.999-.465.074.238-.049.304-.285.25.009-.139-.09-.252-.089-.386-.555.201-1.787-.06-2.138-.522-.1.323-.105.787-.249 1.051-.029-.378-.149-.74-.148-1.118a.181.181 0 0 1-.014.105 1.554 1.554 0 0 0-.513-.322c.014.287.1.561.057.799")
                    ]), M),
                    A2(Da, l([
                        Fa("path733"),
                        Ha("#dcc06d"),
                        qa("M195.97 310.636c.036.231.045.468-.129.628a.168.168 0 0 1-.087-.101c-.105.101-.183.073-.304.115a9.73 9.73 0 0 1-.347-2.653c-.127.47.052 2.235-.458 2.389-.002-.102-.053-.174-.075-.261-.071.034-.207.03-.263.056-.01-.376-.021-1.097-.282-1.375.012.44.241 1.358-.04 1.64.201-.201.845.453 1.029.533.441.192 1.07.283 1.53.179-.273-.329-.506-.712-.574-1.15z")
                    ]), M),
                    A2(Da, l([
                        Fa("path735"),
                        Ha("#dcc06d"),
                        qa("M185.902 307.735c-.612-.445-1.542-1.154-.618-1.727.481-.297 1.609-.319 1.959-.698-.2.217-1.332.711-.797.896-.44.253-.393.669-.055 1.076.557.676 3.504 1.332 3.842.258a4.114 4.114 0 0 0-.692-.157c.031-.01.117-.053.193-.065-.173-.149-.465-.152-.713-.202.077-.085.278-.2.447-.259.008-.036-.003-.058-.034-.065.342-.22.289.162.564.278.41.172 1.317.01 1.162-.588-.098.005-.173-.034-.282-.008.383.168.94-.214 1.384-.139-.088.186.01.301.024.456.042-.035.073-.064.124-.111-.076.365.025.926-.206 1.255-.279.396-.931.493-1.378.605-1.095.275-1.826.169-2.893.061-.452-.046-.577 0-1.009-.264-.329-.199-.718-.382-1.022-.602z")
                    ]), M),
                    A2(Da, l([
                        Fa("path737"),
                        Ha("#dcc06d"),
                        qa("M212.402 306.258c-.375.521-.204 1.47-.192 2.058.139-.189.32-.237.501-.11a.76.76 0 0 1-.085-.01c.392.299.791.313 1.179.333.25.013.205.154.459.06.094-.035.243-.301.405-.363.282 1.181 2.916.067 3.543-.231-.028.028-.064.051-.09.083.439-.268 1.363-.353 1.565-.885-.424-.119-.708-.305-1.098-.603.07 0 .166-.012.229-.007-.351-.17-.466-.666-.843-.786.195 1.396-3.491.768-4.291.652.047-.237.284-.344.508-.464-.169-.009-.147-.081-.246-.124.177-.143.388-.305.529-.461-.491 0-1.318.414-1.811.575-.364.118-.574.136-.465.619")
                    ]), M),
                    A2(Da, l([
                        Fa("path739"),
                        Ha("#ccb25c"),
                        qa("M212 305.856c.085-.102.282-.192.401-.241.164.213.438.195.65.032-.3.179-.661.643-.571 1.006.058-.021.12-.038.182-.054.134 1.493 4.311 1.689 4.393 1.063.834-.192 1.657-.485 2.375-.929.115.123.29.224.426.26-.508.564-.919 1.074-1.629 1.384-.529.23-1.163.689-1.748.766-.437.058-.853-.254-1.26-.356-.412-.102-.552.059-.943.105-.484.058-2.062-.335-2.209-.892-.177-.677.179-1.579.202-2.259-.002.06.005.122 0 .181")
                    ]), M),
                    A2(Da, l([
                        Fa("path741"),
                        Ha("#ccb25c"),
                        qa("M217.029 305.587c.401.102 1.168 1.093 1.537.689-.543-.305-1.32-.672-1.941-.756")
                    ]), M),
                    A2(Da, l([
                        Fa("path743"),
                        Ha("#ccb25c"),
                        qa("M209.988 303.778c-.218.947-.218 2.533.068 3.461.09-.676-.156-2.371.301-2.84.054.133.16.342.22.437.042-.376.201-.701.354-1.041-.023 1.02-.128 2.027-.141 3.047a1.03 1.03 0 0 1 .258-.562c-.226.897.403 1.973-.245 2.726a.729.729 0 0 0-.081-.654c.028.169-.004.352-.011.52-.032-.06-.132-.167-.173-.25-.03.535-.106 1.13-.418 1.573-.284-.569-.186-1.321-.405-1.909.019.951-.09 2.079.207 2.98.096-.483.313-.875.791-1.044.009.039.015.077.024.115.382.092.49-.115.591-.388.113-.302 0-.843.002-1.157.004-.636.103-1.248.136-1.88.052-.933-.042-1.866.062-2.794.051-.459.186-1.004.124-1.46-.141.213-.386.523-.604.256-.417.23-.633.604-1.147.473-.106.024.011.026.02.056")
                    ]), M),
                    A2(Da, l([
                        Fa("path745"),
                        Ha("#ccb25c"),
                        qa("M208.707 311.073c-.427-.029-.569-3.991-.61-4.519-.228.717-.083 1.491-.083 2.22-.002.928-.164 1.841-.089 2.774.244-.195.419-.5.782-.475z")
                    ]), M),
                    A2(Da, l([
                        Fa("path747"),
                        Ha("#ccb25c"),
                        qa("M207.977 303.71c.198.503.203 1.003.269 1.528a4.635 4.635 0 0 1 .192-1.587.474.474 0 0 0-.461.126")
                    ]), M),
                    A2(Da, l([
                        Fa("path749"),
                        Ha("#ccb25c"),
                        qa("M188.474 307.678c.113-.012.159-.067.25-.092-.083-.16-.064-.272-.239-.381 1.098.453 2.763.084 3.56-.794a.14.14 0 0 0-.138.02c.058-.424.613-.297.552-.038-.168.699.138 1.417-.571 1.847-.611.37-1.603.432-2.3.44-.604.007-1.444.133-2.017-.07-.532-.19-.797-.739-1.32-.963-.625-.27-1.272-.454-1.47-1.251.958-.887.543-.041.703.521.174.612 1.052 1.055 1.615 1.243.282.095.625.154.92.061.119-.039.663-.565.455-.543z")
                    ]), M),
                    A2(Da, l([
                        Fa("path751"),
                        Ha("#ccb25c"),
                        qa("M189.269 305.789c.402.096.786.252 1.191.328-.286-.364-.629-.325-1.057-.328")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g753")
                ]), l([
                    A2(Da, l([
                        Fa("path755"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M214.819 291.172c-2.335.136-4.575.69-6.848 1.003-1.09.149-2.187.244-3.307.21-2.515-.075-4.945.011-7.459-.209-2.295-.201-4.562-.018-6.793-.575-1.335-.334-4.319.149-4.718 1.795-.298 1.227 1.46 2.362 2.571 2.331.714-.021 1.579-.351 2.289-.532 3.105-.792 6.44-.698 9.616-1.021 2.836-.288 5.684-.024 8.505.283 1.533.166 3.144.168 4.656.391 1.484.218 2.438.724 3.865-.189 1.047-.67 1.612-1.179.659-2.214-.745-.808-1.944-1.338-3.036-1.273z")
                    ]), M),
                    A2(Da, l([
                        Fa("path757"),
                        Ha("#f3d48c"),
                        Ua("#967348"),
                        Ba(".322"),
                        qa("M200.796 287.707c1.164.037 2.324.034 3.476-.033 1.385-.082 2.773-.278 4.149-.434 1-.112 1.817-.671 2.873-.615.975.051.751 1.041.711 1.784-.101 1.747-.479 3.693.06 5.372.315.984.644 2.121.407 3.156-.282 1.229-1.566 1.343-2.553 1.646-1.359.415-2.745.57-4.155.701-2.105.195-4.045.346-6.158.141a80.55 80.55 0 0 1-3.495-.406c-.973-.139-1.903-.31-2.827-.628-1.167-.401-1.104-1.051-.854-2.13.479-2.066.078-4.131-.169-6.198-.083-.689-.48-2.003-.208-2.667.342-.833 1.614-.202 2.241-.149 2.143.184 4.327.392 6.502.46z")
                    ]), M),
                    A2(Da, l([
                        Fa("path759"),
                        Ha("#dcc06d"),
                        qa("M193.762 297.542c-.512-.198-.561-.301-.539-.8.029-.636.165-1.367.275-2.005-.219.629-.11 1.528-.061 2.197.017-.019.098-.083.126-.108.063.232.175.45.4.511.299-.541.291-1.416.402-2.024.121-.667.232-1.334.338-1.996.091-.559.114-1.096.146-1.661.3 1.218.179 2.611.103 3.864-.039.646-.013 1.445-.185 2.064-.303.293-.516.179-.865-.104.09.224-.025.028-.074.061")
                    ]), M),
                    A2(Da, l([
                        Fa("path761"),
                        Ha("#dcc06d"),
                        qa("M199.998 298.078c.271.253.625.271.857.005.031.365.423.272.682.249.368-.033.518.102.806.121 1.698.104 3.58-.051 5.222-.52.026-.093-.006-.128-.03-.182a.19.19 0 0 0 .094.108c.041-.698.006-1.519.201-2.183-.007.639.22 1.313.422 1.919-.008-.099.007-.193.009-.289.194.459.438.51.774.174.06.06.154.085.199.123-.316-.438-.348-1.778-.179-2.327-.015.638.166 1.491.452 2.047.113-1.605-.806-3.484-.183-5.038-.062.9.175 1.889.263 2.787.081.798.25 1.571.488 2.334.006-.066.058-.206.062-.306.023.077.158.243.186.309.173-.377.687-.422 1.052-.416-.147-.528-.342-1.031-.452-1.574.234.531.49 1.05.732 1.567.055-.381-.152-.828-.252-1.192-.317-1.16-.571-2.25-.688-3.447-.092-.936-.188-1.85-.186-2.792.002-.356.024-.854-.051-1.128a5.89 5.89 0 0 1-.03.326c-.007-.033-.098-.291-.104-.327-.117.768-.126 1.559-.218 2.333.039-.738-.041-2.063-.348-2.713-.239.115-.499.175-.744.132-.103.368.03.781.011 1.176-.021.448-.141.864-.124 1.319-.064-.799-.134-1.579-.271-2.371a5.426 5.426 0 0 0-.013.253c0-.03-.047-.22-.047-.316-.07.066-.211.203-.262.261-.22 1.076-.041 2.328-.132 3.443-.085 1.015.162 2.026.124 3.039-.369-1.461-.252-2.938-.42-4.417-.051-.451-.021-1.579-.36-1.85.013.03.028.059.044.085-.062-.501-.646-.281-.985-.251.322 1.085.269 2.496.314 3.641a96.08 96.08 0 0 1 .064 3.752c-.173-1.388-.32-2.826-.469-4.235-.047-.434-.047-3.225-.689-2.91-.049-.027-.049-.078-.098-.1l-.079.107c.538.347.35 2.328.382 2.896.087 1.592.177 3.229.145 4.821.196-.558.246-1.455.203-2.047.273.621.403 2.662.008 3.212-.042-.078-.189-.172-.237-.268-.657.694-.742.586-.99-.327-.213-.789-.168-1.834-.441-2.551-.132 1.057.305 2.376-.337 3.323.026-.157-.068-.328-.075-.464-.284.397-.431.302-.881.325-.329.017-.565.173-.868-.115-.412-.395-.491-1.73-.591-2.292-.073-.398-.049-.8-.094-1.193-.197.387.006 1.46.03 1.938.026.511.192 1.179.068 1.66a.427.427 0 0 1-.028-.109.748.748 0 0 1-.244.118c-.042-.127-.186-.249-.211-.392-.05.055-.269.132-.323.193-.061-.108-.176-.135-.222-.19-.05.16-.164.244-.262.376-.268-.331-.193-1.104-.269-1.521-.105-.58-.08-1.26-.34-1.798-.012.513-.066 1.02-.062 1.539.005.8-.265 1.628-.201 2.404")
                    ]), M),
                    A2(Da, l([
                        Fa("path763"),
                        Ha("#dcc06d"),
                        qa("M201.813 292.021c-.032-1.019.132-2.044.051-3.057-1.069.203-.183 2.449-.051 3.057z")
                    ]), M),
                    A2(Da, l([
                        Fa("path765"),
                        Ha("#dcc06d"),
                        qa("M204.49 289.965c-.188.636.013 1.326.053 1.97.019.325-.03.786.066 1.041.064-.547.158-1.13.156-1.688-.002-.506.055-1.47-.137-1.909-.166.098-.226.259-.205.452")
                    ]), M),
                    A2(Da, l([
                        Fa("path767"),
                        Ha("#dcc06d"),
                        qa("M194.633 288.893c.236.451.18.986.217 1.471.063-.193.369-2.244-.284-1.604")
                    ]), M),
                    A2(Da, l([
                        Fa("path769"),
                        Ha("#dcc06d"),
                        qa("M192.622 288.356c-.392.521.433 1.604.398 2.25.165-.4.036-2.144-.398-2.25")
                    ]), M),
                    A2(Da, l([
                        Fa("path771"),
                        Ha("#ccb25c"),
                        qa("M209.788 291.104c.06.735.15 1.47.218 2.204.045.505.005 1.142.251 1.598.239-.843-.384-2.19.137-2.914-.154 1.532.495 3.111.317 4.605-.181-.199-.235-.537-.393-.775-.006.304-.098 1.334-.601 1.258-.589-.088-.664-2.35-.807-2.834-.025.37.158 1.168.192 1.676.026.382.263 1.265.007 1.54.008-.105-.015-.221-.007-.318-.096.204-.3.376-.55.379-.007.065-.002.104-.017.162.755-.349 2.146-.18 2.472-1.146.075.096.252.207.313.317-.177-.654-.265-1.733-.127-2.397.125.702.189 1.702.665 2.266-.734-2.804-.998-5.781-.998-8.685.028.664-.032 1.51-.271 2.113.004-.678.004-1.347-.075-1.988a2.464 2.464 0 0 0-.398-.054c.032.923-.002 1.85.006 2.774-.066-.43-.213-.866-.198-1.304-.246.51-.154 1.794-.004 2.329")
                    ]), M),
                    A2(Da, l([
                        Fa("path773"),
                        Ha("#ccb25c"),
                        qa("M208.916 288.759c.215.905-.234 2.034.207 2.869.072-1.051.267-2.197.188-3.282-.181-.074-.179.04-.26.144")
                    ]), M),
                    A2(Da, l([
                        Fa("path775"),
                        Ha("#ccb25c"),
                        qa("M206.971 295.463c.032.836.036 1.653.083 2.481.236-.589.271-2.173-.035-2.785a.915.915 0 0 0-.049.438")
                    ]), M),
                    A2(Da, l([
                        Fa("path777"),
                        Ha("#ccb25c"),
                        qa("M212.469 291.977a.978.978 0 0 0-.337.01c-.277.614.117 1.889.455 2.399.025-.067.056-.12.079-.172.301.395 1.227.329 1.728.312-.3-.081-.83-.455-.772-.808.038-.242.591-.17.284-.467.29-.168.617.129.889.272-1.309-.18.026 1.24.706 1.342.631.095 2.349-.751 2.393-1.523-.474.235-1.135.337-1.653.304.154-.035.279-.19.382-.246-.999-.507-2.308-.592-3.14-1.372.07-.05.184-.208.307-.255-.507.018-.953.082-1.455.138")
                    ]), M),
                    A2(Da, l([
                        Fa("path779"),
                        Ha("#ccb25c"),
                        qa("M188.8 295.263c.429-.083.785-.354 1.192-.491.325-.107.648-.139.974-.304.239-.121.673-.31.769-.593.032-.095 0-.75-.229-.641.3-.144.488-.42.649-.703.137.585.145 1.387-.149 1.914.004-.007-1.171.332-1.332.392-.595.223-1.258.268-1.874.426")
                    ]), M),
                    A2(Da, l([
                        Fa("path781"),
                        Ha("#ccb25c"),
                        qa("M192.824 292.244c.425.948.135 1.951.45 2.867.309-.714.092-1.582.019-2.33-.049-.506-.063-1.225-.284-1.666-.05.003-.058.038-.104.05a10.143 10.143 0 0 0-.267-2.054c-.159 1.278.37 2.713.454 4.005")
                    ]), M),
                    A2(Da, l([
                        Fa("path783"),
                        Ha("#dcc06d"),
                        qa("M216.208 292.982c-.096.024-.192.098-.247.12.162-.016.296.075.454.092-.066.173-.042.284-.258.374.614.275 1.395.129 1.67-.505-.361.025-.378-.185-.581-.366-.337-.298-.407-.364-.951-.503-.657-.17-1.218-.332-1.896-.276-.335.028-.666.049-.99.144-.205.061-.536.317-.728.324.154-.005.377-.048.525-.007.234.066.198.141.399.221.903.361 1.671.139 2.603.382z")
                    ]), M),
                    A2(Da, l([
                        Fa("path785"),
                        Ha("#dcc06d"),
                        qa("M186.252 293.854c.215-.115.417-.225.651-.272-.487.168-.058.554.224.665.967.379 2.811-.34 3.621-.817-.024-.049-.059-.055-.078-.111-.01-.13.066-.103.009-.254.555.02.914-.337 1.383-.559-.21.215-.651.798-.259.976.208.889-.973.982-1.533 1.192-.509.191-1.032.67-1.605.656-.531-.014-1.042-.384-1.477-.656-.484-.302-.921-.16-1.07-.819")
                    ]), M)
                ]))
            ]))
        ]))
    ]), tr = l([
        A2(On, l([
            Fa("g1263")
        ]), l([
            A2(Da, l([
                Fa("path1265"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".32"),
                qa("M225.594 85.563c-1.396.947-1.306 1.439-1.218 3.151.201 3.858.687 7.855.316 11.679-1.619 16.668-24.066 13.251-35.361 10.062-6.639-1.875-7.878-10.501-8.622-16.382-.304-2.41-.006-4.785-1.319-6.97-1.094-1.817-3.411-4.307-5.523-4.865-5.878-1.55-2.437 10.731-1.879 12.708.988 3.516 2.18 6.937 2.994 10.504.843 3.686.146 8.398 3.224 11.095 1.645 1.442 3.794 2.242 5.672 3.388 2.234 1.364 4.458 2.805 6.704 4.068 1.498.842 3.282 1.925 4.958 2.229 3.438.626 7.248-.141 10.738-.218 1.713-.038 3.302-.19 5.014.005 1.442.164 2.698.282 4.096-.135 2.856-.851 5.262-3.168 7.109-5.374 2.78-3.323 6.476-5.968 8.167-10.084.683-1.668 1.49-3.258 1.657-5.08.146-1.588.08-3.007.445-4.566.883-3.774.879-7.922 1.275-11.791.151-1.482.78-4.099.458-5.51-.315-1.379-1.465-1.185-2.733-.885-2.166.51-4.338 1.729-6.172 2.971z")
            ]), M),
            A2(Da, l([
                Fa("path1267"),
                Ha("#dcc06d"),
                qa("M180.671 97.257c-.433-1.708-.106-4.256-1.204-5.668-1.208 1.665-.493 4.848-.192 6.745.304 1.914.666 3.866 1.213 5.721.832 2.824 1.391 6.226 3.811 8.153-.123-1.281.088-3.156-.188-4.219-.424-1.64-1.516-3.125-1.966-4.836-.507-1.933-.977-3.937-1.474-5.896z")
            ]), M),
            A2(Da, l([
                Fa("path1269"),
                Ha("#dcc06d"),
                qa("M226.841 94.204c0-1.419.857-3.761-.398-4.831-1.354 2.1-.533 4.819-.676 7.165-.117 1.95-.137 4.008-.539 5.9-.771 3.59-3.485 6.412-3.942 9.958.99-1.469 2.693-2.175 3.638-3.513.862-1.223 1.973-4.445 2.105-5.91.252-2.769-.188-5.935-.188-8.769z")
            ]), M),
            A2(Da, l([
                Fa("path1271"),
                Ha("#dcc06d"),
                qa("M176.911 102.834c.301 1.897.524 3.867.447 5.791-.051 1.271-.774 3.651-.214 4.843-.79-1.684-.955-2.781-.729-4.593.979-7.829-5.447-14.351-4.428-22.161 2.4 1.176 3.453 5.546 3.876 7.926.483 2.718.618 5.474 1.048 8.194z")
            ]), M),
            A2(Da, l([
                Fa("path1273"),
                Ha("#dcc06d"),
                qa("M233.099 85.631c-1.524 1.021-1.704 5.275-2.09 6.927-.744 3.188-1.48 6.411-1.486 9.7-.004 2.134 1.138 3.813 1.569 5.85.362-3.899.756-7.57.756-11.562 0-2.877.179-5.463.938-8.237.137-.502.733-3.969-.224-2.5")
            ]), M),
            A2(Da, l([
                Fa("path1275"),
                Ha("#dcc06d"),
                qa("M207.924 122.983c1.416-.304 2.527.705 3.668 1.446a10.969 10.969 0 0 1-.78-1.237c.766.462 1.623.998 2.416 1.398-.785-1.423-2.811-1.891-3.909-3.201-.807-.961-1.205-1.777-1.227-3.013.156-.03.297-.029.448-.053-.162.026-1.51-2.154-1.67-2.406-.075.511.228 7.244 1.054 7.066z")
            ]), M),
            A2(Da, l([
                Fa("path1277"),
                Ha("#dcc06d"),
                qa("M219.352 119.52c-.512 1.744-1.233 3.222-2.321 3.277.825-3.046 2.578-5.75 3.525-8.682-.283.878-.597 3.329-1.204 5.405z")
            ]), M),
            A2(Da, l([
                Fa("path1279"),
                Ha("#dcc06d"),
                qa("M222.193 118.351c.616-1.468 2.484-2.291 3.585-3.354 1.175-1.136 2.398-2.515 3.22-3.913-.564 1.648-1.669 3.289-2.864 4.581-1.358 1.469-3.32 2.029-4.655 3.58")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1281"),
            Ha("#dcc06d"),
            qa("M190.483 116.345c-.086-.996-.082-2.143-.343-3.09-.615.229-.527.7-.395 1.233.158.633.68 1.195.738 1.857z")
        ]), M),
        A2(Da, l([
            Fa("path1283"),
            Ha("#dcc06d"),
            qa("M217.436 113.434c-.917.122-.876 1.884-.808 2.642.175-.713 1.235-2.095.674-2.642")
        ]), M),
        A2(Da, l([
            Fa("path1285"),
            Ha("#dcc06d"),
            qa("M187.531 112.361c.1.161.22.302.362.424-.312.527.269 1.234.516 1.714-.144-.643-.185-1.703-.744-2.004")
        ]), M),
        A2(Da, l([
            Fa("path1287"),
            Ha("#dcc06d"),
            qa("M194.906 114.239c.18.5.458.881.925 1.105-.703.665.422 3.003.899 3.738-.893-.833-1.954-3.647-1.833-4.937.164.19.31.412.412.63")
        ]), M),
        A2(Da, l([
            Fa("path1289"),
            Ha("#dcc06d"),
            qa("M211.669 115.042c.335-.289.667-.557 1.055-.757-.081.272-.136.69-.262.976.023-.052.063-.072.121-.061-.247.609-.066 1.433.151 1.948.51-.942 1.064-1.988 1.73-2.866-.6 1.161-1.465 2.407-1.758 3.7-.023-.038-.083-.17-.13-.245a1.977 1.977 0 0 0-.512 1.164c.207-.637.661-2.19.243-2.733a4.605 4.605 0 0 0-.211.178c-.032-.189-.032-.316-.149-.469-.141.221-.45.449-.555.727.151-.566.258-1.109.141-1.696")
        ]), M),
        A2(Da, l([
            Fa("path1291"),
            Ha("#dcc06d"),
            qa("M198.795 115.312c.331-.502.661-.7.879-1.227-.007-.046-.072.299-.058.264.154-.044.475-.069.633-.098-.331 1.32-.271 2.762-.483 3.95-.087-1.077-.517-2.081-.569-3.159")
        ]), M),
        A2(Da, l([
            Fa("path1293"),
            Ha("#dcc06d"),
            qa("M203.758 114.641c-.889.328-.279 1.652-.239 2.412.279-.63.104-1.677.104-2.412")
        ]), M),
        A2(Da, l([
            Fa("path1295"),
            Ha("#dcc06d"),
            qa("M207.513 114.775c.334.1.582.187.654.514l-.234.039c.03.372.085.783.192 1.15-.503-.767-.973-1.527-.617-2.47.101.381.277.743.54 1.035")
        ]), M),
        A2(On, l([
            Fa("teethLower"),
            Ha("#e1e2e3"),
            Ua("#967348")
        ]), l([
            A2(Da, l([
                Fa("path1299"),
                Ba(".392"),
                qa("M187.446 111.308c.369.319 1.467.815 1.987.454.616-.429 1.131-1.929.675-2.598-1.524-2.238-4.84.253-2.662 2.144z")
            ]), M),
            A2(Da, l([
                Fa("path1301"),
                Ba(".392"),
                qa("M190.753 108.981c-.256-.54-.982-1.114-1.607-1.103-.284.005-1.228.342-1.333.654-.326.979-.042 2.463.544 3.379.192.3.479.643.805.785.559.243.498.077.894-.34.25-.265.848-.632.965-.975.139-.405-.077-1.999-.268-2.4z")
            ]), M),
            A2(Da, l([
                Fa("path1303"),
                Ba(".392"),
                qa("M191.06 108.159c-.729-.111-1.181-.753-1.63.002-.238.399-.207 1.061-.157 1.517.087.805.721 2.747 1.537 3.112 1.046.466 2.007-.44 2.023-1.5.004-.305-.348-.973-.409-1.33-.06-.354-.034-.854-.177-1.179-.313-.704-1.13-.533-1.634-.979")
            ]), M),
            A2(Da, l([
                Fa("path1305"),
                Ba(".392"),
                qa("M191.854 112.129c.502.577 1.644 1.77 1.69 1.74 1.784-1.154 1.464-6.016-1.117-6.122-1.906-.078-1.362 3.1-.796 4.102.026.045.107.145.223.28z")
            ]), M),
            A2(Da, l([
                Fa("path1307"),
                Ba(".38"),
                qa("M197.309 108.998a.976.976 0 0 1 .147.373c.129.741-.391 2.065-.589 2.8-.177.658-.348 1.571-.964 1.954-.929-.784-2.534-5.406-.604-5.799.666-.136 1.63.091 2.01.672z")
            ]), M),
            A2(Da, l([
                Fa("path1309"),
                Ba(".392"),
                qa("M200.069 109.005c.879.475-.283 4.976-1.253 5.171-.955.191-1.341-2.724-1.386-3.344-.132-1.836.925-2.753 2.639-1.827z")
            ]), M),
            A2(Da, l([
                Fa("path1311"),
                Ba(".427"),
                qa("M203.231 108.776c.604.191.168 2.661.07 3.096-.128.569-.184 1.902-.774 2.21-1.282.672-1.72-1.936-1.793-2.648-.054-.518-.326-1.221-.304-1.718.061-1.371 1.888-1.226 2.801-.94z")
            ]), M),
            A2(Da, l([
                Fa("path1313"),
                Ba(".392"),
                qa("M220.015 111.412c-.373.314-1.478.795-1.992.427-.612-.437-1.107-1.944-.64-2.607 1.553-2.216 4.835.318 2.632 2.18z")
            ]), M),
            A2(Da, l([
                Fa("path1315"),
                Ba(".392"),
                qa("M216.737 109.042c.265-.537.998-1.102 1.624-1.081.283.009 1.224.358 1.324.671.313.984.011 2.464-.589 3.372-.196.297-.488.636-.815.774-.563.236-.499.07-.889-.352-.248-.268-.84-.643-.953-.987-.133-.409.104-1.999.298-2.397z")
            ]), M),
            A2(Da, l([
                Fa("path1317"),
                Ba(".392"),
                qa("M216.442 108.215c.731-.101 1.189-.738 1.632.024.23.402.192 1.064.136 1.52-.1.804-.757 2.737-1.578 3.091-1.051.452-2.001-.466-2.003-1.527 0-.305.363-.969.427-1.325.066-.355.044-.855.192-1.177.322-.699 1.139-.518 1.647-.957")
            ]), M),
            A2(Da, l([
                Fa("path1319"),
                Ba(".392"),
                qa("M215.596 112.174c-.51.57-1.668 1.749-1.715 1.718-1.768-1.177-1.382-6.034 1.201-6.107 1.907-.052 1.32 3.118.742 4.113a2.644 2.644 0 0 1-.228.276z")
            ]), M),
            A2(Da, l([
                Fa("path1321"),
                Ba(".38"),
                qa("M210.185 108.972a.945.945 0 0 0-.153.369c-.139.741.365 2.072.552 2.809.167.66.326 1.575.937 1.966.94-.772 2.606-5.372.682-5.791-.666-.143-1.632.071-2.018.647z")
            ]), M),
            A2(Da, l([
                Fa("path1323"),
                Ba(".392"),
                qa("M207.422 108.942c-.885.462.218 4.979 1.187 5.187.951.204 1.375-2.707 1.428-3.325.156-1.836-.887-2.764-2.615-1.862z")
            ]), M),
            A2(Da, l([
                Fa("path1325"),
                Ba(".427"),
                qa("M204.454 108.974c-.6.2-.126 2.663-.021 3.096.136.567.215 1.9.809 2.199 1.292.652 1.689-1.963 1.751-2.677.045-.519.307-1.225.277-1.722-.084-1.372-1.908-1.198-2.816-.896z")
            ]), M)
        ]))
    ]), ar = l([
        A2(Da, l([
            Fa("path1635"),
            Ha("#f7daa1"),
            Ua("#967348"),
            Ba(".322"),
            qa("M198.285 156.462c-.878-.534-1.495-.886-2.503-.336-1.831.997-2.875 3.3-4.267 4.8-2.2 2.373.162 4.869-1.685 7.455-1.48 2.072 1.408 4.104 2.761 5.792.932 1.165 1.412 3.727 3.318 3.517 1.073-.117 1.875-.897 3.022-1.032 1.326-.156 2.667-.065 3.996-.144 3.121-.186 9.11 2.885 10.73-1.109.572-1.408 1.395-2.658 2.283-3.937 1.09-1.568.65-2.295.752-4.123.064-1.135.151-3.473 1.402-3.958-.499-2.655-3.055-6.365-5.366-7.792-1.494-.919-2.434.104-3.763.679-1.452.627-3.206 1.26-4.795 1.436-2.032.224-3.815-.012-5.546-1.041l-.339-.207z")
        ]), M),
        A2(Da, l([
            Fa("path1637"),
            Ha("#f9e3b7"),
            qa("M192.651 159.848c.53 2.259 3.574-.936 3.371-2.629-.504.484-3.495 3.081-4.003 2.805")
        ]), M),
        A2(Da, l([
            Fa("path1639"),
            Ha("#f9e3b7"),
            qa("M217.084 160.277c-.437-.158-1.077-.762-1.521-1.007-.474-.261-.876-.41-1.303-.789-.842-.747-1.512-1.754-2.101-2.707-.676 1.397.749 3.07 1.668 3.979.484.479 1.218 1.138 1.928 1.229.079.01 1.521-.166 1.222-.422-.11-.095-.241-.293-.38-.382.146.023.33.041.487.099z")
        ]), M),
        A2(Da, l([
            Fa("path1641"),
            Ha("#f9e3b7"),
            qa("M205.249 175.759c.779.245 1.988.414 2.649-.123.962 2.395 6.75-2.63 4.929-4.566.721-1.321 1.787-2.596 2.225-4.044-.058 1.704-.348 3.799-.708 5.482-1.606.521-1.544 2.966-3.059 3.57-.979.392-3.364-.31-4.605-.32")
        ]), M)
    ]), nr = l([
        A2(On, l([
            Fa("g1893")
        ]), l([
            A2(Da, l([
                Fa("path1895"),
                Ha("#f9ce82"),
                Ua("#967348"),
                Ba(".322"),
                qa("M351.842 448.766c-.454-.8-.817-1.481-1.438-2.176-1.062-1.18-.207-2.779-.364-4.136-.215-1.814-.74-3.552-1.281-5.291-.601-1.915-1.284-3.817-1.927-5.721-.368-1.095-1.285-1.808-1.97-2.646-.354-.433-.635-.927-.621-1.53.009-.399.011-1.152.193-1.497.47.249 1.014-.271 1.178-.665.175-.418.043-1.069.457-1.392.226-.176.402-.044.605-.094.2-.047.375-.239.528-.272.429-.095.811.3 1.259.076.313.43.614.903.87 1.371.234.426.247.894.432 1.307.146.335.466.679.643 1.027.192.381.342.785.517 1.169-.365.681.398 1.472.058 2.205-.198.424-.497.508-.445.998.092.887.537 1.887.738 2.763.263 1.149.685 2.294 1.092 3.398.431 1.173.846 2.359 1.373 3.49.318.688.74 1.343 1.341 1.816.583.457 1.303.54 1.562 1.344.207.637.387 1.349.495 2.013.1.642-.271 1.671-.757 2.098-.486.426-.973.773-1.593.982-.775.263-2.494.156-2.945-.637z")
            ]), M),
            A2(Da, l([
                Fa("path1897"),
                Ha("#dcc06d"),
                qa("M350.308 445.567c-.514.164-.278-1.176-.249-1.389.038-.268.106-.543.13-.811.05-.564-.139-1.128-.191-1.686-.045-.456-.054-.911-.099-1.361.158.291.175.787.263 1.126.11.444.175.913.362 1.334.181.406.315.856.524 1.253a2.867 2.867 0 0 0-.467.928c-.026.091.006.222-.043.304-.075.128-.286.158-.342.277")
            ]), M),
            A2(Da, l([
                Fa("path1899"),
                Ha("#dcc06d"),
                qa("M351.446 439.238c-.399-.947-.724-1.93-1.159-2.862-.404-.862-.723-1.772-.857-2.721-.036-.271-.123-.498-.197-.76-.071-.247.062-.854-.147-.949-.05.108-.058.225-.107.331-.258-.278-.288-.941-.249-1.281.281.169.343.663.588.911.156-.656.745-1.118.485-1.864-.144-.4-.457-.613-.798-.794-.305-.159-.807-.533-1.167-.489.168.014.471-.003.488-.225.021-.271-.344-.314-.51-.391-.271-.127-.497-.359-.747-.57.131.063.23-.021.351.011.158.04.328.178.488.243.228.096.367.181.604.063.192.143.278.436.418.631.482-.289.881 1.002 1.378.604-.06-.074-.081-.162-.171-.213.028-.011.043-.001.071-.009-.002-.316-.119-1.32-.581-1.256.245-.135.418-.607.736-.516.008.277.106.324.224.539.143.259.043.386.058.624.002.038.083.183.097.274.017.135-.014.269-.01.399.012.217.142.496.109.668-.077-.041-.173-.041-.256-.087.182.234.352.648.245.924-.13.341-.501.413-.557.838-.047.349.078.71.194 1.034.27.772.396 1.619.616 2.416.459 1.663 1.335 3.202 1.926 4.82.236.646.429 1.302.706 1.934.382.87.877 1.493 1.74 1.922.555.276 1.013.446 1.225 1.085.182.554.092 1.155.151 1.727.076.707.171 1.427-.555 1.829-.016-.511.096-1.124-.616-1.192-.456-.041-1.146.34-1.524.592-.111-.411-.463-.404-.867-.352.032-.227-.089-.389-.253-.539.243-.024.506.055.753.03.339-.033.724-.173 1.04-.291.232-.086 1.32-.536 1.116-.886-.043.037-.126.056-.169.092-.072-.274-.213-.992.169-1.154.481-.203.094.967.121 1.163.306-.179.436-.937.333-1.258-.149-.479-1.212-.937-.964-.155-.012-.007-.041-.031-.06-.04.188 1.042-.356 1.738-1.374 1.903-.211.034-.45.052-.663.015-.03-.006-.348-.117-.356-.113-.153.066-.056.334-.367.374.071-.649-1.045-1.282-1.179-.451-.103.638.279 1.028.454 1.574.102.316.015.691.232 1.004-.553-.31-.401-.742-.463-1.269-.056-.476-.445-1.085-.368-1.551.065-.388.577-.807.786-1.17.265-.467.547-.85.486-1.428-.051-.47-.335-.996-.461-1.466-.204-.753-.333-1.553-.636-2.272z")
            ]), M),
            A2(Da, l([
                Fa("path1901"),
                Ha("#dcc06d"),
                qa("m346.079 428.899-.173-.331c-.179-.339-.559-.998.075-1.142-.007.31-.216.618-.265.93-.077.477.03.963.283 1.355-.033-.435.161-.312.358-.12.201.195.583.699.922.512.051.188.45.399.484.081-.004.047-.746-.313-.8-.343-.468-.252-.671-.547-.884-.942z")
            ]), M),
            A2(Da, l([
                Fa("path1903"),
                Ha("#dcc06d"),
                qa("M347.971 427.03c-.122-.026-.229-.102-.269-.208.684.09 1.402.1 1.541-.743.374.042.024.603-.087.759.245.047.32-.135.411-.305 1.063.21-.597 1.426-.921.792.076-.04.104-.122.162-.171-.448-.161-.742.126-1.113-.331")
            ]), M),
            A2(Da, l([
                Fa("path1905"),
                Ha("#dcc06d"),
                qa("M349.038 426.023c-.084.043-.18.271-.277.343-.119.09-.261.145-.405.176a1.087 1.087 0 0 1-.698-.059c-.4-.173-.802-.63-.778-1.091.502.218.704.635 1.31.386.32-.131.639-.633.095-.574.094-.419-.501-.359-.648-.133.06-.113.03-.177.008-.271-.117.153-.232.337-.337.494-.239-.145-.021-.374-.178-.568-.125-.158-.445-.126-.573.008-.102.108-.132.138-.094.287.028.114.205.156.214.198.053.239-.239.51-.346.731.029-.135.209-.389.2-.526-.015-.176-.236-.235-.245-.434-.01-.311.605-.815.909-.63.008-.113.051-.259.153-.327.149.147.09.38.171.55.161-.221.334-.558.283-.843-.009-.047.445.104.497.173.309-.328.731 1.089.748 1.306.041.551-.189 1.068-.823.998.171-.032.312.046.477.003.117-.03.229-.142.337-.197z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1907")
        ]), l([
            A2(On, l([
                Fa("g1909")
            ]), l([
                A2(Da, l([
                    Fa("path1911"),
                    Ha("#f9ce82"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M344.235 425.82c-.058.111-.142.234-.25.406-.488.776-1.057 1.649-1.169 2.562-.039.311.055.51.074.817.101 1.639.333 3.172.529 4.795.141 1.157.725 2.198.762 3.396.044 1.561.117 3.417 1.149 4.659.299.361.83.652 1 1.104.419 1.107.713 2.275-.265 3.311-.476.506-1.559.735-2.221.724-.696-.012-1.379-.257-1.878-.723-.331-.308-.192-.412-.284-.812-.186-.802-1.088-1.247-1.184-1.971-.044-.344.143-.633.173-.972.036-.416-.096-.841-.1-1.255-.01-.856.046-1.63-.14-2.472-.256-1.16-.563-2.31-.813-3.47-.168-.767-.104-1.586-.215-2.352-.07-.477-.132-.933-.281-1.401-.062-.195-.252-.515-.242-.713.007-.169.23-.195.244-.401.027-.385-.269-.671-.304-1.021-.006-.071.19-.101.185-.218-.003-.109-.113-.229-.133-.338-.03-.162-.104-.308-.175-.467-.289-.65-.418-.692-.237-1.369.16-.592.445-1.384.284-1.959-.047-.172-.227-.225-.256-.48-.028-.222.104-.721.22-.906.108-.176.303-.207.448-.406.195-.272.173-.603.292-.899.999-.188 1.629-.364 2.407.294.597.508 1.201.99 1.824.293-.043.046.586 1.38.616 1.561.056.331.038.49-.06.683z")
                ]), M),
                A2(Da, l([
                    Fa("path1913"),
                    Ha("#dcc06d"),
                    qa("M342.312 446.797c-.694-.274-.255-1.012-.362-1.506-.09.108-.222.2-.368.19.107.319.29 1.067.614 1.229")
                ]), M),
                A2(Da, l([
                    Fa("path1915"),
                    Ha("#dcc06d"),
                    qa("M344.708 445.497c.718-.001.959.288 1.004.923.471-.938.876-1.505.5-2.51a1.989 1.989 0 0 0-.545-.819c-.201-.189-.542-.344-.672-.586.121-.185-.096-.37-.205-.527-.253-.36-.373-.705-.506-1.123-.253-.794-.28-1.66-.514-2.461-.451.002-.488-1.502-.55-1.836-.122-.636-.237-1.132-.151-1.786.01-.103.094-.375.081-.468-.023-.19-.092-.128-.167-.286a1.996 1.996 0 0 1-.193-.621c-.115-.9-.143-1.815-.095-2.726.043-.794-.104-1.681.064-2.462.106-.494.393-.955.644-1.401.093-.159.192-.332.3-.479.188-.261.179-.221.189-.495.01-.32.094-.656.056-.977-.009-.069-.284-.804-.395-.723-.729.537-1.865-.67-2.454-.936-.496-.225-.434.096-.773.361-.258.201-.537.265-.688-.065-.189.217-.391.29-.569.56-.171.251-.239.576-.432.799.354-.305.852-.915 1.343-.877.052-.166.366-.53.568-.514.222.014.273.256.034.359.645-.261 1.856.938 1.184 1.159-.272.087-.424.178-.723.125-.344-.06-.512-.392-.809-.438-.318-.044-1.083.516-1.224.75-.105.176-.06.524.025.744.563-.263.897-.919 1.557-1.063.529-.118 1.038.104 1.529.247.443.129.913.217 1.32.449.013.008-1.694 2.364-1.746 2.65-.127.68.219 1.386.181 2.08-.032.568-.056 1.169-.004 1.74.04.463.238.881.303 1.338.179 1.289.587 2.531.76 3.826.132.987.228 1.986.187 2.988a10.963 10.963 0 0 1-.168 1.544c-.078.421-.318.872-.333 1.293.414-.213.859.335.975.657.074.202.024.436.056.637.062.38.072.308.481.382.342.065.57.138.575.568z")
                ]), M),
                A2(Da, l([
                    Fa("path1917"),
                    Ha("#dcc06d"),
                    qa("M341.486 440.142c-.109-.199-.111-.418-.215-.625-.058-.114-.296-.264-.324-.324-.069-.159-.006-.347-.098-.52.115.027.659.351.721.442.192.274-.121.765.03 1.11")
                ]), M),
                A2(Da, l([
                    Fa("path1919"),
                    Ha("none"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M342.29 443.389c.932-.591 1.414.937.936 1.555-.479.621-1.354.218-1.477-.435-.077-.397.168-.883.541-1.12z")
                ]), M),
                A2(Da, l([
                    Fa("path1921"),
                    Ha("#dcc06d"),
                    qa("M342.255 444.767a.576.576 0 0 1-.081-.364c.249-.248.552-.135.589.177.762-.096.39-1.214-.265-1.11-.545.088-.832.945-.329 1.219")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1923"),
                Ha("#ccb25c"),
                qa("M343.298 444.729c-.038-.244-.05-.941-.51-.741a.817.817 0 0 1 .341.747")
            ]), M),
            A2(Da, l([
                Fa("path1925"),
                Ha("#ccb25c"),
                qa("M346.201 446.07c-.13-.084-.307-.122-.416-.196.486-.359.107-1.514-.162-1.872.268.132.337.455.574.577.023-.045.06-.092.083-.145.222.316.2 1.48-.232 1.579")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1977")
        ]), l([
            A2(On, l([
                Fa("g1979")
            ]), l([
                A2(Da, l([
                    Fa("path1981"),
                    Ha("#f9ce82"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M369.174 417.92c.176.059.276.209.466.249.277.059.265-.067.499-.083.418-.028.83.148 1.241.132.446-.013.809-.282 1.218-.419.576-.193 1.231-.2 1.828-.214 1.111-.028 2.248-.03 3.357.071.42.039.812.144 1.239.153.449.007.921-.078 1.35.105.471.203.277.319.243.648-.021.208-.16.174-.058.386.04.086.381.277.478.314.281.105.87.167.96-.199 2.059.551 3.9-.829 3.662-3.032-.066-.647-.474-1.541-.983-1.968-.66-.556-2.133-.627-2.969-.696-.657-.051-1.312-.022-1.969-.091-.26-.025-.634-.236-.857-.223-.252.014-.49.231-.753.281-.563.108-1.175-.139-1.778-.088-.852.072-1.662.208-2.523.091-.724-.099-1.356-.416-2.061-.55-.563-.107-.921-.537-1.446-.653-.513-.112-1.058.189-1.398.582-1.664-.225-1.631 1.768-2.022 2.881-.149.427-.349.972-.042 1.374.294.384.678.698 1.146.837.388.118.794-.019 1.172.112z")
                ]), M),
                A2(Da, l([
                    Fa("path1983"),
                    Ha("#dcc06d"),
                    qa("M369.956 416.268c-.373-.193-.505-.498-.962-.53-.025-.268.25-.297.403-.422-.016.012.117-.263.121-.269.061-.088.247-.033.333-.186-.155-.059-.569-.214-.607-.419-.06-.32.232-.301.441-.466-.018-.062-.009-.127-.02-.168.441-.021.871.211 1.314.245-.135-.21-.495-.229-.702-.405.216-.253.578-.032.878-.079-.236-.313-.893-.32-.696-.834-.428-.172-1.318.476-.915.93-.247.144-.497-.123-.704-.003-.196.116-.211.55-.205.721.026-.012.088-.044.122-.058.192.104.226.319.164.526a1.164 1.164 0 0 0-.063.014c-.237-.407-.9.245-1.104.515-.283.379-.64.658-.901 1.067-.219-.461.151-.898.338-1.299.27-.576.244-1.12.396-1.698.162.152.18.427.18.658.272-.145.228-.387.302-.625.058-.186.113-.373.176-.556.28.037.652.045.906-.113.368-.233.478-.603.972-.519.439.076.95.531 1.368.712.595.258 1.26.33 1.897.396.675.069 1.371.231 2.057.106.46-.085.751-.251 1.23-.129.572.148 1.092.453 1.719.351-.209-.88 2.681-.107 3.075-.098.578.013 1.193-.029 1.76.092.693.147 1.385.286 1.736.939.312.579.506 1.303.429 1.961-.056.505-.429 1.52-.962 1.633-.064-.301-.025-.654-.066-.959-.032-.247-.11-.14.005-.4.066-.147.324-.29.433-.416.205-.238.482-.59.306-.939-.276-.538-1.197-.013-1.034.416-.176-.458-.461-.231-.779-.167-.366.075-.531-.071-.713.348-.139-.604-.716-1.13-1.261-.488-.527.62 1.235.895 1.615.638-.021.168.141.403.111.533-.018.079-.254.153-.252.171.033.401.063.164.388.216.216.035.409.148.638.148-.221.116-.768.476-.975.339-.029.135-.11.185-.067.364a1.423 1.423 0 0 0-.274-.385c-.155.124-.487.32-.558.51-.068.186.002.624-.033.838-.183-.762-.848-.861-1.176-.121-.092-.48.058-.999-.453-1.286.318-.633.261-.307.768-.113.396.15.65-.168.857.383.529-.078 1.052-.578.509-1.002-.133-.102-.353-.101-.549-.201-.198-.103-.382-.263-.555-.38-.541-.363-.171-.834-.923-.865-.322-.013-1.873.425-1.401-.459.256-.481 1.051-.243 1.443-.491-.269-.258-.679-.368-1.037-.426-.117.566-.909.238-1.281.233-.533-.01-1.062.104-1.591.153-.989.087-1.964-.242-2.956-.154-.537.048-.814.214-1.363.142-.185-.024-.578-.13-.728.047-.181.217-.002.425.269.459-.527.163-.667.051-1.2-.024-.773-.108-.373.479.072.489-.029.248.139.461.322.603-.296.085-.518-.226-.789-.131-.116.042-.414.392-.18.469")
                ]), M),
                A2(Da, l([
                    Fa("path1985"),
                    Ha("#dcc06d"),
                    qa("M371.261 417.871c-.284-.037-.333-.299-.281-.539-.312-.007-.743.018-.871.378.243.059.99.273 1.009.06")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1987"),
                Ha("none"),
                Ua("#967348"),
                Ba(".14"),
                qa("M381.902 419.162c-.557.572-1.845-.028-1.297-.819.358-.513 1.749.117 1.328.771")
            ]), M),
            A2(Da, l([
                Fa("path1989"),
                Ha("none"),
                Ua("#967348"),
                Ba(".14"),
                qa("M382.75 416.068c-.661.78-2.27-.302-1.324-.981.635-.456 1.792.724 1.245.996")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2079")
        ]), l([
            A2(On, l([
                Fa("g2081")
            ]), l([
                A2(Da, l([
                    Fa("path2083"),
                    Ha("#f9ce82"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M363.342 423.511c.61.838 1.241 1.678 1.7 2.611.498 1.021.69 2.17.846 3.283.243 1.735.894 3.373 1.134 5.114.244 1.797.276 3.704.765 5.459.241.865.108 1.834.411 2.647.09.243.248.407.332.638.087.242.067.505.172.739.596 1.348 2.395 1.776 3.709 1.55.742-.128 1.431-.192 1.845-.908a4.133 4.133 0 0 0 .488-2.737c-.112-.656-.398-1.086-.716-1.663-.479-.873-.817-1.931-1.314-2.842-.409-.757-1.005-1.408-1.312-2.188a29.66 29.66 0 0 1-.861-2.525c-.544-1.878-1.391-3.655-1.947-5.542-.423-1.437-.869-2.898-.94-4.405-.058-1.261.467-2.849-.271-4.008-.179-.286-.459-.395-.659-.656-.147-.194-.106-.314-.233-.506-.233-.35-.706-.603-1.124-.679-.558-.103-.645.283-1.026.633-.367.337-.774.549-1.27.543-.672-.009-1.353-.505-2.036-.378-.905.165-.387 1.538-.109 2.094.35.697.938 1.121 1.165 1.873.218.736.797 1.231 1.251 1.853z")
                ]), M),
                A2(Da, l([
                    Fa("path2085"),
                    Ha("#dcc06d"),
                    qa("M362.598 421.626c-.368-.139-.683-.75-.512-1.072-.419-.194-.367-.53.063-.496.354.026.683.487.725.803.461-.461 1.329-.236 1.107.511.066.099.119.181.177.293-.023.032-.025.03-.004-.008.009-.044.036-.066.076-.067.107.511.595.942 1.078 1.113.022-.081-.008-.179-.037-.261.06-.032.154-.046.177-.124-.754-.148-.804-.649-.903-1.322-.004.285-.02.637-.353.659-.332-.521.333-1.624-.531-1.632-.369-.001-.505.261-.919.181-.243-.046-.535-.186-.702-.374-.123-.142.888-.284.935-.305.166-.074.322-.347.558-.433.41-.154 1.164-.122.771.486.349.217.573.037.657-.284-.126-.144-.207-.366-.245-.544.065-.033.136-.038.203-.06-.014-.036-.089-.157-.094-.187.219-.195.286-.511.349-.783.31.143 1.146 1.633.415 1.505.291.404-.242.553.09 1.08.338.534 1.059.839 1.197 1.531.121.602-.29.653-.487 1.107-.557 1.301.619 1.991.92 3.15.478 1.85 1.054 3.718 1.432 5.585.402 2.004.386 4.039 1.168 5.961.117.294.489.78.429 1.096-.058.296-.441.443-.497.791-.098.631.668.647.905 1.43.283-.048.579.017.863.073-.392-.079.102-.598.335-.612.312-.02.764.339 1.05.45-.097-.226-.152-.417-.077-.644.499.054.917.647.543 1.096-.08.097-.251.125-.287.226-.032.09.054.399.063.499.017.148.038.303.076.45.046-.173.024-.688.351-.644.352.05.467.555.056.613.092.082.213.037.312.096.398.239 0 .835-.071 1.141.099-.366-.303-.534-.569-.199.061-.71-.247-1.169-.326-1.879-.204.354-.265.826-.773.603-.444-.196-.194-.86-.708-1 .26.304.146.769.535.948-.454.725-.778-.502-1.109.001-.299-.14-.365-.6-.58-.829-.058.355-.011.578-.006.863.002.216.283.683-.187.453.099.267 0 .313-.085.526-.484-.043-.502-.734-.866-1.022-.768-.61-.514-.044-.46.528.119-.894 1.137 1.152 1.31 1.273-.444-.966.368-.66.989-.759.49-.078.354-.104.708-.455.252-.251.388-.452.785-.438-.025.375-.51 1.603-.924 1.258.122.273.137.588.207.876.249-.194.711-.491 1.013-.294.299.196.252.565-.004.778.441.293-.593.518-.766.548.633-.007 1.558-.254 1.886-.856.191-.354.388-.732.52-1.117.263-.779.067-1.854-.341-2.552-.391-.668-1.211-1.15-1.422-1.901.328-.089.593.445.723.703-.521-1.751-1.73-3.182-2.442-4.849-.679-1.579-1.005-3.236-1.591-4.844-.513-1.406-1.046-2.814-1.502-4.239-.42-1.314-.672-2.435-.563-3.847.036-.479.561-3.017-.271-2.884.123-.365-.201-.626-.538-.732.081.119.079.234.13.336-.324-.105-.503-.43-.572-.748.048 0 .082-.02.1-.057-.347-.193-.903-.606-1.304-.584.053-.093.1-.273.162-.368-.523.419-.965.948-1.636 1.105-.724.165-1.54-.071-2.268-.136.478.256 1.005.501 1.581.533.332.018 1.162.025 1.354-.265-.132.001-.279-.053-.398-.048.29-.157 2.198-1.261 1.91-.043-.545-.133-.644.371-1.068.575-.276.133-.396.002-.601.059-.316.085-.376.202-.646.351-.431.235-.904.335-1.385.123-.366-.161-.533-.738-.921-.759-.149.592.371 1.471.622 1.997.174.361.857 1.069.86 1.208")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2087"),
                Ha("none"),
                Ua("#967348"),
                Ba(".14"),
                qa("M373.521 441.339c.927-.021.829 1.573.052 1.205-.472-.224-.832-1.189-.052-1.205z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2089")
        ]), l([
            A2(Da, l([
                Fa("path2091"),
                Ha("#f9ce82"),
                Ua("#967348"),
                Ba(".322"),
                qa("M351.667 421.68c.265-.512 1.237-.356 1.691-.357.559.002 1.156-.057 1.694-.039.276.011.362.026.601-.04.303-.083.167-.184.51-.104.313.073 1.061.524 1.197.822.153.339.128.833.26 1.219.21.594.367 1.153.506 1.766.128.589.271 1.167.364 1.764.094.604-.01 1.182.05 1.781.044.446.191.856.311 1.279.254.916.416 1.875.685 2.799.606 2.079 1.416 4.25 2.482 6.148.713 1.262 1.575 2.421 2.528 3.507.396.45.865.768 1.22 1.257.505.704.593 1.454.551 2.297-.028.605.012 1.462-.37 1.944-.328.413-.94.795-1.396 1.026-.646.325-1.882.974-2.628.854-.405-.066-.519-.432-.755-.741-.367-.483-.776-.928-1.115-1.429-.306-.447-.445-.59-.873-.846-.314-.189-.597-.457-.725-.814-.308-.863.136-1.8.053-2.687-.11-1.18-.567-2.337-.947-3.45-.185-.543-.276-1.125-.345-1.703-.113-.965-.38-1.895-.652-2.829-.328-1.136-.735-2.255-1.109-3.376-.286-.853-.561-1.697-1.011-2.484-.388-.678-1.508-1.522-1.438-2.303-.396-.014-.446-.213-.645-.498-.128-.185-.291-.334-.414-.521-.231-.357-.177-.283-.213-.684-.074-.89-.328-1.488-.614-2.314.003.007.461-.453.497-.558.078-.219-.048-.49.05-.686z")
            ]), M),
            A2(Da, l([
                Fa("path2093"),
                Ha("#dcc06d"),
                qa("M351.72 423.417c.472.617.525 1.348.79 2.025.215-.287.44-.456.418.006-.018.301-.105.729-.316.949-.227-.205-.399-.457-.441-.764-.096-.667-.096-1.241-.398-1.9")
            ]), M),
            A2(Da, l([
                Fa("path2095"),
                Ha("#dcc06d"),
                qa("M352.958 426.905c.18-.162.147-.4.253-.573.104.175.414.969.092 1.095-.239.091-.096-.502-.345-.522")
            ]), M),
            A2(Da, l([
                Fa("path2097"),
                Ha("#dcc06d"),
                qa("M358.657 441.763c.209.909.228 1.973.586 2.819.628-.1.807-1.547.859-2.006.205.349.267.358.61.339.336-.02.564.042.584.453.414-.201.293-.423.685-.149.295.206.565.225.753.553.188.322.477.415.616.747.088.203-.076.229.214.3.126.03.196-.055.326-.017.126-.204.011-.498.06-.734.101.122.237.208.373.282.006-.027.006-.054.014-.073.202.452.667.868.678 1.396-.108-.103-.377-.188-.533-.101.03.044.034.127.061.173-.293.066-.118.289-.129.481-.18.034-.687-.094-.774-.304-.083-.207.151-.178.107-.381-.081-.394-.668.071-.855.062-.322-.021-.902-.606-1.221-.244-.343.388.598.933.827 1.058-.151.083-.422-.149-.627-.119-.39.058-.302.368-.428-.186-.077-.338-.352-.466-.561-.742-.201-.266-.387-.73-.73-.821-.64-.172-.746.613-.646 1.041.129.548.397 1.081.596 1.581-.358-.229-.655-.541-.996-.789-.258-.189-.447-.348-.563-.654-.28-.73.019-1.4.074-2.128.094-1.267-.446-2.357-.809-3.544-.232-.768-.602-1.75-.324-2.561-.079.397.113.908.218 1.287.276 1.014.715 1.957.955 2.981z")
            ]), M),
            A2(Da, l([
                Fa("path2099"),
                Ha("#dcc06d"),
                qa("M361.43 437.946c.444.827.865 1.63 1.415 2.397.367.515.678 1.028 1.157 1.453.457.406.941.82 1.321 1.307.77.987 1.188 2.42.599 3.574.025-.711-.036-1.275-.368-1.939-.111-.221-.16-.41-.335-.591-.122-.128-.232-.148-.302-.323-.094-.247.06-.528.088-.763-.226-.108-.665.002-.687.288-.497.002-1.48-1.223-1.943-.438-.202-.193-.157-.343-.458-.34a.608.608 0 0 0-.533.329c.171-.665-.006-1.611-.144-2.271-.166-.803-.521-1.586-1.104-2.171.119.504-.149.989-.032 1.505.057.245.116.507.219.737.015.037.146.218.147.234.023.217-.205.358-.196.539-.675-.648-.757-1.585-.665-2.45.034-.34.108-.746.036-1.086-.162-.751-.635-1.427-.919-2.139-.297-.741-.48-1.53-.6-2.318-.145-.941-.282-1.913-.288-2.865-.006-.646-.032-1.273-.258-1.885-.192-.516-.398-.56-.843-.405-.085-.178-.009-.384-.009-.579-.004-.688-.426-1.034-.602-1.64.165-.145.335-.377.378-.591.366.195.431.899.699 1.174-.07-.572-.233-1.186-.307-1.731-.034-.267-.04-.316.02-.58.092-.412.01-.824-.32-1.098-.243-.201-1.115-.462-1.162-.763.174.373.267.776.452 1.143.702-.38 1.222 2.121.207 2.287-.239.04-.687-.35-.838-.524-.129-.147-.067-.185-.123-.329a3.484 3.484 0 0 0-.492-.8c.212-.014.437-.154.522-.342.207.186.207 1.065.628.987.422-.077.063-.877-.248-.916.19-.285-.195-.18-.315-.332-.131-.163.106-.397.047-.663-.132-.6-.771-.615-1.206-.634.042-.121.165-.209.109-.361.486-.039.992-.056 1.427.199.173.099.875.541.883.078.005-.27-.505-.526-.704-.581-.132-.036-.276.001-.404-.056-.115-.048-.173-.207-.354-.212.334-.047.714.097.897-.258.366.343 1.207.565 1.386 1.051.072.194.036.455.068.656.043.253.109.475.179.718.203.677.363 1.323.478 2.034.086.52.077 1.041.129 1.563.052.545.146 1.198.311 1.721.123.381.33.677.387 1.084.175 1.209.382 2.366.731 3.539.153.512.318 1.023.503 1.524.369.995.835 1.922 1.336 2.853z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2315")
        ]), l([
            A2(Da, l([
                Fa("path2317"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M94.274 423.094a1.374 1.374 0 0 0-.645.613c-.201.439-.002 1.031-.16 1.451-.144.381-.559.43-.753.707-.089.129-.134.343-.187.468-.094.223-.178.158-.101.503.108.475.393.708.771.945.552.35 1.062.541 1.676.762.42.152.792.472 1.16.71.816.526 1.765.724 2.538 1.293.89.657 1.601 1.581 2.409 2.307.602.539 1.145 1.324 1.147 2.161.003.837-.182 1.251.666 1.713.448.243.794.461 1.311.375.945-.156 2.102-.891 2.618-1.709a2.7 2.7 0 0 0 .378-1.487c-.034-.713-.315-1.044-.833-1.538-.518-.496-1.085-1.15-1.701-1.51-.65-.386-1.035-.854-1.536-1.471-.724-.891-1.447-1.573-2.295-2.336-.366-.328-.627-.404-1.013-.664-.863-.582-1.321-1.657-2.067-2.366-.248-.235-.519-.497-.798-.683-.597-.399-1.911-.507-2.585-.244z")
            ]), M),
            A2(Da, l([
                Fa("path2319"),
                Ha("#dcc06d"),
                qa("M106.232 434.415c.409-.008.279-.771.486-.962a2.048 2.048 0 0 0-.088.573c-.005.105.024.283-.055.366-.067.072-.188.017-.249.06-.215.153-.088.285-.217.476-.114.169-.312.036-.345.317-.331.083-.526-.193-.745.201-.12.221-.145.501-.286.709-.118.175-.305.271-.403.471.548.192.943-.584 1.507-.466-.236-.024-.445.306-.629.439-.193.142-.411.294-.656.351-.494.115-1.184.018-1.615-.259-.22-.142-.657-.436-.702-.717-.017-.105.046-.224.049-.332.007-.2-.052-.432-.081-.63-.059-.401-.151-.79-.342-1.149a6.426 6.426 0 0 0-1.419-1.786c-.568-.488-1.167-.958-1.754-1.434a9.96 9.96 0 0 0-.875-.646c-.485-.303-1.024-.359-1.486-.703-.533-.396-1.221-.744-1.838-.986-.301-.119-.665-.21-.951-.378-.208-.121-.763-.566-.802-.769.65.212.991-.046 1.103-.737-.203.56-1.343.938-1.188.045.076-.434.508-.89.944-1.006.091.147.059.349.05.509.002-.423.021-.882.079-1.303.041-.288.066-1.065.279-1.31.259-.296.813-.184 1.143-.195.194-.008.355-.109.496-.005-.001 0 .16.354.18.394-.541.032-1.045.201-1.297.768-.296.666.245 1.497-.104 2.148.484.447 1.117.922 1.759.99.168-.361-.487-.743-.655-1.017.309.3.694.586.925.961.184.299.247.681.433.962.336.514.934.81 1.42 1.17a43.499 43.499 0 0 1 2.298 1.838c.617.526 1.186 1.133 1.743 1.721.318.333.591.689.776 1.113.082.187.169.421.17.625.002.184-.132.353-.076.466.09.179.521.181.676.155-.374-.474.049-1.205.649-1.066-.372.16-.491.291-.383.708.067.258.222.537.521.438-.163-.385.627-.791.877-.548.221-.278-.137-.511-.269-.712.163-.096.572-.139.75-.059.106.044.064.203.197.201z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2321")
        ]), l([
            A2(Da, l([
                Fa("path2323"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M90.409 429.253c.2.243.37.361.65.541.94.598.887 1.58.767 2.598-.165 1.379-.136 2.667.259 4.004.352 1.197.995 2.322 1.518 3.449.56 1.206 1.083 2.432 1.706 3.606.708 1.337 1.434 2.784 2.502 3.836.503.498.913.988 1.083 1.708.08.335.023.386.29.522.283.146.367-.026.566.264.391.571.275 1.553.262 2.192-.016.803-.03 1.507-.45 2.2-.555.916-1.319 1.106-2.27 1.521-.665.29-1.536.71-2.216.274-.545-.352-.799-.992-1.219-1.461-.274-.307-.896-.816-1.035-1.208-.105-.304.074-.834.054-1.188-.046-.824-.029-1.664-.151-2.48-.309-2.103-.94-4.16-1.564-6.197-.398-1.303-1.106-2.402-1.631-3.637-.486-1.147-.981-2.185-1.662-3.248-.337-.523-.829-.895-1.171-1.377-.14-.198-.156-.446-.296-.648-.167-.241-.424-.329-.596-.559-.201-.272-.263-.646-.511-.932-.272-.315-.399-.41-.54-.785-.145-.384-.691-1.968-.234-2.246.367-.222 1.236.284 1.674.217.477-.073 1.155-.393 1.572-.623.417-.229.691-.608 1.052-.905.673-.551 1.11-.014 1.591.562z")
            ]), M),
            A2(Da, l([
                Fa("path2325"),
                Ha("#dcc06d"),
                qa("M98.958 449.691c.223.032.371.294.645.302.253.659.289 1.449.193 2.146-.087.637-.306 1.139-.639 1.688-.132.222-.25.457-.507.505.338-.449.658-.933.852-1.465.078-.216.37-1.337-.021-1.413-.02.056-.066.118-.077.172-.021-.228-.305-1.914-.446-1.935z")
            ]), M),
            A2(Da, l([
                Fa("path2327"),
                Ha("#dcc06d"),
                qa("M92.954 450.11c-.048-1.164-.371-2.269-.632-3.407-.292-1.267-.603-2.537-1.14-3.727-.271-.601-.51-1.219-.779-1.824-.228-.515-.663-.886-.866-1.446-.112-.307-.198-.622-.311-.928-.229-.615-.633-1.21-.954-1.783-.316-.568-.655-1.168-1.172-1.578-.287-.227-.403-.381-.357-.74.051-.392.528-.725.651-1.174.248.138.417.246.64-.019.22-.261.218-.685.046-.955.412-.176.977-.64 1.021-1.12.094.024.179.025.283.047-.082.142-.141.318-.223.473-.082.153-.246.231-.288.309-.114.213.01.639.012.866.003.354-.068.646.055.989.362.999.817 1.962 1.162 2.971.18.526.387 1.054.513 1.599.191.823.3 1.649.49 2.474.154.665.381 1.322.574 1.979.381 1.301.839 2.578 1.222 3.877.333 1.131.705 1.899 1.772 2.53.701.413 2.048.792 2.809.321.1.221.003.519.21.665.207.146.561-.038.773-.097.061.579-.573 1.316-1.05 1.563-.41.213-.891.346-1.277.573.689-.635-.608-.901-1.056-.899-.298.002-1.156.161-1.131.581.021.357.565.428.825.449a.484.484 0 0 0 .087.407c.395-.126.214.191.319.393.142.27.608.331.874.362.228.028.458.032.581-.209.16-.31-.063-.301-.244-.455.458-.066.638.252.919-.271a.526.526 0 0 0 .042.343c.063-.014.131.018.193 0-.113.183.088.293.262.331-.104.207-.721.495-.976.565-.258.074-.783-.037-.878.297-.16.563.767 1.141 1.227 1.126-.472.009-.844.437-1.322.481-.487.047-.851-.103-1.146-.509-.329-.452-.481-.996-.883-1.402-.256-.258-.872-.42-.927-.79.341.072.553.229.789.486.174.188.562.813.874.764.79-.126-.388-1.062-.615-1.156-.313-.135-.7-.187-.972-.394.176-.253.002-.463.017-.749.022-.399.063-.829.007-1.226-.044-.327-.037-.629-.05-.963z")
            ]), M),
            A2(Da, l([
                Fa("path2329"),
                Ha("#dcc06d"),
                qa("M90.888 430.598c-.304-.804-1.188 1.45-.978.56-.072-.145-.246-.146-.395-.121.02-.159-.057-.284-.241-.292.315-.156.655-.438.716-.806.153.093.519.17.523-.079.196-.027.496.257.61.434.254.395.18.789.15 1.218-.009-.162-.02-.795-.328-.849")
            ]), M),
            A2(Da, l([
                Fa("path2331"),
                Ha("#dcc06d"),
                qa("M89.445 428.742c.001-.06-.022-.097-.071-.111a.164.164 0 0 0-.068.038c.292.145-.635 1.308-.078 1.733-.258.536-.823 1.28-1.308 1.597.04-.208.102-.452-.055-.624.478-.522.899-1.503.969-2.207-.438.453-.582 1.015-.855 1.549-.241-.053-.442.271-.654.362-.307.133-.604-.084-.912.068.015.259.324.372.443.595.106.195.214.692.17.923-.086.444-.851.651-.752 1.242-.329-.096-.34-.299-.486-.543-.193-.324-.555-.454-.774-.753-.403-.546-.369-1.443-.161-2.07.108-.327.182-.32.521-.235.322.08.576.117.904.1a2.34 2.34 0 0 0 1.281-.456c.165-.123.258-.292.401-.424.18-.167.427-.248.623-.396.184-.14.503-.502.729-.43")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2333")
        ]), l([
            A2(Da, l([
                Fa("path2335"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".347"),
                qa("M66.673 429.213c-.352-.002-.819-.196-1.124.008-.247.166-.336.699-.565.917-.229.218-.538.286-.744.54-.593.729-.091 1.459-.163 2.24-.033.356-.239.584-.319.924-.089.375-.015.863-.016 1.249-.004 1.329-.03 2.683-.325 3.989-.196.869-.368 1.477-.327 2.323.063 1.31-.424 2.732-.708 3.999-.283 1.264-.605 2.521-.911 3.781-.154.64-.437 1.223-.242 1.867.181.6.451 1.165.564 1.8.104.582-.02 1.2.21 1.755.74-.037 1.401.636 2.142.764 1.1.189 2.061-.39 2.867-1.041.639-.516 1.251-1.175 1.052-2.037-.189-.821-.969-1.237-1.182-1.998-.321-1.153.023-2.643.071-3.83.06-1.455.145-2.899.365-4.349.262-1.722.408-3.464.703-5.201.194-1.14.273-2.43.894-3.429.596-.959 1.202-1.476.972-2.683-.12-.623-.648-1.119-.93-1.681-.05-.096-2.114.093-2.284.093z")
            ]), M),
            A2(Da, l([
                Fa("path2337"),
                Ha("#dcc06d"),
                qa("M66.483 453.584c.098-.188.184-.391.313-.558-.088-.148.079-.315.25-.347-.353-.062-.021-.327.132-.436.036.049.123.094.156.142.321-.271-.198-.557-.23-.851 0 .133.004.27.015.402-.042-.025-.415-1.014-.419-.413-.001.19.385.043.205.384-.084.161-.387.185-.541.173-.001-.035.02-.05.019-.086-.183.021-.319.146-.465.24.24.122.396.277.306.552.047-.275.25-.336.469-.283.05.275-.048.658-.39.648.057.177.069.371.123.547.118-.001.108-.061.151-.144")
            ]), M),
            A2(Da, l([
                Fa("path2339"),
                Ha("#dcc06d"),
                qa("M65.101 451.514c-.056-.002-.176-.093-.226-.104.041-.067.033-.165.068-.227-.379.139-.342-.221-.353-.454-.116.092-.231.207-.367.259.044-.581.297-1.143.429-1.711.191-.828.305-1.732.235-2.579-.067-.781-.102-1.567-.147-2.352-.046-.751-.307-1.902.049-2.607.558.813.262 1.992.693 2.82.171-.048.208-.164.291-.329.144-.289.113-.658.15-.97.239-1.964.497-3.927.705-5.901.119-1.128.491-2.108.729-3.188.14.124.18.385.427.273-.018.226-.227.438-.186.66.262-.196.238-.296.33-.572.076-.229.165-.618.474-.553.29-.555.505-1.114.785-1.68-.435-.5-.104-1.328-.247-1.898-.067-.269-.674-.569-.533-.846-.322-.12-.958-.025-1.334-.048-.262-.016-.479-.078-.754-.111-.223-.027-.374.05-.594.054-.255.688-.832.96-1.192 1.529-.36.565-.313 1.136-.04 1.756.095-.288.089-.619.187-.913-.232-.147-.259-.574.062-.637.067.116.141.229.212.327.531-.35.731-1.897 1.619-1.443-.792.623-1.366 1.757-1.224 2.783.022.168.167.551.052.707-.192.26-.494-.181-.699-.289-.354-.188-.166-.174-.377.241-.196.385-.318.476-.314.924.006.744-.023 1.492-.049 2.237-.051 1.436-.534 2.75-.61 4.178-.08 1.559-.414 2.991-.667 4.515-.077.449-.134.902-.202 1.354-.115.77-.364 1.486-.602 2.22-.167.512-.6 1.162-.535 1.707.042.379.323.759.438 1.135.169.546.24 1.113.286 1.684.03.36-.01.622.236.889.301.329.705.354 1.09.418.408.064.784.579 1.189.346-.112.063-.527-.536-.571-.627-.153-.32-.152-.703-.082-1.044.15-.744.649-1.407 1.169-1.933z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2341")
        ]), l([
            A2(Da, l([
                Fa("path2343"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".329"),
                qa("M70.26 435.404c.22.578.445 1.113.628 1.701.32 1.027.048 2.148-.031 3.211-.199 2.697-.603 5.4-.687 8.104-.016.533-.029 1.069-.167 1.583-.078.283-1.588 3.905-.533 3.566.312 1.194.106 2.387.851 3.419.69.955 1.608 1.298 2.729 1.101 1.088-.192 1.831-.473 2.577-1.322 1.046-1.195 1.774-3.799.733-5.199-.44-.59-.692-.846-.866-1.608-.596-2.601-.861-5.501-.869-8.168a9.257 9.257 0 0 1 .334-2.533c.149-.525.461-.922.659-1.425.251-.639.112-1.379.339-2.03.175-.501.499-1.085.81-1.452-.145-.767.122-1.213-.31-1.958-.186-.317-.475-.779-.543-1.063-.066-.268-.03-.661-.109-.968-.327-.051-.665.015-.97-.081-.289-.091-.358-.292-.715-.289-.389.004-.838.326-1.206.438-.447.135-.876.14-1.327.115-.365-.02-.676-.023-1.006.053-.521.122-.557.117-.628.616-.074.512.12 1.022-.027 1.543-.242.854.004 1.77.334 2.646z")
            ]), M),
            A2(Da, l([
                Fa("path2345"),
                Ha("#dcc06d"),
                qa("M74.39 430.641c-.157-.451-.51-.112-.852-.325-.432.364-1.361.746-1.924.621-.357-.081-.667-.262-1.013-.109-.388.171-.176.449.029.176a4.734 4.734 0 0 0-.058.366c.186-.119.573-.479.83-.375.332.134.098.602-.075.786.316.238.381-.223.61-.351.114.132.054.308.093.47.149-.069.24-.238.381-.339.117-.085.302-.097.414-.199.303-.281.268-.734.791-.79.042.375-.207.99-.49 1.256-.294.275-.781.292-1.098.582-.204.188-.531.798-.884.809-.402.013-.116-.551-.283-.818-.06.078-.187.112-.244.148-.074-.29-.237-.807-.476-.987-.035.288.051.631.054.934.003.282-.063.562-.065.844-.005.503.167.986.32 1.45.323.97.951 2.107.873 3.148.063-.137.113-.309.188-.415-.054.076.036.445.038.558.006.28-.013.563-.033.845-.041.593-.115 1.183-.148 1.774-.018.306.083 1.517-.184 1.652-.064-.232-.078-.533-.135-.733-.324.698-.15 1.601-.199 2.339-.033.515-.204 1.006-.248 1.517-.039.453-.016.902-.051 1.358a39.948 39.948 0 0 1-.234 2.188 15.979 15.979 0 0 1-.489 2.353c-.142.482-.58 1.289-.49 1.77.019-.041.061-.087.084-.124.353 1.019.383 2.147.738 3.167.297.854 1.571 2.1 2.387 1.119-.333-.134-.702-.014-1.021-.338-.336-.341-.202-.781-.179-1.238.014-.329.102-.204-.13-.382-.041-.034-.268-.099-.355-.156-.179-.12-.829-.629-.467-.821-.136-.174-.373-.116-.509-.301.071.099-.065-.369-.055-.304-.025-.143-.103-.225-.07-.387.05-.268.25-.354.452-.241.029.015.04.193.084.234.044.038.197.074.251.107-.052-.242-.168-.554-.065-.789.074-.169.496-.544.664-.571.634-.1.042.569.34.828.253-.127.497-.306.759-.421-.039.287-.698 1.102-.376 1.313-.098.179-.39.409-.557.539-.002-.057-.05-.138-.053-.194-.161.061-.225-.067-.381-.121-.006.043-.041.256-.024.282.079.128.098.022.186.09.127.094.415-.012.222.358.182-.067.234-.3.413-.399.483-.268.418.021.422.327.027.001.054 0 .082-.002-.106.221-.441.506-.219.755.305-.177.255-.672.729-.673-.082.335-.161.791.025 1.108-.038-.26.204-.639.454-.702.077.329.175.587.389.854-.333-.595-.006-1.338.318-1.859.336-.544.962-.906 1.268-1.418-.336-.283-.212-.746-.478-1.06-.013.085-.094.168-.114.234-.149-.137-.159-.312-.204-.495-.066.353-.081.74-.252 1.064-.186-.268-.594-.13-.858-.107-.11-.407-.371-.732-.451-1.131-.078-.396.098-.713.266-.985.022-.037-.027-.125.008-.184.029-.051.164-.079.167-.087.075-.134.075-.17.108-.371.064-.398.289-.796.172-1.201-.573.417-.741-1.218-.783-1.483-.158-1.008-.401-2.003-.581-3.008-.371-2.066-.584-4.227.036-6.269.208-.683.457-1.346.665-2.025.207-.68.285-1.383.488-2.069.129-.436.217-.999.372-1.39.096-.236.062-.288.334-.156.401.194.467.591.592.974.058.175.042.32.28.316.111.3.002.495.357.6.442.129.319-.162.552-.372.275.174.266.697.187.982-.209-.145-.14.096-.295.108-.273.023-.41-.175-.621.071-.171.196-.205.791-.207 1.044-.004.909.124 2.103-.209 2.968a.118.118 0 0 1-.074-.008c.016.338.019.698.053 1.041-.023-.229.402-.867.479-1.147.124-.454.338-.885.307-1.369.018.306-.192.589-.324.852a6.306 6.306 0 0 1-.095-.466 4.22 4.22 0 0 1 .004-.646c.032-.389.109-.775.2-1.153.049-.207.778-1.54.849-.753.551-.672.533-1.445.282-2.253-.145-.467-.546-.716-.599-1.249-.052-.515.045-.67-.517-.848.292.092.419 1.746.473 2.031.095.51-.199.845-.693.399-.367-.33-.307-.785-.349-1.225a5.813 5.813 0 0 0-.281-1.317z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2347")
        ]), l([
            A2(Da, l([
                Fa("path2349"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M80.885 440.488c.292 1.661.607 3.433.732 5.119.156 2.107.133 4.23-.069 6.327-.057.575-.257.997-.393 1.543-.155.629.456 1.846.663 2.458.297.881.741 1.678 1.568 2.16 1.221.712 3.084.081 4.004-.909a3.15 3.15 0 0 0 .681-1.22c.239-.832.291-1.96.056-2.793.386-.221-.732-1.123-.896-1.407-.575-1.008-1.025-2.223-1.43-3.316-.647-1.755-.534-3.667-.976-5.456a14.451 14.451 0 0 1-.245-5.546c.078-.498.102-1.023.189-1.511.054-.312.205-.512.204-.836-.001-.545-.193-1.218-.35-1.752-.21-.718-.181-.806.087-1.471.251-.619-.04-1.041-.396-1.675-.292-.516-.623-1.101-1.267-1.068-.569.028-.849.445-1.21.823-.661.694-1.451 1.133-2.368 1.4-.184.055-.937.065-1.04.189-.135.159.083.775.092.989.032.711.341 1.224.338 1.952-.001.303.047.73.201.998.197.345.48.52.593.917.102.36-.009.751.125 1.102.213.559.729.977.917 1.532.141.424.11 1.001.19 1.451z")
            ]), M),
            A2(Da, l([
                Fa("path2351"),
                Ha("#dcc06d"),
                qa("M87.534 454.274a.159.159 0 0 1 .119-.088c.224.348-.007.886-.065 1.247-.05-.004-.098.028-.154.016-.037.221-.039.484.269.448.19-.466.385-.927.28-1.443-.037-.172-.192-.373-.165-.562.027-.179.201-.371.222-.585-.211.271-.465.657-.67.955a.853.853 0 0 0 .193-.036")
            ]), M),
            A2(Da, l([
                Fa("path2353"),
                Ha("#dcc06d"),
                qa("M86.304 455.165c-.066.273-.185.734.055.954-.248.207-.546.411-.842.52.155-.226.4-.444.345-.771-.072-.433-.497-.634-.703-.963.351-.045.329-.19.289-.51-.057-.472-.131-.985-.042-1.455.195.213.618.137.734-.104.135-.278-.17-.976-.244-1.267.021.084.28.289.345.374.119.162.213.341.337.496.208.262.47.6.853.523.144.354-.311.729-.5.97-.279.359-.52.789-.627 1.233z")
            ]), M),
            A2(Da, l([
                Fa("path2355"),
                Ha("#dcc06d"),
                qa("M84.266 457.621c-.018-.028.022-.333-.003-.414-.188-.595-1.066-1.036-1.532-1.422.502-.021.105-.508.01-.746-.206-.51-.689-1.54-.438-2.092.058-.126.208-.275.331-.36.221-.15.331-.07.544-.121.195-.046.123.019.25-.146.127-.163.274-.545.274-.754-.824.105-.728-.463-.82-1.106-.122-.848-.354-1.686-.495-2.529-.194-1.174-.174-2.219-.088-3.396.021-.291-.03-.372-.095-.584-.167-.559-.112-1.267-.129-1.853-.02-.708-.003-1.32-.222-2.012-.201-.629-.282-1.263-.35-1.92-.032-.31-.004-.647-.109-.942-.241.279-.747.316-.872-.091-.033-.114.069-.326.068-.43-.001-.134-.125-.16-.036-.291.16.089.138.359.254.416.179.089.474-.215.447-.385-.171.08-.324.259-.536.273.001-.127-.05-.231-.178-.244.029-.112.081-.22.077-.329-.239.065-.251-.343-.191-.491-.363-.247-.976.24-.884-.482-.61.123.109-1.408.113-1.63.003-.188-.098-.629-.255-.746-.251-.185-.456.05-.681.153-.039-.222.11-.514-.04-.707.131-.144.268-.053.433-.076.253-.038.414-.154.624-.298.427-.29.869-.552 1.383-.635.025.307-.4.905-.548 1.18-.175.323-.44.7-.468 1.074.217-.121.327-.349.569-.452.302-.128.649-.09.587.314.093-.289.342-.676.597-.854-.004.035.008.107.002.151.225.071.462-.421.601-.572.046.532-.284 1.115-.687 1.455-.36.307-.967.788-.861 1.356.077.042.154.074.232.149.155-.575.404-1.12.736-1.613.258-.385.407-.496.693-.127.326.422.071.688-.09 1.166-.159.475.154.528.491.76.155-.204.066-.457.093-.693.022-.185.139-.414.095-.594-.043-.176-.229-.356-.277-.56a2.868 2.868 0 0 1-.069-.662c.006-.285.037-.425-.044-.688-.114-.37-.354-.771-.343-1.171.01-.35.206-.982.401-1.235.07-.09.329-.216.18-.337-.164-.138-.524.333-.606.423-.412.456-.792.974-1.347 1.265-.825.433-1.794.846-2.697.938.105.392.143.752.326 1.127.146.303.376.538.417.861.105.801-.058 1.418.545 2.061.227.241.396.494.367.853-.03.338-.115.595.086.921.175.284.444.522.591.842.25.544.324 1.287.402 1.874.113.862.331 1.707.44 2.567.15 1.173.375 2.333.439 3.521.081 1.492.13 2.991-.159 4.458-.127.635-.087 1.316-.272 1.932-.088.292-.254.615-.238.918.015.272.169.494.34.693.194.227.215.498.38.728.088.124.268.224.369.36.308.414.535 1.051.593 1.565-.208-.435-.423-.882-.701-1.308-.128-.198-.325-.688-.591-.669.038.272.112.679.211.922.113.276.4.534.553.801.256.444.555.824 1 1.09.433.259.92.186 1.374.083.394-.087.987-.061 1.247-.397-.379.063-1.561.312-1.813-.086z")
            ]), M)
        ]))
    ]), rr = l([
        A2(On, l([
            Fa("g57")
        ]), l([
            A2(Da, l([
                Fa("path59"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M246.703 780.568c.827 1.069 1.74 1.995 2.506 3.145a26.741 26.741 0 0 0 2.666 3.404c.559.609 1.253 1.122 1.754 1.766.26.336.424.748.708 1.057.315.345.683.574 1.011.899.821.81.921 1.344.899 2.203-.008.318.03.807-.078 1.036-.101.211-.407.13-.486.347-.07.186.091.36.093.587.003.446.02.974-.153 1.271-.253.444-.873.56-1.439.372-1.89-.624-2.32-3.313-3.233-5.104-1.173-2.304-3.178-4.168-4.844-5.694-1.637-1.506-2.998-2.609-4.541-3.235-.905-.368-2.785-2.637-2.588-3.803.085-.5.631-.521.912-.764.318-.276.514-.694.598-1.239.06-.394.115-.569.298-.874.218-.359.491-1.456.882-1.532.555-.106 2.262 1.929 2.735 2.675.764 1.204 1.426 2.353 2.3 3.483z")
            ]), M),
            A2(Da, l([
                Fa("path61"),
                Ha("#dcc06d"),
                qa("M255.924 792.765c.014 1-.913.035-.73-.741-.147.438-.063 1.439.309 2.086.33-.108.648-.821.448-1.444")
            ]), M),
            A2(Da, l([
                Fa("path63"),
                Ha("#dcc06d"),
                qa("M240.733 782.001c-.693-.706-1.661-2.527-1.378-3.146.144-.308.51-.337.717-.586.104-.127.251-.237.342-.374.126-.186.123-.516.274-.665-.011.251-.447.723-.063 1.1-.047.184-.119.332.049.585.218.323.461.271.576.161.343.719-.45.369-.399.932.027.323.315.874.427 1.219.122.385.16.843.371 1.215.339-.223.872-.026 1.365.188.512.219.737.242.326-.61.249-.213 2.515 2.602 2.965 3.126 1.132 1.31 2.243 2.668 3.405 3.91.329.353.608.61.896 1.051.212.319.489.88.844 1.021.143.06.238-.116.294-.087.211.111.405.501.583.736.208.28.511.752.652.508-.016-.046-.03-.104-.037-.126.263.339.529.779.841.916 0 .204-.103.333-.243.388-.083-.281-.29-.42-.476-.616-.158.241-.016.47.22.77.177.225.161-.036.305.35.081.223.043.507.013.647-.229-.345-.425-.773-.737-.963-.099.152.072.645.226.924.301.536.598.637.954.86-.193.114-.617.223.022.594.661.384.883-.4.702-1.096-.216-.817-.685-1.673-1.03-2.494.058-.051.206-.074.234-.157.023-.064-.021-.313.009-.352.12-.136.422-.098.619-.188.015.492-.111.713.033 1.291.122.49.331 1.001.463 1.492.141.513.479 1.248.292 1.594-.288.53-1.348.523-2.154-.26-.778-.752-1.271-2.336-1.661-3.283-1.149-2.779-3.006-4.378-4.897-6.301-.77-.783-1.516-1.545-2.317-2.165-.653-.505-1.259-1.046-1.898-1.298-.564-.224-1.124-.193-1.729-.811z")
            ]), M),
            A2(Da, l([
                Fa("path65"),
                Ha("#dcc06d"),
                qa("M243.135 776.13c.257-.44-.515-.954-.833-1.086.129.319.729 1.375.864 1.066")
            ]), M)
        ])),
        A2(On, l([
            Fa("g67")
        ]), l([
            A2(Da, l([
                Fa("path69"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M237.941 775.737c.892 1.875 2.029 3.747 3.368 5.371a18.586 18.586 0 0 0 1.627 1.739c.69.639 1.299 1.435 2.025 2.037.606.503 1.327.873 1.896 1.437.454.453.646 1.037 1.013 1.531.376.507.744.502 1.207.887.429.357.605 1.086 1.037 1.454.422.363.75.301 1.108.843.384.576.674 1.261 1.064 1.853.507.769 1.004 1.617.348 2.239-.909.86-2.745 1.155-2.854 2.731-.151-.121-.289-.209-.384-.427-.604.212-.615.146-1.288-.322-.396-.276-1.149-.522-1.424-.898-.322-.438-.31-1.037-.619-1.509-.371-.565-.98-.918-1.356-1.486-.19-.287-.225-.718-.501-.968-.29-.26-.501-.161-.802-.491-.378-.413-.668-1.111-1.007-1.584-1.976-2.753-4.503-5.602-7.553-6.904-.859-.367-2.154-.378-2.911-1.056-.522-.472-1.42-2.513-1.254-3.115.077-.288.461-.354.687-.55.317-.28.48-.727.663-1.11.446-.943.979-1.628 1.781-2.259.388-.309.889-.446 1.279-.753.333-.258.399-.453.9-.266.354.133.924.609 1.261.831.365.244.472.285.689.745z")
            ]), M),
            A2(Da, l([
                Fa("path71"),
                Ha("#dcc06d"),
                qa("M249.405 794.387c-.013.316-.252.554-.344.842-.058.187-.067.372-.171.527-.048-.288-.255-.26-.415-.483-.226-.313-.191-.695-.293-1.031-.071.361-.074.746.021 1.139-.181-.122-.328-.345-.547-.371-.188-.455.33-.704.074-1.176-.303.609-.689.335-.939-.232-.217-.497-.307-1.296-.694-1.703-.177-.188-.286-.143-.481-.286-.344-.254-.169-.329-.304-.588-.645-1.269-1.762-2.362-2.777-3.334-1.188-1.133-2.616-2.436-3.529-3.812-.629-.945-1.16-2.248-2.097-2.839-.672-.423-1.935-.853-2.174-1.72.107.474-.074 1.014-.123 1.461-.049.452.075 1.388-.535 1.258-.65-.141-1.222-1.47-1.327-2.027-.087-.451-.076-1.156.19-1.474-.28.175-.463-.367-.403-.596.139-.532.547.034.708.391a.503.503 0 0 0 .232-.356c-.517-.429.149-1.182.339-1.475.173-.269.722-1.72 1.163-1.197.395.465-.133 1.472-.344 1.746-.083.11-.179.269-.279.361-.06.053-.304.101-.326.184-.135.454.914.582 1.113.914-.279-.342-.578-.681-.832-1.036a.4.4 0 0 1 .173-.138c.313.071.685.684.987.536.013-.293-.205-.303-.386-.505-.301-.327-.146-.359-.291-.653a.683.683 0 0 1 .477.167c.002-.379.292-.563.295-.914-.487-.003-.332-.462-.363-.685-.032-.222-.166-.199-.098-.435.051-.185.254-.271.403-.331.341-.138.946-.063 1.08.491.111.464-.298 1.086-.507 1.408.36.377.567.065.294-.325.316.063.171-.29.255-.499.067-.171.302-.24.271-.479-.067-.507-.965-.843-1.356-.915-.57 1.041-1.941 1.099-2.58 2.008-.295.426-.231.921-.388 1.366-.168.483-.89.892-1.266 1.196-.497.401-.324.704-.063 1.412.201.544.442 1.285.839 1.744.446.514 1.258.657 1.83.838.661.209 1.297.47 1.938.817a13.379 13.379 0 0 1 3.24 2.496c.885.929 1.769 1.867 2.565 2.878.391.491.814 1.02 1.118 1.567.241.434.36.921.776 1.251.336.271.819.148 1.112.479.329.365.045.874.538 1.207.106.072.486.267.569.151.128-.173-.403-.569-.479-.756-.124-.298-.165-.364.128-.333.328.037.298.244.49.438.348.347.742.751.621 1.29-.062-.051-.158-.066-.232-.14-.01.105-.028.224-.036.318.408.476.236 1.113.523 1.546.299.453 1.102.493 1.534.789.49.336.701.584 1.188.389.467-.184.531-.832.551-1.326-.011.282-.493-.038-.565-.154-.174-.282-.065-.979-.091-1.281z")
            ]), M),
            A2(Da, l([
                Fa("path73"),
                Ha("#dcc06d"),
                qa("M249.427 791.845c.643-.209-.091-.941-.37-1.349-.065.523.142.946.516 1.38")
            ]), M)
        ])),
        A2(On, l([
            Fa("g75")
        ]), l([
            A2(Da, l([
                Fa("path77"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M229.354 774.16c.326-.012.425.42.614.558.531.391.959.2 1.517.569.561.369 1.487 1.117 1.787 1.748.178.375.207.87.365 1.268.248.625.497 1.423.891 1.989.428.608 1.084 1.169 1.563 1.759 1.187 1.463 2.276 2.998 3.503 4.417 1.191 1.38 1.983 3.121 3.464 4.299.701.56 1.46.733 2.164 1.249.859.63 1.685 1.412 2.192 2.359.257.479.679 1.325.632 1.806-.063.647-1.235.993-1.646 1.355-.809.706-2.296 3.438-3.553 1.31-.048.179-.205.218-.297.35-.549-.325-1.311-1.348-1.587-1.821-.189-.324-.458-.671-.621-.933-.193-.313-.188-.699-.339-1.043-.346-.784-1.071-1.296-1.662-1.865-1.445-1.387-2.789-2.977-4.12-4.479-1.203-1.361-2.504-2.487-3.785-3.73-.634-.612-1.107-1.014-1.892-1.396-.74-.358-1.53-.646-2.169-1.231-.551-.503-1.244-1.356-1.518-2.018-.165-.402-.552-1.587-.39-1.923.056-.114.519-.219.638-.306.231-.166.393-.346.598-.562.341-.362.687-.839 1.042-1.144.489-.42 1.131-.649 1.619-1.075.365-.319.476-1.489.99-1.51z")
            ]), M),
            A2(Da, l([
                Fa("path79"),
                Ha("#dcc06d"),
                qa("M245.995 796.092c-.391.127-1.056.39-1.15.843.244-.116.911-.462.664.134-.13.313-.378.613-.563.887-.118.174-.42.771-.711.737-.337-.037-.451-.998-.463-1.26-.019-.517.184-1.261.688-1.415-.466-.337-1.204.571-1.4.871-.072-.205-.086-.438-.175-.638-.146-.326-.446-.533-.643-.819-.189-.278-.13-.368-.108-.631.026-.327-.099-.62-.256-.944-.456-.94-1.286-1.411-1.978-2.14-.639-.669-1.297-1.331-1.94-2.005-.567-.597-1.147-1.191-1.708-1.798-1.193-1.295-2.163-2.766-3.402-4.031a109.658 109.658 0 0 0-1.812-1.796c-.368-.355-.802-.869-1.258-1.104-.354-.181-.566.028-.885.104a3.7 3.7 0 0 1-1.939-.042c.186-.236.533-.342.772-.53.173-.137.324-.305.511-.416-.466.038-.815.58-1.341.438.344-.393.378-.659.485-1.178.175-.838.782-1.407 1.341-1.947.018.03.05.073.068.103.196-.098.354-.628.431-.827.09-.231.032-.438.03-.69-.002-.231.102-.662.426-.571.555.152.449 1.09.374 1.412.336.173.292-.458.229-.656-.079-.256-.293-.59-.483-.796.396-.199 1.061.984 1.262 1.249-.041-.4-.508-1.086-.877-1.322-.429-.274-.297.089-.569.223-.458-.285-.83.959-1.02 1.208-.26.343-.522.66-.857.934-.31.248-.892.877-1.372.793.08-.338.442-.503.673-.716.3-.276.582-.584.859-.884.453-.496.764-1.227 1.047-1.852-.273.236-.474.546-.705.823-.344.409-.79.713-1.21 1.032-.622.471-1.147 1.032-1.67 1.617-.111.125-.218.297-.371.379-.02.01-.192.045-.192.045-.146.194.048.342.115.645.032.133-.034.569.063.673.126.134.724.09.88.032-.165.08-.311.229-.43.361.302.142.668.054.973.079-.285.163-.478.55-.829.593.16.306.497.672.735.961.171.205.219.314.463.416.226.093.456.12.681.244.472.257.977.578 1.425.887.439.3.885.531 1.299.885 1.243 1.06 2.467 2.06 3.572 3.289.565.626 1.152 1.224 1.715 1.849.652.725 1.144 1.578 1.801 2.302.43.475.901.896 1.382 1.316.78.687 1.548 1.307 1.728 2.324.06.328.085.452.269.712.245.342.388.669.616 1.026.271.423.861 1.255 1.339 1.416.322.11.252-.249.541-.069.169.105.242.429.415.573.209.17.422.207.629.12.341-.147.693-.627.978-.88.561-.502 1.056-1.067 1.614-1.569.162-.145.309-.313.474-.438.138-.104.577-.31.22-.522-.37-.221-1.144-.155-1.47-.049z")
            ]), M),
            A2(Da, l([
                Fa("path81"),
                Ha("#dcc06d"),
                qa("M245.705 794.959c.147-.478-.419-.612-.576-.988-.247.096-.529-1.018-.678-1.261-.122.317.103.968.312 1.298.396.002.794.418.934.79")
            ]), M)
        ])),
        A2(On, l([
            Fa("g83")
        ]), l([
            A2(Da, l([
                Fa("path85"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M225.22 777.555c.449.671.601 1.49.999 2.195.513.908 1.161 1.686 1.832 2.499 1.395 1.684 2.813 3.081 4.396 4.62 1.192 1.162 2.497 2.267 3.649 3.453.632.652.781 1.333 1.36 2.022.785-.609 2.568 1.069 3.27 1.733.514.491 1.182.993 1.408 1.6.184.491.263 2.098.066 2.481-.364.713-1.511.918-2.179 1.34-.42.264-.756.97-1.321.972-.906.002-2.009-.815-2.729-1.48-1.16-1.074-.925-1.714-1.565-2.849-.33-.585-1.303-1.354-1.813-1.837-1.047-.99-2.057-1.987-3.093-2.987-2.007-1.934-3.974-3.877-6.269-5.556-.565.298-1.045-.345-1.602-.726-.712-.482-1.484-.782-2.239-1.134-.864-.398-.715-.297-1.312-1.039-.658-.815-.868-1.02-.875-1.996-.01-1.621 1.358-1.96 2.568-2.763.855-.564 1.226-1.748 2.182-2.203.933-.438 2.577.617 3.267 1.655z")
            ]), M),
            A2(Da, l([
                Fa("path87"),
                Ha("#dcc06d"),
                qa("M238.05 792.568c-.012.291-.265.845.279 1.021-.064.07-.105.301-.342.283-.18-.298-.431-.585-.598-.895.291-.066.153-.492.579-.414")
            ]), M),
            A2(Da, l([
                Fa("path89"),
                Ha("#dcc06d"),
                qa("M238.548 794.713a1.097 1.097 0 0 1-.466-.355c-.205.326.316.636.496.318")
            ]), M),
            A2(Da, l([
                Fa("path91"),
                Ha("#dcc06d"),
                qa("M231.359 792.572c-.942-.925-1.971-1.798-2.968-2.66-.961-.83-1.872-1.705-2.82-2.545-.333-.296-.648-.605-.983-.896-.32-.277-.676-.495-.996-.765-.253-.217-.38-.284-.687-.322-.45-.057-.563-.287-.936-.557-1.176-.845-2.47-.784-3.528-1.903-.956-1.007-1.676-3.038-.322-3.435-.26.079-.251.336.041.508.378.222 1.007-.051 1.28-.162.146-.058.704-.277.591-.522-.143-.304-.749-.184-.983-.267 1.092.004 1.508-.951 1.934-1.626.109-.178.335-.188.457-.329.109-.122.034-.37.142-.472.176-.157.871-.3 1.026.054.18.403-.512.533-.029 1.025-.416-.013-.036.664.242.76-.025.165-.179.258-.189.441-.01.194.195.316.203.475.023.446-.428.327-.77.03-.092.135-.358.233-.403.381-.084.261.146.408.305.713-.159-.03-1.144-.756-.704-.03-.638-.576-.873.415-.692.832.084.191.418.631.666.647.173.01.301-.279.397-.377.173.184.38.416.638.496-.042-.093-.011-.231-.049-.326.77-.021 2.022 1.445 2.58 1.977 1.554 1.479 3.155 2.906 4.712 4.386 1.475 1.398 2.977 2.787 4.44 4.18.371.354 1.021.819 1.224 1.261.127.269.03.836.668.838.165.19.122.687.425.715.29.027.033-.576.533-.411-.041-.04-.086-.131-.134-.182.258.133.307-.156.509-.234.02.02.109.082.137.109-.036.04-.064.1-.091.145.294.308 1.047 1.363 1.473 1.156.035.473.655.321.538-.087-.083-.015-.165-.062-.252-.066a.733.733 0 0 0 .223-.272c.213.225 1.046 1.137 1.307.82.011.157-.041.223-.207.198-.096-.014-.209-.117-.313-.139-.119-.023-.22.018-.312.047-.252.083-.48.299-.117.562-.079.11-.242.336-.104.506.222.275.834.117 1.046.087.447-.068.867-.242 1.352-.196-.092.893-.512 1.548-1.15 2.102a2.9 2.9 0 0 1-1.164.603c-.196.054-.416.132-.65.086.021-.477.432-.819.422-1.333-.004-.162-.058-.338-.058-.496 0-.126.119-.51.008-.646-.237-.281-.434.113-.604.072-.132-.031-.13-.131-.207-.225-.143-.183-.313-.3-.488-.457.198-.11-.031-.404.011-.582.027-.112.303-.145.263-.294-.088-.31-.832-.192-.994-.185-.082-.143-.32-.367-.478-.292-.218.106.476.999.586 1.221-.342-.331-.493.234-.298.488.11.146.618.613.768.495-.119.126-.207.207-.079.401.123.189.476.386.678.484-.181.425.163 1.147.311 1.642-.869-.219-1.85-.725-2.62-1.304-.541-.411-.795-.987-.979-1.534-.094-.277-.156-.561-.269-.837-.119-.296-.334-.531-.54-.802a8.874 8.874 0 0 0-.879-.989c-.566-.549-1.068-1.139-1.612-1.706l-.478-.48z")
            ]), M),
            A2(Da, l([
                Fa("path93"),
                Ha("#dcc06d"),
                qa("M225.634 778.883c-.297-.467-.354-.929-.644-1.379-.358-.551-1.142-.987-1.696-1.271.339.205 1.985 1.637 1.359 1.846.324.098.714.286.781.642")
            ]), M)
        ])),
        A2(On, l([
            Fa("g95")
        ]), l([
            A2(Da, l([
                Fa("path97"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M233.174 797.172c-.717-.397-1.63-.589-2.572-.927-4.756-1.721-8.544-6.898-10.114-11.49-.183-.537.168-1.142-.083-1.624-1.391-2.674-7.407 1.598-8.254 3.144-.913 1.663-1.098 3.74-.458 5.475.633 1.729 2.378 1.848 3.837 2.589 1.634.83 3.612 1.822 5.017 3.025.917.785 1.557 1.928 2.455 2.714.752.655 1.531 1.073 2.173 1.932 1.283 1.715 2.202 3.768 4.136 4.652 1.132.517 1.58-.451 2.728-1.367 1.508-1.205 2.772-3.892 2.562-5.812-.141-1.262-.678-1.898-1.427-2.311z")
            ]), M),
            A2(Da, l([
                Fa("path99"),
                Ha("#dcc06d"),
                qa("M232.441 803.558c.238-.11 1.4-1.103 1.134-1.431.884 1.087-2.881 4.231-3.779 4.411-.537.106-1.124-.459-1.51-.747-1.425-1.057-1.796-3.029-3.024-4.309-1.38-1.433-2.862-2.614-4.148-4.178-1.362-1.658-3.791-3.304-5.765-4.146-.877-.374-2.037-.545-1.879-1.747-2.971.304 1.458-5.312 2.412-5.84-.457.443-1.056 1.043-.87 1.773 1.67-.441 1.666-3.739 4.176-3.64-1.627-.064-3.888 3.276-3.541 4.703.358 1.473.883.692 1.847.952 1.248.337 1.368.698 1.968 2.03.466 1.027 1.107 1.965 1.739 2.836 1.051 1.451 2.615 2.182 3.781 3.479 1.046 1.162 1.979 2.833 3.449 3.39.207.076.591.055.766.186.375.288.436.901.894 1.087a7.264 7.264 0 0 1-.103-.613c.463.242 2.06.597 1.467-.634.439.448 1.069.732.915 1.646a4.058 4.058 0 0 1-.876-.1c-.043.509-.48.503-.813.634.051-.054.13-.213.192-.282-.063-.253-.248-.348-.483-.309-.163.239-.354.695-.593.78-.276.096-.476-.343-.739-.269-.198.057-.365.433-.582.537-.361.173-.833-.036-1.157-.051.086.175.525.412.658.505.175.12.274.537.589.123.105.582.65 1.497 1.146.347-.047.386-.237 1.025.16 1.088.466-.585.981-1.208 1.103-1.938.493-.235.962-.046 1.466-.273z")
            ]), M),
            A2(Da, l([
                Fa("path101"),
                Ha("#dcc06d"),
                qa("M220.243 783.063c-.409-.104-.589.548-.603.918-.12-.221-.233-.433-.299-.687.246-.184.548-.338.823-.364")
            ]), M)
        ])),
        A2(On, l([
            Fa("g239")
        ]), l([
            A2(Da, l([
                Fa("path241"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M151.707 781.244c-.764 1.047-1.622 1.966-2.319 3.086a25.239 25.239 0 0 1-2.462 3.339c-.523.604-1.184 1.121-1.646 1.752-.241.329-.381.725-.646 1.029-.294.342-.646.576-.957.899-.772.804-.84 1.312-.771 2.117.027.299.017.76.139.968.11.194.414.1.505.3.079.17-.072.343-.06.556.022.419.037.915.225 1.185.278.404.904.479 1.457.273 1.849-.688 2.124-3.235 2.931-4.964 1.037-2.228 2.928-4.084 4.501-5.606 1.55-1.502 2.841-2.61 4.344-3.28.881-.395 2.625-2.625 2.364-3.711-.115-.463-.658-.454-.954-.666-.333-.242-.552-.624-.667-1.131-.083-.367-.147-.529-.347-.807-.239-.324-.574-1.341-.966-1.391-.56-.07-2.146 1.934-2.576 2.658-.695 1.173-1.288 2.286-2.095 3.394z")
            ]), M),
            A2(Da, l([
                Fa("path243"),
                Ha("#dcc06d"),
                qa("M143.21 793.188c.045.94.913-.014.687-.734.172.403.147 1.348-.187 1.976-.336-.085-.694-.736-.53-1.331")
            ]), M),
            A2(Da, l([
                Fa("path245"),
                Ha("#dcc06d"),
                qa("M157.741 782.27c.651-.701 1.514-2.463 1.193-3.028-.159-.281-.527-.289-.748-.513-.111-.112-.263-.208-.361-.332-.136-.166-.152-.477-.313-.61.025.235.49.655.128 1.03.056.17.137.304-.018.551-.198.315-.444.279-.565.183-.3.694.471.323.453.854-.011.305-.268.836-.355 1.166-.1.367-.113.799-.303 1.161-.349-.192-.869.021-1.351.248-.497.234-.721.268-.358-.556-.26-.186-2.358 2.577-2.778 3.094-1.053 1.291-2.083 2.626-3.17 3.854-.308.35-.571.605-.835 1.034-.191.312-.435.853-.779 1.005-.141.063-.245-.097-.299-.066-.205.116-.375.491-.539.723-.193.274-.468.732-.623.511l.031-.12c-.243.332-.484.76-.787.906.014.192.122.307.265.351.067-.27.266-.41.44-.604.171.219.042.44-.175.734-.162.22-.163-.026-.285.346-.068.212-.013.477.026.608.207-.337.378-.75.68-.944.106.137-.035.609-.173.878-.269.521-.559.631-.901.859.198.098.628.176.012.559-.639.397-.903-.329-.762-.99.167-.779.584-1.607.882-2.397-.061-.044-.209-.058-.243-.135-.026-.059.004-.296-.029-.329-.126-.121-.427-.068-.626-.143.012.463.151.663.039 1.213-.094.468-.272.958-.377 1.427-.109.488-.405 1.196-.199 1.512.317.481 1.374.42 2.133-.359.732-.748 1.132-2.26 1.47-3.172.986-2.67 2.744-4.271 4.521-6.178.723-.776 1.423-1.533 2.187-2.157.621-.509 1.194-1.047 1.817-1.319.549-.243 1.106-.242 1.675-.855z")
            ]), M),
            A2(Da, l([
                Fa("path247"),
                Ha("#dcc06d"),
                qa("M155.01 776.886c-.282-.399.458-.924.767-1.063-.108.305-.648 1.327-.801 1.047")
            ]), M)
        ])),
        A2(On, l([
            Fa("g249")
        ]), l([
            A2(Da, l([
                Fa("path251"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M160.166 776.239c-.779 1.807-1.805 3.627-3.051 5.224a17.913 17.913 0 0 1-1.521 1.721c-.654.634-1.214 1.414-1.905 2.021-.574.505-1.273.889-1.805 1.45-.428.449-.585 1.007-.921 1.489-.348.498-.716.514-1.154.898-.407.359-.543 1.053-.95 1.421-.401.364-.731.322-1.059.851-.349.563-.599 1.22-.954 1.795-.462.751-.91 1.574-.219 2.122.955.76 2.803.938 3.003 2.412.143-.123.277-.211.357-.421.613.164.622.102 1.266-.373.38-.28 1.118-.552 1.369-.919.297-.429.25-.991.53-1.449.337-.551.927-.915 1.268-1.469.171-.279.182-.687.443-.936.274-.26.491-.178.771-.504.354-.408.602-1.079.913-1.541 1.813-2.69 4.168-5.501 7.135-6.887.837-.391 2.127-.471 2.841-1.148.496-.471 1.272-2.434 1.074-2.991-.094-.265-.479-.306-.716-.479-.332-.245-.521-.657-.725-1.007-.5-.86-1.071-1.477-1.905-2.025-.407-.27-.913-.372-1.32-.639-.347-.225-.424-.404-.912-.2-.345.143-.887.62-1.209.848-.35.248-.454.293-.644.736z")
            ]), M),
            A2(Da, l([
                Fa("path253"),
                Ha("#dcc06d"),
                qa("M149.805 794.362c.032.296.283.505.391.771.069.172.09.345.201.486.032-.273.24-.258.387-.477.206-.307.151-.663.232-.984.093.335.117.697.042 1.07.173-.124.31-.34.526-.378.161-.437-.369-.642-.141-1.1.336.557.706.277.921-.269.188-.478.233-1.232.597-1.636.166-.186.277-.149.462-.295.329-.257.151-.317.269-.567.57-1.226 1.621-2.313 2.578-3.278 1.12-1.129 2.471-2.429 3.302-3.769.572-.922 1.026-2.173 1.926-2.777.645-.434 1.88-.904 2.068-1.73-.078.45.135.947.209 1.365.075.422.004 1.306.604 1.151.641-.167 1.136-1.445 1.208-1.975.06-.429.009-1.09-.274-1.375.288.151.439-.368.367-.579-.168-.492-.541.062-.684.406a.488.488 0 0 1-.251-.324c.49-.43-.216-1.101-.422-1.365-.188-.243-.818-1.576-1.228-1.063-.366.458.215 1.375.442 1.621.091.1.194.245.299.325.063.046.308.079.336.154.159.42-.88.596-1.058.919.258-.336.536-.67.771-1.018a.396.396 0 0 0-.181-.12c-.309.083-.644.678-.954.557-.031-.275.186-.296.356-.496.28-.324.123-.345.249-.628a.711.711 0 0 0-.465.183c-.022-.355-.322-.514-.344-.842.485-.029.304-.454.323-.662.018-.212.153-.196.072-.414-.062-.171-.269-.241-.421-.289-.349-.111-.948-.009-1.049.52-.085.44.359 1.004.586 1.295-.338.372-.563.092-.313-.291-.311.077-.185-.263-.282-.454-.078-.156-.313-.21-.296-.436.037-.479.913-.842 1.3-.933.627.948 1.998.929 2.687 1.748.321.383.286.851.466 1.261.195.445.938.79 1.332 1.056.517.35.362.645.142 1.322-.167.521-.365 1.229-.735 1.682-.417.507-1.217.687-1.777.885-.647.231-1.267.512-1.884.872a13.005 13.005 0 0 0-3.088 2.519c-.831.918-1.656 1.847-2.394 2.838-.361.482-.755 1.001-1.026 1.532-.213.42-.306.883-.7 1.216-.321.271-.808.182-1.083.509-.305.361.005.823-.465 1.163-.103.072-.471.276-.56.173-.138-.156.369-.558.435-.737.107-.286.141-.35-.146-.305-.326.053-.285.246-.465.438-.325.344-.697.744-.546 1.244.059-.052.156-.071.226-.146.015.101.041.209.054.299-.382.469-.171 1.057-.434 1.479-.272.44-1.071.522-1.485.822-.47.344-.667.585-1.163.43-.476-.146-.576-.753-.624-1.218.027.267.49-.061.554-.173.157-.274.01-.923.018-1.208z")
            ]), M),
            A2(Da, l([
                Fa("path255"),
                Ha("#dcc06d"),
                qa("M149.64 791.976c-.655-.161.033-.888.289-1.285.095.488-.086.896-.437 1.322")
            ]), M)
        ])),
        A2(On, l([
            Fa("g257")
        ]), l([
            A2(Da, l([
                Fa("path259"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M168.639 774.298c-.326.006-.4.417-.58.557-.509.396-.944.239-1.482.615-.536.377-1.417 1.131-1.679 1.736-.157.362-.157.828-.292 1.211-.211.6-.413 1.361-.775 1.914-.389.595-1.013 1.157-1.457 1.736-1.1 1.437-2.099 2.935-3.24 4.334-1.11 1.36-1.799 3.036-3.207 4.222-.669.563-1.417.767-2.089 1.288-.82.638-1.598 1.418-2.048 2.333-.229.462-.601 1.281-.526 1.729.1.604 1.287.867 1.72 1.185.845.619 2.484 3.103 3.618 1.038.056.166.216.194.316.313.526-.334 1.228-1.336 1.475-1.796.173-.313.418-.654.566-.906.176-.306.147-.669.279-.999.301-.755.994-1.274 1.55-1.839 1.361-1.382 2.612-2.945 3.852-4.428 1.121-1.342 2.354-2.47 3.561-3.706.596-.608 1.046-1.012 1.806-1.412.716-.376 1.487-.688 2.092-1.271.519-.502 1.161-1.342 1.396-1.976.143-.386.46-1.521.278-1.827-.062-.104-.527-.177-.653-.252-.241-.143-.41-.304-.627-.495-.362-.321-.734-.751-1.105-1.019-.512-.365-1.167-.548-1.678-.922-.38-.278-.558-1.372-1.071-1.363z")
            ]), M),
            A2(Da, l([
                Fa("path261"),
                Ha("#dcc06d"),
                qa("M153.303 795.78c.397.097 1.075.307 1.194.728-.247-.096-.934-.385-.654.163.148.287.413.555.612.802.128.156.462.701.75.653.333-.052.395-.96.389-1.207-.009-.485-.254-1.174-.767-1.292.445-.341 1.234.473 1.447.744.061-.197.059-.416.138-.61.126-.312.413-.523.592-.802.174-.271.108-.353.073-.598-.045-.307.062-.588.2-.9.403-.908 1.202-1.394 1.851-2.114.598-.663 1.216-1.318 1.818-1.986.533-.591 1.077-1.181 1.601-1.782 1.115-1.278 1.999-2.71 3.161-3.965.561-.602 1.127-1.192 1.703-1.782.349-.354.751-.859 1.192-1.105.343-.189.567-.004.888.049a3.886 3.886 0 0 0 1.93-.143c-.198-.211-.551-.293-.799-.456-.18-.119-.341-.269-.533-.364.466.013.845.501 1.361.341-.363-.351-.413-.599-.55-1.08-.221-.777-.86-1.278-1.448-1.755-.016.028-.046.069-.063.098-.201-.079-.389-.57-.477-.752-.103-.213-.058-.411-.069-.646-.011-.218-.14-.616-.458-.514-.544.173-.383 1.046-.29 1.345-.329.181-.319-.413-.267-.604.064-.243.257-.57.436-.773-.404-.164-1 .982-1.186 1.241.018-.377.445-1.046.799-1.288.412-.282.3.066.582.178.44-.292.88.855 1.084 1.08.28.309.559.592.908.83.322.216.94.775 1.413.671-.099-.313-.469-.448-.71-.636a14.174 14.174 0 0 1-.907-.785c-.484-.44-.833-1.108-1.152-1.682.287.209.502.487.751.735.366.368.828.629 1.265.905.647.407 1.202.906 1.758 1.429.118.111.233.267.39.335.021.009.196.032.196.032.155.175-.028.322-.079.61-.022.128.067.533-.023.635-.117.133-.717.123-.875.076.169.069.32.2.447.317-.292.149-.662.088-.966.127.296.139.511.491.863.512-.142.297-.458.659-.68.943-.158.199-.199.306-.438.415-.217.1-.446.138-.663.266-.455.268-.94.596-1.369.907-.421.306-.853.547-1.247.899-1.178 1.064-2.341 2.068-3.373 3.281-.527.618-1.077 1.212-1.603 1.829-.609.714-1.049 1.542-1.664 2.256-.401.469-.846.888-1.301 1.31-.74.687-1.469 1.311-1.59 2.275-.04.311-.06.429-.228.682-.224.335-.347.649-.554.997-.246.411-.789 1.225-1.254 1.402-.315.12-.267-.221-.542-.038-.164.11-.219.416-.384.562-.196.172-.408.218-.618.146-.349-.119-.729-.55-1.026-.773-.588-.44-1.113-.944-1.699-1.386-.17-.128-.327-.278-.497-.387-.145-.091-.594-.26-.249-.479.353-.225 1.129-.204 1.46-.122z")
            ]), M),
            A2(Da, l([
                Fa("path263"),
                Ha("#dcc06d"),
                qa("M153.526 794.702c-.173-.442.382-.599.52-.961.251.077.468-.982.603-1.217.139.288-.046.911-.237 1.231-.396.024-.765.437-.886.793")
            ]), M)
        ])),
        A2(On, l([
            Fa("g265")
        ]), l([
            A2(Da, l([
                Fa("path267"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M172.953 777.262c-.407.655-.513 1.432-.869 2.115-.458.881-1.059 1.645-1.684 2.444-1.294 1.656-2.629 3.044-4.118 4.573-1.122 1.155-2.361 2.263-3.44 3.438-.592.646-.704 1.294-1.241 1.972-.817-.529-2.5 1.142-3.16 1.804-.485.488-1.122.996-1.312 1.576-.156.472-.141 1.984.076 2.334.405.65 1.558.78 2.249 1.141.432.225.809.871 1.374.841.903-.046 1.956-.871 2.634-1.535 1.095-1.071.825-1.658 1.397-2.759.295-.567 1.223-1.341 1.703-1.821.988-.985 1.936-1.977 2.913-2.97 1.89-1.924 3.741-3.854 5.93-5.553.583.249 1.024-.379 1.558-.767.683-.492 1.433-.814 2.167-1.186.838-.42.694-.315 1.248-1.045.609-.8.808-1.004.757-1.92-.081-1.523-1.466-1.769-2.718-2.456-.883-.485-1.323-1.578-2.302-1.952-.952-.361-2.532.715-3.162 1.726z")
            ]), M),
            A2(Da, l([
                Fa("path269"),
                Ha("#dcc06d"),
                qa("M161.024 792.047c.026.272.311.777-.222.973.068.062.121.277.358.249.161-.291.395-.575.543-.873-.292-.049-.184-.455-.601-.358")
            ]), M),
            A2(Da, l([
                Fa("path271"),
                Ha("#dcc06d"),
                qa("M160.648 794.086c.181-.089.344-.205.445-.359.224.295-.279.614-.476.327")
            ]), M),
            A2(Da, l([
                Fa("path273"),
                Ha("#dcc06d"),
                qa("M167.695 791.69c.886-.918 1.86-1.792 2.808-2.656.908-.83 1.768-1.701 2.665-2.541.315-.294.611-.603.929-.895.304-.276.646-.501.948-.771.243-.216.364-.285.669-.339.445-.077.543-.298.902-.572 1.123-.857 2.417-.869 3.408-1.975.895-.997 1.498-2.943.123-3.245.263.063.271.304-.011.48-.364.229-1.008.007-1.286-.083-.147-.046-.718-.223-.618-.459.124-.292.735-.213.965-.305-1.089.065-1.558-.809-2.023-1.422-.119-.159-.343-.158-.476-.282-.114-.109-.053-.347-.169-.437-.182-.138-.884-.234-1.019.107-.154.386.542.471.09.96.414-.035.073.621-.201.727.037.152.195.23.216.402.022.183-.175.309-.174.457.002.42.446.284.769-.015.098.123.37.201.423.338.098.241-.124.393-.262.686.155-.036 1.095-.77.698-.065.603-.574.895.342.738.744-.072.184-.38.615-.627.644-.17.018-.313-.247-.416-.334-.162.182-.354.411-.607.5.034-.09-.003-.217.03-.308-.77.02-1.934 1.465-2.461 1.992-1.463 1.473-2.977 2.898-4.447 4.371-1.389 1.392-2.808 2.776-4.186 4.162-.352.353-.973.824-1.149 1.248-.109.261.017.789-.617.823-.152.188-.082.651-.383.695-.287.04-.068-.54-.555-.359.037-.038.078-.127.125-.178-.251.14-.317-.129-.523-.191-.017.021-.104.084-.129.109.039.035.069.091.102.132-.277.303-.969 1.335-1.406 1.162-.006.448-.634.339-.54-.05.08-.02.161-.068.247-.076a.72.72 0 0 1-.237-.245c-.198.223-.98 1.125-1.256.84-.001.148.054.208.218.176.095-.018.202-.121.305-.147.116-.028.22.005.313.028.257.063.495.254.149.52.086.1.262.303.134.471-.206.27-.825.155-1.039.137-.45-.04-.878-.182-1.357-.112.142.834.597 1.426 1.266 1.911.347.252.735.41 1.196.505.196.04.423.102.654.045-.049-.446-.478-.747-.498-1.229-.007-.151.037-.32.028-.468-.007-.119-.15-.473-.044-.605.222-.278.439.083.608.033.127-.036.121-.129.192-.22.132-.181.295-.299.46-.457-.203-.092.008-.381-.043-.544-.033-.105-.312-.12-.279-.264.07-.295.819-.226.98-.226.073-.14.298-.362.459-.3.224.087-.417.964-.514 1.177.321-.329.504.195.327.442-.104.145-.583.608-.737.506.126.112.216.184.102.373-.114.184-.452.388-.65.489.208.391-.094 1.088-.214 1.56.853-.253 1.802-.78 2.536-1.364.518-.414.739-.97.89-1.493.076-.267.122-.534.22-.801.101-.285.301-.517.491-.78.245-.34.517-.667.82-.977.535-.546 1.001-1.127 1.51-1.688.144-.159.29-.316.44-.474z")
            ]), M),
            A2(Da, l([
                Fa("path275"),
                Ha("#dcc06d"),
                qa("M172.618 778.532c.268-.454.298-.892.563-1.329.325-.536 1.081-.988 1.617-1.282-.326.209-1.886 1.641-1.25 1.805-.315.108-.695.307-.741.644")
            ]), M)
        ])),
        A2(On, l([
            Fa("g277")
        ]), l([
            A2(Da, l([
                Fa("path279"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M166.149 796.105c.692-.41 1.59-.639 2.51-1.009 4.645-1.866 8.124-6.933 9.426-11.327.154-.517-.234-1.063-.011-1.53 1.234-2.584 7.478 1.103 8.411 2.511 1.005 1.512 1.308 3.45.772 5.114-.534 1.655-2.265 1.861-3.678 2.635-1.582.868-3.497 1.904-4.828 3.11-.871.787-1.443 1.893-2.293 2.68-.713.655-1.465 1.089-2.056 1.929-1.182 1.68-1.981 3.657-3.857 4.59-1.1.546-1.602-.339-2.798-1.137-1.573-1.051-2.988-3.506-2.888-5.317.068-1.192.566-1.82 1.29-2.249z")
            ]), M),
            A2(Da, l([
                Fa("path281"),
                Ha("#dcc06d"),
                qa("M167.246 802.062c-.246-.09-1.46-.959-1.214-1.283-.819 1.069 3.116 3.819 4.021 3.939.542.073 1.095-.489 1.464-.782 1.359-1.068 1.615-2.94 2.768-4.207 1.294-1.419 2.704-2.607 3.897-4.144 1.262-1.629 3.588-3.306 5.509-4.201.853-.397 2-.622 1.775-1.742 2.979.127-1.759-4.908-2.741-5.352.481.392 1.113.921.97 1.618-1.69-.324-1.875-3.422-4.374-3.193 1.621-.148 4.065 2.868 3.801 4.227-.273 1.4-.84.695-1.786.991-1.226.383-1.325.729-1.846 2.012-.405.99-.992 1.904-1.571 2.757-.966 1.418-2.483 2.188-3.571 3.467-.977 1.148-1.812 2.767-3.247 3.367-.199.084-.585.082-.751.215-.357.291-.382.872-.828 1.068.03-.186.057-.41.067-.58-.449.253-2.021.669-1.5-.517-.412.443-1.023.745-.817 1.593.285-.021.591-.061.868-.14.071.475.508.444.846.552-.053-.048-.143-.191-.208-.255.045-.242.226-.339.463-.314.177.216.393.632.636.699.282.075.455-.347.723-.29.2.042.389.387.611.472.368.142.827-.079 1.149-.108-.075.169-.5.413-.626.509-.167.121-.244.519-.578.146-.074.553-.565 1.441-1.125.387.069.36.295.949-.097 1.029-.498-.522-1.048-1.082-1.21-1.761-.507-.195-.962.007-1.478-.179z")
            ]), M),
            A2(Da, l([
                Fa("path283"),
                Ha("#dcc06d"),
                qa("M178.234 782.168c.402-.12.619.482.654.828.107-.213.206-.419.259-.661-.256-.159-.567-.287-.842-.297")
            ]), M)
        ]))
    ]), er = l([
        A2(On, l([
            Fa("PatellaRight")
        ]), l([
            A2(Da, l([
                Fa("path2389"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M180.755 584.773c-4.698-4.028-9.615-5.254-14.558-1.356-1.465 1.155-4.251 2.186-5.231 3.629-.95 1.399-1.549 4.478-1.4 6.115.232 2.555 2.67 4.852 4.285 6.765 1.458 1.726 3.382 4.255 5.633 4.773 5.525 1.275 10.236-2.619 12.677-6.985 1.258-2.249 2.46-3.595 2.602-6.161.16-2.901-1.641-4.749-4.008-6.78z")
            ]), M),
            A2(Da, l([
                Fa("path2391"),
                Ha("#dcc06d"),
                qa("M175.25 603.838c-7.515 3.753-17.199-11.348-11.633-13.121-.336 1.554 1.834 4.828 3.458 2.993 1.174-1.329-1.719-3.062-2.41-3.794.286-.25.799-.436 1.205-.489.964 2.899 5.335 1.224 2.04-1.098.871-.581 4.408 1.568 5.778 1.811 2.074.362 4.733.88 5.947-1.276-.543-.492-1.174-1.217-1.562-1.89 2.196-.887 3.78.51 5.511 2.179 1.89 1.821 1.446 3.188.317 5.553-1.67 3.492-5.159 7.388-8.651 9.132z")
            ]), M),
            A2(Da, l([
                Fa("path2393"),
                Ha("#ccb25c"),
                qa("M169.758 603.084c2.161 1.094 6.984-1.682 5.921-4.213 1.093-.837 2.089-1.917 3.138-2.734.082.277.23.52.308.759 3.321-.715-.067-3.609-1.216-4.525.116-.733.268-1.405.477-2.12 3.839-.048 1.33-3.376.148-4.565-.542.21-1.018.074-1.599.194.044-.136.501-1.085.574-1.213 2.221 1.585 6.162 3.575 5.871 6.881-.371 4.229-3.339 8.16-6.596 10.464-4.251 3.007-9.122 3.666-11.559-2.092 2.688-.91 2.921 4.448 6.141 2.628")
            ]), M)
        ])),
        A2(On, l([
            Fa("PatellaLeft")
        ]), l([
            A2(Da, l([
                Fa("path2397"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M237.796 584.717c-4.699-4.028-9.614-5.254-14.559-1.356-1.462 1.155-4.251 2.186-5.229 3.629-.952 1.399-1.55 4.478-1.401 6.115.233 2.555 2.671 4.852 4.285 6.765 1.459 1.726 3.383 4.255 5.634 4.773 5.525 1.275 10.234-2.619 12.677-6.985 1.258-2.249 2.461-3.595 2.603-6.161.157-2.902-1.644-4.75-4.01-6.78z")
            ]), M),
            A2(Da, l([
                Fa("path2399"),
                Ha("#dcc06d"),
                qa("M232.29 603.781c-7.515 3.753-17.197-11.348-11.633-13.121-.335 1.554 1.834 4.829 3.457 2.993 1.176-1.329-1.719-3.062-2.41-3.794.286-.25.8-.436 1.205-.488.965 2.898 5.337 1.223 2.041-1.099.869-.581 4.406 1.568 5.778 1.811 2.073.362 4.732.88 5.946-1.276-.544-.492-1.176-1.217-1.562-1.889 2.194-.887 3.779.509 5.512 2.178 1.89 1.821 1.444 3.188.315 5.553-1.669 3.493-5.156 7.389-8.649 9.132z")
            ]), M),
            A2(Da, l([
                Fa("path2401"),
                Ha("#ccb25c"),
                qa("M226.799 603.027c2.16 1.094 6.982-1.682 5.921-4.212 1.094-.838 2.09-1.918 3.137-2.734.083.276.23.519.31.758 3.32-.715-.067-3.609-1.215-4.525.115-.733.266-1.404.475-2.12 3.84-.048 1.329-3.376.147-4.565-.542.21-1.018.074-1.598.194.043-.136.502-1.085.574-1.213 2.22 1.585 6.162 3.575 5.871 6.881-.373 4.229-3.34 8.16-6.597 10.464-4.25 3.007-9.122 3.666-11.558-2.091 2.687-.911 2.92 4.447 6.14 2.627")
            ]), M)
        ]))
    ]), dr = l([
        A2(On, l([
            Fa("g447"),
            ln("inline")
        ]), l([
            A2(Da, l([
                Fa("path449"),
                Ha("#f9ce82"),
                Ua("#967348"),
                Ba(".322"),
                qa("M174.425 389.556c1.445-2.521 4.873-5.618 5.351-8.24.636-3.487-3.673-4.885-6.077-6.953-2.549-2.192-3.363-4.174-6.827-4.662-3.307-.466-7.498-1.073-10.823-.632-2.893.384-6.688.904-8.367 3.218-1.997 2.754-2.437 9.078-.269 11.532 2.374 2.684 6.24 3.764 8.843 6.177 3.878 3.596 5.747 7.578 4.907 12.582-.787 4.688-.273 7.283 3.873 9.857 2.389 1.483 4.93 4.063 7.511 4.927 2.914.976 9.766.63 12.807.002 5.656-1.171 8.03-7.883 13.898-8.332 5.969-.456 9.586 5.047 14.777 6.988 6.665 2.492 15.139 4.35 21.463-.159 5.404-3.852 4.903-9.069 5.451-14.913.591-6.279 3.285-11.451 7.678-15.924.038.282.018.56.044.793 2.768-2.007 3.312-5.777 3.167-9.248-.205-4.953-4.885-4.264-8.403-3.331-4.04 1.07-5.345.129-9.055-.31-3.225-.381-5.351 1.725-7.583 3.747-2.874 2.6-7.558 5.451-6.016 9.584 7.786 1.78 12.519 15.145 7.199 21.376-1.684 1.973-6.495 2.857-8.948 2.145-2.862-.83-3.768-3.471-6.063-4.847-2.306-1.382-6.654-1.263-9.306-1.526-8.722-.866-15.839 5.605-24.401 4.099-5.629-.991-6.068-2.87-7.336-8.006-.977-3.947.582-6.591 2.505-9.944z")
            ]), M),
            A2(Da, l([
                Fa("path451"),
                Ha("#dcc06d"),
                qa("M209.278 404.201c-4.927-1.708.588 5.267 1.429 6.061 2.517 2.378 5.651 5.069 9.263 4.951-.209-.388-.299-.909-.527-1.321 6.074 5.909 15.909-.356 18.164-6.811 1.122-3.212.17-4.622-.525-7.519-.724-3.018.098-6.862 1.805-9.285-.303 3.978 1.794 2.482 3.299.077 1.645-2.625 3.093-5.062 5.337-7.238 2.502-2.427 2.521-2.833-.788-4.998-1.84-1.206-6.555-1.997-6.033-4.555-1.053.875-2.509 1.154-3.766 1.264.155-.203.313-.406.471-.609-1.732.3-3.672 3.209-5.599 4.167-1.64.813-3.376 1.465-5.008 2.304-2.361 1.215-6.102 3.518-1.126 4.265.032.324.06.634.106.958 5.979-1.176 2.688 12.12 5.231 13.971.177-.618.893-1.319 1.063-1.737 3.622 7.034-1.282 15.527-9.037 14.656 1.312-.336 2.536-1.035 3.672-1.732-4.231.081-7.363.437-11.359-2.219-1.668-1.109-5.157-7.893-7.146-4.648")
            ]), M),
            A2(Da, l([
                Fa("path453"),
                Ha("#dcc06d"),
                qa("M177.523 410.29c4.895 1.657 11.114-1.297 15.348-3.818-.403.434-.623 1.147-1.009 1.602.849-.082 1.869.187 2.727.116-3.687 8.59-17.054 11.74-23.819 5.633 1.621.485 3.588.631 5.134.132-4.64-1.803-7.967-7.882-9.52-12.585-1.003.634-1.449 1.859-1.893 3.105-.84-2.882 1.122-8.059-.342-10.643-.776-1.371-1.485-.542-2.449-1.434-.804-.744-1.134-1.67-1.824-2.574-2.33-3.046-5.09-5.275-8.117-7.444-3.366-2.414-2.897-5.567-.419-8.938 2.418 1.282 5.989 1.824 8.659.979 1.435-.455 2.75-1.749 4.23-1.974 3.14-.477 7.473 3.221 9.913 4.935 3.952 2.773 2.7 4.085.439 7.965-4.474 7.674-8.311 21.134 2.942 24.943z")
            ]), M),
            A2(Da, l([
                Fa("path455"),
                Ha("#ccb25c"),
                qa("M160.206 389.162c-1.7-2.983-2.025-18.452-9.164-15.719-2.658 1.018-2.919 4.284-2.358 6.693.772 3.312 2.499 3.494 4.651 5.356-2.3-1.991-2.951-5.866 1.184-4.27 2.65 1.024 4.375 5.638 5.687 7.94z")
            ]), M),
            A2(Da, l([
                Fa("path457"),
                Ha("#ccb25c"),
                qa("M236.099 387.395c.396-5.067 9.067-6.824 7.84-.457 1.878-2.278 6.379-5.111 5.317-8.84-1.259-4.42-7.512-3.059-9.942-1.011-2.902 2.449-5.21 8.214-3.879 12.023 1.468 4.204 4.979 3.149 6.355-.133-3.142 1.076-4.531-1.232-4.619-4.086")
            ]), M),
            A2(Da, l([
                Fa("path459"),
                Ha("#ccb25c"),
                qa("M210.351 410.638c2.41 1.552 5.78 2.702 8.552 3.424-2.198-1.468-6.697-3.761-6.488-6.971-.648 1.064-1.414 2.638-2.064 3.906")
            ]), M),
            A2(Da, l([
                Fa("path461"),
                Ha("#ccb25c"),
                qa("M181.027 414.929c3.431 1.331 9.133-1.399 10.594-4.748-.787-.759-1.61-1.321-2.665-1.274-.705 3.192-5.276 5.497-8.286 5.665")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path517"),
            Ha("#f9ce82"),
            Ua("#967348"),
            Ba(".322"),
            qa("M157.196 381.135c.199.169.39.349.57.542 3.535 3.754 1.875 10.125 7.255 11.759 2.957.898 5.912 1.375 8.709 2.744 3.48 1.702 6.141 4.375 9.271 6.592 2.348 1.663 13.377 10.67 15.732 6.541 1.043.234 2.388-.093 3.752.027 2.28.199 3.174 1.041 5.555-.107 2.817-1.359 5.119-3.955 7.392-6.038 4.629-4.237 9.468-4.878 15.369-6.452 2.419-.646 4.671-1.069 6.544-2.762 3.696-3.343 2.121-8.956 4.293-13.266 2.5.996 6.271-.866 8.849-1.068 2.725-.214 5.446.243 6.952-2.654 1.635-3.149.336-9.2 4.454-10.725-.08-.049-.559-.515-.633-.564 3.212 1.355 7.64-2.908 9.589-4.926 3.268-3.378 4.523-6.503 3.722-11.225-1.548-9.115-6.406-18.03-14.607-22.886-9.704-5.746-22.864-5.493-31.646 1.639-6.516 5.291-4.644 13.95-9.639 20.022-1.832 2.228-2.762 3.213-1.514 5.793 1.143 2.363 3.487 5.527 5.262 7.488 4.102 4.527 7.641 6.545 5.926 13.305-1.148 4.529-2.849 9.012-5.414 12.938-2.47 3.779-6.064 6.138-8.917 9.541-2.463 2.939-4.893 2.813-8.512 2.142-1.201-.224-2.741-2.114-3.001.74-1.169.13-2.269.46-3.46.358.026-.388-.159-.93-.118-1.309.052-.487-5.023 1.446-5.354 1.438-2.233-.048-3.016-1.743-4.355-3.312-3.737-4.38-8.451-7.677-12.388-11.85-3.473-3.683-5.198-8.105-5.274-13.23-.095-6.407 4.682-5.207 7.247-9.719 1.349-2.377.58-5.573 1.397-8.083.883-2.715 2.959-5.273 3.819-7.946 1.153-3.585 1.375-7.023-.574-10.451-5.036-8.855-14.673-9.916-23.763-10.997-6.814-.812-10.663-.054-16.08 4.756-4.441 3.944-9.167 10.351-11.312 15.893-1.192 3.082-1.542 6.186-.706 9.479.32 1.262.828 3.303 1.627 4.267 2.108 2.548 8.998 5.685 12.013 3.258-.729.716-1.293 1.211-2.319 1.448-.683.157 1.411 10.193 3.867 10.593 1.134.185 2.171-1.287 2.878-1.024 1.1.41.853 2.355 1.689 3.278 1.63 1.801 4.042 2.465 5.853 4.013z")
        ]), M),
        A2(Da, l([
            Fa("path519"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".236"),
            qa("M202.148 409.921c.83-1.747 1.341-9.106-.764-10.093-3.217-1.509-1.716 8.605-1.684 10.001.589.367 2.062.905 2.448.092z")
        ]), M),
        A2(Da, l([
            Fa("path521"),
            Ha("#dcc06d"),
            qa("M178.25 360.635c1.224 2.592-3.9 4.67-5.642 6.169-2.328 2.005-2.756 3.472-2.502 6.705.536 6.82 4.859 13.282 9.172 17.645-4.631-3.736-7.917-8.135-10.264-13.572.149.128.258.287.324.471-.488-2.688-.806-5.016-.162-7.701-3.791-1.078 6.268-6.978 5.272-9.743a27.599 27.599 0 0 1 2.371-.654c.337.438.881.933 1.073 1.396")
        ]), M),
        A2(Da, l([
            Fa("path523"),
            Ha("#dcc06d"),
            qa("M224.739 359.563c-2.252 2.46 1.188 3.956 2.494 5.713 1.569 2.116 1.974 3.851 2.153 6.445.382 5.443-2.142 10.29-3.967 15.275 3.312-6.279 5.323-10.667 5.102-17.717.261-.147.514-.296.699-.411-1.119-3.161-3.836-7.091-6.84-8.949")
        ]), M),
        A2(Da, l([
            Fa("path525"),
            Ha("#dcc06d"),
            qa("M148.518 363.557c-1.305-.496-1.762-2.182-3.166-2.912-1.16-.602-2.061-.436-2.991-1.476-1.068-1.194-.802-3.15-1.997-4.343-1.861-1.86-4.72-1.614-5.399-4.561-1.751-7.602 9.458-16.474 15.007-19.175-2.819 2.566-9.403 7.994-8.85 12.352.123-.298.849-1.042 1.023-1.632.136.676.539.941.803 1.553.219-.469.781-.9.967-1.318 1.386 1.173 4.07 7.57 7.138 5.303.798-.59.706-2.27.421-3.035.448.463.469.578.652 1.144 1.689 1.446.251 6.447 1.722 9.043 1.983 3.5 4.139 3.263 7.853 3.686-1.718 1.983-3.99 3.563-5.264 5.895-1.284-.216-2.743 1.915-2.876 3.43-.182 2.068 1.578 3.65 2.761 5.221-1.367.429-1.379.46-.913 1.743-1.411-1.975-3.71-3.066-5.296-4.832-.813-.905-1.412-1.282-1.75-2.546-.11-.412.334-3.472.155-3.54z")
        ]), M),
        A2(Da, l([
            Fa("path527"),
            Ha("#dcc06d"),
            qa("M259.069 364.569c-1.482-1.421-2.124-4.8-.261-6.39.727-.618 1.896-.374 2.477-.492 2.988-.607 5.242-1.657 7.124-4.205 5.788-7.838-4.848-21.924-11.11-25.358 1.741 2.64 4.999 4.203 6.356 7.375.919 2.156 2.544 7.462.865 9.392-.113-.477-.412-.942-.527-1.419-1.024.955-1.213 2.957-2.081 4.304.042.126-.654-.469-.646-.464.05-.273.253-.277.269-.568-.896.09-2.604 1.634-3.436 2.082-1.947 1.046-3.745 1.224-5.366 3.227 1.738 2.043 2.226 4.088 1.681 6.687.041-.044.292-.569.365-.662.542.911.013 1.915-1.02 2.654 3.984 4.376-7.691 12.303-3.345 16.329-.175-3.955 3.063-10.575 7.084-11.846a.959.959 0 0 1-.178-.585c.6.267.811-.043 1.425.529-.67-1.045-.841-2.294-.392-3.452")
        ]), M),
        A2(Da, l([
            Fa("path529"),
            Ha("#dcc06d"),
            qa("M249.318 332.465c-1.109.285-2.578-.045-3.793.257-1.386.344-2.911 1.114-4.228 1.694-2.935 1.296-5.737 2.979-7.978 5.301-2.739 2.84-5.544 8.622-4.309 12.694.677 2.229 3.142 3.272 5.701 3.877-.657-1.688-2.289-2.93-3.037-4.612 1.18-.393.008-6.804.957-8.875 3.09-6.743 10.382-8.72 16.687-10.336z")
        ]), M),
        A2(Da, l([
            Fa("path531"),
            Ha("#dcc06d"),
            qa("M178.25 346.69c-2.228 1.527-3.823.682-4.875-1.555-1.058-2.254.608-4.964-.687-7.162-2.408-4.082-8.931-4.894-12.95-6.58 2.338.981 6.226-.099 8.954.912 3.255 1.206 6.069 3.973 6.652 7.528-3.468 1.139 1.26 8.83 2.566 5.531-.118.805.019 1.685-.018 2.397")
        ]), M),
        A2(Da, l([
            Fa("path533"),
            Ha("#dcc06d"),
            qa("M183.972 394.607c4.331 3.059 6.174 9.073 9.94 12.48-.217-.778.067-1.823.065-2.353.232.221.409.435.632.575.399-1.206.937-2.492 2.199-2.914-1.282-1.171-3.583.277-5.405-.547-1.984-.897-3.796-3.315-4.929-5.095")
        ]), M),
        A2(Da, l([
            Fa("path535"),
            Ha("#dcc06d"),
            qa("M203.997 401.402c.364 1.394.69 2.802.697 4.243.203-.75.73-1.307 1.011-1.989.389.992.544 2 .493 3.062 2.681-.398 6.658-6.221 8.874-8.097 2.674-2.264 5.424-4.564 7.751-7.204-5.004 5.799-11.414 10.207-18.738 8.964-.213.357-.488.47-.804.662")
        ]), M),
        A2(Da, l([
            Fa("path537"),
            Ha("#ccb25c"),
            qa("M145.709 334.531c-6.458 4.817-10.258 10.597-9.592 18.908 2.307-.776 3.476.972 5.334 2.43-.324-2.722-3.407-3.168-4.341-5.248-1.752-3.903 3.764-11.775 6.454-13.229")
        ]), M),
        A2(Da, l([
            Fa("path539"),
            Ha("#ccb25c"),
            qa("M148.212 365.285c.673 2.172.383 4.739.075 6.76.842-.041 1.574-.324 2.286-1.03-1.516-1.733-1.945-4.917-2.003-7.161")
        ]), M)
    ]), ur = l([
        A2(On, l([
            Fa("g1801")
        ]), l([
            A2(Da, l([
                Fa("path1803"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M354.693 448.645c-.694.236-1.36.396-2.054.674-.417.165-.388.245-.463.616-.063.327-.24.793-.234 1.139.007.538.427 1.123.768 1.497.478.522.917.991 1.203 1.669.403.946.579 1.929.875 2.904.391 1.288.957 2.528 1.348 3.818.227.745.513 1.746.474 2.521-.026.541-.435.958-.343 1.461.089.487.533 1.49.997 1.72.501.244 1.382.241 1.89.034.561-.228 1.082-.574 1.646-.784.326-.121.589-.202.798-.47.798-1.025-.025-2.169-.608-2.955-.79-1.062-.688-2.004-.878-3.239-.33-2.123-1.328-4.09-1.523-6.276-.046-.513.026-.953.115-1.44.058-.321.311-.884.156-1.182.418-.366-.305-1.491-.586-1.791-.507-.538-.99-.08-1.596-.033-.677.051-1.294-.118-1.985.117z")
            ]), M),
            A2(Da, l([
                Fa("path1805"),
                Ha("#dcc06d"),
                qa("M356.62 460.824a.547.547 0 0 0 .188.137c.326-.337-.352-1.057-.47-1.408.03-.003.041.011.068.006.025-.389-.347-1.004-.486-1.36-.146-.378-.222-.687-.23-1.063.032.028.086.057.104.067.01-.212-.149-.352-.263-.517a5.454 5.454 0 0 1-.531-.949c.351 1.135.704 2.241 1.168 3.336.063.145.178.319.203.475.025.149-.032.237-.017.375.025.292.241.556.287.85")
            ]), M),
            A2(Da, l([
                Fa("path1807"),
                Ha("#dcc06d"),
                qa("M353.187 450.879c.225.336.152.688.268 1.029.103.302.458.682.652.949.214.291.616.45.761.799-.195-.509-.8-1.294-.313-1.795-.322-.101-.232-.602.134-.324a.645.645 0 0 1-.217-.313c.112-.02.229.068.344.128.004-.196-.086-.422.031-.591-.382.114-.648-.014-.938-.268.326.779-.2.381-.589.126-.139-.092-.305-.041-.23-.238.048-.127.561-.297.696-.341a.6.6 0 0 0 .033.054c.12-.02.283-.057.402-.031.219.044.257.202.419.282.172.085.407 0 .64-.068-.094-.101-.205-.233-.241-.388-.085.308-1.051.051-1.18-.183-.132-.238.161-.311.406-.334.213-.021.521-.106.718-.105.225.001.399.352.603.321.296-.047.055-.343.46-.051.188.138 1.432 1.1 1.231.158.211.188.497.24.524.557.032.339-.275.629-.077.968.153-.091.279-.251.441-.349.358.296.036.963.015 1.339-.013.303.003.987-.309 1.144.002-.121.096-.216.219-.251.214.358.194.833.237 1.234.064.584.145 1.184.256 1.762.096.495.182.986.295 1.479.098.431.281.884.332 1.319-.589-.558-.923-1.607-1.122-2.378-.155-.601-.034-1.265-.217-1.848-.436 1.13-.092 2.318.047 3.475.04.342.08.689.11 1.03.016.18-.06.493.03.651.099.178.505.363.659.56.134.173.243.355.362.536.263.404 1.572 1.357.337 1.634-1.088.239-.911-.954-1.301-1.491.018.044 0 .19-.103.259-.145-.16-.229-.413-.436-.515-.087.142-.112.302-.181.452-.102.226-.32.415-.307.671.008.205.255.402.257.61-.002.169-.127.415-.294.305-.021.011-.051.08-.07.099-.04-.038-.096-.06-.135-.094.135.208.071.394.028.616.367.102-.013.324-.124.435-.205.204-.157.363-.251.593.17.076.356.25.358.443.313-.071.514-.454.881-.156.315.253.452.658.857.852.123.059.305.031.404.085.092.047.223.053.205.201-.019.183-.119.054-.201.104-.41.253-1.189.195-1.418.636.606.168 1.142.132 1.706-.133.329-.153.639-.403.973-.544.203-.087.531-.281.747-.279-.317-.084-.665-.094-.971-.226-.239-.099-.968-.436-.467-.687-.22-.175-.697-.463-.181-.723-.178-.128-.421-.345-.378-.59.382.093.395.119.762-.075.33-.176.757-.23 1.013.07.368-.48 1.228 1.331.834 1.743.354-.397.025-1.013-.169-1.397-.247-.486-.503-.963-.753-1.445-.234-.45-1.201-1.457-1.006-1.933.155.083.221.242.366.334-.126-.897-.034-1.838-.243-2.746-.258-1.116-.804-2.167-1.092-3.273-.288-1.104-.581-2.581-.303-3.708.094-.378.352-.886.311-1.273-.025-.247-.326-.786-.505-.936a.496.496 0 0 0-.269-.125c.02.042.027.097.047.142-.22.023-.555-.081-.751-.218.051-.011.083-.028.137-.028-.137-.205-.892.046-1.142.059-.276.014-.754-.016-.995.147.036.052.038.156.076.207-.407.169-.888.201-1.327.246-.338.034-.547.358-.846.361.147-.095.159-.254-.012-.293-.109-.025-.382.199-.481.246.305.257-.221.426-.368.207a21.96 21.96 0 0 0-.161 1.054c.089-.635.855-.264 1.05.033z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1809")
        ]), l([
            A2(Da, l([
                Fa("path1811"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M360.625 465.413c.529.079 1.308-.101 1.788.22.418.28.476.739.464 1.196-.025 1.087.363 2.234.798 3.292.453 1.102 1.056 2.374 1.778 3.348.304.411.619.537.848 1.06.171.39.624 1.532.526 1.934-.108.446-1.015.805-1.356.993-.364.2-.851.54-1.307.443-.54-.117-.646-.649-.926-1.065-.271-.407-.662-.759-.929-1.283-.311-.61-.302-1.273-.601-1.962-.36-.83-.942-1.681-1.44-2.445-.424-.654-.879-1.407-1.382-1.97-.382-.427-.727-.52-.964-1.045.429-.079.049-.626.103-.884.063-.321.622-1.017.849-1.236.312-.304.719-.199 1.15-.339.42-.136.571-.317 1.068-.167")
            ]), M),
            A2(Da, l([
                Fa("path1813"),
                Ha("#dcc06d"),
                qa("M366.742 476.065c-.263-.513-.356-1.105-.577-1.603-.163-.37-.579-.525-.796-.83-.125-.176-.23-.411-.35-.599-.094-.146-.233-.255-.313-.361-.221-.303-.492-.746-.625-1.101.028.076.024.176.044.257-.286-.132-.447-.49-.603-.73-.083-.133-.236-.24-.337-.393-.103-.152-.155-.349-.252-.476-.006.246.113.437.257.59.071.077.143.077.211.179.054.075.063.2.1.282.203.449.61.818.85 1.27-.299-.104-.767-.664-1.009-.919-.184-.194-.284-.497-.478-.678-.28-.26-.393-.167-.484-.605-.035-.163.002-.12-.071-.279-.087-.192-.238-.375-.352-.557.054.301.012.452.144.718.153.311.357.626.517.924.094.175.197.425.309.579.186.262.561.399.694.719-.193-.05-.418-.188-.611-.249.094.179.213.352.324.521.166.253.396.404.605.644.29.329.354.959.796 1.126-.115-.172-.398-.489-.23-.657.137.2.337.559.526.698.127.092.293.089.405.209-.17-.183-.578.383-.629.505.205.091.283-.086.438-.157.193-.09.338-.09.553.004.402.175.731.587.944.969z")
            ]), M),
            A2(Da, l([
                Fa("path1815"),
                Ha("#dcc06d"),
                qa("M359.518 468.944c.575.065 1.032.559 1.396 1.01.312.388.866.997.971 1.483-.065-.122-1.092-1.594-1.218-1.299-.041.1.348.615.409.703.188.281.491.678.568 1.001-.612-.684-.956-1.772-1.862-2.071.132-.039.274.01.404-.009-.098-.117-.215-.221-.314-.351.019-.007.031.012.056.002-.095-.165-.276-.288-.361-.447a.127.127 0 0 1 .092.017")
            ]), M),
            A2(Da, l([
                Fa("path1817"),
                Ha("#dcc06d"),
                qa("M358.908 468.167a.232.232 0 0 1-.161-.066c.084-.365.366.077.112.054")
            ]), M),
            A2(Da, l([
                Fa("path1819"),
                Ha("#dcc06d"),
                qa("M358.996 467.507c-.225.095-.257-.072-.16-.192.011-.016.134.036.168.02.054-.023.043-.133.097-.156.112-.049.145.011.247-.057.107-.066.126-.204.259-.254.08.334.428.389.362.701a1.344 1.344 0 0 1-.545-.447.07.07 0 0 0 .05-.014c-.13.074-.316.324-.488.32")
            ]), M),
            A2(Da, l([
                Fa("path1821"),
                Ha("#dcc06d"),
                qa("M360.543 466.736c-.121-.104-.229-.09-.299.014-.191-.308.313-.443.487-.572-.094-.099-.248-.078-.318-.213a.818.818 0 0 1 .032-.071.474.474 0 0 0-.169-.06c-.226.286-.727.347-1.079.248.214-.134.523-.116.753-.227.141-.065.256-.185.401-.238.315-.117.786-.081 1.128-.08.706.001 1.4.391 1.347 1.258-.024.362-.1.574-.03.958.051.267.096.539.128.8.051.402.238.774.388 1.168.137.36.399.697.472 1.066-.337-.557-.751-1.122-1.013-1.717-.118-.267-.034-.475-.064-.767-.041-.407-.099-.668-.322-1.014-.068-.104-.121-.118-.156-.244-.042-.153.075-.256-.055-.391-.058.039-.133.024-.188.061.07-.641-.991-.157-1.143.17-.131-.057-.328-.14-.41-.078")
            ]), M),
            A2(Da, l([
                Fa("path1823"),
                Ha("#dcc06d"),
                qa("M358.162 467.305c.184-.07.35-.854.537-.565-.121.192-.409.427-.449.642")
            ]), M),
            A2(Da, l([
                Fa("path1825"),
                Ha("#dcc06d"),
                qa("M362.958 473.182c.335.254.146.586.101.839-.06.333.099.733.306 1.032.426.613.512-.105.773-.376.107.21.151.523.322.688-.243.329.188.623.199.923.008.207-.192.412-.229.609-.075-.298-.133-.556-.422-.708-.187-.097-.406-.016-.568-.089-.407-.184.016-.467-.017-.702-.205.061-.338.05-.512-.115-.188-.177-.236-.414-.333-.661-.122-.31-.312-.624-.398-.94.269.528.599.99.905 1.483.139-.112.035-.242-.022-.398-.105-.278-.103-.318-.062-.576.06-.379.104-.72-.131-1.082")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1827")
        ]), l([
            A2(Da, l([
                Fa("path1829"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M363.907 478.02c.606-.645 1.498-1.18 2.435-.933.285.077.742.136.991.248.813.36.049 1.252-.088 1.743-.067.243-.065.499-.049.755.034.532.222 1.021.467 1.499.41-.717.817.711.852 1.101.054.616-.002 1.492-.725 1.686-.666.178-1.487-.326-1.865-.828-.356-.473-1.13-1.576-.026-1.271-.25-.554-.419-1.222-.786-1.702-.382-.492-1.081-.556-1.503-.942-.463-.428-.044-.996.297-1.356z")
            ]), M),
            A2(Da, l([
                Fa("path1831"),
                Ha("#dcc06d"),
                qa("M365.005 479.461c.087-.207.292-.086.373.024-.027-.2-.198-.26-.324-.375.05.006.138-.027.195-.017-.012-.036-.021-.09-.039-.122.02-.011.07-.024.081-.046-.094-.168-.088-.354-.307-.384-.142-.02-.39.116-.535.131-.105.008-.677.118-.754.062-.163-.12.075-.352.171-.448.111.164.472.317.645.194-.175-.138-.434-.137-.626-.244.056-.164.322-.3.485-.347-.338.485.348.172.575.288.133-.232.443-.292.528-.565.246-.204-.392-.184-.443-.199.384-.086.736-.219 1.128-.19.274.017.589.073.859.13.183.038.511.135.597.328.117.273-.23.958-.396 1.157.027-.223.131-.703-.188-.789-.192-.051-.354.144-.439.276-.315-.375-1.017-.07-1.322.179-.017.125.07.147.099.246.034.121.025.133.038.243.01.092-.034.155-.004.253.014.052.143.133.165.221.044-.045.102-.048.142-.079.058.113.113.24.151.36a1.137 1.137 0 0 0-.46-.225c-.144-.037-.251.025-.368-.098a.97.97 0 0 0 .069-.006")
            ]), M),
            A2(Da, l([
                Fa("path1833"),
                Ha("#dcc06d"),
                qa("M366.368 479.359c-.096-.105-.136-.214-.055-.309.118.088.147.27.023.323")
            ]), M),
            A2(Da, l([
                Fa("path1835"),
                Ha("#dcc06d"),
                qa("M366.793 479.141c-.113-.074-.216-.215-.153-.338.169.153.262.267.499.227-.271.299-.014 1.086.065 1.424.098.419.631 1.065.177 1.439.11.165-.051.238-.025.401a.598.598 0 0 0-.254-.101.57.57 0 0 0 .225.34c.012-.035.063-.086.077-.126.244.208.197.596.073.839-.112-.414-.309-.357-.654-.345.081-.196-.067-.493-.263-.578 0 .089-.027.158-.012.247a2.454 2.454 0 0 1-.504-.181c.254-.146.049-.382-.18-.233.027-.019.103-.129.146-.163a.642.642 0 0 1-.144-.271c.192.099.626.372.698.023.045-.215-.178-.25-.263-.39-.096-.16-.058-.371-.132-.571.132.094.175.26.271.379a.104.104 0 0 1 .044-.037c.136.146.246.632.504.383.196-.188-.055-.54-.119-.73.283-.238-.256-.442-.327-.614-.078-.19.08-.246.116-.389.049-.192-.074-.404-.024-.572.217.12-.008.472.259.585.058-.09.043-.355.004-.469-.027-.087-.205-.343-.161-.228")
            ]), M),
            A2(Da, l([
                Fa("path1837"),
                Ha("#dcc06d"),
                qa("M367.697 481.344a.152.152 0 0 1 .137-.024c.088.185.16.812-.213.504.274.232.151.367.147.638-.002.188.249.534-.009.601.034.044.053.154.09.209-.021.005-.041.037-.052.05-.004-.013-.008-.026-.016-.037.046.117-.062.257.104.412.032-.563.318-.192.177.123.358-.5.414-.828.354-1.459-.02-.214-.184-1.322-.612-1.023")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1839")
        ]), l([
            A2(On, l([
                Fa("g1841")
            ]), l([
                A2(Da, l([
                    Fa("path1843"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M349.493 459.291c-.84.381-1.872.596-2.791.657-.049-.181-.09-.471-.184-.634-.11-.188-.332-.314-.481-.527-.337-.482-.108-1.056-.18-1.628-.078-.638-.377-1.236-.58-1.833-.283-.819-.519-1.638-.887-2.424-.533-1.136-1.212-2.036-1.971-3.027-.376-.486-.973-1.153-.783-1.808.036-.124.22-.498.356-.564.249-.126.52.032.84-.056.581-.158.953-.603 1.615-.655.552-.042 1.226.049 1.636-.454.188.367.62.83.728 1.218.132.475.01 1.069.113 1.585.251 1.286.631 2.515.878 3.822.265 1.406.861 2.588 1.579 3.785.432.721 1.324 1.997.112 2.543z")
                ]), M),
                A2(Da, l([
                    Fa("path1845"),
                    Ha("#dcc06d"),
                    qa("M347.881 459.378c.109-.684-.479-.088-.567-.16a2.71 2.71 0 0 1-.482-.487c.273.037.409.076.668-.04.177-.079.337-.287.512-.343.277-.087.205-.031.277.24.063.229.126.367.281.547.252-.232.691-.137.919-.398.263-.299.111-.662.026-.982.326.054.535.432.526.75-.006.357-.334.579-.64.688-.358.125-.736.182-1.081.328-.272.115-.583.336-.896.213.193-.053.427-.158.457-.356z")
                ]), M),
                A2(Da, l([
                    Fa("path1847"),
                    Ha("#dcc06d"),
                    qa("M346.126 458.128c.324-.283.778.047.719.419.473-.286 1.104-.343 1.418-.878.198.054.579.183.786.13.225-.057.259-.249.576-.107.162-.364-.859-1.352-1.021-1.71a17.42 17.42 0 0 1-.968-2.725c-.131-.487-.538-.601-.712-1.065-.194-.517-.348-.955-.392-1.516-.029-.38-.087-.742-.087-1.122-.002-.24.039-.569-.053-.776-.012.778.087 1.669-.039 2.448a2.834 2.834 0 0 1-.906-1.573c-.077.14-.056.304-.087.441-.328-.325-.626-.667-.938-1.007-.221-.241-.51-.372-.744-.588-.032.249.253.617.37.851.207.42.736.737.821 1.214-.068.012-.147.073-.217.078.185.176.658.45.68.748.015.247-.22.241-.202.506.04.649.752 1.131.806 1.812.369.077.578 1.047.587 1.376.004.156-.007.357-.032.513-.014.08-.113.157-.107.238.005.075.113.063.118.094.049.279.068.639-.106.903-.133.203-.097.235-.273.068-.076-.073-.168-.44-.229-.545-.118-.21-.278-.417-.356-.646.181.536.296 1.066.414 1.612.036.165.094.703.161.721")
                ]), M),
                A2(Da, l([
                    Fa("path1849"),
                    Ha("#dcc06d"),
                    qa("M344.9 452.492c-.151-.191-.372-.444-.446-.679-.036-.119.028-.194-.004-.284-.094-.257-.274-.606-.467-.78-.38-.346-.89-.758-1.116-1.218a4.86 4.86 0 0 0 .973 1.447c.301.316.41.653.606 1.046.179.354.39.697.583 1.043.105.187.209.372.311.56.053.103.104.187.207.229.227-.531-.351-.997-.647-1.364z")
                ]), M),
                A2(Da, l([
                    Fa("path1851"),
                    Ha("#dcc06d"),
                    qa("M342.272 448.887c-.167-.428.139-.747.569-.534.169.082.288.378.479.119-.694-.333.768-.505.905-.601-.048-.209-.249-.279-.096-.472.249-.315.575.074.602.329.313-.11.177-.352.559-.287.216.038.495.281.643-.033.238.257.29.582.396.901.005-.129-.137-1.065.226-.718.101-.342-.449-.769-.682-1.021-.124.201-.466.229-.694.234-.364.008-.683.015-1.042.109-.425.113-1.041.411-1.29.792-.275-.028-.616-.141-.845.076-.247.235-.288.761-.165 1.04.043-.232.079-.995.538-.756-.284.154-.254.533-.097.767")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1853"),
                Ha("#ccb25c"),
                qa("M347.909 457.752c-.232.183-.509.627-.839.568.113-.077.223-.161.276-.29-.025-.009-.086-.067-.124-.074.061-.118.237-.228.191-.374-.02-.063-.219-.181-.269-.245-.075-.097-.119-.22-.194-.315.188.015.244.194.3-.044.063-.284-.282-.622-.363-.881.352.225.551.708.798 1.032.083.105.29.204.145.36.073-.004.126.01.197-.012.031.157-.163.278-.223.428")
            ]), M),
            A2(Da, l([
                Fa("path1855"),
                Ha("#ccb25c"),
                qa("M349.537 457.386c-.12-.036-.255-.055-.349.021.016-.349-.563-.926-.754-1.231-.378-.595-.734-1.223-.896-1.912.032.049.092.074.127.105.002-.215-.157-.47-.138-.65.233.358.308.813.491 1.198.188.396.431.772.661 1.146.286.467.595.914.94 1.333")
            ]), M),
            A2(Da, l([
                Fa("path1857"),
                Ha("#ccb25c"),
                qa("M344.864 447.268c-.155-.181-.365-.182-.567-.26.153-.072.478-.217.633-.128-.292.2-.079.325.177.42")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1859")
        ]), l([
            A2(On, l([
                Fa("g1861")
            ]), l([
                A2(Da, l([
                    Fa("path1863"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M352.771 467.732c-.366.354-.915.18-1.36.284-.366.088-.665.275-1.07.284-.913.026-1.243-.539-1.099-1.413.117-.71-.002-1.206-.26-1.849-.329-.82-.704-1.605-1.446-2.107-.571-.385-.687-.482-.904-1.093-.115-.322-.236-.327.061-.728.238-.323.706-.6 1.008-.862.695-.604 1.277-1.125 2.242-.938.631.122 1.321.338 1.391 1.085.027.293-.131.626-.141.938-.011.444.017.853.096 1.298.232 1.317 1.056 2.543 1.623 3.681.203.41.233 1.061-.141 1.42z")
                ]), M),
                A2(Da, l([
                    Fa("path1865"),
                    Ha("#dcc06d"),
                    qa("M350.127 466.813c-.113.013-.203.129-.318.15.004-.114-.042-.266-.186-.209-.103.04-.081.266-.171.342-.249-.244.036-.604.044-.887.006-.309-.138-.652-.248-.916.222-.114.457.19.563.369.021-.226.194-.121.237-.255.051-.156-.064-.549-.113-.709-.108-.367-.331-.819-.621-1.067-.029-.147.002-.189.156-.179-.198-.244.088-.21.13-.338.079-.229.021-.582-.111-.785-.251-.386-.913-.396-1.299-.311.115.096 1.389 1.175.745 1.082-.198-.028-.365-.341-.491-.471-.213-.221-.465-.451-.75-.574.349.399.945.88 1.07 1.43-.589-.166-.837-1.168-1.489-1.259.008-.036.012-.074.018-.115-.567-.088-.245-.359-.109-.791.104.215.37.445.589.262-.26.529.549.352.702.092.277-.475-.731-.638-1.064-.719.213-.052.479-.177.704-.14.237.039.458.27.683.355.422.163.575.24.787-.217.16.079.287.24.474.168.166-.067.258-.431.393-.556.085.104.206.102.322.031-.026.625-.059 1.103.115 1.742.123.453.117 1.252.408 1.624a.342.342 0 0 0 .103-.356c.066.35.382.613.468.971.044.179.113.332.153.466.05.158.193.293-.006.413-.102-.136-.092-.086-.231-.09.009.39.111.371.427.482.277.094.447.238.484.535-.355-.369-1.048-.063-1.305.285.084-.5.452-.808.121-1.318-.411.416-.258-.243-.29-.418-.131.009-.221.101-.316.195-.074-.068-.155-.108-.202-.203.139.197 1.149 1.468.322 1.45-.049.236.213.43.279.618a.976.976 0 0 1 .04.658c-.123.52-.908.702-1.348.454.304-.125.793-.236.849-.639.048-.333-.26-.639-.582-.487.254-.169-.016-.179-.136-.165z")
                ]), M),
                A2(Da, l([
                    Fa("path1867"),
                    Ha("#dcc06d"),
                    qa("M348.171 460.57c.113-.734.629.021.818-.158-.161-.425.265-.81.702-.732a.674.674 0 0 1 .461.307c.102.152-.065.354.236.339.113-.357.563-.267.732-.021-.086-.74-1.088-.874-1.718-.753-.204.04-2 .573-1.465.953.107-.16.292-.118.292.077")
                ]), M),
                A2(Da, l([
                    Fa("path1869"),
                    Ha("#dcc06d"),
                    qa("M349.786 460.499c-.175-.069-.277-.18-.249-.343.188.029.309.197.215.366")
                ]), M)
            ])),
            A2(On, l([
                Fa("g1871"),
                Ha("#ccb25c")
            ]), l([
                A2(Da, l([
                    Fa("path1873"),
                    qa("M349.708 466.852c-.099-.072-.211-.133-.301-.216a.722.722 0 0 1 .068-.058c-.084-.136.035-.135.031-.247a.892.892 0 0 0-.159-.47c.161.117.278.355.392.528.009-.034.036-.069.047-.096.236.304.308-.034.576-.022-.002-.031 0-.083-.002-.102.094.061.173.153.261.215-.178.056-.483.215-.477.428-.072-.117-.232-.122-.348-.062")
                ]), M),
                A2(Da, l([
                    Fa("path1875"),
                    qa("M352.542 466.265c-.156-.188-.329-.266-.559-.319.443-.226-.316-.972-.304-1.268.223-.051-.078-.523-.144-.67.185.543.53 1.049.771 1.565.136.294.358.647.402.967-.085-.21-.259-.302-.386-.476")
                ]), M),
                A2(Da, l([
                    Fa("path1877"),
                    qa("M350.993 460.391c-.094-.205-.257-.252-.447-.16.018-.033.027-.078.04-.104a.6.6 0 0 0-.271.063 1.154 1.154 0 0 0-.414-.359c.211.114.479-.06.702-.001.187.049.521.27.497.491")
                ]), M)
            ]))
        ])),
        A2(On, l([
            Fa("g1879")
        ]), l([
            A2(On, l([
                Fa("g1881")
            ]), l([
                A2(Da, l([
                    Fa("path1883"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M350.383 469.518c-.354.424.17.529.319.902.126.313.182.386.555.435.378.05.764.097 1.101.321.391.264 1.088 1.128.733 1.502-.294.309-.382.238-.195.645.14.312.368.541.604.829.106.134.228.205.344.303.125.107.206.212.338.325.122.105.223.135.38.17.122.027.501.156.627.122.188-.052.308-.319.501-.421.131-.068.286-.134.362-.261.151-.239.199-1.009.097-1.264-.06-.148-.254-.304-.346-.474-.102-.187-.252-.384-.342-.57-.076-.16-.021-.406-.257-.488-.259-.089-.468.131-.441.365-.397-.17-.547-.987-.621-1.367-.075-.371-.275-1.213.104-1.478-.054-.018-.144-.106-.207-.123.131-.366-.017-.547-.245-.831-.06-.073.058-.09-.1-.157-.084-.034-.19.027-.269.041a7.536 7.536 0 0 1-.568.072c-.734.059-1.531.478-1.883 1.158-.236-.303-.437.06-.591.244z")
                ]), M),
                A2(Da, l([
                    Fa("path1885"),
                    Ha("#dcc06d"),
                    qa("M353.833 471.771c.071.163.304.548.211.727-.121.233-.548.114-.732.028-.229.164-.474.464-.122.645.038-.339.343.107.414.226.182-.035.224-.325.393-.084.098.142-.028.347.006.462.151-.416.378-.089.424.195.032.197-.121.617.077.707.046-.138.056-.789.182-.829.131-.041.429.344.509.417-.033-.207.102-.483.349-.476.13.005.252.122.357.183-.127-.188-.014-.482-.294-.516-.136-.015-.29.098-.437.087-.265-.018-.606-.268-.697-.512-.277-.754 1.054-1.164.802-.169.204-.1.485.284.638.414-.027-.025-.124-.326-.156-.386-.078-.152-.184-.292-.253-.449-.063-.141-.115-.451-.243-.554-.271-.217-.372.049-.585.209-.284-.361-.563-1.054-.689-1.563a2.767 2.767 0 0 1-.068-.688c.007-.226.184-.54.142-.704-.184.275-.408.396-.424.751-.016.321.05.638-.014.948-.155-.048-.309-.156-.472-.221.34.361.489.716.682 1.152z")
                ]), M),
                A2(Da, l([
                    Fa("path1887"),
                    Ha("#dcc06d"),
                    qa("M350.736 470.344a.358.358 0 0 1 .031-.202c.147-.096.471-.111.45.13.263-.013.439.127.661.236.319.158.693.15 1.062.22-.127-.081-.545-.275-.151-.377-.056-.164-.033-.224-.119-.36-.073-.114-.457-.288-.481-.415-.081-.398.714.029.876.142-.084-.089-.391-.343-.377-.476.021-.183.303-.179.437-.205.162-.031.167-.12.382.014.131.083.139.198.29.217.011-.333.301-.728-.113-1.047-.065.2-.2.14-.343.204-.218.1-.169.078-.25.28-.046.122.147.203-.147.193-.165-.007-.242-.243-.428-.13.313.32-.365.625-.639.527-.002-.21.247-.256.37-.401-.332-.245-1.154.463-.656.763.253-.32.988.028.909.438-.106.576-.672-.124-.834-.281-.108.143-.272.198-.42.065-.007.239-.087.069-.214.086-.013.001-.155-.055-.181-.059-.083-.015-.108.104-.211.065-.395-.154.093-.445.339-.384-.089-.373-.443-.139-.512.119-.079.299.226.364.326.585")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path1889"),
                Ha("#ccb25c"),
                qa("M353.64 468.255c.119.16.301.148.334.425.022.188-.06.32-.143.48-.179-.061-.384-.149-.518-.284.017.001.161-.009.163-.005-.088-.167.393-.308.164-.616z")
            ]), M),
            A2(Da, l([
                Fa("path1891"),
                Ha("#ccb25c"),
                qa("M351.309 469.131c-.18.09-.284.377-.349.553-.031-.182-.191-.275-.332-.134 0-.055.032-.283.121-.298.07-.011.149.183.214.229.07-.112.117-.244.24-.334")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1927")
        ]), l([
            A2(Da, l([
                Fa("path1929"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M360.728 450.435c.022.251.15.32.236.549.088.227.024.434.106.652.206.557.919 1.093 1.297 1.539.217.256.469.522.658.804.764 1.125.76 2.329 1.08 3.592.265 1.046.633 2.102.948 3.128.404 1.291 1.053 2.384.987 3.732-.053 1.129.399 2.267 1.502 2.729.785.33 1.933.206 2.661-.228.336-.199.892-.618 1.037-.986.139-.354.083-.806-.004-1.167-.101-.412-.151-.851-.265-1.263-.094-.352-.335-.526-.607-.833-.706-.79-.986-1.979-1.245-3.014-.353-1.398-.855-2.789-1.11-4.206-.276-1.548-.364-3.204-.302-4.775.019-.459.1-.965-.09-1.398-.306-.688-1.512-1.864-2.216-1.401-.754.497-1.208 1.092-2.12 1.252-.462.081-.888-.008-1.344-.128-.854-.223-1.27.696-1.209 1.422z")
            ]), M),
            A2(Da, l([
                Fa("path1931"),
                Ha("#dcc06d"),
                qa("M366.061 461.512a.478.478 0 0 1-.141-.29c.041.006.145-.023.202-.021.046-.79-.513-1.599-.799-2.324-.446-1.134-.796-2.313-1.172-3.475.129 1.228.641 2.403.869 3.544.046.242.189.423.256.649.072.253.011.52.124.761.063.14.242.254.321.452.094.241.038.4.254.616")
            ]), M),
            A2(Da, l([
                Fa("path1933"),
                Ha("#dcc06d"),
                qa("M367.52 465.32a.466.466 0 0 1-.028.411c.171.073.29.215.334.393-.117-.482.564-.125.672.082.262.512-.302.639-.598 1.011.564.353 1.646.146 2.128-.298.244-.222.771-.859.685-1.186-.757.239-1.924-.05-2.111-.929-.211-.974 1.486-.613 1.994-.703-.176-.308.045-.548.322-.291-.198-.185-.224-.532-.433-.757-.181-.192-.599-.544-.863-.613.153.151.341.297.238.525.324-.118.435.368.403.602-.12-.13-.222-.261-.351-.376-.144.228-.404.204-.564.023-.013.122-.005.245-.028.38.171.009.151.088.25.147-.155.136-.973.276-1.188.152-.246-.141-.199-.647-.139-.908a.462.462 0 0 1 .407.185.337.337 0 0 1 .224-.348c-.258-.178-.117-.449.041-.63-.139-.04-.397.186-.479.148-.249-.108-.094-.568.066-.691.377-.284.207.068.45.121.173.036.299-.159.493.003-.097-.384-.092-.763-.25-1.157-.074-.184.051-.274-.166-.36-.177-.069-.306-.003-.344.168.254-.034.463.211.315.418-.418-.064-.627-.37-.761-.718-.107-.278-.563-1.065-.169-1.209-.115-.455-.31-.846-.353-1.263-.051-.509-.168-1.002-.249-1.523-.036-.247-.027-.512-.079-.757-.021-.112-.164-.383-.157-.481.025-.525.188-.149.283.141.122.361.2.742.303 1.113.235.84.685 1.703.879 2.554-.587-.915-.642-2.318-.862-3.37-.211-1.017-.089-1.998-.187-3.007-.099-.992.165-2.124-.284-3.055-.228-.468-.655-.93-1.156-1.106-.414-.147-.957.06-1.335.251-.196.098-.284.276-.438.412-.414.363-.876.444-1.405.485-.326.025-.757-.142-1.06.004.143.529 1.188.371 1.578.313.396-.059 1.395-.243 1.587-.552.012.078.083.17.096.248.367-.223.591-.568 1.068-.328.445.22.478.75.565 1.181.119.609.232 1.223.294 1.846.05.504.246 1.191.214 1.639-.103-.188-.202-.458-.367-.571-.115.986.018 1.948.194 2.917.063.349.324.999.258 1.331-.126.632-.536-.126-.604-.46.079.243-.062.417-.316.418-.121-.227-.249-.51-.394-.705.053.424-.284.389-.38.66-.084.231.179.614.252.839.142.433.258.882.393 1.318.113.366.062.83.26 1.166.228.379.584.454.663.992.038.242.085.483-.058.704-.104.164-.373.044-.458.413-.028.129.083.189.062.35-.032.213-.121.333-.211.511-.133.267-.192.526-.318.802-.004.009.197.686.209.791.396-.127.693-.633 1.148-.435.715.311.123.505-.185.619z")
            ]), M),
            A2(Da, l([
                Fa("path1935"),
                Ha("#dcc06d"),
                qa("M364.344 453.38c.068.422.249.814.342 1.229-.457-.332-.432-.854-.749-1.286-.313-.425-.816-.722-1.154-1.099-.24-.268-.123-.314-.153-.69-.016-.191-.328-.614-.274-.823.159-.632.646.298.814.531.222-.358.306.009.405.23.177.388.328.462.553.781.236.331.157.748.216 1.127z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1937")
        ]), l([
            A2(Da, l([
                Fa("path1939"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M367.486 468.72c.225.514.817.965 1.115 1.465.749 1.25 1.122 2.672 1.843 3.925.244.42.32.765.246 1.224-.069.408-.169.835.11 1.278.22.352.76 1.096 1.184 1.239.594.198 1.263-.327 1.771-.576.277-.137.55-.281.819-.419.384-.192.42-.154.386-.567-.072-.878-.723-1.369-1.12-2.076-.283-.501-.326-1.01-.426-1.562-.109-.61-.322-1.201-.504-1.794-.213-.699-.479-1.473-.544-2.203-.049-.545.363-1.123.187-1.65-.155-.445-.779-.687-.808-1.211-.492.184-1.042.148-1.438.535-.414.402-.79.611-1.387.707-.883.141-1.912.591-1.434 1.685z")
            ]), M),
            A2(Da, l([
                Fa("path1941"),
                Ha("#dcc06d"),
                qa("M371.919 477.432c-.406-.45-.257-1.108-.662-1.572-.354-.405-.37-.735-.442-1.297.107.012.064-.054.178.009-.058-.207-.011-.474.26-.377-.002-.477.047-.505.431-.303.292.154.19.323.508.011-.164-.464-.629-1.141-.563-1.632.041.02.069.039.107.05-.103-.747-.553-1.415-.828-2.096.521 1.004 1.118 1.92 1.546 2.966.161.388.338.743.533 1.101.207-.273-.134-.758-.226-1.066.285.229.627.953.776 1.325-.106-.191-.049-.299.167-.242-.163-.465-.542-.929-.54-1.387.002-.434.087-.493-.228-.822-.585-.607-.623-1.361-.867-2.167-.1-.332-.388-.819-.39-1.163-.002-.393.312-.771.337-1.188.032-.561-.166-.584-.678-.563-.29.013-.708-.051-.783.314-.604-.204-.896.009-1.407.299-.27.152-.429.432-.676.547-.223.102-.449-.039-.694.188-.143-.33 1.028-.949 1.174-.784.256-.037.286-.269.489-.372.183-.093.481-.117.681-.164.304-.066.624-.181.881-.344-.523-.207-1.094.245-1.577.396.247-.232.664-.387.948-.603.163-.12.356-.306.565-.338.232-.036.506.205.702.028.245.251.685.651.796.979.129.396-.129.678-.233 1.034-.267.93.186 1.961.446 2.838.245.817.58 1.629.865 2.419.135.378.229.779.432 1.146.171.308.69.623.646 1.008-.487.173-1.872-.17-2.078.621.045-.002.173.064.2.066-.181.306-.52.249-.699.444-.212.231.066.536-.135.741a.773.773 0 0 1-.151-.36")
            ]), M),
            A2(Da, l([
                Fa("path1943"),
                Ha("#dcc06d"),
                qa("M370.444 471.196c.146.49.365 1 .547 1.471-.12-.167-.243-.374-.41-.468a.81.81 0 0 0-.042.462c-.19-.291-.234-.812-.374-1.171-.143-.366-.244-.762-.463-1.087-.157-.236-.472-.426-.428-.766.771.041.998.976 1.17 1.559z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1945")
        ]), l([
            A2(Da, l([
                Fa("path1947"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M372.986 476.52c-.314.191-.734.702-.7 1.093-.448.116-1.028.149-.997.755.021.432.275.928.604 1.205.434.365.944.529 1.324.953.408.45.702.936.905 1.508-.261.1-.529-.018-.806-.016-.095.203-.01.312-.006.499.002.106.073.193.077.286.005.109-.125.148-.117.221.056.448.436.989.74 1.397.364.49 1.661 1.027 2.275.884.329-.077.788-.438.983-.676.34-.408.216-.714.192-1.223-.021-.464-.014-1.003-.188-1.44-.191-.479-.588-.589-.808-.979-.153.096-.257.261-.378.401-.393-.274-.537-1.403-.55-1.854-.014-.529.015-1.192.177-1.694.124-.381.287-.376.063-.76-.133-.227-.579-.744-.828-.826-.209-.067-.68.059-.906.069-.375.02-.718-.006-1.056.197z")
            ]), M),
            A2(Da, l([
                Fa("path1949"),
                Ha("#dcc06d"),
                qa("M372.293 478.038c.215.095.254.28.337.487.015-.029.039-.065.051-.092.165.143.301.523.314.744-.073-.288-.227-.631-.187-.926.372.004.308.64.525.826-.034-.145-.196-.594-.043-.697.064-.046.228.081.326.084.061.098.237.269.354.336-.2-.353-.384-.828-.753-.979-.209-.085-.556-.002-.625-.28-.07-.266.369-.594.612-.645.186-.041.35.124.51.126.164.003.348-.118.53-.146.368-.056.639.077.852.387.081.119.243.329.241.463-.002.066-.147.172-.113.338.025.129.131.165.169.318.042.174 0 .437-.024.612-.051.386-.177.548-.481.741.378.524.541 1.308.813 1.914-.198-.144-.351-.593-.476-.823-.011.118-.015.252-.056.372a1.507 1.507 0 0 0-.088-.029c-.06.193.002.452-.287.423.141.196.256.422-.027.548-.058.025-.169-.057-.223-.028-.023.014-.181.166-.147.151-.096.041-.031.096-.206.08-.189-.016-.636-.421-.854-.181-.117.133.02.553.117.663-.373-.621.537-.515.511.115.107-.17.368-.28.462-.031.297-.149.22.272.187.444-.061.284-.15.565-.052.854.078-.352-.021-1.389.637-.935.265.183.474.833-.029.776.025.371.241.103.315.16.146.111.107.402.205.571.048-.037.247-.382.263-.386.2-.059.274.203.279.37.15-.014.665.088.373.265.134-.136.398-.165.297-.372-.052-.1-.303-.108-.384-.226-.28-.412.614-.402.718-.09.502-.452-.336-.359-.605-.42-.435-.101-.726-.294-.646-.774-.333-.037-.082-.334.1-.388-.207-.193-.049-.427.034-.64-.096-.026-.226-.051-.324-.071-.007.1-.032.195-.019.297a.493.493 0 0 1-.38-.161c.075.112.072.234.092.366-.07-.006-.111.039-.195.008a.548.548 0 0 1 .05.349c-.102.067-.356.023-.412-.112-.087-.205.113-.215.28-.296-.027-.075.006-.146-.039-.224.286.024.252-.149.409-.309.138-.135.483-.322.57-.047.153-.172.098-.619.425-.504.267.092.221.507-.088.456.151.136.428.153.479.385-.229.085-.364.046-.582.092.113.164.973.525.791.798-.111.168-.735-.357-.731.111.429-.07.486.424.814.438.356-.42.077-1.525-.198-1.928-.102-.148-.433-.593-.609-.637-.16-.041-.484.253-.595.374.021-.421-.304-1.004-.386-1.424-.102-.519.084-1.045.044-1.561-.052-.674-.124-.646.313-1.215-.596-.523-.809-1.125-1.693-.808-.734.264-1.327.3-1.766 1.009-.188.304-.294.295-.618.433-.227.096-.457.351-.251.583a.576.576 0 0 1 .793-.482z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1951")
        ]), l([
            A2(Da, l([
                Fa("path1953"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M384.422 421.772c.354.386 1.113.304 1.617.384 2.803.44 5.028 1.644 6.377 4.199.232.442.269.795.702 1.089.526.362 1.164.566 1.793.407.837-.21.921-1.22 1.459-1.768.271-.274.759-.418.943-.772.563-1.096-1.225-2.014-2.012-2.362-.536-.236-.828-.479-1.275-.816-.937-.707-1.924-1.334-2.839-2.093-.617-.512-1.271-.959-1.764-1.595-.179-.235-.445-.538-.559-.808-.099-.229-.088-.453-.244-.68-.305-.446-.927-.358-1.371-.624-.251-.149-.185-.423-.543-.267-.19.084-.237.396-.328.566-.225.428-.372.95-.752 1.248-.303.239-.793.336-1.09.601-.358.322-.932.987-.932 1.499.004.501.483 1.429.818 1.792z")
            ]), M),
            A2(Da, l([
                Fa("path1955"),
                Ha("#dcc06d"),
                qa("M395.838 426.219c-.219-.089-.485.141-.709.201-.2-.396-1.032.146-1.322.206a1.183 1.183 0 0 0-.065-.07c.058.16.305.292.449.373-.265.012-1.374-.337-1.03-.75.146.022.275.044.393-.037-.074-.25.236-.263.384-.399.079-.07.052-.172.131-.235.063-.049.249-.063.271-.087.181-.189.032-.436.247-.651.125-.124.313-.215.486-.196.228.024.312.198.476.323.237.184.512.275.798.348.4.103.782.088.84-.373.104-.801-.883-1.197-1.465-1.498-.636-.326-1.243-.652-1.821-1.055-.251-.174-.45-.426-.7-.587-.172.152-1.034-.576-1.249-.724a13.74 13.74 0 0 1-1.943-1.623c-.354-.354-.69-.655-.983-1.077-.067-.098-.768-1.26-.735-1.318-.06.111-.182.129-.307.081.117.125.155.339-.018.378-.153.035-.158-.31-.301-.082-.229-.014-.726-.178-.85-.339.304.077.487-.382.75-.017.098-.155.228-.111.334.001.398-.263-.151-.414-.337-.454-.209-.045-.689-.049-.771-.228-.243.146-.236.625-.317.876-.158.478-.588.982-1.004 1.259.445-.059.622-.643.881-.933.253.407.64-.007.894.314.056-.079.32-.28.433-.238.162.06.188.437.085.555-.106.125-.38.09-.523.135.114.271.478.533.786.477-.002-.181-.193-.61.02-.722.202-.107.43.355.543.508-.155-.011-.316-.124-.454-.043.36.324.648.681.985 1.017.292.292.756.485.979.87-.065-.371-.443-.696-.473-1.08.622.562 1.115 1.241 1.783 1.753.391.299 1.186.593 1.395 1.048-.143.065-.346-.005-.507-.003.501.615 1.317 1.043 1.962 1.494-.08-.275-.151-.613-.255-.847.165.224.219.55.332.804.098.223.415.434.478.616.11.339-.862.633-.591 1.067-.34.373-.679-.045-.798-.332-.326.093-.151.262-.441.121-.192-.093-.399-.393-.016-.433-.002-.008-.002-.071-.002-.075-.13.021-.275.045-.384-.022a.11.11 0 0 1 .047-.041c-.267.217-.697.185-1.021.206.25.157.315.513.567.684.124.083.331.084.389.234.048.127-.149.278-.131.396.016.111.141.123.179.195.034.069.026.21.05.28.236-.174.388.099.438.282.074.274-.018.345.283.503.441.237 1.054.257 1.537.158.443-.089.768-.21 1.014-.605.201-.328.367-.692.554-1-.326.057-.62.229-.848.46")
            ]), M),
            A2(Da, l([
                Fa("path1957"),
                Ha("#dcc06d"),
                qa("M387.855 419.554c-.282-.012-.359-.396-.568-.541.192.193.497.224.619.489-.005.03-.019.047-.051.052")
            ]), M),
            A2(Da, l([
                Fa("path1959"),
                Ha("#dcc06d"),
                qa("M386.437 419.83c.008.436-.61.548-.745.848-.088.192-.297.798-.116.982.14.145.246.015.392.018.368.007.699.101 1.047.212.753.24 1.441.503 2.114.931-.014-.028-.037-.056-.052-.084.085-.084.211-.081.326-.059a11.493 11.493 0 0 1-1.493-.938c-.382-.281-.563-.524-.508-.972-.081-.039-.098-.083-.157-.126.272.074.571.217.865.24-.435-.29-1.328-.579-1.402-1.184-.095.094-.169.082-.261.078")
            ]), M),
            A2(Da, l([
                Fa("path1961"),
                Ha("#dcc06d"),
                qa("M384.607 420.532c.01.079-.016.133-.077.163a1.058 1.058 0 0 0-.243-.269c-.014.09-.025.226-.052.321-.191 0-.265-.28-.042-.324-.097-.193-.457-.4-.263-.647.117.095.226.06.292-.06.085.088.115.21.099.333-.06-.026-.158-.007-.211-.029-.034.172.138.397.307.448.072.022.099-.208.196-.119.085.073.056.231.004.317a.344.344 0 0 1 .111-.03")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1963")
        ]), l([
            A2(Da, l([
                Fa("path1965"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M394.657 428.633c.121.809.535 1.008 1.188 1.256.346.132.405.031.75.008.439-.031.834.215 1.201.428.55.319 1.403.813 1.356 1.578-.113.025-.236.145-.352.171.111.504.643 1.202 1.106 1.421.246.116.474.168.7.271.3.136.366.171.706.205.68.07 1.239.309 1.774-.122-.026.018.081-.217.098-.238 0 .003.277-.122.308-.141.168-.117.37-.341.559-.489.034-.36-.087-1.175-.48-1.317-.049-.34-.255-1.611-.844-1.223.143-.371-.241-.73-.533-.903-.572-.339-.646-.133-1.178.118-.186-.646-.8-1.121-1.028-1.758-.221-.611.088-.636.316-1.039.161-.285.199-.09-.054-.421-.165-.218-.474-.294-.65-.483-.267-.287-.269-.815-.657-.984-.375-.164-.688.157-1.048.256-.464.128-.889.037-1.345.256-.606.291-.817.858-1.099 1.421-.261.526-.886 1.103-.794 1.729z")
            ]), M),
            A2(Da, l([
                Fa("path1967"),
                Ha("#dcc06d"),
                qa("M394.908 428.57a.856.856 0 0 0 .149.173c-.082-.192-.038-.459.179-.327.133.082.254.454.209.592.081.022.211.041.294.047-.006-.136.06-.288.201-.222-.006-.051.004-.104 0-.151.196.059.397.28.254.488a.867.867 0 0 1 .424.314c-.012-.154.09-.256.241-.113a.544.544 0 0 0-.032-.088c.135.089.209.294.314.363.119.08.4.104.535.105a.703.703 0 0 1 .157-.234c-.243-.001-.855-.174-.672-.506-.162-.003-.567-.021-.593-.256-.036-.317.346-.163.479-.048a.4.4 0 0 1 .236-.1c-.162-.284-.553-.52-.789-.754-.198.263-.332-.3-.489-.384-.121.15-.294.124-.334-.07-.243.209.111.367-.048.552-.019-.011-.036-.021-.058-.03a.741.741 0 0 0 .219.227c.021-.021.034-.045.056-.066.14.052.153.207.283.292.021-.109-.036-.231-.054-.345.156.04.081.144.18.222.06.046.243.102.269.126.144.153.09.28-.196.235-.213-.034-.362-.268-.539-.375-.058-.035-.111.001-.205-.08a.74.74 0 0 1-.177-.298c-.472-.008-.591.535-.416.89")
            ]), M),
            A2(Da, l([
                Fa("path1969"),
                Ha("#dcc06d"),
                qa("M399.139 428.58c-.115-.055-.18-.149-.156-.259.05.016.122.008.174.024.038-.17-.133-.331-.124-.509.333.264.209.34.573.171.038.029.077.037.107.058-.056-.19-.124-.383-.19-.575.049.008.188-.032.232-.023-.054-.224.002-.626-.328-.712-.098-.025-.249.076-.356.091-.119.016-.238-.052-.374-.021.12-.237-.622-.459-.752-.656.107-.036.227-.048.344-.06-.187-.26-.432.042-.583-.375-.344.12-.701.272-1.025.437a.656.656 0 0 0 .045.212.142.142 0 0 1 .062-.049c.106.097.151.262.213.399-.085-.076-.17-.164-.254-.212.079.174.129.367.144.555-.092-.134-.178-.278-.269-.418-.028.026-.056.037-.082.069-.012-.052-.069-.112-.085-.164-.337.066-.384.333-.605.548a3.677 3.677 0 0 1-.67.491c-.138-.33.427-.676.606-.938.2-.291.29-.688.582-.914.273-.211.65-.151.979-.177.39-.028.631-.183.953-.345.883-.439.804.35 1.23.903.172.224.562.29.552.577-.006.305-.263.522-.238.852.031.424.279.79.488 1.145.209.357.42.716.729.994.039-.047.122-.063.157-.099.146.181-.039.231-.028.395.011.17.157.4.279.508.177.153.894.254.512.579-.034-.021-.076-.037-.11-.061.056.181.267.328.296.492.047.252-.192.344-.308.093-.102.168.178.242.104.389-.084.158-.28.007-.389-.01-.047.156.004.296-.089.408-.088-.06-.151-.097-.178-.209.011.051-.561.15-.593.167.064.239.126.438.309.619.016-.027.05-.079.063-.104.148.109.274.467.33.645-.193-.104-.354-.224-.541-.348-.054-.035-.353-.258-.387-.261-.169-.013-.188.152-.369.153-.22 0-.579-.297-.692-.45.296.068.539.27.869.295-.008-.14.039-.264.163-.325a1.273 1.273 0 0 0-.277-.494c-.104.134-.263.2-.329.364-.166-.084-.808-.213-.78.039-.132-.215-.1-.381.141-.469.347-.128.387.271.689.255.288-.015 1.211-.514 1.378-.762.276-.411-.232-1.219-.691-1.231.145-.328-.285-.189-.431-.218-.472-.096-.129-.241-.113-.464.203-.077.465.175.405.358.228.127.429.341.644.452-.084-.376-.44-.808-.748-.987-.064-.038-.271-.076-.299-.115-.07-.092.064-.149.015-.229-.106-.169-.247-.271-.452-.272.075-.297.288.011.396-.078.121-.101.002-.349-.107-.427-.338-.243-.495.235-.773.326a.476.476 0 0 1-.133-.192")
            ]), M),
            A2(Da, l([
                Fa("path1971"),
                Ha("#dcc06d"),
                qa("M399.25 429.336c-.193.394-.437-.288-.368-.461.202.01.337.388.328.563")
            ]), M),
            A2(Da, l([
                Fa("path1973"),
                Ha("#dcc06d"),
                qa("M402.172 430.242c.081.141.008.429.24.332.046.033.054.07.086.118.447-.475.938.09.81.626-.13.017-.269.044-.402.041a.363.363 0 0 1-.004-.196c.251-.009.579-.304.224-.479-.068.112-.09.224-.209.293-.015-.345-.36-.141-.514.009-.201-.121-.178-.274-.301-.415-.103-.117-.273-.147-.371-.266-.182-.218.015-.556-.116-.79.344-.096 1.059.197.979.651-.186-.209-.438-.354-.717-.34-.063.223.204.252.295.416z")
            ]), M),
            A2(Da, l([
                Fa("path1975"),
                Ha("#dcc06d"),
                qa("M403.423 431.99c-.386.205-.01.411-.006.647.004.386-.22.21-.41.243-.014-.34-.159-.613-.545-.401.042-.084.015-.194.044-.266.05-.108.084-.095.135-.174.058-.088.14-.068.166-.207.014-.049-.11-.188-.138-.224.247.133.495.202.692-.052.099.265.382.336.484.625.076.22.137.636-.029.819-.286-.062-.064-.428-.115-.663-.034-.159-.374-.601-.367-.266")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2069")
        ]), l([
            A2(Da, l([
                Fa("path2071"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M369.514 446.158c-.149.303.009.784-.077 1.136-.13.537-.136.8.259 1.259.245.282.58.454.857.698 1.227 1.083 1.408 3.073 1.809 4.607.269 1.035.566 2.04.921 3.043.229.647.277 1.383.448 2.056.305 1.198-.433 2.331.346 3.49.243.359.439.5.825.592.455.106.507-.059.902-.292.41-.244 1.025-.475 1.51-.413.299.037.468.218.804.122 1.306-.369.963-2.116.651-3.081-.241-.746-.659-1.383-.976-2.098-.221-.503-.187-1.042-.315-1.573-.198-.825-.665-1.586-.825-2.42-.31-1.591-.602-3.326-.514-4.931.067-1.287.843-2.685-.472-3.585-.41-.283-.583-.69-1.049-.518-.412.151-.754.651-1.18.857-.537.26-1.066.271-1.641.415-.606.153-1.966-.013-2.283.636z")
            ]), M),
            A2(Da, l([
                Fa("path2073"),
                Ha("#dcc06d"),
                qa("M371.184 445.902c.292-.047.578.181.779.364-.233.078-.211.211-.06.356.348.338.388-.083.575-.098.461-.032.111.323.013.463-.229.313-.26.504-.688.599.479-.019.555-.618.071-.632-.027.154-.123.271-.282.272.021.04.03.117.05.148-.02-.031-.639-.392-.742-.385-.19.008-.169.007-.16.178.011.291.506.675.668.903-.31-.113-.556-.325-.767-.575-.093-.114-.315-.36-.004-.314.034-.333-.411-.203-.449.061-.046.333.413.639.669.746a2.055 2.055 0 0 0-.034.343c-.324-.017-.226.233-.217.456-.291-.31-.498-.716-.788-1.021.299-.09.303-.385.368-.631.046-.193.227-.461.109-.65.244-.209.414-.313.338-.668.141.038.193-.083.326-.124.218-.066.47-.032.69-.049.572-.038 1.206-.286 1.717-.522.356-.167.679-.402 1.014-.578.4-.21.512-.319.86-.021.292.249.631.501.84.831.24.38.146.699.067 1.128-.105.564-.197 1.063-.224 1.636-.027.598.026 1.224.036 1.837.016.797.007 1.61.124 2.399-.345-.837-.412-1.882-.514-2.781a6.566 6.566 0 0 1-.004-1.496c.044-.37.132-.735.104-1.112-.021-.299-.195-1.14-.467-1.303.16-.077.072-.193-.013-.311-.169-.229-.508-.24-.756-.134-.244.104-.323.412-.527.534-.14.083-.086.012-.237.029-.128.014-.252.022-.35.041-.023.006-.06.118-.137.132-.126.026-.331-.142-.448-.176a3.701 3.701 0 0 0-.919-.125c-.181.002-.676.131-.344.368")
            ]), M),
            A2(Da, l([
                Fa("path2075"),
                Ha("#dcc06d"),
                qa("M373.577 455.386c.444.04.587.892.815 1.181-.02-.003-.025-.026-.042.003-.255-.153-.574-.956-.893-.884.03.505.109.892.297 1.368.238.604.627 1.302.715 1.94.297-.034.197.355.143.529.337.115.825.191 1.135-.018.128-.087.247-.206.108-.372.25-.152.757.277.992.411.24-.452-.54-1.105-.817-1.451-.217-.276-.207-.563-.231-.915-.035-.461-.107-.912-.175-1.372.102.192.24.025.332-.093.335.601.604 1.237.991 1.805.302.439.598.883.801 1.371.181-.007.375-.01.514.125-.012-.634-.483-1.127-.606-1.706.18.392.466.721.626 1.126.134.334.134.691.247 1.029.141.414.227.728.261 1.172.027.371.109.984-.188 1.289-.207.209-.717.42-.908.199.309-.131.778-.192.915-.518.106-.253-.047-.535-.244-.708.648-.119-.635-.88-.795-.968.292.099.644.184.892.351.066-.146-.06-.552-.085-.73-.037-.258-.151-.483-.423-.556-.476-.127-.813.627-.631 1.008-.425-.061-.9-.336-1.34-.233-.179.042-.415.16-.355.403.078.308.324.138.526.094.425-.093 1.227-.17 1.48.275-.32-.437-1.345-.289-1.613.148-.286.47.028 1.484.648 1.485-.252.402-1.004.332-1.405.28.484-.545-.64-1.02-1.064-.958.095-.429.664-.693 1.044-.726.129-.011.503.073.4-.238-.144-.424-1.23.428-1.502.312-.319-.137-.057-.304.027-.48.188-.392.067-.835.046-1.241.036.034.125.055.157.081.167-.173-.019-.173-.083-.291-.013-.025-.096-.051-.124-.109-.03-.061-.015-.166-.03-.233-.083-.398-.257-.787-.422-1.159-.177-.397-.355-.838-.435-1.27-.051-.285-.024-.534-.139-.781-.058-.128-.164-.182-.198-.317-.058-.229.032-.507.034-.741 0-.441-.122-.81-.284-1.216-.265-.662-.768-1.483-.396-2.215-.117.229.119.941.2 1.172.12.345.286.673.444 1.001.357.736.726 1.499.638 2.341z")
            ]), M),
            A2(Da, l([
                Fa("path2077"),
                Ha("#dcc06d"),
                qa("M372.125 449.269c-.193-.142-1.279-.714-.993-1.013.445.174.725.776 1.079 1.081")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2101")
        ]), l([
            A2(Da, l([
                Fa("path2103"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M374.39 463.278c-.135.589.555 1.275.849 1.681.796 1.096 1.236 2.619 1.32 3.958.029.485-.009 1.002.133 1.479.05.173.145.25.143.44-.007.195-.143.367-.115.596.072.667.533.712 1.094.587.567-.128 1.133-.256 1.704-.389.431-.102.638.013.686-.43.031-.295.002-.75-.033-1.039-.051-.41-.315-.758-.563-1.076-.7-.896-.564-2.104-.604-3.169-.018-.43-.03-.81.006-1.234.041-.482.521-1.779.335-2.131-.17-.325-.908-.604-1.222-.753-.382-.181-.729-.317-1.148-.213-.816.207-2.366.722-2.585 1.693z")
            ]), M),
            A2(Da, l([
                Fa("path2105"),
                Ha("#dcc06d"),
                qa("M374.9 463.011c.123-.171.355-.387.564-.433.187-.041.491.101.263.286.124.092.312.074.459.026-.109-.319-.407-.629.157-.729.802-.141.115.76.653.734.336-.017-.189-.732.083-.886.277-.153.414.312.447.484.014.063-.115.046-.04.15.03.043.222.083.277.109-.036-.583.944-.319 1.171-.054.351.412.021 1-.018 1.506-.006.079.024.246-.012.314-.05.094-.137.081-.201.157-.137.165-.092.256-.049.512.062.373.096.728.117 1.103.023.359.139.806.051 1.151-.254-.488-.317-1.098-.396-1.631-.118.697.381 1.385-.024 2.034-.133-.517-.117-1.126-.275-1.622-.068-.207-.474-1.101.077-1.09 0-.131.047-.25.119-.351-.189-.128-.202-.383-.305-.578-.007.128-.106.171-.214.105.171.152.101.562-.092.639-.017-.364-.102-.826-.498-.984.096.336-.378.439-.529.212.271-.221-.256-.681-.503-.813.076.216.663.491.565.702-.201.433-.832-.438-.992-.391-.009.138.025.281-.072.398a.956.956 0 0 0-.314-.102c-.044.162-.002.54.102.688.019.031.146.079.197.132a.659.659 0 0 1 .165.231c-.012-.096.036-.158.067-.236.299.149.203 1.008.354 1.304a.084.084 0 0 1 0-.052c.29.211.229.989.243 1.308.021.409.188.733.258 1.116.06.326.124.686.137 1.016.007.212-.054.206-.097.39-.087.383.142.504.278.856.253-.034.469-.219.718-.291.23-.064.442-.065.675-.102-.277-.374-.533-.378-.924-.527-.194-.075-.421-.336-.542-.512-.232-.341-.119-.862-.051-1.229.038-.213-.035-.431-.009-.658-.191-.083-.11-.387.047-.195.047-.226.153-.583.094-.775-.109-.369-.537-.546-.735-.875.256.117.497.551.787.594.008-.55-.687-.966-.774-1.474.193-.055.36.311.479.443.199-.432.41.393.448.508.09.275.263.454.395.718.175.347.313.768.315 1.164.002.338-.145.352-.274.557-.075.111.01.21-.111.299-.058.043-.149-.001-.232.03-.301.116-.205.501-.028.809.178.313.338.387.604.16.193-.166.452-.498.526-.055.23.095.441.644.58.875-.147-.205-.401-.963-.232-1.171.127.156.205.442.413.509-.012-.079.036-.127.044-.179.219.061.28.349.332.52.047.166-.006.128.139.279.074.079.143.152.239.217-.146-.442-.192-.814-.495-1.181-.265-.32-.407-.512-.499-.924-.157-.723-.165-1.525-.146-2.256.021-.716.036-1.428.153-2.141.073-.44.322-1.173-.002-1.578-.195-.244-.548-.255-.825-.297-.253-.039-.46-.199-.71-.241-.271-.042-.573.088-.852.135-.354.061-.673.136-.983.325-.449.271-.849.475-1.09.963-.251.512.18 1.03.537 1.384-.135-.525-.568-1.003-.184-1.539z")
            ]), M),
            A2(Da, l([
                Fa("path2107"),
                Ha("#dcc06d"),
                qa("M377.165 471.489c-.401-.309.416-.671.661-.674.149-.003.275.058.42.089.304.066 1.149.027 1.295.378-.396.107-.832-.001-1.218.136-.192.068-.371.279-.537.331-.101.029-.109-.105-.234-.028.317-.37-.422-.212-.459-.293-.013-.03-.015-.058-.021-.092")
            ]), M)
        ])),
        A2(On, l([
            Fa("g2109")
        ]), l([
            A2(Da, l([
                Fa("path2111"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M377.875 476.305c.138-.077.609.287.75.354-.324-.896-.548-2.061-1.283-2.752-.243-.229-.464-.288-.579-.611-.107-.314-.076-.688.368-.71-.397-.286.3-.522.501-.605.36-.152.595-.449.949-.623.526-.255.899.136 1.335.373.433.235.746.094 1.193.201.012.044-.01.069-.008.1.258.117.416.621.388.905-.049.525-.471.359-.699.698-.239.362-.104 1.192-.112 1.594-.008.296-.046.951.202 1.131.193-.602.44-.194.58.186.148.413.139.671.023 1.08-.086.304-.004.736-.169.996-.098.155-.261.157-.352.255-.101.108-.141.273-.27.405-.213.216-.687.257-.975.219-.518-.064-.65-.351-.961-.669-.308-.317-.817-.519-.813-1.041.005-.213.113-.313.086-.548-.02-.166-.416-.792-.154-.938z")
            ]), M),
            A2(Da, l([
                Fa("path2113"),
                Ha("#dcc06d"),
                qa("M379.669 472.37c-.286.164-.48.212-.848.193-.155-.007-1.032-.208-1.092-.094-.014.021-.032.206.038.181l-.058.021c.107.323-.307.375-.215.069-.237.047-.438-.018-.372.325.223-.091.545-.148.531.179a.927.927 0 0 0 .194-.067c-.113-.363.354-.688.22-.036.021.021.071.08.09.096.051-.128.025-.335.22-.347.076.287.021.618-.065.891.123.07.153.209.161.341.068-.137-.085-1.756.491-1.185.189.188.042.363.048.563.008.215.171.43.026.603-.03-.037-.086-.066-.117-.111-.007.168-.068.248-.013.386.07.172.326.209.241.454-.009-.038-.003-.083-.011-.117.379-.007-.056-.843.04-1.127.032.036.128.102.151.149-.038-.138.002-.395.034-.53.06-.261.081-.231.34-.103.193-.632.881 1.05.376.618-.105-.088-.102-.299-.255-.313-.137-.013-.196.173-.211.277-.03.234.136.447.11.68-.047.438-.578.569-.625 1.058-.017.157-.013.502.023.638.05.176.335.409-.012.537-.003.002-.046-.042-.052-.046-.007.053-.03.083-.042.126a3.06 3.06 0 0 1-.19-.671c-.214.023-.525-.712-.602-.903.188.421.504.936.51 1.415.006.498-.372.06-.643-.006.06.215.318.463.423.686.078.166.11.271.312.39.204.121.296.187.478.348.181.159.476.272.728.275-.05-.234.036-.369.096-.557.045-.141-.04-.372.241-.311.135.029.222.194.188.313.043-.247.207-.596-.166-.673-.144-.03-.389.217-.362-.208.012-.235.161-.133.244-.289.072-.138-.021-.125-.053-.269-.04-.168-.184-.648.113-.66.02.041.047.078.062.117-.084-.353.041-.751.121-1.097.054-.224.124-1.232.41-1.269-.084-.018-.587-.296-.305-.452-.107-.078-.432-.207-.384-.338.071-.2.501-.036.428.217.267.032.246.659.603.485.278-.135.109-.718-.008-.888-.364-.531-1.149-.22-1.59.036z")
            ]), M),
            A2(Da, l([
                Fa("path2115"),
                Ha("#dcc06d"),
                qa("M378.858 472.053c-.021-.168-.117-.373.126-.377.181-.002.258.226.177.362.119-.001.23.052.35.081.064-.113.171-.198.271-.276-.285-.266-.576-.468-.936-.358-.225.065-.558.253-.628.488.045-.145.301-.211.413-.172-.048.158-.084.347-.004.496.014.024.107-.134.073-.206.047-.015.104-.039.158-.038z")
            ]), M),
            A2(Da, l([
                Fa("path2117"),
                Ha("#dcc06d"),
                qa("M379.462 478.662c.193.063.479-.042.395-.271.044.011.115-.017.165 0 .056-.246.175.019.302.058.224.068.464-.003.582-.19a1.67 1.67 0 0 0 .16-.455c.021-.232-.115-.313-.267-.527.136-.011.305.007.378.149a.47.47 0 0 0 .144-.197c-.148-.116-.044-.288-.067-.459-.017-.142-.132-.267-.068-.449.235.158.482 1.32.068 1.388.054.383-.038.603-.186.95-.092-.041-.452-.078-.535-.047-.29.105-.147.215-.025.347a.302.302 0 0 1-.275-.016.613.613 0 0 0-.043.146c.472.138-.06.412-.265-.025.115-.022.237-.178.069-.234-.097-.031-.25.156-.33.194-.046-.03-.06-.04-.085-.085.133-.047.282-.093.316-.235-.149-.085-.279.019-.414.105-.081-.017 0-.02-.002-.039")
            ]), M),
            A2(On, l([
                Fa("g2155")
            ]), l([
                A2(Da, l([
                    Fa("path2157"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M115.638 449.534c-.146.02-.228.076-.358.032.144.723.912 1.177 1.486 1.5.601.337 1.325.033 1.798-.425.442-.426.842-.879.687-1.496-.065-.266-.177-.764-.315-.974-.181-.275-.585-.314-.825-.552-.03.032-.076.058-.1.08.151-.688-1.04-.494-1.469-.574.14.128.292.238.443.354-.374-.544-1.041-.799-1.393-1.36-.114-.183-.276-.424-.303-.65-.026-.229.143-.379-.021-.626.123.155.19.347.267.529a.452.452 0 0 0 .197-.61c-.107-.195-.24-.087-.346-.213-.074-.091-.091-.238-.148-.363-.25-.541-.834-.887-1.447-.736-.614.15-1.115 1.187-1.402 1.695a7.137 7.137 0 0 0-.468.948c-.082.216-.117.902-.416.779-.086.409.133 1.06.573 1.181.318.088.3-.073.604-.134.222-.042.408.048.599.109.428.139.944.239 1.322.47.417.255.662.703 1.015.984.089-.03.006-.049.014-.109")
                ]), M),
                A2(Da, l([
                    Fa("path2159"),
                    Ha("#dcc06d"),
                    qa("M117.403 447.919c.102.238.362.264.553.428.161.136.337.354.396.556.167.568-.189 1.148-.82 1.09.083.021.167.074.239.115-.236.156-.673.188-.843-.109.036-.038.046-.114.073-.146-.246-.083-.499-.776-.614-1.001-.134-.26-.107-.188-.333-.28a1.304 1.304 0 0 1-.555-.433c-.166-.218-.303-.492-.539-.634-.174-.104-.418-.17-.608-.24-.476-.175-1.046-.255-1.553-.29.044-.1.152-.087.215-.191.051-.087.025-.184.046-.287.017.021.04.048.059.068.225-.05.05-.344.235-.414.125-.048.901.519 1.009.633-.251-.317-.906-.585-1.004-.988a.364.364 0 0 0-.121.034l-.031-.049c-.084.057-.068.372-.163.527-.178.291-.408.385-.259.747-.088.033-.148.082-.222.13-.056-.098-.217-.166-.234-.313-.021-.181.171-.342.29-.444-.084-.202.332-.819.472-.971.093-.104.197-.149.269-.248.068-.093.157-.316.184-.435-.154-.033-.21-.179-.062-.276.114-.074.293.039.41.107.146-.167.363-.336.498-.505a1.193 1.193 0 0 0-.484.244c-.056-.167.092-.275.111-.433-.243.02-.371.334-.574.332.011-.043.043-.043.058-.067-.243-.128.199-.452.267-.568-.743.345-1.161 1.35-1.516 2.03-.173.331-.256.718-.439 1.057-.191.354-.241.832.166 1.099-.229-.23.09-.506.328-.489.193.016.489.237.399.441.36-.017.729.256 1.053.391.271.112.571.113.847.223.294.118.558.262.796.47.264.231.415.559.7.756-.089-.001-.185-.005-.271-.007-.041.173-.121.319-.067.494.065.22.196.163.321.265.057.049.064.136.13.181.068.046.157.063.223.106.1.065.184.208.343.155.06.18.018.245.219.276.124.02.307-.067.325-.188-.501-.019-.2-.109-.417-.429-.304.252-1.053-.117-.969-.545.078-.392.435-.065.631.055.284.172.582.327.921.3.419-.03.825-.36 1.258-.309-.068-.047-.248-.096-.275-.171-.029-.077.093-.236.093-.324.001-.174-.109-.19.004-.368.063-.097.164-.138.244-.208-.074-.058-.171-.1-.26-.149.06-.101.04-.193-.044-.267-.434.125-.469-.595-.754-.585-.066.188-.29.08-.384-.03.054.123.169.195.257.29")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2161")
            ]), l([
                A2(Da, l([
                    Fa("path2163"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M110.005 437.501c.342.589.81 1.096 1.074 1.729a7.226 7.226 0 0 0 1.121 1.872c.272.334.691.611.901.967.11.184.108.412.247.582.152.189.389.313.562.491.428.442.328.742.013 1.224-.117.179-.255.452-.428.583-.159.119-.398.078-.543.2-.123.106-.042.202-.119.329-.152.251-.323.546-.572.716-.375.253-.951.326-1.374.231-1.417-.324-.856-1.827-1.023-2.82-.214-1.276-1.299-2.293-2.207-3.128-.895-.819-1.686-1.42-2.801-1.749-.654-.192-1.492-1.438-.918-2.096.247-.283.723-.302 1.051-.442.372-.159.684-.397.946-.704a2.14 2.14 0 0 1 .561-.495c.313-.204.928-.826 1.292-.874.515-.067 1.286 1.05 1.437 1.464.244.662.417 1.299.78 1.92z")
                ]), M),
                A2(Da, l([
                    Fa("path2165"),
                    Ha("#dcc06d"),
                    qa("M113.741 444.214c-.335.563-.801.033-.375-.406-.279.249-.554.81-.456 1.168.322-.067.843-.471.887-.818")
                ]), M),
                A2(Da, l([
                    Fa("path2167"),
                    Ha("#dcc06d"),
                    qa("M104.352 438.393c-.353-.388-.559-1.396-.098-1.748.229-.174.555-.195.822-.339.132-.071.299-.137.424-.215.172-.105.285-.29.468-.377-.096.142-.638.412-.438.619-.103.103-.217.187-.158.326.075.179.303.146.44.083.047.398-.517.215-.668.529-.086.181-.028.483-.053.678-.029.214-.152.47-.101.677.369-.132.762-.028 1.115.084.366.117.553.126.493-.347.288-.123 1.269 1.424 1.478 1.712.523.719 1.012 1.465 1.583 2.146.163.194.314.334.412.576.07.177.116.486.372.563.104.03.247-.069.285-.055.144.061.176.275.246.406.085.154.184.413.388.274.004-.025.009-.058.013-.068.11.185.186.428.409.501a.55.55 0 0 1-.344.22c.024-.156-.105-.231-.201-.337-.217.137-.174.265-.075.428.073.123.153-.023.142.192-.005.124-.138.282-.214.363-.077-.19-.099-.428-.303-.53-.138.087-.162.36-.125.516.072.297.295.349.524.468-.206.068-.61.135-.187.335.438.206.901-.238.985-.626.1-.456-.009-.929-.023-1.386.068-.028.203-.044.257-.091.042-.038.089-.177.129-.197.15-.079.4-.061.598-.115-.158.275-.342.402-.418.725-.064.273-.061.556-.116.832-.058.284-.02.693-.302.89-.432.302-1.344.313-1.77-.114-.411-.411-.287-1.294-.297-1.82-.028-1.543-1.076-2.414-2.043-3.466-.394-.428-.775-.846-1.251-1.182-.389-.272-.724-.568-1.189-.701-.407-.117-.899-.092-1.209-.429z")
                ]), M),
                A2(Da, l([
                    Fa("path2169"),
                    Ha("#dcc06d"),
                    qa("M108.462 435.061c.375-.251-.114-.528-.343-.597 0 .176.154.762.377.586")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path2171"),
                Ha("#dcc06d"),
                qa("M59.308 468.386c.094-.145.117-.304.043-.449-.185.031-.23.29-.084.407")
            ]), M),
            A2(On, l([
                Fa("g2173")
            ]), l([
                A2(Da, l([
                    Fa("path2175"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M99.622 457.322c-.584 1.355-1.014 2.833-1.167 4.299-.056.52-.082 1.143-.049 1.666.042.661-.064 1.354.019 2.016.069.553.291 1.101.299 1.661.006.45-.228.826-.3 1.251-.074.437.157.624.208 1.044.049.393-.282.831-.24 1.229.042.391.281.53.176.973-.112.473-.347.947-.464 1.431-.151.63-.357 1.29-1.138 1.247-1.081-.056-2.39-.861-3.411-.166-.02-.136-.051-.249.022-.401-.5-.209-.466-.248-.598-.815-.08-.338-.396-.844-.338-1.163.067-.374.436-.655.53-1.038.114-.46-.05-.944.062-1.408.058-.233.296-.458.276-.719-.021-.273-.211-.335-.197-.647.017-.393.26-.874.336-1.273.444-2.331.607-4.992-.485-7.184-.31-.618-1.101-1.29-1.156-2.003-.039-.493.642-1.929 1.107-2.132.223-.098.498.069.757.091.364.03.735-.099 1.079-.187a6.193 6.193 0 0 1 2.463-.161c.426.054.817.245 1.244.302.36.046.521-.014.715.334.138.245.202.768.274 1.045.078.304.12.378-.024.708z")
                ]), M),
                A2(Da, l([
                    Fa("path2177"),
                    Ha("#dcc06d"),
                    qa("M95.423 472.124c-.201.143-.49.135-.72.225-.149.059-.269.142-.425.163.144-.162-.001-.256.035-.444.051-.266.302-.431.443-.643a1.918 1.918 0 0 0-.674.554c-.038-.15.006-.335-.114-.459.16-.313.629-.166.755-.523-.554.138-.627-.195-.437-.593.166-.349.592-.776.6-1.171.004-.182-.09-.215-.124-.385-.059-.298.093-.244.167-.436.369-.937.342-2.034.302-3.021-.046-1.153-.141-2.509.127-3.637.185-.774.643-1.668.423-2.434-.159-.546-.677-1.401-.301-1.938-.222.28-.66.443-.96.633-.302.19-.792.701-1.089.325-.317-.402.133-1.331.405-1.651.221-.259.652-.591 1.008-.604-.278-.062-.063-.413.111-.491.408-.183.316.296.201.552a.512.512 0 0 0 .358-.052c-.058-.471.807-.486 1.101-.529.27-.038 1.484-.448 1.44.027-.038.424-.97.633-1.267.656-.118.01-.273.035-.392.028-.069-.006-.248-.107-.313-.082-.356.148.214.752.136 1.01.035-.305.054-.621.112-.921a.44.44 0 0 1 .191.022c.151.195.008.68.284.765.186-.134.059-.25.067-.44.014-.31.13-.245.219-.46a.48.48 0 0 1 .191.325c.23-.18.521-.12.733-.284-.298-.253.076-.392.189-.516.114-.121.02-.18.203-.256.145-.063.321.001.449.048.294.11.621.458.37.791-.211.28-.84.364-1.164.41-.007.365.311.325.377-.002.158.191.28-.052.458-.108.145-.045.332.042.457-.089.264-.275-.085-.897-.284-1.135-.98.204-1.86-.476-2.804-.37-.439.049-.7.319-1.064.453-.395.143-1.087-.033-1.504-.083-.547-.063-.624.17-.891.643-.206.362-.505.839-.536 1.263-.035.475.378.963.622 1.343.282.44.515.892.699 1.388.342.915.506 1.883.491 2.859-.013.899-.038 1.801-.156 2.693-.058.436-.113.907-.258 1.324-.114.332-.333.626-.277.995.045.303.415.493.398.803-.02.343-.501.439-.4.853.022.09.14.378.26.365.184-.017.096-.479.161-.607.104-.206.12-.257.28-.093.181.186.038.271.04.462.003.344.004.739-.397.935-.008-.057-.059-.113-.059-.187-.069.045-.153.093-.216.133-.035.439-.526.653-.611 1.009-.088.369.382.802.47 1.166.1.413.081.638.498.798.398.151.831-.124 1.141-.351-.179.129-.28-.272-.255-.364.066-.226.552-.503.72-.66z")
                ]), M),
                A2(Da, l([
                    Fa("path2179"),
                    Ha("#dcc06d"),
                    qa("M96.971 470.923c.524.23.515-.495.589-.835-.358.217-.485.525-.516.925")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2181")
            ]), l([
                A2(Da, l([
                    Fa("path2183"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M93.186 483.632c.711.119 2.078.509 2.65-.065.425-.427.622-1.224.618-1.81-.002-.357-.202-.687-.184-1.043.032-.561.264-1.185.369-1.748.153-.813.198-2.117.841-2.702.215-.197.484-.408.582-.695a.797.797 0 0 0 .013-.459c-.046-.197-.051-.382-.11-.569-.085-.277-.354-.342-.555-.511-.323-.276-.554-.616-.917-.86a1.254 1.254 0 0 0-.935-.203c-.578.089-.98.505-1.462.779-.506.289-1.136.334-1.144 1.077-.006.394.275.633.393.987.232.703.075 1.555.22 2.29.254 1.286-.159 2.115-.75 3.205a.164.164 0 0 1-.026.096c-.044-.022-.089-.044-.132-.067-.073.284-.104.588-.183.871-.038-.014-.037-.043-.075-.06-.06.207.082.289.108.458.022.156-.023.323.014.475.111.438.316.495.665.554z")
                ]), M),
                A2(Da, l([
                    Fa("path2185"),
                    Ha("#dcc06d"),
                    qa("M95.716 482.425c-.065-.339.575-.401.479-.696-.12-.365-.869.507-.451.736")
                ]), M),
                A2(Da, l([
                    Fa("path2187"),
                    Ha("#dcc06d"),
                    qa("M95.093 483.662a.363.363 0 0 0 .182-.036c-.029-.214-.361-.602-.588-.647-.198-.04-.351.108-.569.037-.132-.043-.316-.294-.417-.289-.227.014-.407.536-.707.574.033-.197.897-1.556.228-1.421.176-.184.117-.477.263-.666.088-.114.042-.187.229-.125.102.032.151.065.153.194.16-.466.137-1.098.424-1.515.085-.124.177-.114.24-.332.113-.386.113-.88.132-1.281.035-.677-.004-1.477.182-2.131.063-.219.235-.356-.029-.579-.144-.126-.355-.067-.221-.343-.018.024-.037.049-.054.076.065-.198.006-.359.007-.558.001-.332.165-.661.35-.924.127.212.278.766.138.969.522-.753 1.141-.967 2.023-.785-.391-.126-.638-.543-1.06-.628a1.269 1.269 0 0 0-.835.121c-.263.14-.527.318-.799.473-.501.282-1.18.326-1.249 1.001.204-.196.345.051.259.261a1.07 1.07 0 0 1-.246-.146c-.043.198.206.456.274.655.085.248.088.477.111.73.026.319.096.629.145.945.063.408.226.832.25 1.232.054.839-.279 1.682-.649 2.417-.06.119-.094.322-.199.408-.131.109-.203-.037-.307.166-.056.108-.013.25-.037.386-.037.215-.158.427-.221.626.328.088.138.413.228.658.116.31.299.325.583.327.646.002 1.381.235 1.93.139")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2189")
            ]), l([
                A2(Da, l([
                    Fa("path2191"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M94.266 486.757c-.021-.518.424-.967.712-1.35.373-.496.637-.596 1.19-.796 1.377-.496-.573-1.906-1.276-2.116-.676-.202-2.159-.225-2.683.375-.313.36.099.653.235.989.168.418.024.97-.023 1.396a3.997 3.997 0 0 1-.33 1.201c-.122-.066-.198-.227-.278-.338-.167.171-.352.535-.459.74-.117.222-.281.545-.32.791.159.139.012.464.054.682.055.282.255.603.486.777.453.342.951.327 1.453.259.006-.085.062-.111.08-.17-.069.227.529-.034.56-.058.211-.157.323-.424.47-.632.145-.203.705-.864.188-1.007.315.032.417-.292.32-.557-.035-.091-.392-.469-.379-.186z")
                ]), M),
                A2(Da, l([
                    Fa("path2193"),
                    Ha("#dcc06d"),
                    qa("M93.636 484.528c.082.356-.109.853-.176 1.241-.08.457.026 1.095-.158 1.526-.071.168-.234.231-.33.387-.068.107-.069.241-.155.333-.189-.144-.396-.379-.624-.116-.224.259.071.433.257.558-.645.155-.522-.35-.674-.709.341-.343-.288-.399-.508-.266-.011.153.151.191.277.229a.363.363 0 0 1-.11.217c-.033-.012-.081-.013-.113-.028a.326.326 0 0 0-.091.259c.095.063.181.032.228-.072.039.115.005.231-.098.293a.326.326 0 0 1 .268.125c-.041.002-.085.026-.127.028-.073.29.364.271.518.407-.072.023-.183.063-.219.146-.125-.117-.312-.159-.408-.286-.096-.13.003-.28-.226-.363.07-.221-.016-.462.118-.649-.273-.121.045-.631.141-.861.055-.133.175-.454.322-.514.204-.081.209.153.385.198.175-.217.218-.545.254-.809.048-.34.121-.719.186-1.079.062-.345.114-.69-.044-1.019-.123-.251-.436-.384-.273-.671.327-.581 1.309-.618 1.875-.602.258.009.583.032.825.148.259.125.549.464.041.353-.183-.04-.393-.298-.578-.275-.243.029-.31.395-.599.225.024-.068.032-.165.07-.234-.157-.072-.271.096-.391.183-.208.15-.225.123-.438.131-.225.007-.695-.031-.763.255.151.184.52.384.758.439.375.091.681-.079 1.036-.149-.047.01-.323.343-.365.399-.157.204-.151.368-.091.622z")
                ]), M),
                A2(Da, l([
                    Fa("path2195"),
                    Ha("#dcc06d"),
                    qa("M93.532 488.637a2.477 2.477 0 0 0-.22.147c.068-.104.052-.214-.066-.255.147-.032.387-.118.479-.226.141-.167.042-.3.065-.521.023-.218.135-.264.223-.413.098-.164.14-.382.23-.552.381.244-.243.673-.287.873-.041.184.105.38.048.535-.05.139-.434.416-.562.479")
                ]), M),
                A2(Da, l([
                    Fa("path2197"),
                    Ha("#dcc06d"),
                    qa("M92.507 489.18a.818.818 0 0 0 .263-.073c-.059-.127-.009-.25.099-.327-.201-.277-.481.199-.353.37")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2199")
            ]), l([
                A2(Da, l([
                    Fa("path2201"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M68.918 467.154c-.199-.407-.755-.59-.923-1.057-.065-.181.015-.416-.044-.605-.078-.251-.288-.463-.379-.71-.228-.623-.211-1.395-.247-2.069-.071-1.263.184-2.214.264-3.461.064-.979-.1-1.941-.024-2.909.039-.508.032-1.207-.688-1.198-.008-1.737-2.311.208-3.112.316-.331.046-.848-.068-1.152.018-.469.131-.186.012-.336.476-.168.521-.61.995-.547 1.552.083.745.85 1.479 1.222 2.105.428.719.682 1.505.912 2.292.207.708.206 1.463.406 2.165.167.587.405 1.079.475 1.711.139 1.261.036 2.526.664 3.684.368.676.8.433 1.526.487.544.04 1.421-.199 1.721-.674.266-.423.487-1.663.262-2.123z")
                ]), M),
                A2(Da, l([
                    Fa("path2203"),
                    Ha("#dcc06d"),
                    qa("M67.538 469.349c.13.047.882.075.845-.175.119.827-2.295.707-2.732.429-.261-.167-.378-.648-.477-.928-.361-1.029-.04-2.043-.263-3.091-.25-1.178-.606-2.284-.785-3.48-.111-.741-.412-1.362-.781-1.999-.294-.51-.731-.908-1.019-1.423-.253-.453-.447-1.004-.353-1.525.073-.412.325-.773.435-1.166.233.172.358-.079.408.257.039.255-.259.542.166.559.211.009.862-.465.836-.708-.039-.382-.935-.296-1.176-.379.211-.04.502.063.743.059.378-.005.731-.133 1.072-.291.421-.194 1.385-1.114 1.843-.889-.082.068-.201.087-.281.146-.131.097-.253.237-.388.366-.296.278-.428.389-.546.806-.111-.182-.097-.426.059-.563-.324.196-.711.264-1.049.468.155.129.109.197.091.355a.7.7 0 0 0-.116.148c-.031.101-.006.216-.002.318.021.425.238 1.454.831 1.069.051.374-.011.769-.041 1.145-.05.636.001 1.302.063 1.935.104 1.055.606 1.996.797 3.027.171.927.168 2.029.672 2.858.072.115.247.258.29.386.093.275-.031.568.124.832a3.52 3.52 0 0 1 .106-.311c.142.292.752 1.08.795.308.083.37.286.745-.004 1.084a3.013 3.013 0 0 1-.359-.394c-.142.207-.333.029-.51-.045.035-.003.11-.04.154-.048.035-.134-.022-.249-.135-.326-.131.04-.326.164-.45.105-.145-.068-.125-.339-.258-.411-.1-.054-.266.043-.386.003-.199-.067-.353-.347-.492-.481-.006.109.128.39.163.482.046.12-.012.345.226.287-.097.299-.083.916.416.608-.115.149-.354.355-.197.541.347-.071.725-.139.957-.409.274.091.432.361.708.461z")
                ]), M),
                A2(Da, l([
                    Fa("path2205"),
                    Ha("#dcc06d"),
                    qa("M67.244 455.519c-.154-.209-.392.006-.49.161.002-.143.004-.281.038-.42a.951.951 0 0 1 .45.168")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2207")
            ]), l([
                A2(Da, l([
                    Fa("path2209"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".347"),
                    qa("M68.623 468.661c.848.693.931 1.052.763 2.065-.149.891-.107 1.913.003 2.811.042.349.066.856.21 1.179.122.273.508.433.599.671.187.487-.178 1.454-.36 1.88-.537-.13-.759.21-1.222.346-.435.127-.8-.157-1.214-.021-.348-.502-.661-.927-.886-1.496.853-.9.235-2.47-.135-3.474-.19-.513-.327-.766-.732-1.066-.451-.335-.731-.352-.822-.917-.148-.932.723-1.649 1.497-1.919.374-.13 1.045.003 1.477-.03.495-.038.995-.2 1.262.554")
                ]), M),
                A2(Da, l([
                    Fa("path2211"),
                    Ha("#dcc06d"),
                    qa("M69.512 476.448c-.508-.362.012-.905-.042-1.319a.604.604 0 0 1-.595-.388c-.063.333-.302.602-.521.845-.12-.054-.102-.148-.185-.236-.063-.066-.181-.101-.205-.226-.042-.21.281-.415.375-.558-.256-.087-.243-.322-.324-.558-.159-.461-.321-.925-.458-1.399a25.993 25.993 0 0 1-.349-1.379c-.044-.187-.056-.456-.138-.61a1.038 1.038 0 0 1-.518.052c-.04-.27-.448.22-.68-.049-.243-.281.178-.476.288-.684.066-.127-.012-.153.102-.299.026-.032.2-.156.257-.196.195-.139.516-.32.672-.042.013-.014.003-.047.012-.064.026-.024.032.021.058-.052-.2-.292-.624.073-.935-.115.181-.207.581-.219.707-.407-.462.313-1.05.302-1.473.7-.273.261-.515.497-.614.869-.209.776.561.963 1.06 1.377.599.496.928 1.253 1.128 1.992.121.448.172 1.086.091 1.544-.045.247-.542.78-.438.887.098-.118.245-.077.288.081.03.105-.125.298-.107.433.021.171.287.709.444.813.319.214 1.729-.002 1.962-.367-.11-.108-.277-.357-.432-.401-.245-.071-.106-.001-.229.136-.279.314-.446.497-.88.239-.346-.204-.205-.36.092-.613.128-.11.632-.541.18-.564.179-.117.938.239.964.438.127-.031.265-.011.275.079")
                ]), M),
                A2(Da, l([
                    Fa("path2213"),
                    Ha("#dcc06d"),
                    qa("M69 469.372c.007-.226-.184-.33-.353-.43.326.396-.456.839-.75.902.096.136.204.188.347.133.101-.04.212-.271.297-.346.179-.163.386-.234.596-.342")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2215")
            ]), l([
                A2(Da, l([
                    Fa("path2217"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".347"),
                    qa("M69.909 481.753c.055-.054-.309-1.371-.292-1.606.043-.59.474-.718.667-1.223.098-.257-.273-1.282-.464-.995.521-.78-.443-.496-.74-.556-.24-.049-.878-.816-.942-.039-.921-.174-1.216.354-1.448 1.047-.036.102-.258.146-.314.317-.02.065.103.604.131.686.126.347.249.627.553.873.523-.75 1.899 2.063.961 2.697.367.813.472 2.199 1.626 1.692 1.221-.535 1.242-2.064.764-3.133-.207.09-.353.094-.502.24z")
                ]), M),
                A2(Da, l([
                    Fa("path2219"),
                    Ha("#dcc06d"),
                    qa("M70.083 481.81c-.193.262-.241.388-.216.694.2.008.367.563.255.734-.043-.039-.104-.048-.125-.063-.061.404.165.704-.203 1.006.007-.09.091-.313.044-.393-.119-.199-.12-.035-.256-.021-.161.017-.515.082-.62.222-.255.344.432.126.522.399-.307.467-.877-.067-1.002-.372-.104-.25-.131-.51-.186-.776-.065-.32.012-.271.107-.555.236-.703-.314-3.005-1.302-2.67a1.639 1.639 0 0 0-.122-.468c-.034.016-.069.025-.104.04-.006-.144-.125-.221-.261-.263.243-.167.24-.405 0-.581.417-.067.396-.784.657-1.077a.36.36 0 0 1 .208.244c-.425.225-.655.656-.504 1.084.165-.127.337-.648.535-.609-.002-.047.009-.094.013-.126.392.344.661.204 1.109.013.289-.124.201-.167.392-.471-.266.326.186.35.191.649-.409-.201-1.238-.176-1.076.509.069.284.35.248.503.448.126.165.184.485.214.689.086.607.007 1.278.105 1.907.075.472.058.808.069 1.27.006.305.296.573.571.345.27-.226.157-.785.15-1.081.327-.214-.299-.831.313-.854")
                ]), M),
                A2(Da, l([
                    Fa("path2221"),
                    Ha("#dcc06d"),
                    qa("M69.775 479.157c.291-.063.259-.392.037-.514-.071.176.027.442.074.547")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2223")
            ]), l([
                A2(Da, l([
                    Fa("path2225"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M77.163 459.15c-.082.532-.446 1.049-.581 1.585-.174.689-.183 1.35-.195 2.041-.024 1.43.131 2.708.314 4.119.137 1.064.385 2.139.48 3.203.051.587-.236 1.022-.239 1.61.87-.074 1.11 1.484 1.201 2.101.066.455.228.967.033 1.388-.157.341-1.019 1.276-1.369 1.428-.648.277-1.531.002-2.219.011-.431.005-1.059.291-1.439.096-.608-.308-.88-1.147-.983-1.77-.165-1.005.355-1.286.573-2.147.112-.445-.103-1.213-.169-1.661-.138-.92-.245-1.828-.372-2.75-.244-1.78-.454-3.553-1.035-5.289-.549-.024-.503-.553-.662-.958-.2-.519-.547-.951-.854-1.409-.351-.521-.31-.413-.288-1.035.025-.688-.001-.875.551-1.431.915-.921 2.027-.644 3.292-.684.894-.027 1.817-.57 2.716-.498.872.066 1.373 1.227 1.245 2.05z")
                ]), M),
                A2(Da, l([
                    Fa("path2227"),
                    Ha("#dcc06d"),
                    qa("M77.21 472.038c-.171.163-.657.388-.392.673-.083.02-.241.136-.391.045.049-.229.045-.479.11-.711.231.063.383-.226.622-.036")
                ]), M),
                A2(Da, l([
                    Fa("path2229"),
                    Ha("#dcc06d"),
                    qa("M76.324 473.424a.524.524 0 0 1-.108-.361c-.323.114-.151.468.149.352")
                ]), M),
                A2(Da, l([
                    Fa("path2231"),
                    Ha("#dcc06d"),
                    qa("M72.727 469.751c-.103-.847-.295-1.691-.474-2.522-.171-.797-.282-1.604-.44-2.405-.054-.279-.088-.565-.148-.843-.058-.267-.17-.513-.231-.776-.048-.209-.094-.288-.277-.416-.269-.187-.214-.355-.312-.635-.305-.881-1.205-1.291-1.28-2.285-.067-.897.606-2.293 1.741-2.055-.22-.043-.361.105-.263.301.127.256.704.317.948.348.131.018.63.085.694-.095.079-.22-.397-.359-.506-.486.729.376 1.552-.021 2.221-.259.173-.063.331.009.492-.027.143-.032.234-.201.364-.22.206-.028.755.129.658.383-.112.288-.648.126-.605.568-.271-.149-.401.364-.268.515-.111.084-.268.084-.378.184-.119.107-.051.245-.135.337-.238.262-.473.04-.532-.246-.139.046-.373.01-.487.079-.205.12-.132.281-.202.507-.089-.072-.335-.818-.453-.258-.099-.544-.821-.064-.938.233-.053.138-.08.501.079.596.106.063.358-.056.479-.077.012.162.017.364.145.496.027-.064.124-.133.152-.199.529.251.532 1.51.605 2.002.198 1.368.458 2.725.659 4.095.19 1.296.408 2.597.595 3.885.048.33.219.813.104 1.133-.071.195-.457.484-.031.703.002.164-.309.431-.122.55.177.114.351-.313.59-.052-.004-.035.019-.102.014-.148.096.165.294.019.476.044-.001.018.023.083.027.107-.047.011-.099.036-.145.05.023.277-.074 1.132.332 1.16-.248.28.255.406.408.136-.046-.038-.076-.093-.129-.124a.918.918 0 0 0 .302-.08c.015.201.056 1.003.409.913-.081.092-.152.111-.251.041-.057-.041-.073-.138-.131-.186-.066-.055-.157-.065-.235-.079-.216-.042-.492.005-.398.275-.116.036-.354.107-.359.251-.007.231.491.354.651.408.339.112.719.159 1.016.351-.568.475-1.221.701-1.966.797a3.207 3.207 0 0 1-1.122-.058c-.161-.037-.355-.068-.485-.174.286-.265.756-.317 1.042-.611.089-.093.153-.21.244-.3.072-.071.371-.246.372-.363.002-.24-.354-.085-.445-.167-.072-.063-.014-.117-.01-.196.006-.153-.041-.278-.067-.428.194.008.209-.238.337-.325.082-.055.286.022.343-.076.119-.206-.447-.395-.561-.443.028-.109-.004-.318-.152-.33-.207-.015-.25.729-.304.891-.038-.304-.462-.035-.477.176-.008.121.065.558.233.541-.152.031-.255.047-.281.202-.024.148.099.38.179.506-.365.178-.546.704-.729 1.034-.455-.42-.826-1.043-1.011-1.633-.131-.419.028-.833.215-1.206.097-.188.215-.369.298-.564.089-.207.079-.414.095-.639a4.126 4.126 0 0 0-.026-.86c-.068-.505-.068-1.011-.11-1.518-.011-.147-.026-.29-.043-.434z")
                ]), M),
                A2(Da, l([
                    Fa("path2233"),
                    Ha("#dcc06d"),
                    qa("M76.685 460.043c.067-.364.292-.646.352-.999.075-.435-.202-.949-.413-1.299.112.231.401 1.604-.139 1.51.161.163.317.406.158.629")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2235")
            ]), l([
                A2(Da, l([
                    Fa("path2237"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M74.754 482.396c-.393-1.114-1.039-2.222-1.394-3.308-.401-1.223-.053-1.652.611-2.672 1.134-1.738 3.165-.796 4.758-.601.165.474.514.753.618 1.202.155.685-.248 1.773-.343 2.459-.251 1.785-.359 3.375.49 4.906.379.682.971 2.829.407 3.47-.452.517-1.334.149-1.886.191-.582.048-1.564.769-2.098.615-.574-.165-.844-1.311-.861-1.825-.023-.653.354-1.253.287-1.908-.045-.433-.23-.902-.291-1.354a5.806 5.806 0 0 0-.298-1.175z")
                ]), M),
                A2(Da, l([
                    Fa("path2239"),
                    Ha("#dcc06d"),
                    qa("M79.398 487.858c-.131-.548-1.054-1.231-1.621-.925.339.356.536.468-.011.667-.371.134-1.166.393-1.252.837.373-.056.728-.315 1.101-.414.307-.079.616-.092.929-.085.329.008.889.141 1.186-.095.25-.199.22-.861.147-1.14-.118-.449-.052-.901-.194-1.359-.014.373-.144.723-.044 1.097.057.213.179.365.195.601.02.313-.363 1.193-.529.508")
                ]), M),
                A2(Da, l([
                    Fa("path2241"),
                    Ha("#dcc06d"),
                    qa("M78.69 486.226c.122-.016.252-.014.364-.032-.147-.18-.05-.243-.049-.411.002-.198-.003-.459-.065-.673-.06.382-.175.761-.201 1.143")
                ]), M),
                A2(Da, l([
                    Fa("path2243"),
                    Ha("#dcc06d"),
                    qa("M73.521 477.561c-.155.396-.225.745-.099 1.152.181.588.544 1.117.728 1.721.502 1.643 1.737 3.538 1.26 5.324-.137.513-.138 1.215.046 1.707.087.233.176.661.373.81.323-.485.654-1.369 1.366-1.313.198-.643-1.145-.027-1.144.363-.001-.508-.642-.981-.473-1.493.053-.158.197-.271.372-.198.344.143.197.633.114.89.232-.161.707-1.047.36-1.244.585-.985.414-1.855.021-2.861-.173-.442-.063-1.019-.09-1.494-.032-.556-.032-1.104-.084-1.639-.117.282-.227.215-.429.095-.04-.022-.085-.146-.143-.185-.225-.152-.503-.003-.715-.275-.208-.269-.332-1.514.313-1.203-.078-.304.262-.46.367-.059.009-.056.025-.344-.074-.392-.136-.063-.28.182-.394.278-.163.138-.523.436-.766.379-.355-.086-.238-.43.036-.57.212-.109.468-.092.697-.178-.044-.27.195-.483.44-.539.333-.077.519.166.775.258-.205-.076-.302-.427-.447-.574-.144-.147-.557-.311-.325-.584-.002-.034-.011-.117-.013-.154-.356.015-.819.37-1.125.563-.519.332-.734.865-.947 1.415z")
                ]), M),
                A2(Da, l([
                    Fa("path2245"),
                    Ha("#dcc06d"),
                    qa("M78.886 479.029c.066-.338.204-.737.129-1.068-.083.217-.181.776-.048.918")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2247")
            ]), l([
                A2(Da, l([
                    Fa("path2249"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M79.562 490.397c.063-.332.11-.737.239-1.044.088-.208.378-.421.422-.63.089-.418-.421-.653-.794-.918-.389-.275-.859-.404-1.351-.456-.848-.089-1.682.273-2.231.896-.345.391-.837.678-.493 1.212.308.475.868.825 1.17 1.365.307.551.346 1.165.512 1.763.082.299.253.602.125.893-.113-.151-.267-.153-.387-.231-.34 1.179.704 3.685 2.079 3.005.16-.08.192-.312.333-.406.076-.052.31-.002.439-.103.137-.104.397-.606.486-.778.249-.473.068-.805.11-1.223.033-.33.485-1.103-.03-1.207.025-.122-.025-.285-.077-.393-.522.125-.677.44-.756-.332-.047-.459.121-.964.204-1.413z")
                ]), M),
                A2(Da, l([
                    Fa("path2251"),
                    Ha("#dcc06d"),
                    qa("M76.833 488.664c-.284.129-.575.029-.853.26-.155.129-.303.376-.326.571.211-.013.443-.079.635-.096.145-.013.474-.106.628-.079.41.075.716.975.692 1.339.323-.437.417.745.442.893.119.662.315 1.314.453 1.971-.153.106-.188.341-.232.511-.244-.31-.508.419-.063.187-.009.155.013.317.032.469-.06.007-.135.064-.195.068.135.306.888-.12 1.035-.306.219-.277.26-.75.329-1.076.049-.239.164-.541.147-.778.137.046.276-.031.361-.145-.078.314-.032.506.048.791-.392-.459-.197.503-.217.53-.032-.005-.05-.014-.079-.017-.058.115-.025.239.055.335-.273-.09-.226.171-.137.319-.12-.2-.215.374-.216.41-.005.129-.041.481.177.464.153-.012.418-.465.468-.603-.041.454-.418.591-.727.832.083-.171.196-.321.102-.515-.123-.25-.48-.28-.622-.047-.04.064.007.182-.034.237-.019.024-.202.153-.191.125.164-.444-.286-.333-.267-.111a.491.491 0 0 1-.246.032c.026-.167-.064-.311-.261-.262-.011-.161-.044-.417-.286-.331.005-.156-.008-.618-.248-.611-.258.008.051.369-.13.47.022.127.119.209.246.233a.484.484 0 0 0-.069.274c.005.033.176.271.193.281.124.079.449.205.568.144-.013.099.038.096.063.195.231-.064.523-.009.698-.155.236.361-.348.148-.493.208-.014-.031-.022-.061-.035-.092-.114.024-.229.065-.342.088.003-.03-.017-.094-.01-.134-.08.015-.165-.018-.25.021.032-.293-.179-.29-.412-.256-.06-.144.014-.293-.05-.427-.215.09-.201-.037-.212-.169-.007-.085.057-.16.052-.244-.006-.082-.065-.1-.083-.18-.074-.307-.153-.628-.047-.943.147.065.269.291.442.279-.063-.324-.051-.652-.128-.98-.124-.528-.254-1.049-.379-1.577a2.36 2.36 0 0 0-.875-1.327c-.398-.299-.812-.471-.522-1.037.059.331.874-.187.786-.386-.147.03-.293.079-.438.122.716-1.025 2.215-1.122 3.289-.765-.211.041-.37.176-.582.159-.146-.01-.378-.109-.562-.13-.543-.062-1.061-.11-1.419.383.322.187.955.03 1.328-.055.269-.064.509-.115.699.111-.24.202-.801.125-1.097.159-.141.017-.36.019-.48.107a.968.968 0 0 0-.153.256z")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2287")
            ]), l([
                A2(Da, l([
                    Fa("path2289"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M88.482 456.721c.231.135.059.425.111.588.148.456.549.534.728.99.179.456.4 1.289.255 1.782-.086.292-.342.588-.457.884-.177.465-.452 1.032-.495 1.528-.046.537.093 1.146.094 1.691.001 1.356-.104 2.711-.052 4.061.051 1.312-.376 2.653-.015 3.976.172.629.599 1.059.796 1.663.241.736.371 1.546.193 2.31-.091.386-.273 1.055-.575 1.31-.404.343-1.404.028-1.891.054-.95.052-3.499.961-3.178-.808-.133.082-.265.035-.401.07-.197-.425-.149-1.345-.076-1.736.051-.27.06-.585.094-.806.04-.264.261-.481.347-.746.199-.598-.015-1.21-.104-1.793-.221-1.428-.26-2.926-.336-4.368-.069-1.305-.338-2.52-.528-3.793-.093-.625-.196-1.063-.524-1.627-.308-.527-.691-1.038-.806-1.653-.098-.529-.099-1.321.08-1.818.111-.304.508-1.148.807-1.271.102-.041.479.103.611.105.252.006.461-.025.723-.06.438-.058.944-.18 1.358-.199.572-.025 1.142.126 1.716.096.43-.024 1.16-.644 1.525-.43z")
                ]), M),
                A2(Da, l([
                    Fa("path2291"),
                    Ha("#dcc06d"),
                    qa("M87.704 476.553c-.339-.098-.944-.239-1.262-.022.231.041.885.137.382.368-.266.123-.603.187-.884.262-.177.047-.718.256-.9.109-.211-.167.247-.769.385-.924.274-.303.83-.641 1.263-.508-.132-.396-1.148-.2-1.451-.115.063-.15.186-.286.236-.441.081-.249-.01-.499.016-.748.023-.243.115-.268.276-.409.201-.176.279-.397.351-.652.21-.737-.098-1.371-.169-2.09-.065-.663-.151-1.329-.217-1.995-.059-.592-.125-1.188-.173-1.779-.099-1.264.054-2.528-.095-3.794a59.346 59.346 0 0 0-.245-1.821c-.054-.364-.067-.849-.251-1.183-.142-.259-.405-.233-.665-.329-.512-.188-.955-.459-1.314-.872.26-.055.559.036.828.033.196-.002.394-.031.584-.015-.341-.181-.885-.023-1.168-.335.456-.073.628-.211.991-.461.588-.405 1.326-.462 2.01-.526-.003.023-.005.063-.009.089.189.03.593-.205.759-.285.191-.094.267-.238.406-.381.128-.135.44-.335.614-.142.295.331-.301.818-.531.972.136.246.458-.135.524-.275.087-.182.127-.466.111-.667.383.06.18 1.027.171 1.267.194-.246.255-.842.133-1.141-.142-.345-.253-.079-.517-.122-.156-.363-1.106.186-1.376.246-.372.08-.728.148-1.113.156-.35.009-1.104.112-1.386-.146.243-.158.584-.095.861-.115.363-.025.728-.078 1.086-.128.592-.085 1.211-.368 1.756-.601-.321.016-.63.105-.946.162-.466.083-.943.063-1.41.06-.691-.004-1.367.089-2.054.194-.146.021-.315.075-.467.053-.018-.002-.157-.057-.157-.057-.21.047-.159.214-.281.418-.053.09-.341.312-.333.412.012.133.448.368.588.404a1.658 1.658 0 0 0-.497.018c.127.214.429.324.626.473-.289-.031-.637.104-.904-.024-.06.245-.032.604-.03.873.002.191-.024.273.088.439.102.153.246.27.332.438.181.353.35.759.488 1.131.135.364.313.691.402 1.074.263 1.152.548 2.259.625 3.448.039.605.108 1.202.148 1.809.045.698-.093 1.403-.045 2.104.032.461.122.907.218 1.357.154.735.336 1.426-.107 2.088-.143.213-.193.294-.212.523-.022.305-.108.553-.149.856-.049.361-.105 1.096.132 1.399.161.202.312-.034.411.195.058.136-.072.351-.032.51a.445.445 0 0 0 .365.345c.318.065.829-.055 1.167-.075.665-.042 1.322-.147 1.987-.19.193-.013.389-.045.571-.044.155.002.571.077.444-.202-.13-.288-.702-.588-.985-.671z")
                ]), M),
                A2(Da, l([
                    Fa("path2293"),
                    Ha("#dcc06d"),
                    qa("M88.137 475.777c.368-.209.054-.532.154-.817-.224-.054.204-.813.237-1.017-.26.127-.469.598-.51.879.272.176.313.586.204.86")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2295")
            ]), l([
                A2(Da, l([
                    Fa("path2297"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M88.639 486.242c.051-.403-.202-1.038-.276-1.469-.12-.707-.004-1.43.063-2.139.072-.749.115-1.481.292-2.215a8.498 8.498 0 0 1 .64-1.731c.188-.396.297-.727.094-1.156-.556-1.172-2.149-1.64-3.359-1.47-1.032.146-2.561 1.167-2.389 2.351.05.339.304.735.412 1.062.182.555.292 1.113.363 1.69.11.88.25 1.751.211 2.644-.028.624-.094 1.031-.418 1.54-.297.467-.418.608-.211 1.156.157.413.143.874.472 1.138.466.375.907.209 1.47.172.444-.029.833.136 1.258.146.824.021 1.288-1.021 1.378-1.719z")
                ]), M),
                A2(Da, l([
                    Fa("path2299"),
                    Ha("#dcc06d"),
                    qa("M85.683 487.242c-.145.029-.413.148-.311.331-.096.022-.212.05-.26.134.417.078.68-.022 1.08-.109.242-.053.784.296.934.186.033-.027-.525-.396-.571-.417a1.429 1.429 0 0 0-.872-.125z")
                ]), M),
                A2(Da, l([
                    Fa("path2301"),
                    Ha("#dcc06d"),
                    qa("M87.627 485.875c.292-.084.063-.188.128-.368.065-.178.304-.104.369-.29-.215-.13-1.201.042-.976.37.093.137.175-.008.244.022.119.049.133.249.235.266")
                ]), M),
                A2(Da, l([
                    Fa("path2303"),
                    Ha("#dcc06d"),
                    qa("M86.998 486.163c.028-.041.029-.078.005-.113-.262-.014-.42.308-.682.346a.115.115 0 0 0-.026-.041c-.004.122-.092.238-.076.356.261-.032.791-.362.831-.628")
                ]), M),
                A2(Da, l([
                    Fa("path2305"),
                    Ha("#dcc06d"),
                    qa("M85.241 487.003c.091-.015.19-.061.236-.133.042-.066-.682.103-.705.101.11-.26.173-.523.15-.827-.027.045-.096.076-.128.117-.196-.174-.231-.682-.053-.888.1-.117.445-.226.52-.041.012.011.013.01.004-.002-.428-.152-.104.709.233.311-.093.203.059.217.217.18.271-.063.274-.268.34-.518-.001.182.027.366.008.545-.017.156-.16.366-.108.494.391-.093.572-.923.391-1.248.109-.075.147-.209.156-.338.115.029.228-.048.287-.141-.242-.204-.125-.399-.052-.66.089-.329.106-.541-.047-.836-.294-.565-.134-1.435-.167-2.066-.29-.066-.261-.478-.237-.685.054-.461.108-.97.081-1.434-.133.058-.202-.027-.182-.164.019-.135.163-.17.238-.265.106-.134.071-.105.084-.266.014-.172.07-.638-.004-.762-.104.216-.324.583-.579.635-.301.06-.166-.253-.157-.475.008-.166-.067-.364-.054-.504.023-.246.318-.27.522-.256.079.004.16.058.235.053.137-.01.039.002.136-.059.041-.026.085-.117.156-.158a.81.81 0 0 1 .269-.074c.314-.044.533.153.815.207.144.028.244-.056.378-.046-.372-.137-.653-.47-1.047-.554-.487-.105-1.023-.013-1.489.136-.542.173-.904.452-1.279.858-.14.152-.443.359-.476.572.09-.045.19-.08.28-.119.1.094.062.293-.019.387-.029.033-.12 0-.168.054-.016.018-.015.161-.015.185-.003.099-.048.042-.004.157.034.087.142.177.186.281.149.353.185.711.27 1.079.171.744.251 1.508.354 2.259.069.493.103.973.137 1.468.025.386.052.674-.109 1.029a6.037 6.037 0 0 1-.342.646c-.086.144-.265.336-.303.504-.027.119.207.699-.08.555.062.318.409.576.447.912a.406.406 0 0 0 .127-.252c.007.126.089.2.062.343.178.011.374-.161.485-.297")
                ]), M)
            ])),
            A2(On, l([
                Fa("g2307")
            ]), l([
                A2(Da, l([
                    Fa("path2309"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M87.669 488.181c-.352-.393-.597-.861-1.091-1.023-.832-.275-1.224.386-1.834.745-.458.269-.965.014-1.42.549-.397.463-.456 1.054-.041 1.435.125.114.319.148.471.307.099.102.293.373.383.524.32.546.346 1.414.349 2.037.001.151.088.697-.142.765-.365.108-.256-.458-.506-.513-.584-.127-.421 1.465-.333 1.71.054.147.184.32.261.468.031.06.166.109.182.154.039.1-.029.234.006.324.115.297.19.592.52.74.289.129 1.676.333 1.564-.276.647.242.899-.606 1.139-.938.177-.246.815-.553.239-.897.302-.284.436-.889.236-1.269-.39-.74-.349.234-.714.318-.143-1.095.194-2.24.668-3.224.209-.436.805-.691.965-1.165.116-.347.087-.191-.044-.398.06.093-.428-.318-.359-.281-.211-.114-.201-.271-.499-.092z")
                ]), M),
                A2(Da, l([
                    Fa("path2311"),
                    Ha("#dcc06d"),
                    qa("M88.42 489.12c-.324.184-.189-.09-.184-.202.009-.224-.016-.338-.262-.447-.331-.15-.547.142-.409.48-.085.063-.162.147-.256.188-.019-.286.275-.44.182-.723-.128-.397-.717-.337-1.005-.176.142-.4-1.54-.32-1.335.188-.133-.006-.237-.078-.322-.136 0 .171.158.289.172.466.05 0 .094.036.143.034.023.199-.039.372.059.563a.314.314 0 0 1-.143.006c-.048-.122-.02-.255-.118-.35-.016.04-.076.096-.082.17-.063-.021-.176-.033-.229.02-.122.121.008.118 0 .252-.016.243-.072.34-.24.532.055-.158.061-.322-.031-.464-.077.077-.149.189-.246.245a1.37 1.37 0 0 1-.015-.055.401.401 0 0 0-.021.339c-.166-.26-.088-.441-.023-.752.067.098.179.323.315.221.128-.096-.003-.355.011-.48.192.007.284.26.455-.024.135-.228-.038-.55-.297-.561-.347-.018-.768.523-.909.79-.09.171-.102.465-.331.498-.062-.109-.057-.342-.059-.465-.004-.244.028-.479.188-.675.228-.281.616-.468.966-.504.142-.016.329.087.455.042.098-.034.206-.27.292-.339.226-.189.608-.409.907-.441.366-.041.639.094.919.313.207.16.458.439.682.557.108.057.207-.001.312.036.126.044.18.14.281.229.199.179.447.394.124.617 0-.036-.018-.032-.037-.048")
                ]), M),
                A2(Da, l([
                    Fa("path2313"),
                    Ha("#dcc06d"),
                    qa("M85.228 490.503c-.278-.041-.466-.211-.509-.484-.087.017-.416.303-.451.415-.061.188.24.468.332.664.153.329.149.626.188.988.043.403.096.853-.031 1.252-.086.271-.347.416-.596.229-.184-.139-.277-.712-.528-.361-.353.495.009 1.568.357 1.951-.105-.505.413-.812.685-.314.164.302-.055.1-.071.331-.012.164.172.13.272.09.023.307.029.473-.274.643-.144.081-.511.244-.083.316.188-.26.378-.519.567-.769.074-.097.422-.625.511-.358.32-.184.232.709.219.863.298-.111.319-.462.542-.653.263-.226.61-.413.766-.756-.143.044-.25.223-.395.253-.044-.17.087-.298.095-.452.007-.149-.101-.25-.059-.414.05-.194.24-.217.355-.354.112-.133.119-.323.209-.46-.45.753-.518-.259-.528-.603-.091.34-.034.909-.21 1.185-.13.203-.257.096-.142.392.08.203.226.368-.028.544-.153.105-.183.056-.34-.043a.516.516 0 0 0-.104.326c.211-.134.376-.056.31.171-.084.289-.333.463-.447.175-.033-.08.024-.163-.038-.232-.055-.059-.205-.048-.277-.077-.192-.081-.201-.132-.227-.358-.032-.262-.092-.529.022-.78.045-.096.183-.211.2-.313.021-.131-.058-.35-.082-.479a13.03 13.03 0 0 1-.228-1.674c-.014-.233-.212-.679.05-.853")
                ]), M)
            ]))
        ])),
        A2(On, l([
            Fa("g103")
        ]), l([
            A2(On, l([
                Fa("g105")
            ]), l([
                A2(Da, l([
                    Fa("path107"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M265.451 802.916c.458-.6 1.514-1.652 1.145-2.56-.275-.674-1.063-1.37-1.708-1.738-.395-.226-.851-.243-1.232-.489-.606-.387-1.187-1.003-1.759-1.461-.824-.661-2.24-1.531-2.59-2.516-.118-.329-.229-.721-.5-.995a1.231 1.231 0 0 0-.499-.304c-.238-.084-.443-.193-.676-.259-.348-.095-.54.121-.819.203-.452.133-.934.135-1.369.326a1.088 1.088 0 0 0-.654.759c-.169.607.104 1.255.185 1.886.086.666-.153 1.292.659 1.772.434.256.825.141 1.27.255.883.225 1.749.916 2.625 1.245 1.536.578 2.258 1.496 3.187 2.748a.26.26 0 0 1 .094.089c-.044.026-.09.056-.136.082.281.249.602.473.876.725-.032.029-.063.011-.098.036.198.188.354.104.553.188.183.077.345.228.531.288.531.174.688.016.915-.28z")
                ]), M),
                A2(Da, l([
                    Fa("path109"),
                    Ha("#dcc06d"),
                    qa("M265.282 799.744c-.401-.152-.177-.8-.546-.896-.459-.119.16 1.147.604.896")
                ]), M),
                A2(Da, l([
                    Fa("path111"),
                    Ha("#dcc06d"),
                    qa("M266.356 801.123a.311.311 0 0 0 .048-.196c-.247-.108-.83-.038-.985.149-.135.16-.041.402-.22.564-.106.098-.47.112-.51.213-.09.224.403.728.307 1.036-.203-.155-1.301-1.844-1.459-1.118-.121-.283-.471-.414-.616-.674-.085-.157-.186-.158-.032-.299.084-.074.144-.103.286-.021-.438-.446-1.147-.827-1.474-1.363-.098-.162-.045-.241-.256-.441-.376-.353-.917-.666-1.35-.939-.729-.462-1.631-.935-2.264-1.526-.215-.199-.288-.449-.654-.342-.203.06-.236.296-.478-.007l.058.099c-.187-.188-.394-.233-.61-.36-.364-.212-.652-.576-.855-.92.29.014.969.223 1.128.486-.591-.978-.539-1.702.066-2.424-.317.292-.89.262-1.18.61a1.173 1.173 0 0 0-.251.869c.036.341.108.704.153 1.062.081.654-.182 1.327.528 1.823-.121-.319.214-.297.408-.082a1.003 1.003 0 0 1-.276.144c.199.165.597.093.848.154.313.077.567.218.857.359.362.177.737.31 1.109.462.478.198 1.017.313 1.471.545.95.484 1.724 1.334 2.366 2.153.102.134.311.295.358.449.06.194-.135.17.04.398.094.12.269.17.409.278.22.172.396.421.589.608.247-.257.518.132.828.201.396.086.497-.077.629-.346.3-.615.896-1.163 1.04-1.748")
                ]), M)
            ])),
            A2(On, l([
                Fa("g113")
            ]), l([
                A2(Da, l([
                    Fa("path115"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M261.16 805.241c.458-.601 1.514-1.652 1.145-2.562-.275-.674-1.063-1.369-1.709-1.737-.395-.225-.85-.243-1.231-.489-.606-.386-1.187-1.003-1.759-1.46-.825-.662-2.241-1.533-2.59-2.517-.118-.331-.229-.72-.5-.995a1.267 1.267 0 0 0-.499-.305c-.238-.082-.443-.192-.676-.257-.349-.097-.54.12-.819.202-.452.133-.934.136-1.369.326a1.088 1.088 0 0 0-.654.758c-.169.607.104 1.255.185 1.888.086.665-.153 1.292.659 1.772.434.255.825.14 1.269.254.884.225 1.749.917 2.626 1.246 1.536.576 2.256 1.495 3.187 2.748.04.021.07.051.094.088-.044.026-.09.057-.137.083.282.249.603.473.877.725-.032.029-.063.01-.098.035.198.188.354.105.552.189.184.076.346.227.531.287.532.174.689.016.916-.279z")
                ]), M),
                A2(Da, l([
                    Fa("path117"),
                    Ha("#dcc06d"),
                    qa("M260.991 802.069c-.401-.153-.177-.802-.545-.897-.46-.12.159 1.147.603.896")
                ]), M),
                A2(Da, l([
                    Fa("path119"),
                    Ha("#dcc06d"),
                    qa("M262.065 803.446a.332.332 0 0 0 .05-.195c-.25-.108-.832-.038-.988.149-.134.16-.04.401-.219.564-.107.099-.47.113-.51.214-.09.224.402.727.307 1.035-.203-.155-1.301-1.843-1.459-1.119-.121-.282-.471-.413-.616-.674-.085-.155-.186-.157-.032-.298.084-.075.144-.102.285-.021-.437-.448-1.146-.828-1.473-1.364-.099-.161-.045-.242-.256-.441-.376-.353-.917-.665-1.351-.939-.729-.461-1.63-.935-2.263-1.525-.216-.201-.288-.449-.654-.343-.203.058-.234.296-.479-.007.02.032.039.065.058.099-.186-.188-.393-.233-.609-.361-.365-.211-.652-.575-.855-.92.29.016.969.224 1.128.488-.591-.978-.539-1.702.066-2.425-.318.292-.89.263-1.18.608a1.184 1.184 0 0 0-.251.872c.036.339.107.703.153 1.061.081.655-.182 1.327.528 1.822-.121-.317.214-.296.408-.081a.975.975 0 0 1-.276.143c.199.167.596.094.848.156.313.075.566.217.857.358.362.177.737.309 1.109.462.478.198 1.017.313 1.471.545.951.483 1.724 1.334 2.365 2.154.103.132.312.295.358.448.06.194-.134.17.041.397.094.12.269.169.409.279.22.173.396.422.589.607.247-.255.519.133.828.201.396.087.496-.076.629-.346.3-.614.896-1.164 1.04-1.748")
                ]), M)
            ])),
            A2(On, l([
                Fa("g121")
            ]), l([
                A2(Da, l([
                    Fa("path123"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M256.028 803.896c-.305-.401-1.099-.725-1.546-1.037-.736-.508-1.264-1.252-1.826-1.938-.591-.725-1.195-1.41-1.677-2.221-.401-.674-.683-1.369-.928-2.117-.173-.524-.365-.916-.928-1.104-1.549-.516-3.44.556-4.415 1.829-.831 1.088-1.354 3.406-.153 4.288.343.251.93.365 1.315.552.657.319 1.25.708 1.826 1.148.875.673 1.772 1.308 2.521 2.128.522.575.821.996.967 1.744.137.687.149.925.821 1.213.509.219.901.639 1.438.565.762-.104 1.028-.66 1.52-1.217.386-.438.892-.655 1.297-1.04.784-.749.301-2.095-.232-2.793z")
                ]), M),
                A2(Da, l([
                    Fa("path125"),
                    Ha("#dcc06d"),
                    qa("M254.162 807.522c-.109.16-.255.515.002.581-.071.107-.153.241-.126.357.456-.317.614-.65.91-1.098.177-.272.988-.468 1.03-.705.01-.055-.836.141-.897.163a1.986 1.986 0 0 0-.919.702z")
                ]), M),
                A2(Da, l([
                    Fa("path127"),
                    Ha("#dcc06d"),
                    qa("M254.764 804.512c.199-.344-.105-.223-.202-.443-.096-.216.188-.375.087-.596-.314.085-1.078 1.15-.581 1.231.207.034.155-.17.245-.207.153-.065.343.096.451.015")
                ]), M),
                A2(Da, l([
                    Fa("path129"),
                    Ha("#dcc06d"),
                    qa("M254.434 805.351c-.01-.061-.042-.096-.094-.104-.256.232-.121.66-.33.938a.166.166 0 0 0-.06-.013c.102.111.123.296.242.385.214-.272.414-1.053.22-1.323")
                ]), M),
                A2(Da, l([
                    Fa("path131"),
                    Ha("#dcc06d"),
                    qa("M253.541 807.721c.07-.096.124-.229.103-.333-.019-.098-.542.722-.567.743-.128-.329-.301-.622-.589-.868.016.066-.021.156-.015.222-.335.028-.815-.384-.832-.73-.007-.198.218-.612.45-.52.019-.004.019-.005.002-.006-.533.264.524.722.488.055.094.268.246.137.358-.041.198-.307.02-.492-.139-.771.16.161.346.297.486.473.123.152.175.471.335.535.281-.444-.281-1.345-.733-1.462.034-.168-.05-.321-.154-.444.135-.079.169-.251.143-.389-.404.046-.467-.235-.628-.532-.205-.372-.378-.575-.778-.691-.771-.223-1.389-1.138-1.974-1.661-.328.211-.664-.18-.823-.382-.356-.457-.75-.954-1.186-1.337-.075.174-.211.163-.314.025-.102-.135 0-.301-.01-.454-.021-.216-.028-.16-.155-.313-.137-.164-.497-.626-.675-.664.092.282.211.811.02 1.094-.226.333-.375-.067-.563-.271-.138-.151-.384-.258-.492-.394-.194-.237.058-.533.259-.71.078-.07.199-.098.263-.173.121-.136.042-.034.077-.178.016-.061-.023-.183.007-.282.025-.102.121-.232.186-.316.252-.332.63-.358.938-.575.156-.109.177-.274.31-.393-.465.226-1.021.194-1.462.486-.543.36-.959.941-1.262 1.504-.35.655-.443 1.237-.434 1.945.005.264-.096.727.061.944.047-.124.106-.248.157-.366.173-.009.313.201.322.357.002.057-.113.113-.108.204 0 .03.128.156.147.178.084.089-.01.081.134.141.108.047.288.026.42.076.447.17.798.453 1.201.698.814.497 1.56 1.094 2.315 1.659.497.37.949.76 1.419 1.165.363.313.64.543.805 1.007.1.285.181.586.247.884.046.207.051.544.161.725.081.131.81.424.414.563.34.223.887.128 1.219.387.004-.109-.021-.25-.104-.339.118.104.259.094.358.244.176-.161.208-.496.192-.719")
                ]), M)
            ])),
            A2(On, l([
                Fa("g133")
            ]), l([
                A2(Da, l([
                    Fa("path135"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M257.26 806.431c-.561-.226-1.092-.587-1.589-.502-.839.144-.652 1.026-.855 1.71-.151.512-.728.507-.681 1.294.038.683.429 1.323 1.026 1.504.182.055.352-.011.586.075.152.057.499.235.681.348.646.399 1.308 1.282 1.771 1.926.11.155.58.675.452.862-.198.3-.531-.342-.764-.271-.542.168.759 1.73 1.007 1.938.149.125.376.237.543.35.069.045.207.029.253.066.104.084.151.258.242.332.31.249.583.514.943.498.317-.013 1.531-.513.996-1.084.671-.083.239-1.089.179-1.552-.047-.346.216-.989-.479-1.049.02-.45-.323-1.141-.756-1.432-.846-.566-.094.419-.313.694-.917-1.061-1.503-2.416-1.865-3.676-.16-.557.106-1.127-.12-1.699-.165-.417-.074-.24-.328-.387.115.065-.561-.109-.481-.106-.246-.009-.354-.177-.448.161z")
                ]), M),
                A2(Da, l([
                    Fa("path137"),
                    Ha("#dcc06d"),
                    qa("M258.527 807.017c-.11.355-.211.004-.287-.116-.161-.235-.265-.339-.531-.327-.365.013-.314.427.04.705-.02.108-.015.236-.058.325-.224-.286-.113-.595-.395-.842-.388-.342-.793.022-.898.336-.186-.488-1.413.456-.882.877-.107.061-.237.042-.346.024.125.177.334.217.476.395.038-.026.1-.012.135-.039.163.194.245.404.458.552a.231.231 0 0 1-.105.079c-.125-.102-.201-.254-.347-.302.017.05.013.138.063.218-.063.01-.16.057-.162.137-.002.188.095.119.185.26.167.261.197.388.211.674-.075-.19-.193-.364-.366-.465-.002.12.026.274-.008.381l-.052-.05c.028.134.12.265.232.36-.316-.182-.392-.409-.568-.764.121.066.373.243.403.066.024-.164-.265-.365-.348-.504.153-.089.409.126.33-.256-.063-.305-.436-.548-.641-.429-.278.159-.201.934-.112 1.282.057.225.264.534.114.687-.127-.084-.296-.325-.39-.453-.182-.247-.33-.509-.352-.793-.034-.405.126-.797.367-1.015.098-.089.314-.079.38-.189.048-.085-.041-.383-.028-.5.032-.31.164-.734.366-.919.253-.229.562-.229.935-.147.277.06.674.221.932.227.127.002.159-.107.265-.123.131-.02.243.053.386.093.284.085.629.179.551.577-.027-.039-.041-.025-.063-.031")
                ]), M),
                A2(Da, l([
                    Fa("path139"),
                    Ha("#dcc06d"),
                    qa("M257.104 810.08c-.243.1-.512.02-.746-.242-.056.063-.094.525-.04.66.094.225.529.361.744.517.358.262.575.571.872.926.331.395.701.832.9 1.31.132.324.04.607-.288.542-.241-.05-.736-.597-.67-.104.097.694 1.163 1.616 1.712 1.836-.453-.47-.282-1.053.291-.678.35.228.033.131.192.38.11.174.226.044.272-.048.243.304.37.474.265.805-.052.156-.209.515.171.369-.05-.363-.095-.728-.133-1.084-.015-.137-.138-.862.125-.632.109-.352.7.614.806.782.145-.268-.099-.643-.069-.954.034-.367.163-.739.03-1.172-.076.117-.028.356-.118.463-.157-.153-.153-.354-.259-.514-.105-.159-.263-.21-.351-.399-.106-.229.024-.348.011-.549-.015-.195-.147-.396-.181-.582.213 1.01-.587-.001-.848-.353.18.397.645.956.712 1.332.052.275-.125.23.183.476.211.17.443.266.377.578-.038.187-.096.15-.289.129a.788.788 0 0 0 .159.388c.063-.243.247-.248.364.021.147.341.086.647-.213.409-.086-.067-.102-.183-.203-.223-.085-.032-.191.058-.269.063-.207.014-.249-.033-.438-.254-.217-.255-.46-.5-.557-.817-.038-.122-.017-.311-.08-.428-.079-.146-.301-.331-.414-.453a22.019 22.019 0 0 1-1.41-1.611c-.183-.235-.66-.593-.591-.907")
                ]), M)
            ])),
            A2(On, l([
                Fa("g141")
            ]), l([
                A2(Da, l([
                    Fa("path143"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M243.181 806.721c-1.188-.928-2.655-1.659-3.775-2.584-1.266-1.042-1.155-1.771-1.078-3.389.137-2.758 3.066-3.249 5.007-4.229.499.397 1.082.44 1.496.856.629.633.897 2.13 1.241 2.955.897 2.146 1.827 3.971 3.807 5.015.884.462 2.975 2.373 2.762 3.501-.173.905-1.416 1.162-2.014 1.625-.631.487-1.269 2.015-1.975 2.247-.761.249-1.828-.805-2.188-1.354-.458-.701-.428-1.642-.938-2.31-.337-.441-.859-.817-1.228-1.268a6.986 6.986 0 0 0-1.117-1.065z")
                ]), M),
                A2(Da, l([
                    Fa("path145"),
                    Ha("#dcc06d"),
                    qa("M252.073 809.226c-.512-.501-2.011-.559-2.454.205.622.135.919.109.431.739-.331.425-1.064 1.304-.866 1.858.386-.343.616-.895.975-1.281a4.884 4.884 0 0 1 1-.789c.378-.241 1.101-.514 1.283-.994.151-.407-.322-1.111-.589-1.361-.432-.404-.656-.95-1.12-1.347.229.42.315.901.673 1.237.205.191.449.266.621.512.23.331.38 1.583-.262.954")
                ]), M),
                A2(Da, l([
                    Fa("path147"),
                    Ha("#dcc06d"),
                    qa("M250.187 807.969c.129-.108.278-.205.394-.31-.288-.087-.221-.231-.329-.414-.13-.219-.307-.502-.518-.689.183.463.305.967.53 1.404")
                ]), M),
                A2(Da, l([
                    Fa("path149"),
                    Ha("#dcc06d"),
                    qa("M238.575 802.342c.087.55.238.985.652 1.336.596.51 1.356.819 1.967 1.345 1.659 1.425 4.316 2.576 4.959 4.896.186.663.648 1.435 1.184 1.836.253.191.637.592.959.608.048-.773-.163-1.994.681-2.464-.201-.854-1.317.829-1.059 1.254-.336-.554-1.377-.593-1.524-1.28-.047-.215.043-.443.289-.497.487-.102.646.546.72.891.158-.352.111-1.681-.413-1.632.008-1.523-.764-2.351-1.875-3.156-.49-.356-.745-1.071-1.092-1.574-.405-.584-.768-1.187-1.182-1.733.053.396-.115.407-.425.425-.06.006-.191-.096-.285-.095-.354.002-.572.374-.992.234-.416-.139-1.383-1.412-.443-1.556-.288-.273-.007-.699.377-.338-.025-.069-.198-.397-.341-.374-.196.032-.198.41-.263.599-.094.275-.307.872-.619.989-.46.174-.556-.291-.336-.651.169-.276.469-.451.674-.715-.229-.264-.098-.679.141-.923.329-.335.699-.209 1.052-.302-.281.072-.625-.239-.888-.293-.261-.053-.836.076-.757-.396-.023-.036-.089-.121-.117-.16-.395.284-.686 1.02-.902 1.462-.376.754-.262 1.497-.142 2.264z")
                ]), M),
                A2(Da, l([
                    Fa("path151"),
                    Ha("#dcc06d"),
                    qa("M245.638 799.927c-.147-.418-.255-.96-.559-1.27.047.302.308.988.55 1.044")
                ]), M)
            ])),
            A2(On, l([
                Fa("g153")
            ]), l([
                A2(Da, l([
                    Fa("path155"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M253.835 812.507c-.154-.371-.368-.816-.441-1.191-.05-.257.087-.608-.005-.845-.184-.476-.813-.491-1.33-.597-.539-.109-1.061-.031-1.554.136-.851.292-1.402 1.043-1.521 1.938-.075.562-.354 1.082.31 1.482.591.354 1.337.464 1.967.889.635.433 1.064 1.055 1.6 1.601.267.274.62.509.687.871-.203-.107-.349-.041-.51-.068.43 1.38 3.004 3.513 3.859 2.184.099-.153-.019-.409.052-.57.038-.089.29-.143.348-.305.062-.169-.013-.809-.041-1.027-.068-.603-.447-.867-.675-1.321-.181-.357-.246-1.362-.796-1.24-.054-.137-.205-.283-.322-.372-.409.364-.352.763-.919-.004-.338-.459-.502-1.056-.709-1.561z")
                ]), M),
                A2(Da, l([
                    Fa("path157"),
                    Ha("#dcc06d"),
                    qa("M250.175 811.938c-.184.263-.521.29-.634.656-.063.204-.043.526.058.74.19-.109.367-.283.535-.387.126-.079.375-.324.54-.366.428-.106 1.29.689 1.499 1.08.023-.603.864.586.981.725.533.636 1.13 1.225 1.681 1.846-.079.178.04.438.106.634-.425-.212-.209.665.06.222.09.166.211.324.328.473-.054.035-.088.129-.141.16.322.257.755-.527.776-.783.028-.388-.234-.897-.38-1.268-.104-.27-.187-.636-.354-.875.155-.015.236-.157.245-.313.126.361.292.541.546.801-.656-.3.137.61.137.647-.034.011-.056.009-.086.021.02.144.131.259.267.322-.314.028-.104.28.073.393-.241-.154.036.485.058.522.079.139.269.52.463.404.136-.081.096-.673.055-.839.25.491-.017.803-.153 1.194-.03-.216-.019-.423-.232-.581-.272-.205-.625-.075-.611.231.004.086.123.185.119.262-.002.034-.092.25-.101.215-.126-.534-.479-.215-.32.007a.416.416 0 0 1-.209.144c-.082-.186-.257-.293-.412-.155-.111-.162-.305-.412-.478-.213-.096-.166-.4-.639-.62-.524-.239.124.284.359.177.548a.382.382 0 0 0 .38.131c.008.098.04.229.109.314.027.034.339.204.36.207.166.027.55.011.624-.106.052.107.094.082.184.173.175-.171.482-.245.555-.476.45.269-.23.31-.328.438-.034-.026-.06-.054-.094-.079-.092.077-.173.169-.263.244-.018-.032-.077-.089-.096-.134-.066.051-.164.056-.22.133-.156-.319-.353-.218-.548-.08-.147-.122-.175-.309-.318-.42-.145.189-.213.052-.307-.079-.063-.086-.049-.193-.106-.277-.061-.085-.126-.076-.192-.149-.267-.286-.544-.583-.644-.959.179 0 .435.182.591.091-.267-.308-.466-.654-.744-.962-.453-.492-.907-.974-1.359-1.465a3.35 3.35 0 0 0-1.666-.983c-.565-.133-1.06-.123-1.149-.843.267.32.699-.588.491-.756-.12.1-.227.215-.331.326.015-1.39 1.358-2.164 2.591-2.279-.17.138-.234.351-.443.43-.146.053-.424.056-.607.118-.549.181-1.066.363-1.088 1.037.42.049.915-.399 1.209-.656.211-.188.402-.351.725-.199-.096.318-.669.49-.925.66-.124.081-.326.182-.382.328-.023.054.01.34.018.329z")
                ]), M)
            ])),
            A2(On, l([
                Fa("g159")
            ]), l([
                A2(Da, l([
                    Fa("path161"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".259"),
                    qa("M234.204 800.51c1.778.035 2.15.485 2.582 2.262.384 1.558 1.146 3.086 1.93 4.336.305.488.687 1.244 1.13 1.566.374.273 1.076.049 1.378.302.619.529.721 2.469.73 3.354-.915.452-1.021 1.248-1.643 2.024-.581.727-1.338.736-1.88 1.45-.88-.349-1.65-.626-2.386-1.227.694-2.438-1.325-4.104-2.584-5.203-.641-.562-1.024-.784-1.854-.754-.922.032-1.365.352-1.89-.414-.866-1.256-.016-3.432.987-4.791.485-.661 1.609-1.272 2.25-1.854.738-.664 1.395-1.527 2.321-.69")
                ]), M),
                A2(Da, l([
                    Fa("path163"),
                    Ha("#dcc06d"),
                    qa("M240.893 811.458c-1.026.063-.597-1.413-.967-1.985-.411.336-.847.389-1.179.124.133.593-.052 1.302-.22 1.943-.225.062-.261-.103-.447-.139-.142-.027-.349.064-.47-.099-.209-.272.147-.982.193-1.321-.452.18-.595-.199-.878-.461-.561-.521-1.127-1.04-1.66-1.607a30.272 30.272 0 0 1-1.482-1.703c-.193-.232-.396-.636-.629-.776-.217.296-.469.55-.759.716-.247-.369-.54.886-1.079.756-.565-.138-.052-.954-.025-1.408.017-.276-.122-.226-.048-.587.018-.081.201-.484.261-.617.205-.452.576-1.126 1.007-.889.008-.035-.03-.075-.03-.11.027-.076.063-.01.054-.152-.506-.206-.907.874-1.512.965.134-.543.741-1.047.804-1.493-.493 1.045-1.408 1.749-1.783 2.884-.244.735-.45 1.396-.352 2.095.211 1.454 1.524.802 2.572.832 1.26.033 2.286.798 3.097 1.696.492.545 1.009 1.468 1.196 2.278.1.435-.299 1.865-.066 1.9.07-.3.322-.415.499-.226.118.128.011.613.13.801.149.238.926.743 1.239.714.637-.06 2.655-2.115 2.767-2.967-.246-.028-.67-.213-.94-.094-.425.19-.163.129-.259.493-.215.827-.346 1.312-1.188 1.445-.672.106-.563-.309-.28-1.064.123-.326.604-1.605-.105-1.093.191-.396 1.604-.774 1.78-.499.175-.205.399-.34.478-.214")
                ]), M),
                A2(Da, l([
                    Fa("path165"),
                    Ha("#dcc06d"),
                    qa("M235.268 801.147c-.144-.357-.507-.286-.836-.235.772.216-.127 1.857-.535 2.315.239.091.441.041.623-.222.131-.183.141-.675.22-.896.166-.468.433-.833.685-1.254")
                ]), M)
            ])),
            A2(On, l([
                Fa("g167")
            ]), l([
                A2(Da, l([
                    Fa("path169"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".211"),
                    qa("M244.898 816.612c.043-.122-1.103-1.405-1.198-1.712-.243-.782.249-1.369.245-2.189-.006-.42-1.009-1.327-1.111-.779.277-1.49-.828-.178-1.245.047-.335.179-1.557-.141-1.244.89-1.279.701-1.395 1.652-1.345 2.748.008.164-.261.44-.244.711.007.1.439.651.521.724.34.305.641.53 1.16.537.299-1.457 3.518.677 2.626 2.402.889.648 1.73 2.27 2.972.489 1.313-1.885.559-3.813-.604-4.669-.227.317-.416.469-.533.801z")
                ]), M),
                A2(Da, l([
                    Fa("path171"),
                    Ha("#dcc06d"),
                    qa("M245.152 816.508c-.117.52-.115.724.074 1.083.263-.191.762.332.702.661-.072-.008-.159.042-.191.044.128.563.571.714.247 1.456-.034-.117-.042-.48-.143-.532-.254-.132-.171.073-.343.23-.199.18-.624.615-.692.891-.153.685.627-.271.882-.021-.16.889-1.172.79-1.491.537-.26-.208-.429-.504-.636-.782-.247-.338-.123-.35-.146-.798-.051-1.11-1.938-3.433-3.05-2.029-.093-.185-.254-.343-.394-.464a3.493 3.493 0 0 1-.117.155c-.079-.172-.274-.148-.474-.065.231-.452.105-.747-.297-.725.508-.499.117-1.375.305-1.998.162-.049.299-.013.395.098-.438.701-.516 1.47-.104 1.853.151-.32.11-1.144.385-1.292-.028-.056-.034-.129-.046-.17.683.037.963-.405 1.444-1.09.312-.441.177-.41.271-.978-.177.673.418.25.578.619-.636.156-1.695 1.014-1.137 1.706.232.286.582-.04.881.059.247.079.487.421.629.644.423.673.662 1.587 1.109 2.272.337.515.486.949.736 1.513.166.375.68.423.917-.139.236-.551-.196-1.136-.356-1.497.315-.592-.811-.738-.027-1.376")
                ]), M),
                A2(Da, l([
                    Fa("path173"),
                    Ha("#dcc06d"),
                    qa("M243.402 813.509c.343-.366.134-.746-.217-.675-.002.29.261.523.374.608")
                ]), M)
            ])),
            A2(On, l([
                Fa("g175")
            ]), l([
                A2(Da, l([
                    Fa("path177"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".171"),
                    qa("M265.464 808.604c.032-.083-1.002-1.403-1.096-1.668-.234-.669.175-.973.146-1.604-.018-.322-.917-1.313-.989-.924.195-1.06-.728-.38-1.082-.332-.288.037-1.36-.567-1.056.314-1.095.158-1.164.851-1.088 1.706.013.127-.214.261-.189.473.008.078.403.629.474.707.305.334.576.597 1.027.755.216-1.026 3.082 1.557 2.357 2.615.795.76 1.578 2.25 2.604 1.254 1.082-1.057.368-2.756-.671-3.755-.186.178-.345.239-.437.459z")
                ]), M),
                A2(Da, l([
                    Fa("path179"),
                    Ha("#dcc06d"),
                    qa("M265.683 808.599c-.088.362-.079.521.098.851.222-.068.672.48.631.714-.065-.026-.138-.015-.166-.023.128.471.519.717.26 1.189-.034-.101-.051-.38-.14-.45-.227-.175-.147.006-.293.075-.166.079-.524.287-.574.478-.112.479.538-.021.766.245-.109.632-.993.258-1.281-.03-.232-.236-.388-.514-.578-.786-.224-.331-.117-.305-.149-.654-.078-.865-1.791-3.201-2.717-2.455a2.326 2.326 0 0 0-.358-.473c-.03.031-.064.057-.096.085-.075-.157-.243-.195-.414-.19.189-.277.068-.541-.28-.642.426-.232.058-1.019.203-1.441a.477.477 0 0 1 .346.189c-.358.411-.403.975-.031 1.39.121-.201.06-.843.294-.876-.025-.049-.034-.107-.045-.143.596.23.823-.026 1.225-.408.258-.245.141-.261.205-.669-.136.463.37.315.521.645-.548-.066-1.445.277-.936.971.211.289.503.142.768.305.218.136.435.468.565.681.39.639.624 1.41 1.036 2.067.309.493.452.872.687 1.377.155.334.604.523.796.163.188-.353-.207-.927-.358-1.251.259-.36-.728-.805-.065-1.063")
                ]), M),
                A2(Da, l([
                    Fa("path181"),
                    Ha("#dcc06d"),
                    qa("M264.066 805.783c.288-.179.094-.531-.209-.579.007.22.243.478.343.576")
                ]), M)
            ])),
            A2(On, l([
                Fa("g183")
            ]), l([
                A2(Da, l([
                    Fa("path185"),
                    Ha("#f3d48c"),
                    Ua("#967348"),
                    Ba(".269"),
                    qa("M268.079 804.587c-.332-.271-.446-.774-.579-1.151-.171-.488-.135-.696-.054-1.124.203-1.07-1.4-.713-1.793-.42-.375.28-.94 1.126-.759 1.759.105.378.443.3.703.405.322.131.612.517.862.778a4.2 4.2 0 0 1 .624.85c-.087.033-.213-.009-.313-.025.045.189.203.498.29.674.096.188.237.459.376.616.145-.016.294.248.445.343.197.123.47.182.663.144.382-.074.557-.371.702-.698-.052-.052-.047-.098-.076-.141.114.164.174-.325.17-.355-.019-.208-.146-.419-.218-.619-.075-.195-.276-.881-.559-.66.137-.164-.027-.4-.229-.489-.069-.035-.438-.036-.255.113z")
                ]), M),
                A2(Da, l([
                    Fa("path187"),
                    Ha("#dcc06d"),
                    qa("M266.458 803.731c.251.147.487.529.708.782.253.296.69.585.891.927.08.134.058.265.118.402.042.1.127.173.148.273-.157.031-.38.021-.303.298.079.271.297.195.444.157-.142.457-.41.11-.691 0-.088-.384-.356-.052-.356.149.094.09.177.019.248-.034a.4.4 0 0 1 .094.184c-.02.01-.038.039-.058.049.017.077.06.144.127.194.073-.021.086-.087.038-.172a.247.247 0 0 1 .146.219.177.177 0 0 1 .177-.087c-.012.024-.014.063-.029.09.156.201.306-.063.448-.078-.013.054-.029.14.009.207-.12.008-.216.093-.329.078-.115-.016-.173-.153-.31-.067-.113-.161-.296-.244-.362-.424-.177.092-.378-.37-.486-.553-.063-.104-.216-.351-.198-.468.024-.163.173-.037.267-.113-.072-.221-.26-.426-.411-.592-.194-.213-.401-.464-.604-.699-.191-.225-.386-.444-.65-.532-.202-.066-.4.042-.52-.21-.239-.507.1-1.096.322-1.414.1-.146.236-.321.397-.396.176-.082.493-.064.235.169-.094.086-.333.063-.386.185-.072.156.13.395-.084.47-.034-.051-.092-.107-.119-.169-.104.051-.04.208-.032.327.016.203-.006.197-.081.325-.078.135-.277.386-.123.58.17.015.431-.09.555-.196.196-.169.204-.438.29-.683-.012.033.096.375.115.431.068.2.173.286.355.391z")
                ]), M),
                A2(Da, l([
                    Fa("path189"),
                    Ha("#dcc06d"),
                    qa("M268.978 806.042c0 .067.002.14.008.207-.036-.096-.112-.147-.181-.099.033-.104.07-.29.036-.402-.051-.174-.173-.188-.301-.324-.128-.132-.115-.222-.173-.355-.068-.146-.188-.289-.26-.437.292-.086.328.512.437.645.101.125.275.148.352.267.067.106.1.479.09.589")
                ]), M),
                A2(Da, l([
                    Fa("path191"),
                    Ha("#dcc06d"),
                    qa("M268.935 806.934a.563.563 0 0 0 .051-.193c-.098-.035-.157-.131-.166-.235-.245-.036-.053.388.101.406")
                ]), M)
            ]))
        ])),
        A2(On, l([
            Fa("g287")
        ]), l([
            A2(Da, l([
                Fa("path289"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M134.296 803.23c-.492-.539-1.606-1.471-1.291-2.342.236-.648.98-1.343 1.605-1.724.382-.232.833-.274 1.202-.525.581-.395 1.124-1.006 1.667-1.467.786-.665 2.148-1.558 2.44-2.5.1-.315.187-.688.44-.961.137-.146.294-.24.481-.313.232-.09.432-.204.659-.276.341-.109.545.083.829.145.458.101.939.078 1.385.233.35.122.574.341.695.677.202.563-.033 1.185-.078 1.781-.046.63.227 1.206-.555 1.699-.417.262-.815.176-1.252.308-.866.256-1.69.953-2.547 1.311-1.497.624-2.164 1.524-3.019 2.75a.256.256 0 0 0-.089.087c.048.024.092.049.14.07-.265.251-.57.477-.831.729.034.024.064.005.1.028-.188.186-.349.117-.541.207-.178.082-.331.231-.512.298-.52.19-.686.05-.928-.215z")
            ]), M),
            A2(Da, l([
                Fa("path291"),
                Ha("#dcc06d"),
                qa("M134.281 800.242c.392-.164.131-.761.493-.87.45-.138-.093 1.086-.551.874")
            ]), M),
            A2(Da, l([
                Fa("path293"),
                Ha("#dcc06d"),
                qa("M133.289 801.595a.288.288 0 0 1-.059-.182c.242-.113.825-.08.992.087.144.145.063.376.252.519.112.087.474.081.52.173.102.205-.359.704-.247.989.192-.157 1.191-1.8 1.392-1.129.104-.271.446-.414.574-.666.077-.151.177-.158.015-.281-.086-.065-.147-.089-.284-.004.411-.443 1.095-.84 1.389-1.359.09-.156.031-.229.232-.43.353-.351.875-.673 1.292-.953.699-.471 1.57-.965 2.168-1.555.204-.198.26-.436.634-.355.206.045.251.265.478-.032a.995.995 0 0 0-.052.097c.174-.187.376-.241.586-.372.351-.218.617-.575.8-.911-.288.03-.953.262-1.097.52.532-.949.441-1.627-.204-2.271.334.256.901.198 1.209.508.202.204.315.496.303.803-.018.321-.07.667-.094 1.005-.043.619.258 1.236-.423 1.739.104-.305-.229-.268-.41-.055a.977.977 0 0 0 .281.12c-.188.167-.588.12-.835.191-.308.088-.552.234-.834.384-.353.184-.718.329-1.079.492-.465.212-.998.35-1.436.591-.921.504-1.643 1.345-2.235 2.148-.095.131-.293.294-.333.44-.047.185.144.152-.017.376-.086.118-.257.174-.392.284-.21.173-.371.417-.552.602-.262-.227-.509.151-.814.233-.391.103-.5-.046-.647-.291-.334-.561-.959-1.044-1.138-1.586")
            ]), M)
        ])),
        A2(On, l([
            Fa("g295")
        ]), l([
            A2(Da, l([
                Fa("path297"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M138.708 805.182c-.49-.539-1.605-1.471-1.29-2.342.236-.646.981-1.343 1.605-1.724.381-.231.834-.273 1.202-.523.58-.396 1.124-1.007 1.668-1.468.785-.665 2.146-1.559 2.44-2.501.098-.315.185-.687.44-.961.135-.146.293-.239.479-.313.234-.09.432-.205.661-.277.34-.108.543.085.827.146.459.101.939.076 1.386.231.349.122.573.342.696.678.201.562-.035 1.185-.078 1.781-.047.63.227 1.205-.556 1.698-.417.264-.814.177-1.252.308-.866.258-1.689.954-2.546 1.311-1.498.624-2.164 1.525-3.02 2.751a.232.232 0 0 0-.088.088c.048.022.093.047.141.07-.266.248-.571.476-.832.728.034.025.064.006.1.027-.188.187-.348.117-.541.207-.177.082-.33.231-.512.3-.522.192-.688.05-.93-.215z")
            ]), M),
            A2(Da, l([
                Fa("path299"),
                Ha("#dcc06d"),
                qa("M138.693 802.196c.393-.167.131-.763.493-.873.451-.137-.092 1.087-.55.875")
            ]), M),
            A2(Da, l([
                Fa("path301"),
                Ha("#dcc06d"),
                qa("M137.7 803.546a.292.292 0 0 1-.059-.182c.242-.113.826-.079.992.088.143.144.064.375.253.519.113.086.473.081.519.173.103.206-.359.704-.245.989.192-.157 1.189-1.801 1.39-1.128.104-.273.446-.415.574-.666.077-.152.178-.159.016-.282-.087-.066-.148-.089-.286-.004.411-.444 1.096-.84 1.391-1.36.088-.156.031-.229.231-.429.352-.35.875-.672 1.292-.953.699-.473 1.569-.965 2.168-1.554.204-.2.261-.438.634-.357.205.045.25.266.477-.032-.02.032-.036.064-.054.097.176-.188.378-.241.588-.37.352-.219.617-.577.801-.911-.29.028-.955.262-1.098.518.532-.948.441-1.625-.204-2.271.333.257.902.198 1.209.509.202.203.316.496.303.803-.017.322-.071.668-.094 1.004-.043.621.258 1.237-.422 1.741.103-.307-.23-.267-.411-.055a.977.977 0 0 0 .28.119c-.188.167-.587.119-.834.19-.307.089-.552.235-.835.384-.352.186-.716.329-1.077.492-.466.213-1 .35-1.438.592-.919.503-1.642 1.345-2.235 2.148-.094.13-.293.293-.332.44-.048.185.143.152-.018.375-.087.118-.259.174-.391.284-.211.173-.372.417-.553.604-.261-.229-.509.152-.813.232-.391.102-.501-.046-.648-.291-.334-.562-.96-1.045-1.138-1.585")
            ]), M)
        ])),
        A2(On, l([
            Fa("g303")
        ]), l([
            A2(Da, l([
                Fa("path305"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M143.747 803.645c.282-.394 1.055-.74 1.483-1.057.704-.517 1.187-1.244 1.707-1.919.549-.711 1.112-1.388 1.545-2.173.361-.655.604-1.323.804-2.038.143-.501.31-.879.863-1.087 1.514-.566 3.461.336 4.507 1.479.892.979 1.545 3.125.397 4.018-.327.256-.904.394-1.28.59a10.51 10.51 0 0 0-1.753 1.177c-.833.677-1.693 1.321-2.392 2.131-.489.568-.76.979-.863 1.69-.096.651-.095.876-.749 1.183-.496.232-.862.647-1.402.607-.767-.057-1.064-.565-1.585-1.061-.411-.392-.926-.566-1.352-.906-.827-.661-.421-1.95.07-2.634z")
            ]), M),
            A2(Da, l([
                Fa("path307"),
                Ha("#dcc06d"),
                qa("M145.814 806.949c.12.146.283.468.032.547.076.096.167.217.146.328-.474-.274-.649-.577-.969-.983-.193-.246-1.013-.386-1.068-.605-.012-.052.841.087.905.105.363.109.718.32.954.608z")
            ]), M),
            A2(Da, l([
                Fa("path309"),
                Ha("#dcc06d"),
                qa("M145.041 804.154c-.217-.312.094-.214.177-.427.083-.208-.209-.342-.122-.555.319.063 1.142 1.023.651 1.126-.205.042-.167-.152-.256-.183-.158-.052-.337.112-.45.039")
            ]), M),
            A2(Da, l([
                Fa("path311"),
                Ha("#dcc06d"),
                qa("M145.419 804.924c.008-.058.037-.091.087-.103.267.204.159.615.383.863a.196.196 0 0 1 .06-.015c-.097.11-.106.285-.221.374-.228-.243-.473-.967-.296-1.231")
            ]), M),
            A2(Da, l([
                Fa("path313"),
                Ha("#dcc06d"),
                qa("M146.448 807.103c-.078-.087-.138-.21-.123-.31.013-.092.582.649.608.668.107-.316.263-.599.537-.847-.012.064.03.146.027.207.335.011.791-.403.788-.729-.003-.187-.251-.563-.478-.463-.018-.002-.019-.003-.002-.005.546.218-.483.704-.484.076-.078.257-.235.142-.36-.019-.215-.277-.048-.461.093-.732-.15.159-.328.298-.458.471-.114.149-.147.45-.303.52-.305-.401.204-1.277.649-1.411-.045-.155.028-.306.125-.425-.138-.069-.182-.228-.164-.358.406.021.452-.246.598-.533.183-.359.343-.56.736-.69.755-.251 1.318-1.143 1.872-1.668.339.183.65-.2.799-.401.328-.446.695-.936 1.107-1.318.083.159.22.143.314.009.092-.133-.019-.283-.016-.429.008-.203.017-.15.137-.302.127-.161.459-.614.634-.659-.077.271-.165.773.042 1.028.246.299.371-.085.546-.285.13-.149.368-.262.469-.396.18-.233-.088-.496-.299-.652-.082-.063-.206-.083-.274-.148-.127-.121-.04-.03-.085-.163-.018-.056.012-.172-.022-.266a1.043 1.043 0 0 0-.204-.285c-.271-.299-.648-.304-.968-.49-.164-.095-.193-.248-.331-.352.477.187 1.026.126 1.483.377.563.31 1.011.833 1.345 1.345.387.598.514 1.138.544 1.803.012.246.138.678-.005.89-.054-.113-.121-.227-.178-.334-.174 0-.3.205-.3.354.002.053.119.099.12.184.001.03-.118.155-.138.176-.078.087.014.075-.125.139-.105.049-.286.04-.415.095-.438.185-.769.467-1.156.72-.784.509-1.492 1.11-2.215 1.682-.475.374-.903.764-1.348 1.169-.344.314-.607.545-.744.988a6.921 6.921 0 0 0-.197.843c-.035.199-.02.514-.12.69-.072.126-.782.44-.38.549-.324.228-.877.168-1.193.43-.009-.104.007-.236.083-.323-.111.103-.253.101-.343.247-.184-.146-.234-.457-.228-.667")
            ]), M)
        ])),
        A2(On, l([
            Fa("g315")
        ]), l([
            A2(Da, l([
                Fa("path317"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M142.663 806.09c.545-.243 1.056-.609 1.557-.556.844.089.707.928.95 1.559.181.473.754.437.754 1.178-.001.644-.353 1.266-.938 1.467-.177.061-.353.011-.581.104-.148.06-.484.247-.658.36-.623.41-1.229 1.274-1.655 1.903-.103.152-.539.666-.401.834.216.271.51-.349.746-.295.55.129-.657 1.666-.892 1.873-.142.126-.361.242-.522.356-.066.047-.206.041-.249.076-.097.085-.137.251-.224.323-.292.252-.55.516-.911.521-.318.005-1.555-.4-1.054-.965-.676-.041-.301-1.009-.268-1.448.026-.325-.272-.916.417-1.01-.047-.42.255-1.088.669-1.384.812-.577.119.387.352.636.854-1.044 1.361-2.35 1.65-3.551.127-.532-.171-1.053.022-1.601.143-.4.059-.23.304-.381-.109.066.553-.135.477-.128.243-.019.341-.183.455.129z")
            ]), M),
            A2(Da, l([
                Fa("path319"),
                Ha("#dcc06d"),
                qa("M141.434 806.708c.132.327.21-.008.282-.124.144-.229.242-.333.51-.336.363-.007.337.384 0 .663.025.101.027.222.076.303.208-.28.078-.564.344-.811.369-.343.794-.021.915.266.156-.468 1.437.354.93.777.111.052.24.025.348.004-.115.174-.32.222-.451.396-.041-.021-.101-.004-.138-.029-.152.191-.22.393-.425.543.021.033.07.057.109.067.12-.101.189-.248.331-.299-.015.046-.004.128-.051.207.064.005.161.044.168.12.014.176-.085.115-.169.253-.152.253-.173.375-.171.643a.835.835 0 0 1 .338-.454c.009.111-.009.258.029.357l.049-.05a.626.626 0 0 1-.211.35c.306-.188.367-.406.526-.747-.12.068-.361.247-.4.083-.036-.152.243-.357.318-.49-.158-.077-.402.14-.343-.224.046-.29.4-.538.613-.438.287.135.253.867.186 1.198-.045.214-.235.516-.075.65.123-.085.276-.321.361-.445.167-.242.301-.495.307-.764a1.16 1.16 0 0 0-.424-.933c-.103-.077-.32-.058-.389-.157-.055-.077.018-.362-.001-.472-.051-.289-.207-.682-.419-.843-.263-.201-.571-.187-.939-.089-.273.071-.66.243-.917.264-.124.009-.163-.094-.272-.102-.13-.01-.238.062-.377.108-.278.094-.619.201-.515.569.026-.037.036-.024.062-.032")
            ]), M),
            A2(Da, l([
                Fa("path321"),
                Ha("#dcc06d"),
                qa("M143.028 809.507c.247.081.512-.007.731-.266.058.055.124.488.076.615-.079.218-.505.369-.712.527-.342.265-.541.566-.815.914-.308.39-.653.82-.822 1.279-.115.312-.006.573.317.492.239-.059.7-.599.662-.134-.056.658-1.067 1.582-1.602 1.816.426-.465.222-1.003-.329-.621-.334.233-.026.126-.169.367-.101.17-.224.055-.276-.03-.226.299-.342.467-.218.771.061.144.239.471-.148.354.028-.343.052-.688.069-1.023.007-.13.088-.817-.161-.586-.13-.325-.662.612-.757.776-.161-.243.06-.608.013-.899-.056-.344-.204-.686-.097-1.098.084.105.047.333.144.427.147-.151.132-.339.229-.496.095-.155.249-.211.325-.394.093-.22-.042-.326-.042-.516.002-.183.125-.377.148-.556-.154.96.583-.032.824-.375-.156.383-.588.933-.634 1.288-.035.262.139.21-.152.456-.202.171-.428.273-.346.563.049.174.107.137.298.104a.718.718 0 0 1-.139.374c-.076-.227-.259-.22-.36.039-.128.329-.049.612.236.372.081-.066.091-.177.188-.218.083-.037.195.042.272.043.207.002.247-.043.421-.263.203-.249.431-.493.509-.795.03-.117-.002-.295.056-.406.072-.141.282-.326.387-.447a21.17 21.17 0 0 0 1.313-1.589c.169-.231.626-.592.537-.884")
            ]), M)
        ])),
        A2(On, l([
            Fa("g323")
        ]), l([
            A2(Da, l([
                Fa("path325"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M156.719 805.607c1.129-.934 2.55-1.701 3.614-2.629 1.203-1.045 1.052-1.726.881-3.238-.292-2.582-3.244-2.886-5.235-3.701-.474.398-1.053.469-1.442.882-.591.629-.772 2.048-1.068 2.841-.771 2.063-1.595 3.827-3.508 4.913-.855.481-2.832 2.388-2.554 3.436.224.839 1.479 1.015 2.102 1.416.657.424 1.38 1.825 2.098 2.005.773.192 1.775-.854 2.105-1.389.417-.683.331-1.565.803-2.219.31-.433.809-.813 1.152-1.256a6.713 6.713 0 0 1 1.052-1.061z")
            ]), M),
            A2(Da, l([
                Fa("path327"),
                Ha("#dcc06d"),
                qa("M147.996 808.436c.481-.497 1.973-.632 2.457.061-.611.161-.908.153-.386.718.355.381 1.137 1.167.972 1.698-.405-.301-.667-.807-1.047-1.15a4.85 4.85 0 0 0-1.04-.688c-.393-.204-1.129-.424-1.337-.865-.174-.373.258-1.061.51-1.309.406-.403.597-.927 1.04-1.325-.208.408-.265.862-.604 1.2-.193.189-.43.272-.587.513-.211.322-.287 1.506.317.881")
            ]), M),
            A2(Da, l([
                Fa("path329"),
                Ha("#dcc06d"),
                qa("M149.805 807.155c-.134-.097-.289-.179-.411-.27.281-.1.206-.229.303-.406.117-.214.278-.488.478-.675-.156.443-.249.923-.447 1.346")
            ]), M),
            A2(Da, l([
                Fa("path331"),
                Ha("#dcc06d"),
                qa("M161.06 801.25c-.056.521-.18.938-.573 1.29-.566.509-1.306.841-1.885 1.365-1.572 1.427-4.156 2.649-4.663 4.862-.147.633-.565 1.382-1.074 1.788-.242.192-.603.59-.923.622-.091-.723.05-1.88-.82-2.276.152-.813 1.361.707 1.126 1.121.305-.539 1.341-.631 1.447-1.285.036-.203-.067-.414-.315-.45-.493-.069-.612.548-.667.875-.178-.32-.206-1.572.321-1.556-.098-1.429.625-2.245 1.686-3.063.468-.36.683-1.046.998-1.536.371-.57.699-1.155 1.08-1.69-.032.375.138.376.448.377.06.001.187-.102.278-.104.354-.018.592.321 1.003.167.407-.151 1.295-1.4.353-1.483.271-.271-.034-.66-.396-.299.021-.065.175-.384.32-.369.197.021.22.374.296.549.11.253.355.802.673.896.469.138.538-.304.298-.63-.183-.253-.494-.399-.714-.637.214-.258.06-.641-.193-.858-.347-.297-.709-.158-1.064-.227.285.053.61-.258.868-.323.256-.063.838.028.73-.41.022-.035.084-.119.108-.158.41.246.742.922.985 1.324.414.686.345 1.391.269 2.118z")
            ]), M),
            A2(Da, l([
                Fa("path333"),
                Ha("#dcc06d"),
                qa("M153.877 799.36c.124-.4.201-.914.486-1.221-.031.285-.251.945-.491 1.01")
            ]), M)
        ])),
        A2(On, l([
            Fa("g335")
        ]), l([
            A2(Da, l([
                Fa("path337"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M146.428 811.609c.129-.355.318-.785.371-1.141.035-.243-.121-.566-.044-.794.154-.456.782-.504 1.291-.63.531-.133 1.057-.088 1.559.044a2.222 2.222 0 0 1 1.627 1.736c.105.524.414.997-.225 1.409-.567.362-1.308.507-1.909.939-.61.438-1.001 1.047-1.503 1.589-.25.271-.59.51-.634.853.195-.109.344-.057.504-.089-.351 1.317-2.795 3.458-3.724 2.255-.107-.137-.006-.384-.085-.533-.043-.079-.295-.117-.362-.267-.072-.155-.034-.759-.02-.967.033-.569.398-.839.599-1.277.158-.345.166-1.289.723-1.206.045-.133.188-.278.3-.366.43.321.396.697.916-.053.308-.445.438-1.015.616-1.502z")
            ]), M),
            A2(Da, l([
                Fa("path339"),
                Ha("#dcc06d"),
                qa("M150.042 810.88c.2.237.536.245.67.582a1.02 1.02 0 0 1-.015.697c-.195-.092-.38-.245-.556-.333-.13-.068-.394-.284-.559-.315-.435-.078-1.248.717-1.434 1.094-.059-.563-.827.596-.937.734-.495.624-1.057 1.21-1.568 1.821.087.164-.016.414-.072.603.413-.223.248.611-.045.211a3.377 3.377 0 0 1-.301.461c.054.03.094.116.149.144-.307.257-.784-.454-.818-.696-.052-.361.182-.853.305-1.209.088-.26.151-.606.303-.839-.156-.007-.246-.136-.262-.283-.106.346-.26.524-.5.782.64-.317-.1.581-.097.614.033.009.055.007.084.016-.011.135-.114.25-.246.316.314.01.118.257-.051.373.23-.157-.009.457-.028.493-.071.134-.238.501-.438.404-.141-.068-.133-.627-.101-.784-.223.474.062.753.218 1.111.018-.203-.003-.396.2-.557.26-.208.62-.104.623.185.001.08-.111.18-.104.253.004.031.106.229.112.196.096-.509.466-.228.319-.012a.414.414 0 0 0 .218.124c.072-.179.24-.29.401-.168.104-.158.281-.403.463-.226.087-.161.364-.621.591-.525.244.104-.261.354-.145.523a.393.393 0 0 1-.371.144.566.566 0 0 1-.091.301c-.025.033-.327.21-.347.213-.164.034-.549.039-.629-.065-.043.103-.089.081-.173.172-.185-.151-.497-.204-.581-.417-.433.275.249.278.354.394l.087-.079c.097.067.182.149.278.217.014-.032.07-.09.086-.132.068.044.167.044.228.115.138-.311.338-.227.542-.107.14-.121.155-.299.292-.41.155.169.216.037.302-.093.056-.084.037-.184.09-.265.054-.082.121-.077.184-.15.247-.283.508-.576.585-.937-.177.012-.423.195-.583.117.248-.302.425-.639.688-.941.421-.487.846-.963 1.271-1.448.426-.488 1-.844 1.603-1.013.556-.154 1.05-.173 1.098-.853-.248.313-.732-.515-.532-.684.124.087.236.189.35.287-.098-1.302-1.481-1.957-2.717-2 .179.12.254.317.468.379.147.043.426.03.615.078.555.143 1.082.284 1.142.917-.416.068-.935-.326-1.241-.553-.223-.163-.423-.307-.736-.146.113.293.695.425.96.57.128.069.335.153.4.288.026.051.009.322-.001.311z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g341")
        ]), l([
            A2(Da, l([
                Fa("path343"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".251"),
                qa("M165.313 799.296c-1.769.127-2.116.571-2.444 2.261-.291 1.482-.964 2.958-1.674 4.175-.276.475-.614 1.205-1.038 1.53-.358.277-1.069.104-1.356.357-.587.53-.578 2.355-.536 3.188.938.376 1.089 1.118 1.754 1.813.62.65 1.375.619 1.957 1.259.857-.373 1.611-.675 2.309-1.278-.833-2.251 1.087-3.926 2.278-5.023.609-.563.978-.792 1.807-.806.92-.02 1.381.255 1.861-.491.791-1.226-.182-3.223-1.259-4.445-.522-.594-1.678-1.108-2.352-1.619-.772-.586-1.477-1.358-2.352-.524")
            ]), M),
            A2(Da, l([
                Fa("path345"),
                Ha("#dcc06d"),
                qa("M159.272 809.934c1.024.003.514-1.359.849-1.917.43.294.866.32 1.183.054-.097.563.127 1.22.331 1.813.227.044.254-.111.438-.153.139-.034.351.04.463-.12.192-.267-.203-.915-.269-1.229.46.146.581-.219.849-.48.529-.518 1.064-1.036 1.563-1.597.48-.532.937-1.108 1.379-1.679.179-.229.358-.617.584-.763.232.267.498.491.797.632.224-.36.589.803 1.12.651.554-.16-.005-.899-.055-1.324-.034-.257.107-.217.014-.554-.022-.074-.229-.442-.295-.565-.23-.414-.639-1.026-1.055-.779-.01-.032.024-.072.022-.104-.032-.069-.065-.007-.063-.14.494-.221.957.771 1.565.823-.167-.503-.801-.943-.888-1.359.552.957 1.503 1.568 1.943 2.612.285.68.529 1.286.472 1.946-.128 1.378-1.475.835-2.518.922-1.254.099-2.232.87-2.99 1.758-.458.537-.922 1.432-1.063 2.202-.074.415.406 1.736.176 1.782-.087-.278-.344-.374-.512-.187-.108.127.026.575-.082.759-.135.231-.881.749-1.196.737-.636-.023-2.77-1.843-2.928-2.638.243-.04.656-.234.932-.138.434.156.169.112.286.45.262.764.42 1.212 1.268 1.291.676.064.544-.319.219-1.014-.141-.299-.695-1.475.043-1.032-.215-.36-1.645-.641-1.804-.372-.188-.184-.418-.299-.49-.177")
            ]), M),
            A2(Da, l([
                Fa("path347"),
                Ha("#dcc06d"),
                qa("M164.289 799.951c.123-.344.49-.298.819-.266-.757.243.234 1.736.668 2.145-.236.098-.44.063-.635-.174-.139-.166-.179-.627-.271-.83-.192-.431-.48-.76-.754-1.142")
            ]), M)
        ])),
        A2(On, l([
            Fa("g349")
        ]), l([
            A2(Da, l([
                Fa("path351"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".204"),
                qa("M155.573 814.985c-.05-.112 1.019-1.378 1.096-1.671.198-.748-.328-1.271-.368-2.042-.021-.395.929-1.301 1.063-.792-.364-1.384.815-.21 1.243-.023.345.151 1.544-.214 1.291.77 1.317.589 1.487 1.476 1.5 2.508.001.154.284.4.283.653-.001.096-.402.636-.477.707-.321.305-.61.534-1.127.567-.38-1.351-3.468.823-2.479 2.396-.849.657-1.596 2.224-2.935.62-1.417-1.699-.776-3.551.335-4.417.244.287.441.42.575.724z")
            ]), M),
            A2(Da, l([
                Fa("path353"),
                Ha("#dcc06d"),
                qa("M155.313 814.902c.148.479.157.672-.011 1.019-.271-.163-.741.354-.663.661.073-.013.162.029.194.029-.093.536-.527.7-.162 1.38.027-.111.014-.453.112-.507.246-.136.176.06.355.198.208.157.657.543.74.799.193.635-.641-.221-.878.028.209.824 1.212.679 1.516.423.249-.209.398-.497.589-.769.228-.329.103-.335.099-.757-.012-1.044 1.736-3.326 2.924-2.068a1.55 1.55 0 0 1 .368-.457c.039.049.083.093.125.139.069-.164.265-.153.469-.086-.259-.412-.148-.696.253-.696-.534-.441-.194-1.284-.418-1.859-.163-.037-.297.005-.386.111.476.638.597 1.355.208 1.735-.168-.293-.174-1.066-.455-1.192.023-.054.026-.122.036-.163-.679.073-.982-.327-1.504-.944-.336-.397-.2-.376-.326-.903.217.622-.402.258-.541.612.643.113 1.75.862 1.231 1.539-.215.283-.581-.005-.875.104-.242.088-.46.421-.589.639-.383.653-.568 1.524-.976 2.192-.307.501-.431.918-.647 1.46-.144.359-.654.433-.923-.082-.268-.505.131-1.075.27-1.424-.348-.537.768-.736-.05-1.294")
            ]), M),
            A2(Da, l([
                Fa("path355"),
                Ha("#dcc06d"),
                qa("M156.888 811.991c-.364-.325-.177-.692.175-.645.021.271-.229.505-.336.593")
            ]), M)
        ])),
        A2(On, l([
            Fa("g357")
        ]), l([
            A2(Da, l([
                Fa("path359"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".166"),
                qa("M134.607 808.57c-.039-.075.919-1.37.996-1.623.196-.642-.229-.904-.236-1.498-.002-.304.84-1.283.934-.921-.257-.985.702-.396 1.059-.37.289.021 1.325-.605 1.071.237 1.099.091 1.21.738 1.181 1.546-.004.119.229.231.218.432-.004.074-.367.613-.433.69-.284.329-.539.591-.98.763-.273-.951-2.983 1.627-2.201 2.582-.748.756-1.443 2.196-2.522 1.316-1.142-.934-.528-2.567.451-3.561.197.157.358.206.462.407z")
            ]), M),
            A2(Da, l([
                Fa("path361"),
                Ha("#dcc06d"),
                qa("M134.389 808.577c.107.335.109.484-.048.803-.225-.051-.643.487-.589.706.063-.029.137-.022.165-.031-.101.448-.477.699-.191 1.129.028-.095.03-.359.114-.431.215-.175.148-.002.295.056.171.066.538.242.6.418.141.442-.538.01-.75.271.147.589 1.006.189 1.276-.097.219-.235.356-.502.53-.77.206-.323.101-.292.112-.622.029-.815 1.604-3.102 2.568-2.45.079-.163.214-.33.33-.462.033.027.068.048.101.072.066-.148.231-.194.403-.2-.205-.25-.101-.503.241-.616-.438-.196-.117-.953-.285-1.343a.488.488 0 0 0-.334.198c.382.365.458.893.112 1.302-.132-.183-.108-.788-.343-.806.022-.05.027-.105.037-.139-.581.248-.823.021-1.245-.316-.271-.218-.156-.238-.243-.617.16.428-.352.316-.484.635.542-.093 1.458.181.99.859-.194.283-.495.16-.749.327-.208.14-.408.462-.525.67-.351.621-.541 1.355-.915 1.996-.28.479-.402.843-.604 1.329-.137.322-.573.524-.784.196-.209-.32.151-.882.284-1.194-.276-.324.68-.795.006-1")
            ]), M),
            A2(Da, l([
                Fa("path363"),
                Ha("#dcc06d"),
                qa("M135.84 805.848c-.297-.152-.125-.493.174-.555.007.207-.216.46-.31.559")
            ]), M)
        ])),
        A2(On, l([
            Fa("g365")
        ]), l([
            A2(Da, l([
                Fa("path367"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M131.771 804.94c.314-.274.398-.753.509-1.113.142-.467.095-.659-.01-1.059-.263-.993 1.355-.743 1.764-.489.393.242 1.002 1.007.859 1.609-.085.361-.426.305-.678.418-.314.142-.581.52-.814.778a4.007 4.007 0 0 0-.576.831c.09.026.214-.021.312-.041-.033.182-.172.479-.252.647-.083.181-.208.444-.337.6-.146-.007-.279.249-.425.345a1.042 1.042 0 0 1-.654.171c-.384-.05-.576-.319-.738-.619.047-.05.04-.093.067-.136-.104.161-.192-.296-.191-.325.008-.195.121-.4.183-.593.062-.186.225-.841.518-.649-.146-.145.005-.375.199-.47.069-.034.435-.054.264.095z")
            ]), M),
            A2(Da, l([
                Fa("path369"),
                Ha("#dcc06d"),
                qa("M133.339 804.05c-.243.151-.459.521-.662.771-.237.293-.656.586-.836.917-.07.13-.042.251-.094.387-.037.095-.116.169-.134.262.161.021.381.003.319.265-.063.258-.284.198-.433.17.168.424.417.083.69-.035.063-.366.351-.067.361.121-.086.089-.175.025-.247-.019a.333.333 0 0 0-.083.177c.02.009.04.035.062.043a.317.317 0 0 1-.117.188c-.075-.014-.091-.075-.049-.156a.225.225 0 0 0-.132.212c-.04-.059-.104-.083-.181-.072.015.021.018.059.035.083-.143.196-.307-.044-.45-.05.015.051.036.13.001.195.12.001.221.075.334.055.114-.02.164-.153.305-.078.103-.157.28-.247.336-.418.182.076.355-.368.453-.546.055-.101.195-.34.172-.449-.034-.151-.175-.025-.273-.093.059-.211.235-.413.375-.577.182-.211.375-.456.563-.688.178-.221.361-.438.619-.534.197-.074.402.019.505-.226.21-.489-.163-1.023-.401-1.31-.108-.131-.254-.289-.42-.352-.179-.067-.495-.034-.224.172.097.074.335.041.396.151.08.144-.107.378.109.438.03-.052.084-.107.11-.167.106.043.052.194.05.307-.003.19.017.185.099.301.087.122.298.348.158.538-.17.022-.436-.061-.566-.155-.204-.148-.228-.399-.329-.624.014.029-.072.356-.088.41-.06.191-.159.276-.333.386z")
            ]), M),
            A2(Da, l([
                Fa("path371"),
                Ha("#dcc06d"),
                qa("M130.956 806.354c.005.063.006.131.004.195.032-.093.104-.146.176-.104-.041-.096-.087-.268-.06-.373.042-.168.16-.188.281-.322.12-.13.102-.213.152-.342.059-.142.17-.281.235-.424-.297-.065-.299.497-.4.63-.094.121-.267.153-.335.269-.063.102-.071.455-.058.556")
            ]), M),
            A2(Da, l([
                Fa("path373"),
                Ha("#dcc06d"),
                qa("M131.05 807.188a.49.49 0 0 1-.062-.179.244.244 0 0 0 .152-.23c.244-.047.077.361-.077.387")
            ]), M)
        ]))
    ]), ir = l([
        A2(On, l([
            Fa("RadiusLeft")
        ]), l([
            A2(Da, l([
                Fa("path1689"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M342.383 407.233c.311.63.812 1.191 1.597 1.648 2.606 1.512 5.394-.22 7.979-.831 2.945-.696 6.781.573 8.377-2.508 1.48-2.858.146-6.236-1.407-8.759-2.099-3.416-3.528-7.085-4.615-10.948-1.205-4.283-2.169-8.623-3.487-12.926-.614-2.008-1.344-3.993-2.005-5.962-1.137-3.393-1.696-6.788-3.12-10.061-1.664-3.815-2.994-7.762-4.737-11.549-3.313-7.202-7.346-14.216-10.286-21.56-1.765-4.404-1.978-9.238-1.786-13.93.071-1.684 1.225-4.472-.136-5.854-1.54-1.562-3.66-.896-5.253.021-1.562.899-3.41.435-5.002 1.437-1.612 1.019-2.099 2.796-.914 4.345.497.65 1.303.993 1.748 1.717.593.958.571 2.096.71 3.177.305 2.378.23 4.804.267 7.255.044 2.9 1.154 3.788 2.354 6.169 3.115 6.188 4.178 13.195 7.368 19.388 3.736 7.255 7.279 14.63 9.109 22.629.834 3.646 2.412 6.879 2.822 10.629.505 4.605.072 9.248.072 13.864-.003 2.322 0 4.645 0 6.968 0 1.922-.458 4.012.345 5.641z")
            ]), M),
            A2(Da, l([
                Fa("path1691"),
                Ha("#dcc06d"),
                qa("M328.424 306.613c-1.088 3.373-.945 6.396-.396 10.012.583 3.798 2.956 7.616 3.234 11.335-2.481-3.023-4.287-5.104-4.22-8.823.056-2.891.834-7.825-.357-10.343-1.368.322-2.075 1.324-3.251 1.432-1.269.119-2.057-1.194-3.604-.536.809-1.24 1.497-.825 2.559-1.371.041-.02 6.517-3.203 6.035-1.706z")
            ]), M),
            A2(Da, l([
                Fa("path1693"),
                Ha("#dcc06d"),
                qa("M331.327 337.365c4.007 3.569 6.065 13.107 7.431 18.219a54.502 54.502 0 0 1 1.865 14.214c-.031-3.953-2.055-7.753-2.484-11.675-.281-2.569-1.101-5.121-1.896-7.599-1.297-4.039-1.58-9.817-4.202-13.159")
            ]), M),
            A2(Da, l([
                Fa("path1695"),
                Ha("#dcc06d"),
                qa("M353.141 393.865c1.725 2.22 4.046 6.802 1.552 9.047.304.155.566.196.898.313-.081.488.144 1.173.106 1.67 8.284 1.351-1.352-14.843-2.211-17.002-.09.246-.254.705-.329.939-5.127-3.812-2.988-15.732-6.49-21.33 1.229 5.444 2.941 11.071 4.247 16.626.793 3.37 1.42 7.505 3.299 10.451")
            ]), M)
        ])),
        A2(On, l([
            Fa("RadiusRight")
        ]), l([
            A2(Da, l([
                Fa("path1779"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M67.924 311c.842.966 2.541.996 3.244 2.047.864 1.288.334 3.732.499 5.302.162 1.564.417 3.311 1.142 4.728 1.013 1.975 2.588 2.037 3.848 3.499 2.703 3.14 3.985 10.283 4.666 14.294 1.137 6.715 1.161 13.222 1.597 20.069.207 3.263-.134 6.491-.074 9.768.098 5.384-1.009 10.54-.98 15.893.026 4.669.113 9.46-2.044 13.741-1.101 2.185-6.014 6.593-2.289 8.82-3.062 3.197 2.857 9.243 5.236 4.429-.136.275 3.615 3.494 4.921-.388.576-1.716-.057-3.165-.019-4.907 1.077 2.023.378 3.58.523 5.616.083 1.169-.692 1.018.687 1.867.597.369 1.372.535 2.02.209 2.626-1.319.598-6.47.715-8.618.254-4.692-1.081-9.382-.896-14.179.223-5.815.729-11.628.778-17.448.054-6.305.917-12.672.074-18.922-.408-3.035-1.196-5.619-1.376-8.693a50.21 50.21 0 0 0-1.443-9.314c-1.144-4.529-2.356-8.818-4.407-12.936-1.188-2.386-1.376-5.132-2.524-7.529-1.435-2.997-3.104-4.857-3.342-8.446-.14-2.101.658-3.825-1.7-4.912-2.952-1.358-12.479 1.863-8.856 6.01z")
            ]), M),
            A2(Da, l([
                Fa("path1781"),
                Ha("#dcc06d"),
                qa("M78.202 308.404c-.516 1.375-2.323 1.899-3.661 2.083-.709.099-4.437.348-4.909-.027.188.15 1.252.955 1.487.802-.116.076-.364.187-.482.267 2.023 1.491 3.682 3.451 4.064 6.153.186 1.317.237 2.81.477 4.096.253 1.366.62 2.279 1.34 3.883.475-3.795-1.039-7.767-.745-11.719.034-.447-.217-1.459.055-1.824.433-.579 1.197.021 1.561-.377.854-.937.843-1.925.813-3.337z")
            ]), M),
            A2(Da, l([
                Fa("path1783"),
                Ha("#dcc06d"),
                qa("M84.028 407.563c-.937 1.296-3.804 3.621-3.629 5.384.204 2.046 1.807.198 2.353-.579.925-1.319.605-3.877 1.276-4.805z")
            ]), M),
            A2(Da, l([
                Fa("path1785"),
                Ha("#dcc06d"),
                qa("M88.111 413.978c1.152-3.106-.055-6.859-1.013-9.929-.793-2.542-1.106-4.769-1.387-7.504-.368-3.574-1.496-6.926-1.355-10.681.122-3.224 1.369-6.677 1.073-9.888 0 5.132-.931 11.168.863 15.982.241-.227.805-.347.968-.474.175 2.316 1.362 3.945 1.91 5.906.678 2.428.767 5.021 1.08 7.469.316 2.466 2.42 9.275-1.563 9.346-.162-.719-.085-1.489.229-2.104")
            ]), M),
            A2(Da, l([
                Fa("path1787"),
                Ha("#dcc06d"),
                qa("M78.456 327.887c.538 2.109 2.265 4.052 2.957 6.161.622 1.896 1.068 3.997 1.669 5.961 1.049 3.429 2.527 7.603 2.406 11.19.694-1.717-2.317-4.258-2.472-1.816-1.039-6.609-1.339-13.892-4.023-20.154")
            ]), M),
            A2(Da, l([
                Fa("path1789"),
                Ha("#ccb25c"),
                qa("M69.605 309.918c.99 2.092 3.137.771 4.782 1.119l.091.445c.271-.022.713.019.987.086 0 .708.177 1.411.51 2.031.095-2.623 1.407-1.573 2.233 0-.043-1.443-.199-3.094-.61-4.458-1.509 1.415-6.045 1.547-7.993.777")
            ]), M),
            A2(Da, l([
                Fa("path1791"),
                Ha("#ccb25c"),
                qa("M90.046 408.675c.485 2.814-1.039 7.791-1.485 2.513-.175-2.066-.664-3.928-1.456-5.852-1.148-2.789-.872-5.946-.872-8.977-.284 4.68 3.077 8.028 3.813 12.316z")
            ]), M),
            A2(Da, l([
                Fa("path1793"),
                Ha("#ccb25c"),
                qa("M80.065 413.441c-.351.673-.323 1.254.047 1.837 1.016-.185 2.555-1.539 2.883-2.621-1.331.548-2.109 1.92-3.734 1.052")
            ]), M),
            A2(Da, l([
                Fa("path1795"),
                Ha("#ccb25c"),
                qa("M79.528 330.569c.927 1.817 1.115 3.869 1.395 5.815.161-.16.274-.318.416-.431 1.766 3.412 2.457 6.721 3.271 10.372.646 2.903.018 6.945 1.028 9.433.11-5.063-.203-9.345-1.608-14.193-.79-2.721-1.688-8.529-3.965-10.191")
            ]), M),
            A2(Da, l([
                Fa("path1797"),
                Ha("#ccb25c"),
                qa("M77.115 405.665c-1.852 2.453.697 3.746 2.058.624-.697.381-1.565.636-2.327.18")
            ]), M)
        ]))
    ]), hr = l([
        A2(On, l([
            Fa("g847")
        ]), l([
            A2(On, l([
                Fa("g855")
            ]), l([
                A2(Da, l([
                    Fa("path857"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".335"),
                    qa("M180.092 279.628c-1.067.865-2.216 1.614-3.483 2.149-1.728.729-2.756 1.49-4.376 2.437-2.402 1.403-5.432 1.822-8.116 2.58-3.863 1.09-7.91 2.438-11.438 4.285-2.422 1.269-4.503 2.927-6.5 4.695-.855.758-3.46 3.733-4.921 3.05-3.764-1.761 3.173-7.266 4.586-8.441 3.715-3.092 8.012-5.52 12.351-7.748 2.404-1.236 5.136-1.754 7.765-2.411 8.085-2.022 13.996-8.535 20.594-12.919 1.271-.845 4.104-3.112 5.203-1.117 1.706 3.1-3.378 4.846-4.982 6.352-2.355 2.208-4.095 4.991-6.683 7.088z")
                ]), M),
                A2(Da, l([
                    Fa("path859"),
                    Ha("#dcc06d"),
                    qa("M181.638 275.834c1.449-1.825 3.766-3.75 5.701-5.14 1.918-1.378 4.071-1.749 3.699-4.437-2.627-.425-5.133 2.838-6.762 4.224-1.866 1.589-4.237 2.999-6.192 4.643-2.468 2.077-5.247 3.389-8.576 4.694-3.356 1.316-7.667 1.932-10.759 3.537.381-.06.916.093 1.308.07.559.98 6.162-1.003 7.354-1.298-.151.07-.331.13-.489.208 3.063-.404 5.944-1.833 8.635-3.159-1.731 1.823-4.338 2.1-6.372 3.464-.79.53-1.006 1.161-2.073 1.613-1.258.534-2.825.698-4.158.965-3.192.638-6.948 1.278-9.788 2.826-1.462.796-3.601 2.168-4.488 3.378 3.129-1.153 6.032-2.766 9.292-3.741 2.706-.81 5.301-1.614 7.927-2.632 2.489-.965 4.784-1.898 7.116-3.125 1.239-.651 4.264-1.929 4.67-3.149-.182-.023-.354-.038-.536-.057.6-1.95 4.214-4.555 6.208-5.099-.172.888-1.152 1.504-1.717 2.215z")
                ]), M),
                A2(Da, l([
                    Fa("path861"),
                    Ha("#ccb25c"),
                    qa("M181.773 275.17c-.563.621-1.025 1.41-1.345 2.138 2.484-.994 4.754-4.16 6.77-5.905.89-.77 2.689-1.88 3.233-2.89 1.151-2.136-1.142-.533-2.065.207-2.674 2.141-5.274 4.532-7.368 7.166")
                ]), M)
            ])),
            A2(On, l([
                Fa("g863")
            ]), l([
                A2(Da, l([
                    Fa("path865"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".335"),
                    qa("M191.72 280.363c.233-1.419.5-4.008-.908-3.77-1.344.229-2.482 2.124-3.406 2.942-2.835 2.512-5.793 4.872-9.226 6.675-3.612 1.896-7.118 3.922-10.916 5.497-1.751.726-2.999 1.577-4.583 2.496-1.521.884-3.561 1.729-3.802 3.605-.103.792-.174 1.9-.007 2.748.581 2.975 4.093-.115 5.144-.904 2.381-1.788 5.059-3.2 7.739-4.564 3.535-1.8 6.755-3.719 9.915-6.06 1.295-.961 2.46-2.055 3.739-3.034 1.625-1.243 3.361-2.47 5.128-3.365 1.102-.557 1.01-1.205 1.183-2.266z")
                ]), M),
                A2(Da, l([
                    Fa("path867"),
                    Ha("#dcc06d"),
                    qa("M189.905 279.103c1.869-.506.277 1.982-.165 2.507-1.267 1.501-3.321 2.235-4.879 3.442-2.323 1.8-4.798 3.415-7.206 5.137-3.605 2.577-8.386 4.572-12.679 5.921 3.01-1.411 5.579-3.479 8.311-5.245 3.979-2.571 8.673-4.311 12.583-7.129 1.295-.933 1.924-1.896 2.501-3.203.556-1.257 1.206-1.55 2.27-2.619.64.715.432 1.724.238 2.561-.024-.566-.161-.1-.2-.122")
                ]), M)
            ])),
            A2(On, l([
                Fa("g869")
            ]), l([
                A2(Da, l([
                    Fa("path871"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".335"),
                    qa("M237.615 293.124c-.857-.391-1.749-.678-2.587-1.165-2.766-1.608-5.377-3.44-7.97-5.275-1.588-1.123-3.238-2.183-4.83-3.3a83.275 83.275 0 0 1-7.733-6.13c-.685-.611-1.567-.987-2.314-1.547-1.149.734-1.224 3.515-1.143 4.696.062.917.38 1.301 1.267 1.595 1.26.417 1.815.499 2.964 1.333 2.438 1.77 4.628 3.813 7.237 5.38 2.678 1.607 5.344 3.434 7.838 5.31 2.791 2.099 5.352 4.356 8.013 6.583.892.744 5.121 3.297 5.678 1.398.209-.714-.299-2.212-.4-2.98-.163-1.209-.199-1.884-1.21-2.68a41.552 41.552 0 0 0-3.922-2.751 8.194 8.194 0 0 0-.888-.467z")
                ]), M),
                A2(Da, l([
                    Fa("path873"),
                    Ha("#ccb25c"),
                    qa("M212.75 277.316c-1.361.218-1.38 2.736-.58 3.417.19-.172.563-.227.736-.351 1.792 1.752 4.472 4.281 6.94 5.004-1.741-1.909-5.194-3.883-6.103-6.248.103-.09.237-.154.333-.25-.166-.72-1.161-1.334-1.713-1.753")
                ]), M),
                A2(Da, l([
                    Fa("path875"),
                    Ha("#dcc06d"),
                    qa("M223.786 288.093c-1.958-1.183-3.707-2.47-5.533-3.813-1.416-1.042-3.803-2.223-4.287-3.954-.322-1.156.052-1.73 1.278-1.048 1.037.579 1.5 2.05 2.319 2.854 3.116 3.055 7.042 5.855 10.528 8.563 1.045.81 2.3 1.46 3.45 2.136.958.564 1.744 1.478 2.677 1.993.418.232.734.418 1.2.528.313.074.538-.634.954-.5.852.275 2.003 2.193 2.517 2.847.723.916 1.369 1.879 2.293 2.615-2.799-2.339-6.444-3.682-9.218-6.195-2.403-2.175-5.35-4.319-8.178-6.026z")
                ]), M)
            ])),
            A2(On, l([
                Fa("g877")
            ]), l([
                A2(On, l([
                    Fa("g879")
                ]), l([
                    A2(Da, l([
                        Fa("path881"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M147.833 288.628c-.046-.259-.117-.52-.066-.824.144-.862.971-1.744.734-2.655-.359-1.376-2.777-1.067-3.755-2.284-1.479-1.841 1.474-4.512 2.808-5.555 3.041-2.378 7.339-4.263 10.986-5.72 4.057-1.622 8.405-2.788 12.741-3.613 1.456-.276 3.461-.468 4.806-1.078 1.128-.509 1.914-1.552 2.815-2.279 2.488-2.003 4.805-4.43 7.762-5.909 1.548-.775 3.627-.843 4.984-1.818 1.435-1.033 2.458-3.847 1.312-5.328-1.566-2.023-4.17-.415-5.959.361-3.76 1.632-7.302 4.169-10.615 6.481-1.197.836-2.125 1.896-3.552 2.418-2.046.75-4.383 1.098-6.548 1.426-4.971.755-9.521 2.028-14.19 3.81-4.208 1.604-7.558 4.107-10.989 6.815-3.124 2.465-5.205 5.318-5.227 9.236-.008 1.639.387 3.58 1.553 4.856 1.711 1.874 3.589 3.922 6.437 3.766 1.116-.062 3.062-.183 3.766-1.136.265-.362.249-.664.197-.97z")
                    ]), M),
                    A2(Da, l([
                        Fa("path883"),
                        Ha("#dcc06d"),
                        qa("M143.633 282.679c-1.83-3.189-3.343-4.57-1.162-8.18 2.2-3.64 6.403-5.31 9.991-7.393-.078.029-.108.083-.09.161 2.543-.189 5.479-1.904 8.098-2.517 4-.935 8.484-1.334 12.211-3.01 2.805-1.262 5.376-3.824 8.124-5.524a31.788 31.788 0 0 1 5.192-2.563c1.117-.435 4.213-.879 4.769-1.982-.305-.018-.62-.012-.93-.012.414-.061 1.09-.525 1.524-.364.31.115 1.112 1.087 1.26 1.363 1.01 1.872-1.399 3.098-2.604 4.166-1.688 1.495-4.272 2.12-6.309 3.147-1.799.908-3.408 1.985-5.005 3.017.373-.652 1.008-1.557.57-2.287-1.43.447-2.206 1.778-3.484 2.502-2.246 1.271-5.114 2.244-7.612 2.986-1.987.59-4.283 1.49-6.423 1.296-1.332-.121-2.086-.524-3.584-.329-5.068.656-13.456 4.526-14.723 9.721-1.414 1.022-2.457 3.51-.59 4.729")
                    ]), M),
                    A2(Da, l([
                        Fa("path885"),
                        Ha("#ccb25c"),
                        qa("M192.034 254.697c.4-.342.629-1.353.008-1.628.118-.147.26-.385.443-.507-1.601.828-3.367 1.357-4.977 2.145 1.153-.278 2.486-.934 3.723-.888-.182.127-.314.325-.516.437.213-.046.375.07.536.079-.212 1.275-3.328 1.391-4.303 1.839-2.42 1.116-4.845 2.694-7.042 4.177.375-.4.332-.598.482-1.036-1.711.868-2.94 2.546-4.457 3.696-2.295 1.738-5.245 2.713-8.068 3.213-3.017.534-5.718 1.286-8.867 1.249.088.111.229.274.302.357-2.145 2.166-7.099 2.687-10.008 3.764-.603.223-2.241 1.186-2.806.768-.747-.553-.043-1.39.41-1.814-1.047.982-2.879 1.468-4 2.562-1.556 1.517-3.453 3.938-2.652 6.079.693 1.851 2.87 4.114 5.075 4.397-1.53-.196-1.547-2.62-1.232-3.5.557-1.559 2.167-2.843 3.5-3.833 2.149-1.598 4.601-2.757 6.925-4.114 3.764-2.199 8.193-3.372 12.502-4.117 1.906-.329 3.973-.558 5.846-.938 1.309-.267 1.735-.93 2.871-1.508 1.123.896 4.323-2.908 5.116-3.688 1.843-1.815 4.054-3.232 6.36-4.409 1.826-.932 5.471-1.035 5.233-3.532-.309.611-1.216 1.001-2.235 1.304")
                    ]), M),
                    A2(Da, l([
                        Fa("path887"),
                        Ha("#dcc06d"),
                        qa("M137.437 282.5c-1.683 4.021 4.147 6.008 6.756 6.941-.272-.25-.606-.677-.933-.835 1.033.328 3 .014 3.062-1.252-2.087.045-3.814-1.479-5.743-1.975 1.223.95 2.929 1.284 4.147 2.306-.485.207-1.086.252-1.607.206.054.166.072.346.11.488-2.59-.073-5.578-2.225-5.988-4.627")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g889")
                ]), l([
                    A2(Da, l([
                        Fa("path891"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M141.69 267.188c-.585-1.18-.513-2.49.649-3.863 3.099-3.66 9.201-5.542 13.728-7.109 2.196-.76 4.528-1.181 6.663-2.031 2.258-.9 4.529-1.881 6.872-2.61 3.963-1.23 8.015-2.193 12.021-3.3 3.259-.902 6.573-2.083 9.716-3.285 2.11-.807 3.313-3.907 1.327-5.646-1.467-1.285-3.862.944-5.472 1.361-1.402.362-2.872.667-4.312.989-2.468.555-4.81 1.836-7.352 2.089-2.58.258-4.877.762-7.403 1.529-5.686 1.724-11.219 3.843-16.763 5.919-8.077 3.025-23.834 11.585-15.702 21.615 1.001 1.236 2.111 1.374 3.49 2.065 3.774 1.892 6.849 4.64 11.372 4.958 3.308.232 10.1-3.526 6.96-7.272-.858-1.027-4.362-.091-5.58-.133-2.137-.073-3.44-.904-5.174-1.833-1.858-.993-4.053-1.458-5.04-3.443z")
                    ]), M),
                    A2(Da, l([
                        Fa("path893"),
                        Ha("#ccb25c"),
                        qa("M141.89 268.196c-1.354-1.63-3.518-3.272-3.877-5.364-.396-2.298 1.375-4.118 3.261-5.345-.328.662-.083 1.159.775 1.085l.066.296c1.242.265 2.782-.741 3.863-1.212 1.621-.705 3.458-1.217 4.949-2.087-.002.1-.106.13-.123.265 1.228-.237 2.207-.833 3.421-1.126 1.243-.301 2.537-.345 3.73-.824 2.328-.931 15.784-5.11 15.162-7.107 3.186-1.05 6.896-1.855 10.222-2.543 1.403-.289 6.23-.813 6.151-2.472-2.048-.119-4.743 1.229-6.524.741 2.235-.865 5.13-1.635 7.545-2.019 1.739-.276 1.223-.321 1.521.888.415 1.682-.671 2.735-2.502 3.582-3.982 1.838-8.793 3.11-13.01 4.33a1147.634 1147.634 0 0 0-16.634 4.965c-3.76 1.149-7.468 1.849-10.985 3.609-2.447 1.225-10.873 5.265-7.594 9.087")
                    ]), M),
                    A2(Da, l([
                        Fa("path895"),
                        Ha("#dcc06d"),
                        qa("M156.033 250.084c2.993-.806 5.972-1.21 8.897-2.091 1.831-.553 3.273-1.345 5.218-1.968 2.907-.932 5.943-1.684 8.929-2.373 1.29-.298 11.409-3.343 11.4-1.526-.006 1.031-4.426 2.017-5.294 2.246-2.955.777-6.58.54-9.395 1.618-2.926 1.121-5.307 3.061-8.187 4.313-4.947 2.15-9.736 3.903-15.029 5.159-1.978.469-3.971 1.241-5.801 2.081-.994.456-5.204 2.517-5.85.936-.879-2.166 13.142-7.864 15.112-8.395z")
                    ]), M),
                    A2(Da, l([
                        Fa("path897"),
                        Ha("#dcc06d"),
                        qa("M134.92 266.945c-.639 1.843.343 4.501 2.144 5.475-.013-.22.025-.427.03-.633 1.422 2.216 4.285 3.411 6.776 4.634 2.727 1.34 5.115 2.578 8.214 2.696-.077-.114-.18-.205-.253-.333.401-.135.834-.455 1.224-.583-5.84.578-12.785-3.633-15.82-7.976-.021.146-.009.306-.025.454-1.472-.186-2.763-2.863-2.097-4.092")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g909")
                ]), l([
                    A2(Da, l([
                        Fa("path911"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M262.522 268.113c.211-1.348-.075-2.736-1.058-3.934-3.035-3.705-9.104-5.675-13.604-7.309-2.184-.791-4.507-1.247-6.627-2.128-2.242-.933-4.496-1.947-6.827-2.709-3.941-1.289-7.977-2.31-11.96-3.476-3.246-.95-6.539-2.18-9.66-3.427-2.096-.837-3.246-3.954-1.23-5.665 1.489-1.263 3.845 1 5.447 1.441 1.397.383 2.863.708 4.296 1.052 2.457.59 4.778 1.905 7.314 2.197 2.574.295 4.863.834 7.376 1.636 5.656 1.807 11.152 4.007 16.659 6.165 5.848 2.291 12.129 5.404 15.659 10.478.962 1.383 1.998 2.517 2.08 4.203.211 4.511-.939 8.071-4.78 11.037-1.369 1.055-2.849 2.161-4.494 2.821-1.4.563-3.058 1.104-4.577 1.264-.637.067-1.168.173-1.736-.114-.285-.146.195-.645-.008-.82-.424-.363-1.106-.467-1.576-.814-.845-.625-1.812-2.591-1.549-3.597.267-1.023.284-.699 1.354-1.024 4-1.221 8.818-2.904 9.501-7.277z")
                    ]), M),
                    A2(Da, l([
                        Fa("path913"),
                        Ha("#ccb25c"),
                        qa("M262.63 258.356c.318.666.063 1.159-.794 1.073-.022.099-.048.198-.072.296-1.245.246-2.769-.782-3.841-1.269-1.609-.728-3.438-1.267-4.911-2.159-.003.099.104.13.117.267-1.226-.255-2.194-.865-3.402-1.177-1.237-.319-2.529-.383-3.716-.877-2.312-.965-15.692-5.341-15.038-7.327-3.167-1.099-6.863-1.958-10.176-2.694-1.399-.309-6.217-.904-6.108-2.561 2.05-.09 4.721 1.299 6.512.836-2.221-.897-5.102-1.709-7.512-2.127-1.734-.302-1.218-.339-1.536.866-.443 1.675.625 2.744 2.44 3.617 3.95 1.897 8.74 3.238 12.936 4.52a1186.897 1186.897 0 0 1 16.546 5.207c3.739 1.206 7.438 1.959 10.923 3.771 4.589 2.385 11.42 6.227 7.191 11.75 2.995-3.912 5.688-8.483.441-12.012z")
                    ]), M),
                    A2(Da, l([
                        Fa("path915"),
                        Ha("#dcc06d"),
                        qa("M248.001 250.739c-2.977-.85-5.948-1.297-8.859-2.222-1.821-.579-3.25-1.392-5.186-2.043-2.89-.975-5.912-1.771-8.886-2.503-1.285-.317-11.353-3.51-11.374-1.692-.011 1.03 4.391 2.082 5.258 2.322 2.939.821 6.569.636 9.363 1.755 2.907 1.164 5.253 3.137 8.113 4.432 4.91 2.222 9.668 4.045 14.936 5.377 1.974.498 3.953 1.3 5.768 2.166.985.469 5.161 2.593 5.831 1.023.918-2.154-13.003-8.056-14.964-8.615z")
                    ]), M),
                    A2(Da, l([
                        Fa("path917"),
                        Ha("#dcc06d"),
                        qa("M268.823 267.906c.606 1.853-.421 4.496-2.24 5.443.02-.22-.015-.428-.015-.634.007 2.326-5.829 2.769-5.577 5.467a1.644 1.644 0 0 0 1.546-.437c-1.252 1.102-3.282 1.953-5.001 2.041.597-.967 2.459-1.167 2.623-2.444-1.104-.233-1.967.512-3.021.664 1.382-.201 3.939-2.271 5.078-3.07 1.558-1.091 3.143-2.271 4.238-3.783.015.146.003.305.015.452 1.474-.163 2.812-2.822 2.165-4.06")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g919")
                ]), l([
                    A2(Da, l([
                        Fa("path921"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M161.042 242.968c-4.08 1.015-8.209 1.826-12.145 3.37-2.385.935-5.825 2.745-6.927 5.011-1.291 2.657 2.034 4.612 3.991 5.889 3.15 2.058 8.155 3.06 12.001 3.277 2.107.119 8.372-1.555 9.252 1.038 1.298 3.821-5.537 4.894-8.079 5.105-3.23.267-6.555-.436-9.718-.938-4.291-.683-8.447-2.373-11.463-5.335-4.805-4.718-3.835-13.391 2.101-16.806 7.029-4.045 15.51-4.685 23.167-7.25 8.596-2.878 17.756-5.563 25.721-9.743 1.359-.714 2.696-2.087 4.323-2.082.195 0 .502 2.523.515 2.741.071 1.245-.132 1.824-.863 2.768-1.574 2.029-3.885 3.212-6.305 4.39-2.145 1.045-4.438 1.746-6.742 2.494-1.133.367-2.409.947-3.48 1.43-2.058.929-4.27 1.892-6.423 2.651-1.606.568-3.349.401-4.959.9a72.7 72.7 0 0 1-3.967 1.09z")
                    ]), M),
                    A2(Da, l([
                        Fa("path923"),
                        Ha("#ccb25c"),
                        qa("m141.528 254.05.013.022c.586 1.06 1.829 1.666 2.619 2.574-3.214-1.499-5.653-4.33-5.562-7.765.101-3.809 4.173-4.688 7.095-6.274-.291.186-.329.397-.496.566 1.232.983 3.919-.041 5.236-.407 2.712-.755 5.544-1.64 7.863-3.194-.22.011-.45.001-.669.03 1.427-.784 2.944-1.011 4.575-.88-.775-.063.543 1.336.717 1.418.908.442 2.771.063 3.706-.125 2.568-.516 4.691-1.722 7.032-2.757 1.674-.739 3.205-1.728 4.864-2.458 2.563-1.129 5.256-2.528 7.538-4.116 1.072-.748 4.53-5.19 5.779-4.876 1.75.439-.613 4.103-1.2 4.843-1.687 2.122-5.021 2.916-7.465 4.061-4.759 2.231-9.453 4.788-14.674 6.004-4.276.995-8.642 1.546-12.951 2.538-4.496 1.035-17.889 4.112-14.02 10.796z")
                    ]), M),
                    A2(Da, l([
                        Fa("path925"),
                        Ha("#dcc06d"),
                        qa("M184.662 233.653c1.192-.464 3.696-1.85 1.384-2.594.537-.744 1.539-1.001 2.283-1.557.746-.559 1.503-1.273 2.007-2.033.104-.157.693-1.627.708-1.633-.746.229-1.606.896-2.302 1.233-.824.398-1.752.695-2.565 1.118-1.609.835-3.061 1.89-4.609 2.807-1.724 1.02-3.607 1.866-5.417 2.747-1.75.852-3.523 1.708-5.344 2.414-3.158 1.227-6.527 1.952-9.954 2.183-2.698.181-5.388 1.135-7.922 1.992-1.84.624-3.542 1.379-5.421 1.899-1.143.318-2.956.686-3.492 1.802 4.651.547 9.136-1.58 12.929-3.73 1.297-.735 4.063-1.791 5.604-1.579-2.79 1.769 4.18 1.328 4.682 1.228 4.221-.836 7.653-2.33 11.456-4.088 1.894-.876 4.015-1.445 5.973-2.209z")
                    ]), M),
                    A2(Da, l([
                        Fa("path927"),
                        Ha("#dcc06d"),
                        qa("M144.001 261.564c-.007.074-3.708-1.774-3.984-1.976 2.486 2.611 6.214 3.776 9.768 4.529 2.061.436 4.135.87 6.251.997 1.99.119 3.825-.481 5.741-.498-2.12.018-5.861.602-7.674-.576.606-.504 1.652-.176 2.292-.63-3.823-.006-9.107.344-12.035-2.517-.088.217-.322.28-.359.671z")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g929")
                ]), l([
                    A2(On, l([
                        Fa("g931")
                    ]), l([
                        A2(Da, l([
                            Fa("path933"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M143.821 247.633c-5.25-3.391-10.139-8.737-5.6-13.802 1.607-1.792 4.108-2.819 6.405-3.637 2.792-.995 5.279-2.363 7.978-3.584 6.032-2.731 12.334-4.897 18.492-7.369 2.375-.954 4.747-1.892 7.179-2.713 3.032-1.023 6.118-1.945 9.042-3.221 2.433-1.062 4.339-2.642 7.168-2.262.376 2.058.646 4.51.078 6.559-.819 2.953-5.116 2.533-7.563 3.439-1.045.388-2.087.663-3.157 1.001-6.375 2.021-12.515 4.934-18.709 7.396-3.568 1.419-7.26 2.609-10.677 4.335-2.355 1.19-6.407 1.63-7.766 4.044-1.509 2.683 2.142 4.979 4.315 6.005 2.466 1.164 5.246 2.631 7.95 3.229 2.54.561 5.228-.024 7.67-.602 1.651-.392 3.718-.657 4.148 1.301.219 1-.86 2.892-1.488 3.724-.621.823-1.398 1.025-2.466 1.212-1.55.272-3.175.339-4.758.272-2.617-.112-4.965-.285-7.483-1.019-3.884-1.13-7.338-2.098-10.758-4.308z")
                        ]), M),
                        A2(Da, l([
                            Fa("path935"),
                            Ha("#ccb25c"),
                            qa("M156.186 232.397c-2.063 1.009-13.852 4.125-9.854 7.798-.993-1.706-3.833-2.718-4.309-4.487-.714-2.658 3.098-4.377 5.016-5.435-2.157 1.395.54 1.95 1.874 1.663 1.602-.347 8.19-2.069 7.566-3.974.948-.256 1.852-.915 2.83-.857-.063.153-.136.158-.169.33 1.075.651 3.563-.538 4.657-.846 3.783-1.063 7.332-2.488 10.827-4.179 2.521-1.22 5.131-2.236 7.695-3.351.732-.319 1.512-.329 1.797-1.074 1.07.03 6.169-2.01 3.858-3.25 1.632-.883 3.311-2.091 4.984-2.968 1.436 1.171 1.459 4.583.388 6.015-1.048 1.401-4.17 1.734-5.814 2.308-7.558 2.639-14.988 5.439-22.565 8.06-3.13 1.084-5.866 2.824-8.781 4.247z")
                        ]), M),
                        A2(Da, l([
                            Fa("path937"),
                            Ha("#dcc06d"),
                            qa("M158.477 227.265c-1.347 1.336 1.416.693 1.99.483 2.071-.76 4.148-1.597 6.161-2.473 2.899-1.262 6.061-2.835 9.118-3.717-.104.222-.066.462-.137.664 1.575-.163 14.192-3.939 12.766-6.405.616-.719 1.536-1.415 1.892-2.127-.542.079-1.101.335-1.667.481.359-.144.713-.401 1.058-.571-3.012.101-6.473 2.365-9.235 3.42-4.11 1.569-8.562 2.59-12.579 4.326-3.398 1.468-6.667 2.897-10.078 4.255-2.667 1.061-5.706 1.918-8.066 3.455.796-.24 1.862-.624 2.625-.2-.581.916-3.482 2.297-.577 2.523 1.634.125 2.785-1.037 3.752-2.052.859-.903 2.161-1.251 2.977-2.062z")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path939"),
                        Ha("#dcc06d"),
                        qa("M147.144 246.871c-.45-.29-.896-.594-1.343-.912.831.592 1.593 1.614 2.535 2.271 1.984 1.387 4.15 1.981 6.406 2.794 2.795 1.006 5.718.779 8.641.837 2.15.043 4.715-.121 4.615-2.94-.021-.588-.561-.936-.456-1.559-.067.29-.162.311-.273.532.032.054.148.16.149.233-.766.576-2.153 1.257-3.184 1.343.966.06 2.228-.476 3.006.096-.97.77-2.794 1.448-4.027 1.726-3.145.707-6.657-.262-9.602-1.274a29.134 29.134 0 0 1-6.467-3.147z")
                    ]), M),
                    A2(Da, l([
                        Fa("path941"),
                        Ha("#dcc06d"),
                        qa("M169.769 250.853c.748.03.996-.557.977-1.193-.517.652-2.292.81-3.24 1.152 1.047.061 2.013.183 3.039.041")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g943")
                ]), l([
                    A2(Da, l([
                        Fa("path945"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M217.458 235.794c4.289 2.431 8.928 5.583 13.613 7.261 2.82 1.011 5.957 1.75 8.924 2.373 6.542 1.371 13.319 2.012 19.548 4.452 2.855 1.121 7.324 3.037 5.221 6.577-2.79 4.694-11.922 4.61-16.881 5.084-2.63.251-5.915-.407-8.389.071.15-.029 3.342 2.529 3.572 2.918.513.861.358 2.856 1.448 3.345.453.204 1.374-.011 1.896.028.698.049 1.385.17 2.083.207 1.339.069 2.805-.137 4.138-.269 4.094-.404 8.853-.725 12.427-2.696 3.228-1.777 6.441-3.065 7.99-6.518 1.482-3.303-.081-7.393-2.519-9.955-2.146-2.252-5.191-2.938-8.113-3.916-5.242-1.753-10.242-2.73-15.621-3.857-4.285-.897-9.844-1.811-13.715-3.747-3.855-1.928-8.354-3.428-11.868-5.796-3.666-2.472-6.87-5.49-10.643-7.832-2.128 1.437-.69 5.271.386 6.944 1.237 1.923 3.47 3.659 5.526 4.781l.977.545z")
                    ]), M),
                    A2(Da, l([
                        Fa("path947"),
                        Ha("#ccb25c"),
                        qa("M266.209 257c.86-.878 1.527-1.891 1.845-2.908.521-1.677.318-3.458-.865-4.858-1.278-1.511-2.692-2.133-4.445-3.083.29.186.328.396.497.566-1.233.983-3.921-.04-5.236-.408-2.715-.755-5.543-1.639-7.863-3.194.219.01.45.002.667.029-1.427-.783-2.942-1.011-4.572-.879 1.48 3.197-8.399.455-9.351.173-4.278-1.263-8.226-3.021-12.11-5.093-.98-.521-3.464-1.335-3.643-2.441.457-.308.836-.495 1.291-.42-.255-.321-.399-.701-.775-1.015.06-.146.128-.183.158-.339.094-.513-2.498-2.09-2.935-2.442-1.521-1.221-3.018-2.467-4.566-3.658-1.203-.925-2.941-2.7-4.554-2.873-.245 1.403.879 3.867 1.453 5.232 1.032 2.456 2.562 3.562 5.017 4.782 1.407.698 2.689 1.556 4.048 2.378 2.966 1.797 6.616 3.163 9.821 4.577 3.118 1.377 6.343 2.576 9.74 3.218 3.163.598 6.348 1.068 9.495 1.736 4.289.909 8.997 1.894 12.856 3.92 1.824.957 3.671 2.678 3.72 4.766.05 2.125-2.456 3.42-3.847 4.749 1.467-.377 2.987-1.323 4.154-2.515z")
                    ]), M),
                    A2(Da, l([
                        Fa("path949"),
                        Ha("#dcc06d"),
                        qa("M251.491 243.844c-1.299-.736-4.064-1.792-5.604-1.579 2.789 1.767-4.181 1.327-4.683 1.228-4.223-.838-7.654-2.332-11.454-4.088-1.895-.877-4.015-1.445-5.974-2.209-1.404-.546-4.191-2.445-.983-2.142-.756-.491-1.421-1.341-1.869-2.086 1.677-.009 3.61 1.688 5.138 2.297 3.828 1.528 7.721 2.939 11.568 4.432 3.156 1.227 6.526 1.952 9.954 2.183 2.697.182 5.387 1.135 7.921 1.993 1.841.623 3.543 1.377 5.423 1.899 1.14.317 2.956.685 3.493 1.802-4.655.547-9.137-1.582-12.93-3.73z")
                    ]), M),
                    A2(Da, l([
                        Fa("path951"),
                        Ha("#dcc06d"),
                        qa("M253.022 266.659c-1.078.128-2.109.295-3.19.285-.96-.009-2.227.307-3.104-.153-.267-.14-.499-.457-.771-.647-.293-.204-.689-.318-.864-.613.167.002.275-.053.448-.027-.696-.535-.969-1.143-1.515-1.718.834.385 1.801.489 2.781.472-.597.2-1.284.066-1.903.109.046.45.756.579 1.11.879-.772.445.729 1.264 1.193 1.413.909.292 2.007.053 2.936-.002a26.94 26.94 0 0 0 3.267-.405c.822-.151 2.234-.168 2.795-.804-.316-.191-.744-.11-1.122-.112 1.709.127 3.568-.63 5.074-1.238-.845.402-2.105.844-2.771 1.396.901.44 2.284.137 3.163-.212.863-.343 2.166-.848 2.894-1.385-.121.088-.175.204-.252.28.689.302 2.063-.374 2.705-.643 1.226-.518 2.268-1.37 3.361-2.034-1.971 1.196-3.749 3.316-6.209 3.744-3.291.573-6.688 1.019-10.026 1.415z")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g953")
                ]), l([
                    A2(On, l([
                        Fa("g955")
                    ]), l([
                        A2(Da, l([
                            Fa("path957"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M264.116 249.124c4.613-3.414 7.573-8.68 4.474-13.926-1.149-1.944-3.178-2.831-5.359-3.607-2.792-.995-5.278-2.362-7.979-3.584-6.031-2.73-12.335-4.896-18.49-7.368-2.375-.954-4.747-1.893-7.179-2.714-3.937-1.33-7.832-3.279-11.782-4.438-1.173-.346-4.905-2.241-5.936-1.183-.729.748.244 2.935.122 3.865-.137 1.033-.693 2.042.034 2.944.871 1.084 3.206 1.288 4.449 1.709 2.516.852 4.973 1.805 7.543 2.619 6.375 2.02 12.515 4.934 18.709 7.397 3.567 1.418 7.26 2.608 10.677 4.334 1.201.606 2.538.933 3.805 1.397 2.394.876 5.238 2.177 4.689 4.987-.349 1.794-2.192 2.856-3.871 3.518-3.736 1.475-8.473 1.958-12.509 1.572-3.071-.293-6.11-.625-9.189-.822-1.103-.072-1.649-.195-2.24.875-.501.909-.466 2.158.101 3.035 1.928 2.977 6.676 3.065 9.952 3.213 3.688.167 7.402.216 11.066-.287 3.221-.439 6.363-1.649 8.913-3.536z")
                        ]), M),
                        A2(Da, l([
                            Fa("path959"),
                            Ha("#ccb25c"),
                            qa("M264.856 236.554c-.521-2.005-2.266-3.796-3.98-4.846 2.111 1.154-.802 1.868-1.932 1.624-1.603-.346-8.191-2.069-7.565-3.972-.95-.256-1.854-.915-2.833-.857.064.151.136.156.17.329-1.074.651-3.563-.539-4.655-.845-3.783-1.064-7.332-2.489-10.826-4.18-2.521-1.22-5.132-2.236-7.695-3.351-.733-.32-1.512-.33-1.797-1.075-1.071.03-6.171-2.009-3.859-3.248-.787.421-4.596-3.238-5.6-3.499-2.353-.608-2.509 1.914-2.509 3.484.002 3.696 5.741 4.388 8.551 5.369 7.559 2.64 14.986 5.439 22.563 8.059 3.133 1.084 5.867 2.825 8.782 4.249 3.044 1.486 12.226 3.107 10.443 7.895-.276.739-1.003 1.509-1.734 1.888 1.828-.944 3.813-2.593 4.43-4.521.817-2.555-.885-4.897-3.023-6.351")
                        ]), M),
                        A2(Da, l([
                            Fa("path961"),
                            Ha("#dcc06d"),
                            qa("M249.379 228.662c1.346 1.335-1.416.692-1.989.482a111.622 111.622 0 0 1-6.162-2.472c-2.898-1.262-6.06-2.834-9.117-3.718.104.223.067.464.138.666-1.574-.164-14.191-3.939-12.768-6.405-.616-.719-1.535-1.416-1.892-2.128.542.079 1.103.335 1.668.481-.36-.144-.715-.401-1.058-.571 3.009.102 6.474 2.365 9.234 3.42 4.108 1.57 8.563 2.592 12.58 4.327 3.397 1.468 6.668 2.897 10.075 4.255 2.668 1.061 5.708 1.918 8.068 3.457-.797-.24-1.861-.624-2.625-.201.58.915 3.482 2.296.576 2.522-1.635.127-2.786-1.036-3.752-2.051-.857-.905-2.158-1.255-2.976-2.064z")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path963"),
                        Ha("#dcc06d"),
                        qa("M260.287 249.331c-3.75 1.452-7.723 2.488-11.85 2.151-1.832-.149-3.56-.652-5.422-.674-1.304-.015-2.792.5-3.997.372.29-.028.666-.163.94-.205-1.132-.499-4.516-1.532-4.446-2.936 1.294.326 2.65.74 3.997.76-1.185.048-2.372-.397-3.535-.25.351.35.734.678 1.08 1.032a3.235 3.235 0 0 1-.382.043c.352.71 1.751 1.008 2.557.896-.108-.121-.168-.244-.241-.363 1.32-.076 2.603.114 3.912.246 2.845.284 6.149 1.163 8.969.439 2.734-.702 5.563-1.275 8.418-1.511z")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g965")
                ]), l([
                    A2(Da, l([
                        Fa("path967"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M164.165 238.984c-.5-.066-.993-.145-1.479-.235-3.48-.644-7.147-1.37-10.407-2.63-3.333-1.289-6.46-3.294-9.455-5.136-3.018-1.857-5.498-4.936-4.683-8.438.579-2.491 4.002-3.833 6.209-4.814 2.454-1.092 5.063-1.746 7.541-2.685 4.512-1.709 9.375-2.979 13.766-4.917 4.028-1.779 7.989-3.657 12.2-5.186 1.967-.714 3.895-1.472 5.841-2.234 2.591-1.013 5.046-1.668 7.449-3.062 1.268-.736 4.691-2.852 5.183-.296 1.06 5.511-5.37 6.977-9.714 8.586-2.756 1.021-4.968 2.441-7.474 3.749-2.763 1.442-6.201 1.674-9.139 2.733-5.118 1.846-10.17 3.742-15.35 5.513-2.062.706-5.751 1.56-6.871 3.517-1.372 2.399 3.104 4.429 4.844 5.544 3.385 2.169 7.097 2.651 11.002 3.458 2.415.498 5.098 1.15 7.688 1.115 1.333-.018 5.84-1.254 6.834.111 1.391 1.911-3.257 5.167-4.959 5.509-2.91.582-6.112.183-9.026-.202z")
                    ]), M),
                    A2(Da, l([
                        Fa("path969"),
                        Ha("#dcc06d"),
                        qa("M147.699 226.537c-1.468-1.688-3.413-2.929-3.675-5.185-.24-2.063 1.857-3.785 4.043-3.898-.228.15-.454.536-.732.719.475.873 2.29.559 3.073.144 1.622-.862 2.499-2.168 4.689-2.91 2.744-.929 5.431-1.864 8.133-2.901 2.128-.816 4.279-1.984 6.543-2.383 3.489-.614 7.861-1.856 11.074-3.79 3.775-2.272 8.31-3.31 11.933-5.843.336 2.889-3.511 5.539-5.987 6.571-2.449 1.02-4.424 1.918-6.758 3.348-2.212 1.356-5.353 3.852-8.081 4.165.451-.37.308-.698.5-1.061-5.314.041-10.049 1.419-15.032 3.503-2.679 1.121-5.289 2.382-7.981 3.442-1.226.481-3.1.868-3.995 1.778.26.986.597 3.195 1.671 3.585")
                    ]), M),
                    A2(Da, l([
                        Fa("path971"),
                        Ha("#ccb25c"),
                        qa("M148.324 221.936c-2.439 1.878-1.008 4.35 1.252 5.69-2.839-1.684-9.411-5.662-4.544-8.739 2.207-1.395 6.036-3 8.615-3.181-.814.326-3.787 1.244-4.068 2.02-.558 1.54 4.367.227 5.061.124 2.755-.412 5.315-1.475 7.977-2.225 2.857-.805 5.765-1.913 8.5-3.035 4.085-1.677 8.102-3.384 12.005-5.319 2.819-1.399 7.272-1.827 7.728-5.202-.268.071-.674.025-.925.128 1.249-1.895 3.791-2.453 5.804-3.485-.115 1.375.253 2.7-.349 4.053-.688 1.549-2.176 1.863-3.726 2.483-3.833 1.537-7.499 3.41-11.229 5.026-3.646 1.581-7.221 3.35-11.042 4.6-6.941 2.273-15.207 2.556-21.059 7.062z")
                    ]), M),
                    A2(Da, l([
                        Fa("path973"),
                        Ha("#dcc06d"),
                        qa("M158.347 235.477c3.373 1.229 5.839 1.82 8.778 2.325 1.416.243 3.088.71 4.562.508-.14-.276-.125-.631-.292-.876.231-.223.573-.61.872-.992-1.15.531-2.013.562-3.255.681.321.222.988.538 1.324.639-2.224.629-4.658-.281-6.761-.983-2.003-.669-3.81-1.103-5.735-2.038.063.177.05.369.092.541-.817-.14-1.474-.63-2.238-.898.714.381 1.483.7 2.268.915")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g975")
                ]), l([
                    A2(Da, l([
                        Fa("path977"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M242.036 240.066c2.884-.188 5.748-.774 8.563-1.366 3.199-.673 6.23-1.688 9.104-3.107 2.754-1.358 5.883-3.338 6.967-6.215.817-2.167.843-5.344-.149-7.455-.813-1.735-2.363-3.039-4.174-3.876-3.647-1.685-7.762-2.979-11.603-4.231-3.199-1.043-6.476-1.928-9.681-2.984-8.259-2.721-15.706-6.383-23.372-10.383-1.677-.875-6.375-4.612-7.026-1.493-.36 1.729.171 4.7 1.854 5.77.888.563 2.397.795 3.402 1.309 1.098.562 2.147 1.204 3.237 1.779 3.709 1.957 7.682 4.088 11.661 5.607 2.981 1.14 6.093 1.848 9.003 3.196 3.734 1.731 8.226 2.074 12.187 3.489 2.184.781 4.565 1.666 6.37 3.071 1.772 1.379 1.171 4.073-.026 5.566-1.426 1.774-3.597 3.121-5.761 4.014-3.802 1.569-8.063 1.741-12.141 2.147-1.068.106-2.116.218-3.19.217-.802 0-1.397-.222-2.148-.337-3.997-.61-3.688 5.561.002 5.548 2.057-.006 4.128-.137 6.194-.225.243-.012.485-.025.727-.041z")
                    ]), M),
                    A2(Da, l([
                        Fa("path979"),
                        Ha("#dcc06d"),
                        qa("M258.858 226.805c1.333-1.489 5.24-2.91 4.979-5.13-.307-2.623-4.146-3.841-6.417-4.521-4.053-1.214-7.711-3.37-11.818-4.48-2.849-.771-5.651-2.032-8.555-2.583-3.479-.663-7.829-1.964-11.012-3.943-3.739-2.322-8.256-3.422-11.837-6.003-.382 2.883 3.421 5.584 5.88 6.651 2.431 1.054 4.393 1.979 6.703 3.441 2.19 1.385 5.292 3.924 8.015 4.274-.445-.377-.298-.703-.483-1.069 1.809.039 3.095-.072 4.56.831 1.152.709 2.484 1.042 3.756 1.509 2.456.902 5.043 1.321 7.529 2.118-.076-.104-.164-.261-.243-.357 2.061-.831 5.208 2.052 6.861 2.919 1.259.66 4.098 1.007 4.309 2.428.121.831-.729 2.894-1.636 3.208")
                    ]), M),
                    A2(Da, l([
                        Fa("path981"),
                        Ha("#ccb25c"),
                        qa("M244.118 215.69c-2.845-.845-5.735-1.991-8.45-3.151-4.061-1.732-8.047-3.495-11.92-5.483-2.796-1.438-7.241-1.925-7.644-5.307.267.075.674.036.923.141-1.217-1.912-3.751-2.505-5.748-3.565.094 1.378-.296 2.697.284 4.059.666 1.558 2.148 1.892 3.688 2.535 3.807 1.587 7.444 3.51 11.146 5.178 3.62 1.63 7.169 3.447 10.967 4.75 4.025 1.38 8.279 2.042 12.364 3.246 1.866.553 3.396 1.07 4.799 2.256.879.74 2.231 1.257 3.351 1.936.89.537 1.632 1.177 1.883 2.11.482 1.801-.768 4.556-2.58 5.369 2.745-1.002 4.671-2.783 6.159-5.081 2.763-4.264-6.505-7.719-9.969-7.982.573.19 1.839.707 1.291 1.495-.439.633-1.931-.014-2.506-.143-2.76-.62-5.342-1.562-8.038-2.363z")
                    ]), M),
                    A2(Da, l([
                        Fa("path983"),
                        Ha("#dcc06d"),
                        qa("M248.05 236.671a49.88 49.88 0 0 1-8.816 2.203c-1.418.224-3.099.668-4.568.447.145-.274.135-.63.307-.872a10.84 10.84 0 0 1-.857-1.003c1.144.546 2.005.588 3.244.724a6.198 6.198 0 0 1-1.331.622c2.212.659 4.66-.218 6.773-.891 2.017-.642 3.827-1.05 5.771-1.96-.067.176-.058.369-.104.539.819-.128 1.486-.61 2.255-.868a11.07 11.07 0 0 1-2.284.885")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g985")
                ]), l([
                    A2(On, l([
                        Fa("g987")
                    ]), l([
                        A2(Da, l([
                            Fa("path989"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M180.938 220.466c-1.055-.354-2.413-.323-3.398-.362a84.673 84.673 0 0 1-6.846-.531c-1.873-.23-3.688-1.124-5.576-1.484-3.92-.748-7.997-1.766-11.622-3.357-1.71-.751-3.592-1.729-3.679-3.751-.08-1.875 2.52-2.637 4.081-3.267 10.021-4.046 19.913-8.424 30.397-11.354 3.151-.879 7.853-1.255 10.329-3.492.963-.869 2.619-6.518.512-6.306-2.098.212-4.331.865-6.446 1.404-4.281 1.092-8.299 3.059-12.538 4.38-4.492 1.399-8.971 2.842-13.352 4.516-2.086.798-4.14 1.552-6.173 2.46-3.205 1.432-6.345 2.387-9.357 4.115-2.727 1.565-5.401 1.936-7.306 4.636-2.563 3.633.667 7.008 3.858 9.159 2.732 1.84 5.791 3.223 8.954 4.308 5.598 1.92 10.55 4.262 16.569 4.69 3.406.242 7.257.996 10.492-.363 1.706-.716 3.57-2.739 2.377-4.513-.291-.433-.745-.709-1.276-.888z")
                        ]), M),
                        A2(Da, l([
                            Fa("path991"),
                            Ha("#dcc06d"),
                            qa("M150.795 213.306c-2.359-.743-7.126-3.86-5.571-6.571.779-1.36 2.947-2.159 4.356-2.771.966-.42 1.989-.963 2.957-1.256.741-.225 2.004-.169 2.309-.819-.436.019-.685-.053-1.078.122 3.093-1.111 6.254-2.716 9.418-3.903 4.525-1.697 9.37-2.837 13.76-4.759.006 1.92 5.582.756 5.837-.407 1.042.377 2.338-.072 3.386.558-.563.295-1.387.62-1.668 1.127.137.079.278.151.358.209-1.673 1.018-3.916 1.297-5.792 1.839-2.949.849-5.958 1.563-8.771 2.69-4.358 1.747-8.979 3.109-13.349 4.863-2.731 1.095-13.03 5.916-6.541 9.258")
                        ]), M),
                        A2(Da, l([
                            Fa("path993"),
                            Ha("#ccb25c"),
                            qa("M148.279 212.054c-1.771-1.26-5.474-4.087-3.281-6.373-.058.936.404 1.697 1.005 2.426.072-.123.289-.244.382-.509.054.132.456.479.54.683.752-.273 7.429-3.556 6.267-4.269 2.297-1.354 5.665-2.327 8.252-3.228 2.62-.913 5.467-2.292 8.123-2.855 3.618-.768 12.301-.109 13.154-4.979-.335.034-.738-.099-1.087-.015.827-.575 1.954-.744 2.645-1.407-1.148-.104-2.54.267-3.607.652 2.021-1.138 4.649-2.038 6.912-2.704 2.07-.609 4.71-1.566 6.9-1.534-.273.225-.323.519-.691.731.119.053.25.277.542.349-.184.789-1.083 1.327-1.301 1.932-.279.775.38 1.165-.22 1.975-.523.705-2.032.708-2.762.918-.874.249-1.565.732-2.471.996-3.872 1.129-7.913 1.89-11.625 3.308-3.9 1.491-7.818 2.76-11.569 4.56-2.024.972-4.218 1.641-6.29 2.542-2.876 1.253-12.736 3.461-8.132 7.993-.819-.805-1.932-1.565-2.847-2.266")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path995"),
                        Ha("#dcc06d"),
                        qa("M175.965 224.212c1.204.316 3.592.797 4.631.041-.259-.008-.483-.128-.696-.175.528-.189.885-.636 1.026-1.133-.75.239-1.56.315-2.222.598.03.136.105.167.146.317-2.494 1.248-8.199-1.979-10.406-2.838.139.161.221.49.336.662-2.987.179-2.87.07-4.003-.192-1.146-.266-2.849-.422-3.861-.824 3.31.874 6.193 2.106 9.636 2.294 2.364.128 4.651.913 6.96 1.25")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g997")
                ]), l([
                    A2(On, l([
                        Fa("g999")
                    ]), l([
                        A2(Da, l([
                            Fa("path1001"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M225.421 221.766c-.354-2.635 3.329-2.347 5.613-2.441 3.406-.14 6.853-.146 10.193-.865 3.651-.787 7.439-2.111 10.857-3.555 1.724-.726 3.622-1.678 3.741-3.699.111-1.874-2.477-2.671-4.028-3.323-9.954-4.182-19.775-8.696-30.211-11.769-3.138-.924-7.832-1.363-10.274-3.634-.947-.882-2.512-6.552-.41-6.311 2.095.239 4.317.923 6.424 1.491 4.263 1.149 8.25 3.172 12.466 4.551 4.468 1.459 8.924 2.963 13.276 4.699 2.076.825 4.117 1.607 6.135 2.543 3.183 1.476 6.304 2.473 9.288 4.243 2.705 1.604 5.373 2.01 7.232 4.735 2.504 3.669-.78 7-4.006 9.105-7.941 5.186-17.072 6.642-26.551 7.257-2.83.184-8.053 1.372-9.429-1.933a4.425 4.425 0 0 1-.316-1.094z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1003"),
                            Ha("#dcc06d"),
                            qa("M254.81 213.517c2.371-.711 7.188-3.763 5.678-6.494-.758-1.369-2.912-2.199-4.312-2.83-.962-.433-1.975-.989-2.936-1.295-.738-.236-2.001-.198-2.296-.852.436.026.685-.042 1.075.138-3.076-1.155-6.211-2.803-9.354-4.032-4.498-1.758-9.325-2.967-13.682-4.948-.039 1.919-5.595.679-5.832-.487-1.047.363-2.336-.104-3.394.512.557.303 1.375.639 1.648 1.15-.136.076-.279.147-.363.204 1.657 1.04 3.897 1.35 5.766 1.916 2.932.891 5.932 1.646 8.725 2.811 4.33 1.807 8.926 3.231 13.271 5.045 2.712 1.132 12.933 6.093 6.39 9.347")
                        ]), M),
                        A2(Da, l([
                            Fa("path1005"),
                            Ha("#ccb25c"),
                            qa("M257.348 212.3c1.791-1.237 5.538-4.013 3.382-6.328.042.936-.431 1.691-1.042 2.411-.071-.123-.286-.247-.376-.513-.056.131-.463.473-.551.676-.746-.284-7.368-3.658-6.197-4.354-2.273-1.385-5.629-2.404-8.199-3.34-2.605-.949-5.43-2.367-8.074-2.967-3.606-.818-12.3-.278-13.075-5.159.335.038.74-.088 1.088 0-.819-.586-1.941-.771-2.621-1.443 1.147-.089 2.534.301 3.595.701-2.002-1.166-4.615-2.102-6.867-2.798-2.06-.638-4.686-1.63-6.876-1.627.271.229.315.522.681.74-.122.051-.254.275-.548.341.17.793 1.063 1.342 1.271 1.951.267.779-.401 1.16.187 1.978.512.712 2.02.736 2.745.953.873.263 1.555.756 2.455 1.032 3.856 1.182 7.883 1.998 11.573 3.466 3.875 1.545 7.771 2.867 11.493 4.719 2.01 1 4.193 1.698 6.249 2.629 2.856 1.292 12.678 3.633 8.003 8.102.831-.794 1.955-1.54 2.883-2.226")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path1007"),
                        Ha("#dcc06d"),
                        qa("M246.045 222.285c-2.286.403-4.81.675-7.155.715.086.062.292.218.376.277-2.749.221-5.644-.004-8.45.05 1.83-1.014 5.041-.52 7.119-.681 3.288-.256 6.456-1.229 9.807-.899-.6.179-1.074.429-1.697.538z")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g1009")
                ]), l([
                    A2(On, l([
                        Fa("g1011")
                    ]), l([
                        A2(Da, l([
                            Fa("path1013"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M227.733 176.94c-3.65-.841-7.701-3.25-11.591-2.555-1.711.306-4.057 2.445-3.673 4.22.28 1.286 1.967 1.761 3.191 1.972 6.038 1.04 11.794 1.711 17.376 4.167 4.525 1.991 9.32 3.552 13.737 5.738 1.58.781 2.975 1.881 4.55 2.686 1.949.998 4.005 2.34 2.356 4.558-2.941 3.958-8.484 3.937-13.027 4.812-3.03.583-6.07 1.132-9.122 1.613-1.499.237-6.799-.551-7.71.744-.399.572.149 2.039.16 2.691.015.754-.721 1.917-.633 2.458.215 1.295 4.512.592 5.604.57 3.702-.068 7.462-.994 11.12-1.469 4.266-.555 8.56-2.189 12.618-3.566 4.523-1.535 12.019-5.503 9.296-10.924-1.247-2.482-3.736-3.825-5.726-5.722-3.15-3.01-8.22-4.526-12.315-6.271-2.912-1.237-5.811-2.516-8.86-3.438-2.421-.733-4.875-1.713-7.351-2.284z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1015"),
                            Ha("#dcc06d"),
                            qa("M252.984 193.96a54.45 54.45 0 0 0-9.148-5.283c-1.377-.624-2.829-1.079-4.229-1.659-2.111-.875-4.093-1.838-6.296-2.542-3.27-1.045-6.633-1.933-9.95-2.862-1.907-.534-3.786-1.054-5.735-1.435-.842-.164-2.455-.082-3.137-.484-1.062-.625-.823-1.743-.382-2.695 1.201-2.587 4.965-1.286 7.115-.84 3.171.658 6.136 1.905 9.214 2.953 2.367.808 4.677 1.776 7.048 2.594 1.86.642 6.187 1.73 7.201 3.325-2.039-.31-3.941-.906-5.932.212 1.794.135 3.686 1.135 5.386 1.65.629.191 1.724.663 2.403.503-.018.003 1.312-.334.902-.536 1.963.974 3.924 2.074 6.009 2.888 1.476.576 3.234 1.113 4.026 2.499 1.482 2.601-2.127 5.228-4.195 6.409 1.009-.242 1.47-1.454 1.479-2.336.015-1.319-.743-1.624-1.779-2.361z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1017"),
                            Ha("#ccb25c"),
                            qa("M255.117 189.875c-.015-.011-.028-.021-.044-.031-2.761-1.982-5.433-3.758-8.784-4.828-2.198-.702-4.45-1.284-6.561-2.195.412.234.689.447.689.888-2.771 1.209-6.544-.707-9.075-1.733-1.227-.497-2.556-.969-3.73-1.559-.991-.497-1.771-1.516-2.982-1.38-.65 1.837-5.415.69-4.738-1.137.271-.735 1.655-.573 2.331-.742-1.09.263-2.92-1.533-4.197-1.545-2.195-.017-3.852 2.023-1.772 3.576 2.298 1.716 5.942 1.851 8.711 2.506a45.97 45.97 0 0 1 10.828 4.081c4.063 2.139 8.186 2.91 12.739 2.384 1.871-.217 3.403.483 4.41 2.06.843 1.328.31 4.048-1.593 2.194.569.555 1.831.475 2.434 1.059 1.894 1.836 1.354 4.473-.69 5.859 1.464-.954 3.531-2.448 4.427-3.897 1.615-2.618-.305-4.052-2.403-5.56z")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path1019"),
                        Ha("#dcc06d"),
                        qa("M224.246 210.19c.045.008.974-1.864.996-1.998.174-.975-.37-2.045-1.053-2.763.725-.321 1.795-.17 2.636-.169-.773-.023-1.585.125-2.041.671.458.448.398.472.389 1.09 0 .07 4.159-.497 4.558-.468-1.026.4-3.438.358-3.455 1.716-.943.077-1.304.968-.562 1.471.519.352 2.751-.056 3.284-.151-.906 1.257-3.429.811-4.752.601z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1021"),
                        Ha("#dcc06d"),
                        qa("M251.86 204.724c1.488-.355 3.12-1.064 4.091-2.146-.07-.137-.134-.236-.198-.357 1.443-1.081 3.277-1.508 4.56-2.804-2.378 2.997-4.835 3.563-8.452 5.127")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g1023")
                ]), l([
                    A2(On, l([
                        Fa("g1025")
                    ]), l([
                        A2(Da, l([
                            Fa("path1027"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M172.767 209.716c-1.192-.375-2.335-.742-3.385-1.026a82.962 82.962 0 0 1-13-4.707c-2.874-1.323-7.189-3-9.465-5.063-2.383-2.16-2.323-6.621.302-8.404 5.9-4.008 13.017-7.062 19.81-9.531 5.672-2.063 11.466-3.955 17.359-5.405 3.121-.768 11.568-2.125 9.645 3.216-1.39 3.857-5.04 2.559-8.381 3.106-2.945.483-5.718 1.831-8.56 2.731-3.419 1.082-6.543 2.362-9.816 3.838-2.854 1.288-7.498 3.076-9.412 5.535-2.315 2.974 1.75 3.622 4.174 4.613 4.386 1.798 7.869 3.287 12.593 4.229 5.263 1.051 10.903-.225 10.056 6.786-.522 4.289-9.603.814-11.92.082z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1029"),
                            Ha("#dcc06d"),
                            qa("M164.061 188.784c-1.318.578-2.573 1.227-3.697 2.005-2.261 1.562-6.577 5.477-1.804 6.844-2.947-.844-7.969-2.749-7.103-6.359.639-2.662 6.084-7.62 9.289-5.944-.27.371-.266.838-.419 1.132 4.828.078 10.456-2.834 14.753-4.713.702-.307 8.715-3.513 5.324-3.742a78.096 78.096 0 0 1 9.197-2.427c3.914-.777 2.686 3.487.636 4.798-2.227 1.424-5.392 1.25-7.955 1.639-3.662.553-5.909 1.904-9.192 3.316-2.838 1.221-6.091 2.16-9.029 3.451z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1031"),
                            Ha("#ccb25c"),
                            qa("M156.507 196.23c-4.458-1.483-6.157-5.337-2.077-8.278-.497 1.199-.698 3.632.916 4.058 1.207.318 3.704-1.609 4.97-2.102-1.122 1.033-5.781 5.326-3.809 6.59")
                        ]), M),
                        A2(Da, l([
                            Fa("path1033"),
                            Ha("#ccb25c"),
                            qa("M175.384 183.626c.982-.337 1.638-.969 1.704-1.838-2.25-.123-4.103.385-6.271.724.494-.269.702-.687 1.053-.978-1.889-.245-6.208 1.24-7.715 2.316 5.267-3.071 11.065-4.319 16.818-6.058 3.739-1.131 6.941-2.142 10.921-1.904.092 1.51.021 2.841-.587 4.204-5.008-.017-9.759 2.253-14.47 3.264")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path1035"),
                        Ha("#dcc06d"),
                        qa("M175.965 209.641c2.374.386 4.519.909 6.942.764-.059-.944.714-2.107.317-3.177-.468-1.266-1.406-.854-2.041-2.047.125-.053-.798.461-.839.489.983.583 1.256 1.886.297 2.508.296-.054.897.167 1.372.167 1.363 2.205-3.962.818-5.176.759-2.326-.113-4.565-.081-6.592-1.301 1.706.733 4.681 1.923 6.592 1.837")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g1037")
                ]), l([
                    A2(Da, l([
                        Fa("path1039"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M182.353 196.141c1.241-.469.418-.985.195-2.115-.362-1.842 2.762-3.477 1.704-4.814-.996-1.258-5.113-1.311-6.589-1.475-3.777-.419-6.927-.992-10.405-2.325-1.919-.736-3.829-1.408-5.813-1.961-.999-.279-2.795-.345-2.908-1.433-.292-2.813 5.13-4.851 7.208-5.723 6.528-2.743 12.668-4.674 19.892-5.36 2.366-.225 8.897-.311 9.303-3.22.101-.723.12-2.288-.426-2.873-.704-.759-1.543-.514-2.479-.389-3.378.454-6.732 1.146-10.005 1.953-3.839.947-7.834 1.192-11.646 2.281-4.661 1.331-9.682 2.783-13.891 5.102-3.36 1.851-7.105 5.165-6.875 9.085.174 2.943 3.1 4.832 5.581 6.253 1.65.946 3.486 1.418 5.286 2.042 2.432.841 4.67 2.093 7.211 2.641 2.056.442 4.367 1.138 6.486 1.305 2.178.175 6.097 1.809 8.171 1.026z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1041"),
                        Ha("#ccb25c"),
                        qa("M162.602 176.473c-1.44.979-3.079 2.143-3.94 3.627-.653 1.124-.638 3.557 1.18 3.896-3.492-1.028-5.418-5.109-3.053-7.875 2.071-2.424 5.719-2.97 7.947-4.69.832 1.137 6.011-1.252 7.124-1.755 2.455-1.113 5.033-1.407 7.798-1.828 4.486-.683 8.902-1.454 13.278-2.11-.821.699.15 2.165-.826 3.097.066.07.147.118.245.14-1.277.004-3.131.792-4.381 1.068-1.2.266-2.417.359-3.635.5.702-.275 1.508-.599 1.664-1.362-1.716-1.275-6.396.461-7.466 1.947 1.321-.175 2.627-.647 3.951-.74-1.379.706-3.274.957-4.771 1.36-2.083.561-4.283.947-6.388 1.469-3.058.758-6.152 1.505-8.727 3.256z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1043"),
                        Ha("#dcc06d"),
                        qa("M150.832 179.857c1.036-1.079 1.29-2.507 2.678-3.541 1.161-.863 2.569-1.631 3.863-2.33 2.934-1.587 6.149-2.896 9.482-3.561-.101.082-.19.086-.328.155 1.943-.333 3.834-.995 5.792-1.24.347 1.133-2.969 1.857-3.96 2.101-1.459.358-2.435.497-3.86 1.139-2.324 1.047-4.938 1.299-6.912 2.945-1.335 1.113-3.341 3.398-2.371 5.186-1.197-2.204-2.165-3.165-4.384-.854z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1045"),
                        Ha("#dcc06d"),
                        qa("M179.45 192.745c.649.215 1.366.569 1.728 1.032-.163.065-.334.144-.499.214 1.231 1.228.031 1.942-1.377 1.421 4.286 1.487 1.531-1.605 2.791-2.999-.191.003-.458-.067-.646-.063.807-.454 1.757-1.235 1.701-2.096-1.659.825-1.751 3.461-4.471 2.311")
                    ]), M),
                    A2(Da, l([
                        Fa("path1047"),
                        Ha("#dcc06d"),
                        qa("M153.313 186.128c.988 1.35 2.155 1.906 3.804 2.302-.284-.311-.461-.618-.829-.886.082.023.321.073.311.071-1.519-.58-3.657-1.032-4.564-2.363.458.976 1.73 1.464 2.632 1.949")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g1049")
                ]), l([
                    A2(Da, l([
                        Fa("path1051"),
                        Ha("#f9e3b7"),
                        Ua("#967348"),
                        Ba(".335"),
                        qa("M217.651 164.095c-.213-.043-.424-.088-.637-.133-2.743-.568-5.257 1.697-4.311 4.462.883 2.571 5.387 1.481 7.571 1.992 3.728.874 7.352 2.118 11.142 2.763a43.096 43.096 0 0 1 9.091 2.58c2.085.845 4.138 1.926 5.929 3.216 1.508 1.086 4.035 2.817 2.686 4.753-1.049 1.507-3.897 2.584-5.62 3.2-3.483 1.243-7.191 1.742-10.796 2.531-2.15.47-4.197.902-6.386 1.248-.973.153-2.797.307-3.396 1.168-.639.915.117 1.326.356 2.249.411 1.597-.88 3.984 1.857 3.984 3.432-.001 7.435-1.178 10.723-2.034 3.096-.806 6.097-1.979 9.164-2.789 2.388-.631 4.454-1.127 6.656-2.329 1.138-.622 2.337-1.302 3.278-2.151 3.612-3.27 3.173-7.628.305-11.201-2.503-3.116-6.508-4.84-10.144-6.57-2.713-1.29-5.799-2.739-8.875-2.965-2.855-.209-5.652-.822-8.434-1.568-3.303-.888-6.766-1.692-10.159-2.406z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1053"),
                        Ha("#ccb25c"),
                        qa("M238.579 169.725c4.012.742 8.265 2.493 11.223 4.476 1.436.962 3.406 2.823 3.95 4.387.888 2.554-2.13 5.043-4.529 5.685.716-1.835 1.618-2.564.102-4.1-1.474-1.491-3.169-2.969-5.076-3.973-4.786-2.518-9.951-3.169-15.194-4.394a136.257 136.257 0 0 1-6.66-1.758c-2.651-.767-5.036-1.26-7.687-1.476-.019-.144.139-.136.147-.278-.665-.368-.878-.966-.757-1.653.239-1.344 1.506-1.233 2.662-1.61-.29-.107-.559-.279-.853-.375 1.61.474 3.434.874 5.134 1.095-1.103-.011-3.873-.379-2.467 1.252 1.326 1.537 3.528 1.458 5.36 1.987 2.047.589 3.962 1.403 6.091 1.903 1.279.3 4.406 1.591 5.616 1.351 2.354-.464-.691-1.991-.997-2.894 1.243-.012 2.576.123 3.935.375z")
                    ]), M),
                    A2(Da, l([
                        Fa("path1055"),
                        Ha("#dcc06d"),
                        qa("M221.077 166.282c-.595 0-3.175-.295-3.073.711.096.94 3.146 1.491 3.852 1.667 2.107.527 3.969 1.303 5.998 2.053 2.466.912 5.255 2.204 7.951 2.503.94.104 2.081.434 2.322-.672.282-1.291-1.519-1.583-2.286-2.163 2.286-.165 5.181.837 7.1 1.373-.912-1.585-5.08-2.098-6.993-2.567-3.063-.75-6.291-1.447-9.382-1.809.398 1.382-4.33.042-4.893-.885.235-.018.512-.073.744-.072-.84-.321-2.188-.668-3.218-.635.079.013.365.1.448.13-.177.123-.079.222.077.366")
                    ]), M),
                    A2(Da, l([
                        Fa("path1057"),
                        Ha("#dcc06d"),
                        qa("M224.368 193.281c-.243.268-.514 3.288-.156 3.719.845 1.003 4.101.225 4.786-.464-1.644-.027-3.484 1.057-3.689-.747-.215-1.878 1.821-.496 3.11-1.395-1.136-.208-2.163.368-3.262.28.062-.113.153-.187.203-.319-.32-.139-.476-.399-.958-.388-.091-.116-.12-.345-.198-.461.102-.137.246-.135.358-.224")
                    ]), M),
                    A2(Da, l([
                        Fa("path1059"),
                        Ha("#dcc06d"),
                        qa("M253.41 182.017c-1.646 1.349-3.365 3.172-5.558 3.771 1.659-.988 2.954-2.442 2.055-4.263.512.576.846 1.4.424 2.064 2.101.215 4.311-3.579 3.27-4.816.288 1.186.911 2.951-.578 3.601")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g1061")
                ]), l([
                    A2(On, l([
                        Fa("g1063")
                    ]), l([
                        A2(On, l([
                            Fa("g1065")
                        ]), l([
                            A2(Da, l([
                                Fa("path1067"),
                                Ha("#f9e3b7"),
                                Ua("#967348"),
                                Ba(".335"),
                                qa("M194.724 160.448c1.19-.378 2.04-.979 2.279-1.929 1.189-4.733-12.893-3.431-15.258-3.069-5.947.911-11.753 2.6-17.296 4.772-3.986 1.563-10.928 4.672-9.313 9.726 1.576 4.927 11.25 6.079 15.691 7.191 2.419.605 4.97 1.705 7.483 1.854 1.375.082 3.842.616 4.668-.514.546-.747.911-1.592 1.522-2.299.412-.474 1.42-.976 1.48-1.634.141-1.577-2.255-1.564-3.367-1.716-3.717-.507-7.423-1.673-10.972-2.48-1.354-.308-5.175-.492-5.694-1.889-.745-1.997 2.508-2.936 3.982-3.549 3.908-1.628 8.085-2.484 12.173-3.613 2.229-.616 9 .3 12.622-.851z")
                            ]), M),
                            A2(Da, l([
                                Fa("path1069"),
                                Ha("#ccb25c"),
                                qa("M172.581 162.965a22.295 22.295 0 0 0-3.792 1.415c-3.042 1.475-5.382 4.021-1.026 5.669-2.215-.838-5.115-.956-6.711-2.805-4.276-4.948 8.466-8.024 11.617-8.874 1.491-.403 9.123-1.207 9.273-2.259-3.775 1.159-7.937 2.429-10.604 5.298 1.333.468 2.539.556 3.864.223 2.725-.682 5.716-1.126 8.468-1.917 1.063-.305 6.946-2.082 6.25-3.231 1.052-.006 2.262-.18 3.251-.375-.184 1.696-1.347 3.294-1.761 4.968-1.736-1.371-6.977-.212-9.047.154-3.461.614-6.639.864-9.782 1.734z")
                            ]), M)
                        ])),
                        A2(Da, l([
                            Fa("path1071"),
                            Ha("#dcc06d"),
                            qa("M171.899 161.992c2.415.808 6.844-.844 9.302-1.302 1.153-.214 5.549-.576 5.92-1.604 1.454-.61 3.407-.87 3.996-2.447-2.072-1.292-4.392-.601-6.781-.731.402.023.645.234.96.353-.695 1.343-3.81 2.066-5.283 1.805-2.27-.401-.291-.798.735-1.411-2.2.718-4.551.906-6.679 1.802-1.87.791-2.793 2.559-4.671 3.394.532.591 2.722.635 3.663.498")
                        ]), M),
                        A2(Da, l([
                            Fa("path1073"),
                            Ha("#dcc06d"),
                            qa("M176.739 177.546c1.004.548 3.594 1.102 4.241-.143-.112-.065-.296-.139-.354-.175.68-.134 1.299-.412 2.039-.407-.075.026-.106.076-.094.152.394-.033 1.075-.283 1.335-.674.579-.872.28-.467-.39-.903-.625-.405-2.098-.261-2.856-.545 1.298.415 2.81.146 4.162.219-1.361 1.729-2.326 4.085-5.029 3.917-1.313-.083-2.124-.822-3.248-1.311-.906-.395-1.832-.456-2.642-.858 1.254.198 2.653.664 3.803 1.086")
                        ]), M),
                        A2(Da, l([
                            Fa("path1075"),
                            Ha("#dcc06d"),
                            qa("M156.217 167.355c-.352.837-.39 3.092 1.142 2.579-.659.841.095 2.026.77 2.721-1.044-1.363-3.09-3.801-1.912-5.479")
                        ]), M),
                        A2(Da, l([
                            Fa("path1077"),
                            Ha("#dcc06d"),
                            qa("M160.089 167.534c-1.527-1.092-1.618-3.396.126-4.408-.29.391-.46.816-.528 1.298.03-.067.085-.096.164-.087-.722 2.429 2.617 4.418 4.718 5.083-1.652-.826-4.474-.883-5.254-2.779")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path1079"),
                        Ha("none"),
                        Ua("#967348"),
                        Ba(".191"),
                        qa("M164.542 168.785c-2.102-.482-4.548-1.906-3.915-4.112.684-2.382 3.88-2.881 5.85-4.113")
                    ]), M)
                ])),
                A2(On, l([
                    Fa("g1081")
                ]), l([
                    A2(On, l([
                        Fa("g1083")
                    ]), l([
                        A2(Da, l([
                            Fa("path1085"),
                            Ha("#f9e3b7"),
                            Ua("#967348"),
                            Ba(".335"),
                            qa("M235.147 173.348c-2.284.427-4.577.759-6.846 1.209-1.707.338-4.42-.207-5.826.878-3.551 2.744 3.65 3.848 2.488 6.186 1.07.138 1.494-.354 2.352-.458 1.455-.177 2.741.02 4.157-.327 5.417-1.33 12.065-.976 16.517-4.687 2.933-2.445 4.571-7.067 2.407-10.283-3.149-4.688-10.213-6.81-15.767-7.858-5.488-1.037-11.373-2.042-17-2.096-1.597-.016-2.572-.323-2.384 1.188.158 1.271 1.188 2.994 1.817 4.153.793 1.455 2.265 1.885 3.897 2.186 3.199.585 6.454-.012 9.67.041 3.427.056 10.746.596 12.175 4.158 1.255 3.125-2.994 4.463-5.498 5.2-.709.208-1.428.373-2.159.51z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1087"),
                            Ha("#ccb25c"),
                            qa("M246.91 167.564c.457-2.455-1.636-5.067-3.774-6.314-2.586-1.508-5.935-1.474-8.856-1.936-1.604-.255-3.037-.446-4.684-.537-1.117-.063-3.107.059-4.055-.461 1.655.306 3.875 2.133 1.195 2.606-1.907.336-4.176-.155-5.049-1.792-.367-.685.16-.958-.621-1.573-.644-.506-.906-.151-1.61-.252-1.683-.24-3.385-.407-4.933-1.018-.205 1.342-2.086 3.789-1.005 4.951 1.003 1.081 3.477.494 4.867.564 1.481.076 2.995.268 4.483.411 4.311.417 8.766-.03 12.912.98 2.441.594 5.411 1.013 7.062 2.99 1.843 2.206.252 3.733-1.376 5.468.812 1.14 4.949-2.737 5.17-3.224a3.56 3.56 0 0 0 .274-.863z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1089"),
                            Ha("#dcc06d"),
                            qa("M229.013 162.219c1.154-.475 1.301-1.285.017-1.797.501-.125 1.005-.26 1.462-.393a4.857 4.857 0 0 0-1.432-.684c2.606-.362 5.55.721 8.03 1.006-2.978-1.608-7.759-2.099-11.164-2.65-2.672-.434-5.206-.389-7.677-1.23a.521.521 0 0 1 .094.306c-.619.046-1.272.015-1.893.057.359 1.375 2.159 1.609 3.103 2.384 1.224 1.001 2.396 1.833 3.98 2.301 1.355.399 4.164 1.241 5.48.7z")
                        ]), M),
                        A2(Da, l([
                            Fa("path1091"),
                            Ha("#dcc06d"),
                            qa("M240.438 164.494c2.143 1.448 4.658 3.244 2.671 5.722-1.971 2.458-4.732 3.086-7.497 3.893 2.463.128 5.482-1.561 7.729-2.464 4.029-1.615 4.462-3.947 2.547-7.266.746 1.293 1.118 3.04.465 4.431-.717 1.521-2.438 1.868-3.763 2.807 2.158-2.446 1.99-4.84-1.115-6.386.117.259.312.214.512.336")
                        ]), M),
                        A2(Da, l([
                            Fa("path1093"),
                            Ha("#dcc06d"),
                            qa("M225.528 177.904c.567.049 1.12.127 1.675.168-3.357 1.576 2.81 1.906 4.26 1.065-.159.078-.33.178-.493.242.851 1.38 3.855.313 5.195.177 2.037-.206 6.759-.331 8.254-1.679-5.21 1.421-10.428 2.661-15.749 2.351-2.277-.131-5.481-1.236-6.213-3.545.67-.047 1.363-.027 2.046-.035-.666-.006-1.128.278-1.073.867 1.041.481 2.113.389 3.261.389")
                        ]), M)
                    ])),
                    A2(Da, l([
                        Fa("path1095"),
                        Ha("none"),
                        Ua("#967348"),
                        Ba(".191"),
                        qa("M241.019 160.739c2.578.819 5.302 3.243 5.876 5.745.481 2.104-1.402 3.229-3.167 4.268")
                    ]), M)
                ]))
            ])),
            A2(On, l([
                Fa("g1617")
            ]), l([
                A2(Da, l([
                    Fa("path1619"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M219.859 143.315c-.77.953-2.785 1.69-4.007 1.524-.663-.089-1.367-.565-2.056-.27-.247.106-.802.669-.825.981-.041.52.397.321.595.792.337.793-.631 1.711.151 2.485.772.762 2.195.129 2.952-.348.892-.563 1.583-1.199 2.67-1.283.89-.067 1.683.23 2.568.292 2.252.156 4.666 1.851 6.144 3.407.64.673.597 1.334.917 2.138.447 1.121.8 1.951.946 3.181.227 1.887-.815 5.035-3.267 5.09-.062.842.092 1.671.104 2.501.676.019.896-.262.883.418-.009.444-.635.82-.583 1.145.077.47 2.097 1.613 2.568 1.661.683.067 1.044-.335 1.637-.787 1.395-1.065 2.885-2.047 4.216-3.128.898-.73.652-1.588.715-2.629.108-1.834 1.355-3.758 1.005-5.617-.288-1.51-2.091-2.895-3.242-3.88a247.195 247.195 0 0 1-4.98-4.352 7.746 7.746 0 0 1-1.418-1.702c-.308-.491-.49-1.487-1.02-1.799-.569-.337-1.602-.105-2.266-.214-.979-.161-.697-.233-1.205-.948-.526-.741-2.182-1.018-2.809-.025-.265.424-.033.917-.393 1.367z")
                ]), M),
                A2(Da, l([
                    Fa("path1621"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M187.367 143.324c.768.955 2.785 1.692 4.006 1.525.664-.09 1.367-.566 2.055-.27.25.106.804.67.827.981.04.519-.396.32-.595.791-.338.793.63 1.711-.152 2.484-.771.763-2.195.129-2.951-.347-.893-.562-1.583-1.199-2.672-1.282-.889-.068-1.681.231-2.567.292-2.251.155-4.666 1.851-6.145 3.407-.64.672-.597 1.334-.917 2.137-.448 1.122-.8 1.951-.947 3.181-.226 1.888.818 5.035 3.267 5.09.063.841-.091 1.67-.104 2.5-.676.019-.896-.262-.882.418.009.444.635.821.582 1.146-.078.47-2.099 1.614-2.567 1.66-.684.068-1.044-.333-1.637-.786-1.396-1.066-2.887-2.048-4.217-3.129-.897-.729-.652-1.587-.714-2.629-.108-1.833-1.357-3.758-1.004-5.617.288-1.509 2.089-2.895 3.242-3.879a241.416 241.416 0 0 0 4.979-4.353 7.717 7.717 0 0 0 1.419-1.701c.307-.492.491-1.487 1.019-1.799.572-.336 1.602-.105 2.265-.214.98-.161.7-.234 1.206-.947.527-.742 2.182-1.019 2.809-.025.264.422.033.917.395 1.366z")
                ]), M),
                A2(Da, l([
                    Fa("path1623"),
                    Ha("#dcc06d"),
                    qa("M181.596 149.296c-3.069 2.302-5.27 4.995-4.633 9.104-3.174-2.829-.38-7.542 2.223-9.6.697-.553 1.621-.604 2.324-1.068 1.175-.774.3-1.012 1.011-1.971a22.815 22.815 0 0 1-1.35-.621c1.688-.663 3.644-.863 5.475-.487 1.323.271 2.638.996 3.833 1.603 1.216.617 1.268.526 1.25 1.956-1.606-.365-2.782-1.722-4.537-1.602-1.869.129-4.116 1.575-5.596 2.686z")
                ]), M),
                A2(Da, l([
                    Fa("path1625"),
                    Ha("#dcc06d"),
                    qa("M219.915 146.78c-.667.042-4.485 2.622-4.454 1.075.018-.791 2.51-1.833 3.168-1.916.994-.122 2.335.311 2.745-1.099.563.483 1.51.455 1.646-.211.742.326 1.508.254 2.252.506 1.533.521 2.988 1.608 4.168 2.695 1.092 1.003 2.429 2.179 3.037 3.571 1.22 2.796-1.427 8.264-3.741 10.034 3.363-3.683 1.476-9.772-2.209-12.498-1.733-1.278-4.508-2.289-6.612-2.157z")
                ]), M),
                A2(Da, l([
                    Fa("path1627"),
                    Ha("#dcc06d"),
                    qa("M171.278 158.773c.372.726.856 1.374 1.19 2.119-.756.068-.768.736-.689 1.407-.588-.86-.491-2.687-.501-3.704")
                ]), M),
                A2(Da, l([
                    Fa("path1629"),
                    Ha("#dcc06d"),
                    qa("M233.142 161.276c.837-.477 1.895-.463 1.819.701.175-.267.438-.416.549-.867.019.036.102.192.14.288.175-.987.39-2.092.365-3.107-.919 1.172-1.578 2.09-2.873 2.807")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path415"),
                Ha("none"),
                Ua("#ccb25c"),
                Ba(".322"),
                qa("M184.152 266.588c-.886-.474-4.267-.147-4.114.178"),
                ln("inline"),
                zn("visible")
            ]), M),
            A2(Da, l([
                Fa("path849"),
                Ha("#f9e3b7"),
                Ua("#967348"),
                Ba(".335"),
                qa("M264.042 300.578c1.171-.396.789-1.785.439-2.79-.98-2.826-3.354-5.408-5.707-7.362-3.044-2.522-6.597-4.517-9.961-6.641-4.553-2.873-10.225-3.771-14.935-6.385-4.774-2.651-8.089-7.21-13.161-9.552-1.573-.727-8.516-4.165-9.512-1.608-.356.919-.15 2.088.232 3.038 1.105 2.749 4.304 1.246 6.446 2.62 3.124 2.004 5.869 4.155 8.265 6.924 1.184 1.367 1.655 2.938 3.282 3.936 1.719 1.055 3.828 1.391 5.782 1.892 4.538 1.165 9.504 2.754 13.543 4.998 4.371 2.427 7.947 5.591 11.594 8.818.857.761 1.743 2.302 3.125 2.215.221-.014.409-.049.568-.103z")
            ]), M),
            A2(Da, l([
                Fa("path851"),
                Ha("#dcc06d"),
                qa("M214.881 266.945c-1.454.179-.469 2.126.343 2.48.195-.229.587-.304.766-.486 1.425 1.106 3.345 1.536 4.903 2.611 2.125 1.466 4.285 3.343 5.811 5.349-.23-1.513-2.596-3.966-3.827-4.969 2.846 1.232 5.106 3.899 7.349 5.882 1.011.895 2.171 1.981 3.436 2.557 1.113.505 2.331.519 3.436.902-2.425-.966-4.434-3.196-6.338-4.815-2.12-1.8-4.36-3.531-6.635-5.18-1.926-1.394-3.984-2.319-6.1-3.437-1.126-.594-2.27-1.546-3.336-1.609")
            ]), M),
            A2(Da, l([
                Fa("path853"),
                Ha("#ccb25c"),
                qa("M213.177 269.958c.833-.35 1.964-.002 2.8.157a.24.24 0 0 0-.104.182c3.601 1.716 5.955 3.419 8.888 6.127 2.005 1.851 5.154 6.654 8.455 6.262-3.707-1.696-5.509-4.484-8.214-7.156-1.479-1.458-2.856-2.979-4.506-4.266-1.152-.897-2.95-1.684-3.856-2.681.188-.025.363-.037.55-.066-1.318-.745-3.657-1.341-4.604-2.433a.613.613 0 0 1 .292-.043c-1.654-.145.109 3.996.299 3.917z")
            ]), M),
            A2(On, l([
                Fa("g1097"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".335")
            ]), l([
                A2(Da, l([
                    Fa("path1099"),
                    qa("M193.795 182.139c1.934-.521 1.829-3.034 2.065-4.592.299-1.992-2.435-3.047-4.176-3.218-1.026-.101-2.012-.42-3.035-.535-.42-.047-2.113-.437-2.404-.354-1.405.404-.959 1.923-1.761 2.864-.756.889-2.218 1.223-2.449 2.444 2.195.943 5.076.784 7.127 2.106 1.398.901 2.766 1.786 4.633 1.285z")
                ]), M),
                A2(Da, l([
                    Fa("path1101"),
                    qa("M216.432 175.86c-1.184.191-2.267.497-2.886.876-1.881 1.153-2.579 5.156-.452 6.468 1.597.984 2.976-.341 4.354-.804 1.985-.667 4.295-.031 6.34-.563 2.321-.604.041-2.357-.836-3.107-.392-.333-1.087-.697-1.253-1.194-.132-.391.336-.904.2-1.261-.296-.769-.217-.921-1.35-1.033-1.421-.139-2.739.396-4.117.618z")
                ]), M),
                A2(Da, l([
                    Fa("path1103"),
                    qa("M238.084 252.427c-.135-1.169-2.075-2.385-2.653-3.451-1.047-1.929-.098-2.354 1.535-3.286-.889-.618-2.224-.798-3.266-1.206-1.998-.781-3.943-1.84-5.459-3.287-.747-.71-2.287-2.558-1.172-3.509 1.013.402 8.333 4.505 8.27 1.722-.021-.927-3.318-4.7-.668-4.71-.49.002-1.922-.898-2.423-1.109-.633-.267-.985-.488-1.528-.858-1.032-.703-2.087-1.389-3.098-2.12-.99-.716-2.882-1.929-2.852-3.254.039-1.832 3.16-1.401 4.46-1.952 1.69-.715.056-1.752-.621-2.764-.553-.832-.146-1.272-.134-2.145.021-1.791-1.255-1.526-2.689-1.622-1.575-.105-3.135-.479-4.718-.698-2.342-.324-4.219-1.243-6.382-1.961-1.792-.595-6.296-1.096-4.918 2.003.495 1.114 1.907 1.597 2.762 2.442 1.353 1.337 2.794 2.807 4.018 4.236 1.267 1.48.484 2.842.602 4.424.043.553 1.454 3.195.638 3.496-1.374.5-4.034-3.276-4.699-4.104-1.491-1.855-3.651-4.8-6.558-3.417-2.603 1.236.335 4.012 1.422 5.133.616.635.533.823.921 1.475.926 1.555 2.418 2.95 3.489 4.505a51.267 51.267 0 0 1 3.688 6.352c.527 1.078.811 2.413 1.54 3.361 1.45.336-.179 1.038-.251 1.28-.269.902.092 1.78.393 2.69.666 2.019 1.945 3.75 3.394 5.356 1.548 1.72 2.749 3.598 4.397 5.238 1.913 1.9 4.592 3.797 5.475 6.297 1.03 2.92 2.511 5.708 4.341 8.271 1.711 2.396 3.929 3.981 5.88 6.066 3.167 3.385 6.324 7.042 10.054 9.947.882.686 2.259 1.89 3.462 1.751.032-1.092-1.061-2.309-1.325-3.366-.131-.521-.276-1.027-.151-1.574.08-.339.915-1.049.894-1.331-.112-1.692-5.41-3.504-4.048-5.664.165-.261 5.177 1.647 6.371.69 1.401-1.123-.422-1.903-.996-3.068-.604-1.228-.468-2.4-.591-3.655-5.882.867-10.641-2.843-14.629-6.369.949-1.003 9.513 1.19 5.452-1.822-1.048-.778-2.273-1.729-2.944-2.823-.223-.365-.687-.931-.549-1.392.029-.102.658-.922.712-.743-.326-1.093-1.83-.811-2.837-1.035-3.041-.679-4.345-2.468-6.695-4.013-2.308-1.518-4.432-3.233-5.351-5.799-.425-1.188-.691-2.191.962-1.686 1.521.47 7.64 4.615 9.073 3.058z")
                ]), M),
                A2(Da, l([
                    Fa("path1105"),
                    qa("M147.482 285.144c-.725.739.781 1.613-.25 2.864-.655.795-2.108 1.112-2.603 2.003-1.022 1.844 8.145-.636 8.845-.96 2.627-1.216 4.817-3.803 6.971-5.609 4.429-3.713 8.635-8.028 12.234-12.438 2.683-3.29 4.896-6.973 7.303-10.447 1.142-1.646 2.193-3.424 3.781-4.76.917-.771 2.143-1.184 3.05-1.949 1.021-.862 2.281-7.671-.081-7.351-.167-1.191 1.326-3.077 2.007-4.002 2.346-3.193 4.766-6.484 7.846-9.115.861-.737 1.577-1.52 2.36-2.265 1.288-1.23 2.33-1.84 2.48-3.683.091-1.105-.125-2.428-1.646-2.366-1.506.062-2.963 1.816-4.25 2.533-.98.547-5.919 3.718-6.805 2.164-1.413-2.478 4.555-5.989 6.12-6.817 1.182-.626 2.306-1.182 3.337-2.012 1.249-1.005 2.372-3.135 1.82-4.674-1.138-3.183-4.143-.438-5.773.588-1.43.899-3.256 1.374-4.864 1.874-1.725.535-3.541.878-5.299 1.106-1.04.134-2.813-.051-3.666.606-1.087.837.153 2.26-.381 3.507-.351.823-2.719 1.667-2.461 2.598.292 1.051 3.715-.191 4.386-.307 2.363-.41 1.979 1.302.9 2.366a3.362 3.362 0 0 1-.364.313c-1.727 1.286-3.824 2.036-5.821 2.881-.531.226-1.919.669-2.256 1.073-.384.46-.147 1.427-.266 1.983-.13.604-.406 1.165-.693 1.719-.248.48-1.67 1.981-.641 2.338.627.216 1.524-.261 2.146-.468 1.269-.425 7.737-3.651 6.58.018-.7 2.216-3.371 3.863-5.167 5.288-1.736 1.379-4.336 1.59-6.494 1.975-2.59.463-.815 1.716-.575 3.346.128.869-1.736 2.347-1.226 2.957.334.398 2.17-.086 2.639-.1.881-.027 3.1-.292 3.799.336a.805.805 0 0 1 .082.084c.498.607-.329 1.629-.749 2.292-1.138 1.791-3.205 3.328-5.276 4.11-2.094.792-5.137 1.107-5.622 3.599-.07.359-.502 3.154-.121 3.316 1.367.583 6.27-1.054 6.57.203.47 1.962-4.9 4.017-6.333 4.668-2.428 1.104-7.116 1.354-7.615 4.104a9.622 9.622 0 0 1-1.586 3.752c-.385.538-2.289 1.766-2.246 2.369.113 1.573 3.95-.894 4.392.099.36.813-3.028 2.353-3.463 2.582-1.602.849-3.754.38-5.055 1.709z")
                ]), M),
                A2(Da, l([
                    Fa("path1107"),
                    qa("M195.526 196.942c1.806-1.719.641-5.144-1.528-6.132-1.157-.527-2.405-.235-3.649-.303-1.6-.087-3.143-.543-4.714-.802-1.348-.222-3.304 2.49-3.474 3.576-.151.962.631 2.085.803 3.013 2.352-.143 4.75.014 7.082.305 1.523.19 3.596 1.526 5.057.662a2.3 2.3 0 0 0 .423-.319z")
                ]), M),
                A2(Da, l([
                    Fa("path1109"),
                    qa("M217.112 198.131c1.677.043 3.402.306 4.934-.201 2.452-.815 2.047-5.339-.572-5.535-2.316-.173-6.132-1.218-8.294-.296-2.099.894-3.594 3.545-2.201 5.495 1.12 1.566 2.512.949 4.18.652.635-.114 1.29-.132 1.953-.115z")
                ]), M),
                A2(Da, l([
                    Fa("path1111"),
                    qa("M184.437 208.74c-.327.834-.925 1.611-1.278 2.553 1.302.899 4.155.286 5.714.225 2.854-.111 11.441-.645 8.722-5.25-.743-1.259-2.568-1.772-4.013-1.41-3.194.802-5.587-.278-8.711-.483-2.363-.155-.747 1.255-.374 2.313.275.778.182 1.431-.06 2.052z")
                ]), M),
                A2(Da, l([
                    Fa("path1113"),
                    qa("M220.403 204.705c-1.101.012-2.2-.022-3.396-.141-2.728-.267-5.027.22-5.709 2.989-.363 1.474.333 3.417 2.313 3.448 1.446.022 2.662-.803 4.141-.713 1.583.096 3.067.537 4.679.157 2.34-.554 2.797-3.398 1.446-4.939-.991-1.129-2.064-.817-3.474-.801z")
                ]), M)
            ])),
            A2(On, l([
                Fa("g899")
            ]), l([
                A2(Da, l([
                    Fa("path901"),
                    Ha("#f9e3b7"),
                    Ua("#967348"),
                    Ba(".335"),
                    qa("M254.673 292.865c-.41.064-.655.238-1.124-.126-.93-.72-1.542-3.15-1.649-4.25-.307-3.093 2.359-1.816 4.422-1.546 1.717.223 3.819-.097 4.592-1.718 1.205-2.538-3.165-5.736-4.901-7.139-3-2.423-7.264-4.37-10.886-5.88-4.028-1.68-8.358-2.909-12.678-3.798-1.45-.298-3.453-.52-4.788-1.148-1.117-.526-1.886-1.581-2.774-2.319-2.455-2.039-4.729-4.5-7.659-6.022-1.536-.798-3.612-.896-4.952-1.892-1.418-1.052-2.393-3.882-1.22-5.346 1.6-1.999 4.176-.354 5.953.449 3.73 1.688 7.229 4.276 10.502 6.636 1.184.853 2.093 1.927 3.511 2.47 2.03.779 4.363 1.161 6.52 1.522 4.959.828 9.487 2.167 14.126 4.016 4.181 1.666 7.484 4.217 10.871 6.976 5.512 4.489 9.182 12.443 2.811 17.674-3.436 2.818-5.968 2.051-10.196 1.439a1.534 1.534 0 0 0-.481.002z")
                ]), M),
                A2(Da, l([
                    Fa("path903"),
                    Ha("#dcc06d"),
                    qa("M221.173 255.055c.894.297.063.624-.552.449-.631-.179-1.798-.577-2.054-1.169.303-.168.632-.002.934.153-.603-.49-1.561-.844-2.297-1.11-.813-.294-1.725-.814-2.595-.902.529.611 1.469 1.093 2.181 1.583-1.243-.304-2.493-1.014-3.732-1.221-.802-.135-.623.204-1.241.354.262.553 1.051.928 1.583 1.246-.789.006-1.389-.635-2.188-.621.116.669.612.641.988 1.057.356.393.514 1.048.787 1.502l-.239-.031c2.139 1.691 4.966 2.597 7.412 3.878 1.785.933 3.375 2.034 4.955 3.088-.362-.658-.984-1.571-.531-2.295 1.422.467 2.173 1.81 3.439 2.552 2.225 1.304 5.076 2.319 7.562 3.098 1.975.619 4.257 1.552 6.398 1.389 1.333-.101 2.094-.493 3.589-.276 4.761.689 8.024 2.206 11.916 4.713 3.775 2.429 8.09 5.384 7.163 10.368-.37 1.979-2.352 4.336-4.794 3.898 1.905-.684 1.419-3.469.764-4.792-1.013-2.05-2.799-3.658-4.805-4.887-2-1.228-3.444-3.083-5.514-4.275-2.081-1.2-4.625-1.247-6.765-2.231-1.553-.714-3.43-3.018-4.647-3.267")
                ]), M),
                A2(Da, l([
                    Fa("path905"),
                    Ha("#ccb25c"),
                    qa("M260.609 274.106c1.146.864 2.099 1.89 2.442 3.553.586 2.853 1.936 7.231-1.873 8.747 2.425-2.422-1.103-6.659-3.092-8.292-2.671-2.192-5.978-3.511-8.939-5.301-3.726-2.252-8.135-3.492-12.431-4.299-1.9-.357-3.963-.615-5.829-1.024-1.305-.286-1.719-.956-2.845-1.549-1.139.881-4.272-2.971-5.053-3.762-1.813-1.841-3.996-3.291-6.283-4.501-1.811-.958-5.452-1.114-5.17-3.607.642 1.333 4.121 1.669 5.449 2.307 2.399 1.15 4.796 2.763 6.97 4.28-.369-.407-.322-.603-.464-1.043 1.695.893 2.894 2.589 4.392 3.761 2.263 1.771 5.196 2.789 8.013 3.331 3.007.578 5.694 1.369 8.845 1.377-.092.11-.234.272-.31.353 2.109 2.197 7.053 2.79 9.943 3.91.599.232 2.22 1.218 2.791.808.758-.542.069-1.388-.376-1.819 1.158 1.118 2.598 1.852 3.82 2.77z")
                ]), M),
                A2(Da, l([
                    Fa("path907"),
                    Ha("#dcc06d"),
                    qa("M263.074 290.74c-1.313.922-2.448 2.153-4.257 1.979-1.717-.166-2.777-.907-3.628-2.208-.128-.194-1.602-2.902-1.166-2.973.748-.122 1.426.313 2.038.468-.375-.24-.847-.265-1.277-.298-.02.994.971 1.543 1.858 1.958-.295-.057-.608.036-.886.017.355 2.744 5.764 2.149 7.318 1.057z")
                ]), M)
            ]))
        ]))
    ]), fr = l([
        A2(Da, l([
            Fa("path593"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".322"),
            qa("M215.167 346.926c1.5-.815 2.696-2.308 3.88-3.331 3.02-2.604 5.527.485 6.585 3.407 1.543 4.255 2.068 9.056 1.016 13.488-.384 1.624-.519 3.139-2.193 3.684-1.364.445-3.208.202-4.504.876-.844.441-1.559 1.667-2.004 2.474-1.09 1.965-.83 3.723-1.532 5.721-.648 1.852-1.962 3.242-3.794 4.068-1.685.76-3.664 2.306-5.336 2.757-.636 1.858-.444 2.571-2.522 2.661-1.977.085-3.922.223-5.864 0-1.944-.223-2.444-.47-3.442-1.976-1.692-2.555-6.592-1.052-7.687-4.47-1.057-3.294.097-7.015-2.183-10.013-1.32-1.735-3.159-1.97-5.163-1.84-1.811.118-2.936.209-3.538-1.673-1.457-4.549-.792-9.993 1.558-14.132 1.612-2.841 5.653-4.695 8.422-2.598 4.084 3.093 8.613 4.362 13.789 4.339a34.76 34.76 0 0 0 6.603-.696c2.816-.571 5.591-1.487 7.909-2.746zm-23.91 14.299c-1.82-.345-3.877.67-4.858 2.202.712-.672 1.684-1.015 2.353-1.438-.224.141 2.521 2.737 3.7 2.106 1.482-.794-.024-2.65-1.195-2.87zm.357 6.724c2.052.099 1.25-1.993-.204-2.34-1.106-.262-2.888.72-3.858.49 1.401.331 2.622 1.78 4.062 1.85zm1.041 2.746c-.884-.457-2.435-1.227-3.405-.806 1.192.512 3.046 3.983 4.506 3.234 2.693-1.381-3.113-3.422-3.946-3.377m3.799 5.882c-.052-1.811-3.031-1.752-2.012.106.487.888 2.051 1.28 2.012-.106zm18.599-11.763c.687-.785 1.574-1.18 2.342-1.871.708.465 1.792 1.19 2.693 1.613-.39-.307-1.058-.996-1.536-1.257-1.269-.691-3.737-1.749-5.198-.959-.748.404-1.503 1.585-.875 2.415.8 1.055 2.615-.05 3.522-.32m1.879 2.613c-.97.229-2.751-.752-3.858-.49-1.452.347-2.254 2.439-.202 2.34 1.439-.07 2.661-1.519 4.06-1.85zm-2.257 3.648c-.834-.045-6.639 1.996-3.946 3.377 1.459.749 3.312-2.722 4.504-3.234-.97-.421-2.521.349-3.404.806m1.059 5.038c1.02-1.858-1.96-1.917-2.011-.106-.041 1.386 1.522.994 2.011.106z")
        ]), M),
        A2(On, l([
            Fa("g595")
        ]), l([
            A2(Da, l([
                Fa("path597"),
                Ha("#dcc06d"),
                qa("M191.233 359.975c.61-.203 1.098-.382 1.489-1.039.187-.316.626-2.252.446-2.54.563.899-.029 2.183.663 3.033.733.905 2.605.91 3.659 1.03 1.766.204 6.225.952 6.487-1.795-.01.634-.015 1.274.028 1.908 3.161.616 1.735-3.181.768-2.267-.062-.134-.196-.733-.203-.845 1.453-.023 2.908-1.089 4.322-1.574-.431 1.042-3.27 1.188-2.453 2.556.039-.097.151-.358.201-.436 0 .593.213 1.161.601 1.616.909-.287.352-1.087.384-1.853.101.938.958 1.276 1.821 1.478.192.046.35-2.604.438-2.821.312-.771 1.137-1.321 1.617-2.031-.521.771-1.209 2.255-1.229 3.188-.04 1.751 1.182 1.779 2.636 2.215 1.943.581 5.038 1.507 5.851 3.566-.803-.217-1.506-.649-2.183-1.075.71.827 1.44 1.838 1.943 2.848-1.497-.774-2.519-2.538-4.065-3.294-1.156-.567-3.79-1.207-5.063-.563-1.865.944-.173 2.329-.6 3.537 1.821 2.136 6.398-1.208 7.833 1.835-1.393-.627-2.726-1.053-4.244-1.123-.981-.045-4.372.934-2.163 2.142-.102.098-.245.372-.335.476.561.171.781.571.563 1.11 1.209-.172 2.988-.544 4.112.072 1.811.995.025 1.826.569 2.632-.934-1.384-2.097-2.645-3.935-2.399-1.073.144-3.649 1.417-3.226 2.819.331 1.076 1.898.749 2.79.981.591.153 2.803 1.589 3.208 1.467a3.302 3.302 0 0 0-1.307.73c-1.011-1.487-5.899-2.139-5.311.652.425 2.008 3.311 1.985 4.624.972-1.602 1.236-3.504 1.755-5.105 2.883-.143-.009-.211-.1-.384-.091-.254.61-.294 1.343-.256 1.992-1.374-.398-1.133-3.366-.749-4.452-.598-.112-1.029.138-1.167.716-.062-.089-.122-.172-.181-.348-.147.228-.561.562-.683.93.063-.445-.032-.919.082-1.341-1.565-.006-4.834.754-6.057-.299a24.866 24.866 0 0 0-.277 1.541c-.367-.646-.21-1.409-.27-2.147a2.002 2.002 0 0 1-1.234-.954c1.801.684 3.709 1.494 5.858 1.166 1.182-.18 3.003-.283 3.915-1.16.518-.498.755-.853.631-1.594-.109-.645-1.543-1.471-1.519-1.251.066.573-.02 1.107-.367 1.466-.853-2.904-6.194-1.199-8.504-2.057.375-1.895-6.348-3.118-7.306-2.845 2.806-1.952 4.815.776 7.368 1.138-.247-.813-.406-1.718-.284-2.623.283 1.105.475 2.707 1.276 3.4.123-.188.334-.352.52-.471 1.179 1.27 2.803 1.343 4.448 1.238.59-.037 6.21-1.703 6.022-1.976-.618-.896-.778-2.191-.189-3.148-.518.254-1.124.217-1.28-.38.168.015.451-.021.631-.029a.846.846 0 0 1-.435-.037 5.008 5.008 0 0 1-.087-.319c-.066-.073-.06-.07.018.01-2.735.565-6.935 2.262-9.759.327.047.044.095.085.145.125-1.639-.822-4.018-1.288-5.851-1.05.94-.122 3.159-.08 3.947-.471 1.125-.56.449-1.334.889-2.369-.001.879.064 2.18 1.006 2.455.794.231 1.17-.126.977-1.083.587 2.895 3.496 2.1 5.785 1.8.99-.129 2.355-.504 3.017-1.316 1.021-1.249-.194-2.268.433-3.55-4.271 1.425-8.556-.289-12.813-.604-3.329-.246-6.608.965-9.134 3.164-.118-.187-.152-.301-.226-.505 1.628-1.528 3.902-2.194 5.952-2.934.161-.058.315-.107.461-.155z")
            ]), M),
            A2(Da, l([
                Fa("path599"),
                Ha("#dcc06d"),
                qa("M223.329 345.422c-1.356.928-2.452 2.159-3.787 3.083-.813.562-1.884.863-2.647 1.249 1.544-.401 4.882-1.352 5.677-2.737.096.189.267.779.312 1.021-.984.718-2.175 1.007-3.112 1.766 1.278-.079 2.709-.815 3.871-1.363-.431.216-.771.601-1.056.933.851-.011 1.527-.628 2.285-.037-.992-1.69-1.103-4.93-3.434-5.412-.352.374-.715.74-1.086 1.095.322-.165.873-.233 1.244-.48.064.136.042.328.055.477.597-.066.971.207 1.111.786")
            ]), M),
            A2(Da, l([
                Fa("path601"),
                Ha("#dcc06d"),
                qa("M178.743 353.391c.23-2.4 2.187-5.14 4.226-6.404 2.635-1.632 4.163.401 6.72 1.669-1.375.019-3-.955-4.229-1.503.099.151.184.389.274.517-.974-.644-2.626-.26-2.447 1.177.183 1.475 2.69 2.532 3.935 2.65-1.681-.288-3.21-.948-4.604-1.874a.724.724 0 0 0 .127.274c-1.756-.124-3 1.363-3.49 2.878-.358 1.11-.436 1.473-1.081 2.513-.587.946-1.345 2.024-.75 3.167-.104-2.166.123-3.951 1.508-5.824")
            ]), M),
            A2(Da, l([
                Fa("path603"),
                Ha("#dcc06d"),
                qa("M225.608 353.581c-1.009.938.211 2.939.189 4.221-.02 1.077-.203 2.714-.536 3.438 1.105-1.994 1.592-5.614.347-7.659")
            ]), M),
            A2(Da, l([
                Fa("path605"),
                Ha("#dcc06d"),
                qa("M185.953 364.965c.479.251 1.037.469 1.519.674.832-.233 1.756-.425 2.598-.679-.833-.274-3.11-.673-3.737.005")
            ]), M),
            A2(Da, l([
                Fa("path607"),
                Ha("#dcc06d"),
                qa("M188.419 374.072c.81.159 1.306.812 2.049.924.366-.781 1.22-1.229 2.068-1.157-1.019-.571-3.07-.668-3.927.232")
            ]), M),
            A2(Da, l([
                Fa("path609"),
                Ha("#dcc06d"),
                qa("M178.743 361.929c-.024.71.239 1.335.758 1.735.598-.729 2.179-.305 2.999-.046 1.014-2.336 4.876-3.3 6.853-4.46-1.482.761-3.209 1.322-4.769 2.054-1.22.572-2.311 1.51-3.739 1.263.22-.565.7-.932 1.247-1.276-.928.634-2.974 1.371-3.704.161.014.545.278 1.035.734 1.328")
            ]), M),
            A2(Da, l([
                Fa("path611"),
                Ha("#dcc06d"),
                qa("M197.526 357.565c1.2.896 3.418.618 4.728.337-1.148-.595-3.123-.337-4.538-.337")
            ]), M),
            A2(Da, l([
                Fa("path613"),
                Ha("#ccb25c"),
                qa("M191.456 364.016c2.662 1.629 3.586-1.413 1.198-2.41.593.988 1.122 2.514-.44 2.79")
            ]), M),
            A2(Da, l([
                Fa("path615"),
                Ha("#ccb25c"),
                qa("M209.671 361.359c-2.088 1.331-.469 4.63.74 3.074-1.314-.048-1.434-1.622-.74-2.504")
            ]), M),
            A2(Da, l([
                Fa("path617"),
                Ha("#ccb25c"),
                qa("M202.649 371.795c1.058.353 5.347.566 4.706-1.503-.096.171-.448.474-.578.716-.714.033-1.955.44-2.846.55-.941.116-2.232.121-3.179.427")
            ]), M),
            A2(Da, l([
                Fa("path619"),
                Ha("#ccb25c"),
                qa("M202.838 367.052c1.547.089 3.989-.302 5.295-1.139-.028-.188-.09-.707-.162-.892-.299 2.442-6.78 1.578-8.485 1.642 1.115.41 2.322.384 3.542.389")
            ]), M),
            A2(Da, l([
                Fa("path621"),
                Ha("#ccb25c"),
                qa("M201.321 361.359c.806-.362 7.554.212 6.503-1.84-.154.367-.488.537-.678.826-.075-.146-.1-.285-.169-.438-1.689 1.756-5.612 1.234-7.772.855-.162.099-.152.234.029.409")
            ]), M),
            A2(Da, l([
                Fa("path623"),
                Ha("#ccb25c"),
                qa("M212.896 349.786c.015.615.155.91.032 1.487 1.646-2.25 4.831-3.543 7.309-4.72-1.036.172-2.163.703-3.148.734.567-1.156 3.25-2.949 4.51-3.225a1.707 1.707 0 0 0-.597-.891c-1.508 1.325-3.449 2.256-5.029 3.59-1.169.988-2.489 1.936-3.784 2.434.122.39.369.568.706.782")
            ]), M),
            A2(Da, l([
                Fa("path625"),
                Ha("#ccb25c"),
                qa("M184.624 346.75c-.718-.343-1.431-.203-1.877.332 1.735.979 3.578 1.628 5.425 2.295-.415-.448-.909-.96-1.486-1.233 1.108 1.281 3.473 1.99 5.13 2.33-.004-.283-.119-.937-.201-1.229-2.537-.147-5.204-1.959-7.587-2.685-.258-.342.068-.094.218-.189")
            ]), M),
            A2(Da, l([
                Fa("path627"),
                Ha("#ccb25c"),
                qa("M203.598 377.107c.861-.188 1.675-.57 2.449-.929-.358.943-.177 2.138-.168 3.154-.1-.477-.164-1.622-.422-1.996-.408-.595-.971.047-1.289-.607")
            ]), M)
        ]))
    ]), pr = l([
        A2(On, l([
            Fa("scapluaRight")
        ]), l([
            A2(On, l([
                Fa("g545")
            ]), l([
                A2(Da, l([
                    Fa("path547"),
                    Ha("#f9ce82"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M258.002 162.278c-1.657 2.816-2.167 4.011-5.769 3.44-2.727-.434-6.087-1.1-8.372-2.761-.782-.571-1.325-1.957-2.199-2.375-1.875-.896-3.826 1.262-4.767 2.761-1.147 1.833-1.933 4.799-1.942 6.914-.01 1.507.499 3.003.742 4.475.422 2.537-.071 4.549-.153 6.979-.361 10.352-2.628 21.469 1.084 31.517.99 2.677 2.15 6.322 4.285 8.254 2.52 2.279 6.396 2.752 9.624 2.938 3.318.188 5.477-1.139 8.567-2.945 4.282-2.503 4.012-4.587 5.88-8.915 1.562-3.617 3.38-6.976 5.312-10.388 1.966-3.477 4.402-6.194 6.777-9.371.848-1.134 1.673-2.335 2.608-3.442.58-.685 2.22-1.935 2.554-2.676.891-1.979-2.222-2.518-3.029-4.82-.555-1.584-.762-3.847-.551-5.509.185-1.441 1.301-2.922 1.374-4.292.105-1.988-2.588-4.495-4.552-5.083 1.172-1.982 4.371-4.048 6.663-4.565 3.298-.744 6.757.101 9.938-.458 3.257-.57 4.293-4.115 2.689-6.657-1.828-2.898-5.89-5.62-9.118-6.838-1.576-.594-5.814-1.561-7.193.141-.808.994.119 2.283.213 3.425.13 1.637-.245 2.407-1.402 3.487-1.797 1.682-4.707 3.666-7.305 3.386 2.123.775 2.513 5.301.511 6.412.829-1.449 1.774-1.672 1.393-3.597-.476-2.396-3.202-3.893-5.467-4.048-1.454-.1-2.677-.105-4.091.575-1.742.84-3.331 2.384-4.304 4.036z")
                ]), M),
                A2(Da, l([
                    Fa("path549"),
                    Ha("#dcc06d"),
                    qa("M262.69 199.166c-.027-.285-.038-.574-.027-.871.091-2.233 1.789-3.387 2.551-5.348.17-.432.87-1.497.492-1.989-.159-.209-1.36-.827-1.492-.367.61-2.115 1.784-4.392 2.444-6.65.351-1.205 1.908-4.283 1.206-5.537-.569-1.016-2.478-.933-3.393-1.43.467-.91 1.384-1.8 1.837-2.713-1.026-.602-3.581-.22-3.417 1.313.198.097.364.181.475.255-.975.119-2.007.261-2.697.864.162.212.374.586.539.75-2.938.093-6.849-1.952-8.621-4.237-.727-.938-1.015-1.61-2.06-2.36-.944-.677-2.092-.797-2.698-1.829 3.063.625 5.238 1.399 8.002 2.854 1.408.743 2.252 1.202 3.963 1.028-.483-1.711-2.589-2.37-3.064-4.043-.371-1.306.552-3.528 1.079-4.768 1.585-3.734 4.564-5.341 8.226-5.853-1.483 1.148-.901 2.268.298 3.373.995.918 3.434 1.656 1.985-.444.65.451 1.393.473 1.981.001.065 1.632 1.851 2.745.424 4.152-.712.701-2.241.485-3.129.567-.957.086-2.352-.12-3.161.545-1.211.996-.161 2.052-.729 3.002.512-.856 1.845-1.496 2.813-1.653.543-.09 3.621.802 3.563.841.778-.532 1.027-1.351.567-2.104 2.66-3.563 15.167-5.379 14.972-10.647.593.396 1.264.84 1.837 1.219.735-1.847.403-5.339-1.192-6.642 2.198.759 3.938 3.817 5.35 5.597.723.911 2.44 2.806 1.883 4.029-.584 1.285-3.509 1.22-4.712 1.081-3.604-.417-4.938-.863-8.241.986-2.63 1.471-4.858 3.538-7.415 4.947.866 1.275-.697 2.871-1.619 3.902 2.477-2.233 5.501-3.357 6.814.715 1.167 3.615-2.823 5.953-2.646 9.329.054 1.015 3.441 4.623 4.406 3.783.307-.268.429-.165.697-.293-.367.844.119 1.142 1.071 1.071-.185.014-3.439 4.993-3.946 5.524-1.715 1.8-3.713 3.339-5.366 5.195-2.729 3.066-4.197 6.633-6.155 10.164-1.066 1.926-1.94 3.911-2.81 5.902-2.588 5.941-5.229 11.207-12.459 11.251-2.751.017-7.014.408-7.608-3.116 1.725.697 3.471 1.944 5.354 1.567 1.547-.309 3.278-1.855 4.443-2.845 2.789-2.371 5.075-5.426 6.727-8.685 1.175-2.324 2.542-4.871 2.965-7.47.226-1.405-.188-2.615-.307-3.913z")
                ]), M),
                A2(Da, l([
                    Fa("path551"),
                    Ha("#ccb25c"),
                    qa("M264.522 166.529c1.931-.418 4.641.202 6.3-.892 2.141-1.409 1.456-3.938.309-5.731 4.376 6.848-9.392 3.62-8.295 1.047-.433 1.021-.391 2.411.445 3.141-1.876.939-3.235 4.487-1.027 5.868-.072-2.32.901-3.137 2.268-3.433z")
                ]), M),
                A2(Da, l([
                    Fa("path553"),
                    Ha("#ccb25c"),
                    qa("M286.446 157.116c1.704-.61 3.875-.537 4.786 1.051-1.071-3.833-4.526-8.611-8.978-8.311.396.894-2.127 2.566-1.937 4.499 1.666-1.764 5.153-.521 6.096 1.382a.694.694 0 0 1-.434.031c1.057.414 2.574.236 2.574 1.576-.59.192-.963-.013-1.305-.227")
                ]), M),
                A2(Da, l([
                    Fa("path555"),
                    Ha("#dcc06d"),
                    qa("M239.792 214.15c-1.8-5.183-.793-11.938-.081-17.321.339-2.561.171-4.617-1.201-6.749.685 1.065-.842 7.042-.742 8.624.333 5.178 1.606 10.25 2.024 15.446z")
                ]), M)
            ])),
            A2(On, l([
                Fa("scapulaLeft")
            ]), l([
                A2(Da, l([
                    Fa("path559"),
                    Ha("#f9ce82"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M151.19 160.02c.465 2.88-1.493 5.753-1.134 8.575.288 2.253 1.973-.034 2.617-1.288.45-.873.673-1.947 1.337-2.667 1.136-1.232 2.046-.733 3.499-1.276 2.773-1.04 4.704-3.456 7.114-4.757 2.436-1.315 4.552-2.218 6.234.587 1.461 2.438.701 5.886-.065 8.363-2.142 6.917-3.364 13.727-2.145 20.716.671 3.849 1.893 8.167 1.668 12.092-.228 3.99-2.426 5.863-4.163 9.023-1.99 3.619-.822 8.662-3.501 11.897-2.725 3.291-8.445 6.587-12.739 6.625-4.41.038-8.119-3.105-9.439-7.227-1.709-5.339-2.118-11.06-3.951-16.379-1.198-3.476-2.572-6.954-4.404-10.151-1.359-2.372-4.509-3.197-5.597-5.371-.732-1.463 1.399-4.704 1.687-6.261.434-2.338.624-4.61.262-6.959-.281-1.814-1.169-3.292-1.56-4.962 1.739-.923 2.059-3.07 3.657-4.162 1.067-.729 2.529.06 3.64.162-.104-4.256-9.667-4.366-12.476-4.671-3.82-.415-11.924-1.894-9.109-7.776.644-1.348 2.165-1.706 3.308-2.409 1.727-1.061 2.478-2.476 4.024-3.753 1.415-1.168 4.474-3.05 6.292-2.375.729.271 3.836 4.235 3.53 4.87-.57 1.181-2.082 1.77-1.32 3.208.407.77 2.914 1.528 3.699 1.813 2.065.748 6.725 2.61 8.769 1.239-.885.507-1.903 1.119-2.928 1.398-1.016.276-2.108.058-2.73.935-1.408 1.988 1.048 5.299 3.208 5.149-1.536-.422-4.987-3.326-2.994-5.284.592-.581 2.366-.807 3.187-1.151 2.398-1.008 3.586-2.977 6.296-2.692 2.105.222 4.483 1.23 5.587 3.135.345.595.544 1.189.64 1.784z")
                ]), M),
                A2(Da, l([
                    Fa("path561"),
                    Ha("#dcc06d"),
                    qa("M146.18 197.269a36.801 36.801 0 0 1 .037-3.404c.231.104.496.174.739.255-.418-1.727-.434-3.318-.55-5.073-1.463.782-2.137 2.43-3.941 2.832-.212-1.825 1.597-6.974.73-8.223-1.063-1.532-3.961.264-5.27-1.051-4.589-4.611 7.667-17.599 11.947-7.334.016-.292.112-.665.121-.969.006.027.202.556.262.761.931-1.066 3.155-4.411 4.76-4.61 2.081-.259 1.903 2.181 2.441 3.745-.042-4.071 1.339-8.256 4.317-11.073-2.519 1.842-4.902 3.862-7.449 5.666-.202.143-6.612 3.081-6.379 2.255.482-1.71 2.589-2.369 3.064-4.042.372-1.307-.553-3.528-1.079-4.768-1.586-3.734-4.565-5.342-8.227-5.853 1.483 1.148.901 2.267-.297 3.372-.996.919-3.434 1.656-1.984-.442-.65.451-1.393.471-1.983.001-.065 1.632-1.851 2.744-.422 4.15.712.703 2.24.485 3.129.568.956.086 2.353-.121 3.16.545 1.211.996.161 2.051.729 3.002-.512-.856-1.845-1.497-2.813-1.653-.545-.088-3.621.803-3.564.842-.777-.532-1.028-1.351-.567-2.104-2.658-3.563-15.166-5.377-14.974-10.646-.592.396-1.26.84-1.836 1.218-.735-1.847-.401-5.339 1.193-6.641-2.199.758-3.938 3.816-5.35 5.597-.723.91-2.438 2.805-1.881 4.028.584 1.285 3.507 1.22 4.71 1.081 3.604-.417 4.938-.863 8.242.986 2.628 1.471 4.858 3.539 7.416 4.947-.867 1.274.698 2.871 1.62 3.902-2.479-2.232-5.502-3.356-6.815.715-1.166 3.614 2.823 5.952 2.646 9.328-.053 1.014-3.443 4.623-4.405 3.783-.308-.268-.432-.166-.697-.293.365.843-.12 1.142-1.071 1.07.862.064 2.655 3.811 3.059 4.554 1.187 2.188 2.396 2.974 4.149 4.696 1.685 1.656 2.724 3.135 3.495 5.371 1.548 4.496 1.646 9.466 3.361 13.953.665 1.738 1.555 4.339 2.942 5.705 1.021 1.005 1.563.867 2.279 2.388 1.068 2.269 1.546 3.554 4.506 3.49 1.851-.04 3.424-.788 4.852-1.754-1.558.525-3.633-.556-4.353-2.071-.657-1.38-.016-1.813-.297-3.151-.375-1.784-1.259-2.898-1.286-5.024-.035-2.691.281-5.196.776-7.822-2.441.584-3.075-3.533-3.192-6.805z")
                ]), M),
                A2(Da, l([
                    Fa("path563"),
                    Ha("#ccb25c"),
                    qa("M143.215 164.675c-1.929-.417-4.64.204-6.301-.891-2.139-1.409-1.452-3.938-.306-5.731-4.376 6.847 9.391 3.619 8.293 1.047.435 1.021.392 2.41-.444 3.141 1.876.938 3.235 4.487 1.026 5.867.073-2.319-.901-3.136-2.268-3.433z")
                ]), M),
                A2(Da, l([
                    Fa("path565"),
                    Ha("#ccb25c"),
                    qa("M121.292 155.262c-1.704-.61-3.876-.536-4.786 1.05 1.071-3.832 4.525-8.611 8.978-8.31-.395.893 2.125 2.566 1.937 4.498-1.666-1.763-5.152-.52-6.096 1.383a.712.712 0 0 0 .432.032c-1.053.414-2.572.234-2.574 1.576.593.191.964-.013 1.306-.229")
                ]), M),
                A2(Da, l([
                    Fa("path567"),
                    Ha("#dcc06d"),
                    qa("M164.968 212.298c1.8-5.184.793-11.94.08-17.321-.338-2.562-.169-4.617 1.201-6.75-.684 1.066.843 7.044.742 8.625-.332 5.178-1.606 10.248-2.023 15.446z")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path569"),
                Ha("#e1e2e3"),
                Ua("#ccb25c"),
                Ba(".322"),
                qa("M128.94 148.07c-.163-2.202.483-4.085-2.284-4.156-1.361-.035-2.743.598-3.624 1.637-1.971 2.329-.631 4.728 2.227 5.121 1.067.147 2.297.229 3.217-.524 1.472-1.201.556-.829.464-2.078z")
            ]), M),
            A2(Da, l([
                Fa("path571"),
                Ha("#e1e2e3"),
                Ua("#ccb25c"),
                Ba(".322"),
                qa("M278.868 146.844c-1.967 1.731.919 2.36-.352 3.84-.144.166 4.978 1.033 5.799.786 1.472-.441 4.167-1.751 3.156-3.684-1.252-2.383-6.804-2.522-8.603-.942z")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path375"),
            Ha("#ccb25c"),
            qa("M282.668 186.575c-1.676.201-3.191.351-4.812.048.172.125.486.517.707.704-.725.186-1.733.439-2.332.925-1.366 1.106-.387.743-1.107 2.335-1.723 3.8-4.822 8.021-7.386 11.318 2.275-1.542 4.248-4.403 6.15-6.424 1.5-1.593 2.95-3.27 4.474-4.821.961-.981 4.646-3.311 3.77-4.352")
        ]), M),
        A2(Da, l([
            Fa("path573"),
            Ha("#ccb25c"),
            qa("M131.406 173.97c1.649 2.329.819 6.103.14 8.583-.339 1.238-1.075 2.598-1.924 3.576-.549.632-2.985 1.847-1.661 2.656 4.049-2.857 6.182-11.225 3.686-15.543.114-.027.319-.043.418-.058-.47-.9-1.167-1.552-1.837-2.237.528 1.406 1.007 2.954 1.716 4.276")
        ]), M)
    ]), or = l([
        A2(Da, l([
            Fa("Sternum"),
            Ha("#f9e3b7"),
            Ua("#967348"),
            Ba(".322"),
            qa("M200.779 240.434c.093.889.316 1.691 1.074 2.154 2.649 1.624 3.622-1.784 3.976-3.765.379-2.131 1.868-6.595.904-8.641-.363-.773-1.286-.795-1.474-1.939-.124-.751.064-1.633.546-2.229.627-.774 1.245-.388 2.077-.436 1.109-.064 1-.369.942-1.277-.042-.695-.104-1.559.022-2.239.125-.689.65-1.183.936-1.807.375-.818-.307-1.175-.591-1.822-.296-.674-.269-1.636.237-2.199.478-.534 1.403-.26 1.636-.781.113-.255-.068-1.099-.009-1.455.092-.521.229-.995.367-1.503.077-.28.377-.876.361-1.157-.033-.535-.48-.687-.783-1.038-.324-.378-.527-.827-.641-1.325-.274-1.213-.11-2.632.881-3.448.164-.136.595-.298.695-.47.281-.49-.269-1.274-.341-1.834-.175-1.393.906-3.735-.158-4.782-.94-.924-1.414-3.075-.91-4.309.364-.891.539-1.203 1.251-1.902.634-.622.207-2.454.177-3.285-.036-.995-.375-1.928-.103-2.927.083-.309 1.66-2.689 1.772-2.44-.731-1.614-1.819-1.861-1.762-3.893.032-1.128.928-2.215.322-3.353-1.197-2.244-6.522-2.594-8.596-2.564-3.132.046-5.908.74-8.288 2.512-.292.219-.182 2.801-.262 3.333-.174 1.165-.239 2.364-1.562 2.79-.248.841.37.936.639 1.576.569 1.355.887 2.753 1.017 4.215.083.94-.425 2.329-.127 3.165.33.925 1.102 1.132 1.094 2.331-.007 1.1-.629 2.524-1.261 3.408-.3.418-.548.198-.433.858.059.332.333.663.492.954.465.855.614 1.545.605 2.526-.006.603-.052 1.124-.244 1.697-.094.281-.521.945-.386 1.236.285.623 1.32.522 1.729 1.09.575.798.33 2.21.146 3.087-.187.886-1.11 1.86-1.142 2.705-.011.281.303.56.412.821.34.822.493 1.813.313 2.69-.193.945-.146.867.604 1.492.359.299.647.792.83 1.227.375.897.583 2.026.313 2.974-.125.436-.574.835-.61 1.252-.04.469.31 1.17.387 1.659.131.826.355 1.642.631 2.429.964-.354 1.296-.755 1.892.207.4.647.296 1.807.048 2.499-.277.777-1.178 1.303-1.399 2.002-.146.461.064 1.104.174 1.557.676 2.783 1.276 5.539 1.58 8.374z")
        ]), M)
    ]), Mr = l([
        A2(On, l([
            Fa("g13")
        ]), l([
            A2(Da, l([
                Fa("path15"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M217.037 780.802c-2.924 1.405-6.044 2.717-8.892 4.228-.887.47-1.203 1.455-2.353 1.136-.851-.234-1.562-1.153-2.252-1.616-.659-.442-.825-.544-.941-1.492-.305-2.5.474-5.105 1.049-7.494.491-2.031-1.36-3.985-1.25-6.007.092-1.667 2.545-3.426 3.721-4.269 4.123-2.948 9.158-4.122 13.616-6.319 2.478-1.221 2.877-2.361 5.741-1.08 2.166.969 3.887 1.625 3.477 3.965.062-.354 1.061.673 1.12.814.243.576-.147 1.429-.322 1.968-.595 1.834-1.233 3.017-.8 5.057.301 1.414 1.452 3.115.825 4.576-.805 1.882-3.639 2.319-5.324 2.938-2.529.93-4.971 2.419-7.415 3.595z")
            ]), M),
            A2(Da, l([
                Fa("path17"),
                Ha("#dcc06d"),
                qa("M207.796 773.56c-.597.517-2.305 3.11-.874 3.633.802.29 1.691-1.579 2.146-2.037.789-.794 2.512-2.93 3.677-3.07.595-.071.392.186.998.29 1.26.218 2.382-.079 3.619-.405 1.02-.269 4.205-1.212 3.52-2.8-.375-.869-1.152-.457-1.354-1.357-.142-.623.313-2.098.345-2.826.094-2.064-.625-2.137-2.643-1.796-1.244.21-2.999 1.15-4.253.979.877-1.578 2.66-1.833 4.292-1.954.855-.063 1.695 0 2.504-.36.835-.373 1.318-1.188 2.145-1.555 1.203-.53 4.351.383 5.207 1.229 2.475 2.449-.811 6.682.124 9.543.315.962 1.706 1.743 1.8 2.719.157 1.675-2.071 1.938-3.259 2.192-1.071.23-1.954.633-2.974 1.026-1.583.608-2.93 1.574-4.378 2.438-1.62.969-3.622 1.739-5.392 2.438-1.926.757-3.822 1.462-5.72 2.292-1.463.64-2.573.326-3.661-1.081-.876-1.133-.036-2.444.32-3.651.435-1.466.742-3.028.637-4.563-.166-2.453-2.61-3.771-.324-5.958-2.391 2.284 1.39 4.747 3.498 4.634z")
            ]), M),
            A2(Da, l([
                Fa("path19"),
                Ha("#ccb25c"),
                qa("M208.784 765.243c.03.247 9.13-.166 9.778-.314 1.239-.285 1.527-.921 2.298-1.987.622-.858.731-1.175 1.787-1.378.945-.181 1.101.269 1.981.319.449.026 1.199-.386 1.573-.151.597.378.4 2.465.392 2.978-.016 1.261-.771 2.86-.685 3.998.066.86 1.173 1.814 1.717 2.499.789-1.815.519-3.966 1.32-5.813.501-1.154 1.196-1.684.845-2.987-.47-1.74-2.674-3.847-4.458-4.169-2.194-.397-4.276 1.461-6.091 2.427-2.099 1.112-3.967 1.189-6.311 1.514-3.543.489-7.439 2.37-8.73 5.995.898-1.654 3.127-2.229 4.557-3.273.022.115.011.222.027.342z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g23")
        ]), l([
            A2(Da, l([
                Fa("path25"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M227.842 777.088c1.85 1.159 3.938 1.667 6.055 2.073 1.669.32 3.767 1.403 5.449.688 1.61-.686 2.466-3.112 2.044-4.739-.359-1.378-2.763-3.219-4.055-3.709-1.19-.45-2.489-.592-3.646-1.14-.986-.468-1.583-1.414-2.49-1.875-1.815-.923-3.658 1.45-5.431 1.673-1.269.161-2.747.086-3.988-.073-1.126-.145-2.033.098-1.521 1.359.361.893 1.653 2.692 2.458 3.176.604.364 1.35.284 2.014.564 1.117.471 2.09 1.363 3.111 2.003z")
            ]), M),
            A2(Da, l([
                Fa("path27"),
                Ha("#dcc06d"),
                qa("M230.498 769.553c-.45 2.744 3.372 3.241 5.193 3.359 1.448.095 3.961 1.65 3.212 3.441-.546 1.312-2.708 1.201-3.758.687-1.6-.784-2.014-1.507-2.09-3.145-.715.462-1.606-.288-2.057.609-.348-.374-1.032-1.155-1.602-1.308-1.407-.376-2.25-.027-3.534-.936-1.011-.715-1.907-1.739-3.209-1.88 1.199.13 3.551 2.271 1.757 3.226.931.733 2.312.785 3.342 1.454 1.241.805 2.502 1.665 4.042 1.732 1.335.059 2.871-.102 4.053.665.429.275 1.102 1.7 1.616.726 1.281.36 1.393.132 1.892-.96.418-.917.913-1.813 1.606-2.551-1.192-.231-1.686-1.211-2.53-1.901-.947-.776-2.376-1.187-3.535-1.506-1.055-.288-1.978-.65-2.896-1.214-.648-.396-.894-1.014-1.771-.365")
            ]), M)
        ])),
        A2(On, l([
            Fa("g29")
        ]), l([
            A2(Da, l([
                Fa("path31"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M215.813 772.52a3.633 3.633 0 0 1-.277.16c-1.889 1.005-3.581 2.349-5.421 3.445-1.122.666-2.252 1.499-3.487 1.745-1.049.209-1.513-.248-2.151.67-1.068 1.545-.25 3.268.503 4.721.37.713.417 3.555 1.745 3.309.58-.108.826-1.256 1.318-1.6.643-.445 1.466-.386 2.212-.428 1.689-.097 2.063-1.419 2.937-2.648.873-1.227 1.672-2.533 2.73-3.611 1.208-1.232 2.486-1.113 3.856-1.923 1.179-.699 1.805-2.494 2.384-3.688-.478-.341-1.126-.343-1.589-.735-.544-.462-.486-.92-.696-1.555-1.388-.084-2.867 1.396-4.064 2.138z")
            ]), M),
            A2(Da, l([
                Fa("path33"),
                Ha("#dcc06d"),
                qa("M210.515 783.23c-1.058.875-2.19 1.652-3.248 2.549-.636.538-.518.605-1.075-.134-.962-1.274-1.387-3.789-1.308-5.334.188 1.573 1.344 2.711 1.205 4.361-.063-1.541.617-3.528 1.852-4.532.554-.45 1.106-.37 1.771-.526.591-.141.798-.494 1.451-.293.439-1.184 1.235-3.438 2.568-3.838.759-.228 1.587-.004 2.387-.263.966-.311 1.688-1.07 2.223-1.891.098-.152 1.134-1.648 1.136-1.608.084.906.867 1.047 1.351 1.58-.648.708-.806 1.675-1.431 2.316-1.097 1.124-2.869 1.605-4.181 2.475-2.03 1.346-2.901 3.652-4.701 5.138z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g35")
        ]), l([
            A2(Da, l([
                Fa("path37"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M226.648 779.218c1.701.254 4.842-3.767 2.864-4.758-.45-.224-1.553-.07-2.097-.209-.843-.212-1.625-.592-2.376-.987-1.296-.684-2.103-1.277-3.385-.188-.589.502-2.353 2.666-2.306 3.334 2.599.102 4.619 2.409 7.3 2.808z")
            ]), M),
            A2(Da, l([
                Fa("path39"),
                Ha("#dcc06d"),
                qa("M229.028 776.983c.252-.048.254-.292.225-.486-.192.131-.41.074-.574-.05.122.233.377.407.292.702")
            ]), M)
        ])),
        A2(On, l([
            Fa("g41")
        ]), l([
            A2(Da, l([
                Fa("path43"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".269"),
                qa("M219.918 781.154c1.348.099 2.257-2.093 2.48-3.101.382-1.714-.151-2.021-1.825-2.331-1.557-.287-1.559-.886-2.726-1.753-1.749-1.302-3.97.612-4.117 2.47-.186 2.358 2.444 4.176 4.351 4.915.915.354 1.092-.155 1.851-.144")
            ]), M),
            A2(Da, l([
                Fa("path45"),
                Ha("#dcc06d"),
                qa("M220.898 779.699c.256.01.311-.229.326-.425-.216.085-.416-.018-.548-.176.067.254.28.482.13.752")
            ]), M)
        ])),
        A2(On, l([
            Fa("g47")
        ]), l([
            A2(Da, l([
                Fa("path49"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".204"),
                qa("M207.295 784.447c-.31 1.794-.205 3.83.987 4.979.992.957 1.758 1.888 3.212 1.896-.211.767.495.87 1 .685.721-.265 1.51-1.346 2.239-2.043.832-.795 1.335-1.173 1.896-2.271.763-1.493 1.467-3.05 2.246-4.531-.894-.668-1.513-1.585-2.148-2.483-.478-.672-.814-1.735-1.412-2.277-.546-.498-1.451-.319-2.216-.235-2.464.266-4.392 1.995-5.26 4.267a10.82 10.82 0 0 0-.544 2.013z")
            ]), M),
            A2(Da, l([
                Fa("path51"),
                Ha("#dcc06d"),
                qa("M211.249 785.991c.175.485.486-.111.715.059.181.133.162 1.068.267 1.325.348-.534.254-1.353.132-1.808.42-.243.557.278.294.636.032.072.115.173.162.225.224-.162.345-.203.414-.523.156.266.051.637.158.915-.328.152-.552-1.233-1.07-.091-.38.845.584 1.015.759 1.508.261.003.467.194.697.305.052-.257.12-.533.195-.801.354.719.019 1.714-.331 2.509-.281.643-1.113 1.86-1.666 1.268-.213-.225-.039-.542-.331-.679-.263-.121-.761-.09-1.064-.176-.719-.204-1.079-.399-1.339-1.222-.232-.736-.908-1.085-1.109-1.854-.277-1.051.685-2.669 1.472-3.3.405-.325.792-.627 1.314-.396 1.109.493.073 1.377.331 2.1z")
            ]), M),
            A2(Da, l([
                Fa("path53"),
                Ha("#dcc06d"),
                qa("M217.822 782.755c-.388-.455-.863-.881-.932-.964-.524-.624-1.111-2.403-1.802-2.724-.652-.302-2.107.351-2.664.688.734.06 2.194.191 1.591 1.319 1.096-.534 3.361 2.051 3.229 3.161.047-.388-.002-.815.015-1.228-.006.11.587.979.729.962.639-.082.3-.668-.166-1.214z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g195")
        ]), l([
            A2(Da, l([
                Fa("path197"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M181.3 779.873c2.996 1.161 6.181 2.227 9.109 3.491.911.395 1.283 1.303 2.411.941.834-.266 1.49-1.167 2.152-1.639.632-.451.79-.555.852-1.45.1-1.443-.269-2.985-.867-4.293-.384-.842-1.179-1.625-1.314-2.559-.337-2.322 2.038-4.16 1.461-6.692-.467-2.056-1.5-3.097-3.137-4.3-4.832-3.551-10.167-4.895-15.982-5.985-2.551-.479-4.601.401-6.23 2.746-1.323 1.905.203 2.599-.261 4.437-.522 2.071-2.853 2.64-3.673 4.336-.52 1.078.583 1.635 1.117 2.375.685.948.537 1.921 1.088 2.855 1.141 1.937 3.645 2.177 5.673 2.759 2.577.738 5.096 2.005 7.601 2.978z")
            ]), M),
            A2(Da, l([
                Fa("path199"),
                Ha("#dcc06d"),
                qa("M192.077 773.063a1.593 1.593 0 0 0-.067.469c.011 1.061.762 1.405-.393 1.942-2.157 1-4.074-2.336-5.751-2.835-1.632-.486-2.024 1.106-3.588.004-1.201-.847-1.213-3.065-2.289-3.691-1.152-.673-3.95 1.272-4.86.425-.709-.659.432-3.431 1.049-3.785 1.256-.717 3.482.424 4.713.947 1.705.726 4.331 1.471 5.733 2.637.711-.614 1.621-.883 2.426-1.332-1.079-.466-3.055-.439-3.915-1.166-.88-.743-.6-1.645-2.171-2.246-1.126-.434-2.436-.55-3.518-.973-.892-.351-1.726-1.141-2.73-1.23-2.056-.184-4.87.757-5.697 2.508-.714 1.513-.95 3.186-1.839 4.641-.312.512-.885.898-.874 1.482.007.327.67.601.789.893.232.578-.023.546-.012 1.098.016.847-.452 1.394.326 2.127.72.68 1.947.703 2.889.842 1.079.158 1.985.488 3.023.804 1.613.486 3.013 1.32 4.504 2.054 1.671.82 3.713 1.438 5.518 1.998 1.962.607 3.893 1.168 5.834 1.846 1.495.521 2.583.169 3.587-1.213.809-1.109-.104-2.296-.529-3.408-.517-1.353-.913-2.805-.897-4.251.026-2.312 2.387-3.681-.018-5.61 2.257 1.809-.747 3.305-1.243 5.023z")
            ]), M),
            A2(Da, l([
                Fa("path201"),
                Ha("#ccb25c"),
                qa("M187.796 763.628c1.727.742 8.384 3.069 5.824 6.31-.076-1.29-1.178-1.905-2.344-2.17.462-3.523-5.133.585-6.308.223-.63-.193-1.672-1.428-2.287-1.814-.789-.497-1.676-.884-2.552-1.203-1.662-.605-3.845-1.664-5.657-1.502-1.602.143-1.828 1.006-2.421 2.367a27.594 27.594 0 0 1-1.378 2.697c-.397.684-.993 1.864-1.845 2.078-.396.1-2.312-.691-1.96-.972 2.37-1.903 5.381-6.472 3.081-9.391.636-.375 1.884-1.254 2.653-1.295.62-.032.888.304 1.581.419 1.87.314 2.611.068 4.353.886 2.98 1.398 6.222 2.061 9.26 3.367z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g205")
        ]), l([
            A2(Da, l([
                Fa("path207"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M170.313 776.966c-1.777 1.187-3.832 1.775-5.918 2.271-1.645.391-3.676 1.521-5.394.938-1.645-.557-2.636-2.789-2.308-4.34.277-1.313 2.567-3.169 3.83-3.699 1.16-.487 2.447-.689 3.568-1.265.958-.492 1.497-1.412 2.378-1.895 1.755-.964 3.73 1.165 5.509 1.28 1.274.082 2.745-.067 3.973-.283 1.114-.196 2.032-.018 1.594 1.194-.309.857-1.493 2.615-2.267 3.114-.58.374-1.331.339-1.975.636-1.09.504-2.007 1.392-2.99 2.049z")
            ]), M),
            A2(Da, l([
                Fa("path209"),
                Ha("#dcc06d"),
                qa("M167.235 770.034c.604 2.552-3.178 3.224-4.989 3.433-1.438.165-3.853 1.762-3.004 3.402.621 1.203 2.77.982 3.788.442 1.548-.822 1.918-1.523 1.903-3.064.738.396 1.585-.355 2.084.462.326-.369.963-1.14 1.523-1.313 1.38-.428 2.242-.147 3.47-1.068.967-.725 1.8-1.733 3.092-1.937-1.188.187-3.411 2.322-1.568 3.121-.885.738-2.261.862-3.249 1.546-1.191.821-2.398 1.697-3.93 1.843-1.329.127-2.868.059-4.004.843-.409.281-1 1.653-1.569.767-1.258.406-1.382.197-1.941-.801-.47-.837-1.014-1.652-1.749-2.309 1.177-.28 1.613-1.227 2.413-1.92.901-.778 2.304-1.241 3.441-1.604 1.032-.327 1.933-.717 2.818-1.295.623-.407.832-.999 1.745-.438")
            ]), M)
        ])),
        A2(On, l([
            Fa("g211")
        ]), l([
            A2(Da, l([
                Fa("path213"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M182.045 772.03c.097.051.192.096.286.137 1.942.842 3.705 2.013 5.604 2.942 1.156.567 2.332 1.288 3.578 1.454 1.057.139 1.494-.314 2.18.515 1.156 1.392.438 3.052-.23 4.456-.328.689-.211 3.362-1.549 3.2-.586-.069-.896-1.134-1.408-1.431-.666-.384-1.483-.284-2.229-.284-1.69 0-2.137-1.221-3.08-2.329-.94-1.103-1.813-2.287-2.931-3.244-1.275-1.091-2.542-.91-3.954-1.598-1.217-.593-1.942-2.245-2.589-3.334.456-.345 1.103-.382 1.542-.774.516-.464.432-.892.603-1.498 1.382-.152 2.941 1.157 4.177 1.788z")
            ]), M),
            A2(Da, l([
                Fa("path215"),
                Ha("#dcc06d"),
                qa("M187.942 781.803c1.105.765 2.278 1.435 3.386 2.219.665.472.549.539 1.064-.183.884-1.249 1.164-3.632.998-5.078-.098 1.486-1.186 2.617-.953 4.159-.022-1.45-.817-3.278-2.106-4.155-.578-.394-1.125-.288-1.798-.399-.595-.1-.821-.422-1.461-.197-.506-1.088-1.429-3.162-2.78-3.465-.772-.174-1.583.08-2.396-.118-.981-.242-1.745-.915-2.323-1.656-.109-.138-1.227-1.487-1.227-1.451-.031.856-.805 1.03-1.256 1.558.686.629.9 1.528 1.56 2.097 1.158.997 2.953 1.354 4.31 2.1 2.102 1.152 3.103 3.271 4.982 4.569z")
            ]), M)
        ])),
        A2(On, l([
            Fa("g217")
        ]), l([
            A2(Da, l([
                Fa("path219"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M171.627 778.901c-1.683.328-5.044-3.277-3.131-4.313.438-.235 1.545-.151 2.08-.309.828-.245 1.587-.643 2.313-1.055 1.252-.714 2.022-1.313 3.362-.357.618.438 2.5 2.375 2.492 3.005-2.584.235-4.467 2.511-7.116 3.029z")
            ]), M),
            A2(Da, l([
                Fa("path221"),
                Ha("#dcc06d"),
                qa("M169.126 776.931c-.255-.03-.27-.261-.251-.443.198.112.412.047.567-.079-.105.226-.352.404-.25.677")
            ]), M)
        ])),
        A2(On, l([
            Fa("g223")
        ]), l([
            A2(Da, l([
                Fa("path225"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".261"),
                qa("M178.449 780.358c-1.339.165-2.372-1.844-2.654-2.778-.478-1.589.035-1.907 1.688-2.286 1.536-.353 1.504-.915 2.617-1.793 1.67-1.314 3.992.363 4.246 2.1.322 2.204-2.198 4.051-4.057 4.846-.892.383-1.097-.085-1.854-.034")
            ]), M),
            A2(Da, l([
                Fa("path227"),
                Ha("#dcc06d"),
                qa("M177.388 779.045c-.255.022-.325-.198-.35-.381.219.068.413-.04.535-.194-.05.24-.249.466-.086.712")
            ]), M)
        ])),
        A2(On, l([
            Fa("g229")
        ]), l([
            A2(Da, l([
                Fa("path231"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".197"),
                qa("M191.224 782.772c.412 1.668.424 3.585-.699 4.728-.935.953-1.644 1.867-3.094 1.952.255.709-.442.844-.958.697-.734-.211-1.584-1.184-2.349-1.799-.877-.701-1.4-1.028-2.022-2.029-.847-1.361-1.637-2.784-2.498-4.134.852-.675 1.416-1.569 1.998-2.447.438-.656.712-1.673 1.276-2.214.517-.498 1.428-.378 2.197-.34 2.471.117 4.492 1.638 5.489 3.725.253.53.491 1.174.66 1.861z")
            ]), M),
            A2(Da, l([
                Fa("path233"),
                Ha("#dcc06d"),
                qa("M187.369 784.434c-.145.467-.49-.078-.709.094-.171.135-.102 1.012-.189 1.259-.377-.483-.33-1.258-.235-1.689-.433-.207-.54.29-.257.611a1 1 0 0 1-.149.22c-.233-.14-.355-.17-.442-.469-.142.258-.016.601-.106.867.338.126.479-1.188 1.063-.144.429.773-.523.985-.671 1.455-.258.019-.454.21-.677.325a9.77 9.77 0 0 0-.24-.741c-.312.695.08 1.609.474 2.338.318.589 1.217 1.687 1.735 1.1.198-.222.007-.509.291-.653.255-.129.753-.125 1.049-.224.707-.229 1.055-.431 1.266-1.217.19-.704.843-1.067 1-1.801.216-1.001-.836-2.468-1.657-3.019-.422-.283-.824-.547-1.333-.301-1.081.522.003 1.296-.213 1.989z")
            ]), M),
            A2(Da, l([
                Fa("path235"),
                Ha("#dcc06d"),
                qa("M180.63 781.749c.36-.447.81-.872.873-.955.489-.614.971-2.316 1.643-2.653.634-.318 2.121.216 2.695.502-.729.095-2.176.297-1.511 1.325-1.124-.443-3.232 2.103-3.038 3.141-.068-.362-.046-.767-.084-1.154.012.105-.529.951-.674.944-.642-.045-.337-.614.096-1.15z")
            ]), M)
        ]))
    ]), br = l([
        A2(On, l([
            Fa("g1609"),
            ln("inline")
        ]), l([
            A2(Da, l([
                Fa("path1611"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("m215.995 166.999-.021.044c-1.103 2.168-1.307 3.711 1.297 2.855 2.506-.826 4.871-1.754 7.473-2.234 1.08-.2 4.93-.042 5.279-1.204-.852-2.092-1.245-5.704-4.52-5.271-.787.104-1.329.96-2.082 1.273-1.024.423-1.569.31-2.547.108-.816-.169-2.247.687-2.949 1.184-.996.702-1.408 2.197-1.93 3.245z")
            ]), M),
            A2(Da, l([
                Fa("path1613"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M191.23 166.881c.16 1.17.424 2.385.229 3.455-1.268-.433-2.015-1.404-3.411-1.774-1.367-.361-2.682-.519-4.064-.671-2.941-.324-7.951-.072-6.039-4.54 1.205-2.814 5.114-1.579 7.456-1.399 1.283.098 2.658.171 3.938.393 2.063.356 1.791 1.229 1.784 3.223 0 .423.045.865.107 1.313z")
            ]), M),
            A2(Da, l([
                Fa("path1615"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M212.162 150.151c.442-.953-1.198-.876-1.433-1.368-.228-.477.747-2.088.922-2.59.992-.069 1.755-.447 2.248.49.379.725 1.107 1.663 1.192 2.475.176 1.738-2.487.042-2.929.993z")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path381"),
            Ha("#dcc06d"),
            qa("M212.759 317.276a2.76 2.76 0 0 0-.439.61c.612.229 2.291.28 2.67-.241-.624.218-1.734-.023-2.321-.279")
        ]), M),
        A2(Da, l([
            Fa("path383"),
            Ha("#dcc06d"),
            qa("M197.784 312.092c.184.126.382.205.595.19-.105-.695-.142-1.403-.208-2.121-.148.546-.306 1.417-.252 1.998")
        ]), M),
        A2(Da, l([
            Fa("path385"),
            Ha("#ccb25c"),
            qa("M211.127 287.618c-.209.693-.397 1.8-.335 2.528-.002-.467-.429-2.529.269-2.461")
        ]), M),
        A2(Da, l([
            Fa("path387"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".199"),
            qa("M208.158 210.473c-2.346.702-4.863.512-7.298.647-1.642.093-3.395.195-4.969-.345-.832-.286-2.508-1.065-2.738-1.909-.201-.734.057-1.463.208-2.179.116-.542-.121-1.538.329-1.887.893-.692 2.554.575 3.415.804 1.534.408 2.915.683 4.533.64 1.418-.037 2.8-.323 4.164-.649 1.286-.308 4.297-1.415 4.732.276.141.55.004 1.179.167 1.744.089.307.365.594.29.87-.113.416-.892.795-1.229 1.1-.458.418-.907.67-1.525.866-.027.006-.053.014-.079.022z")
        ]), M),
        A2(Da, l([
            Fa("path389"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".199"),
            qa("M209.097 228.519c-.113.431-.277.874-.271 1.239.02.836.92 2.111-.138 2.607-1.715-1.528-4.483-1.267-6.591-1.07-1.131.105-2.274.23-3.394.424-1.12.196-1.948.037-3.082.085-.54.025-1.709.533-2.158.016-.358-.414.146-2.135-.145-2.789-.363-.811-1.232-1.055-.582-1.96.266-.368 1.417-.465 1.826-.562 2.064-.491 4.086-.792 6.218-.692 1.831.084 3.671.1 5.491.338.923.122 2.472.34 2.866 1.341.117.297.058.655-.04 1.023z")
        ]), M),
        A2(Da, l([
            Fa("path391"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".216"),
            qa("M202.952 223.961c1.696.144 3.2 1.681 4.942 1.511.625-.063 1.442-.519 1.822-1.133-.525-1.505.511-3.148.17-4.651-.422-1.858-2.715-1.559-4.02-1.485-2.667.151-5.746 1.273-8.392.716-.955-.202-2.712-1.668-3.651-.819-.9.813-.336 3.325-.452 4.448-.441 4.241 7.671 1.253 9.581 1.413z")
        ]), M),
        A2(Da, l([
            Fa("path393"),
            Ha("#dcc06d"),
            qa("M201.642 222.17c-.078.506.156.881.214 1.368.113-.17.151-.47.173-.703.25-.035.318-.073.316-.335.015.094.074.176.089.263.582-.545 1.103.041 1.883-.27.337 1.371.06 3.044.834 4.293.165-1.152-.717-2.984.068-4.052.12.304.107.541.329.779 1.1-2.226 2.425 1.22 2.687 2.093.519 1.732.393 1.854 1.992 1.13-.473-.693-.669-1.505-.797-2.327-.111-.712-.28-1.689.177-2.33.071.316.106.659.205.98.348-.653.063-1.753.375-2.498a.293.293 0 0 0 .053.132c.119-.189.283-.402.345-.602-.702.53-1.58.981-2.485 1.017a6.224 6.224 0 0 1-.215 1.371c-.22-.468-.077-.863-.664-1-.462-.106-.881.134-1.339.179a89.02 89.02 0 0 1-1.688.146c-.341.026-.881-.144-1.054.17-.104-.102-.358-.137-.439-.193-.253.487-1.775-.077-2.291-.086.338.202.981.563 1.229.545")
        ]), M),
        A2(Da, l([
            Fa("path395"),
            Ha("#dcc06d"),
            Ua("#967348"),
            Ba(".296"),
            qa("M196.078 209.433c1.186-.387 2.43-.517 3.64-.65 2.148-.238 4.437-.144 6.547.187 1.273.199 2.768.405 3.858 1.275 1.389 1.108.906 2.29.47 3.933-.783 2.951 2.083 7.114-2.244 5.908-4.17-1.164-7.595-.334-11.771-.283a8.646 8.646 0 0 0-1.931.248c-.143.036-1.015.41-1.06.398-.708-.202-.788-1.167-.889-1.962-.197-1.548.359-2.891.506-4.34.094-.923-.716-2.674-.204-3.417.27-.392 2.112-.925 2.531-1.094.18-.076.364-.143.547-.203z")
        ]), M),
        A2(Da, l([
            Fa("path397"),
            Ha("#dcc06d"),
            qa("M201.847 210.69c.531.015 1.042-.011 1.568-.027-.215.183-.004.374.262.488.184-.13.273-.041.455-.091 0 .066.013.134.015.199.168-.137.26-.062.454-.113.021.443.175.893.205 1.368.039.655-.077 1.426.098 2.063.015-.738.092-1.459.147-2.19.03-.386-.117-.996.276-1.227.113.201.158.425.234.637.122-.147.277-.34.38-.47.042 1.501.337 3.089.264 4.58.192-.807.099-1.622.077-2.439-.015-.564-.096-1.825.386-2.243.584.263.467.841.536 1.336.12.87.168 1.662.143 2.541-.015.409.156 1.56-.36 1.703-.009-.186-.102-.309-.175-.479-.045.109-.179.201-.23.303-.03-.091-.096-.152-.132-.242-.053.438-.413.761-.906.473-.47-.275-.415-1.028-.57-1.456-.077.487.021.998-.229 1.461.009-.068.002-.124-.004-.191-.378.233-1.041.266-1.483.364 1.423.128 2.742.171 4.113-.195 1.025-.274.716-1.314 1.025-2.122-.136.509-.145 1.039.024 1.543.042-.155.198-.32.239-.399-.062.338.253.602.482.236.331.11.855-.164 1.113-.388-1.137-.548-.714-3.252-.732-4.181.071.344.218.764.434 1.058.06-.599.153-1.157.245-1.716.08-.479.289-1.122.06-1.579a1.76 1.76 0 0 1-.825.215c-.098.342-.275.716-.279 1.073-.054-.156-.096-.696-.203-.936-.064.091-.269.236-.316.321-.002-.084-.011-.17-.006-.259-.442 1.081.006 2.389-.113 3.503-.346-.726.189-2.563-.438-3.251a246.118 246.118 0 0 0-.113 3.024c.134-.646.013-1.602-.251-2.208-.137-.311-.22-.512-.586-.574-.199-.033-1.794.468-1.768.595-.117-.577-1.163-.151-1.698-.192-.627-.047-1.399-.2-1.967-.062")
        ]), M),
        A2(Da, l([
            Fa("path399"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".199"),
            qa("M211.008 195.795v-.042c.019-.422.177-.859.087-1.283-.164-.786-1.745-.4-2.318-.496-1.422-.238-2.82-.228-4.262-.125-.721.051-1.442.133-2.163.169-1.99.101-3.978-.326-5.971-.172-.446.035-.872.139-1.312.192-.305.036-.61-.072-.895-.041-.578.066-.455.394-.414.775.068.642.052 1.301-.103 1.931-.111.45-.269.92.159 1.297.349.308 1.196.44 1.648.581.627.195 1.262.368 1.907.503 2.601.542 5.276.879 7.947.714 1.226-.076 2.613-.175 3.703-.687.811-.38 2.156-1.068 2.039-2.057a8.126 8.126 0 0 1-.052-1.259z")
        ]), M),
        A2(Da, l([
            Fa("path401"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".199"),
            qa("M210.01 187.25c-.297.106-.655.152-1.009.211-1.819.299-3.66.643-5.505.821-2.915.284-6.527.26-9.115-1.222-.841-.483-.24-1.417-.084-2.061.143-.59-.27-1.643.068-2.146.303-.451 1.686-.51 2.209-.483 1.291.069 2.484.584 3.757.739 1.732.21 3.673.266 5.422.221.971-.025 1.903-.247 2.864-.33.627-.055 1.79-.656 1.981.159.126.531-.211 1.14-.264 1.666-.085.814.983 1.957-.324 2.425z")
        ]), M),
        A2(Da, l([
            Fa("path403"),
            Ha("#dcc06d"),
            Ua("#967348"),
            Ba(".272"),
            qa("M193.116 204.779c.197.757 1.771 1.502 2.471 1.751 1.019.361 2.116.539 3.196.656 2.491.27 5.045.261 7.503-.199 1.075-.201 2.073-.411 3.097-.764.836-.289 1.448-.485 1.269-1.426-.363-1.907.132-4.023.642-5.863.104-.378.207-.798.188-1.197-.013-.279-.134-.631-.45-.72-.346.521-.636.914-1.314 1.091-.902.235-1.849.259-2.771.388-1.506.212-3.044.269-4.569.221-2.679-.086-5.137-.694-7.675-1.354-.392-.101-.549-.294-.869-.448-.566-.271-.762.237-.762.754 0 .367.104.841.201 1.202.355 1.344.474 2.556.273 3.946-.086.588-.533 1.308-.445 1.895a.484.484 0 0 0 .015.067z")
        ]), M),
        A2(Da, l([
            Fa("path405"),
            Ha("#ccb25c"),
            qa("M193.992 198.774a.548.548 0 0 0-.204.219c.201.152.217.395.239.623-.006-.021-.023-.03-.048-.028-.063.266.041.476.083.737.083.489.079.958.073 1.46-.011.695.009 1.322-.248 1.978.287-.358.555-1.005.525-1.454.005.021.021.031.044.031.308-.514-.305-1.529.125-1.927.035.081.082.111.115.159.007-.113.088-.219.091-.332.66.6.109 1.628.396 2.331.014-.71.086-1.536.197-2.242.062.036.084.026.153.094.036-.329-.521-.76-.072-1.016.021.033.088.092.107.118.07-.124.21-.193.318-.27.183.128.256.344.337.53.039-.005.058-.024.06-.06.273.517.005 1.166.23 1.697.106-.596.069-1.202.14-1.794.108.189.291.181.469.046.412.494 1.189.164 1.583.586.369.395.226 1.212.184 1.681.169-.411-.026-1.563.359-1.82.364-.242 1.282.369 1.565-.152.606.167 1.514-.013 2.188.009.787.025 2 .217 2.722-.081-.362.119-.286.76-.174 1.021.046-.048.172-.103.217-.147.058 1.173.495 2.31.681 3.452-.26-.61-.139-1.704-.156-2.358-.011-.426-.028-1.204.395-1.495.036.061.146.132.168.23.116-.213.271-.525.544-.586.196 1.046-.062 2.17-.092 3.223-.017.628-.232 1.261-.234 1.863-.081-.195-.168-.409-.162-.62a1.25 1.25 0 0 1-.465.988c-.09-.236.032-.537-.079-.792.03.327-.058.784-.267 1.05-.337-.286-.612.18-.969.288-.362.11-.855.13-1.237.132-.527.002-1.359.313-1.446-.354-.591.604-1.205.395-2.012.568 1.432.015 3.055.237 4.457-.088.886-.206 1.67-.478 2.617-.339.117-.408.324-.388.727-.259.073-.331-.124-.626-.134-.955-.008-.307.137-.591.137-.897.072.37.204 1.6.772 1.618.008-.078.091-.163.087-.258.399.194.554-.24.928-.089-.605-1.009-.525-2.329-.405-3.433-.015.021-.038.071-.051.084a1.013 1.013 0 0 1-.007-.352c.094-.044.16-.114.209-.283.192.512.054 1.171.092 1.721.032.464.132.92.087 1.385.201-.472.028-1.083.054-1.581.034-.666.062-1.333.122-1.993.034-.363-.073-1.579.303-1.812-.258.161-.309.463-.623.556-.02-.059-.085-.164-.094-.216-.021.406-.119.981-.281 1.335-.002-.368-.241-.979-.051-1.234-.168.169-.373.321-.638.302-.1.877.034 1.885-.26 2.722-.079-.989.186-2.09.024-3.035-.212.308-.182.841-.22 1.205-.08.728.04 1.488-.082 2.207-.36-.961.083-2.306-.235-3.301-.358.331-.729.198-1.149.092-.514-.127-1.007-.052-1.521-.017-.404.025-.689.136-1.045.21-.859.176-1.962-.011-2.852.003-1.487.024-2.991-.253-4.422-.513.06.192-.049.242-.258.193.011-.111-.074-.205-.069-.312-.498.145-1.584-.099-1.882-.48-.097.257-.114.629-.249.837-.015-.305-.112-.599-.102-.901a.128.128 0 0 1-.017.083 1.439 1.439 0 0 0-.446-.273c.005.23.074.454.03.643")
        ]), M),
        A2(Da, l([
            Fa("path407"),
            Ha("#dcc06d"),
            Ua("#967348"),
            Ba(".272"),
            qa("M201.279 186.641c1.03.062 2.061.091 3.084.07 1.229-.025 2.466-.145 3.693-.23.887-.062 1.627-.487 2.563-.413.864.069.64.856.582 1.45-.132 1.4-.516 2.95-.083 4.313.256.799.516 1.719.281 2.542-.281.978-1.423 1.033-2.308 1.247-1.215.296-2.45.38-3.702.446-1.873.097-3.597.163-5.466-.061a78.28 78.28 0 0 1-3.09-.426c-.858-.138-1.68-.302-2.493-.583-1.023-.354-.953-.875-.704-1.731.479-1.645.176-3.313.01-4.979-.056-.553-.375-1.62-.117-2.145.324-.659 1.438-.117 1.991-.056 1.898.209 3.831.439 5.759.556z")
        ]), M),
        A2(Da, l([
            Fa("path409"),
            Ha("#dcc06d"),
            qa("M200.306 194.937c.234.21.547.234.759.028.018.293.368.23.6.219.328-.016.456.097.712.119 1.504.131 3.176.06 4.646-.27.026-.074-.004-.103-.021-.146.013.04.041.069.079.089.056-.56.045-1.218.235-1.746-.021.513.16 1.06.324 1.552-.004-.08.013-.155.015-.231.16.374.378.42.683.161.054.049.136.073.173.104-.269-.36-.26-1.438-.1-1.872-.028.511.111 1.201.352 1.655.141-1.284-.626-2.817-.034-4.047-.079.721.104 1.521.16 2.243.051.644.181 1.268.373 1.888.008-.053.058-.164.064-.244.017.063.134.199.158.253.16-.298.619-.32.943-.304-.12-.428-.277-.837-.363-1.275.194.433.408.855.61 1.276.058-.305-.113-.667-.192-.964-.254-.938-.452-1.819-.524-2.784-.058-.751-.12-1.489-.094-2.244.011-.287.042-.686-.017-.907a2.627 2.627 0 0 1-.034.261c-.004-.028-.079-.237-.083-.267-.124.614-.153 1.247-.254 1.866.054-.592.017-1.656-.239-2.186a1.196 1.196 0 0 1-.664.084c-.1.293.007.626-.021.944-.03.359-.147.688-.143 1.054a19.14 19.14 0 0 0-.179-1.908 2.292 2.292 0 0 0-.017.202c0-.023-.039-.178-.035-.254a3.347 3.347 0 0 0-.239.202c-.224.857-.096 1.866-.207 2.758-.102.813.092 1.631.035 2.441-.292-1.183-.15-2.363-.26-3.554-.037-.364.021-1.268-.273-1.495.011.024.021.048.037.07-.043-.404-.565-.245-.866-.23.258.88.173 2.01.186 2.93.011.969-.011 2.147-.041 3.013-.117-1.119-.211-2.276-.309-3.411-.028-.35.041-2.588-.535-2.354-.043-.023-.041-.063-.085-.083 0 .002-.075.085-.071.083.465.293.25 1.877.263 2.334.039 1.279.075 2.595.007 3.873.187-.442.253-1.16.23-1.637.229.505.292 2.146-.075 2.577-.034-.064-.162-.144-.203-.222-.6.539-.672.45-.868-.291-.169-.638-.103-1.475-.327-2.059-.145.844.209 1.915-.386 2.657.027-.125-.049-.266-.054-.375-.262.312-.391.23-.789.237-.292.004-.506.123-.766-.117-.358-.328-.393-1.401-.467-1.856-.053-.319-.023-.642-.053-.958-.184.305-.032 1.171-.023 1.555.011.411.141.951.019 1.335a.313.313 0 0 1-.021-.088.703.703 0 0 1-.22.087c-.034-.104-.16-.205-.178-.321-.047.044-.242.1-.292.147-.05-.089-.152-.113-.191-.159-.048.127-.152.191-.243.294-.229-.272-.142-.892-.2-1.228-.079-.468-.038-1.013-.256-1.452-.022.411-.084.815-.095 1.232-.015.641-.274 1.298-.239 1.923")
        ]), M),
        A2(Da, l([
            Fa("path411"),
            Ha("#dcc06d"),
            qa("M202.071 190.128c-.002-.817.169-1.637.124-2.449-.954.133-.225 1.958-.124 2.449z")
        ]), M),
        A2(Da, l([
            Fa("path413"),
            Ha("#ccb25c"),
            qa("M194.835 283.125c.259.231.476.409.79.378-.225-.499-.116-1.132.02-1.679a.255.255 0 0 1-.036.184c-.126-.58-.338-1.333-.095-1.929-.409.955.15 2.391-.679 3.181")
        ]), M),
        A2(Da, l([
            Fa("path417"),
            Ha("#dcc06d"),
            qa("M194.521 324.339c.168-.519.202-1.443.021-1.939-.12.621-.393 1.146-.549 1.74.237.113.445.27.618.467")
        ]), M),
        A2(Da, l([
            Fa("path639"),
            Ha("#ccb25c"),
            Ua("#967348"),
            Ba(".322"),
            qa("M209.818 230.691c.013.213.032.427.06.64.077.598.255 1.156.403 1.738.096.372.324.773.277 1.169-.011.093-.288.785-.303.762-.671-1.241-2.482-1.493-3.728-1.487-1.92.011-3.856-.546-5.8-.41-.9.062-6.831.686-6.665 2.563-1.595.14-.654-4.815-.599-6.008.125-2.73-1.148-4.797 1.804-6.173 2.826-1.318 6.016-1.49 9.089-1.458 1.824.019 6.783.12 5.938 4.142-.312 1.474-.566 3.007-.476 4.522z")
        ]), M),
        A2(Da, l([
            Fa("path791"),
            Ha("#dcc06d"),
            qa("M201.673 274.946c.33.458.223 1.07.375 1.467.063-.62.369-1.215.277-1.849-.256-.086-.444-.018-.651.113")
        ]), M),
        A2(Da, l([
            Fa("path793"),
            Ha("#dcc06d"),
            qa("M204.086 274.812c.098.673.303 1.322.403 1.978-.03-.727.804-2.41-.67-1.978")
        ]), M),
        A2(Da, l([
            Fa("path797"),
            Ha("#ccb25c"),
            qa("M208.378 283.26c-.248-.875-.253-1.617-.271-2.512.062.429.149.857.277 1.268a6.461 6.461 0 0 1-.013-.462c.068.324.286.562.416.835.362-.666 0-2.002-.006-2.842-.019.692.267 1.779.674 2.261.024-.243.12-.479-.017-.845.093-.048.113.016.228-.028-.28-1.363.074-2.657-.075-3.96-.115.641-.282 1.24-.437 1.827-.48-1.034.339-2.541-.104-3.682-.488.768-.387 1.75-.645 2.62.056-.914.047-2.185.399-3.052.26.292.661.485 1.016.277.085.034.11.2.194.228.153-.097.418-.155.593-.263-.714 1.22-.345 3.487-.35 4.883-.004.813.493 2.067.269 2.628-.793-.486-1.687 1.299-2.415.818")
        ]), M),
        A2(Da, l([
            Fa("path799"),
            Ha("#ccb25c"),
            qa("M205.563 274.812c-.498.664.062 2.437.277 3.193-.127-.646.049-3.375-.412-3.327")
        ]), M),
        A2(On, l([
            Fa("g801")
        ]), l([
            A2(Da, l([
                Fa("path805"),
                Ha("#dcc06d"),
                qa("M194.253 257.29c-1.26.849-.415-.577-.632-1.123.623-.365.744-1.668.806-2.328a.07.07 0 0 0 .072.05c.205-.836.568-2.567.196-3.356.03 1.399.276 2.946-.015 4.323-.084.397-.465.742-.341 1.213.093.35.212.654.518.195.025.104.108.207.129.308.489-.286.512-1.401.614-1.953-.081.889-.136 1.772-.197 2.659-.412-.025-.781.118-1.15.281")
            ]), M),
            A2(Da, l([
                Fa("path807"),
                Ha("#dcc06d"),
                qa("M195.505 249.065c-.469.61.092 2.038.176 2.745.173-.678.182-1.497.25-2.197.042-.418.067-1.141-.426-.458")
            ]), M),
            A2(Da, l([
                Fa("path809"),
                Ha("#dcc06d"),
                qa("M198.008 248.798c-.15.189-.301.228-.256.444.055-.062.168-.128.238-.175.129.76.354 1.522.371 2.28.25-.673.056-1.401.543-1.988.015.165.106.329.104.506.099-.266.333-.581.542-.786 1.157.396.602 4.734.602 5.635.005-2.107.234-4.252.071-6.358-.211.142-.437.412-.587.611l-.036-.156c-.231.002-.411-.007-.588-.007-.125.326-.197.672-.54.788-.169-.33-.146-.766-.444-.967-.05.108-.139.168-.201.261")
            ]), M),
            A2(Da, l([
                Fa("path811"),
                Ha("#dcc06d"),
                qa("M199.707 255.949c-.216.163-.324.368-.254.615.378.07.953.242.874-.32.229.276.715.13 1.155.215.668.129 1.327.359 1.995.48.608.11 1.227.029 1.827.181.108-.229.171-.515.215-.792.008.151.098.329.107.488.041-.026.119-.123.138-.146.167.406.766.287 1.165.333.239.026.514.111.736.098.203-.013.25-.262.529-.237-.041.034-.128.092-.165.138.55.012.827-.099 1.301.192.002-.216.104-.467.122-.682.181.431.499.904.975 1.014-.508-1.622-1.071-3.182-1.064-4.896.002-.413.07-2.099.339-2.239.047-.195.202-.375.271-.521.16.997-.173 2.1-.056 3.129.111.968.416 1.931.678 2.833.23-1.627-.307-3.49-.25-5.138.011-.266.16-.952.077-1.163-.122-.307-1.035-.994-1.316-1.086-.013.5-.106 1.02-.211 1.512-.008-.06-.063-.269-.065-.406-.033.319-.09.638-.207.937-.037.003-.06-.014-.068-.05.025 1.144.29 2.258.343 3.36-.41-.733-.751-1.869-.862-2.753-.081-.638.088-1.389-.081-1.956a.55.55 0 0 1-.115.216c-.041-.692-1.372-1.319-2.022-1.213.631 1.259.531 2.91.599 4.288.032.622-.158 1.442.085 2.023.292-.639.132-1.337.194-2.014.083-.901.179-1.809.271-2.705.672 1.24.646 3.171.789 4.567.066.639.147 1.533-.248 2.048-.188-.431-.188-.946-.313-1.405-.115.477-.017 1.006-.22 1.477-.072-.108-.311-.223-.382-.334-.177.282-.454.477-.791.436-.192-.688-.393-1.336-.527-2.042-.133-.696-.131-1.609-.389-2.255.043 1.323.344 3.264-.064 4.718.03-.171-.038-.407-.032-.586-.319.132-.509.27-.791.274.113-.002-.708-.222-.627-.15-.695-.618-.46-2.038-.556-2.873-.275.793-.175 1.719-.452 2.534-.062-.06-.079-.107-.149-.158-.505.585-.816-.083-1.251-.082-.457.001-.838.601-1.345.096")
            ]), M),
            A2(Da, l([
                Fa("path813"),
                Ha("#ccb25c"),
                qa("M209.185 255.055c.454-.935-.42-2.594-.359-3.644.007 1.827.094 3.938.557 5.693.015-.066.149-.307.179-.437.318.464.984.622 1.391 1.043.134-.676-.213-1.426-.251-2.116a40.8 40.8 0 0 1-.087-2.714c.009-1.006-.085-2.302.168-3.26-.318-.142-.614-.287-.706-.619-.126 1.677-.337 3.444-.153 5.133.004-.88-.226-1.832-.292-2.722 0 1.082.07 2.199-.015 3.273-.149.075-.096-.043-.164-.079")
            ]), M),
            A2(Da, l([
                Fa("path815"),
                Ha("#ccb25c"),
                qa("M208.111 248.798c.205.635-.063 1.327.184 1.947-.066-.635.159-1.454.522-1.947-.316-.21-.637-.464-1.034-.333.06-.144-.29-.178-.484.075-.1.129.09 1.08.096 1.238.025.581.055 1.128.183 1.699-.015-.771-.177-2.257.533-2.767")
            ]), M),
            A2(Da, l([
                Fa("path817"),
                Ha("#ccb25c"),
                qa("M205.339 254.34c.414.901.083 1.758.192 2.668.111.054.396.104.51.092.132-1.133-.281-2.471-.633-3.537-.09.273-.066.56-.068.867")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path1115"),
            Ha("#f4e9d7"),
            Ua("#967348"),
            Ba(".32"),
            qa("M194.325 158.323c.83 3.676 6.25 4.976 10.03 4.919 2.734-.04 8.026-.856 8.246-4.016.071-1.01-.015-3.847-.201-4.833-.561-2.969-3.572-3.127-5.933-3.091-3.309.051-7.045-1.503-10.288-.458-2.512.81-1.851 4.13-1.956 6.23-.022.444.015.86.102 1.249z")
        ]), M),
        A2(Da, l([
            Fa("path1607"),
            Ha("#dcc06d"),
            qa("M211.144 154.11c-.149.024-.183.093-.305.155 1.007-.007.429 3.204.217 3.813a5.413 5.413 0 0 1-.121-1.627c-.143.128-.412.239-.522.342l-.039-.24c-.729.12-1.279.664-1.99.788-.938.165-2.764.057-3.625-.301.013-.106.1-.102.119-.208-2.036-.168-4.373.231-6.116-1.109.747.574 2.791.38 3.674.344 3.05-.127 6.578 1.059 8.708-1.957z")
        ]), M),
        A2(Da, l([
            Fa("path377"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".236"),
            qa("M205.985 276.415c-2.338-.137-4.773.406-7.101.581-1.515.114-3.132.242-4.617-.15-.553-.146-1.566-.505-1.966-.912-.56-.57-.205-1.496-.194-2.193.007-.442.035-.907-.02-1.341-.152-1.187.604-1.383 1.49-1.965 1.14-.75 2.381-1.158 3.719-1.402 3.23-.585 6.779-.377 9.966.403 1.271.313 3.41.665 3.193 2.332-.109.841-.384 1.671-.303 2.528.073.755.275 1.541-.386 2.145-.859.782-2.772.034-3.781-.026z"),
            ln("inline"),
            zn("visible")
        ]), M),
        A2(Da, l([
            Fa("path379"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".25"),
            qa("M209.582 236.422c.119.893.377 1.865-.082 2.583-.666 1.045-2.363.726-3.303.597-1.989-.276-3.808-.099-5.842-.015-2.435.103-4.326-.762-6.256 1.292-.17.182-.801-1.731-.83-2.012-.077-.743.233-1.403.395-2.099.176-.758.003-1.361.048-2.1.074-1.182.938-1.215 1.819-1.256 2.708-.127 5.355-.09 8.065-.048 1.495.023 2.997.156 4.479.139 1.288-.015 1.618.625 1.467 2.008-.029.282-.003.592.04.911z"),
            ln("inline"),
            zn("visible")
        ]), M),
        A2(Da, l([
            Fa("path635"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".25"),
            qa("M207.527 263.216c-3.056-.631-5.895-.658-8.951-.232-1.44.2-2.953.763-4.414.509-1.649-.286-1.373-1.667-1.066-3.11.1-.475.114-1.004.085-1.51-.177-3.102 4.484-2.889 6.28-3.194 3.133-.532 6.848-1.59 9.935-.319 1.57.647 1.766 1.75 1.568 3.49-.12 1.046-.086 1.859.004 2.891.068.773.068 1.654-.618 2.081-.746.461-2.036-.443-2.823-.606z")
        ]), M),
        A2(Da, l([
            Fa("path637"),
            Ha("#e1e2e3"),
            Ua("#967348"),
            Ba(".25"),
            qa("M206.474 248.176c-1.668-.137-3.336.079-4.983.363-1.42.244-2.884.108-4.292.443-1.065.255-2.513 1.08-3.189-.389-.456-.984.002-2.327.249-3.307.792-3.149 3.692-2.639 6.054-2.933 2.18-.27 4.409-.714 6.602-.357 1.075.174 2.052.556 2.845 1.417 1.049 1.135.75 1.558.855 3.054.062.891.8 2.093-.334 2.309-1.079.206-2.686-.508-3.807-.6z")
        ]), M),
        A2(On, l([
            Fa("g4248")
        ]), l([
            A2(Da, l([
                Fa("path787"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".322"),
                qa("M202.353 273.56c2.154 0 4.324-.161 6.457.25.597.116 2.261.046 2.504.735.207.583-.273 1.719-.326 2.352-.087 1.036-.361 2.015-.171 3.064.19 1.039.904 1.969.339 3.047-.333.634-1.018.875-1.67 1.052-1.31.356-2.687.65-4.037.803-2.549.287-5.488.134-8.1-.03-1.404-.088-2.712-.233-4.041-.687-1.146-.39-1.021-1.133-.875-2.149.223-1.554.133-3.038-.06-4.591-.111-.897-.6-2.025.258-2.729.673-.554 2.07-.766 2.906-.91 2.252-.387 4.545-.207 6.816-.207z")
            ]), M),
            A2(Da, l([
                Fa("path789"),
                Ha("#dcc06d"),
                qa("M200.065 283.796c.227.133.53.167.779.113.062-.185.186-.438.189-.633a.195.195 0 0 1 .141.065c.056-.175.152-.395.238-.577-.079.488-.078.951.292 1.284.08-.073.276-.172.372-.269.484.256 1.164.167 1.723.131-.038-.532.03-1.105.258-1.551.03.472-.028.974.198 1.397.3-.246 2.042-.313 2.634-.388-.077-.109-.066-.236-.096-.331a.586.586 0 0 1 .145.204c.608-.218 1.871-.15 2.241-.735.146.111.261.133.382.198.043-.028.51-.421.404-.336-1.156-1.438-.943-5.311-.229-6.885-.263-.224-.655-.949-1.06-.786-.51.204-.427 2.119-.424 2.571-.427-1.084.401-2.466-1.054-2.712-.058.115-.019.229-.023.348-.032-.058-.092-.193-.109-.223-.081.836.087 1.719-.132 2.538-.019-.722-.111-2.043-.526-2.625a1.185 1.185 0 0 1-.246.167c-.015-.006-.226-.167-.203-.169.041 1.188.435 2.383.542 3.604.093 1.057.126 2.118.269 3.15.111-1.046.141-2.079.13-3.14.156.541.103 1.121.269 1.662.426-.925-.064-2.388.375-3.171.104 1.939.117 3.896.172 5.854-.258-.327-.405-.86-.516-1.156-.017.389-.075.816-.271 1.167-.055-.097-.03-.224-.051-.331-.117.142-.184.276-.346.339-.16-.141-.158-.182-.373-.231-.109.411-.294.494-.576.639-.198-.871-.664-1.625-.83-2.534-.149-.821-.156-1.752-.375-2.516.222.899.687 3.915.007 4.654-.107-.514-.192-1.214-.403-1.59-.017.314-.182.487-.271.755a2.005 2.005 0 0 1-.055-.187c-.32.604-.301 1.343-.668 1.955-1.533-.43-.947-4.22-1.18-5.446-.006 1.455-.146 2.887-.131 4.345-.034-.292-.167-.594-.238-.859-.12.519-.49 1.511-.806 1.818-.425-.659-.267-1.601-.435-2.357.034.892-.192 1.761-.134 2.646")
            ]), M),
            A2(Da, l([
                Fa("path795"),
                Ha("#dcc06d"),
                qa("M194.03 275.617c-.598-.15-.965.051-.929.621-.092-.003-.098-.136-.251-.065-.313.58.113 1.092.249 1.724.24 1.11.19 2.457.128 3.599-.031.552.04 2.6 1.076 1.545.243.361.628.461 1.048.332-.048-1.836-.127-3.689-.109-5.573-.302 1.33.184 3.654-.645 4.75-.087-.347-.279-.409-.436-.647-.058.098-.206.237-.271.375.04-1.762.155-4.007-.234-5.682.126.063.095.239.136.35.006-.004.261-.217.242-.218.122.866.316 1.798.265 2.678.003-1.19.096-3.026.161-4.449.518.521.606 1.568.643 2.309.007-.808.198-1.646.115-2.434-.586-.157-.994.256-1.454.517")
            ]), M)
        ])),
        A2(Da, l([
            Fa("path803"),
            Ha("#f4e9d7"),
            Ua("#967348"),
            Ba(".342"),
            qa("M211.373 250.003c.047-3.234-7.329-3.008-8.979-2.986-2.039.027-4.158.175-6.137.767-.824.247-1.684.333-2.363.967-.924.862-.469 1.573-.353 2.732.15 1.495-.149 2.954-.481 4.386-.169.731-1.027 2.716-.394 3.381.431.453.299 0 .623-.159 1.277-.626 2.4-.713 3.729-.932 2.302-.38 4.645-.357 6.961-.186 1.182.086 2.362.217 3.539.367.753.097 2.128-.045 2.811.347.25.143.371.517.482.588.75.482.942-.506.866-1.147-.117-.999-.663-1.832-.714-2.816-.051-.997-.089-1.952-.015-2.948.058-.807.412-1.566.425-2.361z"),
            ln("inline"),
            zn("visible")
        ]), M),
        A2(On, l([
            Fa("g819")
        ]), l([
            A2(Da, l([
                Fa("path821"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".342"),
                qa("M210.991 266.431c.149-2.021 1.235-3.79-.823-4.656-1.149-.483-2.472-.716-3.689-.807-1.656-.124-3.321-.447-4.979-.486-2.157-.051-4.355.23-6.429.91-.774.252-1.992.644-2.59 1.282-.66.709-.039 1.601.007 2.498.071 1.408.085 2.784-.222 4.163-.237 1.061-.638 2.362.206 3.214-.005-.646 1.672-.865 2.117-1.027.994-.364 2.065-.562 3.095-.749 2.826-.512 5.635-.533 8.478-.234 1.325.14 2.747.315 4.009.82.267.106.811.513 1.016.423.514-.227.175-1.121.063-1.502-.328-1.112-.355-2.512-.259-3.849z")
            ]), M),
            A2(Da, l([
                Fa("path823"),
                Ha("#dcc06d"),
                qa("M208.359 268.469c.049.531.075 1.122.384 1.58-.017-.131.019-.273.011-.394.258.587 1.488.861 2.02 1.126-.026-.159-.008-.336-.075-.497.062.154.215.393.26.504-.469-2.009-.458-4.051-.35-6.102.024-.437.233-1.021.03-1.427-.163-.329-.676-.682-.898-.957a13.665 13.665 0 0 0-.469 3.275c0-.867.124-1.876.015-2.727-.082-.63-.397-.707-1.088-.911-.209-.062-.873-.047-1.035-.002.021.006.134.156.141.17.062-.011.109-.082.162-.07.152 1.628-.433 3.446.177 4.993.085-.968-.125-4.624.363-4.721.296.731.13 1.689.213 2.464.188-.408.229-.87.316-1.289.337.969.55 2.538.286 3.531.068-.259.119-.504.205-.759.246.782.134 1.989.049 2.826-.7-.755-.606-2.189-.717-3.181-.262.873.124 2.687-.588 3.366.023-.124-.034-.31-.032-.437-.201.086-.426.078-.61.163-.346-.516-.254-1.27-.544-1.858.047.549-.037 1.187-.326 1.661-.205-.2-.525.073-.74.115-.262.053-.758-.049-1.078-.069-.77-.049-1.563-.172-2.312-.007.068.127.026.313.068.418-.81.314-2.066.152-2.926.092.013-.379-.047-.762-.096-1.135-.141.337-.259.686-.367 1.033-.004-.082-.006-.158-.014-.238-.513.883-1.642.772-2.562.968-.011-.357-.008-.715-.123-1.063-.218.502-.478.944-.872 1.309 1.922-.803 4.354-.537 6.413-.528.737.003 1.392-.139 2.098-.154.676-.015 1.348.055 2.024.083.546.021 1.203.288 1.721.268.896-.035.48-.733.866-1.419z")
            ]), M),
            A2(Da, l([
                Fa("path825"),
                Ha("#dcc06d"),
                qa("M193.292 267.84c-.29 1.093-.844 2.125-.724 3.289.242-.146.502-.293.783-.359-.161-.346-.089-.829.012-1.208-.017.365-.091.812.176 1.063.036-.129.177-.25.192-.451.166.099.448.089.599.158.04-1.103.32-2.133.646-3.18-.457.844-.622 1.632-.92 2.537a.511.511 0 0 1-.087-.141c-.02.015-.21.141-.237.141.016-.211-.048-.467-.031-.679-.324.349-.577 1.079-.608 1.575-.064-.983.285-1.855.561-2.738.325-1.042.251-2.189.242-3.271.073.623.075 1.311.25 1.903.085-1.11.024-2.332.306-3.406.265.675.353 1.592.334 2.318.242-.537.059-2.616-.418-2.996a2.41 2.41 0 0 0-.407.592c-.035-.037-.11-.116-.151-.178-.342.299-.078.768-.186 1.163.031-.32-.146-.687-.304-.934-.328.397.069 1.578.112 2.084.077.913.097 1.823-.14 2.718z")
            ]), M),
            A2(Da, l([
                Fa("path827"),
                Ha("#dcc06d"),
                qa("M198.098 262.117a.787.787 0 0 0-.522-.076c-.002.525.625 1.092.771 1.683.251 1.015.23 2.116.445 3.113-.15-.697-.032-1.623-.133-2.365-.094-.682-.356-1.628-.007-2.261.391.304.677-.233 1.129-.171.271.872.194 2.209.194 2.956.005-1.191.181-2.396.072-3.584-.122.135-.298.218-.403.402-.432.751-1.274-1.009-1.814.125")
            ]), M),
            A2(Da, l([
                Fa("path829"),
                Ha("#dcc06d"),
                qa("M205.697 262.207c-.085.019.491.031.282-.006-.406.263.181.496.367.819.433.759.305 2.09.354 2.939.348-.945.111-2.693-.032-3.738-.117-.025-.228-.087-.345-.104")
            ]), M),
            A2(Da, l([
                Fa("path831"),
                Ha("#ccb25c"),
                qa("M210.972 263.548c.258 2.212-.631 4.603.32 6.707a.503.503 0 0 1-.307.101c.006.032-.002.24-.013.269-.034-.091-.275-.25-.522-.293.004-.593-.107-1.629-.397-2.104-.177.416.529 2.184-.23 2.102-.139-1.021.068-2.156.006-3.186-.051-.877-.032-1.729-.11-2.591.164.876.179 1.791.382 2.663.486-1.234-.175-2.976.435-4.309-.183.415-.158 1.014.013 1.439.136-.253.196-.644.337-.949-.04.122.036.096.086.151")
            ]), M),
            A2(Da, l([
                Fa("path833"),
                Ha("#ccb25c"),
                qa("M192.555 271.236c1.256-.554 2.476-1.119 3.819-1.34-.785-.072-1.754.213-2.46.527-.019-.112-.11-.216-.123-.342-.089.082-.323.136-.419.23-.008-.075-.019-.148-.026-.225-.71-.236-.557.453-.662.881.127.128 0 .109-.04.179")
            ]), M)
        ])),
        A2(On, l([
            Fa("g835")
        ]), l([
            A2(Da, l([
                Fa("path837"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".342"),
                qa("M193.683 244.095c-.164.783-.424 1.981.142 2.254.264.128.888-.369 1.149-.481 2.829-1.222 6.024-1.382 9.041-1.51 1.162-.05 2.329.132 3.462.425.644.166 1.215.615 1.858.786.486.13 1.48-.084 1.251.864.666-.451.586-1.169.386-1.878-.307-1.082-.488-1.883-.536-3.029-.034-.9.092-1.455.267-2.314.565-2.782-4.291-3.414-6.006-3.498-2.817-.135-5.61.431-8.387.868-1.245.197-3.016.465-2.962 2.231.021.688.339 1.391.446 2.071.138.89.072 1.81-.017 2.7-.014.126-.051.303-.094.511z")
            ]), M),
            A2(Da, l([
                Fa("path839"),
                Ha("#dcc06d"),
                qa("M206.636 243.567c.574-.035 1.163.221 1.693.398-.028.882.617.033 1.021.125.375.083 1.077.685 1.284.94-.378-1.291-.813-2.674-.734-4.026.041-.702.751-2.188.227-2.784-.222-.255-.732.031-1.022-.156-.377-.243-.301-.74-.714-1.013-.235.489-.585.714-.951.184-.075.17-.139.361-.164.548.021.002-.31-.036-.241-.061a2.507 2.507 0 0 1-.107.099c.363 1.132.431 2.507.371 3.705.322-.939.399-2.437.429-3.44.239.04.312.042.525.238.034-.026.183-.193.234-.212.068.716-.008 1.49.056 2.204.143-.595.149-1.269.48-1.805.066 1.217.674 3.545-.002 4.635-.085-.128-.406-.336-.474-.509-.032.187-.16.346-.198.516-.06-.079-.288-.216-.375-.352-.047.21-.258.476-.288.745-.422.025-.58.047-.913.231-.979-.49-1.841-.385-2.916-.613-.842-.179-.992-.07-1.248-1.074-.184-.716-.132-1.551-.369-2.222-.085 1.038.179 2.286-.158 3.243-.503-.065-1.209.144-1.726.303-.036-.78-.183-1.494-.298-2.27.012.292-.106 1.386-.268 1.911.017.01.077-.003.013-.114-.233.993-2.726.646-3.637 1.113-.001-.744.131-1.488.174-2.235.03-.53-.123-1.488.074-1.863-.016.975.169 2.089.291 3.029.466-1.49.258-3.679.363-5.024a.247.247 0 0 0 .181.121c.125-.208.462-.402.566-.673.466.419.269 1.686.376 2.34.146-.966.136-1.93.968-2.6.427.434.517 1.614.502 2.288-.035-.606.224-1.965.108-2.836-.131.337-.385.421-.646.606a2.647 2.647 0 0 1-.258-.199c.084.069-1.897.466-2.052.513.132-.041-1.074.568-.948.438-.455.472-.364 1.063-.49 1.811-.114-.57-.209-1.154-.432-1.683-1.576.267-.857 1.155-.675 2.26.254 1.539-.328 3.092.136 4.556 1.231-.486.699-2.823.699-3.844-.001 1.105.172 2.206.154 3.291.43.047.849-.104 1.187-.382")
            ]), M),
            A2(Da, l([
                Fa("path841"),
                Ha("#ccb25c"),
                qa("M210.257 244.104c-.441-.317-.853-.466-1.307-.282-.156-.475-.495-.743-.959-.573.267-.73.119-1.67.121-2.459.024.577.156 1.135.299 1.696.062.015.158-.093.237-.108.137.216.356.353.51.506.092-1.137.049-2.355-.237-3.432-.166.455-.181.983-.414 1.386.021-.955.162-2.267-.241-3.019.158.234.489.367.759.499.077-.069.203-.177.26-.231.344.302.235.348.683.272-.476 1.492-.542 4.306.403 5.617-.313.287-.094.003-.113-.005")
            ]), M),
            A2(Da, l([
                Fa("path843"),
                Ha("#ccb25c"),
                qa("M195.237 243.567a2.5 2.5 0 0 0-.657 1.33c1.452-.202.875-3.491.515-4.375.025 1.193.035 2.617-.394 3.717")
            ]), M)
        ])),
        A2(On, l([
            Fa("g1117"),
            ln("inline")
        ]), l([
            A2(Da, l([
                Fa("path1119"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M204.667 151.082c-1.653-.067-11.576-1.645-8.276 2.493.697.875 1.953 1.218 2.991 1.447 2.369.524 4.875.361 7.277.234 1.536-.083 4.332-.833 3.914-2.874-.428-2.08-4.247-1.233-5.906-1.3z")
            ]), M),
            A2(Da, l([
                Fa("path1121"),
                Ha("#f4e9d7"),
                Ua("#967348"),
                Ba(".32"),
                qa("M212.405 146.129c.058-.328.104-.663.134-1.008.177-1.931-.563-2.281-2.316-3.003-2.289-.942-4.73-.973-7.161-.691-1.467.169-2.848.872-4.327.937-1.134.049-2.104-.426-3.132.216-2.983 1.862.002 5.797-1.422 8.146.101-.142 2.716 1.929 2.955 2.079 1.561.982 3.259 1.101 5.07 1.284 2.387.242 4.626-.268 6.964-.642 2.107-.336 2.576-1.229 2.64-3.519.04-1.369.379-2.54.595-3.799z")
            ]), M),
            A2(Da, l([
                Fa("path1123"),
                Ha("#dcc06d"),
                qa("M196.31 150.905c.592.591 1.349 1.44 2.132 1.586-.358-.449-.63-1.097-.514-1.711-.583 1.646-1.283-.518-1.26-1.251-.121.604-.044 1.72-.537 1.555")
            ]), M),
            A2(Da, l([
                Fa("path1125"),
                Ha("#dcc06d"),
                qa("M205.608 153.051c.755.081 4.563-.254 3.916-1.537.143.247.454.385.604.615.155-.082.765-.522.816-.589.045-.664.047-1.379-.008-2.047-.228.138-.44.059-.648.133-.047-.423-.28-.709-.2-1.16-.461.852-.026 2.025-.224 2.961-.704-.399-.427-1.367-.689-2.077-.16.971.085 2.148-.695 2.82-.382.326-1.952.596-2.487.496-.023-.253-.177-.432-.209-.625-.038.339-.243.501-.343.765-.668-.116-2.805.123-3.394.393 1.294-.388 2.914-.148 4.277-.148")
            ]), M),
            A2(Da, l([
                Fa("path1127"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M205.648 141.385c-2.988-.482-7.505-1.865-10.062.504-1.802 1.67-2.008 5.045.545 6.112 3.096 1.291 6.219-.069 9.259.44 2.933.492 6.557.168 6.123-3.834-.309-2.824-3.476-2.837-5.865-3.222z")
            ]), M)
        ]))
    ]), sr = l([
        A2(On, l([
            Fa("TibiaRight")
        ]), l([
            A2(Da, l([
                Fa("path431"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M153.748 591.677c-1.213 2.563-.193 7.182-.051 9.959.193 3.769 2.044 6.459 4.367 9.315 2.713 3.338 4.924 8.374 6.499 12.427 4.457 11.476 4.983 25.45 4.926 37.644-.03 6.397.458 12.963 1.083 19.287.617 6.25 2.122 12.087 3.209 18.255 2.601 14.741 1.397 29.671 1.708 44.549.116 5.581-3.227 11.08-1.242 16.617 1.563 4.362 7.873 4.551 11.603 6.404 1.48.735 2.295 2.353 4.083 2.642 4.836.778 7.059-6.007 7.806-9.521 1.006-4.735-1.775-8.615-2.959-13.115-.578-2.196-.424-4.219-.657-6.375-.299-2.771-1.43-5.474-2.126-8.185-1.561-6.076-2.569-12.319-2.481-18.608.079-5.609 1.053-11.303.713-16.908-.28-4.626-.851-9.24-1.062-13.921-.457-10.102-1.598-20.121-1.091-30.155.793-15.703 4.327-30.654 7.179-46.023.474-2.549-.094-3.852-.646-6.195-.397-1.685-.279-1.379-.079-3.138.204-1.787 1.234-1.773-.288-3.567-3.437-4.05-10.172-.603-14.106.367-4.095 1.008-9.379 1.331-13.615 1.08-1.26-.077-12.378-3.67-12.773-2.835z")
            ]), M),
            A2(Da, l([
                Fa("path433"),
                Ha("#dcc06d"),
                qa("M189.774 618.452c1.121-2.655 7.147-14.558 4.003-17.203-1.482-1.247-5.577 1.628-6.646 2.956 1.951-2.426 4.772-4.687 5.472-7.871 1.053-4.792-2.578-2.763-5.597-2.101-4.163.913-8.882 1.227-12.721 3.442 2.945-.276 6.083-1.668 9.101-1.688-.113 1.878-4.018 3.7-5.479 4.518-2.657 1.491-5.339 2.076-8.328 2.57-2.314.383-6.096.314-7.83 2.066 1.407 2.214 3.98 3.471 6.522 3.659 1.423.105 6.589-.024 7.339-1.291-1.938 3.273-2.195 8.78 2.404 3.908.291 1.352-.69 1.591-.748 2.674-.099 1.867.155 1.075.91 2.942 1.479 3.659 2.052 9.383 1.664 12.97.78-3.769.87-7.328 1.063-10.81.18-3.241 2.916-7.492 5.71-8.929-.16.356-.367.745-.552 1.111 1.511-2.112 3.55-4.55 5.934-5.68-.472 1.96-9.14 10.848-6.459 11.771-.591 1.861.004 4.869-.214 6.716-.353 2.986-1.646 6.241-2.235 9.278-2.143 11.057-.458 22.718-1.064 33.98-.339 6.303-.299 12.938.043 19.319.462 8.606 2.523 17.889 1.555 26.439-1.09 9.619 1.319 17.887 3.286 27.14 1.016 4.785 7.142 16.229 1.63 20.387-.769-.937-1.787-1.389-2.704-.784-.392-1.688-.738-3.709-.968-5.488-.202 2.521-1.123 3.585.34 5.615.896 1.241 4.422 4.67 5.676 4.956-.396-.091.511-13.187 4.64-10.716.837-5.152-1.958-12.493-3.405-17.485-1.234-4.253-3.414-8.361-3.693-12.777-.643-10.15-.693-20.113-1.332-30.232a583.496 583.496 0 0 1-1.153-36.307c-.011-7.577.16-15.347.794-22.885.424-5.013 1.081-11.521 3.042-16.17z")
            ]), M),
            A2(Da, l([
                Fa("path435"),
                Ha("#dcc06d"),
                qa("M172.708 626.328c-.091-.593-.347-.869-.769-.83-.215 5.463 1.349 12.675 3.647 17.56-.076-3.051-.176-5.861-.655-8.89-.303-1.913-1.551-5.883-1.09-7.786.536-2.214 3.409-2.61 2.728-5.396-.781 1.148-2.57 3.98-4.506 3.866-1.603-.093-1.699-3.043-4.031-1.055-.193-.486-.639-1.11-.724-1.667 1.197 3.769 1.446 7.949 2.912 11.611-.126-2.778-1.86-6.773-.015-9.201")
            ]), M),
            A2(Da, l([
                Fa("path437"),
                Ha("#ccb25c"),
                qa("M192.044 598.696c.747-.607 2.271-3.133 1.959-4.168-.663-2.2-1.25-.534-2.582-1.105 3.686 1.583-4.614 6.538-5.714 7.838 1.014-.813 3.021-1.066 3.297.663.283 1.772-2.493 3.298-3.672 4.082-1.837 1.219-2.72 2.416-4.281 3.763 3.308-2.853 6.747-5.536 10.466-7.723a1.197 1.197 0 0 0-.173.646c.681-.707 1.561-.758 2.399-.983.149.531.418 1.075.436 1.623-.23-1.666-.743-3.654-2.135-4.636z")
            ]), M),
            A2(Da, l([
                Fa("path439"),
                Ha("#ccb25c"),
                qa("M186.296 697.132c.047 6.914.991 13.771 1.422 20.654.37 5.9 2.233 11.478 2.866 17.141-.948-8.573-2.143-17.006-2.143-25.646 0-4.108 1.058-11.764-1.341-15.012-.608 1.578-.512 3.32-.447 5.007")
            ]), M),
            A2(Da, l([
                Fa("path441"),
                Ha("#ccb25c"),
                qa("M187.728 761.499c2.161.196 3.663 1.889 4.943 3.206.123-1.663-.614-5.002.421-6.451 1.778-2.491 2.332.227 2.207 2.143 3.413-1.964.939-8.501-1.153-10.608-1.512 4.073-1.466 9.86-5.346 12.783")
            ]), M),
            A2(Da, l([
                Fa("path443"),
                Ha("#ccb25c"),
                qa("M178.429 751.843c-.815 2.656-3.313 7.766 1.393 6.749-.959-2.324-1.423-4.273-.32-6.749")
            ]), M),
            A2(Da, l([
                Fa("path445"),
                Ha("#ccb25c"),
                qa("M188.529 632.001c.138-1.604.356-3.172.708-4.679.62-2.658 2.193-5.052 2.582-7.736.25-1.743-.013-3.646.218-5.444.194-1.511.539-8.811 2.518-9.268-.436.099-1.351.648-1.706.973 3.422 4.877-3.29 10.241-4.572 14.535-1.853 6.206-1.167 12.802-1.883 19.159-1.159 10.284-.495 20.742-.455 31.028-.014-7.842.902-15.638 1.874-23.406.606-4.846.283-10.174.716-15.162z")
            ]), M)
        ])),
        A2(On, l([
            Fa("TibiaLeft")
        ]), l([
            A2(Da, l([
                Fa("path2371"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M247.396 590.918c1.194 2.572.136 7.183-.025 9.96-.223 3.766-2.095 6.443-4.438 9.281-2.739 3.316-4.989 8.335-6.595 12.377-4.545 11.44-5.179 25.412-5.215 37.604-.019 6.396-.557 12.959-1.23 19.277-.666 6.246-2.214 12.071-3.351 18.229-2.713 14.721-1.624 29.661-2.05 44.531-.128 4.469 1.793 10.134.575 14.4-.476 1.66-1.571 2.433-2.908 3.438-1.408 1.057-2.587 2.987-4.065 3.795-1.713.939-4.025.256-5.96.459-2.184.228-3.888 1.412-5.646 2.675-2.301 1.651-3.944 2.373-4.756-.987-.784-3.241-1.25-7.284-.58-10.538.942-4.573 2.821-8.881 4.272-13.301 2.762-8.415 3.265-18.039 4.372-26.832.832-6.607-.136-13.575.318-20.268.316-4.621.923-9.232 1.171-13.912.533-10.097 1.751-20.108 1.32-30.145-.672-15.709-4.091-30.688-6.825-46.076-.452-2.555.124-3.852.693-6.191.41-1.682.29-1.378.104-3.137-.19-1.79-1.222-1.783.313-3.564 3.468-4.024 10.176-.524 14.103.474 4.088 1.04 9.369 1.403 13.607 1.186 1.261-.066 12.406-3.571 12.796-2.735z")
            ]), M),
            A2(Da, l([
                Fa("path2373"),
                Ha("#dcc06d"),
                qa("M211.166 617.417c-1.101-2.666-7.037-14.613-3.871-17.234 1.491-1.234 5.564 1.672 6.622 3.008-1.932-2.44-4.737-4.724-5.411-7.913-1.016-4.8 2.6-2.743 5.611-2.058 4.157.946 8.872 1.294 12.694 3.538-2.94-.297-6.069-1.712-9.088-1.756.1 1.878 3.99 3.729 5.443 4.56 2.646 1.51 5.323 2.116 8.309 2.634 2.313.401 6.094.361 7.815 2.126-1.426 2.203-4.01 3.44-6.552 3.608-1.423.095-6.589-.074-7.327-1.346 1.912 3.287 2.127 8.797-2.435 3.889-.301 1.35.678 1.596.727 2.679.085 1.869-.165 1.075-.932 2.936-1.508 3.647-2.124 9.366-1.764 12.959-.75-3.776-.814-7.336-.98-10.82-.154-3.241-2.858-7.513-5.642-8.973.158.357.362.75.544 1.117-1.496-2.124-3.515-4.577-5.891-5.726.458 1.964 9.058 10.919 6.371 11.82.576 1.868-.041 4.869.164 6.717.329 2.99 1.598 6.254 2.161 9.297 2.061 11.071.286 22.722.806 33.987.29 6.305.198 12.94-.194 19.318-.527 8.603-2.66 17.87-1.757 26.427 1.015 9.627-1.457 17.876-3.494 27.114-1.053 4.776-7.266 16.174-1.787 20.372.774-.929 1.798-1.374 2.711-.763a60.247 60.247 0 0 0 1.011-5.48c.182 2.521 1.094 3.594-.384 5.612-.906 1.234-4.458 4.635-5.713 4.913.396-.088-.41-13.19-4.559-10.752-.798-5.158 2.054-12.478 3.541-17.459 1.264-4.242 3.476-8.335 3.79-12.749.719-10.144.849-20.107 1.566-30.222a585.071 585.071 0 0 0 1.429-36.296c.071-7.577-.041-15.346-.619-22.889-.384-5.018-.992-11.533-2.915-16.195z")
            ]), M),
            A2(Da, l([
                Fa("path2375"),
                Ha("#dcc06d"),
                qa("M228.17 625.423c.094-.593.354-.867.774-.824.175 5.464-1.445 12.665-3.781 17.532.101-3.05.222-5.862.723-8.885.318-1.912 1.596-5.871 1.15-7.777-.52-2.219-3.39-2.637-2.686-5.417.77 1.154 2.54 3.998 4.474 3.901 1.604-.083 1.723-3.031 4.04-1.024.196-.486.646-1.106.736-1.662-1.224 3.759-1.506 7.938-2.999 11.588.147-2.776 1.911-6.759.085-9.199")
            ]), M),
            A2(Da, l([
                Fa("path2377"),
                Ha("#ccb25c"),
                qa("M209.048 597.644c-.742-.613-2.246-3.149-1.926-4.183.676-2.194 1.254-.525 2.589-1.087-3.698 1.556 4.563 6.573 5.652 7.883-1.007-.821-3.012-1.09-3.302.638-.296 1.771 2.467 3.317 3.641 4.11 1.828 1.232 2.703 2.437 4.253 3.795-3.287-2.877-6.704-5.587-10.408-7.803.117.2.175.416.169.647-.676-.711-1.555-.769-2.391-1.001-.154.53-.427 1.071-.448 1.62.243-1.664.772-3.649 2.171-4.619z")
            ]), M),
            A2(Da, l([
                Fa("path2379"),
                Ha("#ccb25c"),
                qa("M214.039 696.121c-.1 6.913-1.096 13.762-1.581 20.643-.414 5.897-2.32 11.46-2.999 17.117 1.015-8.567 2.275-16.987 2.342-25.628.03-4.106-.968-11.771 1.455-15.001.595 1.584.486 3.324.41 5.011")
            ]), M),
            A2(Da, l([
                Fa("path2381"),
                Ha("#ccb25c"),
                qa("M212.115 760.475c-2.163.181-3.679 1.86-4.969 3.168-.109-1.664.653-4.997-.371-6.453-1.758-2.507-2.334.208-2.223 2.124-3.398-1.989-.875-8.508 1.233-10.6 1.482 4.088 1.393 9.872 5.249 12.825")
            ]), M),
            A2(Da, l([
                Fa("path2383"),
                Ha("#ccb25c"),
                qa("M221.487 750.892c.793 2.66 3.252 7.788-1.444 6.738.975-2.319 1.455-4.265.371-6.747")
            ]), M),
            A2(Da, l([
                Fa("path2385"),
                Ha("#ccb25c"),
                qa("M212.307 630.974c-.126-1.604-.33-3.175-.671-4.683-.6-2.662-2.154-5.069-2.523-7.756-.237-1.746.041-3.646-.175-5.446-.181-1.513-.471-8.814-2.447-9.286.434.102 1.344.658 1.698.985-3.459 4.85 3.21 10.267 4.46 14.569 1.804 6.22 1.068 12.811 1.736 19.173 1.079 10.293.334 20.746.217 31.03.075-7.84-.783-15.643-1.695-23.42-.57-4.849-.205-10.175-.6-15.166z")
            ]), M)
        ]))
    ]), lr = l([
        A2(On, l([
            Fa("UlnaLeft")
        ]), l([
            A2(Da, l([
                Fa("path1699"),
                Ha("#bbbdbf"),
                qa("M305.731 311.869c-.008.956-.026 1.778.481 2.545-.356-.789.205-1.479.84-1.827-.468-.146-.919-.311-1.323-.583")
            ]), M),
            A2(Da, l([
                Fa("path1701"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M325.653 338.044c-.108-1.411-.267-2.821-.636-4.138-.754-2.691-.985-5.482-1.738-8.143-.663-2.359-1.898-4.687-3.12-6.79-1.201-2.063-1.271-3.105-.808-5.43.274-1.367.074-.957-.998-1.648-1.884-1.216-2.479-4.272.148-5.076-1.738-.104-3.877.046-5.507.694-1.551.617-2.423 2.273-3.976 2.909-1.828.747-3.394-.884-4.679 1.079-1.37 2.092 1.085 4.775 2.162 6.429 2.065 3.175 2.201 4.786 2.656 8.365.853 6.714 4.263 13.444 5.814 20.022 1.95 8.268 3.336 16.547 6.225 24.666 1.356 3.816 2.097 7.831 3.419 11.656 1.369 3.958 3.42 7.664 4.786 11.695a444.583 444.583 0 0 1 4.053 12.655c.294.957.394 3.489 1.82 3.635 1.604.164 1.675-2.27 2.88-2.799 1.772-.775 8.479 2.346 6.761-1.702-.303-.713-3.239-2.254-3.924-3.339-.826-1.306-1.621-2.96-2.262-4.392-2.156-4.8-3.854-10.133-4.813-15.278-.669-3.584-2.131-6.305-3.094-9.758-2.914-10.43-3.894-21.25-4.928-31.989-.1-1.076-.155-2.2-.241-3.323z")
            ]), M),
            A2(Da, l([
                Fa("path1703"),
                Ha("#dcc06d"),
                qa("M314.65 323.24c-.951-3.846-2.489-3.842-4.873-6.179-2.433-2.383-1.336-4.612 1.011-6.552 1.226-1.014 2.926-1.66 4.341-2.319.815 2.247.159 5.453.961 8.113 1.026 3.403.597 5.352.602 8.938.009 7.263 1.731 14.613 3.325 21.782-1.188-4.804-2.978-9.335-3.875-14.225-.592-3.211-.718-6.426-1.492-9.558z")
            ]), M),
            A2(Da, l([
                Fa("path1705"),
                Ha("#dcc06d"),
                qa("M319.871 356.395c1.421 4.887 2.262 9.268 4.393 14.001 1.377 3.061 3.137 5.876 4.527 8.874.196-.507.827-2.047.829-2.062.048 4.701 1.353 9.387 2.363 13.921-1.201-2.214-2.765-1.805-4.187-3.237-1.89-1.899-3.171-7.215-3.83-9.701-1.947-7.336-2.446-15.481-4.802-22.52")
            ]), M),
            A2(Da, l([
                Fa("path1707"),
                Ha("#dcc06d"),
                qa("M333.928 404.136c.427 1.066 1.013 1.646 2.082 1.402-.164-.78-.289-1.907-.661-2.689 1.408 1.983 6.437 3.723 8.598 2.979.3 3.335-5.17.89-6.77.184-.23 1.332-.677 2.473-1.617 3.456-1.265-1.223-1.589-3.539-1.989-5.336")
            ]), M),
            A2(Da, l([
                Fa("path1709"),
                Ha("#ccb25c"),
                qa("M334.244 395.448c-.934-3.531-1.607-7.146-2.205-10.737-1-6.022-1.348-12.629-3.369-18.447-.111 5.24 1.126 10.14 1.759 15.267.619 5.038 2.557 9.16 3.815 13.917z")
            ]), M),
            A2(Da, l([
                Fa("path1711"),
                Ha("#ccb25c"),
                qa("M337.586 397.746c.58 1.542 1.294 6.069 2.734 6.407-.5-1.708-1.511-3.498-2.035-5.326")
            ]), M),
            A2(Da, l([
                Fa("path1713"),
                Ha("#ccb25c"),
                qa("M305.38 314.727c1.277 2.649 3.558 4.343 5.02 6.769 1.202 2 1.962 5.758 2.315 8.256-.746-2.414-2.174-5.002-4.086-6.374.579-2.703-1.395-5.669-3.264-7.579")
            ]), M),
            A2(Da, l([
                Fa("path1715"),
                Ha("#ccb25c"),
                qa("M314.758 308.408c1.134 2.101.796 3.442.643 5.73-.119 1.754.493 2.862.354 4.591 3.057.455 3.289 3.765 4.188 6.059-1.255-2.321-2.372-5.511-3.062-8.128-.672-2.542-.087-5.939-1.407-8.243")
            ]), M)
        ])),
        A2(On, l([
            Fa("UlnaRight")
        ]), l([
            A2(Da, l([
                Fa("path1763"),
                Ha("#f3d48c"),
                Ua("#967348"),
                Ba(".322"),
                qa("M77.35 384.708c3.151-13.243 3.252-26.641 5.88-39.963 1.124-5.695 2.029-11.453 3.628-17.044.681-2.387 1.292-5.123 2.214-7.398.934-2.304 2.869-3.83 4-6.023 1.705-3.305-1.301-3.857-3.551-4.708-2.469-.933-4.51-2.914-7.095-3.545-7.559-1.847-7.411 7.438-6.785 12.516.377 3.051.782 5.333 0 8.494-1.119 4.536-.965 8.763-1.432 13.339-.506 4.981-2.046 10.022-2.79 15.001-.733 4.9-.875 9.791-1.509 14.669-1.106 8.528-2.277 16.751-2.861 25.389-.251 3.722-.88 7.44-1.43 11.086-.305 2.02-2.995 7.586-1.437 9.305 2.802 3.095 4.488-4.247 7.051-3.947-.723.291-.823.665-1.294 1.026 1.572-.177 5.75.813 6.695-.735 1.767-2.907-2.117-8.5-2.177-11.611-.102-5.375 1.663-10.681 2.893-15.851z")
            ]), M),
            A2(Da, l([
                Fa("path1765"),
                Ha("#dcc06d"),
                qa("M81.854 307.468a3.714 3.714 0 0 0-1.503-.788c-1.43.431-3.104 1.792-2.806 3.648.366 2.264 2.36 2.329 4.281 2.584-.389.158-.871.793-1.349 1.08 4.817 4.016 1.552 14.189.392 19.796-1.498 7.248-1.861 14.586-3.01 21.855-.545 3.456-1.22 10.172-3.076 12.952.046-3.906.141-8.299 1.287-12.089-2.182 4.34-2.102 11.324-2.701 16.354-.337 2.827-1.119 6.037-.831 8.88.493-.905.947-1.769 1.467-2.628-.102 4.593-.833 8.895-1.475 13.344 4.544-5.46 3.852-14.402 5.301-20.973 3.34-15.158 4.755-30.522 6.962-45.785.224-1.554.389-3.259 1.084-4.545 1.334-2.469 4.284-3.651 5.259-6.388.179-.503.625-5.567-1.507-4.385-2.708 1.506-5.952-5.02-9.564-2.913")
            ]), M),
            A2(Da, l([
                Fa("path1767"),
                Ha("#dcc06d"),
                qa("M65.405 415.818c2.272-1.509 2.133-5.375 4.203-6.365 1.608-.769 4.271 1.167 6.137 1.064-1.891 3.433-7.48-2.173-8.553 4.229")
            ]), M),
            A2(Da, l([
                Fa("path1769"),
                Ha("#ccb25c"),
                qa("M80.781 311.759c2.266 1.54 4.428-1.073 3.978-3.164.382.019 1.37.192 1.716.364-3.307 2.649 1.176 3.902 3.449 4.013-1.328.721-3.523 2.12-4.486.732-.098 4.813-1.311 9.451-2.895 13.982.608-4.159 2.66-11.986-1.762-14.855")
            ]), M),
            A2(Da, l([
                Fa("path1771"),
                Ha("#ccb25c"),
                qa("M73.629 399.727c.511 4.129-1.494 6.492 2.36 9.527-.896-2.83-2.556-6.196-2.36-9.17")
            ]), M),
            A2(Da, l([
                Fa("path1773"),
                Ha("#ccb25c"),
                qa("M74.444 377.527c.939-4.344 2.341-8.628 2.421-13.111-.136 7.596-8.861 18.275-3.575 25.919-.201-3.819.342-9.052 1.154-12.808z")
            ]), M),
            A2(Da, l([
                Fa("path1775"),
                Ha("#ccb25c"),
                qa("M88.648 317.123c-3.417 1.521-2.412 5.438-3.244 8.481.875-2.733 2.054-5.488 2.886-8.124")
            ]), M)
        ]))
    ]), zr = l([
        A7(Xa, "Cervical Vertebrae", 1, l([
            h(21, 103)
        ]), Rn, un, 2, 1),
        A7(Xa, "Thoracic Vertebrae", 1, l([
            h(21, 141)
        ]), br, In, 2, 1),
        A7(Xa, "Lumbar Vertebrae", 1, l([
            h(21, 282)
        ]), cr, sn, 2, 1),
        A7(Xa, "Cranium", 0, l([
            h(260, 52)
        ]), Jn, pn, 2, 0),
        A7(Xa, "Mandible", 0, l([
            h(259, 117)
        ]), tr, gn, 2, 0),
        A7(Xa, "Ribs", 1, l([
            h(324, 218)
        ]), hr, _n, 0, 0),
        A7(Xa, "Clavicle", 1, l([
            h(325, 151)
        ]), Sn, hn, 0, 0),
        A7(Xa, "Manubrium", 1, l([
            h(325, 166)
        ]), ar, vn, 2, 0),
        A7(Xa, "Scapula", 1, l([
            h(324, 180)
        ]), pr, Ln, 2, 0),
        A7(Xa, "Sternum", 1, l([
            h(324, 195)
        ]), or, An, 2, 0),
        A7(Xa, "Humerus", 2, l([
            h(337, 286)
        ]), Kn, bn, 2, 0),
        A7(Xa, "Ulna", 2, l([
            h(350, 328)
        ]), lr, Nn, 2, 0),
        A7(Xa, "Radius", 2, l([
            h(350, 342)
        ]), ir, kn, 2, 0),
        A7(Xa, "Carpals", 2, l([
            h(285, 413)
        ]), En, Pa, 2, 0),
        A7(Xa, "Metacarpals", 2, l([
            h(276, 436)
        ]), nr, $n, 2, 0),
        A7(Xa, "Sacrum", 3, l([
            h(21, 370)
        ]), fr, jn, 2, 0),
        A7(Xa, "Coccyx", 3, l([
            h(21, 385)
        ]), Xn, fn, 2, 0),
        A7(Xa, "Pelvic girdle", 3, l([
            h(350, 358)
        ]), dr, wn, 0, 0),
        A7(Xa, "Femur", 4, l([
            h(276, 559)
        ]), Zn, on, 2, 0),
        A7(Xa, "Tarsals", 4, l([
            h(275, 768)
        ]), Mr, Cn, 2, 0),
        A7(Xa, "Metatarsals", 4, l([
            h(275, 787)
        ]), rr, mn, 2, 0),
        A7(Xa, "Fibula", 4, l([
            h(275, 659)
        ]), Qn, Mn, 2, 0),
        A7(Xa, "Tibia", 4, l([
            h(274, 622)
        ]), sr, Tn, 2, 0),
        A7(Xa, "Patella", 4, l([
            h(275, 593)
        ]), er, yn, 0, 0),
        A7(Xa, "Phalanges", 5, l([
            h(275, 454),
            h(278, 810)
        ]), ur, xn, 2, 0)
    ]), gr = {
        m: {
            k: h(15, 8),
            C: h(1, 30)
        },
        aM: {
            aq: 18
        }
    }, vr = (La = function() {
        var c, t;
        return {
            aJ: (c = it.body, t = it.documentElement, {
                X: Math.max(c.scrollWidth, c.offsetWidth, t.scrollWidth, t.offsetWidth, t.clientWidth),
                ab: Math.max(c.scrollHeight, c.offsetHeight, t.scrollHeight, t.offsetHeight, t.clientHeight)
            }),
            t: {
                aN: ht.pageXOffset,
                aO: ht.pageYOffset,
                X: it.documentElement.clientWidth,
                ab: it.documentElement.clientHeight
            }
        };
    }, Z(function(c) {
        dt(function() {
            c(J(La()));
        });
    })), $r = I, mr = function(c) {
        return {
            $: 9,
            a: c
        };
    }, yr = function(c) {
        return {
            $: 15,
            a: c
        };
    }, wr = function(c) {
        return {
            $: 14,
            a: c
        };
    }, xr = F2(function(c, t) {
        return {
            $: 13,
            a: c,
            b: t
        };
    }), kr = sc, _r = F2(function(c, t) {
        return {
            $: 0,
            a: c,
            b: t
        };
    }), jr = F2(function(c, t) {
        return {
            aE: t,
            aL: c
        };
    }), Lr = {
        $: -2
    }, Ar = Lr, Cr = la(A2(jr, Ar, Ar)), Ir = i, Tr = F2(function(c, t) {
        c: for(;;){
            if (-2 === t.$) return zt;
            var a = t.c, n = t.d, r = t.e;
            switch(A2(Ir, c, t.b)){
                case 0:
                    t = n;
                    continue c;
                case 1:
                    return lt(a);
                default:
                    t = r;
                    continue c;
            }
        }
    }), Nr = F5(function(c, t, a, n, r) {
        return {
            $: -1,
            a: c,
            b: t,
            c: a,
            d: n,
            e: r
        };
    }), Or = F5(function(c, t, a, n, r) {
        if (-1 !== r.$ || r.a) {
            if (-1 !== n.$ || n.a || -1 !== n.d.$ || n.d.a) return A5(Nr, c, t, a, n, r);
            var e = n.d;
            return d = n.e, A5(Nr, 0, n.b, n.c, A5(Nr, 1, e.b, e.c, e.d, e.e), A5(Nr, 1, t, a, d, r));
        }
        var d, u = r.b, i = r.c, h = r.d, f = r.e;
        return -1 !== n.$ || n.a ? A5(Nr, c, u, i, A5(Nr, 0, t, a, n, h), f) : A5(Nr, 0, t, a, A5(Nr, 1, n.b, n.c, n.d, d = n.e), A5(Nr, 1, u, i, h, f));
    }), Er = F3(function(c, t, a) {
        if (-2 === a.$) return A5(Nr, 0, c, t, Lr, Lr);
        var n = a.a, r = a.b, e = a.c, d = a.d, u = a.e;
        switch(A2(Ir, c, r)){
            case 0:
                return A5(Or, n, r, e, A3(Er, c, t, d), u);
            case 1:
                return A5(Nr, n, r, t, d, u);
            default:
                return A5(Or, n, r, e, d, A3(Er, c, t, u));
        }
    }), Rr = F3(function(c, t, a) {
        var n = A3(Er, c, t, a);
        return -1 !== n.$ || n.a ? n : A5(Nr, 1, n.b, n.c, n.d, n.e);
    }), Sr = F2(function(c, t) {
        var a = c.a, n = c.b, r = A2(Tr, a, t);
        return A3(Rr, a, 1 === r.$ ? l([
            n
        ]) : A2(gt, n, r.a), t);
    }), Xr = function(c) {
        return Z(function(t) {
            var a = c.f;
            2 === a.$ && a.c && a.c(), c.f = null, t(J(0));
        });
    }, qr = F3(function(c, t, a) {
        for(;;){
            if (-2 === a.$) return t;
            var n = a.e, r = c, e = A3(c, a.b, a.c, A3(qr, c, t, a.d));
            c = r, t = e, a = n;
        }
    }), Hr = F6(function(c, t, a, n, r, e) {
        var d = A3(qr, F3(function(n, r, e) {
            c: for(;;){
                var d = e.a, i = e.b;
                if (d.b) {
                    var f = d.a, p = f.a, o = f.b, M = d.b;
                    if (0 > u(p, n)) {
                        e = h(M, A3(c, p, o, i));
                        continue c;
                    }
                    return u(p, n) > 0 ? h(d, A3(a, n, r, i)) : h(M, A4(t, p, o, r, i));
                }
                return h(d, A3(a, n, r, i));
            }
        }), h($t(n), e), r), i = d.a, f = d.b;
        return A3(Ot, F2(function(t, a) {
            return A3(c, t.a, t.b, a);
        }), f, i);
    }), Fr = Mc, Vr = Mt, Dr = ac, Ur = F3(function(c, t, a) {
        if (t.b) {
            var n = t.a, r = t.b, e = Dr(A2(Vr, n, A2(Fr, c, n)));
            return A2(ma, function(t) {
                return A3(Ur, c, r, A3(Rr, n, t, a));
            }, e);
        }
        return la(a);
    }), Br = F3(function(c, t, a) {
        var n = a.aE, r = F3(function(c, t, a) {
            var n = a.c;
            return f(a.a, a.b, A2(ma, function() {
                return n;
            }, Xr(t)));
        }), e = A3(Ot, Sr, Ar, t), d = A6(Hr, F3(function(c, t, a) {
            var n = a.b, r = a.c;
            return f(A2(gt, c, a.a), n, r);
        }), F4(function(c, t, a, n) {
            var r = n.c;
            return f(n.a, A3(Rr, c, a, n.b), r);
        }), r, e, n, f(M, Ar, la(0))), u = d.a, i = d.b;
        return A2(ma, function(c) {
            return la(A2(jr, e, c));
        }, A2(ma, function() {
            return A3(Ur, c, u, i);
        }, d.c));
    }), Pr = (ja = fa, Z(function(c) {
        c(J(ja(Date.now())));
    })), Gr = F3(function(c, t, a) {
        var n = A2(Tr, t, a.aL);
        if (1 === n.$) return la(a);
        var r = n.a;
        return A2(ma, function() {
            return la(a);
        }, A2(ma, function(t) {
            return xa(A2($a, function(a) {
                return A2(ka, c, a(t));
            }, r));
        }, Pr));
    }), Wr = F3(function(c, t, a) {
        return c(t(a));
    });
    hc.Time = fc(Cr, Br, Gr, 0, F2(function(c, t) {
        return A2(_r, t.a, A2(Wr, c, t.b));
    }));
    var Yr = bc("Time"), Jr = F2(function(c, t) {
        return Yr(A2(_r, c, t));
    }), Zr = function(c) {
        return !c;
    }, Qr = F3(function(c, t, a) {
        return {
            $: 0,
            a: c,
            b: t,
            c: a
        };
    }), Kr = F2(function(c, t) {
        return {
            aB: t,
            aK: c
        };
    }), ce = la(A2(Kr, M, Ar)), te = function(c) {
        return h(o(c.a ? "w_" : "d_", c.b), c);
    }, ae = function(c) {
        return A3(Ot, F2(function(c, t) {
            return A3(Rr, c.a, c.b, t);
        }), Ar, c);
    }, ne = F2(function(c, t) {
        return {
            au: t,
            ax: c
        };
    }), re = F3(function(c, t, a) {
        return A2(ya, function(c) {
            return h(t, c);
        }, A3(ft, a.a ? ht : it, a.b, function(a) {
            return A2(Fr, c, A2(ne, t, a));
        }));
    }), ee = F2(function(c, t) {
        return A3(qr, Rr, t, c);
    }), de = F3(function(c, t, a) {
        var n = F3(function(t, a, n) {
            var r = n.c;
            return f(n.a, n.b, A2(gt, A3(re, c, t, a), r));
        }), r = F3(function(c, t, a) {
            var n = a.b, r = a.c;
            return f(A2(gt, t, a.a), n, r);
        }), e = F4(function(c, t, a, n) {
            var r = n.c;
            return f(n.a, A3(Rr, c, t, n.b), r);
        }), d = A2($a, te, t), u = A6(Hr, r, e, n, a.aB, ae(d), f(M, Ar, M)), i = u.b, h = u.c;
        return A2(ma, function(c) {
            return la(A2(Kr, d, A2(ee, i, ae(c))));
        }, A2(ma, function() {
            return xa(h);
        }, xa(A2($a, Xr, u.a))));
    }), ue = F3(function(c, t, a) {
        var n = c(t);
        return n.$ ? a : A2(gt, n.a, a);
    }), ie = F2(function(c, t) {
        return A3(va, ue(c), M, t);
    });
    hc["Browser.Events"] = fc(ce, de, F3(function(c, t, a) {
        var n = t.ax, r = t.au, d = A2(ie, function(c) {
            var t = c.b.c;
            return e(c.a, n) ? A2(pt, t, r) : zt;
        }, a.aK);
        return A2(ma, function() {
            return la(a);
        }, xa(A2($a, ka(c), d)));
    }), 0, F2(function(c, t) {
        return A3(Qr, t.a, t.b, A2(da, c, t.c));
    }));
    var he, fe, pe, oe, Me = bc("Browser.Events"), be = F3(function(c, t, a) {
        return Me(A3(Qr, c, t, a));
    }), se = A2(be, 0, "keydown"), le = T, ze = F2(function(c, t) {
        return c(t ? 1 : 0);
    }), ge = function(c) {
        var t = void 0 !== yc.hidden ? {
            a_: "hidden",
            aV: "visibilitychange"
        } : void 0 !== yc.mozHidden ? {
            a_: "mozHidden",
            aV: "mozvisibilitychange"
        } : void 0 !== yc.msHidden ? {
            a_: "msHidden",
            aV: "msvisibilitychange"
        } : void 0 !== yc.webkitHidden ? {
            a_: "webkitHidden",
            aV: "webkitvisibilitychange"
        } : {
            a_: "hidden",
            aV: "visibilitychange"
        };
        return A3(be, 0, t.aV, A2(da, ze(c), A2(Ta, "target", A2(Ta, t.a_, le))));
    }, ve = N, $e = {
        $: 2
    }, me = {
        $: 3
    }, ye = {
        $: 0
    }, we = function(c) {
        return {
            $: 1,
            a: c
        };
    }, xe = function(c) {
        return {
            $: 2,
            a: c
        };
    }, ke = function(c) {
        return {
            $: 1,
            a: c
        };
    }, _e = K, je = F2(function(c, t) {
        return Aa(A2(_e, A2(Wr, A2(Wr, la, c), xt), A2(ma, A2(Wr, A2(Wr, la, c), Lt), t)));
    }), Le = F3(function(c, t, a) {
        return 0 > u(a, c) ? c : u(a, t) > 0 ? t : a;
    }), Ae = F2(function(c, t) {
        var a = t.b;
        return h(c(t.a), a);
    }), Ce = F3(function(c, t, a) {
        return t(c(a));
    }), Ie = F4(function(c, t, a, n) {
        return {
            a0: t,
            a5: c,
            a8: a,
            bi: n
        };
    }), Te = bt, Ne = function(c) {
        return A2(Te, {
            aU: !1,
            a6: !1
        }, c);
    }, Oe = F2(function(c, t) {
        return t.$ ? c : t.a;
    }), Ee = A2(Ce, Ne, Oe(/.^/)), Re = (he = l([
        h("[\xe0-\xe6]", "a"),
        h("[\xc0-\xc6]", "A"),
        h("\xe7", "c"),
        h("\xc7", "C"),
        h("[\xe8-\xeb]", "e"),
        h("[\xc8-\xcb]", "E"),
        h("[\xec-\xef]", "i"),
        h("[\xcc-\xcf]", "I"),
        h("\xf1", "n"),
        h("\xd1", "N"),
        h("[\xf2-\xf6]", "o"),
        h("[\xd2-\xd6]", "O"),
        h("[\xf9-\xfc]", "u"),
        h("[\xd9-\xdc]", "U"),
        h("\xfd", "y"),
        h("\xff", "y"),
        h("\xdd", "Y")
    ]), A2($a, Ae(Ee), he)), Se = st(1 / 0), Xe = function(c) {
        return function(c) {
            return "" === c;
        }(c) ? c : A3(Ot, function(c) {
            var t = c.b;
            return A2(Se, c.a, function() {
                return t;
            });
        }, c, Re);
    }, qe = function(c) {
        return c.toLowerCase();
    }, He = F2(function(c, t) {
        return e(Xe(qe(c)), Xe(qe(t)));
    }), Fe = W, Ve = F2(function(c, t) {
        return A3(Ot, function(c) {
            return F2(function(t, a) {
                return a.push(c(t)), a;
            });
        }(c), [], t);
    }), De = ot("focus"), Ue = w, Be = function(c) {
        return A2(Ue, c, "");
    }, Pe = " ", Ge = function(c) {
        switch(c.$){
            case 0:
            case 1:
            case 2:
            case 3:
                return c.a;
            default:
                return Pe;
        }
    }, We = function(c) {
        return z(c).join("");
    }, Ye = A2(Ce, $a(Ge), We), Je = A2(Ce, (fe = function(c) {
        switch(c.$){
            case 0:
                return !1;
            case 1:
                return !c.b;
            default:
                return !0;
        }
    }, A2(va, F2(function(c, t) {
        return fe(c) && function(c) {
            return !c.b;
        }(t) ? M : A2(gt, c, t);
    }), M)), Ye), Ze = function(c) {
        return c.b ? lt(c.a) : zt;
    }, Qe = F2(function(c, t) {
        return {
            $: 1,
            a: c,
            b: t
        };
    }), Ke = F3(function(c, t, a) {
        for(;;){
            if (!a.b) return zt;
            var n = a.b;
            if (t(a.a)) return lt(c);
            c += 1, a = n;
        }
    })(0), cd = F2(function(c, t) {
        c: for(;;){
            if (c > 0) {
                if (t.b) {
                    c -= 1, t = t.b;
                    continue c;
                }
                return t;
            }
            return t;
        }
    }), td = F3(function(c, t, a) {
        c: for(;;){
            if (c > 0) {
                if (t.b) {
                    var n = t.a;
                    c -= 1, t = t.b, a = A2(gt, n, a);
                    continue c;
                }
                return a;
            }
            return a;
        }
    }), ad = F2(function(c, t) {
        return Ht(A3(td, c, t, M));
    }), nd = F3(function(c, t, a) {
        if (t > 0) {
            var n = h(t, a);
            c: for(;;){
                t: for(;;){
                    if (!n.b.b) return a;
                    if (!n.b.b.b) {
                        if (1 === n.a) break c;
                        break t;
                    }
                    switch(n.a){
                        case 1:
                            break c;
                        case 2:
                            var r = n.b;
                            return l([
                                r.a,
                                r.b.a
                            ]);
                        case 3:
                            if (n.b.b.b.b) {
                                var e = n.b, d = e.b;
                                return l([
                                    e.a,
                                    d.a,
                                    d.b.a
                                ]);
                            }
                            break t;
                        default:
                            if (n.b.b.b.b && n.b.b.b.b.b) {
                                var u = n.b, i = u.b, f = i.b, p = f.b, o = p.b;
                                return A2(gt, u.a, A2(gt, i.a, A2(gt, f.a, A2(gt, p.a, c > 1e3 ? A2(ad, t - 4, o) : A3(nd, c + 1, t - 4, o)))));
                            }
                            break t;
                    }
                }
                return a;
            }
            return l([
                n.b.a
            ]);
        }
        return M;
    }), rd = F2(function(c, t) {
        return A3(nd, 0, c, t);
    }), ed = F3(function(c, t, a) {
        if (0 > c) return a;
        var n = A2(cd, c, a);
        if (n.b) {
            var r = n.a, e = n.b;
            return o(A2(rd, c, a), A2(gt, t(r), e));
        }
        return a;
    }), dd = {
        $: 0
    }, ud = F2(function(c, t) {
        for(;;){
            if (!t.b) return !1;
            var a = t.b;
            if (c(t.a)) return !0;
            t = a;
        }
    }), id = F2(function(c, t) {
        return !A2(ud, A2(Wr, Zr, c), t);
    }), hd = id(function(c) {
        switch(c.$){
            case 2:
            case 4:
                return !0;
            default:
                return !1;
        }
    }), fd = id(function(c) {
        return 2 !== c.$;
    }), pd = F2(function(c, t) {
        return t.$ ? zt : lt(c(t.a));
    }), od = function(c) {
        return {
            $: 0,
            a: c
        };
    }, Md = F2(function(c, t) {
        return Ht(A2(rd, c, Ht(t)));
    }), bd = F2(function(c, t) {
        return o(c, A2(Md, Et(t) - Et(c), t));
    }), sd = F2(function(c, t) {
        return 1 > c ? t : A3(Ma, 0, -c, t);
    }), ld = F2(function(c, t) {
        for(;;){
            if (e(c, "")) return c;
            if (A2(He, c, A2(ba, oa(c), t))) return c;
            c = A2(sd, 1, c);
        }
    }), zd = k, gd = function(c) {
        return A3(zd, gt, M, c);
    }, vd = F2(function(c, t) {
        var a = A3(Rt, F2(function(c) {
            switch(c.$){
                case 2:
                    return od(c.a);
                case 1:
                    return A2(Qe, c.a, !0);
                default:
                    return c;
            }
        }), t, gd(A2(ld, c, Ye(t))));
        return A2(bd, a, t);
    }), $d = F2(function(c, t) {
        return A3(va, F2(function(t, a) {
            return c(t) ? A2(gt, t, a) : a;
        }), M, t);
    }), md = A2(Ce, $d(function(c) {
        switch(c.$){
            case 2:
                return !0;
            case 1:
                return !c.b;
            default:
                return !1;
        }
    }), Et), yd = F2(function(c, t) {
        return u(md(c), md(t)) > 0 ? t : c;
    }), wd = sc(M), xd = (oe = fa, function(c) {
        hc[c] && r(3);
    }(pe = "persistSettings"), hc[pe] = {
        e: mc,
        u: oe,
        a: function(c) {
            var t = [], a = hc[c].u, n = Z(function(c) {
                var t = setTimeout(function() {
                    c(J(0));
                }, 0);
                return function() {
                    clearTimeout(t);
                };
            });
            return hc[c].b = n, hc[c].c = F3(function(c, r) {
                for(; r.b; r = r.b)for(var e = t, d = a(r.a), u = 0; e.length > u; u++)e[u](d);
                return n;
            }), {
                subscribe: function(c) {
                    t.push(c);
                },
                unsubscribe: function(c) {
                    var a = (t = t.slice()).indexOf(c);
                    0 > a || t.splice(a, 1);
                }
            };
        }
    }, bc(pe)), kd = {
        $: 2
    }, _d = function(c) {
        return {
            $: 12,
            a: c
        };
    }, jd = F2(function(c, t) {
        return {
            $: 0,
            a: c,
            b: t
        };
    }), Ld = function(c) {
        var t = c.b;
        return A2(jd, 1664525 * c.a + t >>> 0, t);
    }, Ad = A2(ma, function(c) {
        var t, a;
        return la((t = c, a = Ld(A2(jd, 0, 1013904223)), Ld(A2(jd, a.a + t >>> 0, a.b))));
    }, Pr), Cd = F2(function(c, t) {
        return c(t);
    }), Id = F3(function(c, t, a) {
        if (t.b) {
            var n = t.b, r = A2(Cd, t.a, a), e = r.b;
            return A2(ma, function() {
                return A3(Id, c, n, e);
            }, A2(ka, c, r.a));
        }
        return la(a);
    }), Td = F3(function(c, t, a) {
        return la(a);
    }), Nd = F2(function(c, t) {
        var a = t;
        return function(t) {
            var n = a(t), r = n.b;
            return h(c(n.a), r);
        };
    });
    hc.Random = fc(Ad, Id, Td, F2(function(c, t) {
        return A2(Nd, c, t);
    }));
    var Od, Ed, Rd, Sd = bc("Random"), Xd = F2(function(c, t) {
        return Sd(A2(Nd, c, t));
    }), qd = function(c) {
        return h(1, c);
    }, Hd = function(c) {
        return 0 > c ? -c : c;
    }, Fd = function(c) {
        var t = c.a, a = 277803737 * (t ^ t >>> 4 + (t >>> 28));
        return (a >>> 22 ^ a) >>> 0;
    }, Vd = F2(function(c, t) {
        return function(a) {
            var n = Ld(a), r = Hd(t - c), e = Fd(n);
            return h((1 * (67108863 & Fd(a)) * 134217728 + 1 * (134217727 & e)) / 9007199254740992 * r + c, Ld(n));
        };
    }), Dd = F3(function(c, t, a) {
        for(;;){
            var n = c.a, r = c.b;
            if (!t.b) return r;
            var e = t.a, d = t.b;
            if (1 > u(a, Hd(n))) return r;
            c = e, t = d, a -= Hd(n);
        }
    }), Ud = F2(function(c, t) {
        var a = function(c) {
            return Hd(c.a);
        }, n = a(c) + A3(Ot, Ct, 0, A2($a, a, t));
        return A2(Nd, A2(Dd, c, t), A2(Vd, 0, n));
    }), Bd = F2(function(c, t) {
        return A2(Ud, qd(c), A2($a, qd, t));
    }), Pd = function(c) {
        var t = c.a, a = A2($a, function(c) {
            return c.a2;
        }, A2($d, function(c) {
            return e(c.bh, me);
        }, c.j));
        return a.b ? h(c, A2(Xd, _d, A2(Bd, a.a, a.b))) : h(2 === t.$ ? p(c, {
            a: xe(p(t.a, {
                h: kd
            }))
        }) : c, wd);
    }, Gd = {
        $: 4
    }, Wd = F2(function(c, t) {
        return A3(Ce, qt(F2(function(t, a) {
            return u(c, t) > 0 ? 4 === a.$ ? Gd : {
                $: 3,
                a: Ge(a)
            } : a;
        })), Ht, Ht(t));
    }), Yd = A2(Ce, gd, $a(function(c) {
        return e(Pe, c) ? Gd : {
            $: 2,
            a: c
        };
    })), Jd = {
        $: 1
    }, Zd = function(c) {
        return {
            $: 1,
            a: c
        };
    }, Qd = {
        $: 0
    }, Kd = {
        $: 2
    }, cu = F2(function(c, t) {
        c: for(;;){
            if (t.b) {
                var a = t.b;
                if (c(t.a)) {
                    t = a;
                    continue c;
                }
                return t;
            }
            return M;
        }
    }), tu = A2(Ce, Ht, A2(Ce, cu(function(c) {
        switch(c.$){
            case 3:
            case 4:
                return !0;
            default:
                return !1;
        }
    }), Ht)), au = A2(Ce, tu, Et), nu = A2(Ce, Ht, A2(Ce, cu(function(c) {
        switch(c.$){
            case 3:
            case 4:
                return !0;
            default:
                return !1;
        }
    }), A2(Ce, Ze, A2(Ce, Oe(od(" ")), function(c) {
        switch(c.$){
            case 0:
                return !0;
            case 1:
                return c.b;
            default:
                return !1;
        }
    })))), ru = F2(function(c, t) {
        var a;
        return a = Je(t), A2(He, a, A2(ba, oa(a), c));
    }), eu = F2(function(c, t) {
        var a = c.a;
        if (2 === a.$) {
            var n = a.a, r = A2(yd, n.i, A2(vd, t, n.i)), d = nu(r) ? A2($a, function(c) {
                var t;
                return e(c.bh, $e) ? p(c, {
                    bh: (t = r, {
                        $: 1,
                        a: t
                    })
                }) : c;
            }, c.j) : c.j, i = A2(ru, t, r) ? u(oa(t), au(r)) > 0 ? n.g : lt(t) : lt(Je(r));
            if (e(d, c.j)) {
                var f = e(r, n.i) ? n.z : 0;
                return h(p(c, {
                    a: xe(p(n, {
                        i: r,
                        g: i,
                        z: f
                    }))
                }), wd);
            }
            return Pd(p(c, {
                a: xe(p(n, {
                    g: lt(""),
                    S: A2(gt, r, n.S),
                    z: 0
                })),
                j: d
            }));
        }
        return h(c, wd);
    }), du = F2(function(c, t) {
        var a, n, r, d, i, f = t.a, o = t.m, b = h(t, wd);
        switch(c.$){
            case 0:
                return b;
            case 1:
                return h(p(t, {
                    Y: (i = {
                        t: c.a
                    }, {
                        $: 1,
                        a: i
                    })
                }), wd);
            case 13:
                return h(t, A2(Ca, Ra, vr));
            case 15:
                var s = c.a;
                if (2 === f.$) {
                    var z = (F = f.a).z, g = F.R, v = F.g, $ = F.i, m = F.ah;
                    if (1 === (V = F.h).$ && 1 === V.a) {
                        var y = h(10 * m.a, 10 * m.b), w = y.a, x = y.b, k = u(1 + z, hd($) ? w : x) > -1 ? fd($) ? h(0, !1) : h(0, !0) : h(1 + z, !1), _ = k.a, j = k.b, L = j ? 1 === (d = A2(Ke, function(c) {
                            return 2 === c.$;
                        }, r = $)).$ ? r : A3(ed, d.a, function(c) {
                            return 2 === c.$ ? A2(Qe, c.a, !1) : c;
                        }, r) : $, A = j ? lt(Je(L)) : v, C = 1 === g.$ ? 1 === v.$ ? zt : j && !A2(He, v.a, Je($)) ? lt(s) : zt : s - g.a > 500 ? zt : g;
                        return h(p(t, {
                            a: xe(p(F, {
                                i: L,
                                g: A,
                                R: C,
                                z: _
                            }))
                        }), wd);
                    }
                    return b;
                }
                return b;
            case 8:
                return b;
            case 2:
                switch(f.$){
                    case 0:
                        return h(p(t, {
                            a: we({
                                M: lt(o.k.a),
                                N: lt(o.k.b),
                                O: 0
                            })
                        }), wd);
                    case 1:
                        var I = (n = h(f.a.M, f.a.N)).a.$ || n.b.$ ? o : {
                            k: h(n.a.a, n.b.a)
                        };
                        return h(p(t, {
                            a: Ea,
                            m: I
                        }), xd(function(c) {
                            var t;
                            return t = l([
                                h("hintTime", A2(Ve, Fe, l([
                                    c.k.a,
                                    c.k.b
                                ])))
                            ]), A3(Ot, F2(function(c, t) {
                                return A3(Y, c.a, c.b, t);
                            }), {}, t);
                        }(I)));
                    default:
                        return b;
                }
            case 3:
                var T = c.a, N = c.b;
                if (1 === f.$) {
                    var O = f.a, E = A2(pd, A2(Le, gr.m.C.a, gr.m.C.b), sa(N)), R = function() {
                        var c = sa(N);
                        if (1 === c.$) return 0;
                        var t = c.a;
                        return 1 > u(gr.m.C.a, t) && 1 > u(t, gr.m.C.b) ? 0 : 1;
                    }(), S = p(O, T ? {
                        N: E,
                        O: R
                    } : {
                        M: E,
                        O: R
                    });
                    return h(p(t, {
                        a: we(S)
                    }), wd);
                }
                return b;
            case 4:
                return Pd(p(t, {
                    a: (a = o, xe({
                        i: M,
                        ah: a.k,
                        ac: zt,
                        g: zt,
                        R: zt,
                        h: dd,
                        S: M,
                        z: 0
                    })),
                    j: A2($a, function(c) {
                        return p(c, {
                            bh: me
                        });
                    }, t.j)
                }));
            case 5:
                return h(function(c) {
                    return p(c, {
                        a: Ea,
                        j: A2($a, function(c) {
                            return {
                                a2: c,
                                bh: Oa
                            };
                        }, zr),
                        q: zt
                    });
                }(t), wd);
            case 6:
                return h(p(t, {
                    q: lt(c.a)
                }), wd);
            case 7:
                return h(p(t, {
                    q: zt
                }), wd);
            case 12:
                var X = c.a;
                return 2 === f.$ ? h(p(t, {
                    a: xe(p(F = f.a, {
                        i: X.bl ? A2(Wd, A2(Oe, 0, A2(pd, oa, Ze(Ht(A2(Nt, " ", X.a7))))), Yd(X.a7)) : Yd(X.a7),
                        ac: lt(X),
                        g: lt(""),
                        z: 0
                    })),
                    j: A2($a, function(c) {
                        return e(X, c.a2) ? p(c, {
                            bh: $e
                        }) : c;
                    }, t.j)
                }), A2(je, function() {
                    return ye;
                }, De("guess-input"))) : b;
            case 9:
                var q = function(c) {
                    var t, a, n = (a = (t = c).charCodeAt(0), isNaN(a) ? zt : lt(55296 > a || a > 56319 ? h(t[0], t.slice(1)) : h(t[0] + t[1], t.slice(2))));
                    if (!n.$ && "" === n.a.b) return {
                        $: 0,
                        a: n.a.a
                    };
                    switch(qe(c)){
                        case "backspace":
                            return Zd(Jd);
                        case "enter":
                            return Zd(Qd);
                        case "escape":
                            return Zd(Kd);
                        default:
                            return Zd(function(c) {
                                return {
                                    $: 3,
                                    a: c
                                };
                            }(c));
                    }
                }(c.a);
                if (2 === f.$) {
                    if (v = (F = f.a).g, 2 === (V = F.h).$) return b;
                    if (1 === v.$) {
                        if (q.$) return h(p(t, {
                            a: xe(p(F, {
                                g: lt(""),
                                h: ke(1)
                            }))
                        }), A2(je, function() {
                            return ye;
                        }, De("guess-input")));
                        var H = q.a;
                        return h(p(t, {
                            a: xe(p(F, {
                                i: A2(yd, F.i, A2(vd, Be(H), F.i)),
                                g: lt(" " === H ? "" : Be(H)),
                                h: ke(1)
                            }))
                        }), A2(je, function() {
                            return ye;
                        }, De("guess-input")));
                    }
                    return 1 === q.$ && 2 === q.a.$ ? h(p(t, {
                        a: xe(p(F, {
                            g: zt,
                            h: ke(0)
                        }))
                    }), wd) : b;
                }
                return b;
            case 10:
                if (2 !== f.$) return b;
                var F, V;
                switch((V = (F = f.a).h).$){
                    case 0:
                        return h(p(t, {
                            a: xe(p(F, {
                                g: lt(""),
                                h: ke(1)
                            }))
                        }), A2(je, function() {
                            return ye;
                        }, De("guess-input")));
                    case 1:
                        return V.a ? h(p(t, {
                            a: xe(p(F, {
                                h: ke(0)
                            }))
                        }), wd) : h(p(t, {
                            a: xe(p(F, {
                                h: ke(1)
                            }))
                        }), A2(je, function() {
                            return ye;
                        }, De("guess-input")));
                    default:
                        return b;
                }
            case 14:
                return h(p(t, 1 === c.a ? {
                    P: !0
                } : {
                    P: !1
                }), wd);
            default:
                return A2(eu, t, c.a);
        }
    }), uu = F2(function(c, t) {
        return {
            $: 3,
            a: c,
            b: t
        };
    }), iu = _c("a"), hu = "rgba(236,240,240,0.3)", fu = "rgba(255,254,224,0.3)", pu = W, ou = F2(function(c, t) {
        return A2(Cc, c, pu(t));
    }), Mu = ou("className"), bu = A2(Ce, $d(function(c) {
        return 1 === c.$;
    }), Et), su = h(488, 842), lu = _c("div"), zu = function(c) {
        return 0 > c || c > 1114111 ? "\uFFFD" : c > 65535 ? String.fromCharCode(Math.floor((c -= 65536) / 1024) + 55296, c % 1024 + 56320) : String.fromCharCode(c);
    }, gu = _c("hr"), vu = {
        a9: {
            $: 10
        },
        ba: {
            $: 7
        },
        bb: function(c) {
            return {
                $: 6,
                a: c
            };
        }
    }, $u = _c("input"), mu = function(c) {
        return 1 !== c.$;
    }, yu = F2(function(c, t) {
        return 1 === c ? t : t + "s";
    }), wu = tn, xu = wu(""), ku = function(c) {
        return h(c, !0);
    }, _u = Lc, ju = F2(function(c, t) {
        return A2(_u, c, {
            $: 1,
            a: t
        });
    }), Lu = A2(F2(function(c, t) {
        return A3(va, Ta, t, c);
    }), l([
        "target",
        "value"
    ]), ve), Au = function(c) {
        return A2(ju, "input", A2(da, ku, A2(da, c, Lu)));
    }, Cu = _c("p"), Iu = A2(Ce, It, function(c) {
        return c + "px";
    }), Tu = F2(function(c, t) {
        return 0 > u(c, t) ? c : t;
    }), Nu = F2(function(c, t) {
        var a = c.t;
        return Yt(t * A2(Tu, a.X / su.a, a.ab / su.b));
    }), Ou = _c("span"), Eu = Ac, Ru = ou("target"), Su = ou("type"), Xu = ou("value"), qu = Ic("height"), Hu = A2(Ce, id(function(c) {
        return 1 !== c.$;
    }), Zr), Fu = F2(function(c, t) {
        return A2(_u, c, {
            $: 0,
            a: t
        });
    }), Vu = A, Du = Va("svg"), Uu = function(c) {
        return A2(On, o(l([
            Fa("staticBack")
        ]), c), l([
            A2(Da, l([
                Fa("path1681"),
                Ha("#bbbdbf"),
                qa("M319.256 298.873c-1.153.729-1.669 2.242-1.132 3.5.533 1.244 1.855 1.4 2.922 1.599-1.003 1.971-2.626.673-3.215-.785-.755-1.877.229-2.985 1.425-4.314")
            ]), M),
            A2(Da, l([
                Fa("path479"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M169.335 592.031c-4.383-1.106-10.063 1.451-13.592-1.467-2.613-2.16-5.664-8.213-2.964-11.299.902 3.14 6.469 5.402 9.404 6.071 3.184.727 7.134-.117 10.003-1.721 1.905-1.064 1.25-1.634 3.64-1.426 3.969.346 6.464 1.957 10.672.622 4.472-1.418 7.393-4.307 7.547-8.885 5.976-3.271 1.519 8.783.393 11.03-.926 1.846-1.852 4.888-3.675 5.732-2.021.936-4.589-.368-6.784-.367-5.366.003-9.239 3.074-14.644 1.71z")
            ]), M),
            A2(Da, l([
                Fa("path1683"),
                Ha("#bbbdbf"),
                qa("M317.39 299.833c-.685 1.182-.821 4.661.567 5.481.306-.54-.307-1.056-.488-1.59-.392-1.138-.495-2.392.06-3.49")
            ]), M),
            A2(Da, l([
                Fa("path1631"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".236"),
                qa("M195.064 150.161c-.443-.954 1.199-.876 1.433-1.368.227-.477-.748-2.089-.922-2.589-.991-.069-1.755-.448-2.247.488-.38.725-1.108 1.664-1.192 2.477-.178 1.736 2.486.04 2.928.992z")
            ]), M)
        ]));
    }, Bu = function(c) {
        return A2(On, o(l([
            Fa("staticFront")
        ]), c), l([
            A2(Da, l([
                Fa("path1679"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M314.599 307.902c.42-.069.829-.191 1.207-.414 1.099-.65 1.932-1.792 3.142-2.439-.485-.727-1.022-1.525-1.27-2.394.631 1.482 1.047 2.314 2.585 2.56 1.696.27 3.826-.321 4.901-1.727 1.472-1.926.205-3.469-1.427-4.503-1.02-.649-2.192-1.289-3.441-1.204-1.355.092-2.287 1.12-3.521 1.507-1.881.592-2.962 2.463-4.786 3.127-1.482.538-3.058.277-4.596.322-1.209.034-2.948.474-3.903 1.275-.737.618-1.008 1.914-1.239 2.802-.435 1.677-.58 4.25 1.208 5.06 2.356 1.067 4.446-.693 6.089-2.134 1.013-.888 1.571-1.579 2.922-1.692.696-.058 1.429-.031 2.129-.146z")
            ]), M),
            A2(On, l([
                Fa("g1753")
            ]), l([
                A2(Da, l([
                    Fa("path1755"),
                    Ha("#e1e2e3"),
                    Ua("#967348"),
                    Ba(".322"),
                    qa("M81.932 307.471a3.407 3.407 0 0 1-1.257-.226c-1.186-.474-2.182-1.474-3.476-1.93.368-.793.776-1.664.888-2.559-.396 1.56-.68 2.446-2.164 2.921-1.633.526-3.83.268-5.107-.957-1.749-1.679-.732-3.396.721-4.669.912-.797 1.971-1.608 3.22-1.715 1.353-.116 2.431.758 3.708.952 1.95.297 3.303 1.983 5.207 2.36 1.547.306 3.066-.193 4.591-.384 1.201-.149 2.985.019 4.053.666.823.5 1.289 1.738 1.651 2.581.687 1.589 1.222 4.111-.42 5.183-2.166 1.415-4.501-.006-6.344-1.179-1.138-.723-1.794-1.32-3.145-1.227-.696.05-1.419.189-2.126.183z")
                ]), M),
                A2(Da, l([
                    Fa("path1757"),
                    Ha("#bbbdbf"),
                    qa("M75.95 299.258c1.253.545 1.994 1.96 1.654 3.285-.337 1.312-1.62 1.666-2.643 2.027 1.291 1.795 2.697.266 3.057-1.266.461-1.972-.682-2.915-2.068-4.046")
                ]), M)
            ])),
            A2(Da, l([
                Fa("path513"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M245.023 588.769a20.691 20.691 0 0 0 2.737-2.271c1.88-1.879.869-4.551.778-6.832-.026-.713 1.058-8.91-1.682-6.686-.684.555-.941 1.392-1.295 2.168-.495 1.085-.896 2.176-1.707 3.072-1.313 1.454-2.89 2.824-4.574 3.827-2.082 1.238-3.329.341-5.511.815-2.212.481-4.324.925-6.61 1.074-.685.044-1.615.048-2.271.228-.755.208-1.27.626-1.954.981-2.076 1.077-4.612 1.541-6.959 1.319-3.594-.339-5.52-3.905-6.257-7.065-.369-1.588-.593-3.094-1.069-4.649-.186-.611-.254-1.762-.778-2.206-.077-.064-1.517-.773-1.295-.111.55 1.656.335 3.708.286 5.504-.045 1.719-1.024 3.738-.48 5.374.785 2.362 1.634 5.307 3.434 7.114 1.356 1.362 2.413.897 3.995 1.211 1.374.272 2.606.784 4.095.891 3.898.281 7.571-1.885 11.462-1.622 3.297.223 6.581.796 9.898.378 1.878-.239 3.958-1.267 5.757-2.514z")
            ]), M),
            A2(Da, l([
                Fa("path481"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M158.591 394.719c1.419-2.629-8.889-5.732-10.656-7.152-2.859-2.296-6.188-6.174-3.325-9.155 2.898-3.018 6.788-2.515 9.977-.415 5.186 3.416 11.667 14.471 2.932 17.794")
            ]), M),
            A2(Da, l([
                Fa("path499"),
                Ha("#e1e2e3"),
                Ua("#967348"),
                Ba(".322"),
                qa("M245.284 378.301c-6.745 1.467-10.107 11.286-5.941 16.778 1.032 1.357 2.848 1.809 4.221 2.714-.631-.417-1.371-.654-1.458-1.592-.127-1.345.469-.964 1.391-1.259 2.061-.659 4.159-1.106 6.225-1.726 2.43-.729 3.296-1.234 4.688-3.394.829-1.285 1.275-2.389 1.67-3.891 1.19-4.514-1.196-7.428-5.629-7.862-1.613-.157-3.458-.139-5.167.232z"),
                ln("inline"),
                zn("visible")
            ]), M)
        ]));
    }, Pu = Ic("transform"), Gu = Ic("filter"), Wu = F3(function(c, t, a) {
        var n = a.a2, r = a.bh, d = function() {
            var n = h(r, t);
            if (1 !== n.b.$) return e(n.b.a, a) ? M : l([
                Gu("grayscale(100%)"),
                Dn("0.5")
            ]);
            switch(n.a.$){
                case 0:
                case 2:
                default:
                    return M;
                case 1:
                    return c ? l([
                        Gu("grayscale(100%)")
                    ]) : M;
            }
        }();
        return A2(On, d, n.aR);
    }), Yu = Ic("class"), Ju = function(c) {
        return A2(Fu, "mouseout", ia(c));
    }, Zu = function(c) {
        return A2(Fu, "mouseover", ia(c));
    }, Qu = F5(function(c, t, a, n, r) {
        var d = c.bb, u = c.ba, i = r.a2, f = r.bh, p = function() {
            var c = h(f, n);
            if (1 !== c.b.$) return e(c.b.a, r) ? M : l([
                Gu("grayscale(100%)")
            ]);
            switch(c.a.$){
                case 0:
                    return M;
                case 1:
                    return a || t && !Hu(c.a.a) ? l([
                        Gu("grayscale(100%)"),
                        Dn("0.5")
                    ]) : M;
                case 2:
                    return l([
                        Yu("animate-pulse")
                    ]);
                default:
                    return l([
                        Gu("grayscale(100%)"),
                        Dn("0.5")
                    ]);
            }
        }();
        return A2(On, o(l([
            Zu(d(r)),
            Ju(u)
        ]), p), i.bk);
    }), Ku = Ic("viewBox"), ci = function(c) {
        return 1 === c.$ ? M : l([
            Gu("grayscale(100%)")
        ]);
    }, ti = F2(function(c, t) {
        return t.b ? A3(va, gt, t, c) : c;
    }), ai = function(c) {
        return A3(va, ti, M, c);
    }, ni = Ic("cursor"), ri = Ic("dy"), ei = $a(function(c) {
        switch(c.$){
            case 0:
            case 3:
                return A2(nn, M, l([
                    an(Be(t = c.a))
                ]));
            case 4:
                return A2(nn, M, l([
                    an(" ")
                ]));
            case 1:
                var t = c.a;
                return A2(nn, l([
                    cn("fill: red;")
                ]), l([
                    an(Be(t))
                ]));
            default:
                return A2(nn, M, M);
        }
    }), di = x, ui = zu(9679), ii = di(function(c) {
        return e(c, Pe) ? Pe : ui;
    }), hi = F2(function(c, t) {
        return h(A2(rd, c, t), A2(cd, c, t));
    }), fi = F2(function(c, t) {
        var a, n = A2(Ke, c, t);
        return l(n.$ ? [
            t
        ] : [
            (a = A2(hi, n.a, t)).a,
            A2(cd, 1, a.b)
        ]);
    })(function(c) {
        return 4 === c.$;
    }), pi = Va("text"), oi = F5(function(c, t, a, n, r) {
        var d, u = c.bb, i = c.ba, f = n.a2, p = n.bh, b = r.a, s = r.b, z = function() {
            switch(p.$){
                case 0:
                    return l([
                        ni("pointer")
                    ]);
                case 1:
                    return t ? M : l([
                        Ha("grey"),
                        ni("pointer")
                    ]);
                case 2:
                    return l([
                        Ha("black"),
                        ni("default")
                    ]);
                default:
                    return l([
                        Ha("grey"),
                        ni("default")
                    ]);
            }
        }(), g = 1 === a.$ ? M : e(a.a, n) ? l([
            Ha("black"),
            Za(It(18))
        ]) : l([
            Gu("grayscale(100%)"),
            Dn("0.5")
        ]), v = h(f.a7, f.bl), $ = v.a, m = v.b, y = function() {
            switch(p.$){
                case 0:
                case 1:
                    return h($, !1);
                default:
                    return h(f.bl ? A2(Tt, " ", A2(qt, F2(function(c, t) {
                        return c ? t : ii(t);
                    }), A2(Nt, " ", $))) : ii($), !0);
            }
        }(), w = y.a, x = y.b, k = m ? t ? 1 === p.$ ? (d = p.a, ai(A2(qt, F2(function(c, t) {
            return l([
                A2(nn, l([
                    rn(It(b)),
                    ri(It(14 * c))
                ]), ei(t))
            ]);
        }), fi(d)))) : M : ai(A2(qt, F2(function(c, t) {
            return l([
                A2(nn, l([
                    rn(It(b)),
                    dn(It(s + 14 * c))
                ]), l([
                    an(t)
                ]))
            ]);
        }), A2(Nt, " ", w))) : t ? 1 === p.$ ? ei(d = p.a) : M : l([
            A2(nn, l([
                rn(It(b)),
                dn(It(s))
            ]), l([
                an(w)
            ]))
        ]);
        return A2(pi, o(l([
            rn(It(b)),
            dn(It(s)),
            Ja("sans-serif,Arial"),
            Za(It(x ? 12 : 14)),
            cn("user-select: none"),
            Zu(u(n)),
            Ju(i)
        ]), o(z, g)), k);
    }), Mi = F4(function(c, t, a, n) {
        var r = n.a2;
        return A2(On, M, A2($a, A4(oi, c, t, a, n), r.a3));
    }), bi = Ic("width"), si = F2(function(c, t) {
        var a, n = t._, r = t.Z, d = t.ae, u = t.ad, i = t.aa, f = t.q, p = t.af, b = 1 === u.$ ? "" : function(c) {
            var t = c.G, a = c.I, n = t.a, r = t.b;
            return "translate(" + It(n) + "," + It(r) + ") scale(" + Vu(a) + ") translate(" + It(-n) + "," + It(-r) + ")";
        }(function(c) {
            switch(c){
                case 0:
                    return {
                        G: h(200, 0),
                        I: 3
                    };
                case 1:
                    return {
                        G: h(200, 100),
                        I: 2
                    };
                case 2:
                    return {
                        G: h(400, 250),
                        I: 2
                    };
                case 3:
                    return {
                        G: h(200, 300),
                        I: 2
                    };
                case 4:
                    return {
                        G: h(200, 1e3),
                        I: 1.5
                    };
                default:
                    return {
                        G: h(400, 1050),
                        I: 1.5
                    };
            }
        }(u.a)), s = 1 === u.$ ? o(A2($a, A2(Wu, !0, f), A2($d, function(c) {
            return !e(c.bh, me);
        }, n)), A2($a, A3(Mi, i, !1, f), A2($d, function(c) {
            return !e(c.bh, me);
        }, n))) : M, z = d.a, g = d.b, v = Ku("-42 0 " + It(z) + " " + It(g));
        return h(z, g), A2(Du, l([
            Fa("skeleton"),
            bi(It(Yt(c.t.X))),
            qu(It(Yt(c.t.ab))),
            v,
            cn("display: block; margin: auto; position: relative;"),
            cn("background-color: " + r),
            (a = i.a9, A2(Fu, "click", ia(a)))
        ]), l([
            A2(On, l([
                Pu(b)
            ]), function() {
                if (p) {
                    var c = A2($d, function(c) {
                        var t = c.bh;
                        return 1 === t.$ && !!Hu(t.a);
                    }, n);
                    return o(l([
                        Uu(ci(f))
                    ]), o(A2($a, A4(Qu, i, !0, !1, f), A2($d, function(c) {
                        return 2 === c.a2.a4;
                    }, n)), o(l([
                        Bu(ci(f))
                    ]), o(A2($a, A4(Qu, i, !0, !1, f), A2($d, function(c) {
                        return !c.a2.a4;
                    }, n)), o(A2($a, A2(Wu, !1, f), c), A2($a, A3(Mi, i, !0, f), c))))));
                }
                return o(l([
                    Uu(ci(f))
                ]), o(A2($a, A4(Qu, i, !1, mu(u), f), A2($d, function(c) {
                    return 2 === c.a2.a4;
                }, n)), o(l([
                    Bu(ci(f))
                ]), o(A2($a, A4(Qu, i, !1, mu(u), f), A2($d, function(c) {
                    return !c.a2.a4;
                }, n)), s))));
            }())
        ]));
    }), li = function(c) {
        return {
            $: 11,
            a: c
        };
    }, zi = function(c) {
        return A2(ou, "autocomplete", c ? "on" : "off");
    }, gi = A2(Ce, ie(function(c) {
        return 3 === c.$ ? lt(c.a) : zt;
    }), We), vi = ou("id"), $i = F3(function(c, t, a) {
        return c > 0 ? A3($i, c >> 1, o(t, t), 1 & c ? o(a, t) : a) : a;
    }), mi = F2(function(c, t) {
        return A3($i, c, t, "");
    }), yi = F4(function(c, t, a, n) {
        return o(A3(Ma, 0, t, n), o(c, A3(Ma, a, oa(n), n)));
    }), wi = function(c) {
        return A3(yi, A2(mi, c, " "), 0, c);
    }, xi = W, ki = F2(function(c, t) {
        return A2(Cc, c, xi(t));
    })("spellcheck"), _i = A2(Eu, "background-color", "rgba(0,0,0,0.0)"), ji = F5(function(c, t, a, n) {
        var r = Yt(c.t.X), d = "white", u = e(oa(n), au(a)) && !A2(He, n, t.a7), i = oa(gi(a)) > 0, h = A2(Nu, c, 55), f = h / 2 | 0, p = Yt(h / 1.65), o = (r / 2 | 0) - (p * oa(Ye(tu(a))) / 2 | 0), b = (r / 2 | 0) - (p * oa(gi(a)) / 2 | 0);
        return A2(lu, l([
            A2(Eu, "position", "absolute"),
            A2(Eu, "width", "100%"),
            A2(Eu, "bottom", "0"),
            A2(Eu, "overflow", "hidden"),
            u ? Mu("animate-background-grey-red") : A2(Eu, "background-color", "rgba(34,34,34,0.5)")
        ]), l([
            A2($u, l([
                vi("guess-hints"),
                zi(!1),
                ki(!1),
                Xu(A2(wi, oa(n), We(A2($a, function(c) {
                    switch(c.$){
                        case 0:
                        default:
                            return Pe;
                        case 1:
                        case 3:
                            return c.a;
                        case 2:
                            return e(c.a, Pe) ? Pe : "-";
                    }
                }, tu(a))))),
                A2(Eu, "outline", "0"),
                A2(Eu, "border", "0"),
                A2(Eu, "margin", "0"),
                A2(Eu, "color", "#ccc"),
                _i,
                A2(Eu, "padding", i ? Iu(f / 2 | 0) + " " + Iu(o) + " 0" : Iu(f) + " " + Iu(o)),
                A2(Eu, "font-size", Iu(h)),
                Mu("font-mono")
            ]), M),
            A2($u, l([
                vi("guess-input"),
                zi(!1),
                ki(!1),
                Xu(n),
                A2(Eu, "position", "absolute"),
                A2(Eu, "width", "100%"),
                A2(Eu, "top", "0"),
                A2(Eu, "left", "0"),
                A2(Eu, "outline", "0"),
                A2(Eu, "border", "0"),
                A2(Eu, "margin", "0"),
                _i,
                A2(Eu, "padding", i ? Iu(f / 2 | 0) + " " + Iu(o) + " 0" : Iu(f) + " " + Iu(o)),
                A2(Eu, "font-size", Iu(h)),
                A2(Eu, "color", d),
                Mu("font-mono"),
                Au(li)
            ]), M),
            oa(gi(a)) ? A2($u, l([
                vi("guess-revealed"),
                zi(!1),
                ki(!1),
                Xu(gi(a)),
                A2(Eu, "outline", "0"),
                A2(Eu, "border", "0"),
                A2(Eu, "color", d),
                _i,
                A2(Eu, "padding", "0 " + Iu(b) + " " + Iu(f / 2 | 0)),
                A2(Eu, "font-size", Iu(h)),
                Mu("font-mono")
            ]), M) : xu
        ]));
    }), Li = {
        $: 2
    }, Ai = _c("button"), Ci = function(c) {
        return Iu(A2(Zt, A2(Nu, c, gr.aM.aq), 14));
    }, Ii = F2(function(c, t) {
        return A2(gt, A2(Eu, "position", "fixed"), function(c) {
            switch(t){
                case 0:
                    return l([
                        A2(Eu, "top", Iu(c)),
                        A2(Eu, "right", Iu(c))
                    ]);
                case 1:
                    return l([
                        A2(Eu, "bottom", Iu(c)),
                        A2(Eu, "right", Iu(c))
                    ]);
                case 2:
                    return l([
                        A2(Eu, "bottom", Iu(c)),
                        A2(Eu, "left", Iu(c))
                    ]);
                default:
                    return l([
                        A2(Eu, "top", Iu(c)),
                        A2(Eu, "left", Iu(c))
                    ]);
            }
        }(15));
    }), Ti = function(c) {
        return A2(Fu, "click", ia(c));
    }, Ni = F2(function(c, t) {
        return A2(Ai, o(l([
            Ti(Li),
            A2(Eu, "font-size", Ci(c)),
            Mu("font-mono")
        ]), A2(Ii, c, 0)), l([
            wu(function() {
                switch(t.$){
                    case 0:
                        return "Options & Info";
                    case 1:
                        return "Close";
                    default:
                        return "";
                }
            }())
        ]));
    }), Oi = {
        $: 4
    }, Ei = function(c) {
        return A2(Ai, o(l([
            Ti(Oi),
            A2(Eu, "font-size", Ci(c)),
            Mu("font-mono")
        ]), A2(Ii, c, 3)), l([
            wu("Start Quiz")
        ]));
    }, Ri = {
        $: 5
    }, Si = function(c) {
        return A2(Ai, o(l([
            Ti(Ri),
            A2(Eu, "font-size", Ci(c)),
            Mu("font-mono")
        ]), A2(Ii, c, 3)), l([
            wu("Quit Quiz")
        ]));
    }, Xi = Ia({
        a1: function(c) {
            var t = c.k;
            return h({
                a: Ea,
                Y: Sa,
                j: A2($a, function(c) {
                    return {
                        a2: c,
                        bh: Oa
                    };
                }, zr),
                q: zt,
                P: !1,
                m: {
                    k: 1 === t.$ ? gr.m.k : t.a
                }
            }, A2(Ca, Ra, vr));
        },
        bj: function(c) {
            var t, a = c.a, n = 2 === a.$ && 1 === a.a.h.$ ? c.P ? M : l([
                A2(Jr, 100, yr)
            ]) : M;
            return kr(o(l([
                (t = xr, A3(be, 1, "resize", A2(Ta, "target", A3(ua, t, A2(Ta, "innerWidth", $r), A2(Ta, "innerHeight", $r))))),
                se(A2(da, mr, A2(Ta, "key", ve))),
                ge(wr)
            ]), n));
        },
        bn: du,
        bo: function(c) {
            var t = c.j, a = c.a, n = c.q, r = c.Y;
            if (!r.$) return xu;
            var e, d, u, i, h, f = r.a.t;
            switch(a.$){
                case 0:
                    return A2(lu, M, l([
                        A2(si, f, {
                            Z: hu,
                            _: t,
                            aa: vu,
                            q: n,
                            ad: zt,
                            ae: su,
                            af: !1
                        }),
                        Ei(f),
                        A2(Ni, f, a)
                    ]));
                case 1:
                    var p = a.a.M, b = a.a.N, s = a.a.O;
                    return A2(lu, l([
                        A2(Eu, "display", "flex"),
                        A2(Eu, "flex-direction", "column"),
                        A2(Eu, "padding", "60px 5%"),
                        A2(Eu, "font-size", "16px"),
                        A2(Eu, "height", "100%"),
                        A2(Eu, "background-color", hu)
                    ]), l([
                        A2(Ou, M, l([
                            wu("Options")
                        ])),
                        A2(gu, l([
                            A2(Eu, "margin-bottom", "20px")
                        ]), M),
                        A2(Ou, M, l([
                            wu("Time before showing the next letter as a hint "),
                            A2(Ou, l([
                                Mu(1 === s ? "animate-color-red" : "")
                            ]), l([
                                wu("(" + It(gr.m.C.a) + "-" + It(gr.m.C.b) + ")")
                            ])),
                            wu(":")
                        ])),
                        A2(lu, l([
                            A2(Eu, "padding", "10px 15px"),
                            A2(Eu, "gap", "10px"),
                            A2(Eu, "display", "flex"),
                            A2(Eu, "flex-direction", "column")
                        ]), l([
                            A2(lu, l([
                                A2(Eu, "flex-direction", "row"),
                                A2(Eu, "display", "flex"),
                                A2(Eu, "gap", "10px")
                            ]), l([
                                A2($u, l([
                                    Mu("number-input"),
                                    A2(Eu, "font-size", "20px"),
                                    A2(Eu, "width", "40px"),
                                    A2(Eu, "height", "40px"),
                                    A2(Eu, "text-align", "center"),
                                    Su("number"),
                                    Xu((u = A2(pd, It, p), 1 === u.$ ? "" : u.a)),
                                    Au(uu(0))
                                ]), M),
                                A2(Ou, l([
                                    A2(Eu, "flex", "1"),
                                    A2(Eu, "align-content", "center")
                                ]), l([
                                    wu("seconds for the first letter")
                                ]))
                            ])),
                            A2(lu, l([
                                A2(Eu, "flex-direction", "row"),
                                A2(Eu, "display", "flex"),
                                A2(Eu, "gap", "10px")
                            ]), l([
                                A2($u, l([
                                    Mu("number-input"),
                                    A2(Eu, "font-size", "20px"),
                                    A2(Eu, "width", "40px"),
                                    A2(Eu, "height", "40px"),
                                    A2(Eu, "text-align", "center"),
                                    Su("number"),
                                    Xu((d = A2(pd, It, b), 1 === d.$ ? "" : d.a)),
                                    Au(uu(1))
                                ]), M),
                                A2(Ou, l([
                                    A2(Eu, "flex", "1"),
                                    A2(Eu, "align-content", "center")
                                ]), l([
                                    wu("seconds for each of the subsequent")
                                ]))
                            ]))
                        ])),
                        A2(Ou, l([
                            A2(Eu, "margin-top", "40px")
                        ]), l([
                            wu("General information")
                        ])),
                        A2(gu, l([
                            A2(Eu, "margin-bottom", "20px")
                        ]), M),
                        A2(Ou, M, l([
                            wu("This simple app aims to teach you the names of the major bones of the human skeleton."),
                            A2(Cu, M, l([
                                wu("The next letter for the bone you're currently trying to name will be shown after the time in the settings above has run out.")
                            ])),
                            A2(Cu, M, l([
                                wu("Can you make it through without using any hints? " + Be(zu(128526)))
                            ]))
                        ])),
                        A2(Ou, l([
                            A2(Eu, "margin-top", "40px")
                        ]), l([
                            wu("Credits")
                        ])),
                        A2(gu, l([
                            A2(Eu, "margin-bottom", "20px")
                        ]), M),
                        A2(Ou, M, l([
                            wu("Original skeleton image by "),
                            A2(iu, l([
                                (i = "https://commons.wikimedia.org/wiki/User:LadyofHats", A2(ou, "href", Oc.test(h = i) ? "" : h)),
                                Ru("_blank")
                            ]), l([
                                wu("LadyOfHats")
                            ])),
                            wu(".")
                        ])),
                        A2(Ni, f, a)
                    ]));
                default:
                    var z = a.a, g = z.h, v = z.R, $ = z.S, m = z.g, y = z.ac, w = z.i;
                    switch(g.$){
                        case 0:
                            return A2(lu, l([
                                A2(Eu, "width", "100%"),
                                A2(Eu, "height", "100%")
                            ]), l([
                                A2(si, f, {
                                    Z: fu,
                                    _: t,
                                    aa: vu,
                                    q: zt,
                                    ad: zt,
                                    ae: su,
                                    af: !1
                                }),
                                Si(f),
                                A2(lu, l([
                                    A2(Eu, "width", "100%"),
                                    A2(Eu, "height", "100%"),
                                    A2(Eu, "position", "absolute"),
                                    A2(Eu, "top", "0"),
                                    A2(Eu, "left", "0"),
                                    A2(Eu, "display", "flex"),
                                    A2(Eu, "justify-content", "center"),
                                    A2(Eu, "align-items", "center"),
                                    A2(Eu, "font-size", Iu(A2(Nu, f, 60))),
                                    A2(Eu, "font-weight", "bold"),
                                    A2(Eu, "color", "rgb(148 163 184)"),
                                    A2(Eu, "pointer-events", "none")
                                ]), l([
                                    A2(lu, l([
                                        A2(Eu, "padding", "40px"),
                                        A2(Eu, "text-align", "center"),
                                        A2(Eu, "opacity", "0"),
                                        Mu("animate-pulse-color")
                                    ]), l([
                                        wu("Touch screen to start")
                                    ]))
                                ]))
                            ]));
                        case 2:
                            var x = {
                                aJ: f.aJ,
                                t: {
                                    ab: f.t.ab - 70,
                                    X: f.t.X,
                                    aN: f.t.aN,
                                    aO: f.t.aO
                                }
                            }, k = A3(Ot, Ct, 0, A2($a, bu, $));
                            return A2(lu, l([
                                A2(Eu, "width", "100%")
                            ]), l([
                                A2(lu, o(l([
                                    A2(Eu, "height", Iu(70)),
                                    A2(Eu, "margin", "0px 0px 0px"),
                                    A2(Eu, "text-align", "center"),
                                    A2(Eu, "height", "100%"),
                                    A2(Eu, "background-color", hu)
                                ]), k ? M : l([
                                    A2(Eu, "position", "absolute"),
                                    A2(Eu, "width", "100%"),
                                    A2(Eu, "display", "flex"),
                                    A2(Eu, "flex-direction", "column"),
                                    A2(Eu, "justify-content", "center")
                                ])), l([
                                    A2(lu, l([
                                        A2(Eu, "font-weight", "bold"),
                                        A2(Eu, "padding-top", "20px")
                                    ]), l([
                                        wu("Finished")
                                    ])),
                                    A2(lu, l([
                                        A2(Eu, "text-align", "center")
                                    ]), l(k ? [
                                        A2(Ou, l([
                                            A2(Eu, "color", "red"),
                                            A2(Eu, "font-weight", "semi-bold")
                                        ]), l([
                                            wu(It(k))
                                        ])),
                                        A2(Ou, l([
                                            A2(Eu, "font-style", "normal")
                                        ]), l([
                                            wu(A2(yu, k, " hint") + " used ")
                                        ])),
                                        A2(Ou, l([
                                            A2(Eu, "font-weight", "bold"),
                                            A2(Eu, "font-size", "20px")
                                        ]), l([
                                            wu(Be(zu((e = k, 5 > e ? 128578 : 15 > e ? 129300 : 30 > e ? 128552 : 128561))))
                                        ]))
                                    ] : [
                                        A2(Ou, l([
                                            A2(Eu, "font-weight", "bold"),
                                            A2(Eu, "font-size", "20px")
                                        ]), l([
                                            wu(Be(zu(10024)))
                                        ])),
                                        wu(" No hints needed "),
                                        A2(Ou, l([
                                            A2(Eu, "font-weight", "bold"),
                                            A2(Eu, "font-size", "20px")
                                        ]), l([
                                            wu(Be(zu(128526))),
                                            wu(Be(zu(10024)))
                                        ]))
                                    ]))
                                ])),
                                k > 0 ? A2(si, x, {
                                    Z: hu,
                                    _: t,
                                    aa: vu,
                                    q: n,
                                    ad: zt,
                                    ae: su,
                                    af: !0
                                }) : xu,
                                Si(f)
                            ]));
                        default:
                            var _ = g.a;
                            return A2(lu, l([
                                A2(Eu, "width", "100%"),
                                A2(Eu, "height", "100%")
                            ]), l([
                                A2(si, f, {
                                    Z: fu,
                                    _: t,
                                    aa: vu,
                                    q: zt,
                                    ad: _ ? A2(pd, function(c) {
                                        return c.aT;
                                    }, y) : zt,
                                    ae: su,
                                    af: !1
                                }),
                                Si(f),
                                _ ? 1 === y.$ || 1 === m.$ ? xu : A5(ji, f, y.a, w, m.a, mu(v)) : xu
                            ]));
                    }
            }
        }
    });
    Od = {
        Main: {
            init: Xi(A2(ea, function(c) {
                return ia({
                    k: c
                });
            }, A2(Ta, "hintTime", (Ed = l([
                (Rd = zt, {
                    $: 5,
                    c: Rd
                }),
                A2(da, lt, A2(ea, function(c) {
                    return A2(ea, function(t) {
                        return ia(h(c, t));
                    }, A2(Na, 1, $r));
                }, A2(Na, 0, $r)))
            ]), {
                $: 11,
                g: Ed
            }))))(0)
        }
    }, c.Elm ? function c(t, a) {
        for(var n in a)n in t ? "init" == n ? r(6) : c(t[n], a[n]) : t[n] = a[n];
    }(c.Elm, Od) : c.Elm = Od;
}($a0b4f895e1596b3b$exports);


// HELPERS
JSON.tryParse = function(value) {
    try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON.tryParse error: ${error}`);
        return null;
    }
};
function $35da740d59af89ba$var$storageAvailable(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && e.name === "QuotaExceededError" && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}
// END HELPERS
const $35da740d59af89ba$var$APP_NAME = "HUMAN_SKELETON_1";
const $35da740d59af89ba$var$SETTINGS_HINTTIME = `${$35da740d59af89ba$var$APP_NAME}.userSettings.hintTime`;
var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root"),
    flags: {
        hintTime: $35da740d59af89ba$var$storageAvailable("localStorage") ? JSON.tryParse(localStorage.getItem($35da740d59af89ba$var$SETTINGS_HINTTIME)) : null
    }
});
$35da740d59af89ba$var$app.ports.persistSettings.subscribe(function(settings) {
    if (!$35da740d59af89ba$var$storageAvailable("localStorage")) return;
    localStorage.setItem($35da740d59af89ba$var$SETTINGS_HINTTIME, JSON.stringify(settings.hintTime ?? null));
});


//# sourceMappingURL=index.3b4b8d92.js.map
